import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigDecimal: any;
  Date: any;
  Instant: any;
  LocalDate: any;
  LocalDateTime: any;
  Long: any;
  Map_BusinessIndustry_StringScalar: any;
  Map_BusinessJobPosition_StringScalar: any;
  Map_BusinessOperationRegion_StringScalar: any;
  Map_BusinessProfileStatus_StringScalar: any;
  Map_BusinessType_StringScalar: any;
  Map_FilterDataType_Set_LabeledDataResponseScalar: any;
  Map_StockExchange_StringScalar: any;
  Map_String_ObjectScalar: any;
  Map_String_StringArrayScalar: any;
  Map_String_StringScalar: any;
  Map_TenDlcOptInMethod_ImageIdContainerScalar: any;
  Map_TenDlcOptInMethod_List_AssetScalar: any;
  Map_TenDlcOptInMethod_LongArrayScalar: any;
  Map_TenDlcOptInMethod_StringScalar: any;
  Map_TenDlcPackageType_TenDlcFeesScalar: any;
  Map_TenDlcProfileStatus_StringScalar: any;
  Map_TenDlcUseCaseType_StringScalar: any;
  Map_TollFreeVerificationMessageAmount_StringScalar: any;
  Map_TollFreeVerificationOptInMethod_TollFreeOptInMetadataScalar: any;
  Map_TollFreeVerificationStatus_StringScalar: any;
  Map_TollFreeVerificationUseCaseType_StringScalar: any;
  Map_VerificationStatus_StringScalar: any;
  ObjectScalar: any;
  UUID: any;
};

export enum A2PRegistrationStep {
  AssignEndUserToSecondaryProfile = 'ASSIGN_END_USER_TO_SECONDARY_PROFILE',
  CreateAuthorizedRepresentative_1 = 'CREATE_AUTHORIZED_REPRESENTATIVE_1',
  CreateAuthorizedRepresentative_2 = 'CREATE_AUTHORIZED_REPRESENTATIVE_2',
  CreateCustomerDocument = 'CREATE_CUSTOMER_DOCUMENT',
  CreateCustomerProfileAddress = 'CREATE_CUSTOMER_PROFILE_ADDRESS',
  CreateProfileBusinessInformation = 'CREATE_PROFILE_BUSINESS_INFORMATION',
  CreateSecondaryCustomerProfileBundle = 'CREATE_SECONDARY_CUSTOMER_PROFILE_BUNDLE',
  EvaluateSecondaryProfile = 'EVALUATE_SECONDARY_PROFILE',
  SubmitSecondaryProfileForReview = 'SUBMIT_SECONDARY_PROFILE_FOR_REVIEW'
}

export enum AccountIntegrationType {
  ActiveCampaign = 'ActiveCampaign',
  Custom = 'Custom',
  Drip = 'Drip',
  HubSpot = 'HubSpot',
  Keap = 'Keap',
  LeadConnector = 'LeadConnector',
  Zapier = 'Zapier'
}

export type AccountIntegrationsInput = {
  activeCampaign?: InputMaybe<ActiveCampaignIntegrationInput>;
  oAuth2Integration?: InputMaybe<OAuth2IntegrationInput>;
};

export type AccountIntegrationsResponse = {
  __typename?: 'AccountIntegrationsResponse';
  OAuth2Integrations?: Maybe<Array<Maybe<OAuth2IntegrationResponse>>>;
  activeCampaign?: Maybe<ActiveCampaignIntegration>;
  contactWebhookIntegration?: Maybe<ContactWebhookIntegrationResponse>;
};

export type ActiveCampaignIntegration = {
  __typename?: 'ActiveCampaignIntegration';
  apiKey?: Maybe<Scalars['String']>;
  apiUrl?: Maybe<Scalars['String']>;
  connected?: Maybe<Scalars['Boolean']>;
  connectedUser?: Maybe<Scalars['String']>;
};

export type ActiveCampaignIntegrationInput = {
  apiKey?: InputMaybe<Scalars['String']>;
  apiUrl?: InputMaybe<Scalars['String']>;
  connected?: InputMaybe<Scalars['Boolean']>;
  connectedUser?: InputMaybe<Scalars['String']>;
};

export type ActiveSubscriberInfo = {
  __typename?: 'ActiveSubscriberInfo';
  days: Scalars['Int'];
  months: Scalars['Int'];
  years: Scalars['Int'];
};

export type AddCreditInput = {
  amount?: InputMaybe<Scalars['Int']>;
  balanceType?: InputMaybe<BalanceType>;
  organizationId?: InputMaybe<Scalars['Long']>;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryInput>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type AdvancedSchedulingConfig = {
  __typename?: 'AdvancedSchedulingConfig';
  allowedDays?: Maybe<Array<Maybe<DayOfWeek>>>;
  contactsPerDay: Scalars['Int'];
  durationDays: Scalars['Int'];
  durationHours: Scalars['Int'];
  durationMinutes: Scalars['Int'];
  expectedFinishDate?: Maybe<Scalars['Instant']>;
  expectedStartDate?: Maybe<Scalars['Instant']>;
  lastSentDate?: Maybe<Scalars['Instant']>;
  speedConfig?: Maybe<BroadcastSendingSpeedConfig>;
  startTimeHour: Scalars['Int'];
  startTimeMinute: Scalars['Int'];
};

export type AdvancedSchedulingConfigInput = {
  allowedDays?: InputMaybe<Array<InputMaybe<DayOfWeek>>>;
  contactsPerDay: Scalars['Int'];
  durationDays: Scalars['Int'];
  durationHours: Scalars['Int'];
  durationMinutes: Scalars['Int'];
  expectedFinishDate?: InputMaybe<Scalars['Instant']>;
  expectedStartDate?: InputMaybe<Scalars['Instant']>;
  lastSentDate?: InputMaybe<Scalars['Instant']>;
  speedConfig?: InputMaybe<BroadcastSendingSpeedConfigInput>;
  startTimeHour: Scalars['Int'];
  startTimeMinute: Scalars['Int'];
};

export enum AllowImportStatus {
  Approved = 'APPROVED',
  NeedsReview = 'NEEDS_REVIEW',
  Rejected = 'REJECTED'
}

export type ApplicationConfiguration = {
  __typename?: 'ApplicationConfiguration';
  defaultChargeObjectPrices?: Maybe<Array<Maybe<ChargeObjectPrice>>>;
  segmentFeatureEnabled: Scalars['Boolean'];
  shortUrlDomains?: Maybe<Array<Maybe<Scalars['String']>>>;
  twilioCallRecordingNumber?: Maybe<Scalars['String']>;
};

export type ApplicationProperty = {
  __typename?: 'ApplicationProperty';
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['Long']>;
  name?: Maybe<ApplicationPropertyType>;
  updatedAt?: Maybe<Scalars['Date']>;
  value?: Maybe<Scalars['String']>;
};

export enum ApplicationPropertyType {
  ActionApiKeys = 'ACTION_API_KEYS',
  CallFireDefaultUnsubscribeAudioId = 'CALL_FIRE_DEFAULT_UNSUBSCRIBE_AUDIO_ID',
  CallResultMapping = 'CALL_RESULT_MAPPING',
  CarrierFeesChargeEnabled = 'CARRIER_FEES_CHARGE_ENABLED',
  CarrierFeesEnabled = 'CARRIER_FEES_ENABLED',
  CarrierFeesImmediateChargeThreshold = 'CARRIER_FEES_IMMEDIATE_CHARGE_THRESHOLD',
  CarrierFeesStartCheckingDate = 'CARRIER_FEES_START_CHECKING_DATE',
  CreditsMigrationEnabled = 'CREDITS_MIGRATION_ENABLED',
  DefaultRinglessMessageProvider = 'DEFAULT_RINGLESS_MESSAGE_PROVIDER',
  DefaultVoiceMessageProvider = 'DEFAULT_VOICE_MESSAGE_PROVIDER',
  EmailDomainBlacklist = 'EMAIL_DOMAIN_BLACKLIST',
  FirstpromoterEventsEnabled = 'FIRSTPROMOTER_EVENTS_ENABLED',
  SegmentFilterEnabled = 'SEGMENT_FILTER_ENABLED',
  ShortUrlDomains = 'SHORT_URL_DOMAINS',
  TwilioErrorCodeMapping = 'TWILIO_ERROR_CODE_MAPPING',
  TwilioRecordingPhoneNumber = 'TWILIO_RECORDING_PHONE_NUMBER',
  TwilioTollFreeDataSyncOnSigninEnabled = 'TWILIO_TOLL_FREE_DATA_SYNC_ON_SIGNIN_ENABLED'
}

export type Asset = {
  __typename?: 'Asset';
  compressedKey?: Maybe<Scalars['String']>;
  compressedSize: Scalars['Long'];
  compressedUrl?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Long']>;
  member?: Maybe<Member>;
  organization?: Maybe<Organization>;
  originalFileName?: Maybe<Scalars['String']>;
  previewKey?: Maybe<Scalars['String']>;
  previewUrl?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Long']>;
  sourceKey?: Maybe<Scalars['String']>;
  sourceSize: Scalars['Long'];
  sourceUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type AssetInput = {
  commonKey?: InputMaybe<Scalars['String']>;
  commonSize: Scalars['Long'];
  commonUrl?: InputMaybe<Scalars['String']>;
  compressedKey?: InputMaybe<Scalars['String']>;
  compressedSize: Scalars['Long'];
  compressedUrl?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  extension?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Long']>;
  member?: InputMaybe<MemberInput>;
  organization?: InputMaybe<OrganizationInput>;
  originalFileName?: InputMaybe<Scalars['String']>;
  previewKey?: InputMaybe<Scalars['String']>;
  previewUrl?: InputMaybe<Scalars['String']>;
  sourceKey?: InputMaybe<Scalars['String']>;
  sourceSize: Scalars['Long'];
  sourceUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type AssetLight = {
  __typename?: 'AssetLight';
  compressedKey?: Maybe<Scalars['String']>;
  compressedSize: Scalars['Long'];
  compressedUrl?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Long']>;
  organizationId?: Maybe<Scalars['Long']>;
  originalFileName?: Maybe<Scalars['String']>;
  previewKey?: Maybe<Scalars['String']>;
  previewUrl?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Long']>;
  sourceKey?: Maybe<Scalars['String']>;
  sourceSize: Scalars['Long'];
  sourceUrl?: Maybe<Scalars['String']>;
};

export type AudioItem = {
  __typename?: 'AudioItem';
  callFireId?: Maybe<Scalars['Long']>;
  contentType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  duration: Scalars['Int'];
  fileKey?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Long']>;
  member?: Maybe<Member>;
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  personalized: Scalars['Boolean'];
  size?: Maybe<Scalars['Long']>;
  sourceName?: Maybe<Scalars['String']>;
  sourceNameIndex?: Maybe<Scalars['Int']>;
  ttsMessage?: Maybe<TtsMessageTemplate>;
  type?: Maybe<AudioType>;
  updatedAt?: Maybe<Scalars['Date']>;
  url?: Maybe<Scalars['String']>;
  usageStatistics?: Maybe<AudioUsageStatistics>;
};

export type AudioItemInput = {
  callFireId?: InputMaybe<Scalars['Long']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  duration: Scalars['Int'];
  fileKey?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Long']>;
  name?: InputMaybe<Scalars['String']>;
  sourceName?: InputMaybe<Scalars['String']>;
  sourceNameIndex?: InputMaybe<Scalars['Int']>;
  ttsMessage?: InputMaybe<TtsMessageTemplateInput>;
  type?: InputMaybe<AudioType>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  url?: InputMaybe<Scalars['String']>;
  usageStatistics?: InputMaybe<AudioUsageStatisticsInput>;
};

export type AudioItemLight = {
  __typename?: 'AudioItemLight';
  callFireId?: Maybe<Scalars['Long']>;
  contentType?: Maybe<Scalars['String']>;
  duration: Scalars['Int'];
  fileKey?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Long']>;
  size?: Maybe<Scalars['Long']>;
  type?: Maybe<AudioType>;
  url?: Maybe<Scalars['String']>;
};

export enum AudioType {
  Migrated = 'MIGRATED',
  RecordedByComputer = 'RECORDED_BY_COMPUTER',
  RecordedByPhone = 'RECORDED_BY_PHONE',
  RecordedByTwilio = 'RECORDED_BY_TWILIO',
  Tts = 'TTS',
  Uploaded = 'UPLOADED'
}

export type AudioUsageSource = {
  __typename?: 'AudioUsageSource';
  id?: Maybe<Scalars['Long']>;
  name?: Maybe<Scalars['String']>;
};

export type AudioUsageSourceInput = {
  id?: InputMaybe<Scalars['Long']>;
  name?: InputMaybe<Scalars['String']>;
};

export type AudioUsageStatistics = {
  __typename?: 'AudioUsageStatistics';
  broadcastCount: Scalars['Int'];
  broadcasts?: Maybe<Array<Maybe<AudioUsageSource>>>;
  campaignCount: Scalars['Int'];
  campaigns?: Maybe<Array<Maybe<AudioUsageSource>>>;
  triggerCount: Scalars['Int'];
  triggers?: Maybe<Array<Maybe<TriggerUsageSource>>>;
};

export type AudioUsageStatisticsInput = {
  broadcastCount: Scalars['Int'];
  broadcasts?: InputMaybe<Array<InputMaybe<AudioUsageSourceInput>>>;
  campaignCount: Scalars['Int'];
  campaigns?: InputMaybe<Array<InputMaybe<AudioUsageSourceInput>>>;
  triggerCount: Scalars['Int'];
  triggers?: InputMaybe<Array<InputMaybe<TriggerUsageSourceInput>>>;
};

export type AutoRechargeOptionsInput = {
  creditsAmount: Scalars['Int'];
  enable: Scalars['Boolean'];
  initialSetup?: InputMaybe<Scalars['Boolean']>;
  threshold: AutoRechargeThreshold;
};

export enum AutoRechargeThreshold {
  Credits100 = 'Credits100',
  Credits250 = 'Credits250',
  Credits500 = 'Credits500',
  Credits750 = 'Credits750',
  Credits1000 = 'Credits1000'
}

export type AvailablePhoneNumbers = {
  __typename?: 'AvailablePhoneNumbers';
  availablePhoneNumbers?: Maybe<Array<Maybe<TwPhoneNumber>>>;
  uri?: Maybe<Scalars['String']>;
};

export enum BalanceType {
  Plan = 'Plan',
  Purchased = 'Purchased',
  Rollover = 'Rollover'
}

export type Balances = {
  __typename?: 'Balances';
  plan?: Maybe<Scalars['Float']>;
  purchased?: Maybe<Scalars['Float']>;
  purchasedExpire?: Maybe<Scalars['Instant']>;
  rollover?: Maybe<Scalars['Float']>;
};

export type BillingCarrierFees = {
  __typename?: 'BillingCarrierFees';
  createdAt?: Maybe<Scalars['LocalDateTime']>;
  dateFrom?: Maybe<Scalars['LocalDate']>;
  dateTo?: Maybe<Scalars['LocalDate']>;
  feesAmount: Scalars['Float'];
  id?: Maybe<Scalars['Long']>;
  organizationId?: Maybe<Scalars['Long']>;
  paymentAt?: Maybe<Scalars['LocalDateTime']>;
  paymentStatus?: Maybe<Scalars['String']>;
  retryCount: Scalars['Int'];
  subscriptionPeriodType?: Maybe<Scalars['String']>;
};

export type BillingInvoice = {
  __typename?: 'BillingInvoice';
  amount?: Maybe<Scalars['Float']>;
  currency?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Instant']>;
  id?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  paymentMethodDetails?: Maybe<Scalars['String']>;
  refundAmount?: Maybe<Scalars['Float']>;
  status?: Maybe<InvoiceStatus>;
};

export enum BillingStatus {
  Active = 'Active',
  Canceled = 'Canceled',
  Lead = 'Lead',
  PendingCancellation = 'Pending_Cancellation',
  Trial = 'Trial'
}

export enum BlacklistCondition {
  AllWords = 'ALL_WORDS',
  Exact = 'EXACT',
  Partial = 'PARTIAL'
}

export enum BlacklistMessageType {
  All = 'ALL',
  Broadcast = 'BROADCAST',
  Keyword = 'KEYWORD',
  Test = 'TEST',
  Trigger = 'TRIGGER',
  WebForm = 'WEB_FORM'
}

export enum BoundType {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export type BroadcastContactsCount = {
  __typename?: 'BroadcastContactsCount';
  active: Scalars['Int'];
  globalOptOut: Scalars['Int'];
  total: Scalars['Int'];
};

export type BroadcastEstimatedDurationResponse = {
  __typename?: 'BroadcastEstimatedDurationResponse';
  durationDays: Scalars['Int'];
  durationHours: Scalars['Int'];
  durationMinutes: Scalars['Int'];
  expectedFinishDate?: Maybe<Scalars['Instant']>;
  expectedStartDate?: Maybe<Scalars['Instant']>;
};

export type BroadcastEstimatedPriceResponse = {
  __typename?: 'BroadcastEstimatedPriceResponse';
  activeContactsCount?: Maybe<Scalars['Int']>;
  broadcastAllowed: Scalars['Boolean'];
  globalOptOutContactsCount?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  totalContactsCount?: Maybe<Scalars['Int']>;
  totalPrice?: Maybe<Scalars['Float']>;
};

export type BroadcastFirstItemResponse = {
  __typename?: 'BroadcastFirstItemResponse';
  id?: Maybe<Scalars['Long']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<BroadcastItemType>;
};

export type BroadcastFullResponse = {
  __typename?: 'BroadcastFullResponse';
  advancedSchedulingConfig?: Maybe<AdvancedSchedulingConfig>;
  assetIds?: Maybe<Array<Maybe<Scalars['Long']>>>;
  cardIds?: Maybe<Array<Maybe<Scalars['Long']>>>;
  contactCount: Scalars['Long'];
  contacts?: Maybe<Array<Maybe<ContactLightResponse>>>;
  contactsCount?: Maybe<BroadcastContactsCount>;
  conversion?: Maybe<ConversionResponse>;
  conversionStatistics?: Maybe<ConversionSourceStatistics>;
  createdAt?: Maybe<Scalars['Date']>;
  estimatedDuration?: Maybe<BroadcastEstimatedDurationResponse>;
  filterCount: Scalars['Long'];
  filterValue?: Maybe<FilterValue>;
  finished?: Maybe<Scalars['Boolean']>;
  firstItemResponse?: Maybe<BroadcastFirstItemResponse>;
  id?: Maybe<Scalars['Long']>;
  listCount: Scalars['Long'];
  lists?: Maybe<Array<Maybe<ListResponse>>>;
  member?: Maybe<Member>;
  messagesStat?: Maybe<StatusStatistics>;
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  ringlessMessage?: Maybe<RinglessMessage>;
  schedulingConfig?: Maybe<SchedulingConfig>;
  segmentCount: Scalars['Long'];
  segments?: Maybe<Array<Maybe<SegmentResponse>>>;
  sendFromCompany?: Maybe<Scalars['String']>;
  sendFromPhoneNumber?: Maybe<PhoneNumber>;
  sendTime?: Maybe<Scalars['Date']>;
  shortUrlClickStatistics?: Maybe<ShortUrlClickStatistics>;
  simplifiedStatus?: Maybe<Status>;
  smsMessage?: Maybe<SmsMessage>;
  sourceType?: Maybe<SourceType>;
  status?: Maybe<Status>;
  type?: Maybe<ContentType>;
  updatedAt?: Maybe<Scalars['Date']>;
  uuid?: Maybe<Scalars['UUID']>;
  voiceMessage?: Maybe<VoiceMessage>;
  voiceTransferCount?: Maybe<Scalars['Long']>;
  workflowConfig?: Maybe<WorkflowRequest>;
  workflowId?: Maybe<Scalars['Long']>;
};

export type BroadcastInput = {
  advancedSchedulingConfig?: InputMaybe<AdvancedSchedulingConfigInput>;
  conversion?: InputMaybe<ConversionInput>;
  conversionStatistics?: InputMaybe<ConversionSourceStatisticsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  filterValue?: InputMaybe<FilterValueInput>;
  finished?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Long']>;
  member?: InputMaybe<MemberInput>;
  messagesStat?: InputMaybe<StatusStatisticsInput>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationInput>;
  ringlessMessage?: InputMaybe<RinglessMessageInput>;
  schedulingConfig?: InputMaybe<SchedulingConfigInput>;
  sendFromCompany?: InputMaybe<Scalars['String']>;
  sendFromPhoneNumber?: InputMaybe<PhoneNumberInput>;
  sendTime?: InputMaybe<Scalars['Date']>;
  shortUrlClickStatistics?: InputMaybe<ShortUrlClickStatisticsInput>;
  simplifiedStatus?: InputMaybe<Status>;
  smsMessage?: InputMaybe<SmsMessageInput>;
  status: Status;
  updatedAt?: InputMaybe<Scalars['Date']>;
  uuid?: InputMaybe<Scalars['UUID']>;
  voiceMessage?: InputMaybe<VoiceMessageInput>;
  voiceTransferCount?: InputMaybe<Scalars['Long']>;
  workflowConfig?: InputMaybe<WorkflowRequestInput>;
  workflowId?: InputMaybe<Scalars['Long']>;
};

export enum BroadcastItemType {
  Contact = 'CONTACT',
  Filter = 'FILTER',
  List = 'LIST',
  Segment = 'SEGMENT'
}

export type BroadcastResponse = {
  __typename?: 'BroadcastResponse';
  advancedSchedulingConfig?: Maybe<AdvancedSchedulingConfig>;
  assetIds?: Maybe<Array<Maybe<Scalars['Long']>>>;
  cardIds?: Maybe<Array<Maybe<Scalars['Long']>>>;
  contactCount: Scalars['Long'];
  conversion?: Maybe<ConversionResponse>;
  conversionStatistics?: Maybe<ConversionSourceStatistics>;
  createdAt?: Maybe<Scalars['Date']>;
  filterCount: Scalars['Long'];
  filterValue?: Maybe<FilterValue>;
  finished?: Maybe<Scalars['Boolean']>;
  firstItemResponse?: Maybe<BroadcastFirstItemResponse>;
  id?: Maybe<Scalars['Long']>;
  listCount: Scalars['Long'];
  member?: Maybe<Member>;
  messagesStat?: Maybe<StatusStatistics>;
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  ringlessMessage?: Maybe<RinglessMessage>;
  schedulingConfig?: Maybe<SchedulingConfig>;
  segmentCount: Scalars['Long'];
  sendFromCompany?: Maybe<Scalars['String']>;
  sendFromPhoneNumber?: Maybe<PhoneNumber>;
  sendTime?: Maybe<Scalars['Date']>;
  shortUrlClickStatistics?: Maybe<ShortUrlClickStatistics>;
  simplifiedStatus?: Maybe<Status>;
  smsMessage?: Maybe<SmsMessage>;
  sourceType?: Maybe<SourceType>;
  status?: Maybe<Status>;
  type?: Maybe<ContentType>;
  updatedAt?: Maybe<Scalars['Date']>;
  uuid?: Maybe<Scalars['UUID']>;
  voiceMessage?: Maybe<VoiceMessage>;
  voiceTransferCount?: Maybe<Scalars['Long']>;
  workflowConfig?: Maybe<WorkflowRequest>;
  workflowId?: Maybe<Scalars['Long']>;
};

export enum BroadcastSendType {
  Immediately = 'IMMEDIATELY',
  Later = 'LATER'
}

export type BroadcastSendingSpeedConfig = {
  __typename?: 'BroadcastSendingSpeedConfig';
  contactsAmount: Scalars['Int'];
  unit?: Maybe<SendingSpeedUnit>;
  unitAmount: Scalars['Int'];
};

export type BroadcastSendingSpeedConfigInput = {
  contactsAmount: Scalars['Int'];
  unit?: InputMaybe<SendingSpeedUnit>;
  unitAmount: Scalars['Int'];
};

export type BroadcastSpeedOption = {
  __typename?: 'BroadcastSpeedOption';
  allowedUnits?: Maybe<Array<Maybe<Scalars['Int']>>>;
  unit?: Maybe<SendingSpeedUnit>;
};

export type BusinessAuthorizedUser = {
  __typename?: 'BusinessAuthorizedUser';
  businessProfile?: Maybe<BusinessProfile>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formattedPhoneNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Long']>;
  jobPosition?: Maybe<BusinessJobPosition>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  twilioSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type BusinessAuthorizedUserRequestInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  jobPosition?: InputMaybe<BusinessJobPosition>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type BusinessGeneralInfo = {
  __typename?: 'BusinessGeneralInfo';
  address?: Maybe<SecondStreetAddress>;
  businessProfile?: Maybe<BusinessProfile>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  einDocument?: Maybe<Asset>;
  id?: Maybe<Scalars['Long']>;
  manual?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  twilioAddressDocSid?: Maybe<Scalars['String']>;
  twilioAddressSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type BusinessGeneralInfoEinRequestInput = {
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  ein?: InputMaybe<Scalars['String']>;
  einAssetId?: InputMaybe<Scalars['Long']>;
  name?: InputMaybe<Scalars['String']>;
  secondStreet?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type BusinessGeneralInfoEinResponse = {
  __typename?: 'BusinessGeneralInfoEinResponse';
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  ein?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  secondStreet?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type BusinessGeneralInfoRequestInput = {
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  secondStreet?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export enum BusinessIdentity {
  IsvResellerOrPartner = 'ISV_RESELLER_OR_PARTNER'
}

export enum BusinessIndustry {
  Agriculture = 'AGRICULTURE',
  Automotive = 'AUTOMOTIVE',
  Banking = 'BANKING',
  Consumer = 'CONSUMER',
  Education = 'EDUCATION',
  Electronics = 'ELECTRONICS',
  Energy = 'ENERGY',
  Engineering = 'ENGINEERING',
  FastMovingConsumerGoods = 'FAST_MOVING_CONSUMER_GOODS',
  Financial = 'FINANCIAL',
  Fintech = 'FINTECH',
  FoodAndBeverage = 'FOOD_AND_BEVERAGE',
  Government = 'GOVERNMENT',
  Healthcare = 'HEALTHCARE',
  Hospitality = 'HOSPITALITY',
  Insurance = 'INSURANCE',
  Jewelry = 'JEWELRY',
  Legal = 'LEGAL',
  Manufacturing = 'MANUFACTURING',
  Media = 'MEDIA',
  NotForProfit = 'NOT_FOR_PROFIT',
  OilAndGas = 'OIL_AND_GAS',
  Online = 'ONLINE',
  ProfessionalServices = 'PROFESSIONAL_SERVICES',
  RawMaterials = 'RAW_MATERIALS',
  RealEstate = 'REAL_ESTATE',
  Religion = 'RELIGION',
  Retail = 'RETAIL',
  Technology = 'TECHNOLOGY',
  Telecommunications = 'TELECOMMUNICATIONS',
  Transportation = 'TRANSPORTATION',
  Travel = 'TRAVEL'
}

export type BusinessInfo = {
  __typename?: 'BusinessInfo';
  businessProfile?: Maybe<BusinessProfile>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['Long']>;
  identity?: Maybe<BusinessIdentity>;
  industry?: Maybe<BusinessIndustry>;
  operationRegions?: Maybe<Array<Maybe<BusinessOperationRegion>>>;
  socialMediaProfile?: Maybe<Scalars['String']>;
  twilioSid?: Maybe<Scalars['String']>;
  type?: Maybe<BusinessType>;
  updatedAt?: Maybe<Scalars['Date']>;
  website?: Maybe<Scalars['String']>;
};

export type BusinessInfoRequestInput = {
  industry?: InputMaybe<BusinessIndustry>;
  operationRegions?: InputMaybe<Array<InputMaybe<BusinessOperationRegion>>>;
  socialMediaProfile?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<BusinessType>;
  website?: InputMaybe<Scalars['String']>;
};

export enum BusinessJobPosition {
  Ceo = 'CEO',
  Cfo = 'CFO',
  Director = 'DIRECTOR',
  GeneralCounsel = 'GENERAL_COUNSEL',
  Gm = 'GM',
  Other = 'OTHER',
  Vp = 'VP'
}

export enum BusinessOperationRegion {
  Africa = 'AFRICA',
  Asia = 'ASIA',
  Europe = 'EUROPE',
  LatinAmerica = 'LATIN_AMERICA',
  UsaAndCanada = 'USA_AND_CANADA'
}

export type BusinessProfile = {
  __typename?: 'BusinessProfile';
  createdAt?: Maybe<Scalars['Date']>;
  currentBusinessProfileStep?: Maybe<BusinessProfileStep>;
  currentStep?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['Date']>;
  ein?: Maybe<Scalars['String']>;
  hasEin: Scalars['Boolean'];
  id?: Maybe<Scalars['Long']>;
  member?: Maybe<Member>;
  operationCountries?: Maybe<Array<Maybe<CountryCode>>>;
  organization?: Maybe<Organization>;
  status?: Maybe<BusinessProfileStatus>;
  twilioFriendlyName?: Maybe<Scalars['String']>;
  twilioPolicySid?: Maybe<Scalars['String']>;
  twilioSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type BusinessProfileEvaluationErrors = {
  __typename?: 'BusinessProfileEvaluationErrors';
  errorCode?: Maybe<Scalars['Int']>;
  failureReason?: Maybe<Scalars['String']>;
  fieldName?: Maybe<Scalars['String']>;
  objectType?: Maybe<Scalars['String']>;
  passed: Scalars['Boolean'];
};

export type BusinessProfileEvaluationResult = {
  __typename?: 'BusinessProfileEvaluationResult';
  errors?: Maybe<Array<Maybe<BusinessProfileEvaluationErrors>>>;
  status?: Maybe<Scalars['String']>;
};

export type BusinessProfileRequestInput = {
  operationCountries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type BusinessProfileResponse = {
  __typename?: 'BusinessProfileResponse';
  businessAuthorizedUsers?: Maybe<Array<Maybe<BusinessAuthorizedUser>>>;
  businessGeneralInfo?: Maybe<BusinessGeneralInfo>;
  businessInfo?: Maybe<BusinessInfo>;
  businessProfile?: Maybe<BusinessProfile>;
  errors?: Maybe<Array<Maybe<BusinessProfileEvaluationErrors>>>;
};

export enum BusinessProfileStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  InReview = 'IN_REVIEW',
  PendingReview = 'PENDING_REVIEW',
  ReviewRequired = 'REVIEW_REQUIRED',
  TwilioRejected = 'TWILIO_REJECTED'
}

export enum BusinessProfileStep {
  AuthorizedUser = 'AUTHORIZED_USER',
  BusinessInfo = 'BUSINESS_INFO',
  CompanyType = 'COMPANY_TYPE',
  CountryOfOperations = 'COUNTRY_OF_OPERATIONS',
  GeneralInfo = 'GENERAL_INFO',
  Terms = 'TERMS'
}

export type BusinessProfileTypes = {
  __typename?: 'BusinessProfileTypes';
  businessIndustryMapping?: Maybe<Scalars['Map_BusinessIndustry_StringScalar']>;
  businessJobPositionMapping?: Maybe<Scalars['Map_BusinessJobPosition_StringScalar']>;
  businessOperationRegionMapping?: Maybe<Scalars['Map_BusinessOperationRegion_StringScalar']>;
  businessProfileStatusMapping?: Maybe<Scalars['Map_BusinessProfileStatus_StringScalar']>;
  businessTypeMapping?: Maybe<Scalars['Map_BusinessType_StringScalar']>;
};

export enum BusinessType {
  Corporation = 'CORPORATION',
  CoOperative = 'CO_OPERATIVE',
  LimitedLiabilityCorporation = 'LIMITED_LIABILITY_CORPORATION',
  NonProfitCorporation = 'NON_PROFIT_CORPORATION',
  Partnership = 'PARTNERSHIP',
  SoleProprietorship = 'SOLE_PROPRIETORSHIP'
}

export enum ClStatus {
  Active = 'Active',
  Canceled = 'Canceled',
  Incomplete = 'Incomplete',
  IncompleteExpired = 'IncompleteExpired',
  PastDue = 'PastDue',
  Trialing = 'Trialing',
  Unpaid = 'Unpaid'
}

export type ClSubscription = {
  __typename?: 'CLSubscription';
  cancelAt?: Maybe<Scalars['Instant']>;
  canceledAt?: Maybe<Scalars['Instant']>;
  created?: Maybe<Scalars['Instant']>;
  customer?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  limits?: Maybe<Limits>;
  metadata?: Maybe<Scalars['Map_String_StringScalar']>;
  nextPlan?: Maybe<UiNextPlan>;
  price?: Maybe<SimplePrice>;
  renews?: Maybe<Scalars['Instant']>;
  status?: Maybe<ClStatus>;
  trialEnd?: Maybe<Scalars['Instant']>;
};

export type ClSubscriptionInput = {
  cancelAt?: InputMaybe<Scalars['Instant']>;
  canceledAt?: InputMaybe<Scalars['Instant']>;
  created?: InputMaybe<Scalars['Instant']>;
  customer?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  limits?: InputMaybe<LimitsInput>;
  metadata?: InputMaybe<Scalars['Map_String_StringScalar']>;
  price?: InputMaybe<SimplePriceInput>;
  renews?: InputMaybe<Scalars['Instant']>;
  status?: InputMaybe<ClStatus>;
  trialEnd?: InputMaybe<Scalars['Instant']>;
};

export type CampaignAnalyticsStatisticsResponse = {
  __typename?: 'CampaignAnalyticsStatisticsResponse';
  chargeStatistics?: Maybe<ChargeStatistics>;
  conversionStatistics?: Maybe<TodayConversionStatistics>;
  percentageStatistics?: Maybe<PercentageStatistics>;
  shortUrlClickStatistics?: Maybe<ShortUrlClickStatistics>;
  totalStatistics?: Maybe<StatusStatistics>;
  voiceTransferStats?: Maybe<TotalMessageStatistics>;
};

export type CampaignCreateRequestInput = {
  conversion?: InputMaybe<ConversionInput>;
  enabled: Scalars['Boolean'];
  enrollExisting: Scalars['Boolean'];
  listIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  name?: InputMaybe<Scalars['String']>;
  reEnrollEnabled: Scalars['Boolean'];
  status?: InputMaybe<Status>;
  stepCreateRequests?: InputMaybe<Array<InputMaybe<CampaignStepCreateRequestInput>>>;
};

export enum CampaignDelayPeriod {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export enum CampaignDelayType {
  Date = 'DATE',
  Delay = 'DELAY',
  DelayCustomField = 'DELAY_CUSTOM_FIELD',
  Immediate = 'IMMEDIATE'
}

export type CampaignListResponse = {
  __typename?: 'CampaignListResponse';
  listId?: Maybe<Scalars['Long']>;
  listName?: Maybe<Scalars['String']>;
};

export type CampaignResponse = {
  __typename?: 'CampaignResponse';
  campaignListResponses?: Maybe<Array<Maybe<CampaignListResponse>>>;
  campaignStepResponses?: Maybe<Array<Maybe<CampaignStepResponse>>>;
  conversion?: Maybe<Conversion>;
  conversionStatistics?: Maybe<ConversionSourceStatistics>;
  createdAt?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['Long']>;
  messagesStat?: Maybe<StatusStatistics>;
  name?: Maybe<Scalars['String']>;
  reEnrollEnabled: Scalars['Boolean'];
  shortUrlClickStatistics?: Maybe<ShortUrlClickStatistics>;
  status?: Maybe<Status>;
  uuid?: Maybe<Scalars['UUID']>;
  voiceTransferCount?: Maybe<Scalars['Long']>;
};

export enum CampaignScheduleType {
  After = 'AFTER',
  Before = 'BEFORE',
  On = 'ON'
}

export type CampaignSearchInput = {
  searchPattern?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<Status>>>;
};

export type CampaignStepCreateRequestInput = {
  delay?: InputMaybe<CampaignStepDelayRequestInput>;
  delayType?: InputMaybe<CampaignDelayType>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumberId?: InputMaybe<Scalars['Long']>;
  ringlessMessage?: InputMaybe<RinglessMessageInput>;
  smsMessage?: InputMaybe<SmsMessageInput>;
  voiceMessage?: InputMaybe<VoiceMessageInput>;
};

export type CampaignStepDelayRequestInput = {
  customFieldId?: InputMaybe<Scalars['Long']>;
  hour?: InputMaybe<Scalars['Int']>;
  minute?: InputMaybe<Scalars['Int']>;
  period?: InputMaybe<CampaignDelayPeriod>;
  scheduleType?: InputMaybe<CampaignScheduleType>;
  sendDate?: InputMaybe<Scalars['Date']>;
  value: Scalars['Int'];
};

export type CampaignStepDelayResponse = {
  __typename?: 'CampaignStepDelayResponse';
  customField?: Maybe<CustomField>;
  hour?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Long']>;
  minute?: Maybe<Scalars['Int']>;
  period?: Maybe<CampaignDelayPeriod>;
  scheduleType?: Maybe<CampaignScheduleType>;
  sendDate?: Maybe<Scalars['Date']>;
  value: Scalars['Int'];
};

export type CampaignStepResponse = {
  __typename?: 'CampaignStepResponse';
  delay?: Maybe<CampaignStepDelayResponse>;
  delayType?: Maybe<CampaignDelayType>;
  id?: Maybe<Scalars['Long']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<PhoneNumber>;
  ringlessMessage?: Maybe<RinglessMessage>;
  smsMessage?: Maybe<SmsMessage>;
  type?: Maybe<ContentType>;
  uuid?: Maybe<Scalars['UUID']>;
  voiceMessage?: Maybe<VoiceMessage>;
};

export type CampaignStepUpdateRequestInput = {
  delay?: InputMaybe<CampaignStepDelayRequestInput>;
  delayType?: InputMaybe<CampaignDelayType>;
  id?: InputMaybe<Scalars['Long']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumberId?: InputMaybe<Scalars['Long']>;
  ringlessMessage?: InputMaybe<RinglessMessageInput>;
  smsMessage?: InputMaybe<SmsMessageInput>;
  voiceMessage?: InputMaybe<VoiceMessageInput>;
};

export type CampaignUpdateRequestInput = {
  conversion?: InputMaybe<ConversionInput>;
  enabled: Scalars['Boolean'];
  id?: InputMaybe<Scalars['Long']>;
  listIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  name?: InputMaybe<Scalars['String']>;
  reEnrollEnabled: Scalars['Boolean'];
  status?: InputMaybe<Status>;
  stepUpdateRequests?: InputMaybe<Array<InputMaybe<CampaignStepUpdateRequestInput>>>;
};

export enum CancellationReasonType {
  AnotherSolution = 'ANOTHER_SOLUTION',
  BudgetIssue = 'BUDGET_ISSUE',
  DifficultToUse = 'DIFFICULT_TO_USE',
  Other = 'OTHER',
  SoftwareIssue = 'SOFTWARE_ISSUE',
  SupportQuality = 'SUPPORT_QUALITY',
  TemporaryUsage = 'TEMPORARY_USAGE'
}

export type Capabilities = {
  __typename?: 'Capabilities';
  mms?: Maybe<Scalars['Boolean']>;
  sms?: Maybe<Scalars['Boolean']>;
  voice?: Maybe<Scalars['Boolean']>;
};

export type Card = {
  __typename?: 'Card';
  brand?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  expMonth?: Maybe<Scalars['String']>;
  expYear?: Maybe<Scalars['String']>;
  funding?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
  networks?: Maybe<Networks>;
};

export enum ChangeBroadcastStateAction {
  Archive = 'ARCHIVE',
  Pause = 'PAUSE',
  Restore = 'RESTORE',
  Run = 'RUN',
  Stop = 'STOP'
}

export type ChangeEmailRequestInput = {
  email?: InputMaybe<Scalars['String']>;
};

export type ChangeEmailResponse = {
  __typename?: 'ChangeEmailResponse';
  allowedResendDate?: Maybe<Scalars['Instant']>;
  email?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['Instant']>;
  resendRemainingSeconds?: Maybe<Scalars['Long']>;
};

export type ChangePasswordRequestInput = {
  currentPassword?: InputMaybe<Scalars['String']>;
  newPassword?: InputMaybe<Scalars['String']>;
};

export type ChangePasswordResponse = {
  __typename?: 'ChangePasswordResponse';
  allowedResendDate?: Maybe<Scalars['Instant']>;
  expirationDate?: Maybe<Scalars['Instant']>;
  resendRemainingSeconds?: Maybe<Scalars['Long']>;
};

export enum ChargeObject {
  Call = 'CALL',
  DynamicTts = 'DYNAMIC_TTS',
  InboundForwardCall = 'INBOUND_FORWARD_CALL',
  InboundRingless = 'INBOUND_RINGLESS',
  InboundSms = 'INBOUND_SMS',
  Lookup = 'LOOKUP',
  Mms = 'MMS',
  Ringless = 'RINGLESS',
  Sms = 'SMS'
}

export type ChargeObjectPrice = {
  __typename?: 'ChargeObjectPrice';
  chargeObject?: Maybe<ChargeObject>;
  creditPrice?: Maybe<Scalars['BigDecimal']>;
};

export type ChargeObjectPriceInput = {
  chargeObject?: InputMaybe<ChargeObject>;
  creditPrice?: InputMaybe<Scalars['BigDecimal']>;
};

export type ChargeObjectPricesInput = {
  prices?: InputMaybe<Array<InputMaybe<ChargeObjectPriceInput>>>;
};

export type ChargeStatistics = {
  __typename?: 'ChargeStatistics';
  totalCharged?: Maybe<Scalars['Float']>;
};

export type ConfirmChangePasswordRequestInput = {
  newPassword?: InputMaybe<Scalars['String']>;
  verificationCode?: InputMaybe<Scalars['Int']>;
};

export type ConfirmVerificationCodeRequestInput = {
  verificationCode?: InputMaybe<Scalars['Int']>;
};

export type Contact = {
  __typename?: 'Contact';
  activeCampaignAttemptToLink?: Maybe<Scalars['Instant']>;
  activeCampaignAutomationId?: Maybe<Scalars['String']>;
  activeCampaignId?: Maybe<Scalars['String']>;
  callSubscriptionState?: Maybe<ContactSubscriptionState>;
  carrierName?: Maybe<Scalars['String']>;
  carrierType?: Maybe<Scalars['String']>;
  channel?: Maybe<AccountIntegrationType>;
  charged: Scalars['Boolean'];
  contactSource?: Maybe<ContactSource>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdWith?: Maybe<Scalars['UUID']>;
  customFields?: Maybe<Array<Maybe<ContactCustomField>>>;
  deletedAt?: Maybe<Scalars['Date']>;
  doubleOptInStatus?: Maybe<ContactDoubleOptIn>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formattedPhoneNumber?: Maybe<Scalars['String']>;
  ghlContactId?: Maybe<Scalars['String']>;
  ghlLinkAttemptDate?: Maybe<Scalars['Instant']>;
  hubSpotId?: Maybe<Scalars['String']>;
  hubSpotPortalId?: Maybe<Scalars['Int']>;
  hubspotLinkAttemptDate?: Maybe<Scalars['Instant']>;
  id?: Maybe<Scalars['Long']>;
  keapId?: Maybe<Scalars['Long']>;
  keapLinkAttemptDate?: Maybe<Scalars['Instant']>;
  lastName?: Maybe<Scalars['String']>;
  listContacts?: Maybe<Array<Maybe<ListContact>>>;
  member?: Maybe<Member>;
  mobileCountryCode?: Maybe<Scalars['String']>;
  mobileNetworkCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  optIn?: Maybe<ContactOptIn>;
  organization?: Maybe<Organization>;
  phoneNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Status>;
  subscriptionState?: Maybe<ContactSubscriptionState>;
  updatedAt?: Maybe<Scalars['Date']>;
  verificationResult?: Maybe<PhoneVerificationResult>;
  verificationStatus?: Maybe<PhoneVerificationStatus>;
  verifiedBy?: Maybe<Scalars['Long']>;
  whenSubscriptionUpdated?: Maybe<Scalars['Date']>;
};

export type ContactBulkOperationRequestInput = {
  filter?: InputMaybe<FilterValueInput>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  listId?: InputMaybe<Scalars['Long']>;
  searchPattern?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Status>;
};

export type ContactCard = {
  __typename?: 'ContactCard';
  address?: Maybe<Address>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  facebookUrl?: Maybe<Scalars['String']>;
  fileSize: Scalars['Long'];
  formattedPhoneNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Long']>;
  instagramUrl?: Maybe<Scalars['String']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  member?: Maybe<Member>;
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  phoneCountryCode?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  tagline?: Maybe<Scalars['String']>;
  twitterUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  website?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
};

export type ContactCardInput = {
  address?: InputMaybe<AddressInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  fileSize: Scalars['Long'];
  formattedPhoneNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Long']>;
  instagramUrl?: InputMaybe<Scalars['String']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  member?: InputMaybe<MemberInput>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationInput>;
  phoneCountryCode?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  tagline?: InputMaybe<Scalars['String']>;
  twitterUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  website?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
};

export type ContactCardLight = {
  __typename?: 'ContactCardLight';
  address?: Maybe<Address>;
  email?: Maybe<Scalars['String']>;
  facebookUrl?: Maybe<Scalars['String']>;
  fileSize: Scalars['Long'];
  formattedPhoneNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Long']>;
  instagramUrl?: Maybe<Scalars['String']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  memberId?: Maybe<Scalars['Long']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Long']>;
  phoneCountryCode?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  tagline?: Maybe<Scalars['String']>;
  twitterUrl?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
};

export type ContactCardRequestInput = {
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  instagramUrl?: InputMaybe<Scalars['String']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  tagline?: InputMaybe<Scalars['String']>;
  twitterUrl?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  youtubeUrl?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type ContactCustomField = {
  __typename?: 'ContactCustomField';
  contact?: Maybe<Contact>;
  contactFieldId?: Maybe<ContactFieldId>;
  date?: Maybe<Scalars['Instant']>;
  field?: Maybe<CustomField>;
  number?: Maybe<Scalars['Long']>;
  text?: Maybe<Scalars['String']>;
};

export type ContactCustomFieldRequestInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type ContactCustomFieldResponse = {
  __typename?: 'ContactCustomFieldResponse';
  date?: Maybe<Scalars['Instant']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Long']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum ContactDoubleOptIn {
  OptInConfirmed = 'OptInConfirmed',
  OptInRequested = 'OptInRequested',
  OptInRequired = 'OptInRequired'
}

export type ContactFieldId = {
  __typename?: 'ContactFieldId';
  contactId?: Maybe<Scalars['Long']>;
  fieldId?: Maybe<Scalars['Long']>;
};

export type ContactImportRequestInput = {
  columns?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['Long']>;
  listIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  skipFirstRow: Scalars['Boolean'];
};

export type ContactImportState = {
  __typename?: 'ContactImportState';
  allowImportStatus?: Maybe<AllowImportStatus>;
  columns?: Maybe<Array<Maybe<Scalars['String']>>>;
  contactsLimit: Scalars['Int'];
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  fileKey?: Maybe<Scalars['String']>;
  fileLocation?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Long']>;
  importContactLists?: Maybe<Array<Maybe<ListContactImportState>>>;
  invalidCount: Scalars['Int'];
  member?: Maybe<Member>;
  organization?: Maybe<Organization>;
  originalFileName?: Maybe<Scalars['String']>;
  processingCompletionTime?: Maybe<Scalars['Date']>;
  processingStartTime?: Maybe<Scalars['Date']>;
  simplifiedStatus?: Maybe<Status>;
  skipFirstRow: Scalars['Boolean'];
  status?: Maybe<Status>;
  successCount: Scalars['Int'];
  successPercentage: Scalars['Float'];
  totalCount: Scalars['Long'];
  updatedAt?: Maybe<Scalars['Date']>;
};

export type ContactInfoRequestInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type ContactLightResponse = {
  __typename?: 'ContactLightResponse';
  carrierType?: Maybe<Scalars['String']>;
  contactCustomFields?: Maybe<Array<Maybe<ContactCustomFieldResponse>>>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Long']>;
  internationalPhoneNumber?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  listings?: Maybe<Array<Maybe<ListingLight>>>;
  name?: Maybe<Scalars['String']>;
  optIn?: Maybe<ContactOptIn>;
  phone?: Maybe<Scalars['String']>;
  status?: Maybe<Status>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export enum ContactOptIn {
  AddedByKeyword = 'AddedByKeyword',
  AddedByWebForm = 'AddedByWebForm',
  AddedManually = 'AddedManually',
  Imported = 'Imported',
  Integrated = 'Integrated',
  Migrated = 'Migrated'
}

export type ContactRequestInput = {
  createdWith?: InputMaybe<Scalars['UUID']>;
  customFields?: InputMaybe<Array<InputMaybe<ContactCustomFieldRequestInput>>>;
  doubleOptIn?: InputMaybe<ContactDoubleOptIn>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Long']>;
  lastName?: InputMaybe<Scalars['String']>;
  listIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  optIn?: InputMaybe<ContactOptIn>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Status>;
};

export type ContactResponse = {
  __typename?: 'ContactResponse';
  contact?: Maybe<Contact>;
  updatedListings?: Maybe<Array<Maybe<Listing>>>;
};

export type ContactSearchInput = {
  callSubscriptionStates?: InputMaybe<Array<InputMaybe<ContactSubscriptionState>>>;
  excludedContactIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  excludedListIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  searchPattern?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Status>;
  subscriptionStates?: InputMaybe<Array<InputMaybe<ContactSubscriptionState>>>;
};

export type ContactSource = {
  __typename?: 'ContactSource';
  id?: Maybe<Scalars['Long']>;
  name?: Maybe<Scalars['String']>;
  sourceType?: Maybe<SourceType>;
};

export type ContactStatisticsByUuidResponse = {
  __typename?: 'ContactStatisticsByUuidResponse';
  chargeStatistics?: Maybe<ChargeStatistics>;
  conversionStatistics?: Maybe<TodayConversionStatistics>;
  percentageStatistics?: Maybe<PercentageContactStatusStatistics>;
  shortUrlClickStatistics?: Maybe<ShortUrlClickStatistics>;
  todayStat?: Maybe<ContactStatusStatistics>;
  totalStat?: Maybe<ContactStatusStatistics>;
};

export type ContactStatisticsResponse = {
  __typename?: 'ContactStatisticsResponse';
  activeCount: Scalars['Long'];
  archivedCount: Scalars['Long'];
  inactiveCount: Scalars['Long'];
  invalidCount: Scalars['Long'];
  totalCount: Scalars['Long'];
  unsubscribedCount: Scalars['Long'];
};

export type ContactStatusStatistics = {
  __typename?: 'ContactStatusStatistics';
  active?: Maybe<Scalars['Long']>;
  confirmed?: Maybe<Scalars['Long']>;
  subscribed?: Maybe<Scalars['Long']>;
  total?: Maybe<Scalars['Long']>;
  unsubscribed?: Maybe<Scalars['Long']>;
};

export type ContactStatusStatisticsInput = {
  active?: InputMaybe<Scalars['Long']>;
  confirmed?: InputMaybe<Scalars['Long']>;
  subscribed?: InputMaybe<Scalars['Long']>;
  total?: InputMaybe<Scalars['Long']>;
  unsubscribed?: InputMaybe<Scalars['Long']>;
};

export enum ContactSubscriptionState {
  HardUnsubscribed = 'HARD_UNSUBSCRIBED',
  ReSubscribed = 'RE_SUBSCRIBED',
  SoftUnsubscribed = 'SOFT_UNSUBSCRIBED',
  Subscribed = 'SUBSCRIBED'
}

export type ContactWebhookIntegrationResponse = {
  __typename?: 'ContactWebhookIntegrationResponse';
  app?: Maybe<AccountIntegrationType>;
  connected?: Maybe<Scalars['Boolean']>;
  listings?: Maybe<Array<Maybe<Listing>>>;
  webhookUrl?: Maybe<Scalars['String']>;
};

export enum ContentType {
  None = 'None',
  Ringless = 'Ringless',
  Sms = 'SMS',
  Voice = 'Voice'
}

export type Conversion = {
  __typename?: 'Conversion';
  createdAt?: Maybe<Scalars['Date']>;
  defaultAmount?: Maybe<Scalars['Float']>;
  deletedAt?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['Long']>;
  member?: Maybe<Member>;
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  uniqueHit?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['Date']>;
  urlPatterns?: Maybe<Array<Maybe<ConversionUrlMatchConfig>>>;
};

export type ConversionHitProjection = {
  __typename?: 'ConversionHitProjection';
  amount?: Maybe<Scalars['Float']>;
  date?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['Long']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type ConversionInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  defaultAmount?: InputMaybe<Scalars['Float']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['Long']>;
  member?: InputMaybe<MemberInput>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationInput>;
  uniqueHit?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  urlPatterns?: InputMaybe<Array<InputMaybe<ConversionUrlMatchConfigInput>>>;
};

export enum ConversionMatchType {
  Pattern = 'PATTERN',
  Url = 'URL'
}

export type ConversionResponse = {
  __typename?: 'ConversionResponse';
  conversion: Scalars['Float'];
  defaultAmount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Long']>;
  name?: Maybe<Scalars['String']>;
  revenue: Scalars['Float'];
  totalHits: Scalars['Long'];
  uniqueHit: Scalars['Boolean'];
  urlPatterns?: Maybe<Array<Maybe<ConversionUrlMatchConfig>>>;
};

export type ConversionSourceStatistics = {
  __typename?: 'ConversionSourceStatistics';
  revenue?: Maybe<Scalars['Float']>;
  source?: Maybe<Scalars['UUID']>;
  total?: Maybe<Scalars['Long']>;
};

export type ConversionSourceStatisticsInput = {
  revenue?: InputMaybe<Scalars['Float']>;
  source?: InputMaybe<Scalars['UUID']>;
  total?: InputMaybe<Scalars['Long']>;
};

export type ConversionStatistics = {
  __typename?: 'ConversionStatistics';
  percentage?: Maybe<Scalars['Float']>;
  revenue?: Maybe<Scalars['Float']>;
  roi?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Long']>;
  totalCosts?: Maybe<Scalars['Float']>;
};

export type ConversionUrlMatchConfig = {
  __typename?: 'ConversionUrlMatchConfig';
  id?: Maybe<Scalars['Int']>;
  matchType?: Maybe<ConversionMatchType>;
  pattern?: Maybe<Scalars['String']>;
};

export type ConversionUrlMatchConfigInput = {
  id?: InputMaybe<Scalars['Int']>;
  matchType?: InputMaybe<ConversionMatchType>;
  pattern?: InputMaybe<Scalars['String']>;
};

export type Country = {
  __typename?: 'Country';
  countryCode?: Maybe<Scalars['String']>;
  countryName?: Maybe<Scalars['String']>;
};

export enum CountryCode {
  Ca = 'CA',
  Us = 'US'
}

export type CountryInput = {
  countryCode?: InputMaybe<Scalars['String']>;
  countryName?: InputMaybe<Scalars['String']>;
};

export type CreateInvitationBidRequestInput = {
  accessType?: InputMaybe<InvitationAccessType>;
  email?: InputMaybe<Scalars['String']>;
  listIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  role: InvitationRole;
};

export type CreditPrice = {
  __typename?: 'CreditPrice';
  cost?: Maybe<Scalars['Float']>;
  creditsAmount?: Maybe<Scalars['Int']>;
  planName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type CreditPriceInput = {
  cost?: InputMaybe<Scalars['Float']>;
  creditsAmount?: InputMaybe<Scalars['Int']>;
  planName?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CreditPriceSelection = {
  __typename?: 'CreditPriceSelection';
  allowedPrices?: Maybe<Array<Maybe<CreditPrice>>>;
  planName?: Maybe<Scalars['String']>;
  upgradePrices?: Maybe<Array<Maybe<CreditPrice>>>;
};

export type CustomField = {
  __typename?: 'CustomField';
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  displayIndex?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Long']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  type?: Maybe<CustomFieldType>;
  updatedAt?: Maybe<Scalars['Date']>;
  used?: Maybe<Scalars['Boolean']>;
};

export type CustomFieldRequestInput = {
  key?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  required?: InputMaybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

export enum CustomFieldType {
  Date = 'DATE',
  DateTime = 'DATE_TIME',
  Number = 'NUMBER',
  Text = 'TEXT',
  Url = 'URL'
}

export type CustomFieldsRequestInput = {
  customFields: Array<InputMaybe<CustomFieldRequestInput>>;
};

export type CustomMonthConfig = {
  __typename?: 'CustomMonthConfig';
  eachMonthDayConfig?: Maybe<EachMonthDayConfig>;
  monthRepeatType?: Maybe<CustomMonthRepeatType>;
  onMonthDayConfig?: Maybe<OnMonthDayConfig>;
};

export type CustomMonthConfigInput = {
  eachMonthDayConfig?: InputMaybe<EachMonthDayConfigInput>;
  monthRepeatType?: InputMaybe<CustomMonthRepeatType>;
  onMonthDayConfig?: InputMaybe<OnMonthDayConfigInput>;
};

export enum CustomMonthRepeatType {
  Each = 'EACH',
  OnThe = 'ON_THE'
}

export type CustomPlanCreateRqInput = {
  chargeObjectPrices?: InputMaybe<ChargeObjectPricesInput>;
  credits: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  extraCreditPrice: Scalars['Float'];
  name?: InputMaybe<Scalars['String']>;
  period?: InputMaybe<PlanPeriod>;
  price: Scalars['Float'];
  title?: InputMaybe<Scalars['String']>;
};

export type CustomPlanUpdateRqInput = {
  chargeObjectPrices?: InputMaybe<ChargeObjectPricesInput>;
  description?: InputMaybe<Scalars['String']>;
  extraCreditPrice: Scalars['Float'];
  id?: InputMaybe<Scalars['Long']>;
  name?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CustomRepeatConfig = {
  __typename?: 'CustomRepeatConfig';
  monthConfig?: Maybe<CustomMonthConfig>;
  repeatCount?: Maybe<Scalars['Int']>;
  repeatType?: Maybe<RepeatType>;
  weekConfig?: Maybe<CustomWeekConfig>;
};

export type CustomRepeatConfigInput = {
  monthConfig?: InputMaybe<CustomMonthConfigInput>;
  repeatCount?: InputMaybe<Scalars['Int']>;
  repeatType?: InputMaybe<RepeatType>;
  weekConfig?: InputMaybe<CustomWeekConfigInput>;
};

export type CustomWeekConfig = {
  __typename?: 'CustomWeekConfig';
  days?: Maybe<Array<Maybe<DayOfWeek>>>;
};

export type CustomWeekConfigInput = {
  days?: InputMaybe<Array<InputMaybe<DayOfWeek>>>;
};

export type DataCaptureConfig = {
  __typename?: 'DataCaptureConfig';
  fieldCaptures?: Maybe<Array<Maybe<FieldCapture>>>;
  lastReplyConfig?: Maybe<WorkflowSmsConfig>;
  retriesCount: Scalars['Int'];
};

export type DataCaptureConfigInput = {
  fieldCaptures?: InputMaybe<Array<InputMaybe<FieldCaptureInput>>>;
  lastReplyConfig?: InputMaybe<WorkflowSmsConfigInput>;
  retriesCount: Scalars['Int'];
};

export type DateRangeCriteriaInput = {
  from?: InputMaybe<Scalars['Date']>;
  to?: InputMaybe<Scalars['Date']>;
};

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export enum Direction {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum DowngradeReasonType {
  BudgetIssue = 'BUDGET_ISSUE',
  Other = 'OTHER',
  SeasonalBusiness = 'SEASONAL_BUSINESS',
  TooManyCredits = 'TOO_MANY_CREDITS',
  UnusedCredits = 'UNUSED_CREDITS',
  WrongPlan = 'WRONG_PLAN'
}

export type EachMonthDayConfig = {
  __typename?: 'EachMonthDayConfig';
  days?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type EachMonthDayConfigInput = {
  days?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export enum ExpectedMessageType {
  Ringless = 'RINGLESS',
  Sms = 'SMS',
  Voice = 'VOICE'
}

export enum ExternalPhoneNumberProvider {
  Telnyx = 'TELNYX'
}

export enum FailReasonType {
  InsufficientFunds = 'INSUFFICIENT_FUNDS'
}

export type FieldCapture = {
  __typename?: 'FieldCapture';
  fieldName?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  smsConfig?: Maybe<WorkflowSmsConfig>;
};

export type FieldCaptureInput = {
  fieldName?: InputMaybe<Scalars['String']>;
  index: Scalars['Int'];
  smsConfig?: InputMaybe<WorkflowSmsConfigInput>;
};

export type Filter = {
  __typename?: 'Filter';
  andIndex: Scalars['Int'];
  condition?: Maybe<FilterCondition>;
  dataType?: Maybe<FilterDataType>;
  field?: Maybe<Scalars['String']>;
  orIndex: Scalars['Int'];
  type?: Maybe<FilterFieldType>;
  value?: Maybe<Scalars['String']>;
  valueExt?: Maybe<Scalars['String']>;
};

export enum FilterCondition {
  After = 'AFTER',
  Before = 'BEFORE',
  Between = 'BETWEEN',
  ContainsAny = 'CONTAINS_ANY',
  ContainsNone = 'CONTAINS_NONE',
  EndsWithAny = 'ENDS_WITH_ANY',
  Eq = 'EQ',
  Exists = 'EXISTS',
  Greater = 'GREATER',
  GreaterEq = 'GREATER_EQ',
  In = 'IN',
  Less = 'LESS',
  LessEq = 'LESS_EQ',
  NotBetween = 'NOT_BETWEEN',
  NotEq = 'NOT_EQ',
  NotExists = 'NOT_EXISTS',
  NotIn = 'NOT_IN',
  On = 'ON',
  StartsWithAny = 'STARTS_WITH_ANY'
}

export enum FilterDataType {
  Date = 'DATE',
  DateTime = 'DATE_TIME',
  List = 'LIST',
  Number = 'NUMBER',
  Phone = 'PHONE',
  Select = 'SELECT',
  Text = 'TEXT',
  Url = 'URL'
}

export enum FilterFieldType {
  Contact = 'CONTACT',
  Custom = 'CUSTOM'
}

export type FilterFieldsResponse = {
  __typename?: 'FilterFieldsResponse';
  dataTypeConditions?: Maybe<Scalars['Map_FilterDataType_Set_LabeledDataResponseScalar']>;
  fields?: Maybe<Array<Maybe<FilterOption>>>;
};

export type FilterInput = {
  andIndex: Scalars['Int'];
  condition?: InputMaybe<FilterCondition>;
  dataType?: InputMaybe<FilterDataType>;
  field?: InputMaybe<Scalars['String']>;
  orIndex: Scalars['Int'];
  type?: InputMaybe<FilterFieldType>;
  value?: InputMaybe<Scalars['String']>;
  valueExt?: InputMaybe<Scalars['String']>;
};

export type FilterOption = {
  __typename?: 'FilterOption';
  dataType?: Maybe<FilterDataType>;
  ext?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<Labeled>>>;
};

export type FilterValue = {
  __typename?: 'FilterValue';
  contactIds?: Maybe<Array<Maybe<Scalars['Long']>>>;
  empty: Scalars['Boolean'];
  filters?: Maybe<Array<Maybe<Filter>>>;
  listIds?: Maybe<Array<Maybe<Scalars['Long']>>>;
  segmentIds?: Maybe<Array<Maybe<Scalars['Long']>>>;
  sourceFilters?: Maybe<Array<Maybe<Array<Maybe<Filter>>>>>;
};

export type FilterValueInput = {
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  filters?: InputMaybe<Array<InputMaybe<FilterInput>>>;
  listIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  segmentIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  sourceFilters?: InputMaybe<Array<InputMaybe<Array<InputMaybe<FilterInput>>>>>;
};

export enum IntegrationConnectionType {
  Agency = 'AGENCY',
  SubAccount = 'SUB_ACCOUNT'
}

export type IntegrationField = {
  __typename?: 'IntegrationField';
  integrationType?: Maybe<AccountIntegrationType>;
  phoneFields?: Maybe<Array<Maybe<SpecificField>>>;
  specificFields?: Maybe<Array<Maybe<SpecificField>>>;
  standardFields?: Maybe<Array<Maybe<StandardField>>>;
};

export enum InvitationAccessType {
  Full = 'FULL',
  Restricted = 'RESTRICTED'
}

export type InvitationBid = {
  __typename?: 'InvitationBid';
  accessType?: Maybe<InvitationAccessType>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['Instant']>;
  id?: Maybe<Scalars['Long']>;
  invitationLink?: Maybe<Scalars['String']>;
  listIds?: Maybe<Array<Maybe<Scalars['Long']>>>;
  member?: Maybe<Member>;
  organization?: Maybe<Organization>;
  role?: Maybe<InvitationRole>;
  updatedAt?: Maybe<Scalars['Date']>;
  uuid?: Maybe<Scalars['UUID']>;
};

export type InvitationBidInput = {
  accessType?: InputMaybe<InvitationAccessType>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  expirationDate?: InputMaybe<Scalars['Instant']>;
  id?: InputMaybe<Scalars['Long']>;
  invitationLink?: InputMaybe<Scalars['String']>;
  listIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  member?: InputMaybe<MemberInput>;
  organization?: InputMaybe<OrganizationInput>;
  role?: InputMaybe<InvitationRole>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  uuid?: InputMaybe<Scalars['UUID']>;
};

export type InvitationBidResponse = {
  __typename?: 'InvitationBidResponse';
  email?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['Instant']>;
  id?: Maybe<Scalars['Long']>;
  link?: Maybe<Scalars['String']>;
  role?: Maybe<InvitationRole>;
  uuid?: Maybe<Scalars['UUID']>;
};

export enum InvitationRole {
  Admin = 'ADMIN',
  Member = 'MEMBER'
}

export enum InvoiceStatus {
  Draft = 'Draft',
  Open = 'Open',
  Paid = 'Paid',
  Refunded = 'Refunded',
  UnCollectible = 'UnCollectible',
  Undefined = 'Undefined',
  Void = 'Void'
}

export type Keyword = {
  __typename?: 'Keyword';
  assetIds?: Maybe<Array<Maybe<Scalars['Long']>>>;
  cardIds?: Maybe<Array<Maybe<Scalars['Long']>>>;
  contactStatusStatistics?: Maybe<KeywordContactStatusStatistics>;
  conversion?: Maybe<Conversion>;
  conversionStatistics?: Maybe<ConversionSourceStatistics>;
  createdAt?: Maybe<Scalars['Date']>;
  dataCaptureConfig?: Maybe<DataCaptureConfig>;
  deletedAt?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['Long']>;
  keywordLists?: Maybe<Array<Maybe<ListKeyword>>>;
  keywordPhoneNumbers?: Maybe<Array<Maybe<KeywordPhoneNumber>>>;
  listIds?: Maybe<Array<Maybe<Scalars['Long']>>>;
  member?: Maybe<Member>;
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  phoneNumberIds?: Maybe<Array<Maybe<Scalars['Long']>>>;
  shortUrlClickStatistics?: Maybe<ShortUrlClickStatistics>;
  smsMessage?: Maybe<SmsMessage>;
  sourceName: Scalars['String'];
  sourceType?: Maybe<SourceType>;
  status: Status;
  type?: Maybe<ContentType>;
  updatedAt?: Maybe<Scalars['Date']>;
  uuid?: Maybe<Scalars['UUID']>;
};

export type KeywordContactPercentageStatistics = {
  __typename?: 'KeywordContactPercentageStatistics';
  activePercentage: Scalars['Float'];
  unsubscribedPercentage: Scalars['Float'];
};

export type KeywordContactResponse = {
  __typename?: 'KeywordContactResponse';
  addedTime?: Maybe<Scalars['Instant']>;
  contactId?: Maybe<Scalars['Long']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  status?: Maybe<Status>;
};

export type KeywordContactStatisticsResponse = {
  __typename?: 'KeywordContactStatisticsResponse';
  chargeStatistics?: Maybe<ChargeStatistics>;
  conversionStatistics?: Maybe<TodayConversionStatistics>;
  percentageStatistics?: Maybe<KeywordContactPercentageStatistics>;
  shortUrlClickStatistics?: Maybe<ShortUrlClickStatistics>;
  todayStatistics?: Maybe<KeywordContactStatusStatistics>;
  totalStatistics?: Maybe<KeywordContactStatusStatistics>;
};

export type KeywordContactStatusStatistics = {
  __typename?: 'KeywordContactStatusStatistics';
  activeCount: Scalars['Long'];
  subscribersCount: Scalars['Long'];
  unsubscribedCount: Scalars['Long'];
};

export type KeywordContactStatusStatisticsInput = {
  activeCount: Scalars['Long'];
  subscribersCount: Scalars['Long'];
  unsubscribedCount: Scalars['Long'];
};

export type KeywordForm = {
  __typename?: 'KeywordForm';
  id?: Maybe<Scalars['Long']>;
  name?: Maybe<Scalars['String']>;
};

export type KeywordInput = {
  contactStatusStatistics?: InputMaybe<KeywordContactStatusStatisticsInput>;
  conversion?: InputMaybe<ConversionInput>;
  conversionStatistics?: InputMaybe<ConversionSourceStatisticsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  dataCaptureConfig?: InputMaybe<DataCaptureConfigInput>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['Long']>;
  keywordPhoneNumbers?: InputMaybe<Array<InputMaybe<KeywordPhoneNumberInput>>>;
  listIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  member?: InputMaybe<MemberInput>;
  name: Scalars['String'];
  organization?: InputMaybe<OrganizationInput>;
  phoneNumberIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  shortUrlClickStatistics?: InputMaybe<ShortUrlClickStatisticsInput>;
  smsMessage?: InputMaybe<SmsMessageInput>;
  status: Status;
  updatedAt?: InputMaybe<Scalars['Date']>;
  uuid?: InputMaybe<Scalars['UUID']>;
};

export type KeywordPhoneNumber = {
  __typename?: 'KeywordPhoneNumber';
  keyword?: Maybe<Keyword>;
  phoneNumber?: Maybe<PhoneNumber>;
};

export type KeywordPhoneNumberInput = {
  phoneNumber?: InputMaybe<PhoneNumberInput>;
};

export type Labeled = {
  __typename?: 'Labeled';
  key?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

export type Limits = {
  __typename?: 'Limits';
  automations?: Maybe<Scalars['Int']>;
  broadcasts?: Maybe<Scalars['Int']>;
  campaigns?: Maybe<Scalars['Int']>;
  contacts?: Maybe<Scalars['Int']>;
  integrations?: Maybe<Scalars['Int']>;
  keywords?: Maybe<Scalars['Int']>;
  numbers?: Maybe<Scalars['Int']>;
  triggers?: Maybe<Scalars['Int']>;
  users?: Maybe<Scalars['Int']>;
  webForms?: Maybe<Scalars['Int']>;
};

export type LimitsInput = {
  automations?: InputMaybe<Scalars['Int']>;
  broadcasts?: InputMaybe<Scalars['Int']>;
  campaigns?: InputMaybe<Scalars['Int']>;
  contacts?: InputMaybe<Scalars['Int']>;
  integrations?: InputMaybe<Scalars['Int']>;
  keywords?: InputMaybe<Scalars['Int']>;
  numbers?: InputMaybe<Scalars['Int']>;
  triggers?: InputMaybe<Scalars['Int']>;
  users?: InputMaybe<Scalars['Int']>;
  webForms?: InputMaybe<Scalars['Int']>;
};

export type ListContact = {
  __typename?: 'ListContact';
  contact?: Maybe<Contact>;
  listing?: Maybe<Listing>;
};

export type ListContactImportState = {
  __typename?: 'ListContactImportState';
  listing?: Maybe<Listing>;
};

export type ListContactSearchInput = {
  excludedContactIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  excludedListIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  excludedSegmentIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  searchPattern?: InputMaybe<Scalars['String']>;
};

export type ListContactSearchResult = {
  __typename?: 'ListContactSearchResult';
  contacts?: Maybe<Array<Maybe<Contact>>>;
  listings?: Maybe<Array<Maybe<Listing>>>;
  segments?: Maybe<Array<Maybe<SegmentResponse>>>;
  totalContacts: Scalars['Int'];
  totalListings: Scalars['Int'];
  totalSegments: Scalars['Int'];
};

export type ListKeyword = {
  __typename?: 'ListKeyword';
  keyword?: Maybe<Keyword>;
  listing?: Maybe<Listing>;
};

export type ListRequestInput = {
  id?: InputMaybe<Scalars['Long']>;
  name?: InputMaybe<Scalars['String']>;
};

export type ListResponse = {
  __typename?: 'ListResponse';
  activeContactsCount: Scalars['Long'];
  createdAt?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['Long']>;
  invalidContactsCount: Scalars['Long'];
  keywords?: Maybe<Array<Maybe<KeywordForm>>>;
  name?: Maybe<Scalars['String']>;
  totalContactsCount: Scalars['Long'];
  unsubscribedContactsCount: Scalars['Long'];
  webForms?: Maybe<Array<Maybe<WebFormForm>>>;
};

export type ListTrigger = {
  __typename?: 'ListTrigger';
  listing?: Maybe<Listing>;
  trigger?: Maybe<Trigger>;
};

export type Listing = {
  __typename?: 'Listing';
  activeContactsCount: Scalars['Long'];
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['Long']>;
  invalidContactsCount: Scalars['Long'];
  listKeywords?: Maybe<Array<Maybe<ListKeyword>>>;
  listTriggers?: Maybe<Array<Maybe<ListTrigger>>>;
  listWebForms?: Maybe<Array<Maybe<WebFormListContact>>>;
  member?: Maybe<Member>;
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  sourceName?: Maybe<Scalars['String']>;
  sourceNameIndex?: Maybe<Scalars['Int']>;
  totalContactsCount: Scalars['Long'];
  unsubscribedContactsCount: Scalars['Long'];
  updatedAt?: Maybe<Scalars['Date']>;
};

export type ListingLight = {
  __typename?: 'ListingLight';
  createdAt?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['Long']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type ListingSearchInput = {
  excludedListIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  searchPattern?: InputMaybe<Scalars['String']>;
};

export type LiveAnswer = {
  __typename?: 'LiveAnswer';
  audioId?: Maybe<Scalars['Long']>;
  externalAudioId?: Maybe<Scalars['Long']>;
  liveAnswer?: Maybe<AudioItem>;
  liveAnswerEnabled?: Maybe<Scalars['Boolean']>;
  transferCallDigit?: Maybe<Scalars['Int']>;
  transferCallEnabled?: Maybe<Scalars['Boolean']>;
  transferCallNumber?: Maybe<Scalars['String']>;
  unsubscribeDigit?: Maybe<Scalars['Int']>;
};

export type LiveAnswerInput = {
  audioId?: InputMaybe<Scalars['Long']>;
  liveAnswer?: InputMaybe<AudioItemInput>;
  liveAnswerEnabled?: InputMaybe<Scalars['Boolean']>;
  transferCallDigit?: InputMaybe<Scalars['Int']>;
  transferCallEnabled?: InputMaybe<Scalars['Boolean']>;
  transferCallNumber?: InputMaybe<Scalars['String']>;
  unsubscribeDigit?: InputMaybe<Scalars['Int']>;
};

export type Location = {
  __typename?: 'Location';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['Long']>;
  population?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type Member = {
  __typename?: 'Member';
  accessType?: Maybe<InvitationAccessType>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  displayRole?: Maybe<Scalars['String']>;
  displayState?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Long']>;
  invitationBid?: Maybe<InvitationBid>;
  listIds?: Maybe<Array<Maybe<Scalars['Long']>>>;
  memberRegistration?: Maybe<MemberRegistration>;
  organization?: Maybe<Organization>;
  profile?: Maybe<MemberProfile>;
  role?: Maybe<MemberRole>;
  roleSortPriority?: Maybe<Scalars['Int']>;
  state?: Maybe<MemberState>;
  stateSortPriority?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type MemberAndClSubscription = {
  __typename?: 'MemberAndCLSubscription';
  member?: Maybe<MemberResponse>;
  subscription?: Maybe<ClSubscription>;
};

export type MemberInput = {
  accessType?: InputMaybe<InvitationAccessType>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['Long']>;
  invitationBid?: InputMaybe<InvitationBidInput>;
  listIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  memberRegistration?: InputMaybe<MemberRegistrationInput>;
  organization?: InputMaybe<OrganizationInput>;
  profile?: InputMaybe<MemberProfileInput>;
  role?: InputMaybe<MemberRole>;
  roleSortPriority?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<MemberState>;
  stateSortPriority?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type MemberProfile = {
  __typename?: 'MemberProfile';
  createdAt?: Maybe<Scalars['Date']>;
  customTimeZone?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['Date']>;
  displayState?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  hsObjectId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Long']>;
  internationalPhone?: Maybe<Scalars['String']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  lastSelectedOrganizationId?: Maybe<Scalars['Long']>;
  memberHash?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  registrationFinished: Scalars['Boolean'];
  state?: Maybe<MemberProfileState>;
  stateSortPriority?: Maybe<Scalars['Int']>;
  timeZoneType?: Maybe<TimeZoneType>;
  uniqueId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  userTimeZone?: Maybe<UserTimeZone>;
};

export type MemberProfileInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  customTimeZone?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  hsObjectId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Long']>;
  internationalPhone?: InputMaybe<Scalars['String']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastSelectedOrganizationId?: InputMaybe<Scalars['Long']>;
  memberHash?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  registrationFinished: Scalars['Boolean'];
  state?: InputMaybe<MemberProfileState>;
  stateSortPriority?: InputMaybe<Scalars['Int']>;
  timeZoneType?: InputMaybe<TimeZoneType>;
  uniqueId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type MemberProfileOrganization = {
  __typename?: 'MemberProfileOrganization';
  companyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Long']>;
};

export type MemberProfileResponse = {
  __typename?: 'MemberProfileResponse';
  accessType?: Maybe<InvitationAccessType>;
  createdAt?: Maybe<Scalars['Date']>;
  customTimeZone?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  hsObjectId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Long']>;
  internationalPhone?: Maybe<Scalars['String']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  lastSelectedOrganizationId?: Maybe<Scalars['Long']>;
  listIds?: Maybe<Array<Maybe<Scalars['Long']>>>;
  memberHash?: Maybe<Scalars['String']>;
  memberRegistration?: Maybe<MemberRegistration>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  registrationFinished: Scalars['Boolean'];
  state?: Maybe<MemberProfileState>;
  stateSortPriority?: Maybe<Scalars['Int']>;
  timeZoneType?: Maybe<TimeZoneType>;
  uniqueId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type MemberProfileSearchInput = {
  searchPattern?: InputMaybe<Scalars['String']>;
  states?: InputMaybe<Array<InputMaybe<MemberProfileState>>>;
};

export enum MemberProfileState {
  Active = 'ACTIVE',
  Banned = 'BANNED',
  EmailConfirmationAwait = 'EMAIL_CONFIRMATION_AWAIT'
}

export type MemberRegistration = {
  __typename?: 'MemberRegistration';
  currentStep?: Maybe<Scalars['Int']>;
  memberProfileId?: Maybe<Scalars['Long']>;
  migratedEmail?: Maybe<Scalars['String']>;
  migrationFinished: Scalars['Boolean'];
  newSubscription?: Maybe<ClSubscription>;
  oldCredits?: Maybe<Scalars['Int']>;
  oldCreditsForPurchase: Scalars['Int'];
  oldCreditsFree: Scalars['Int'];
  oldCreditsLastYear: Scalars['Int'];
  oldSubscription?: Maybe<ClSubscription>;
  saveCredits: Scalars['Boolean'];
  selectedPriceId?: Maybe<Scalars['String']>;
  type?: Maybe<MemberRegistrationType>;
};

export type MemberRegistrationInput = {
  currentStep?: InputMaybe<Scalars['Int']>;
  memberProfileId?: InputMaybe<Scalars['Long']>;
  migratedEmail?: InputMaybe<Scalars['String']>;
  migrationFinished: Scalars['Boolean'];
  newSubscription?: InputMaybe<ClSubscriptionInput>;
  oldCredits?: InputMaybe<Scalars['Int']>;
  oldCreditsForPurchase: Scalars['Int'];
  oldCreditsFree: Scalars['Int'];
  oldCreditsLastYear: Scalars['Int'];
  oldSubscription?: InputMaybe<ClSubscriptionInput>;
  saveCredits: Scalars['Boolean'];
  selectedPriceId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<MemberRegistrationType>;
};

export enum MemberRegistrationType {
  Migration = 'MIGRATION',
  Signup = 'SIGNUP'
}

export type MemberResponse = {
  __typename?: 'MemberResponse';
  accessType?: Maybe<InvitationAccessType>;
  createdAt?: Maybe<Scalars['Date']>;
  customTimeZone?: Maybe<Scalars['String']>;
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['Date']>;
  displayRole?: Maybe<Scalars['String']>;
  displayState?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  hsObjectId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Long']>;
  internationalPhone?: Maybe<Scalars['String']>;
  invitationBid?: Maybe<InvitationBid>;
  invitationLink?: Maybe<Scalars['String']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  lastSelectedOrganizationId?: Maybe<Scalars['Long']>;
  listIds?: Maybe<Array<Maybe<Scalars['Long']>>>;
  memberHash?: Maybe<Scalars['String']>;
  memberRegistration?: Maybe<MemberRegistration>;
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  phone?: Maybe<Scalars['String']>;
  registrationFinished: Scalars['Boolean'];
  role?: Maybe<MemberRole>;
  roleSortPriority?: Maybe<Scalars['Int']>;
  state?: Maybe<MemberState>;
  stateSortPriority?: Maybe<Scalars['Int']>;
  timeZoneType?: Maybe<TimeZoneType>;
  uniqueId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  userTimeZone?: Maybe<UserTimeZone>;
};

export enum MemberRole {
  Admin = 'ADMIN',
  Owner = 'OWNER',
  Sysadmin = 'SYSADMIN',
  User = 'USER'
}

export enum MemberState {
  Active = 'ACTIVE',
  Banned = 'BANNED',
  EmailConfirmationAwait = 'EMAIL_CONFIRMATION_AWAIT',
  Removed = 'REMOVED'
}

export type MemberUpdateInput = {
  couponId?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  timeZoneCode?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type MessageDataResponse = {
  __typename?: 'MessageDataResponse';
  duration?: Maybe<Scalars['Int']>;
  extStatus?: Maybe<Scalars['String']>;
  extStatusDescription?: Maybe<Scalars['String']>;
  extStatusLabel?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Long']>;
  state?: Maybe<MessageStateResponse>;
  text?: Maybe<Scalars['String']>;
  totalShortUrl?: Maybe<Scalars['Long']>;
  type?: Maybe<MessageType>;
  uniqueClicks?: Maybe<Scalars['Long']>;
};

export type MessageRingless = {
  __typename?: 'MessageRingless';
  audioItem?: Maybe<AudioItem>;
  callerId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['Long']>;
  sessionId?: Maybe<Scalars['Long']>;
  state?: Maybe<MessageState>;
  ttsText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  voiceId?: Maybe<Scalars['String']>;
};

export type MessageState = {
  __typename?: 'MessageState';
  appConversationId?: Maybe<Scalars['String']>;
  appConversationProviderId?: Maybe<Scalars['String']>;
  appMessageId?: Maybe<Scalars['String']>;
  appType?: Maybe<AccountIntegrationType>;
  boundType?: Maybe<BoundType>;
  campaignId?: Maybe<Scalars['Long']>;
  chargeAmount?: Maybe<Scalars['Float']>;
  chargeAttempted: Scalars['Boolean'];
  contactHubSpotId?: Maybe<Scalars['String']>;
  contactId?: Maybe<Scalars['Long']>;
  contactName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  deduplicationId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['Date']>;
  failReasonType?: Maybe<FailReasonType>;
  fromNumberId?: Maybe<Scalars['Long']>;
  fromNumberStr?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Long']>;
  lastUpdated?: Maybe<Scalars['Date']>;
  member?: Maybe<Member>;
  messagePrice?: Maybe<Scalars['Float']>;
  organization?: Maybe<Organization>;
  reason?: Maybe<Scalars['String']>;
  simpleStatus?: Maybe<Status>;
  source?: Maybe<Scalars['UUID']>;
  sourceType?: Maybe<SourceType>;
  status?: Maybe<Status>;
  timeToSend?: Maybe<Scalars['Date']>;
  toNumber?: Maybe<Scalars['String']>;
  type?: Maybe<MessageStateType>;
  updatedAt?: Maybe<Scalars['Date']>;
  uuid?: Maybe<Scalars['UUID']>;
  whenCreated?: Maybe<Scalars['Date']>;
  whenDelivered?: Maybe<Scalars['Date']>;
  whenFailed?: Maybe<Scalars['Date']>;
  whenProcessing?: Maybe<Scalars['Date']>;
  whenQueued?: Maybe<Scalars['Date']>;
  whenRetryProcessing?: Maybe<Scalars['Date']>;
  whenScheduled?: Maybe<Scalars['Date']>;
  whenSent?: Maybe<Scalars['Date']>;
  whenUndelivered?: Maybe<Scalars['Date']>;
};

export type MessageStateResponse = {
  __typename?: 'MessageStateResponse';
  boundType?: Maybe<BoundType>;
  chargeAmount?: Maybe<Scalars['Float']>;
  contactId?: Maybe<Scalars['Long']>;
  contactName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  failReasonType?: Maybe<FailReasonType>;
  fromNumberId?: Maybe<Scalars['Long']>;
  fromNumberStr?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Long']>;
  reason?: Maybe<Scalars['String']>;
  simpleStatus?: Maybe<Status>;
  source?: Maybe<Scalars['UUID']>;
  status?: Maybe<Status>;
  timeToSend?: Maybe<Scalars['Date']>;
  toNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export enum MessageStateType {
  Ringless = 'RINGLESS',
  Sms = 'SMS',
  Voice = 'VOICE'
}

export type MessageStatisticsResponse = {
  __typename?: 'MessageStatisticsResponse';
  chargeStatistics?: Maybe<ChargeStatistics>;
  conversionStatistics?: Maybe<TodayConversionStatistics>;
  percentageStatistics?: Maybe<PercentageStatistics>;
  shortUrlClickStatistics?: Maybe<ShortUrlClickStatistics>;
  todayStatistics?: Maybe<StatusStatistics>;
  totalStatistics?: Maybe<StatusStatistics>;
  voiceTransferMessageStatistics?: Maybe<TotalMessageStatistics>;
};

export type MessageTemplateResponse = {
  __typename?: 'MessageTemplateResponse';
  createdAt?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['Long']>;
  memberId?: Maybe<Scalars['Long']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Long']>;
  smsMessage?: Maybe<SmsMessage>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export enum MessageType {
  Call = 'CALL',
  InboundForwardCall = 'INBOUND_FORWARD_CALL',
  InboundSms = 'INBOUND_SMS',
  Lookup = 'LOOKUP',
  Mms = 'MMS',
  Ringless = 'RINGLESS',
  Sms = 'SMS'
}

export type MessageVoice = {
  __typename?: 'MessageVoice';
  advancedChargeAmount?: Maybe<Scalars['Float']>;
  advancedChargeAttempted?: Maybe<Scalars['Boolean']>;
  audioItem?: Maybe<AudioItem>;
  callFireCallId?: Maybe<Scalars['Long']>;
  callFireCallResult?: Maybe<Scalars['String']>;
  callFireId?: Maybe<Scalars['Long']>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  duration?: Maybe<Scalars['Int']>;
  expectedDuration?: Maybe<Scalars['Int']>;
  forwardToNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Long']>;
  liveAnswer?: Maybe<LiveAnswer>;
  state?: Maybe<MessageState>;
  telnyxCallId?: Maybe<Scalars['String']>;
  twilioCallSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  voiceMail?: Maybe<VoiceMail>;
};

export type MigrateCustomerTaxAddressInput = {
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MigratePaymentMethodInfoInput = {
  customerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum MigrationEntityType {
  Audio = 'AUDIO',
  Contact = 'CONTACT',
  Keyword = 'KEYWORD',
  Trigger = 'TRIGGER',
  WebForm = 'WEB_FORM'
}

export type MigrationRequestInput = {
  cl1Email?: InputMaybe<Scalars['String']>;
  memberId?: InputMaybe<Scalars['Long']>;
  migrationEntityType?: InputMaybe<MigrationEntityType>;
};

/** Mutation root */
export type Mutation = {
  __typename?: 'Mutation';
  actionCampaignArchive: Scalars['Boolean'];
  actionCampaignRestore: Scalars['Boolean'];
  actionCampaignSwitchEnabled: Scalars['Boolean'];
  actualizeStripeCustomerData: Scalars['Boolean'];
  addCard?: Maybe<OrgBillingInfo>;
  addCredits?: Maybe<Balances>;
  addExternalPhoneNumber?: Maybe<Scalars['String']>;
  addToLists?: Maybe<Scalars['String']>;
  adminBanMemberProfile?: Maybe<MemberProfile>;
  adminBusinessProfilePreviousStep?: Maybe<BusinessProfileResponse>;
  adminChangeImportState?: Maybe<ContactImportState>;
  adminChargeCarrierFees?: Maybe<BillingCarrierFees>;
  adminCreateCallerIdPhoneNumber?: Maybe<PhoneNumber>;
  adminCreateCreditsProduct: Scalars['Boolean'];
  adminCreateCustomPlan?: Maybe<SimplePrice>;
  adminGetApplicationProperties?: Maybe<Array<Maybe<ApplicationProperty>>>;
  adminInitBusinessAuthorizedUsers?: Maybe<BusinessProfileResponse>;
  adminInitBusinessGeneralInfo?: Maybe<BusinessProfileResponse>;
  adminInitBusinessGeneralInfoByEin?: Maybe<BusinessProfileResponse>;
  adminInitBusinessGeneralInfoByManualEin?: Maybe<BusinessProfileResponse>;
  adminInitBusinessInfo?: Maybe<BusinessProfileResponse>;
  adminInitBusinessTerms?: Maybe<BusinessProfileResponse>;
  adminInitCompanyType?: Maybe<BusinessProfileResponse>;
  adminInitTFProfileBusinessInfo?: Maybe<TollFreeVerificationProfile>;
  adminInitTFProfileContactInfo?: Maybe<TollFreeVerificationProfile>;
  adminInitTollFreeVerificationOptInMethod?: Maybe<TollFreeVerificationProfile>;
  adminInitTollFreeVerificationProfile?: Maybe<TollFreeVerificationProfile>;
  adminInitTollFreeVerificationTerms?: Maybe<TollFreeVerificationProfile>;
  adminInitTollFreeVerificationUseCase?: Maybe<TollFreeVerificationProfile>;
  adminMigrateBroadcastSendToConfig: Scalars['Boolean'];
  adminMigrateMessages?: Maybe<Scalars['String']>;
  adminMigratePaymentMethodInfo?: Maybe<Scalars['String']>;
  adminMigrateSubscriptionTax?: Maybe<Scalars['String']>;
  adminMigrateTaxAddress?: Maybe<Scalars['String']>;
  adminOrderTelnyxNumbers?: Maybe<Scalars['String']>;
  adminRefreshOrganizationSpentData?: Maybe<Scalars['String']>;
  adminRefreshOrganizationSubscription?: Maybe<Scalars['String']>;
  adminRefreshPrices: Scalars['Boolean'];
  adminRefreshVoiceBroadcasts?: Maybe<Scalars['String']>;
  adminRegisterBusinessProfile?: Maybe<BusinessProfileResponse>;
  adminSaveCreditsForPurchase: Scalars['Boolean'];
  adminSyncHubSpot: Scalars['Boolean'];
  adminSyncWebFormSummaries: Scalars['Boolean'];
  adminTollFreeVerificationProfilePreviousStep?: Maybe<TollFreeVerificationProfile>;
  adminUnbanMemberProfile?: Maybe<MemberProfile>;
  adminUpdateApplicationProperty?: Maybe<ApplicationProperty>;
  adminUpdateAudioItemsContentType?: Maybe<Scalars['String']>;
  adminUpdateAudioItemsSize?: Maybe<Scalars['String']>;
  adminUpdateCustomPlan?: Maybe<SimplePrice>;
  adminUpdateOrganizationContract: Scalars['Boolean'];
  adminUpdateVoiceMessageProvider?: Maybe<Scalars['String']>;
  applyCoupon?: Maybe<OrgBillingInfo>;
  banOrganization?: Maybe<Array<Maybe<OrganizationResponse>>>;
  businessProfilePreviousStep?: Maybe<BusinessProfileResponse>;
  buyCredits?: Maybe<Balances>;
  cancelDowngrade?: Maybe<ClSubscription>;
  cancelSubscription?: Maybe<ClSubscription>;
  carrierFeePay?: Maybe<Organization>;
  changeBroadcastsState?: Maybe<Array<Maybe<BroadcastResponse>>>;
  changeEmail?: Maybe<ChangeEmailResponse>;
  changeOwner?: Maybe<Scalars['String']>;
  changePassword?: Maybe<Scalars['String']>;
  companyDetailsRegistrationStep?: Maybe<MemberResponse>;
  completeTenDlc?: Maybe<TenDlcRegisterProfileResponse>;
  confirmChangeEmail?: Maybe<UserInfoResponse>;
  confirmExternalPhoneNumber?: Maybe<PhoneNumber>;
  confirmRestorePassword?: Maybe<UserInfoResponse>;
  contactBulkArchive?: Maybe<Scalars['String']>;
  contactBulkReSubscribe?: Maybe<Scalars['String']>;
  contactBulkSoftUnsubscribe?: Maybe<Scalars['String']>;
  contactBulkUnArchive?: Maybe<Scalars['String']>;
  contactDetailsRegistrationStep?: Maybe<MemberResponse>;
  createBroadcast?: Maybe<BroadcastFullResponse>;
  createCampaign?: Maybe<CampaignResponse>;
  createContact?: Maybe<ContactResponse>;
  createContactCard?: Maybe<ContactCard>;
  createConversion?: Maybe<ConversionResponse>;
  createInvitation?: Maybe<InvitationBidResponse>;
  createKeyword?: Maybe<Keyword>;
  createList?: Maybe<Listing>;
  createMessageTemplate?: Maybe<MessageTemplateResponse>;
  createOrganization?: Maybe<MemberAndClSubscription>;
  createPredefinedCustomer?: Maybe<PredefinedCustomer>;
  createSegment?: Maybe<SegmentResponse>;
  createStripeCreditPrices?: Maybe<Scalars['Boolean']>;
  createTrigger?: Maybe<Trigger>;
  createWebForm?: Maybe<WebForm>;
  deleteAudioItems: Scalars['Int'];
  deleteBroadcasts?: Maybe<Scalars['String']>;
  deleteCampaigns?: Maybe<Scalars['String']>;
  deleteConversions: Scalars['Boolean'];
  deleteMessageTemplates: Scalars['Boolean'];
  deletePaymentMethod?: Maybe<OrgBillingInfo>;
  /** Delete Phone Number */
  deletePhoneNumber: Scalars['Boolean'];
  deletePredefinedCustomer?: Maybe<Scalars['String']>;
  deleteSegments: Scalars['Boolean'];
  deleteWebForms?: Maybe<Scalars['String']>;
  disableCallbackConfirmation?: Maybe<Organization>;
  disableKeyword?: Maybe<Keyword>;
  disconnectIntegration?: Maybe<AccountIntegrationsResponse>;
  enableInboundCallbacks?: Maybe<PhoneNumber>;
  enableKeyword?: Maybe<Keyword>;
  endTrialPeriod?: Maybe<UpdatedSubscription>;
  initBusinessAuthorizedUsers?: Maybe<BusinessProfileResponse>;
  initBusinessGeneralInfo?: Maybe<BusinessProfileResponse>;
  initBusinessGeneralInfoByEin?: Maybe<BusinessProfileResponse>;
  initBusinessGeneralInfoByManualEin?: Maybe<BusinessProfileResponse>;
  initBusinessInfo?: Maybe<BusinessProfileResponse>;
  initBusinessTerms?: Maybe<BusinessProfileResponse>;
  initCompanyType?: Maybe<BusinessProfileResponse>;
  initMessageSampleTenDlc?: Maybe<TenDlcRegisterProfileResponse>;
  initOptInDescriptionTenDlc?: Maybe<TenDlcRegisterProfileResponse>;
  initOptInImageTenDlc?: Maybe<TenDlcRegisterProfileResponse>;
  initOptInMethodTenDlc?: Maybe<TenDlcRegisterProfileResponse>;
  initPackageTenDlc?: Maybe<TenDlcRegisterProfileResponse>;
  initTFProfileBusinessInfo?: Maybe<TollFreeVerificationProfile>;
  initTFProfileContactInfo?: Maybe<TollFreeVerificationProfile>;
  initTollFreeVerificationOptInMethod?: Maybe<TollFreeVerificationProfile>;
  initTollFreeVerificationProfile?: Maybe<TollFreeVerificationProfile>;
  initTollFreeVerificationTerms?: Maybe<TollFreeVerificationProfile>;
  initTollFreeVerificationUseCase?: Maybe<TollFreeVerificationProfile>;
  initUseCaseTenDlc?: Maybe<TenDlcRegisterProfileResponse>;
  memberRegistrationPreviousStep?: Maybe<MemberResponse>;
  migrateCredits: Scalars['Boolean'];
  migrateEntities: Scalars['Boolean'];
  migratePrepareMembers: Scalars['Boolean'];
  migrateUserStatuses: Scalars['Boolean'];
  migrateUsers: Scalars['Boolean'];
  migrateUsersData: Scalars['Boolean'];
  migrationRegistrationStep?: Maybe<MemberResponse>;
  paymentRegistrationStep?: Maybe<MemberResponse>;
  planSelectionRegistrationStep?: Maybe<MemberResponse>;
  previousStepTenDlc?: Maybe<TenDlcRegisterProfileResponse>;
  reSubscribe?: Maybe<Contact>;
  refreshOrganizationRecordingPin?: Maybe<Organization>;
  registerBusinessProfile?: Maybe<BusinessProfileResponse>;
  /** Reserve Phone Number */
  releasePhoneNumber?: Maybe<Scalars['String']>;
  removeAssets?: Maybe<Scalars['String']>;
  removeContactCards?: Maybe<Scalars['String']>;
  removeContactImportStates?: Maybe<Scalars['String']>;
  removeContacts?: Maybe<Scalars['String']>;
  removeFromLists?: Maybe<Scalars['String']>;
  removeInvitation?: Maybe<Scalars['String']>;
  removeKeywords?: Maybe<Scalars['String']>;
  removeLists?: Maybe<Scalars['String']>;
  removeMember?: Maybe<Scalars['String']>;
  removeTriggers?: Maybe<Scalars['String']>;
  requestDoubleOptInConfirmation: Scalars['Boolean'];
  resendInvitation?: Maybe<Scalars['String']>;
  /** Reserve Phone Number */
  reservePhoneNumber?: Maybe<PhoneNumber>;
  resetMemberProfilePassword?: Maybe<Scalars['String']>;
  resetSubscriptionDefaultPaymentMethod: Scalars['Boolean'];
  restorePassword?: Maybe<ChangePasswordResponse>;
  selectOrganization?: Maybe<MemberResponse>;
  sendTestCallMessage?: Maybe<MessageVoice>;
  sendTestMessage?: Maybe<TestMessage>;
  sendTestRinglessMessage?: Maybe<MessageRingless>;
  setBackupPaymentMethod?: Maybe<OrgBillingInfo>;
  setPrimaryPaymentMethod?: Maybe<OrgBillingInfo>;
  setupAutoRecharge?: Maybe<OrgBillingInfo>;
  setupIntegration?: Maybe<AccountIntegrationsResponse>;
  softUnsubscribe?: Maybe<Contact>;
  startTrial?: Maybe<MemberAndClSubscription>;
  startTrialRegistrationStep?: Maybe<MemberResponse>;
  stopCancelSubscription?: Maybe<ClSubscription>;
  switchPhoneChecker?: Maybe<Organization>;
  switchPlan?: Maybe<UpdatedSubscription>;
  syncTwilioTollFreeData: Scalars['Boolean'];
  tollFreeVerificationProfilePreviousStep?: Maybe<TollFreeVerificationProfile>;
  unSuspendOrganization?: Maybe<UpdateOrganizationStatusResponse>;
  unbanOrganization?: Maybe<Array<Maybe<OrganizationResponse>>>;
  updateAudioItem?: Maybe<AudioItem>;
  updateBroadcast?: Maybe<BroadcastFullResponse>;
  updateCampaign?: Maybe<CampaignResponse>;
  updateContact?: Maybe<ContactResponse>;
  updateContactCard?: Maybe<ContactCard>;
  updateContactCountryCodes?: Maybe<Scalars['String']>;
  updateContactImportState?: Maybe<ContactImportState>;
  updateConversion?: Maybe<ConversionResponse>;
  updateCustomFields?: Maybe<Array<Maybe<CustomField>>>;
  updateFromPredefinedCustomer?: Maybe<OrgBillingInfo>;
  updateKeyword?: Maybe<Keyword>;
  updateLeadMember?: Maybe<MemberResponse>;
  updateList?: Maybe<Listing>;
  updateMember?: Maybe<MemberResponse>;
  updateMemberRestrictions?: Maybe<MemberResponse>;
  updateMessageTemplate?: Maybe<MessageTemplateResponse>;
  /** Update messaging service for number */
  updateMessagingServiceForPhoneNumber?: Maybe<Scalars['Long']>;
  updateOrganization?: Maybe<Organization>;
  updateOrganizationInfo?: Maybe<Organization>;
  /** Update existing Phone Numbers */
  updatePhoneNumbers?: Maybe<Array<Maybe<PhoneNumber>>>;
  updateSegment?: Maybe<SegmentResponse>;
  updateSharedNumberAccess?: Maybe<OrganizationDetails>;
  updateTFVerificationSink?: Maybe<Scalars['String']>;
  updateTrigger?: Maybe<Trigger>;
  updateWebForm?: Maybe<WebForm>;
  verifyAllContacts?: Maybe<PhoneLookup>;
  verifyContactLists?: Maybe<Array<Maybe<Listing>>>;
  verifyContacts?: Maybe<Scalars['String']>;
  verifyRestorePasswordCode?: Maybe<Scalars['String']>;
};


/** Mutation root */
export type MutationActionCampaignArchiveArgs = {
  campaignIds: Array<InputMaybe<Scalars['Long']>>;
};


/** Mutation root */
export type MutationActionCampaignRestoreArgs = {
  campaignIds: Array<InputMaybe<Scalars['Long']>>;
};


/** Mutation root */
export type MutationActionCampaignSwitchEnabledArgs = {
  campaignIds: Array<InputMaybe<Scalars['Long']>>;
  enabled: Scalars['Boolean'];
};


/** Mutation root */
export type MutationActualizeStripeCustomerDataArgs = {
  organizationId?: InputMaybe<Scalars['Long']>;
};


/** Mutation root */
export type MutationAddCardArgs = {
  tokenId?: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationAddCreditsArgs = {
  input: AddCreditInput;
};


/** Mutation root */
export type MutationAddExternalPhoneNumberArgs = {
  extension?: InputMaybe<Scalars['String']>;
  inputPhoneNumber: Scalars['String'];
};


/** Mutation root */
export type MutationAddToListsArgs = {
  bulk?: InputMaybe<ContactBulkOperationRequestInput>;
  listIds: Array<InputMaybe<Scalars['Long']>>;
};


/** Mutation root */
export type MutationAdminBanMemberProfileArgs = {
  id: Scalars['Long'];
};


/** Mutation root */
export type MutationAdminBusinessProfilePreviousStepArgs = {
  organizationId: Scalars['Long'];
};


/** Mutation root */
export type MutationAdminChangeImportStateArgs = {
  allowStatus: AllowImportStatus;
  importId?: InputMaybe<Scalars['Long']>;
};


/** Mutation root */
export type MutationAdminChargeCarrierFeesArgs = {
  chargeEnabled: Scalars['Boolean'];
  organizationId?: InputMaybe<Scalars['Long']>;
};


/** Mutation root */
export type MutationAdminCreateCallerIdPhoneNumberArgs = {
  organizationId?: InputMaybe<Scalars['Long']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationAdminCreateCustomPlanArgs = {
  input: CustomPlanCreateRqInput;
};


/** Mutation root */
export type MutationAdminInitBusinessAuthorizedUsersArgs = {
  input: Array<InputMaybe<BusinessAuthorizedUserRequestInput>>;
  organizationId: Scalars['Long'];
};


/** Mutation root */
export type MutationAdminInitBusinessGeneralInfoArgs = {
  input: BusinessGeneralInfoRequestInput;
  organizationId: Scalars['Long'];
};


/** Mutation root */
export type MutationAdminInitBusinessGeneralInfoByEinArgs = {
  ein: Scalars['String'];
  organizationId: Scalars['Long'];
};


/** Mutation root */
export type MutationAdminInitBusinessGeneralInfoByManualEinArgs = {
  input: BusinessGeneralInfoEinRequestInput;
  organizationId: Scalars['Long'];
};


/** Mutation root */
export type MutationAdminInitBusinessInfoArgs = {
  input: BusinessInfoRequestInput;
  organizationId: Scalars['Long'];
};


/** Mutation root */
export type MutationAdminInitBusinessTermsArgs = {
  organizationId: Scalars['Long'];
};


/** Mutation root */
export type MutationAdminInitCompanyTypeArgs = {
  hasEin: Scalars['Boolean'];
  organizationId: Scalars['Long'];
};


/** Mutation root */
export type MutationAdminInitTfProfileBusinessInfoArgs = {
  input: TfBusinessInfoRequestInput;
  organizationId: Scalars['Long'];
};


/** Mutation root */
export type MutationAdminInitTfProfileContactInfoArgs = {
  input: ContactInfoRequestInput;
  organizationId: Scalars['Long'];
};


/** Mutation root */
export type MutationAdminInitTollFreeVerificationOptInMethodArgs = {
  input: TollFreeVerificationOptInMethodRequestInput;
  organizationId: Scalars['Long'];
};


/** Mutation root */
export type MutationAdminInitTollFreeVerificationProfileArgs = {
  input: TollFreeVerificationRequestInput;
  organizationId: Scalars['Long'];
};


/** Mutation root */
export type MutationAdminInitTollFreeVerificationTermsArgs = {
  organizationId: Scalars['Long'];
  shouldSend: Scalars['Boolean'];
};


/** Mutation root */
export type MutationAdminInitTollFreeVerificationUseCaseArgs = {
  input: TollFreeVerificationUseCaseRequestInput;
  organizationId: Scalars['Long'];
};


/** Mutation root */
export type MutationAdminMigrateMessagesArgs = {
  startId?: InputMaybe<Scalars['Long']>;
  types?: InputMaybe<Array<InputMaybe<MessageStateType>>>;
};


/** Mutation root */
export type MutationAdminMigratePaymentMethodInfoArgs = {
  input?: InputMaybe<MigratePaymentMethodInfoInput>;
};


/** Mutation root */
export type MutationAdminMigrateSubscriptionTaxArgs = {
  input?: InputMaybe<MigrateCustomerTaxAddressInput>;
};


/** Mutation root */
export type MutationAdminMigrateTaxAddressArgs = {
  input?: InputMaybe<MigrateCustomerTaxAddressInput>;
};


/** Mutation root */
export type MutationAdminOrderTelnyxNumbersArgs = {
  numberIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
};


/** Mutation root */
export type MutationAdminRefreshOrganizationSpentDataArgs = {
  forceRefresh: Scalars['Boolean'];
  search?: InputMaybe<OrganizationSearchInput>;
};


/** Mutation root */
export type MutationAdminRefreshOrganizationSubscriptionArgs = {
  forceRefresh: Scalars['Boolean'];
  search?: InputMaybe<OrganizationSearchInput>;
};


/** Mutation root */
export type MutationAdminRefreshVoiceBroadcastsArgs = {
  input?: InputMaybe<RefreshCallFireBroadcastsRqInput>;
};


/** Mutation root */
export type MutationAdminRegisterBusinessProfileArgs = {
  input: BusinessProfileRequestInput;
  organizationId: Scalars['Long'];
};


/** Mutation root */
export type MutationAdminSaveCreditsForPurchaseArgs = {
  userKeys: Array<InputMaybe<Scalars['String']>>;
};


/** Mutation root */
export type MutationAdminSyncHubSpotArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
};


/** Mutation root */
export type MutationAdminSyncWebFormSummariesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
};


/** Mutation root */
export type MutationAdminTollFreeVerificationProfilePreviousStepArgs = {
  organizationId: Scalars['Long'];
};


/** Mutation root */
export type MutationAdminUnbanMemberProfileArgs = {
  id: Scalars['Long'];
};


/** Mutation root */
export type MutationAdminUpdateApplicationPropertyArgs = {
  type?: InputMaybe<ApplicationPropertyType>;
  value?: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationAdminUpdateAudioItemsContentTypeArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  newType?: InputMaybe<Scalars['String']>;
  sourceType?: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationAdminUpdateAudioItemsSizeArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
};


/** Mutation root */
export type MutationAdminUpdateCustomPlanArgs = {
  input: CustomPlanUpdateRqInput;
};


/** Mutation root */
export type MutationAdminUpdateOrganizationContractArgs = {
  contract: Scalars['Boolean'];
  organizationId: Scalars['Long'];
};


/** Mutation root */
export type MutationAdminUpdateVoiceMessageProviderArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  providerType?: InputMaybe<VoiceMessageProviderType>;
};


/** Mutation root */
export type MutationApplyCouponArgs = {
  couponId?: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationBanOrganizationArgs = {
  input: UpdateOrganizationStatusRequestInput;
};


/** Mutation root */
export type MutationBuyCreditsArgs = {
  creditsAmount?: InputMaybe<Scalars['Int']>;
  paymentMethodId?: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationCancelSubscriptionArgs = {
  userInput?: InputMaybe<SubscriptionChangeInputInput>;
};


/** Mutation root */
export type MutationCarrierFeePayArgs = {
  paymentMethodId?: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationChangeBroadcastsStateArgs = {
  action?: InputMaybe<ChangeBroadcastStateAction>;
  broadcastIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
};


/** Mutation root */
export type MutationChangeEmailArgs = {
  input: ChangeEmailRequestInput;
};


/** Mutation root */
export type MutationChangeOwnerArgs = {
  memberId: Scalars['Long'];
};


/** Mutation root */
export type MutationChangePasswordArgs = {
  input: ChangePasswordRequestInput;
};


/** Mutation root */
export type MutationCompanyDetailsRegistrationStepArgs = {
  input: OrganizationUpdateInput;
};


/** Mutation root */
export type MutationCompleteTenDlcArgs = {
  paymentMethodId: Scalars['String'];
};


/** Mutation root */
export type MutationConfirmChangeEmailArgs = {
  input: ConfirmVerificationCodeRequestInput;
};


/** Mutation root */
export type MutationConfirmExternalPhoneNumberArgs = {
  code: Scalars['String'];
  uuid: Scalars['String'];
};


/** Mutation root */
export type MutationConfirmRestorePasswordArgs = {
  input: ConfirmChangePasswordRequestInput;
};


/** Mutation root */
export type MutationContactBulkArchiveArgs = {
  bulk?: InputMaybe<ContactBulkOperationRequestInput>;
};


/** Mutation root */
export type MutationContactBulkReSubscribeArgs = {
  bulk?: InputMaybe<ContactBulkOperationRequestInput>;
};


/** Mutation root */
export type MutationContactBulkSoftUnsubscribeArgs = {
  bulk?: InputMaybe<ContactBulkOperationRequestInput>;
};


/** Mutation root */
export type MutationContactBulkUnArchiveArgs = {
  bulk?: InputMaybe<ContactBulkOperationRequestInput>;
};


/** Mutation root */
export type MutationContactDetailsRegistrationStepArgs = {
  input: RegistrationContactDetailsInput;
};


/** Mutation root */
export type MutationCreateBroadcastArgs = {
  broadcastInput: BroadcastInput;
};


/** Mutation root */
export type MutationCreateCampaignArgs = {
  campaignInput: CampaignCreateRequestInput;
};


/** Mutation root */
export type MutationCreateContactArgs = {
  contactInput: ContactRequestInput;
};


/** Mutation root */
export type MutationCreateContactCardArgs = {
  cardInput: ContactCardRequestInput;
};


/** Mutation root */
export type MutationCreateConversionArgs = {
  conversion?: InputMaybe<UpdateConversionRequestInput>;
};


/** Mutation root */
export type MutationCreateInvitationArgs = {
  input: CreateInvitationBidRequestInput;
};


/** Mutation root */
export type MutationCreateKeywordArgs = {
  keywordInput: KeywordInput;
};


/** Mutation root */
export type MutationCreateListArgs = {
  listInput?: InputMaybe<ListRequestInput>;
};


/** Mutation root */
export type MutationCreateMessageTemplateArgs = {
  template?: InputMaybe<UpdateMessageTemplateRequestInput>;
};


/** Mutation root */
export type MutationCreateOrganizationArgs = {
  input: OrganizationUpdateInput;
  tokenId?: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationCreatePredefinedCustomerArgs = {
  input: PredefinedCustomerInput;
};


/** Mutation root */
export type MutationCreateSegmentArgs = {
  segment?: InputMaybe<UpdateSegmentRequestInput>;
};


/** Mutation root */
export type MutationCreateTriggerArgs = {
  triggerInput: TriggerInput;
};


/** Mutation root */
export type MutationCreateWebFormArgs = {
  input: WebFormInput;
};


/** Mutation root */
export type MutationDeleteAudioItemsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
};


/** Mutation root */
export type MutationDeleteBroadcastsArgs = {
  broadcastIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
};


/** Mutation root */
export type MutationDeleteCampaignsArgs = {
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
};


/** Mutation root */
export type MutationDeleteConversionsArgs = {
  conversionIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
};


/** Mutation root */
export type MutationDeleteMessageTemplatesArgs = {
  templateIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
};


/** Mutation root */
export type MutationDeletePaymentMethodArgs = {
  pmId?: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationDeletePhoneNumberArgs = {
  id?: InputMaybe<Scalars['Long']>;
};


/** Mutation root */
export type MutationDeletePredefinedCustomerArgs = {
  id: Scalars['Long'];
};


/** Mutation root */
export type MutationDeleteSegmentsArgs = {
  segmentIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
};


/** Mutation root */
export type MutationDeleteWebFormsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
};


/** Mutation root */
export type MutationDisableKeywordArgs = {
  id: Scalars['Long'];
};


/** Mutation root */
export type MutationDisconnectIntegrationArgs = {
  accountIntegrationType: AccountIntegrationType;
};


/** Mutation root */
export type MutationEnableInboundCallbacksArgs = {
  phoneNumberId: Scalars['Long'];
};


/** Mutation root */
export type MutationEnableKeywordArgs = {
  id: Scalars['Long'];
};


/** Mutation root */
export type MutationInitBusinessAuthorizedUsersArgs = {
  input: Array<InputMaybe<BusinessAuthorizedUserRequestInput>>;
};


/** Mutation root */
export type MutationInitBusinessGeneralInfoArgs = {
  input: BusinessGeneralInfoRequestInput;
};


/** Mutation root */
export type MutationInitBusinessGeneralInfoByEinArgs = {
  ein: Scalars['String'];
};


/** Mutation root */
export type MutationInitBusinessGeneralInfoByManualEinArgs = {
  input: BusinessGeneralInfoEinRequestInput;
};


/** Mutation root */
export type MutationInitBusinessInfoArgs = {
  input: BusinessInfoRequestInput;
};


/** Mutation root */
export type MutationInitCompanyTypeArgs = {
  hasEin: Scalars['Boolean'];
};


/** Mutation root */
export type MutationInitMessageSampleTenDlcArgs = {
  input: TenDlcMessageSampleRequestInput;
};


/** Mutation root */
export type MutationInitOptInDescriptionTenDlcArgs = {
  input: TenDlcOptInDescriptionRequestInput;
};


/** Mutation root */
export type MutationInitOptInImageTenDlcArgs = {
  input: TenDlcOptInImagesRequestInput;
};


/** Mutation root */
export type MutationInitOptInMethodTenDlcArgs = {
  input: TenDlcOptInMethodRequestInput;
};


/** Mutation root */
export type MutationInitPackageTenDlcArgs = {
  input: TenDlcSelectPackageRequestInput;
};


/** Mutation root */
export type MutationInitTfProfileBusinessInfoArgs = {
  input: TfBusinessInfoRequestInput;
};


/** Mutation root */
export type MutationInitTfProfileContactInfoArgs = {
  input: ContactInfoRequestInput;
};


/** Mutation root */
export type MutationInitTollFreeVerificationOptInMethodArgs = {
  input: TollFreeVerificationOptInMethodRequestInput;
};


/** Mutation root */
export type MutationInitTollFreeVerificationProfileArgs = {
  input: TollFreeVerificationRequestInput;
};


/** Mutation root */
export type MutationInitTollFreeVerificationUseCaseArgs = {
  input: TollFreeVerificationUseCaseRequestInput;
};


/** Mutation root */
export type MutationInitUseCaseTenDlcArgs = {
  input: TenDlcUseCaseRequestInput;
};


/** Mutation root */
export type MutationMigrateCreditsArgs = {
  cl1Email: Scalars['String'];
  cl2MemberId: Scalars['Long'];
};


/** Mutation root */
export type MutationMigrateEntitiesArgs = {
  input: MigrationRequestInput;
};


/** Mutation root */
export type MutationMigrateUserStatusesArgs = {
  userKeys: Array<InputMaybe<Scalars['String']>>;
};


/** Mutation root */
export type MutationMigrateUsersDataArgs = {
  ignoreExisting: Scalars['Boolean'];
  userIds: Array<InputMaybe<Scalars['String']>>;
};


/** Mutation root */
export type MutationPaymentRegistrationStepArgs = {
  paymentMethodId?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationPlanSelectionRegistrationStepArgs = {
  price?: InputMaybe<Scalars['String']>;
  saveCredits: Scalars['Boolean'];
};


/** Mutation root */
export type MutationReSubscribeArgs = {
  contactId: Scalars['Long'];
};


/** Mutation root */
export type MutationRegisterBusinessProfileArgs = {
  input: BusinessProfileRequestInput;
};


/** Mutation root */
export type MutationReleasePhoneNumberArgs = {
  id?: InputMaybe<Scalars['Long']>;
};


/** Mutation root */
export type MutationRemoveAssetsArgs = {
  assetIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
};


/** Mutation root */
export type MutationRemoveContactCardsArgs = {
  cardIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
};


/** Mutation root */
export type MutationRemoveContactImportStatesArgs = {
  importStateIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
};


/** Mutation root */
export type MutationRemoveContactsArgs = {
  bulk?: InputMaybe<ContactBulkOperationRequestInput>;
};


/** Mutation root */
export type MutationRemoveFromListsArgs = {
  bulk?: InputMaybe<ContactBulkOperationRequestInput>;
  listIds: Array<InputMaybe<Scalars['Long']>>;
};


/** Mutation root */
export type MutationRemoveInvitationArgs = {
  invitationId: Scalars['Long'];
};


/** Mutation root */
export type MutationRemoveKeywordsArgs = {
  keywordIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
};


/** Mutation root */
export type MutationRemoveListsArgs = {
  listIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
};


/** Mutation root */
export type MutationRemoveMemberArgs = {
  memberId: Scalars['Long'];
};


/** Mutation root */
export type MutationRemoveTriggersArgs = {
  triggersIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
};


/** Mutation root */
export type MutationRequestDoubleOptInConfirmationArgs = {
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
};


/** Mutation root */
export type MutationResendInvitationArgs = {
  invitationId: Scalars['Long'];
};


/** Mutation root */
export type MutationReservePhoneNumberArgs = {
  input?: InputMaybe<ReservePhoneNumberRequestInput>;
};


/** Mutation root */
export type MutationResetMemberProfilePasswordArgs = {
  memberProfileId: Scalars['Long'];
  password: Scalars['String'];
};


/** Mutation root */
export type MutationResetSubscriptionDefaultPaymentMethodArgs = {
  organizationId?: InputMaybe<Scalars['Long']>;
};


/** Mutation root */
export type MutationSelectOrganizationArgs = {
  organizationId: Scalars['Long'];
};


/** Mutation root */
export type MutationSendTestCallMessageArgs = {
  testMessageInput?: InputMaybe<TestCallMessageRequestInput>;
};


/** Mutation root */
export type MutationSendTestMessageArgs = {
  testMessageInput?: InputMaybe<TestMessageRequestInput>;
};


/** Mutation root */
export type MutationSendTestRinglessMessageArgs = {
  testMessageInput?: InputMaybe<TestRinglessMessageRequestInput>;
};


/** Mutation root */
export type MutationSetBackupPaymentMethodArgs = {
  pmId?: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationSetPrimaryPaymentMethodArgs = {
  pmId?: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationSetupAutoRechargeArgs = {
  options?: InputMaybe<AutoRechargeOptionsInput>;
};


/** Mutation root */
export type MutationSetupIntegrationArgs = {
  input: AccountIntegrationsInput;
};


/** Mutation root */
export type MutationSoftUnsubscribeArgs = {
  contactId: Scalars['Long'];
};


/** Mutation root */
export type MutationStartTrialArgs = {
  customer: MemberUpdateInput;
  tokenId?: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationStartTrialRegistrationStepArgs = {
  paymentMethodId?: InputMaybe<Scalars['String']>;
};


/** Mutation root */
export type MutationSwitchPhoneCheckerArgs = {
  input: SwitchPhoneCheckerRequestInput;
};


/** Mutation root */
export type MutationSwitchPlanArgs = {
  paymentMethodId?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['String']>;
  userInput?: InputMaybe<SubscriptionChangeInputInput>;
};


/** Mutation root */
export type MutationSyncTwilioTollFreeDataArgs = {
  organizationId?: InputMaybe<Scalars['Long']>;
};


/** Mutation root */
export type MutationUnSuspendOrganizationArgs = {
  input: UpdateOrganizationStatusRequestInput;
};


/** Mutation root */
export type MutationUnbanOrganizationArgs = {
  input: UpdateOrganizationStatusRequestInput;
};


/** Mutation root */
export type MutationUpdateAudioItemArgs = {
  input?: InputMaybe<UpdateAudioItemRequestInput>;
};


/** Mutation root */
export type MutationUpdateBroadcastArgs = {
  broadcastInput: BroadcastInput;
};


/** Mutation root */
export type MutationUpdateCampaignArgs = {
  campaignInput: CampaignUpdateRequestInput;
};


/** Mutation root */
export type MutationUpdateContactArgs = {
  contactInput: ContactRequestInput;
};


/** Mutation root */
export type MutationUpdateContactCardArgs = {
  cardInput: ContactCardRequestInput;
  contactCardId: Scalars['Long'];
};


/** Mutation root */
export type MutationUpdateContactImportStateArgs = {
  importStateInput: ContactImportRequestInput;
};


/** Mutation root */
export type MutationUpdateConversionArgs = {
  conversion?: InputMaybe<UpdateConversionRequestInput>;
};


/** Mutation root */
export type MutationUpdateCustomFieldsArgs = {
  fields: CustomFieldsRequestInput;
};


/** Mutation root */
export type MutationUpdateFromPredefinedCustomerArgs = {
  organizationId: Scalars['Long'];
};


/** Mutation root */
export type MutationUpdateKeywordArgs = {
  keywordInput: KeywordInput;
};


/** Mutation root */
export type MutationUpdateLeadMemberArgs = {
  input: MemberUpdateInput;
};


/** Mutation root */
export type MutationUpdateListArgs = {
  listInput?: InputMaybe<ListRequestInput>;
};


/** Mutation root */
export type MutationUpdateMemberArgs = {
  input: MemberUpdateInput;
};


/** Mutation root */
export type MutationUpdateMemberRestrictionsArgs = {
  input: UpdateMemberRestrictionsRequestInput;
  memberId: Scalars['Long'];
};


/** Mutation root */
export type MutationUpdateMessageTemplateArgs = {
  template?: InputMaybe<UpdateMessageTemplateRequestInput>;
};


/** Mutation root */
export type MutationUpdateMessagingServiceForPhoneNumberArgs = {
  id?: InputMaybe<Scalars['Long']>;
  messageServiceId?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Long']>;
};


/** Mutation root */
export type MutationUpdateOrganizationArgs = {
  input: OrganizationUpdateInput;
};


/** Mutation root */
export type MutationUpdateOrganizationInfoArgs = {
  input: OrganizationInfoUpdateInput;
};


/** Mutation root */
export type MutationUpdatePhoneNumbersArgs = {
  inputUpdatePhoneNumbers?: InputMaybe<UpdatePhoneNumbersRequestInput>;
};


/** Mutation root */
export type MutationUpdateSegmentArgs = {
  segment?: InputMaybe<UpdateSegmentRequestInput>;
};


/** Mutation root */
export type MutationUpdateSharedNumberAccessArgs = {
  allowed: Scalars['Boolean'];
  id: Scalars['Long'];
};


/** Mutation root */
export type MutationUpdateTfVerificationSinkArgs = {
  search?: InputMaybe<OrganizationSearchInput>;
};


/** Mutation root */
export type MutationUpdateTriggerArgs = {
  triggerInput: TriggerInput;
};


/** Mutation root */
export type MutationUpdateWebFormArgs = {
  input: WebFormInput;
};


/** Mutation root */
export type MutationVerifyAllContactsArgs = {
  mode: PhoneVerificationMode;
};


/** Mutation root */
export type MutationVerifyContactListsArgs = {
  listIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
};


/** Mutation root */
export type MutationVerifyContactsArgs = {
  bulk?: InputMaybe<ContactBulkOperationRequestInput>;
};


/** Mutation root */
export type MutationVerifyRestorePasswordCodeArgs = {
  input: ConfirmVerificationCodeRequestInput;
};

export type Networks = {
  __typename?: 'Networks';
  available?: Maybe<Array<Maybe<Scalars['String']>>>;
  preferred?: Maybe<Scalars['String']>;
};

export enum NullHandling {
  Native = 'NATIVE',
  NullsFirst = 'NULLS_FIRST',
  NullsLast = 'NULLS_LAST'
}

export type OAuth2IntegrationInput = {
  code?: InputMaybe<Scalars['String']>;
  lcCompanyId?: InputMaybe<Scalars['String']>;
  lcLocationId?: InputMaybe<Scalars['String']>;
  redirectUri?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AccountIntegrationType>;
};

export type OAuth2IntegrationResponse = {
  __typename?: 'OAuth2IntegrationResponse';
  authUrl?: Maybe<Scalars['String']>;
  connected?: Maybe<Scalars['Boolean']>;
  connectedUser?: Maybe<Scalars['String']>;
  invalidated: Scalars['Boolean'];
  organizationType?: Maybe<IntegrationConnectionType>;
  type?: Maybe<AccountIntegrationType>;
};

export type OnMonthDayConfig = {
  __typename?: 'OnMonthDayConfig';
  dayOrdinal?: Maybe<OnMonthDayOrdinal>;
  dayType?: Maybe<OnMonthDayType>;
};

export type OnMonthDayConfigInput = {
  dayOrdinal?: InputMaybe<OnMonthDayOrdinal>;
  dayType?: InputMaybe<OnMonthDayType>;
};

export enum OnMonthDayOrdinal {
  First = 'FIRST',
  Fourth = 'FOURTH',
  Last = 'LAST',
  Second = 'SECOND',
  Third = 'THIRD'
}

export enum OnMonthDayType {
  Day = 'DAY',
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type OrderInput = {
  direction?: InputMaybe<Direction>;
  ignoreCase?: InputMaybe<Scalars['Boolean']>;
  nullHandlingHint?: InputMaybe<NullHandling>;
  property: Scalars['String'];
};

export type OrgBillingInfo = {
  __typename?: 'OrgBillingInfo';
  autoRecharge?: Maybe<Scalars['Boolean']>;
  autoRechargeCreditsAmount?: Maybe<Scalars['Int']>;
  autoRechargeThreshold?: Maybe<AutoRechargeThreshold>;
  backupPaymentMethod?: Maybe<Scalars['String']>;
  cancelAccountAt?: Maybe<Scalars['Instant']>;
  createdAt?: Maybe<Scalars['Date']>;
  currentPeriodStart?: Maybe<Scalars['Instant']>;
  lastChargeId?: Maybe<Scalars['String']>;
  mrr?: Maybe<Scalars['BigDecimal']>;
  paymentMethods?: Maybe<Array<Maybe<PaymentMethod>>>;
  primaryPaymentMethod?: Maybe<Scalars['String']>;
  status?: Maybe<Status>;
  stripeCouponId?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  subscriptionId?: Maybe<Scalars['String']>;
  totalSpent?: Maybe<Scalars['BigDecimal']>;
  trialPeriodEnded?: Maybe<Scalars['Boolean']>;
};

export type Organization = {
  __typename?: 'Organization';
  activeCampaignApiKey?: Maybe<Scalars['String']>;
  activeCampaignConnectedUser?: Maybe<Scalars['String']>;
  activeCampaignUrl?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  allowImport: Scalars['Boolean'];
  canUseGlobalNumber?: Maybe<Scalars['Boolean']>;
  carrierFeePaymentFailed: Scalars['Boolean'];
  companyName?: Maybe<Scalars['String']>;
  complianceUrl?: Maybe<Scalars['String']>;
  contract: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  employees?: Maybe<Scalars['String']>;
  formattedPhoneNumber?: Maybe<Scalars['String']>;
  fpLeadId?: Maybe<Scalars['Long']>;
  ghlAccessToken?: Maybe<Scalars['String']>;
  ghlAccessTokenExpireDate?: Maybe<Scalars['Instant']>;
  ghlCompanyId?: Maybe<Scalars['String']>;
  ghlConnectedUser?: Maybe<Scalars['String']>;
  ghlIntegrationType?: Maybe<IntegrationConnectionType>;
  ghlLocationId?: Maybe<Scalars['String']>;
  ghlRefreshToken?: Maybe<Scalars['String']>;
  ghlUserId?: Maybe<Scalars['String']>;
  global: Scalars['Boolean'];
  hubSpotAccessToken?: Maybe<Scalars['String']>;
  hubSpotAccessTokenExpireDate?: Maybe<Scalars['Instant']>;
  hubSpotCompanyId?: Maybe<Scalars['String']>;
  hubSpotConnectedUser?: Maybe<Scalars['String']>;
  hubSpotOwnerId?: Maybe<Scalars['String']>;
  hubSpotPortalId?: Maybe<Scalars['Int']>;
  hubSpotRefreshToken?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Long']>;
  importApprovedAt?: Maybe<Scalars['Instant']>;
  importApprover?: Maybe<Member>;
  importApproverId?: Maybe<Scalars['Long']>;
  ipAddress?: Maybe<Scalars['String']>;
  ipCountryCode?: Maybe<Scalars['String']>;
  ipCountryName?: Maybe<Scalars['String']>;
  keapAccessToken?: Maybe<Scalars['String']>;
  keapAccessTokenExpireDate?: Maybe<Scalars['Instant']>;
  keapConnectedUser?: Maybe<Scalars['String']>;
  keapRefreshToken?: Maybe<Scalars['String']>;
  migrationStatus?: Maybe<Status>;
  phoneCheckerEnabled: Scalars['Boolean'];
  phoneCountryCode?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneReleaseDate?: Maybe<Scalars['Date']>;
  recordingPin?: Maybe<Scalars['Long']>;
  ringlessMessageProviderType?: Maybe<RinglessMessageProviderType>;
  segmentLastSyncDate?: Maybe<Scalars['Date']>;
  segmentSyncLastMemberId?: Maybe<Scalars['Long']>;
  showCallbackConfirmation: Scalars['Boolean'];
  status?: Maybe<OrganizationStatus>;
  termsUrl?: Maybe<Scalars['String']>;
  trialPhoneNumberId?: Maybe<Scalars['Long']>;
  updatedAt?: Maybe<Scalars['Date']>;
  uuid?: Maybe<Scalars['UUID']>;
  voiceMessageProviderType?: Maybe<VoiceMessageProviderType>;
  website?: Maybe<Scalars['String']>;
};

export type OrganizationComplianceResponse = {
  __typename?: 'OrganizationComplianceResponse';
  businessProfileId?: Maybe<Scalars['Long']>;
  businessProfileStatus?: Maybe<BusinessProfileStatus>;
  companyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Long']>;
  organizationStatus?: Maybe<Scalars['String']>;
  signupDate?: Maybe<Scalars['Instant']>;
  status?: Maybe<Scalars['String']>;
  tollFreeProfileId?: Maybe<Scalars['Long']>;
  tollFreeStatus?: Maybe<TollFreeVerificationStatus>;
  trialPeriodEnded?: Maybe<Scalars['Boolean']>;
};

export type OrganizationComplianceSearchInput = {
  billingStatuses?: InputMaybe<Array<InputMaybe<BillingStatus>>>;
  bpStatuses?: InputMaybe<Array<InputMaybe<BusinessProfileStatus>>>;
  tfStatuses?: InputMaybe<Array<InputMaybe<TollFreeVerificationStatus>>>;
};

export type OrganizationDetails = {
  __typename?: 'OrganizationDetails';
  activeSubscriberInfo?: Maybe<ActiveSubscriberInfo>;
  balances?: Maybe<Balances>;
  billingInfo?: Maybe<OrgBillingInfo>;
  businessProfile?: Maybe<BusinessProfileResponse>;
  canUseGlobalNumber?: Maybe<Scalars['Boolean']>;
  companyName?: Maybe<Scalars['String']>;
  contract: Scalars['Boolean'];
  hubSpotAppId?: Maybe<Scalars['String']>;
  hubSpotCompanyId?: Maybe<Scalars['String']>;
  hubSpotOwnerId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Long']>;
  integrations?: Maybe<AccountIntegrationsResponse>;
  intercomCompanyLink?: Maybe<Scalars['String']>;
  intercomContactLink?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  ipCountryCode?: Maybe<Scalars['String']>;
  ipCountryName?: Maybe<Scalars['String']>;
  migrated: Scalars['Boolean'];
  mrr?: Maybe<Scalars['Float']>;
  organizationStatus?: Maybe<OrganizationStatus>;
  ownerId?: Maybe<Scalars['Long']>;
  signupDate?: Maybe<Scalars['Instant']>;
  status?: Maybe<Scalars['String']>;
  subscription?: Maybe<ClSubscription>;
  teamSize?: Maybe<Scalars['String']>;
  tollFreeVerificationProfile?: Maybe<TollFreeVerificationProfile>;
  totalContacts: Scalars['Int'];
  totalSpend?: Maybe<Scalars['Float']>;
  twilioSubAccountSid?: Maybe<Scalars['String']>;
};

export type OrganizationInfoUpdateInput = {
  city?: InputMaybe<Scalars['String']>;
  complianceUrl?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  termsUrl?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type OrganizationInput = {
  activeCampaignApiKey?: InputMaybe<Scalars['String']>;
  activeCampaignConnectedUser?: InputMaybe<Scalars['String']>;
  activeCampaignUrl?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<AddressInput>;
  allowImport: Scalars['Boolean'];
  canUseGlobalNumber?: InputMaybe<Scalars['Boolean']>;
  carrierFeePaymentFailed: Scalars['Boolean'];
  companyName?: InputMaybe<Scalars['String']>;
  complianceUrl?: InputMaybe<Scalars['String']>;
  contract: Scalars['Boolean'];
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  employees?: InputMaybe<Scalars['String']>;
  formattedPhoneNumber?: InputMaybe<Scalars['String']>;
  fpLeadId?: InputMaybe<Scalars['Long']>;
  ghlAccessToken?: InputMaybe<Scalars['String']>;
  ghlAccessTokenExpireDate?: InputMaybe<Scalars['Instant']>;
  ghlCompanyId?: InputMaybe<Scalars['String']>;
  ghlConnectedUser?: InputMaybe<Scalars['String']>;
  ghlIntegrationType?: InputMaybe<IntegrationConnectionType>;
  ghlLocationId?: InputMaybe<Scalars['String']>;
  ghlRefreshToken?: InputMaybe<Scalars['String']>;
  ghlUserId?: InputMaybe<Scalars['String']>;
  hubSpotAccessToken?: InputMaybe<Scalars['String']>;
  hubSpotAccessTokenExpireDate?: InputMaybe<Scalars['Instant']>;
  hubSpotCompanyId?: InputMaybe<Scalars['String']>;
  hubSpotConnectedUser?: InputMaybe<Scalars['String']>;
  hubSpotOwnerId?: InputMaybe<Scalars['String']>;
  hubSpotPortalId?: InputMaybe<Scalars['Int']>;
  hubSpotRefreshToken?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Long']>;
  importApprovedAt?: InputMaybe<Scalars['Instant']>;
  importApprover?: InputMaybe<MemberInput>;
  importApproverId?: InputMaybe<Scalars['Long']>;
  ipAddress?: InputMaybe<Scalars['String']>;
  ipCountryCode?: InputMaybe<Scalars['String']>;
  ipCountryName?: InputMaybe<Scalars['String']>;
  keapAccessToken?: InputMaybe<Scalars['String']>;
  keapAccessTokenExpireDate?: InputMaybe<Scalars['Instant']>;
  keapConnectedUser?: InputMaybe<Scalars['String']>;
  keapRefreshToken?: InputMaybe<Scalars['String']>;
  migrationStatus?: InputMaybe<Status>;
  phoneCheckerEnabled: Scalars['Boolean'];
  phoneCountryCode?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneReleaseDate?: InputMaybe<Scalars['Date']>;
  recordingPin?: InputMaybe<Scalars['Long']>;
  ringlessMessageProviderType?: InputMaybe<RinglessMessageProviderType>;
  segmentLastSyncDate?: InputMaybe<Scalars['Date']>;
  segmentSyncLastMemberId?: InputMaybe<Scalars['Long']>;
  showCallbackConfirmation: Scalars['Boolean'];
  status?: InputMaybe<OrganizationStatus>;
  termsUrl?: InputMaybe<Scalars['String']>;
  trialPhoneNumberId?: InputMaybe<Scalars['Long']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  uuid?: InputMaybe<Scalars['UUID']>;
  voiceMessageProviderType?: InputMaybe<VoiceMessageProviderType>;
  website?: InputMaybe<Scalars['String']>;
};

export type OrganizationResponse = {
  __typename?: 'OrganizationResponse';
  canUseGlobalNumber?: Maybe<Scalars['Boolean']>;
  cancelAccountAt?: Maybe<Scalars['Instant']>;
  companyName?: Maybe<Scalars['String']>;
  credits?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Long']>;
  ipAddress?: Maybe<Scalars['String']>;
  ipCountryCode?: Maybe<Scalars['String']>;
  ipCountryName?: Maybe<Scalars['String']>;
  isMigrated?: Maybe<Scalars['Boolean']>;
  organizationStatus?: Maybe<Scalars['String']>;
  ownerEmail?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['Long']>;
  ownerName?: Maybe<Scalars['String']>;
  signupDate?: Maybe<Scalars['Instant']>;
  status?: Maybe<Scalars['String']>;
  trialPeriodEnded: Scalars['Boolean'];
};

export type OrganizationSearchInput = {
  billingStatuses?: InputMaybe<Array<InputMaybe<BillingStatus>>>;
  organizationStatuses?: InputMaybe<Array<InputMaybe<OrganizationStatus>>>;
  searchPattern?: InputMaybe<Scalars['String']>;
};

export enum OrganizationStatus {
  Active = 'ACTIVE',
  Banned = 'BANNED',
  Suspended = 'SUSPENDED'
}

export type OrganizationTokenRequestInput = {
  organizationId?: InputMaybe<Scalars['Long']>;
};

export type OrganizationTokenResponse = {
  __typename?: 'OrganizationTokenResponse';
  token?: Maybe<Scalars['String']>;
};

export type OrganizationUpdateInput = {
  companyName?: InputMaybe<Scalars['String']>;
  employees?: InputMaybe<Scalars['String']>;
  messageTypes?: InputMaybe<Array<InputMaybe<ExpectedMessageType>>>;
};

export type PageResponse_Asset = {
  __typename?: 'PageResponse_Asset';
  content?: Maybe<Array<Maybe<Asset>>>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Long'];
};

export type PageResponse_AudioItem = {
  __typename?: 'PageResponse_AudioItem';
  content?: Maybe<Array<Maybe<AudioItem>>>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Long'];
};

export type PageResponse_BillingInvoice = {
  __typename?: 'PageResponse_BillingInvoice';
  content?: Maybe<Array<Maybe<BillingInvoice>>>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Long'];
};

export type PageResponse_BroadcastResponse = {
  __typename?: 'PageResponse_BroadcastResponse';
  content?: Maybe<Array<Maybe<BroadcastResponse>>>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Long'];
};

export type PageResponse_CampaignResponse = {
  __typename?: 'PageResponse_CampaignResponse';
  content?: Maybe<Array<Maybe<CampaignResponse>>>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Long'];
};

export type PageResponse_ContactImportState = {
  __typename?: 'PageResponse_ContactImportState';
  content?: Maybe<Array<Maybe<ContactImportState>>>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Long'];
};

export type PageResponse_ContactLightResponse = {
  __typename?: 'PageResponse_ContactLightResponse';
  content?: Maybe<Array<Maybe<ContactLightResponse>>>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Long'];
};

export type PageResponse_ConversionHitProjection = {
  __typename?: 'PageResponse_ConversionHitProjection';
  content?: Maybe<Array<Maybe<ConversionHitProjection>>>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Long'];
};

export type PageResponse_ConversionResponse = {
  __typename?: 'PageResponse_ConversionResponse';
  content?: Maybe<Array<Maybe<ConversionResponse>>>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Long'];
};

export type PageResponse_Keyword = {
  __typename?: 'PageResponse_Keyword';
  content?: Maybe<Array<Maybe<Keyword>>>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Long'];
};

export type PageResponse_KeywordContactResponse = {
  __typename?: 'PageResponse_KeywordContactResponse';
  content?: Maybe<Array<Maybe<KeywordContactResponse>>>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Long'];
};

export type PageResponse_ListResponse = {
  __typename?: 'PageResponse_ListResponse';
  content?: Maybe<Array<Maybe<ListResponse>>>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Long'];
};

export type PageResponse_MemberProfileResponse = {
  __typename?: 'PageResponse_MemberProfileResponse';
  content?: Maybe<Array<Maybe<MemberProfileResponse>>>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Long'];
};

export type PageResponse_MemberResponse = {
  __typename?: 'PageResponse_MemberResponse';
  content?: Maybe<Array<Maybe<MemberResponse>>>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Long'];
};

export type PageResponse_MessageDataResponse = {
  __typename?: 'PageResponse_MessageDataResponse';
  content?: Maybe<Array<Maybe<MessageDataResponse>>>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Long'];
};

export type PageResponse_MessageTemplateResponse = {
  __typename?: 'PageResponse_MessageTemplateResponse';
  content?: Maybe<Array<Maybe<MessageTemplateResponse>>>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Long'];
};

export type PageResponse_OrganizationComplianceResponse = {
  __typename?: 'PageResponse_OrganizationComplianceResponse';
  content?: Maybe<Array<Maybe<OrganizationComplianceResponse>>>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Long'];
};

export type PageResponse_OrganizationResponse = {
  __typename?: 'PageResponse_OrganizationResponse';
  content?: Maybe<Array<Maybe<OrganizationResponse>>>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Long'];
};

export type PageResponse_PhoneNumberWithVerificationProfileData = {
  __typename?: 'PageResponse_PhoneNumberWithVerificationProfileData';
  content?: Maybe<Array<Maybe<PhoneNumberWithVerificationProfileData>>>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Long'];
};

export type PageResponse_SegmentResponse = {
  __typename?: 'PageResponse_SegmentResponse';
  content?: Maybe<Array<Maybe<SegmentResponse>>>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Long'];
};

export type PageResponse_Trigger = {
  __typename?: 'PageResponse_Trigger';
  content?: Maybe<Array<Maybe<Trigger>>>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Long'];
};

export type PageResponse_WebForm = {
  __typename?: 'PageResponse_WebForm';
  content?: Maybe<Array<Maybe<WebForm>>>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Long'];
};

export type PaginationInput = {
  pageNumber: Scalars['Int'];
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<SortInput>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  card?: Maybe<Card>;
  customer?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['Map_String_StringScalar']>;
  type?: Maybe<Scalars['String']>;
};

export type PercentageContactStatusStatistics = {
  __typename?: 'PercentageContactStatusStatistics';
  active?: Maybe<Scalars['Float']>;
  confirmed?: Maybe<Scalars['Float']>;
  subscribed?: Maybe<Scalars['Float']>;
  unsubscribed?: Maybe<Scalars['Float']>;
};

export type PercentageStatistics = {
  __typename?: 'PercentageStatistics';
  callbackPercentage: Scalars['Float'];
  failedPercentage: Scalars['Float'];
  pendingPercentage: Scalars['Float'];
  successPercentage: Scalars['Float'];
  unsubscribedPercentage: Scalars['Float'];
};

export type PhoneLookup = {
  __typename?: 'PhoneLookup';
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  finished: Scalars['Boolean'];
  id?: Maybe<Scalars['Long']>;
  member?: Maybe<Member>;
  organization?: Maybe<Organization>;
  updatedAt?: Maybe<Scalars['Date']>;
  verificationMode?: Maybe<PhoneVerificationMode>;
};

export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  callForwardEnabled?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  destinationExtension?: Maybe<Scalars['Int']>;
  destinationPhoneNumber?: Maybe<Scalars['String']>;
  emergencyStatus?: Maybe<Status>;
  externalNumber?: Maybe<Scalars['String']>;
  externalNumberId?: Maybe<Scalars['String']>;
  externalProvider?: Maybe<ExternalPhoneNumberProvider>;
  friendlyName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Long']>;
  member?: Maybe<Member>;
  messagingServiceSid?: Maybe<Scalars['String']>;
  mms?: Maybe<Scalars['Boolean']>;
  organization?: Maybe<Organization>;
  phoneNumber?: Maybe<Scalars['String']>;
  sms?: Maybe<Scalars['Boolean']>;
  sourceType?: Maybe<PhoneNumberSourceType>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<PhoneType>;
  updatedAt?: Maybe<Scalars['Date']>;
  verificationStatus?: Maybe<VerificationStatus>;
  voice?: Maybe<Scalars['Boolean']>;
};

export type PhoneNumberInput = {
  callForwardEnabled?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  destinationExtension?: InputMaybe<Scalars['Int']>;
  destinationPhoneNumber?: InputMaybe<Scalars['String']>;
  emergencyStatus?: InputMaybe<Status>;
  externalNumber?: InputMaybe<Scalars['String']>;
  externalNumberId?: InputMaybe<Scalars['String']>;
  externalProvider?: InputMaybe<ExternalPhoneNumberProvider>;
  friendlyName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Long']>;
  member?: InputMaybe<MemberInput>;
  messagingServiceSid?: InputMaybe<Scalars['String']>;
  mms?: InputMaybe<Scalars['Boolean']>;
  organization?: InputMaybe<OrganizationInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  sms?: InputMaybe<Scalars['Boolean']>;
  sourceType?: InputMaybe<PhoneNumberSourceType>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PhoneType>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  verificationStatus?: InputMaybe<VerificationStatus>;
  voice?: InputMaybe<Scalars['Boolean']>;
};

export enum PhoneNumberSourceType {
  External = 'EXTERNAL',
  Twilio = 'TWILIO'
}

export enum PhoneNumberType {
  Local = 'Local',
  Mobile = 'Mobile',
  TollFree = 'TollFree'
}

export type PhoneNumberWithVerificationProfileData = {
  __typename?: 'PhoneNumberWithVerificationProfileData';
  phoneNumber?: Maybe<PhoneNumber>;
  useCaseTitle?: Maybe<Scalars['String']>;
};

export enum PhoneType {
  CallerId = 'CALLER_ID',
  Local = 'LOCAL',
  Mobile = 'MOBILE',
  ShortCode = 'SHORT_CODE',
  TestTollFree = 'TEST_TOLL_FREE',
  TollFree = 'TOLL_FREE'
}

export enum PhoneVerificationMode {
  All = 'ALL',
  NotVerified = 'NOT_VERIFIED'
}

export enum PhoneVerificationResult {
  ChargeFailed = 'CHARGE_FAILED',
  Invalid = 'INVALID',
  Undefined = 'UNDEFINED',
  Valid = 'VALID'
}

export enum PhoneVerificationStatus {
  Pending = 'PENDING',
  PendingManually = 'PENDING_MANUALLY',
  Verified = 'VERIFIED'
}

export enum PlanPeriod {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Semiannual = 'SEMIANNUAL'
}

export type PredefinedCustomer = {
  __typename?: 'PredefinedCustomer';
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Long']>;
  planName?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type PredefinedCustomerInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Long']>;
  planName?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
};

export type PriceMigration = {
  __typename?: 'PriceMigration';
  annualPrices?: Maybe<Array<Maybe<SimplePrice>>>;
  monthlyPrices?: Maybe<Array<Maybe<SimplePrice>>>;
};

export type PriceMigrationSelection = {
  __typename?: 'PriceMigrationSelection';
  annualPrice?: Maybe<SimplePrice>;
  monthlyPrice?: Maybe<SimplePrice>;
};

/** Query root */
export type Query = {
  __typename?: 'Query';
  adminCustomPlans?: Maybe<Array<Maybe<SimplePrice>>>;
  adminGetFullBusinessProfile?: Maybe<BusinessProfileResponse>;
  adminGetFullTollFreeVerificationProfile?: Maybe<TollFreeVerificationProfile>;
  adminGetImportHistory?: Maybe<PageResponse_ContactImportState>;
  adminGetMemberProfiles?: Maybe<PageResponse_MemberProfileResponse>;
  adminGetOrganizationMembers?: Maybe<PageResponse_MemberResponse>;
  adminGetTollFreeVerificationStatus?: Maybe<TollFreeVerificationStatusResponse>;
  adminOrganizationComplianceList?: Maybe<PageResponse_OrganizationComplianceResponse>;
  checkAudioItemExists?: Maybe<Scalars['Boolean']>;
  evaluateFilter?: Maybe<PageResponse_ContactLightResponse>;
  evaluateSegment?: Maybe<PageResponse_ContactLightResponse>;
  fetchContacts?: Maybe<Array<Maybe<Contact>>>;
  fetchInvoice?: Maybe<BillingInvoice>;
  fetchLists?: Maybe<Array<Maybe<ListingLight>>>;
  findCities?: Maybe<Array<Maybe<Location>>>;
  getA2PRegistrationTasks?: Maybe<Array<Maybe<RegistrationTask>>>;
  getActiveContactsCount: Scalars['Int'];
  getAllAudioItems?: Maybe<PageResponse_AudioItem>;
  getAllBroadcasts?: Maybe<PageResponse_BroadcastResponse>;
  getAllCampaigns?: Maybe<PageResponse_CampaignResponse>;
  getAllCountries?: Maybe<Array<Maybe<Country>>>;
  getAllKeywords?: Maybe<PageResponse_Keyword>;
  getAllMembers?: Maybe<PageResponse_MemberResponse>;
  getAllNumbers?: Maybe<Array<Maybe<PhoneNumberWithVerificationProfileData>>>;
  getAllPredefinedCustomers?: Maybe<Array<Maybe<PredefinedCustomer>>>;
  getAllTriggers?: Maybe<PageResponse_Trigger>;
  getAllUserTimezones?: Maybe<Array<Maybe<UserTimeZone>>>;
  getAvailableFilterFields?: Maybe<FilterFieldsResponse>;
  getAvailablePhoneNumbers?: Maybe<AvailablePhoneNumbers>;
  getBalances?: Maybe<Balances>;
  getBroadcastById?: Maybe<BroadcastFullResponse>;
  getBroadcastEstimatedDuration?: Maybe<BroadcastEstimatedDurationResponse>;
  getBroadcastEstimatedPrice?: Maybe<BroadcastEstimatedPriceResponse>;
  getBroadcastMessageStatistics?: Maybe<MessageStatisticsResponse>;
  getBroadcastMessages?: Maybe<PageResponse_MessageDataResponse>;
  getBroadcastSpeedOptions?: Maybe<Array<Maybe<BroadcastSpeedOption>>>;
  getBusinessCountryStates?: Maybe<Array<Maybe<Scalars['String']>>>;
  getBusinessProfileTypes?: Maybe<BusinessProfileTypes>;
  getCampaignAnalyticsStatistics?: Maybe<CampaignAnalyticsStatisticsResponse>;
  getCampaignById?: Maybe<CampaignResponse>;
  getCampaignStatistics?: Maybe<MessageStatisticsResponse>;
  getCampaignStepMessages?: Maybe<PageResponse_MessageDataResponse>;
  getCampaignStepStatistics?: Maybe<MessageStatisticsResponse>;
  getComplianceMessage?: Maybe<Scalars['String']>;
  getConfiguration?: Maybe<ApplicationConfiguration>;
  getContactWebhookUrl?: Maybe<Scalars['String']>;
  getConversion?: Maybe<ConversionResponse>;
  getConversionHits?: Maybe<PageResponse_ConversionHitProjection>;
  getConversionStatistics?: Maybe<ConversionStatistics>;
  getConversions?: Maybe<PageResponse_ConversionResponse>;
  getConversionsTotalStatistics?: Maybe<ConversionStatistics>;
  getCreditPriceSelection?: Maybe<CreditPriceSelection>;
  getCreditPriceSelectionForPlans?: Maybe<Array<Maybe<CreditPriceSelection>>>;
  getCustomFields?: Maybe<Array<Maybe<CustomField>>>;
  getCustomFieldsByType?: Maybe<Array<Maybe<CustomField>>>;
  getExistingKeywordPhoneNumbers?: Maybe<Scalars['Map_String_StringArrayScalar']>;
  getFullBusinessProfile?: Maybe<BusinessProfileResponse>;
  getFullTenDlcProfile?: Maybe<TenDlcRegisterProfileResponse>;
  getFullTollFreeVerificationProfile?: Maybe<TollFreeVerificationProfile>;
  getImportHistory?: Maybe<PageResponse_ContactImportState>;
  getIntegrationCustomFields?: Maybe<Array<Maybe<IntegrationField>>>;
  getIntegrations?: Maybe<AccountIntegrationsResponse>;
  getInvoices?: Maybe<PageResponse_BillingInvoice>;
  getKeywordById?: Maybe<Keyword>;
  getKeywordContactStatistics?: Maybe<KeywordContactStatisticsResponse>;
  getKeywordContacts?: Maybe<PageResponse_KeywordContactResponse>;
  getListContacts?: Maybe<PageResponse_ContactLightResponse>;
  getListContactsStatistics?: Maybe<ContactStatisticsResponse>;
  getMember?: Maybe<MemberResponse>;
  getMessageTemplate?: Maybe<MessageTemplateResponse>;
  getMessageTemplates?: Maybe<PageResponse_MessageTemplateResponse>;
  getMyAssets?: Maybe<PageResponse_Asset>;
  getMyContact?: Maybe<Contact>;
  getMyContactCards?: Maybe<Array<Maybe<ContactCard>>>;
  getMyContactsStatistics?: Maybe<ContactStatisticsResponse>;
  getMyOrganization?: Maybe<Organization>;
  getMyOrganizationContacts?: Maybe<PageResponse_ContactLightResponse>;
  getMyOrganizationContactsStatistics?: Maybe<ContactStatisticsResponse>;
  getMyOrganizationLists?: Maybe<PageResponse_ListResponse>;
  getNumbersPage?: Maybe<PageResponse_PhoneNumberWithVerificationProfileData>;
  getOrganizationBillingInfo?: Maybe<OrgBillingInfo>;
  getOrganizationDetails?: Maybe<OrganizationDetails>;
  getPriceMigration?: Maybe<PriceMigration>;
  getPrices?: Maybe<Array<Maybe<SimplePrice>>>;
  getProfileOrganizations?: Maybe<Array<Maybe<MemberProfileOrganization>>>;
  getSegment?: Maybe<SegmentResponse>;
  getSegments?: Maybe<PageResponse_SegmentResponse>;
  getSkippedContacts?: Maybe<UnvalidatedContactPage>;
  getSubscription?: Maybe<ClSubscription>;
  getTenDlcTypes?: Maybe<TenDlcTypes>;
  getTextBlacklist?: Maybe<Array<Maybe<TextBlacklist>>>;
  getTokenForOrganization?: Maybe<OrganizationTokenResponse>;
  getTollFreeVerificationProfileTypes?: Maybe<TollFreeVerificationProfileTypes>;
  getTollFreeVerificationStatus?: Maybe<TollFreeVerificationStatusResponse>;
  getTriggerById?: Maybe<Trigger>;
  getTriggerMessageStatistics?: Maybe<MessageStatisticsResponse>;
  getTriggerMessages?: Maybe<PageResponse_MessageDataResponse>;
  getWebForm?: Maybe<WebForm>;
  getWebFormContacts?: Maybe<PageResponse_ContactLightResponse>;
  getWebFormContactsStatistics?: Maybe<ContactStatisticsByUuidResponse>;
  getWebForms?: Maybe<PageResponse_WebForm>;
  getWorkflowActionContainer?: Maybe<WorkflowActionContainer>;
  organizationsList?: Maybe<PageResponse_OrganizationResponse>;
  paymentRegistrationSelectPrices?: Maybe<PriceMigrationSelection>;
  searchBusinessGeneralInfo?: Maybe<Array<Maybe<BusinessGeneralInfoEinResponse>>>;
  searchListsAndContacts?: Maybe<ListContactSearchResult>;
  uploadLocationData: Scalars['Boolean'];
};


/** Query root */
export type QueryAdminGetFullBusinessProfileArgs = {
  organizationId: Scalars['Long'];
};


/** Query root */
export type QueryAdminGetFullTollFreeVerificationProfileArgs = {
  organizationId: Scalars['Long'];
};


/** Query root */
export type QueryAdminGetImportHistoryArgs = {
  page?: InputMaybe<PaginationInput>;
  searchPattern?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<AllowImportStatus>>>;
};


/** Query root */
export type QueryAdminGetMemberProfilesArgs = {
  page?: InputMaybe<PaginationInput>;
  search?: InputMaybe<MemberProfileSearchInput>;
};


/** Query root */
export type QueryAdminGetOrganizationMembersArgs = {
  organizationId?: InputMaybe<Scalars['Long']>;
  page?: InputMaybe<PaginationInput>;
};


/** Query root */
export type QueryAdminGetTollFreeVerificationStatusArgs = {
  organizationId: Scalars['Long'];
};


/** Query root */
export type QueryAdminOrganizationComplianceListArgs = {
  page?: InputMaybe<PaginationInput>;
  search?: InputMaybe<OrganizationComplianceSearchInput>;
};


/** Query root */
export type QueryCheckAudioItemExistsArgs = {
  name?: InputMaybe<Scalars['String']>;
};


/** Query root */
export type QueryEvaluateFilterArgs = {
  filterValue?: InputMaybe<FilterValueInput>;
  page?: InputMaybe<PaginationInput>;
};


/** Query root */
export type QueryEvaluateSegmentArgs = {
  page?: InputMaybe<PaginationInput>;
  segmentId?: InputMaybe<Scalars['Long']>;
};


/** Query root */
export type QueryFetchContactsArgs = {
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
};


/** Query root */
export type QueryFetchInvoiceArgs = {
  id?: InputMaybe<Scalars['String']>;
};


/** Query root */
export type QueryFetchListsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
};


/** Query root */
export type QueryFindCitiesArgs = {
  cityName?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
};


/** Query root */
export type QueryGetA2PRegistrationTasksArgs = {
  organizationId: Scalars['Long'];
};


/** Query root */
export type QueryGetActiveContactsCountArgs = {
  input?: InputMaybe<BroadcastInput>;
};


/** Query root */
export type QueryGetAllAudioItemsArgs = {
  page?: InputMaybe<PaginationInput>;
  pattern?: InputMaybe<Scalars['String']>;
};


/** Query root */
export type QueryGetAllBroadcastsArgs = {
  page?: InputMaybe<PaginationInput>;
};


/** Query root */
export type QueryGetAllCampaignsArgs = {
  page?: InputMaybe<PaginationInput>;
  search?: InputMaybe<CampaignSearchInput>;
};


/** Query root */
export type QueryGetAllKeywordsArgs = {
  page?: InputMaybe<PaginationInput>;
  searchPattern?: InputMaybe<Scalars['String']>;
};


/** Query root */
export type QueryGetAllMembersArgs = {
  page?: InputMaybe<PaginationInput>;
};


/** Query root */
export type QueryGetAllTriggersArgs = {
  page?: InputMaybe<PaginationInput>;
};


/** Query root */
export type QueryGetAvailablePhoneNumbersArgs = {
  areaCode?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  pageSize: Scalars['Int'];
  partOfNumber?: InputMaybe<Scalars['String']>;
  phoneNumberType?: InputMaybe<PhoneNumberType>;
  state?: InputMaybe<Scalars['String']>;
};


/** Query root */
export type QueryGetBroadcastByIdArgs = {
  broadcastId?: InputMaybe<Scalars['Long']>;
};


/** Query root */
export type QueryGetBroadcastEstimatedDurationArgs = {
  broadcastInput?: InputMaybe<BroadcastInput>;
  expectedContactsCount: Scalars['Int'];
};


/** Query root */
export type QueryGetBroadcastEstimatedPriceArgs = {
  broadcastInput: BroadcastInput;
};


/** Query root */
export type QueryGetBroadcastMessageStatisticsArgs = {
  uuid?: InputMaybe<Scalars['String']>;
};


/** Query root */
export type QueryGetBroadcastMessagesArgs = {
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
  page?: InputMaybe<PaginationInput>;
  status?: InputMaybe<Status>;
  uuid?: InputMaybe<Scalars['String']>;
};


/** Query root */
export type QueryGetBusinessCountryStatesArgs = {
  countryCode: Scalars['String'];
};


/** Query root */
export type QueryGetCampaignAnalyticsStatisticsArgs = {
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
  uuid: Scalars['String'];
};


/** Query root */
export type QueryGetCampaignByIdArgs = {
  campaignId?: InputMaybe<Scalars['Long']>;
};


/** Query root */
export type QueryGetCampaignStatisticsArgs = {
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
  uuid: Scalars['String'];
};


/** Query root */
export type QueryGetCampaignStepMessagesArgs = {
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
  page?: InputMaybe<PaginationInput>;
  status?: InputMaybe<Status>;
  uuid?: InputMaybe<Scalars['String']>;
};


/** Query root */
export type QueryGetCampaignStepStatisticsArgs = {
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
  uuid: Scalars['String'];
};


/** Query root */
export type QueryGetConversionArgs = {
  conversionId?: InputMaybe<Scalars['Long']>;
};


/** Query root */
export type QueryGetConversionHitsArgs = {
  conversionId?: InputMaybe<Scalars['Long']>;
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
  page?: InputMaybe<PaginationInput>;
};


/** Query root */
export type QueryGetConversionStatisticsArgs = {
  conversionId?: InputMaybe<Scalars['Long']>;
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
};


/** Query root */
export type QueryGetConversionsArgs = {
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
  page?: InputMaybe<PaginationInput>;
  searchPattern?: InputMaybe<Scalars['String']>;
};


/** Query root */
export type QueryGetConversionsTotalStatisticsArgs = {
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
};


/** Query root */
export type QueryGetCreditPriceSelectionForPlansArgs = {
  planNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Query root */
export type QueryGetCustomFieldsByTypeArgs = {
  types: Array<InputMaybe<CustomFieldType>>;
};


/** Query root */
export type QueryGetImportHistoryArgs = {
  page?: InputMaybe<PaginationInput>;
  statuses?: InputMaybe<Array<InputMaybe<Status>>>;
};


/** Query root */
export type QueryGetIntegrationCustomFieldsArgs = {
  byPassCache?: InputMaybe<Scalars['Boolean']>;
};


/** Query root */
export type QueryGetInvoicesArgs = {
  page?: InputMaybe<PaginationInput>;
};


/** Query root */
export type QueryGetKeywordByIdArgs = {
  keywordId?: InputMaybe<Scalars['Long']>;
};


/** Query root */
export type QueryGetKeywordContactStatisticsArgs = {
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
  keywordId: Scalars['Long'];
};


/** Query root */
export type QueryGetKeywordContactsArgs = {
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
  keywordId: Scalars['Long'];
  page?: InputMaybe<PaginationInput>;
  status?: InputMaybe<Status>;
};


/** Query root */
export type QueryGetListContactsArgs = {
  contactSearch?: InputMaybe<ContactSearchInput>;
  listId?: InputMaybe<Scalars['Long']>;
  page?: InputMaybe<PaginationInput>;
};


/** Query root */
export type QueryGetListContactsStatisticsArgs = {
  listId?: InputMaybe<Scalars['Long']>;
};


/** Query root */
export type QueryGetMessageTemplateArgs = {
  templateId?: InputMaybe<Scalars['Long']>;
};


/** Query root */
export type QueryGetMessageTemplatesArgs = {
  page?: InputMaybe<PaginationInput>;
  searchPattern?: InputMaybe<Scalars['String']>;
};


/** Query root */
export type QueryGetMyAssetsArgs = {
  page?: InputMaybe<PaginationInput>;
};


/** Query root */
export type QueryGetMyContactArgs = {
  contactId: Scalars['Long'];
};


/** Query root */
export type QueryGetMyOrganizationContactsArgs = {
  contactSearch?: InputMaybe<ContactSearchInput>;
  page?: InputMaybe<PaginationInput>;
};


/** Query root */
export type QueryGetMyOrganizationListsArgs = {
  listingSearch?: InputMaybe<ListingSearchInput>;
  page?: InputMaybe<PaginationInput>;
};


/** Query root */
export type QueryGetNumbersPageArgs = {
  page?: InputMaybe<PaginationInput>;
  searchPattern?: InputMaybe<Scalars['String']>;
};


/** Query root */
export type QueryGetOrganizationDetailsArgs = {
  id?: InputMaybe<Scalars['Long']>;
};


/** Query root */
export type QueryGetProfileOrganizationsArgs = {
  search?: InputMaybe<Scalars['String']>;
};


/** Query root */
export type QueryGetSegmentArgs = {
  segmentId?: InputMaybe<Scalars['Long']>;
};


/** Query root */
export type QueryGetSegmentsArgs = {
  page?: InputMaybe<PaginationInput>;
  searchPattern?: InputMaybe<Scalars['String']>;
};


/** Query root */
export type QueryGetSkippedContactsArgs = {
  importStateId: Scalars['Long'];
  page: PaginationInput;
};


/** Query root */
export type QueryGetTokenForOrganizationArgs = {
  request?: InputMaybe<OrganizationTokenRequestInput>;
};


/** Query root */
export type QueryGetTriggerByIdArgs = {
  triggerId?: InputMaybe<Scalars['Long']>;
};


/** Query root */
export type QueryGetTriggerMessageStatisticsArgs = {
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
  uuid?: InputMaybe<Scalars['String']>;
};


/** Query root */
export type QueryGetTriggerMessagesArgs = {
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
  page?: InputMaybe<PaginationInput>;
  status?: InputMaybe<Status>;
  uuid?: InputMaybe<Scalars['String']>;
};


/** Query root */
export type QueryGetWebFormArgs = {
  id?: InputMaybe<Scalars['Long']>;
};


/** Query root */
export type QueryGetWebFormContactsArgs = {
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
  page?: InputMaybe<PaginationInput>;
  status?: InputMaybe<Status>;
  uuid?: InputMaybe<Scalars['String']>;
};


/** Query root */
export type QueryGetWebFormContactsStatisticsArgs = {
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
  uuid?: InputMaybe<Scalars['String']>;
};


/** Query root */
export type QueryGetWebFormsArgs = {
  page?: InputMaybe<PaginationInput>;
  searchPattern?: InputMaybe<Scalars['String']>;
};


/** Query root */
export type QueryOrganizationsListArgs = {
  page?: InputMaybe<PaginationInput>;
  search?: InputMaybe<OrganizationSearchInput>;
};


/** Query root */
export type QuerySearchBusinessGeneralInfoArgs = {
  input: Scalars['String'];
};


/** Query root */
export type QuerySearchListsAndContactsArgs = {
  search?: InputMaybe<ListContactSearchInput>;
};


/** Query root */
export type QueryUploadLocationDataArgs = {
  country?: InputMaybe<Scalars['String']>;
};

export type RefreshCallFireBroadcastsRqInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
};

export type RegistrationContactDetailsInput = {
  couponId?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  paymentMethodId?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  timeZoneCode?: InputMaybe<Scalars['String']>;
  tokenId?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type RegistrationTask = {
  __typename?: 'RegistrationTask';
  businessProfile?: Maybe<BusinessProfile>;
  evaluationResult?: Maybe<BusinessProfileEvaluationResult>;
  executedAt?: Maybe<Scalars['Date']>;
  executionAttempts: Scalars['Int'];
  failedMessage?: Maybe<Scalars['String']>;
  isCurrent?: Maybe<Scalars['Boolean']>;
  registrationStep?: Maybe<A2PRegistrationStep>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<Status>;
};

export type RepeatConfig = {
  __typename?: 'RepeatConfig';
  customRepeatConfig?: Maybe<CustomRepeatConfig>;
  endDate?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['Long']>;
};

export type RepeatConfigInput = {
  customRepeatConfig?: InputMaybe<CustomRepeatConfigInput>;
  endDate?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['Long']>;
};

export enum RepeatType {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type ReservePhoneNumberRequestInput = {
  city?: InputMaybe<Scalars['String']>;
  inputPhoneNumber?: InputMaybe<Scalars['String']>;
  phoneType?: InputMaybe<PhoneType>;
  state?: InputMaybe<Scalars['String']>;
};

export type RinglessMessage = {
  __typename?: 'RinglessMessage';
  audioId?: Maybe<Scalars['Long']>;
  callbackEnabled: Scalars['Boolean'];
  voiceMail?: Maybe<AudioItem>;
};

export type RinglessMessageInput = {
  audioId?: InputMaybe<Scalars['Long']>;
  callbackEnabled: Scalars['Boolean'];
  voiceMail?: InputMaybe<AudioItemInput>;
};

export enum RinglessMessageProviderType {
  DropCowboy = 'DROP_COWBOY',
  SlyBroadcast = 'SLY_BROADCAST'
}

export type SmsMessage = {
  __typename?: 'SMSMessage';
  appType?: Maybe<AccountIntegrationType>;
  assetIds?: Maybe<Array<Maybe<Scalars['Long']>>>;
  audioIds?: Maybe<Array<Maybe<Scalars['Long']>>>;
  cardIds?: Maybe<Array<Maybe<Scalars['Long']>>>;
  compliance: Scalars['Boolean'];
  complianceText?: Maybe<Scalars['String']>;
  messageAssets?: Maybe<Array<Maybe<SmsMessageAsset>>>;
  messageAudios?: Maybe<Array<Maybe<SmsMessageAudio>>>;
  messageCards?: Maybe<Array<Maybe<SmsMessageContactCard>>>;
  mmsUrl?: Maybe<Array<Maybe<Scalars['String']>>>;
  text?: Maybe<Scalars['String']>;
};

export type SmsMessageAsset = {
  __typename?: 'SMSMessageAsset';
  asset?: Maybe<Asset>;
};

export type SmsMessageAssetInput = {
  asset?: InputMaybe<AssetInput>;
};

export type SmsMessageAudio = {
  __typename?: 'SMSMessageAudio';
  audio?: Maybe<AudioItem>;
};

export type SmsMessageAudioInput = {
  audio?: InputMaybe<AudioItemInput>;
};

export type SmsMessageContactCard = {
  __typename?: 'SMSMessageContactCard';
  contactCard?: Maybe<ContactCard>;
};

export type SmsMessageContactCardInput = {
  contactCard?: InputMaybe<ContactCardInput>;
};

export type SmsMessageInput = {
  appType?: InputMaybe<AccountIntegrationType>;
  assetIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  audioIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  cardIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  compliance: Scalars['Boolean'];
  complianceText?: InputMaybe<Scalars['String']>;
  messageAssets?: InputMaybe<Array<InputMaybe<SmsMessageAssetInput>>>;
  messageAudios?: InputMaybe<Array<InputMaybe<SmsMessageAudioInput>>>;
  messageCards?: InputMaybe<Array<InputMaybe<SmsMessageContactCardInput>>>;
  mmsUrl?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text?: InputMaybe<Scalars['String']>;
};

export type SmsMessageRequestInput = {
  assetIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  audioIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  cardIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  compliance: Scalars['Boolean'];
  complianceText?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
};

export type SchedulingConfig = {
  __typename?: 'SchedulingConfig';
  sendLaterConfig?: Maybe<SendLaterConfig>;
  sendType?: Maybe<BroadcastSendType>;
};

export type SchedulingConfigInput = {
  sendLaterConfig?: InputMaybe<SendLaterConfigInput>;
  sendType?: InputMaybe<BroadcastSendType>;
};

export type SecondStreetAddress = {
  __typename?: 'SecondStreetAddress';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
  secondStreet?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type SegmentResponse = {
  __typename?: 'SegmentResponse';
  createdAt?: Maybe<Scalars['Date']>;
  filterValue?: Maybe<FilterValue>;
  id?: Maybe<Scalars['Long']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type SendLaterConfig = {
  __typename?: 'SendLaterConfig';
  id?: Maybe<Scalars['Long']>;
  repeatConfig?: Maybe<RepeatConfig>;
  repeatType?: Maybe<SendLaterRepeatType>;
  sendDate?: Maybe<Scalars['Date']>;
};

export type SendLaterConfigInput = {
  id?: InputMaybe<Scalars['Long']>;
  repeatConfig?: InputMaybe<RepeatConfigInput>;
  repeatType?: InputMaybe<SendLaterRepeatType>;
  sendDate?: InputMaybe<Scalars['Date']>;
};

export enum SendLaterRepeatType {
  Custom = 'CUSTOM',
  EveryDay = 'EVERY_DAY',
  EveryMonth = 'EVERY_MONTH',
  EveryWeek = 'EVERY_WEEK',
  Never = 'NEVER'
}

export enum SendingSpeedUnit {
  Minute = 'MINUTE'
}

export type ShortUrlClickStatistics = {
  __typename?: 'ShortUrlClickStatistics';
  shortUrlVisits?: Maybe<Array<Maybe<SpecificUrlClickStatistics>>>;
  totalVisits?: Maybe<Scalars['Long']>;
  totalVisitsPercentage?: Maybe<Scalars['Float']>;
  totalVisitsToday?: Maybe<Scalars['Long']>;
};

export type ShortUrlClickStatisticsInput = {
  shortUrlVisits?: InputMaybe<Array<InputMaybe<SpecificUrlClickStatisticsInput>>>;
  totalVisits?: InputMaybe<Scalars['Long']>;
  totalVisitsPercentage?: InputMaybe<Scalars['Float']>;
  totalVisitsToday?: InputMaybe<Scalars['Long']>;
};

export type SimplePrice = {
  __typename?: 'SimplePrice';
  additionalCreditPrice?: Maybe<Scalars['Float']>;
  bonusValue: Scalars['Int'];
  creditPrices?: Maybe<Array<Maybe<CreditPrice>>>;
  creditsIncluded?: Maybe<Scalars['Int']>;
  customObjectPrices?: Maybe<Array<Maybe<ChargeObjectPrice>>>;
  period?: Maybe<Scalars['String']>;
  planDescription?: Maybe<Scalars['String']>;
  planLine?: Maybe<Scalars['String']>;
  planName?: Maybe<Scalars['String']>;
  planTitle?: Maybe<Scalars['String']>;
  priceCatalogId?: Maybe<Scalars['Long']>;
  priceValue?: Maybe<Scalars['Float']>;
};

export type SimplePriceInput = {
  additionalCreditPrice?: InputMaybe<Scalars['Float']>;
  bonusValue: Scalars['Int'];
  creditPrices?: InputMaybe<Array<InputMaybe<CreditPriceInput>>>;
  creditsIncluded?: InputMaybe<Scalars['Int']>;
  customObjectPrices?: InputMaybe<Array<InputMaybe<ChargeObjectPriceInput>>>;
  period?: InputMaybe<Scalars['String']>;
  planDescription?: InputMaybe<Scalars['String']>;
  planLine?: InputMaybe<Scalars['String']>;
  planName?: InputMaybe<Scalars['String']>;
  planTitle?: InputMaybe<Scalars['String']>;
  priceCatalogId?: InputMaybe<Scalars['Long']>;
  priceValue?: InputMaybe<Scalars['Float']>;
};

export type SortInput = {
  orders: Array<OrderInput>;
};

export enum SourceType {
  Broadcast = 'Broadcast',
  Campaign = 'Campaign',
  Conversation = 'Conversation',
  Keyword = 'Keyword',
  Test = 'Test',
  Trigger = 'Trigger',
  TwilioVoice = 'TwilioVoice',
  WebForm = 'WebForm',
  Webhook = 'Webhook'
}

export type SpecificField = {
  __typename?: 'SpecificField';
  id?: Maybe<Scalars['Long']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type SpecificUrlClickStatistics = {
  __typename?: 'SpecificUrlClickStatistics';
  longUrl?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['Float']>;
  shortUrl?: Maybe<Scalars['String']>;
  totalVisits?: Maybe<Scalars['Long']>;
  totalVisitsToday?: Maybe<Scalars['Long']>;
};

export type SpecificUrlClickStatisticsInput = {
  longUrl?: InputMaybe<Scalars['String']>;
  percentage?: InputMaybe<Scalars['Float']>;
  shortUrl?: InputMaybe<Scalars['String']>;
  totalVisits?: InputMaybe<Scalars['Long']>;
  totalVisitsToday?: InputMaybe<Scalars['Long']>;
};

export type StandardField = {
  __typename?: 'StandardField';
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Maybe<StandardField>>>;
};

export enum Status {
  Active = 'Active',
  Answered = 'Answered',
  Archived = 'Archived',
  Callback = 'Callback',
  CallbackAttempt = 'CallbackAttempt',
  Canceled = 'Canceled',
  Completed = 'Completed',
  Confirmed = 'Confirmed',
  Created = 'Created',
  Declined = 'Declined',
  Deleted = 'Deleted',
  Delivered = 'Delivered',
  Disabled = 'Disabled',
  Draft = 'Draft',
  Failed = 'Failed',
  Finished = 'Finished',
  InProgress = 'InProgress',
  Inactive = 'Inactive',
  Invalid = 'Invalid',
  Missed = 'Missed',
  Paused = 'Paused',
  Pending = 'Pending',
  Processing = 'Processing',
  Queued = 'Queued',
  Received = 'Received',
  RetryProcessing = 'RetryProcessing',
  Running = 'Running',
  Scheduled = 'Scheduled',
  Sending = 'Sending',
  Sent = 'Sent',
  Subscribed = 'Subscribed',
  Success = 'Success',
  Transferred = 'Transferred',
  Trial = 'Trial',
  Undelivered = 'Undelivered',
  Unresolved = 'Unresolved',
  Unsubscribed = 'Unsubscribed',
  WithConversions = 'WithConversions'
}

export type StatusStatistics = {
  __typename?: 'StatusStatistics';
  callbackCount: Scalars['Long'];
  failedCount: Scalars['Long'];
  pendingCount: Scalars['Long'];
  successCount: Scalars['Long'];
  totalCount: Scalars['Long'];
  unsubscribedCount: Scalars['Long'];
};

export type StatusStatisticsInput = {
  callbackCount: Scalars['Long'];
  failedCount: Scalars['Long'];
  pendingCount: Scalars['Long'];
  successCount: Scalars['Long'];
  totalCount: Scalars['Long'];
  unsubscribedCount: Scalars['Long'];
};

export enum StockExchange {
  Amex = 'AMEX',
  Amx = 'AMX',
  Asx = 'ASX',
  B3 = 'B3',
  Bme = 'BME',
  Bse = 'BSE',
  Fra = 'FRA',
  Fwb = 'FWB',
  Hkex = 'HKEX',
  Icex = 'ICEX',
  Jpx = 'JPX',
  Jse = 'JSE',
  Krx = 'KRX',
  Lon = 'LON',
  Lse = 'LSE',
  Nasdaq = 'NASDAQ',
  Nse = 'NSE',
  Nyse = 'NYSE',
  None = 'None',
  Omx = 'OMX',
  Sse = 'SSE',
  Sto = 'STO',
  Swx = 'SWX',
  Szse = 'SZSE',
  Tmx = 'TMX',
  Tse = 'TSE',
  Tsx = 'TSX',
  Twse = 'TWSE',
  Vse = 'VSE'
}

export type SubscriptionChangeInputInput = {
  cancellationReason?: InputMaybe<CancellationReasonType>;
  comment?: InputMaybe<Scalars['String']>;
  downgradeReason?: InputMaybe<DowngradeReasonType>;
};

export type SwitchPhoneCheckerRequestInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  verifyExisting?: InputMaybe<Scalars['Boolean']>;
};

export enum SwitchPlanStrategyType {
  Downgrade = 'DOWNGRADE',
  EndTrial = 'END_TRIAL',
  ReDowngrade = 'RE_DOWNGRADE',
  ReOpen = 'RE_OPEN',
  Upgrade = 'UPGRADE'
}

export type TfBusinessInfoRequestInput = {
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  secondStreet?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type TtsExternalVoice = {
  __typename?: 'TTSExternalVoice';
  externalId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pollyId?: Maybe<Scalars['String']>;
  type?: Maybe<TtsType>;
};

export type TtsExternalVoiceInput = {
  externalId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pollyId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<TtsType>;
};

export type TtsMessageTemplate = {
  __typename?: 'TTSMessageTemplate';
  audioItem?: Maybe<AudioItem>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['Long']>;
  member?: Maybe<Member>;
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  pollyId?: Maybe<Scalars['String']>;
  provider?: Maybe<TtsProviderType>;
  ttsText?: Maybe<Scalars['String']>;
  type?: Maybe<TtsType>;
  updatedAt?: Maybe<Scalars['Date']>;
  voice?: Maybe<TtsExternalVoice>;
};

export type TtsMessageTemplateInput = {
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['Long']>;
  name?: InputMaybe<Scalars['String']>;
  pollyId?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<TtsProviderType>;
  ttsText?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<TtsType>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  voice?: InputMaybe<TtsExternalVoiceInput>;
};

export enum TtsProviderType {
  DropCowboy = 'DROP_COWBOY',
  Polly = 'POLLY'
}

export enum TtsType {
  Premium = 'PREMIUM',
  Standard = 'STANDARD'
}

export enum TenDlcBusinessType {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type TenDlcMessageSampleRequestInput = {
  firstMessage?: InputMaybe<Scalars['String']>;
  secondMessage?: InputMaybe<Scalars['String']>;
};

export type TenDlcOptInDescriptionRequestInput = {
  optInDescriptions?: InputMaybe<Scalars['Map_TenDlcOptInMethod_StringScalar']>;
};

export type TenDlcOptInImagesRequestInput = {
  optInImageIDs?: InputMaybe<Scalars['Map_TenDlcOptInMethod_LongArrayScalar']>;
};

export enum TenDlcOptInMethod {
  IncomingText = 'INCOMING_TEXT',
  OnlineForm = 'ONLINE_FORM',
  PaperForm = 'PAPER_FORM',
  QrCode = 'QR_CODE'
}

export type TenDlcOptInMethodRequestInput = {
  optInMethods?: InputMaybe<Array<InputMaybe<TenDlcOptInMethod>>>;
};

export enum TenDlcPackageType {
  LowVolumeStandard = 'LOW_VOLUME_STANDARD',
  SoleProprietor = 'SOLE_PROPRIETOR',
  Standard = 'STANDARD'
}

export type TenDlcProfile = {
  __typename?: 'TenDlcProfile';
  businessType?: Maybe<TenDlcBusinessType>;
  companyStockTicker?: Maybe<Scalars['String']>;
  currentStep?: Maybe<TenDlcProfileStep>;
  firstSampleMessage?: Maybe<Scalars['String']>;
  optInAssets?: Maybe<Scalars['Map_TenDlcOptInMethod_List_AssetScalar']>;
  optInDescriptions?: Maybe<Scalars['Map_TenDlcOptInMethod_StringScalar']>;
  optInImages?: Maybe<Scalars['Map_TenDlcOptInMethod_ImageIdContainerScalar']>;
  optInMethods?: Maybe<Array<Maybe<TenDlcOptInMethod>>>;
  packageType?: Maybe<TenDlcPackageType>;
  secondSampleMessage?: Maybe<Scalars['String']>;
  status?: Maybe<TenDlcProfileStatus>;
  stockExchange?: Maybe<StockExchange>;
  tenDlcUseCase?: Maybe<TenDlcUseCase>;
};

export enum TenDlcProfileStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  InReview = 'IN_REVIEW',
  Rejected = 'REJECTED'
}

export enum TenDlcProfileStep {
  InReview = 'IN_REVIEW',
  OptInDescription = 'OPT_IN_DESCRIPTION',
  OptInImages = 'OPT_IN_IMAGES',
  OptInMethod = 'OPT_IN_METHOD',
  Payment = 'PAYMENT',
  SampleMessages = 'SAMPLE_MESSAGES',
  SelectPackage = 'SELECT_PACKAGE',
  UseCase = 'USE_CASE'
}

export type TenDlcRegisterProfileResponse = {
  __typename?: 'TenDlcRegisterProfileResponse';
  profile?: Maybe<TenDlcProfile>;
};

export type TenDlcSelectPackageRequestInput = {
  businessType?: InputMaybe<TenDlcBusinessType>;
  companyStockTicker?: InputMaybe<Scalars['String']>;
  packageType?: InputMaybe<TenDlcPackageType>;
  stockExchange?: InputMaybe<StockExchange>;
};

export type TenDlcTypes = {
  __typename?: 'TenDlcTypes';
  businessTypes?: Maybe<Array<Maybe<TenDlcBusinessType>>>;
  optInMethods?: Maybe<Scalars['Map_TenDlcOptInMethod_StringScalar']>;
  packageTypes?: Maybe<Scalars['Map_TenDlcPackageType_TenDlcFeesScalar']>;
  statusMap?: Maybe<Scalars['Map_TenDlcProfileStatus_StringScalar']>;
  stockExchanges?: Maybe<Scalars['Map_StockExchange_StringScalar']>;
  useCaseTypes?: Maybe<Scalars['Map_TenDlcUseCaseType_StringScalar']>;
};

export type TenDlcUseCase = {
  __typename?: 'TenDlcUseCase';
  useCaseDescription?: Maybe<Scalars['String']>;
  useCaseType?: Maybe<TenDlcUseCaseType>;
};

export type TenDlcUseCaseInput = {
  useCaseDescription?: InputMaybe<Scalars['String']>;
  useCaseType?: InputMaybe<TenDlcUseCaseType>;
};

export type TenDlcUseCaseRequestInput = {
  useCase?: InputMaybe<TenDlcUseCaseInput>;
};

export enum TenDlcUseCaseType {
  AccountNotifications = 'ACCOUNT_NOTIFICATIONS',
  CharityNonprofit = 'CHARITY_NONPROFIT',
  CustomerCare = 'CUSTOMER_CARE',
  DeliveryNotifications = 'DELIVERY_NOTIFICATIONS',
  Events = 'EVENTS',
  HigherEducation = 'HIGHER_EDUCATION',
  K12 = 'K12',
  Marketing = 'MARKETING',
  PoliticalElectionCampaigns = 'POLITICAL_ELECTION_CAMPAIGNS',
  PollingAndVotingNonPolitical = 'POLLING_AND_VOTING_NON_POLITICAL',
  PublicServiceAnnouncement = 'PUBLIC_SERVICE_ANNOUNCEMENT',
  SecurityAlert = 'SECURITY_ALERT'
}

export type TestCallMessageRequestInput = {
  fromNumberId: Scalars['Long'];
  toNumber: Scalars['String'];
  voiceMessage?: InputMaybe<VoiceMessageInput>;
};

export type TestMessage = {
  __typename?: 'TestMessage';
  chargeAmount?: Maybe<Scalars['Float']>;
  chargeAttempted: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  dispatchUuid?: Maybe<Scalars['UUID']>;
  fromNumber?: Maybe<PhoneNumber>;
  fromNumberStr?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Long']>;
  mediaUrls?: Maybe<Array<Maybe<Scalars['String']>>>;
  member?: Maybe<Member>;
  messageSid?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  reason?: Maybe<Scalars['String']>;
  segmentsCount?: Maybe<Scalars['Int']>;
  status?: Maybe<Status>;
  text?: Maybe<Scalars['String']>;
  toNumber?: Maybe<Scalars['String']>;
  type?: Maybe<MessageType>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type TestMessageRequestInput = {
  fromNumberId: Scalars['Long'];
  smsMessage: SmsMessageRequestInput;
  toNumber: Scalars['String'];
};

export type TestRinglessMessageRequestInput = {
  audioId?: InputMaybe<Scalars['Long']>;
  callbackEnabled: Scalars['Boolean'];
  fromNumberId: Scalars['Long'];
  toNumber: Scalars['String'];
  ttsText?: InputMaybe<Scalars['String']>;
  voiceId?: InputMaybe<Scalars['String']>;
};

export type TextBlacklist = {
  __typename?: 'TextBlacklist';
  caseSensitive: Scalars['Boolean'];
  condition?: Maybe<BlacklistCondition>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['Long']>;
  message?: Maybe<Scalars['String']>;
  messageType?: Maybe<BlacklistMessageType>;
  organizationWhitelist?: Maybe<Array<Maybe<Scalars['Long']>>>;
  updatedAt?: Maybe<Scalars['Date']>;
  value?: Maybe<Scalars['String']>;
};

export enum TimeZoneType {
  Central = 'CENTRAL',
  Eastern = 'EASTERN',
  EastIndiana = 'EAST_INDIANA',
  Michigan = 'MICHIGAN',
  Mountain = 'MOUNTAIN',
  Pacific = 'PACIFIC'
}

export type TodayConversionStatistics = {
  __typename?: 'TodayConversionStatistics';
  percentage?: Maybe<Scalars['Float']>;
  revenue?: Maybe<Scalars['Float']>;
  roi?: Maybe<Scalars['Float']>;
  todayConversionStatistics?: Maybe<ConversionStatistics>;
  total?: Maybe<Scalars['Long']>;
  totalCosts?: Maybe<Scalars['Float']>;
};

export type TollFreeBusinessInfo = {
  __typename?: 'TollFreeBusinessInfo';
  address?: Maybe<SecondStreetAddress>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['Long']>;
  name?: Maybe<Scalars['String']>;
  tollFreeProfile?: Maybe<TollFreeVerificationProfile>;
  updatedAt?: Maybe<Scalars['Date']>;
  website?: Maybe<Scalars['String']>;
};

export type TollFreeContactInfo = {
  __typename?: 'TollFreeContactInfo';
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formattedPhoneNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Long']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  tollFreeProfile?: Maybe<TollFreeVerificationProfile>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export enum TollFreeVerificationMessageAmount {
  FiveHundredThousand = 'FIVE_HUNDRED_THOUSAND',
  FiveMillion = 'FIVE_MILLION',
  HundredThousand = 'HUNDRED_THOUSAND',
  OneHundred = 'ONE_HUNDRED',
  OneMillion = 'ONE_MILLION',
  OneThousand = 'ONE_THOUSAND',
  SevenHundredFiftyThousand = 'SEVEN_HUNDRED_FIFTY_THOUSAND',
  TenMillionPlus = 'TEN_MILLION_PLUS',
  TenThousand = 'TEN_THOUSAND',
  TwoHundredFiftyThousand = 'TWO_HUNDRED_FIFTY_THOUSAND'
}

export enum TollFreeVerificationOptInMethod {
  IncomingText = 'INCOMING_TEXT',
  OnlineForm = 'ONLINE_FORM',
  PaperForm = 'PAPER_FORM',
  QrCode = 'QR_CODE'
}

export type TollFreeVerificationOptInMethodRequestInput = {
  imageId?: InputMaybe<Scalars['Long']>;
  optInMethod?: InputMaybe<TollFreeVerificationOptInMethod>;
};

export type TollFreeVerificationProfile = {
  __typename?: 'TollFreeVerificationProfile';
  assetId?: Maybe<Scalars['Long']>;
  businessInfo?: Maybe<TollFreeBusinessInfo>;
  contactInfo?: Maybe<TollFreeContactInfo>;
  createdAt?: Maybe<Scalars['Date']>;
  currentStep?: Maybe<TollFreeVerificationStep>;
  deletedAt?: Maybe<Scalars['Date']>;
  firstSampleMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Long']>;
  isNotResubmitable?: Maybe<Scalars['Boolean']>;
  member?: Maybe<Member>;
  messageAmount?: Maybe<TollFreeVerificationMessageAmount>;
  optInAsset?: Maybe<Asset>;
  optInMethod?: Maybe<TollFreeVerificationOptInMethod>;
  organization?: Maybe<Organization>;
  phoneNumberIds?: Maybe<Array<Maybe<Scalars['Long']>>>;
  phoneNumbers?: Maybe<Array<Maybe<PhoneNumber>>>;
  reasonOfMultipleNumbers?: Maybe<Scalars['String']>;
  secondSampleMessage?: Maybe<Scalars['String']>;
  status?: Maybe<TollFreeVerificationStatus>;
  tollFreeVerificationSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  useCase?: Maybe<TollFreeVerificationUseCase>;
  useCaseName?: Maybe<Scalars['String']>;
  verificationErrorDescription?: Maybe<Scalars['String']>;
  verificationRejectedDate?: Maybe<Scalars['Date']>;
  verificationResponse?: Maybe<TwilioCodeMapping>;
};

export type TollFreeVerificationProfileTypes = {
  __typename?: 'TollFreeVerificationProfileTypes';
  messageAmountMapping?: Maybe<Scalars['Map_TollFreeVerificationMessageAmount_StringScalar']>;
  optInMethodMapping?: Maybe<Scalars['Map_TollFreeVerificationOptInMethod_TollFreeOptInMetadataScalar']>;
  tollFreeVerificationStatusMapping?: Maybe<Scalars['Map_TollFreeVerificationStatus_StringScalar']>;
  useCaseMapping?: Maybe<Scalars['Map_TollFreeVerificationUseCaseType_StringScalar']>;
  verificationStatusMapping?: Maybe<Scalars['Map_VerificationStatus_StringScalar']>;
};

export type TollFreeVerificationRequestInput = {
  numberIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  reasonOfMultipleNumbers?: InputMaybe<Scalars['String']>;
};

export enum TollFreeVerificationStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  InReview = 'IN_REVIEW',
  PendingReview = 'PENDING_REVIEW',
  Rejected = 'REJECTED',
  ReviewRequired = 'REVIEW_REQUIRED'
}

export type TollFreeVerificationStatusItem = {
  __typename?: 'TollFreeVerificationStatusItem';
  errorCode?: Maybe<Scalars['ObjectScalar']>;
  rejectionReason?: Maybe<Scalars['ObjectScalar']>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tollfreePhoneNumberSid?: Maybe<Scalars['String']>;
};

export type TollFreeVerificationStatusResponse = {
  __typename?: 'TollFreeVerificationStatusResponse';
  verifications?: Maybe<Array<Maybe<TollFreeVerificationStatusItem>>>;
};

export enum TollFreeVerificationStep {
  BusinessInfo = 'BUSINESS_INFO',
  ContactInfo = 'CONTACT_INFO',
  Numbers = 'NUMBERS',
  OptInMethod = 'OPT_IN_METHOD',
  Terms = 'TERMS',
  UseCase = 'USE_CASE'
}

export type TollFreeVerificationUseCase = {
  __typename?: 'TollFreeVerificationUseCase';
  useCaseDescription?: Maybe<Scalars['String']>;
  useCaseType?: Maybe<TollFreeVerificationUseCaseType>;
};

export type TollFreeVerificationUseCaseRequestInput = {
  description?: InputMaybe<Scalars['String']>;
  messageAmount?: InputMaybe<TollFreeVerificationMessageAmount>;
  sampleMessage?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<TollFreeVerificationUseCaseType>;
};

export enum TollFreeVerificationUseCaseType {
  AccountNotifications = 'ACCOUNT_NOTIFICATIONS',
  CharityNonprofit = 'CHARITY_NONPROFIT',
  CustomerCare = 'CUSTOMER_CARE',
  DeliveryNotifications = 'DELIVERY_NOTIFICATIONS',
  Events = 'EVENTS',
  HigherEducation = 'HIGHER_EDUCATION',
  K12 = 'K12',
  Marketing = 'MARKETING',
  PoliticalElectionCampaigns = 'POLITICAL_ELECTION_CAMPAIGNS',
  PollingAndVotingNonPolitical = 'POLLING_AND_VOTING_NON_POLITICAL',
  PublicServiceAnnouncement = 'PUBLIC_SERVICE_ANNOUNCEMENT'
}

export type TotalMessageStatistics = {
  __typename?: 'TotalMessageStatistics';
  percentage?: Maybe<Scalars['Float']>;
  today?: Maybe<Scalars['Long']>;
  total?: Maybe<Scalars['Long']>;
};

export type Trigger = {
  __typename?: 'Trigger';
  app?: Maybe<AccountIntegrationType>;
  appPhoneField?: Maybe<Scalars['String']>;
  assetIds?: Maybe<Array<Maybe<Scalars['Long']>>>;
  cardIds?: Maybe<Array<Maybe<Scalars['Long']>>>;
  conversion?: Maybe<Conversion>;
  conversionStatistics?: Maybe<ConversionSourceStatistics>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['Long']>;
  link?: Maybe<Scalars['String']>;
  listIds?: Maybe<Array<Maybe<Scalars['Long']>>>;
  member?: Maybe<Member>;
  messagesStat?: Maybe<StatusStatistics>;
  migratedAt?: Maybe<Scalars['Date']>;
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  ringlessMessage?: Maybe<RinglessMessage>;
  sendFromCompany?: Maybe<Scalars['String']>;
  sendFromPhoneNumber?: Maybe<PhoneNumber>;
  shortUrlClickStatistics?: Maybe<ShortUrlClickStatistics>;
  smsMessage?: Maybe<SmsMessage>;
  sourceType?: Maybe<SourceType>;
  status: Status;
  triggerLists?: Maybe<Array<Maybe<ListTrigger>>>;
  type?: Maybe<ContentType>;
  updatedAt?: Maybe<Scalars['Date']>;
  uuid?: Maybe<Scalars['UUID']>;
  voiceMessage?: Maybe<VoiceMessage>;
  voiceTransferCount?: Maybe<Scalars['Long']>;
};

export type TriggerInput = {
  app?: InputMaybe<AccountIntegrationType>;
  appPhoneField?: InputMaybe<Scalars['String']>;
  conversion?: InputMaybe<ConversionInput>;
  conversionStatistics?: InputMaybe<ConversionSourceStatisticsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['Long']>;
  link?: InputMaybe<Scalars['String']>;
  listIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  member?: InputMaybe<MemberInput>;
  messagesStat?: InputMaybe<StatusStatisticsInput>;
  migratedAt?: InputMaybe<Scalars['Date']>;
  name: Scalars['String'];
  organization?: InputMaybe<OrganizationInput>;
  ringlessMessage?: InputMaybe<RinglessMessageInput>;
  sendFromCompany?: InputMaybe<Scalars['String']>;
  sendFromPhoneNumber?: InputMaybe<PhoneNumberInput>;
  shortUrlClickStatistics?: InputMaybe<ShortUrlClickStatisticsInput>;
  smsMessage?: InputMaybe<SmsMessageInput>;
  status: Status;
  updatedAt?: InputMaybe<Scalars['Date']>;
  uuid?: InputMaybe<Scalars['UUID']>;
  voiceMessage?: InputMaybe<VoiceMessageInput>;
  voiceTransferCount?: InputMaybe<Scalars['Long']>;
};

export type TriggerUsageSource = {
  __typename?: 'TriggerUsageSource';
  app?: Maybe<AccountIntegrationType>;
  id?: Maybe<Scalars['Long']>;
  name?: Maybe<Scalars['String']>;
};

export type TriggerUsageSourceInput = {
  app?: InputMaybe<AccountIntegrationType>;
  id?: InputMaybe<Scalars['Long']>;
  name?: InputMaybe<Scalars['String']>;
};

export type TwPhoneNumber = {
  __typename?: 'TwPhoneNumber';
  capabilities?: Maybe<Capabilities>;
  emergencyStatus?: Maybe<Status>;
  friendlyName?: Maybe<Scalars['String']>;
  isoCountry?: Maybe<Scalars['String']>;
  locality?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  sid?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  statusCallback?: Maybe<Scalars['String']>;
  voiceUrl?: Maybe<Scalars['String']>;
};

export type TwilioCodeMapping = {
  __typename?: 'TwilioCodeMapping';
  causes?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  solutions?: Maybe<Scalars['String']>;
};

export type TypeAwareAction = {
  __typename?: 'TypeAwareAction';
  type?: Maybe<WorkflowActionType>;
};

export type UiNextPlan = {
  __typename?: 'UINextPlan';
  price?: Maybe<SimplePrice>;
  startDate?: Maybe<Scalars['Instant']>;
};

export type UnvalidatedContact = {
  __typename?: 'UnvalidatedContact';
  createdAt?: Maybe<Scalars['Date']>;
  customValues?: Maybe<Array<Maybe<Scalars['String']>>>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Long']>;
  importStateId?: Maybe<Scalars['Long']>;
  invalidReason?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  memberId?: Maybe<Scalars['Long']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Long']>;
  phoneNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Status>;
};

export type UnvalidatedContactPage = {
  __typename?: 'UnvalidatedContactPage';
  content?: Maybe<Array<Maybe<UnvalidatedContact>>>;
  importState?: Maybe<ContactImportState>;
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Long'];
};

export type UpdateAudioItemRequestInput = {
  id?: InputMaybe<Scalars['Long']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateConversionRequestInput = {
  defaultAmount?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['Long']>;
  name: Scalars['String'];
  uniqueHit: Scalars['Boolean'];
  urlPatterns?: InputMaybe<Array<InputMaybe<ConversionUrlMatchConfigInput>>>;
};

export type UpdateMemberRestrictionsRequestInput = {
  accessType?: InputMaybe<InvitationAccessType>;
  listIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  role: InvitationRole;
};

export type UpdateMessageTemplateRequestInput = {
  id?: InputMaybe<Scalars['Long']>;
  name?: InputMaybe<Scalars['String']>;
  smsMessage?: InputMaybe<SmsMessageInput>;
};

export type UpdateOrganizationStatusRequestInput = {
  organizationId?: InputMaybe<Scalars['Long']>;
};

export type UpdateOrganizationStatusResponse = {
  __typename?: 'UpdateOrganizationStatusResponse';
  organizationId?: Maybe<Scalars['Long']>;
  status?: Maybe<OrganizationStatus>;
};

export type UpdatePhoneNumbersRequestInput = {
  callForwardEnabled: Scalars['Boolean'];
  destinationExtension?: InputMaybe<Scalars['Int']>;
  destinationPhoneNumber?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
};

export type UpdateSegmentRequestInput = {
  filterValue?: InputMaybe<FilterValueInput>;
  id?: InputMaybe<Scalars['Long']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdatedSubscription = {
  __typename?: 'UpdatedSubscription';
  balances?: Maybe<Balances>;
  subscription?: Maybe<ClSubscription>;
  switchPlanStrategyType?: Maybe<SwitchPlanStrategyType>;
};

export type UserInfoResponse = {
  __typename?: 'UserInfoResponse';
  email?: Maybe<Scalars['String']>;
  hasOrganization: Scalars['Boolean'];
  id?: Maybe<Scalars['Long']>;
  integrationOrgDetails?: Maybe<Organization>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  token?: Maybe<Scalars['String']>;
};

export type UserTimeZone = {
  __typename?: 'UserTimeZone';
  fullName?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
  zoneAbbreviation?: Maybe<Scalars['String']>;
  zoneId?: Maybe<Scalars['String']>;
};

export enum VerificationStatus {
  Blocked = 'BLOCKED',
  InReview = 'IN_REVIEW',
  Pending = 'PENDING',
  Restricted = 'RESTRICTED',
  Unverified = 'UNVERIFIED',
  Verified = 'VERIFIED'
}

export type VoiceMail = {
  __typename?: 'VoiceMail';
  audioId?: Maybe<Scalars['Long']>;
  externalAudioId?: Maybe<Scalars['Long']>;
  voiceMail?: Maybe<AudioItem>;
  voiceMailEnabled?: Maybe<Scalars['Boolean']>;
};

export type VoiceMailInput = {
  audioId?: InputMaybe<Scalars['Long']>;
  voiceMail?: InputMaybe<AudioItemInput>;
  voiceMailEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type VoiceMessage = {
  __typename?: 'VoiceMessage';
  liveAnswer?: Maybe<LiveAnswer>;
  voiceMail?: Maybe<VoiceMail>;
};

export type VoiceMessageInput = {
  liveAnswer?: InputMaybe<LiveAnswerInput>;
  voiceMail?: InputMaybe<VoiceMailInput>;
};

export enum VoiceMessageProviderType {
  CallFire = 'CALL_FIRE',
  Telnyx = 'TELNYX'
}

export type WebForm = {
  __typename?: 'WebForm';
  assetIds?: Maybe<Array<Maybe<Scalars['Long']>>>;
  cardIds?: Maybe<Array<Maybe<Scalars['Long']>>>;
  compliance?: Maybe<Scalars['Boolean']>;
  complianceMessage?: Maybe<Scalars['String']>;
  complianceUrl?: Maybe<Scalars['String']>;
  contactStatusStatistics?: Maybe<ContactStatusStatistics>;
  contactsLists?: Maybe<Array<Maybe<WebFormListContact>>>;
  contactsListsIds?: Maybe<Array<Maybe<Scalars['Long']>>>;
  conversion?: Maybe<Conversion>;
  conversionStatistics?: Maybe<ConversionSourceStatistics>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  doubleOptIn?: Maybe<Scalars['Boolean']>;
  doubleOptInMessage?: Maybe<Scalars['String']>;
  fieldsRequest: Array<Maybe<WebFormFieldRequest>>;
  fieldsToCollect?: Maybe<Array<Maybe<WebFormCustomField>>>;
  id?: Maybe<Scalars['Long']>;
  member?: Maybe<Member>;
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  ringlessMessage?: Maybe<RinglessMessage>;
  sendFromPhoneNumber?: Maybe<PhoneNumber>;
  shortUrlClickStatistics?: Maybe<ShortUrlClickStatistics>;
  smsMessage?: Maybe<SmsMessage>;
  sourceType?: Maybe<SourceType>;
  status?: Maybe<Status>;
  subscribeBtnText?: Maybe<Scalars['String']>;
  termsUrl?: Maybe<Scalars['String']>;
  thankYouPage?: Maybe<Scalars['String']>;
  type?: Maybe<ContentType>;
  updatedAt?: Maybe<Scalars['Date']>;
  uuid?: Maybe<Scalars['UUID']>;
  voiceMessage?: Maybe<VoiceMessage>;
  voiceTransferCount?: Maybe<Scalars['Long']>;
  webFormConfig?: Maybe<Scalars['String']>;
};

export type WebFormCustomField = {
  __typename?: 'WebFormCustomField';
  displayIndex?: Maybe<Scalars['Int']>;
  field?: Maybe<CustomField>;
  required?: Maybe<Scalars['Boolean']>;
  webForm?: Maybe<WebForm>;
  webFormFieldId?: Maybe<WebFormFieldId>;
};

export type WebFormFieldId = {
  __typename?: 'WebFormFieldId';
  fieldId?: Maybe<Scalars['Long']>;
  webFormId?: Maybe<Scalars['Long']>;
};

export type WebFormFieldRequest = {
  __typename?: 'WebFormFieldRequest';
  key?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
};

export type WebFormFieldRequestInput = {
  key?: InputMaybe<Scalars['String']>;
  required?: InputMaybe<Scalars['Boolean']>;
};

export type WebFormForm = {
  __typename?: 'WebFormForm';
  id?: Maybe<Scalars['Long']>;
  name?: Maybe<Scalars['String']>;
};

export type WebFormInput = {
  compliance?: InputMaybe<Scalars['Boolean']>;
  complianceMessage?: InputMaybe<Scalars['String']>;
  complianceUrl?: InputMaybe<Scalars['String']>;
  contactStatusStatistics?: InputMaybe<ContactStatusStatisticsInput>;
  contactsListsIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  conversion?: InputMaybe<ConversionInput>;
  conversionStatistics?: InputMaybe<ConversionSourceStatisticsInput>;
  createdAt?: InputMaybe<Scalars['Date']>;
  deletedAt?: InputMaybe<Scalars['Date']>;
  doubleOptIn?: InputMaybe<Scalars['Boolean']>;
  doubleOptInMessage?: InputMaybe<Scalars['String']>;
  fieldsRequest: Array<InputMaybe<WebFormFieldRequestInput>>;
  id?: InputMaybe<Scalars['Long']>;
  member?: InputMaybe<MemberInput>;
  name: Scalars['String'];
  organization?: InputMaybe<OrganizationInput>;
  ringlessMessage?: InputMaybe<RinglessMessageInput>;
  sendFromPhoneNumber?: InputMaybe<PhoneNumberInput>;
  shortUrlClickStatistics?: InputMaybe<ShortUrlClickStatisticsInput>;
  smsMessage?: InputMaybe<SmsMessageInput>;
  status?: InputMaybe<Status>;
  subscribeBtnText?: InputMaybe<Scalars['String']>;
  termsUrl?: InputMaybe<Scalars['String']>;
  thankYouPage?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Date']>;
  uuid?: InputMaybe<Scalars['UUID']>;
  voiceMessage?: InputMaybe<VoiceMessageInput>;
  voiceTransferCount?: InputMaybe<Scalars['Long']>;
  webFormConfig?: InputMaybe<Scalars['String']>;
};

export type WebFormListContact = {
  __typename?: 'WebFormListContact';
  listing?: Maybe<Listing>;
  webForm?: Maybe<WebForm>;
};

export type WorkflowActionContainer = {
  __typename?: 'WorkflowActionContainer';
  actionDoNothing?: Maybe<WorkflowActionDoNothing>;
  actionIfElse?: Maybe<WorkflowActionIfElse>;
  actionSendMessage?: Maybe<WorkflowActionSendMessage>;
  actionStopWorkflow?: Maybe<WorkflowActionStopWorkflow>;
  actionUpdateContact?: Maybe<WorkflowActionUpdateContact>;
  actionWaitResponse?: Maybe<WorkflowActionWaitResponse>;
};

export type WorkflowActionDoNothing = {
  __typename?: 'WorkflowActionDoNothing';
  type?: Maybe<WorkflowActionType>;
};

export type WorkflowActionIfElse = {
  __typename?: 'WorkflowActionIfElse';
  elseActions?: Maybe<Array<Maybe<TypeAwareAction>>>;
  ifActions?: Maybe<Array<Maybe<TypeAwareAction>>>;
  type?: Maybe<WorkflowActionType>;
};

export type WorkflowActionRequest = {
  __typename?: 'WorkflowActionRequest';
  groupNumber: Scalars['Int'];
  properties?: Maybe<Scalars['Map_String_ObjectScalar']>;
  type?: Maybe<WorkflowActionType>;
};

export type WorkflowActionRequestInput = {
  groupNumber: Scalars['Int'];
  properties?: InputMaybe<Scalars['Map_String_ObjectScalar']>;
  type?: InputMaybe<WorkflowActionType>;
};

export type WorkflowActionSendMessage = {
  __typename?: 'WorkflowActionSendMessage';
  messageConfig?: Maybe<WorkflowSmsConfig>;
  messageType?: Maybe<ContentType>;
  type?: Maybe<WorkflowActionType>;
};

export type WorkflowActionStopWorkflow = {
  __typename?: 'WorkflowActionStopWorkflow';
  type?: Maybe<WorkflowActionType>;
};

export enum WorkflowActionType {
  DoNothing = 'DO_NOTHING',
  IfElse = 'IF_ELSE',
  SendMessage = 'SEND_MESSAGE',
  StopWorkflow = 'STOP_WORKFLOW',
  UpdateContact = 'UPDATE_CONTACT',
  WaitResponse = 'WAIT_RESPONSE'
}

export type WorkflowActionUpdateContact = {
  __typename?: 'WorkflowActionUpdateContact';
  fieldName?: Maybe<Scalars['String']>;
  type?: Maybe<WorkflowActionType>;
};

export type WorkflowActionWaitResponse = {
  __typename?: 'WorkflowActionWaitResponse';
  hours: Scalars['Int'];
  type?: Maybe<WorkflowActionType>;
};

export type WorkflowRequest = {
  __typename?: 'WorkflowRequest';
  actions?: Maybe<Array<Maybe<WorkflowActionRequest>>>;
};

export type WorkflowRequestInput = {
  actions?: InputMaybe<Array<InputMaybe<WorkflowActionRequestInput>>>;
};

export type WorkflowSmsConfig = {
  __typename?: 'WorkflowSmsConfig';
  assetIds?: Maybe<Array<Maybe<Scalars['Long']>>>;
  assets?: Maybe<Array<Maybe<AssetLight>>>;
  audioIds?: Maybe<Array<Maybe<Scalars['Long']>>>;
  audios?: Maybe<Array<Maybe<AudioItemLight>>>;
  cardIds?: Maybe<Array<Maybe<Scalars['Long']>>>;
  compliance: Scalars['Boolean'];
  complianceText?: Maybe<Scalars['String']>;
  contactCards?: Maybe<Array<Maybe<ContactCardLight>>>;
  text?: Maybe<Scalars['String']>;
};

export type WorkflowSmsConfigInput = {
  assetIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  audioIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  cardIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  compliance: Scalars['Boolean'];
  complianceText?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type AssetFragmentFragment = { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null };

export type GetAssetsQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
}>;


export type GetAssetsQuery = { __typename?: 'Query', getMyAssets?: { __typename?: 'PageResponse_Asset', total: any, pageSize: number, pageNumber: number, content?: Array<{ __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null> | null } | null };

export type RemoveAssetsMutationVariables = Exact<{
  assetIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>> | InputMaybe<Scalars['Long']>>;
}>;


export type RemoveAssetsMutation = { __typename?: 'Mutation', removeAssets?: string | null };

export type GetMainInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMainInfoQuery = { __typename?: 'Query', getSubscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null, getOrganizationBillingInfo?: { __typename?: 'OrgBillingInfo', stripeCustomerId?: string | null, cancelAccountAt?: any | null, autoRechargeThreshold?: AutoRechargeThreshold | null, autoRecharge?: boolean | null, autoRechargeCreditsAmount?: number | null, status?: Status | null, primaryPaymentMethod?: string | null } | null, getMember?: { __typename?: 'MemberResponse', registrationFinished: boolean, name?: string | null, displayRole?: string | null, displayState?: string | null, isAdmin?: boolean | null, accessType?: InvitationAccessType | null, listIds?: Array<any | null> | null, invitationLink?: string | null, deletedAt?: any | null, updatedAt?: any | null, createdAt?: any | null, phone?: string | null, internationalPhone?: string | null, email?: string | null, role?: MemberRole | null, lastName?: string | null, firstName?: string | null, id?: any | null, state?: MemberState | null, memberHash?: string | null, uniqueId?: string | null, memberRegistration?: { __typename?: 'MemberRegistration', type?: MemberRegistrationType | null, oldCredits?: number | null, currentStep?: number | null, migratedEmail?: string | null, selectedPriceId?: string | null, migrationFinished: boolean, oldCreditsForPurchase: number, oldCreditsFree: number, oldCreditsLastYear: number, saveCredits: boolean, oldSubscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null } | null, organization?: { __typename?: 'Organization', id?: any | null, uuid?: any | null, updatedAt?: any | null, migrationStatus?: Status | null, createdAt?: any | null, companyName?: string | null, employees?: string | null, website?: string | null, formattedPhoneNumber?: string | null, phoneCountryCode?: string | null, status?: OrganizationStatus | null, phoneCheckerEnabled: boolean, allowImport: boolean, termsUrl?: string | null, complianceUrl?: string | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, recordingPin?: any | null, carrierFeePaymentFailed: boolean, contract: boolean, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null, userTimeZone?: { __typename?: 'UserTimeZone', fullName?: string | null, offset?: string | null, shortName?: string | null, zoneAbbreviation?: string | null, zoneId?: string | null } | null, invitationBid?: { __typename?: 'InvitationBid', role?: InvitationRole | null, expirationDate?: any | null, email?: string | null, uuid?: any | null, id?: any | null, listIds?: Array<any | null> | null } | null } | null };

export type GetActiveContactsCountQueryVariables = Exact<{
  input?: InputMaybe<BroadcastInput>;
}>;


export type GetActiveContactsCountQuery = { __typename?: 'Query', getActiveContactsCount: number };

export type GetDataForSmsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDataForSmsQuery = { __typename?: 'Query', getMyContactCards?: Array<{ __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null> | null, getCustomFields?: Array<{ __typename?: 'CustomField', createdAt?: any | null, type?: CustomFieldType | null, id?: any | null, name?: string | null, displayIndex?: number | null, key?: string | null, used?: boolean | null } | null> | null };

export type GetConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConfigurationQuery = { __typename?: 'Query', getConfiguration?: { __typename?: 'ApplicationConfiguration', twilioCallRecordingNumber?: string | null, shortUrlDomains?: Array<string | null> | null, defaultChargeObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', chargeObject?: ChargeObject | null, creditPrice?: any | null } | null> | null } | null };

export type SendTestCallMessageMutationVariables = Exact<{
  testMessageInput?: InputMaybe<TestCallMessageRequestInput>;
}>;


export type SendTestCallMessageMutation = { __typename?: 'Mutation', sendTestCallMessage?: { __typename?: 'MessageVoice', id?: any | null, state?: { __typename?: 'MessageState', status?: Status | null } | null } | null };

export type SendTestRinglessMessageMutationVariables = Exact<{
  testMessageInput?: InputMaybe<TestRinglessMessageRequestInput>;
}>;


export type SendTestRinglessMessageMutation = { __typename?: 'Mutation', sendTestRinglessMessage?: { __typename?: 'MessageRingless', id?: any | null, state?: { __typename?: 'MessageState', status?: Status | null } | null } | null };

export type StatusStatisticsFragmentFragment = { __typename?: 'StatusStatistics', callbackCount: any, successCount: any, pendingCount: any, failedCount: any, totalCount: any, unsubscribedCount: any };

export type ShortUrlClickStatisticsFragmentFragment = { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null };

export type ConversionStatisticsFragment = { __typename?: 'TodayConversionStatistics', revenue?: number | null, roi?: number | null, totalCosts?: number | null, total?: any | null, percentage?: number | null, todayConversionStatistics?: { __typename?: 'ConversionStatistics', percentage?: number | null, revenue?: number | null, totalCosts?: number | null, roi?: number | null, total?: any | null } | null };

export type MessageStatisticsResponseFragmentFragment = { __typename?: 'MessageStatisticsResponse', shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, percentageStatistics?: { __typename?: 'PercentageStatistics', callbackPercentage: number, failedPercentage: number, pendingPercentage: number, successPercentage: number, unsubscribedPercentage: number } | null, todayStatistics?: { __typename?: 'StatusStatistics', callbackCount: any, successCount: any, pendingCount: any, failedCount: any, totalCount: any, unsubscribedCount: any } | null, totalStatistics?: { __typename?: 'StatusStatistics', callbackCount: any, successCount: any, pendingCount: any, failedCount: any, totalCount: any, unsubscribedCount: any } | null, chargeStatistics?: { __typename?: 'ChargeStatistics', totalCharged?: number | null } | null, voiceTransferMessageStatistics?: { __typename?: 'TotalMessageStatistics', total?: any | null, percentage?: number | null, today?: any | null } | null, conversionStatistics?: { __typename?: 'TodayConversionStatistics', revenue?: number | null, roi?: number | null, totalCosts?: number | null, total?: any | null, percentage?: number | null, todayConversionStatistics?: { __typename?: 'ConversionStatistics', percentage?: number | null, revenue?: number | null, totalCosts?: number | null, roi?: number | null, total?: any | null } | null } | null };

export type MessageFragmentFragment = { __typename?: 'MessageDataResponse', id?: any | null, totalShortUrl?: any | null, uniqueClicks?: any | null, type?: MessageType | null, duration?: number | null, extStatus?: string | null, extStatusLabel?: string | null, extStatusDescription?: string | null, state?: { __typename?: 'MessageStateResponse', boundType?: BoundType | null, simpleStatus?: Status | null, timeToSend?: any | null, contactName?: string | null, toNumber?: string | null, reason?: string | null, failReasonType?: FailReasonType | null, status?: Status | null, contactId?: any | null } | null };

export type PageResponse_MessageFragmentFragment = { __typename?: 'PageResponse_MessageDataResponse', total: any, pageSize: number, pageNumber: number, content?: Array<{ __typename?: 'MessageDataResponse', id?: any | null, totalShortUrl?: any | null, uniqueClicks?: any | null, type?: MessageType | null, duration?: number | null, extStatus?: string | null, extStatusLabel?: string | null, extStatusDescription?: string | null, state?: { __typename?: 'MessageStateResponse', boundType?: BoundType | null, simpleStatus?: Status | null, timeToSend?: any | null, contactName?: string | null, toNumber?: string | null, reason?: string | null, failReasonType?: FailReasonType | null, status?: Status | null, contactId?: any | null } | null } | null> | null };

export type LiveAnswerFragmentFragment = { __typename?: 'LiveAnswer', audioId?: any | null, liveAnswerEnabled?: boolean | null, transferCallEnabled?: boolean | null, transferCallNumber?: string | null, unsubscribeDigit?: number | null, transferCallDigit?: number | null, liveAnswer?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null };

export type VoiceMailFragmentFragment = { __typename?: 'VoiceMail', audioId?: any | null, voiceMailEnabled?: boolean | null, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null };

export type VoiceMessageDetailsFragment = { __typename?: 'VoiceMessage', liveAnswer?: { __typename?: 'LiveAnswer', audioId?: any | null, liveAnswerEnabled?: boolean | null, transferCallEnabled?: boolean | null, transferCallNumber?: string | null, unsubscribeDigit?: number | null, transferCallDigit?: number | null, liveAnswer?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, voiceMail?: { __typename?: 'VoiceMail', audioId?: any | null, voiceMailEnabled?: boolean | null, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null };

export type SmsMessageDetailsFragment = { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null };

export type RinglessMessageDetailsFragment = { __typename?: 'RinglessMessage', callbackEnabled: boolean, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null };

export type CapabilitiesFragmentFragment = { __typename?: 'Capabilities', mms?: boolean | null, sms?: boolean | null, voice?: boolean | null };

export type TwPhoneNumberFragmentFragment = { __typename?: 'TwPhoneNumber', status?: string | null, phoneNumber?: string | null, friendlyName?: string | null, capabilities?: { __typename?: 'Capabilities', mms?: boolean | null, sms?: boolean | null, voice?: boolean | null } | null };

export type AssetLightFragment = { __typename?: 'AssetLight', id?: any | null, size?: any | null, originalFileName?: string | null, sourceUrl?: string | null, sourceSize: any, contentType?: string | null };

export type AudioItemLightFragment = { __typename?: 'AudioItemLight', size?: any | null, url?: string | null, type?: AudioType | null, duration: number, fileKey?: string | null };

export type ContactCardLightFragment = { __typename?: 'ContactCardLight', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null };

export type WorkflowSmsConfigFragment = { __typename?: 'WorkflowSmsConfig', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, assets?: Array<{ __typename?: 'AssetLight', id?: any | null, size?: any | null, originalFileName?: string | null, sourceUrl?: string | null, sourceSize: any, contentType?: string | null } | null> | null, audios?: Array<{ __typename?: 'AudioItemLight', size?: any | null, url?: string | null, type?: AudioType | null, duration: number, fileKey?: string | null } | null> | null, contactCards?: Array<{ __typename?: 'ContactCardLight', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null> | null };

export type FieldCaptureFragment = { __typename?: 'FieldCapture', fieldName?: string | null, index: number, smsConfig?: { __typename?: 'WorkflowSmsConfig', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, assets?: Array<{ __typename?: 'AssetLight', id?: any | null, size?: any | null, originalFileName?: string | null, sourceUrl?: string | null, sourceSize: any, contentType?: string | null } | null> | null, audios?: Array<{ __typename?: 'AudioItemLight', size?: any | null, url?: string | null, type?: AudioType | null, duration: number, fileKey?: string | null } | null> | null, contactCards?: Array<{ __typename?: 'ContactCardLight', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null> | null } | null };

export type DataCaptureConfigFragment = { __typename?: 'DataCaptureConfig', retriesCount: number, lastReplyConfig?: { __typename?: 'WorkflowSmsConfig', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, assets?: Array<{ __typename?: 'AssetLight', id?: any | null, size?: any | null, originalFileName?: string | null, sourceUrl?: string | null, sourceSize: any, contentType?: string | null } | null> | null, audios?: Array<{ __typename?: 'AudioItemLight', size?: any | null, url?: string | null, type?: AudioType | null, duration: number, fileKey?: string | null } | null> | null, contactCards?: Array<{ __typename?: 'ContactCardLight', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null> | null } | null, fieldCaptures?: Array<{ __typename?: 'FieldCapture', fieldName?: string | null, index: number, smsConfig?: { __typename?: 'WorkflowSmsConfig', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, assets?: Array<{ __typename?: 'AssetLight', id?: any | null, size?: any | null, originalFileName?: string | null, sourceUrl?: string | null, sourceSize: any, contentType?: string | null } | null> | null, audios?: Array<{ __typename?: 'AudioItemLight', size?: any | null, url?: string | null, type?: AudioType | null, duration: number, fileKey?: string | null } | null> | null, contactCards?: Array<{ __typename?: 'ContactCardLight', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null> | null } | null } | null> | null };

export type GetAllBroadcastsQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
}>;


export type GetAllBroadcastsQuery = { __typename?: 'Query', getAllBroadcasts?: { __typename?: 'PageResponse_BroadcastResponse', total: any, pageSize: number, pageNumber: number, content?: Array<{ __typename?: 'BroadcastResponse', id?: any | null, uuid?: any | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, finished?: boolean | null, simplifiedStatus?: Status | null, sendTime?: any | null, updatedAt?: any | null, createdAt?: any | null, sendFromCompany?: string | null, name?: string | null, type?: ContentType | null, status?: Status | null, listCount: any, contactCount: any, segmentCount: any, filterCount: any, messagesStat?: { __typename?: 'StatusStatistics', callbackCount: any, successCount: any, pendingCount: any, failedCount: any, totalCount: any, unsubscribedCount: any } | null, conversion?: { __typename?: 'ConversionResponse', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit: boolean, conversion: number, totalHits: any, revenue: number, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', revenue?: number | null, total?: any | null } | null, schedulingConfig?: { __typename?: 'SchedulingConfig', sendType?: BroadcastSendType | null, sendLaterConfig?: { __typename?: 'SendLaterConfig', repeatType?: SendLaterRepeatType | null, id?: any | null, sendDate?: any | null, repeatConfig?: { __typename?: 'RepeatConfig', id?: any | null, endDate?: any | null, customRepeatConfig?: { __typename?: 'CustomRepeatConfig', repeatType?: RepeatType | null, repeatCount?: number | null, weekConfig?: { __typename?: 'CustomWeekConfig', days?: Array<DayOfWeek | null> | null } | null, monthConfig?: { __typename?: 'CustomMonthConfig', monthRepeatType?: CustomMonthRepeatType | null, eachMonthDayConfig?: { __typename?: 'EachMonthDayConfig', days?: Array<number | null> | null } | null, onMonthDayConfig?: { __typename?: 'OnMonthDayConfig', dayOrdinal?: OnMonthDayOrdinal | null, dayType?: OnMonthDayType | null } | null } | null } | null } | null } | null } | null, voiceMessage?: { __typename?: 'VoiceMessage', liveAnswer?: { __typename?: 'LiveAnswer', audioId?: any | null, liveAnswerEnabled?: boolean | null, transferCallEnabled?: boolean | null, transferCallNumber?: string | null, unsubscribeDigit?: number | null, transferCallDigit?: number | null, liveAnswer?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, voiceMail?: { __typename?: 'VoiceMail', audioId?: any | null, voiceMailEnabled?: boolean | null, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null } | null, ringlessMessage?: { __typename?: 'RinglessMessage', callbackEnabled: boolean, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, sendFromPhoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null, firstItemResponse?: { __typename?: 'BroadcastFirstItemResponse', id?: any | null, name?: string | null, type?: BroadcastItemType | null } | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null } | null> | null } | null };

export type GetBroadcastByIdQueryVariables = Exact<{
  broadcastId?: InputMaybe<Scalars['Long']>;
}>;


export type GetBroadcastByIdQuery = { __typename?: 'Query', getBroadcastById?: { __typename?: 'BroadcastFullResponse', id?: any | null, uuid?: any | null, contactCount: any, listCount: any, segmentCount: any, filterCount: any, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, finished?: boolean | null, simplifiedStatus?: Status | null, sendTime?: any | null, updatedAt?: any | null, createdAt?: any | null, sendFromCompany?: string | null, name?: string | null, type?: ContentType | null, status?: Status | null, conversion?: { __typename?: 'ConversionResponse', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit: boolean, conversion: number, totalHits: any, revenue: number, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', revenue?: number | null, total?: any | null } | null, contactsCount?: { __typename?: 'BroadcastContactsCount', total: number, active: number, globalOptOut: number } | null, messagesStat?: { __typename?: 'StatusStatistics', callbackCount: any, successCount: any, pendingCount: any, failedCount: any, totalCount: any, unsubscribedCount: any } | null, schedulingConfig?: { __typename?: 'SchedulingConfig', sendType?: BroadcastSendType | null, sendLaterConfig?: { __typename?: 'SendLaterConfig', repeatType?: SendLaterRepeatType | null, id?: any | null, sendDate?: any | null, repeatConfig?: { __typename?: 'RepeatConfig', id?: any | null, endDate?: any | null, customRepeatConfig?: { __typename?: 'CustomRepeatConfig', repeatType?: RepeatType | null, repeatCount?: number | null, weekConfig?: { __typename?: 'CustomWeekConfig', days?: Array<DayOfWeek | null> | null } | null, monthConfig?: { __typename?: 'CustomMonthConfig', monthRepeatType?: CustomMonthRepeatType | null, eachMonthDayConfig?: { __typename?: 'EachMonthDayConfig', days?: Array<number | null> | null } | null, onMonthDayConfig?: { __typename?: 'OnMonthDayConfig', dayOrdinal?: OnMonthDayOrdinal | null, dayType?: OnMonthDayType | null } | null } | null } | null } | null } | null } | null, voiceMessage?: { __typename?: 'VoiceMessage', liveAnswer?: { __typename?: 'LiveAnswer', audioId?: any | null, liveAnswerEnabled?: boolean | null, transferCallEnabled?: boolean | null, transferCallNumber?: string | null, unsubscribeDigit?: number | null, transferCallDigit?: number | null, liveAnswer?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, voiceMail?: { __typename?: 'VoiceMail', audioId?: any | null, voiceMailEnabled?: boolean | null, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null } | null, ringlessMessage?: { __typename?: 'RinglessMessage', callbackEnabled: boolean, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, sendFromPhoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null, lists?: Array<{ __typename?: 'ListResponse', id?: any | null, name?: string | null, activeContactsCount: any } | null> | null, segments?: Array<{ __typename?: 'SegmentResponse', createdAt?: any | null, name?: string | null, id?: any | null, updatedAt?: any | null, filterValue?: { __typename?: 'FilterValue', contactIds?: Array<any | null> | null, segmentIds?: Array<any | null> | null, listIds?: Array<any | null> | null, filters?: Array<{ __typename?: 'Filter', field?: string | null, dataType?: FilterDataType | null, andIndex: number, condition?: FilterCondition | null, orIndex: number, type?: FilterFieldType | null, value?: string | null, valueExt?: string | null } | null> | null } | null } | null> | null, contacts?: Array<{ __typename?: 'ContactLightResponse', email?: string | null, name?: string | null, id?: any | null, phone?: string | null, createdAt?: any | null } | null> | null, filterValue?: { __typename?: 'FilterValue', sourceFilters?: Array<Array<{ __typename?: 'Filter', field?: string | null, dataType?: FilterDataType | null, andIndex: number, condition?: FilterCondition | null, orIndex: number, type?: FilterFieldType | null, value?: string | null, valueExt?: string | null } | null> | null> | null } | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, advancedSchedulingConfig?: { __typename?: 'AdvancedSchedulingConfig', durationDays: number, durationHours: number, durationMinutes: number, expectedStartDate?: any | null, expectedFinishDate?: any | null, allowedDays?: Array<DayOfWeek | null> | null, contactsPerDay: number, startTimeHour: number, startTimeMinute: number, speedConfig?: { __typename?: 'BroadcastSendingSpeedConfig', unit?: SendingSpeedUnit | null, unitAmount: number, contactsAmount: number } | null } | null, estimatedDuration?: { __typename?: 'BroadcastEstimatedDurationResponse', expectedFinishDate?: any | null, expectedStartDate?: any | null, durationDays: number, durationHours: number, durationMinutes: number } | null, workflowConfig?: { __typename?: 'WorkflowRequest', actions?: Array<{ __typename?: 'WorkflowActionRequest', type?: WorkflowActionType | null, groupNumber: number, properties?: any | null } | null> | null } | null } | null };

export type GetBroadcastMessagesQueryVariables = Exact<{
  uuid?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<PaginationInput>;
  status?: InputMaybe<Status>;
}>;


export type GetBroadcastMessagesQuery = { __typename?: 'Query', getBroadcastMessages?: { __typename?: 'PageResponse_MessageDataResponse', total: any, pageSize: number, pageNumber: number, content?: Array<{ __typename?: 'MessageDataResponse', id?: any | null, totalShortUrl?: any | null, uniqueClicks?: any | null, type?: MessageType | null, duration?: number | null, extStatus?: string | null, extStatusLabel?: string | null, extStatusDescription?: string | null, state?: { __typename?: 'MessageStateResponse', boundType?: BoundType | null, simpleStatus?: Status | null, timeToSend?: any | null, contactName?: string | null, toNumber?: string | null, reason?: string | null, failReasonType?: FailReasonType | null, status?: Status | null, contactId?: any | null } | null } | null> | null } | null };

export type GetBroadcastEstimatedPriceQueryVariables = Exact<{
  broadcastInput: BroadcastInput;
}>;


export type GetBroadcastEstimatedPriceQuery = { __typename?: 'Query', getBroadcastEstimatedPrice?: { __typename?: 'BroadcastEstimatedPriceResponse', activeContactsCount?: number | null, totalPrice?: number | null, broadcastAllowed: boolean, message?: string | null } | null };

export type GetBroadcastMessageStatisticsQueryVariables = Exact<{
  uuid?: InputMaybe<Scalars['String']>;
}>;


export type GetBroadcastMessageStatisticsQuery = { __typename?: 'Query', getBroadcastMessageStatistics?: { __typename?: 'MessageStatisticsResponse', shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, percentageStatistics?: { __typename?: 'PercentageStatistics', callbackPercentage: number, failedPercentage: number, pendingPercentage: number, successPercentage: number, unsubscribedPercentage: number } | null, todayStatistics?: { __typename?: 'StatusStatistics', callbackCount: any, successCount: any, pendingCount: any, failedCount: any, totalCount: any, unsubscribedCount: any } | null, totalStatistics?: { __typename?: 'StatusStatistics', callbackCount: any, successCount: any, pendingCount: any, failedCount: any, totalCount: any, unsubscribedCount: any } | null, chargeStatistics?: { __typename?: 'ChargeStatistics', totalCharged?: number | null } | null, voiceTransferMessageStatistics?: { __typename?: 'TotalMessageStatistics', total?: any | null, percentage?: number | null, today?: any | null } | null, conversionStatistics?: { __typename?: 'TodayConversionStatistics', revenue?: number | null, roi?: number | null, totalCosts?: number | null, total?: any | null, percentage?: number | null, todayConversionStatistics?: { __typename?: 'ConversionStatistics', percentage?: number | null, revenue?: number | null, totalCosts?: number | null, roi?: number | null, total?: any | null } | null } | null } | null };

export type CreateBroadcastMutationVariables = Exact<{
  broadcastInput: BroadcastInput;
}>;


export type CreateBroadcastMutation = { __typename?: 'Mutation', createBroadcast?: { __typename?: 'BroadcastFullResponse', id?: any | null, uuid?: any | null, contactCount: any, listCount: any, segmentCount: any, filterCount: any, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, finished?: boolean | null, simplifiedStatus?: Status | null, sendTime?: any | null, updatedAt?: any | null, createdAt?: any | null, sendFromCompany?: string | null, name?: string | null, type?: ContentType | null, status?: Status | null, conversion?: { __typename?: 'ConversionResponse', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit: boolean, conversion: number, totalHits: any, revenue: number, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', revenue?: number | null, total?: any | null } | null, contactsCount?: { __typename?: 'BroadcastContactsCount', total: number, active: number, globalOptOut: number } | null, messagesStat?: { __typename?: 'StatusStatistics', callbackCount: any, successCount: any, pendingCount: any, failedCount: any, totalCount: any, unsubscribedCount: any } | null, schedulingConfig?: { __typename?: 'SchedulingConfig', sendType?: BroadcastSendType | null, sendLaterConfig?: { __typename?: 'SendLaterConfig', repeatType?: SendLaterRepeatType | null, id?: any | null, sendDate?: any | null, repeatConfig?: { __typename?: 'RepeatConfig', id?: any | null, endDate?: any | null, customRepeatConfig?: { __typename?: 'CustomRepeatConfig', repeatType?: RepeatType | null, repeatCount?: number | null, weekConfig?: { __typename?: 'CustomWeekConfig', days?: Array<DayOfWeek | null> | null } | null, monthConfig?: { __typename?: 'CustomMonthConfig', monthRepeatType?: CustomMonthRepeatType | null, eachMonthDayConfig?: { __typename?: 'EachMonthDayConfig', days?: Array<number | null> | null } | null, onMonthDayConfig?: { __typename?: 'OnMonthDayConfig', dayOrdinal?: OnMonthDayOrdinal | null, dayType?: OnMonthDayType | null } | null } | null } | null } | null } | null } | null, voiceMessage?: { __typename?: 'VoiceMessage', liveAnswer?: { __typename?: 'LiveAnswer', audioId?: any | null, liveAnswerEnabled?: boolean | null, transferCallEnabled?: boolean | null, transferCallNumber?: string | null, unsubscribeDigit?: number | null, transferCallDigit?: number | null, liveAnswer?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, voiceMail?: { __typename?: 'VoiceMail', audioId?: any | null, voiceMailEnabled?: boolean | null, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null } | null, ringlessMessage?: { __typename?: 'RinglessMessage', callbackEnabled: boolean, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, sendFromPhoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null, lists?: Array<{ __typename?: 'ListResponse', id?: any | null, name?: string | null, activeContactsCount: any } | null> | null, segments?: Array<{ __typename?: 'SegmentResponse', createdAt?: any | null, name?: string | null, id?: any | null, updatedAt?: any | null, filterValue?: { __typename?: 'FilterValue', contactIds?: Array<any | null> | null, segmentIds?: Array<any | null> | null, listIds?: Array<any | null> | null, filters?: Array<{ __typename?: 'Filter', field?: string | null, dataType?: FilterDataType | null, andIndex: number, condition?: FilterCondition | null, orIndex: number, type?: FilterFieldType | null, value?: string | null, valueExt?: string | null } | null> | null } | null } | null> | null, contacts?: Array<{ __typename?: 'ContactLightResponse', email?: string | null, name?: string | null, id?: any | null, phone?: string | null, createdAt?: any | null } | null> | null, filterValue?: { __typename?: 'FilterValue', sourceFilters?: Array<Array<{ __typename?: 'Filter', field?: string | null, dataType?: FilterDataType | null, andIndex: number, condition?: FilterCondition | null, orIndex: number, type?: FilterFieldType | null, value?: string | null, valueExt?: string | null } | null> | null> | null } | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, advancedSchedulingConfig?: { __typename?: 'AdvancedSchedulingConfig', durationDays: number, durationHours: number, durationMinutes: number, expectedStartDate?: any | null, expectedFinishDate?: any | null, allowedDays?: Array<DayOfWeek | null> | null, contactsPerDay: number, startTimeHour: number, startTimeMinute: number, speedConfig?: { __typename?: 'BroadcastSendingSpeedConfig', unit?: SendingSpeedUnit | null, unitAmount: number, contactsAmount: number } | null } | null, estimatedDuration?: { __typename?: 'BroadcastEstimatedDurationResponse', expectedFinishDate?: any | null, expectedStartDate?: any | null, durationDays: number, durationHours: number, durationMinutes: number } | null, workflowConfig?: { __typename?: 'WorkflowRequest', actions?: Array<{ __typename?: 'WorkflowActionRequest', type?: WorkflowActionType | null, groupNumber: number, properties?: any | null } | null> | null } | null } | null };

export type UpdateBroadcastMutationVariables = Exact<{
  broadcastInput: BroadcastInput;
}>;


export type UpdateBroadcastMutation = { __typename?: 'Mutation', updateBroadcast?: { __typename?: 'BroadcastFullResponse', id?: any | null, uuid?: any | null, contactCount: any, listCount: any, segmentCount: any, filterCount: any, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, finished?: boolean | null, simplifiedStatus?: Status | null, sendTime?: any | null, updatedAt?: any | null, createdAt?: any | null, sendFromCompany?: string | null, name?: string | null, type?: ContentType | null, status?: Status | null, conversion?: { __typename?: 'ConversionResponse', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit: boolean, conversion: number, totalHits: any, revenue: number, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', revenue?: number | null, total?: any | null } | null, contactsCount?: { __typename?: 'BroadcastContactsCount', total: number, active: number, globalOptOut: number } | null, messagesStat?: { __typename?: 'StatusStatistics', callbackCount: any, successCount: any, pendingCount: any, failedCount: any, totalCount: any, unsubscribedCount: any } | null, schedulingConfig?: { __typename?: 'SchedulingConfig', sendType?: BroadcastSendType | null, sendLaterConfig?: { __typename?: 'SendLaterConfig', repeatType?: SendLaterRepeatType | null, id?: any | null, sendDate?: any | null, repeatConfig?: { __typename?: 'RepeatConfig', id?: any | null, endDate?: any | null, customRepeatConfig?: { __typename?: 'CustomRepeatConfig', repeatType?: RepeatType | null, repeatCount?: number | null, weekConfig?: { __typename?: 'CustomWeekConfig', days?: Array<DayOfWeek | null> | null } | null, monthConfig?: { __typename?: 'CustomMonthConfig', monthRepeatType?: CustomMonthRepeatType | null, eachMonthDayConfig?: { __typename?: 'EachMonthDayConfig', days?: Array<number | null> | null } | null, onMonthDayConfig?: { __typename?: 'OnMonthDayConfig', dayOrdinal?: OnMonthDayOrdinal | null, dayType?: OnMonthDayType | null } | null } | null } | null } | null } | null } | null, voiceMessage?: { __typename?: 'VoiceMessage', liveAnswer?: { __typename?: 'LiveAnswer', audioId?: any | null, liveAnswerEnabled?: boolean | null, transferCallEnabled?: boolean | null, transferCallNumber?: string | null, unsubscribeDigit?: number | null, transferCallDigit?: number | null, liveAnswer?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, voiceMail?: { __typename?: 'VoiceMail', audioId?: any | null, voiceMailEnabled?: boolean | null, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null } | null, ringlessMessage?: { __typename?: 'RinglessMessage', callbackEnabled: boolean, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, sendFromPhoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null, lists?: Array<{ __typename?: 'ListResponse', id?: any | null, name?: string | null, activeContactsCount: any } | null> | null, segments?: Array<{ __typename?: 'SegmentResponse', createdAt?: any | null, name?: string | null, id?: any | null, updatedAt?: any | null, filterValue?: { __typename?: 'FilterValue', contactIds?: Array<any | null> | null, segmentIds?: Array<any | null> | null, listIds?: Array<any | null> | null, filters?: Array<{ __typename?: 'Filter', field?: string | null, dataType?: FilterDataType | null, andIndex: number, condition?: FilterCondition | null, orIndex: number, type?: FilterFieldType | null, value?: string | null, valueExt?: string | null } | null> | null } | null } | null> | null, contacts?: Array<{ __typename?: 'ContactLightResponse', email?: string | null, name?: string | null, id?: any | null, phone?: string | null, createdAt?: any | null } | null> | null, filterValue?: { __typename?: 'FilterValue', sourceFilters?: Array<Array<{ __typename?: 'Filter', field?: string | null, dataType?: FilterDataType | null, andIndex: number, condition?: FilterCondition | null, orIndex: number, type?: FilterFieldType | null, value?: string | null, valueExt?: string | null } | null> | null> | null } | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, advancedSchedulingConfig?: { __typename?: 'AdvancedSchedulingConfig', durationDays: number, durationHours: number, durationMinutes: number, expectedStartDate?: any | null, expectedFinishDate?: any | null, allowedDays?: Array<DayOfWeek | null> | null, contactsPerDay: number, startTimeHour: number, startTimeMinute: number, speedConfig?: { __typename?: 'BroadcastSendingSpeedConfig', unit?: SendingSpeedUnit | null, unitAmount: number, contactsAmount: number } | null } | null, estimatedDuration?: { __typename?: 'BroadcastEstimatedDurationResponse', expectedFinishDate?: any | null, expectedStartDate?: any | null, durationDays: number, durationHours: number, durationMinutes: number } | null, workflowConfig?: { __typename?: 'WorkflowRequest', actions?: Array<{ __typename?: 'WorkflowActionRequest', type?: WorkflowActionType | null, groupNumber: number, properties?: any | null } | null> | null } | null } | null };

export type DeleteBroadcastsMutationVariables = Exact<{
  broadcastIds: Array<InputMaybe<Scalars['Long']>> | InputMaybe<Scalars['Long']>;
}>;


export type DeleteBroadcastsMutation = { __typename?: 'Mutation', deleteBroadcasts?: string | null };

export type ChangeBroadcastsStateMutationVariables = Exact<{
  action?: InputMaybe<ChangeBroadcastStateAction>;
  broadcastIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>> | InputMaybe<Scalars['Long']>>;
}>;


export type ChangeBroadcastsStateMutation = { __typename?: 'Mutation', changeBroadcastsState?: Array<{ __typename?: 'BroadcastResponse', id?: any | null, uuid?: any | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, finished?: boolean | null, simplifiedStatus?: Status | null, sendTime?: any | null, updatedAt?: any | null, createdAt?: any | null, sendFromCompany?: string | null, name?: string | null, type?: ContentType | null, status?: Status | null, listCount: any, contactCount: any, segmentCount: any, filterCount: any, messagesStat?: { __typename?: 'StatusStatistics', callbackCount: any, successCount: any, pendingCount: any, failedCount: any, totalCount: any, unsubscribedCount: any } | null, conversion?: { __typename?: 'ConversionResponse', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit: boolean, conversion: number, totalHits: any, revenue: number, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', revenue?: number | null, total?: any | null } | null, schedulingConfig?: { __typename?: 'SchedulingConfig', sendType?: BroadcastSendType | null, sendLaterConfig?: { __typename?: 'SendLaterConfig', repeatType?: SendLaterRepeatType | null, id?: any | null, sendDate?: any | null, repeatConfig?: { __typename?: 'RepeatConfig', id?: any | null, endDate?: any | null, customRepeatConfig?: { __typename?: 'CustomRepeatConfig', repeatType?: RepeatType | null, repeatCount?: number | null, weekConfig?: { __typename?: 'CustomWeekConfig', days?: Array<DayOfWeek | null> | null } | null, monthConfig?: { __typename?: 'CustomMonthConfig', monthRepeatType?: CustomMonthRepeatType | null, eachMonthDayConfig?: { __typename?: 'EachMonthDayConfig', days?: Array<number | null> | null } | null, onMonthDayConfig?: { __typename?: 'OnMonthDayConfig', dayOrdinal?: OnMonthDayOrdinal | null, dayType?: OnMonthDayType | null } | null } | null } | null } | null } | null } | null, voiceMessage?: { __typename?: 'VoiceMessage', liveAnswer?: { __typename?: 'LiveAnswer', audioId?: any | null, liveAnswerEnabled?: boolean | null, transferCallEnabled?: boolean | null, transferCallNumber?: string | null, unsubscribeDigit?: number | null, transferCallDigit?: number | null, liveAnswer?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, voiceMail?: { __typename?: 'VoiceMail', audioId?: any | null, voiceMailEnabled?: boolean | null, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null } | null, ringlessMessage?: { __typename?: 'RinglessMessage', callbackEnabled: boolean, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, sendFromPhoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null, firstItemResponse?: { __typename?: 'BroadcastFirstItemResponse', id?: any | null, name?: string | null, type?: BroadcastItemType | null } | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null } | null> | null };

export type GetBroadcastSpeedOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBroadcastSpeedOptionsQuery = { __typename?: 'Query', getBroadcastSpeedOptions?: Array<{ __typename?: 'BroadcastSpeedOption', unit?: SendingSpeedUnit | null, allowedUnits?: Array<number | null> | null } | null> | null };

export type GetBroadcastEstimatedDurationQueryVariables = Exact<{
  broadcastInput?: InputMaybe<BroadcastInput>;
  expectedContactsCount: Scalars['Int'];
}>;


export type GetBroadcastEstimatedDurationQuery = { __typename?: 'Query', getBroadcastEstimatedDuration?: { __typename?: 'BroadcastEstimatedDurationResponse', expectedFinishDate?: any | null, expectedStartDate?: any | null, durationDays: number, durationHours: number, durationMinutes: number } | null };

export type BroadcastResponseFragment = { __typename?: 'BroadcastResponse', id?: any | null, uuid?: any | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, finished?: boolean | null, simplifiedStatus?: Status | null, sendTime?: any | null, updatedAt?: any | null, createdAt?: any | null, sendFromCompany?: string | null, name?: string | null, type?: ContentType | null, status?: Status | null, listCount: any, contactCount: any, segmentCount: any, filterCount: any, messagesStat?: { __typename?: 'StatusStatistics', callbackCount: any, successCount: any, pendingCount: any, failedCount: any, totalCount: any, unsubscribedCount: any } | null, conversion?: { __typename?: 'ConversionResponse', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit: boolean, conversion: number, totalHits: any, revenue: number, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', revenue?: number | null, total?: any | null } | null, schedulingConfig?: { __typename?: 'SchedulingConfig', sendType?: BroadcastSendType | null, sendLaterConfig?: { __typename?: 'SendLaterConfig', repeatType?: SendLaterRepeatType | null, id?: any | null, sendDate?: any | null, repeatConfig?: { __typename?: 'RepeatConfig', id?: any | null, endDate?: any | null, customRepeatConfig?: { __typename?: 'CustomRepeatConfig', repeatType?: RepeatType | null, repeatCount?: number | null, weekConfig?: { __typename?: 'CustomWeekConfig', days?: Array<DayOfWeek | null> | null } | null, monthConfig?: { __typename?: 'CustomMonthConfig', monthRepeatType?: CustomMonthRepeatType | null, eachMonthDayConfig?: { __typename?: 'EachMonthDayConfig', days?: Array<number | null> | null } | null, onMonthDayConfig?: { __typename?: 'OnMonthDayConfig', dayOrdinal?: OnMonthDayOrdinal | null, dayType?: OnMonthDayType | null } | null } | null } | null } | null } | null } | null, voiceMessage?: { __typename?: 'VoiceMessage', liveAnswer?: { __typename?: 'LiveAnswer', audioId?: any | null, liveAnswerEnabled?: boolean | null, transferCallEnabled?: boolean | null, transferCallNumber?: string | null, unsubscribeDigit?: number | null, transferCallDigit?: number | null, liveAnswer?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, voiceMail?: { __typename?: 'VoiceMail', audioId?: any | null, voiceMailEnabled?: boolean | null, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null } | null, ringlessMessage?: { __typename?: 'RinglessMessage', callbackEnabled: boolean, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, sendFromPhoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null, firstItemResponse?: { __typename?: 'BroadcastFirstItemResponse', id?: any | null, name?: string | null, type?: BroadcastItemType | null } | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null };

export type AdvancedSchedulingConfigFragment = { __typename?: 'AdvancedSchedulingConfig', durationDays: number, durationHours: number, durationMinutes: number, expectedStartDate?: any | null, expectedFinishDate?: any | null, allowedDays?: Array<DayOfWeek | null> | null, contactsPerDay: number, startTimeHour: number, startTimeMinute: number, speedConfig?: { __typename?: 'BroadcastSendingSpeedConfig', unit?: SendingSpeedUnit | null, unitAmount: number, contactsAmount: number } | null };

export type BroadcastEstimatedDurationResponseFragment = { __typename?: 'BroadcastEstimatedDurationResponse', expectedFinishDate?: any | null, expectedStartDate?: any | null, durationDays: number, durationHours: number, durationMinutes: number };

export type BroadcastFullResponseFragment = { __typename?: 'BroadcastFullResponse', id?: any | null, uuid?: any | null, contactCount: any, listCount: any, segmentCount: any, filterCount: any, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, finished?: boolean | null, simplifiedStatus?: Status | null, sendTime?: any | null, updatedAt?: any | null, createdAt?: any | null, sendFromCompany?: string | null, name?: string | null, type?: ContentType | null, status?: Status | null, conversion?: { __typename?: 'ConversionResponse', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit: boolean, conversion: number, totalHits: any, revenue: number, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', revenue?: number | null, total?: any | null } | null, contactsCount?: { __typename?: 'BroadcastContactsCount', total: number, active: number, globalOptOut: number } | null, messagesStat?: { __typename?: 'StatusStatistics', callbackCount: any, successCount: any, pendingCount: any, failedCount: any, totalCount: any, unsubscribedCount: any } | null, schedulingConfig?: { __typename?: 'SchedulingConfig', sendType?: BroadcastSendType | null, sendLaterConfig?: { __typename?: 'SendLaterConfig', repeatType?: SendLaterRepeatType | null, id?: any | null, sendDate?: any | null, repeatConfig?: { __typename?: 'RepeatConfig', id?: any | null, endDate?: any | null, customRepeatConfig?: { __typename?: 'CustomRepeatConfig', repeatType?: RepeatType | null, repeatCount?: number | null, weekConfig?: { __typename?: 'CustomWeekConfig', days?: Array<DayOfWeek | null> | null } | null, monthConfig?: { __typename?: 'CustomMonthConfig', monthRepeatType?: CustomMonthRepeatType | null, eachMonthDayConfig?: { __typename?: 'EachMonthDayConfig', days?: Array<number | null> | null } | null, onMonthDayConfig?: { __typename?: 'OnMonthDayConfig', dayOrdinal?: OnMonthDayOrdinal | null, dayType?: OnMonthDayType | null } | null } | null } | null } | null } | null } | null, voiceMessage?: { __typename?: 'VoiceMessage', liveAnswer?: { __typename?: 'LiveAnswer', audioId?: any | null, liveAnswerEnabled?: boolean | null, transferCallEnabled?: boolean | null, transferCallNumber?: string | null, unsubscribeDigit?: number | null, transferCallDigit?: number | null, liveAnswer?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, voiceMail?: { __typename?: 'VoiceMail', audioId?: any | null, voiceMailEnabled?: boolean | null, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null } | null, ringlessMessage?: { __typename?: 'RinglessMessage', callbackEnabled: boolean, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, sendFromPhoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null, lists?: Array<{ __typename?: 'ListResponse', id?: any | null, name?: string | null, activeContactsCount: any } | null> | null, segments?: Array<{ __typename?: 'SegmentResponse', createdAt?: any | null, name?: string | null, id?: any | null, updatedAt?: any | null, filterValue?: { __typename?: 'FilterValue', contactIds?: Array<any | null> | null, segmentIds?: Array<any | null> | null, listIds?: Array<any | null> | null, filters?: Array<{ __typename?: 'Filter', field?: string | null, dataType?: FilterDataType | null, andIndex: number, condition?: FilterCondition | null, orIndex: number, type?: FilterFieldType | null, value?: string | null, valueExt?: string | null } | null> | null } | null } | null> | null, contacts?: Array<{ __typename?: 'ContactLightResponse', email?: string | null, name?: string | null, id?: any | null, phone?: string | null, createdAt?: any | null } | null> | null, filterValue?: { __typename?: 'FilterValue', sourceFilters?: Array<Array<{ __typename?: 'Filter', field?: string | null, dataType?: FilterDataType | null, andIndex: number, condition?: FilterCondition | null, orIndex: number, type?: FilterFieldType | null, value?: string | null, valueExt?: string | null } | null> | null> | null } | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, advancedSchedulingConfig?: { __typename?: 'AdvancedSchedulingConfig', durationDays: number, durationHours: number, durationMinutes: number, expectedStartDate?: any | null, expectedFinishDate?: any | null, allowedDays?: Array<DayOfWeek | null> | null, contactsPerDay: number, startTimeHour: number, startTimeMinute: number, speedConfig?: { __typename?: 'BroadcastSendingSpeedConfig', unit?: SendingSpeedUnit | null, unitAmount: number, contactsAmount: number } | null } | null, estimatedDuration?: { __typename?: 'BroadcastEstimatedDurationResponse', expectedFinishDate?: any | null, expectedStartDate?: any | null, durationDays: number, durationHours: number, durationMinutes: number } | null, workflowConfig?: { __typename?: 'WorkflowRequest', actions?: Array<{ __typename?: 'WorkflowActionRequest', type?: WorkflowActionType | null, groupNumber: number, properties?: any | null } | null> | null } | null };

export type GetAllCampaignsQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
  search: CampaignSearchInput;
}>;


export type GetAllCampaignsQuery = { __typename?: 'Query', getAllCampaigns?: { __typename?: 'PageResponse_CampaignResponse', total: any, pageSize: number, pageNumber: number, content?: Array<{ __typename?: 'CampaignResponse', id?: any | null, createdAt?: any | null, uuid?: any | null, name?: string | null, status?: Status | null, reEnrollEnabled: boolean, messagesStat?: { __typename?: 'StatusStatistics', callbackCount: any, successCount: any, pendingCount: any, failedCount: any, totalCount: any, unsubscribedCount: any } | null, campaignListResponses?: Array<{ __typename?: 'CampaignListResponse', listId?: any | null, listName?: string | null } | null> | null, campaignStepResponses?: Array<{ __typename?: 'CampaignStepResponse', id?: any | null, type?: ContentType | null, name?: string | null, uuid?: any | null, delayType?: CampaignDelayType | null, phoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, voiceMessage?: { __typename?: 'VoiceMessage', liveAnswer?: { __typename?: 'LiveAnswer', audioId?: any | null, liveAnswerEnabled?: boolean | null, transferCallEnabled?: boolean | null, transferCallNumber?: string | null, unsubscribeDigit?: number | null, transferCallDigit?: number | null, liveAnswer?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, voiceMail?: { __typename?: 'VoiceMail', audioId?: any | null, voiceMailEnabled?: boolean | null, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null } | null, ringlessMessage?: { __typename?: 'RinglessMessage', callbackEnabled: boolean, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, delay?: { __typename?: 'CampaignStepDelayResponse', id?: any | null, hour?: number | null, minute?: number | null, period?: CampaignDelayPeriod | null, value: number, sendDate?: any | null, scheduleType?: CampaignScheduleType | null, customField?: { __typename?: 'CustomField', createdAt?: any | null, type?: CustomFieldType | null, id?: any | null, name?: string | null, displayIndex?: number | null, key?: string | null, used?: boolean | null } | null } | null } | null> | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', revenue?: number | null, total?: any | null } | null, conversion?: { __typename?: 'Conversion', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit?: boolean | null, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null } | null> | null } | null };

export type GetCampaignByIdQueryVariables = Exact<{
  campaignId?: InputMaybe<Scalars['Long']>;
}>;


export type GetCampaignByIdQuery = { __typename?: 'Query', getCampaignById?: { __typename?: 'CampaignResponse', id?: any | null, createdAt?: any | null, uuid?: any | null, name?: string | null, status?: Status | null, reEnrollEnabled: boolean, messagesStat?: { __typename?: 'StatusStatistics', callbackCount: any, successCount: any, pendingCount: any, failedCount: any, totalCount: any, unsubscribedCount: any } | null, campaignListResponses?: Array<{ __typename?: 'CampaignListResponse', listId?: any | null, listName?: string | null } | null> | null, campaignStepResponses?: Array<{ __typename?: 'CampaignStepResponse', id?: any | null, type?: ContentType | null, name?: string | null, uuid?: any | null, delayType?: CampaignDelayType | null, phoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, voiceMessage?: { __typename?: 'VoiceMessage', liveAnswer?: { __typename?: 'LiveAnswer', audioId?: any | null, liveAnswerEnabled?: boolean | null, transferCallEnabled?: boolean | null, transferCallNumber?: string | null, unsubscribeDigit?: number | null, transferCallDigit?: number | null, liveAnswer?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, voiceMail?: { __typename?: 'VoiceMail', audioId?: any | null, voiceMailEnabled?: boolean | null, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null } | null, ringlessMessage?: { __typename?: 'RinglessMessage', callbackEnabled: boolean, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, delay?: { __typename?: 'CampaignStepDelayResponse', id?: any | null, hour?: number | null, minute?: number | null, period?: CampaignDelayPeriod | null, value: number, sendDate?: any | null, scheduleType?: CampaignScheduleType | null, customField?: { __typename?: 'CustomField', createdAt?: any | null, type?: CustomFieldType | null, id?: any | null, name?: string | null, displayIndex?: number | null, key?: string | null, used?: boolean | null } | null } | null } | null> | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', revenue?: number | null, total?: any | null } | null, conversion?: { __typename?: 'Conversion', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit?: boolean | null, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null } | null };

export type GetCampaignStatisticsQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type GetCampaignStatisticsQuery = { __typename?: 'Query', getCampaignStatistics?: { __typename?: 'MessageStatisticsResponse', shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, percentageStatistics?: { __typename?: 'PercentageStatistics', callbackPercentage: number, failedPercentage: number, pendingPercentage: number, successPercentage: number, unsubscribedPercentage: number } | null, todayStatistics?: { __typename?: 'StatusStatistics', callbackCount: any, successCount: any, pendingCount: any, failedCount: any, totalCount: any, unsubscribedCount: any } | null, totalStatistics?: { __typename?: 'StatusStatistics', callbackCount: any, successCount: any, pendingCount: any, failedCount: any, totalCount: any, unsubscribedCount: any } | null, chargeStatistics?: { __typename?: 'ChargeStatistics', totalCharged?: number | null } | null, voiceTransferMessageStatistics?: { __typename?: 'TotalMessageStatistics', total?: any | null, percentage?: number | null, today?: any | null } | null, conversionStatistics?: { __typename?: 'TodayConversionStatistics', revenue?: number | null, roi?: number | null, totalCosts?: number | null, total?: any | null, percentage?: number | null, todayConversionStatistics?: { __typename?: 'ConversionStatistics', percentage?: number | null, revenue?: number | null, totalCosts?: number | null, roi?: number | null, total?: any | null } | null } | null } | null };

export type GetCampaignAnalyticsStatisticsQueryVariables = Exact<{
  uuid: Scalars['String'];
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
}>;


export type GetCampaignAnalyticsStatisticsQuery = { __typename?: 'Query', getCampaignAnalyticsStatistics?: { __typename?: 'CampaignAnalyticsStatisticsResponse', chargeStatistics?: { __typename?: 'ChargeStatistics', totalCharged?: number | null } | null, percentageStatistics?: { __typename?: 'PercentageStatistics', successPercentage: number, pendingPercentage: number, failedPercentage: number, unsubscribedPercentage: number, callbackPercentage: number } | null, totalStatistics?: { __typename?: 'StatusStatistics', totalCount: any, unsubscribedCount: any, failedCount: any, pendingCount: any, successCount: any, callbackCount: any } | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'TodayConversionStatistics', revenue?: number | null, roi?: number | null, totalCosts?: number | null, total?: any | null, percentage?: number | null, todayConversionStatistics?: { __typename?: 'ConversionStatistics', percentage?: number | null, revenue?: number | null, totalCosts?: number | null, roi?: number | null, total?: any | null } | null } | null } | null };

export type GetCampaignStepStatisticsQueryVariables = Exact<{
  uuid: Scalars['String'];
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
}>;


export type GetCampaignStepStatisticsQuery = { __typename?: 'Query', getCampaignStepStatistics?: { __typename?: 'MessageStatisticsResponse', shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, percentageStatistics?: { __typename?: 'PercentageStatistics', callbackPercentage: number, failedPercentage: number, pendingPercentage: number, successPercentage: number, unsubscribedPercentage: number } | null, todayStatistics?: { __typename?: 'StatusStatistics', callbackCount: any, successCount: any, pendingCount: any, failedCount: any, totalCount: any, unsubscribedCount: any } | null, totalStatistics?: { __typename?: 'StatusStatistics', callbackCount: any, successCount: any, pendingCount: any, failedCount: any, totalCount: any, unsubscribedCount: any } | null, chargeStatistics?: { __typename?: 'ChargeStatistics', totalCharged?: number | null } | null, voiceTransferMessageStatistics?: { __typename?: 'TotalMessageStatistics', total?: any | null, percentage?: number | null, today?: any | null } | null, conversionStatistics?: { __typename?: 'TodayConversionStatistics', revenue?: number | null, roi?: number | null, totalCosts?: number | null, total?: any | null, percentage?: number | null, todayConversionStatistics?: { __typename?: 'ConversionStatistics', percentage?: number | null, revenue?: number | null, totalCosts?: number | null, roi?: number | null, total?: any | null } | null } | null } | null };

export type GetCampaignStepMessagesQueryVariables = Exact<{
  uuid: Scalars['String'];
  status?: InputMaybe<Status>;
  page?: InputMaybe<PaginationInput>;
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
}>;


export type GetCampaignStepMessagesQuery = { __typename?: 'Query', getCampaignStepMessages?: { __typename?: 'PageResponse_MessageDataResponse', total: any, pageSize: number, pageNumber: number, content?: Array<{ __typename?: 'MessageDataResponse', id?: any | null, totalShortUrl?: any | null, uniqueClicks?: any | null, type?: MessageType | null, duration?: number | null, extStatus?: string | null, extStatusLabel?: string | null, extStatusDescription?: string | null, state?: { __typename?: 'MessageStateResponse', boundType?: BoundType | null, simpleStatus?: Status | null, timeToSend?: any | null, contactName?: string | null, toNumber?: string | null, reason?: string | null, failReasonType?: FailReasonType | null, status?: Status | null, contactId?: any | null } | null } | null> | null } | null };

export type CreateCampaignMutationVariables = Exact<{
  campaignInput: CampaignCreateRequestInput;
}>;


export type CreateCampaignMutation = { __typename?: 'Mutation', createCampaign?: { __typename?: 'CampaignResponse', id?: any | null, createdAt?: any | null, uuid?: any | null, name?: string | null, status?: Status | null, reEnrollEnabled: boolean, messagesStat?: { __typename?: 'StatusStatistics', callbackCount: any, successCount: any, pendingCount: any, failedCount: any, totalCount: any, unsubscribedCount: any } | null, campaignListResponses?: Array<{ __typename?: 'CampaignListResponse', listId?: any | null, listName?: string | null } | null> | null, campaignStepResponses?: Array<{ __typename?: 'CampaignStepResponse', id?: any | null, type?: ContentType | null, name?: string | null, uuid?: any | null, delayType?: CampaignDelayType | null, phoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, voiceMessage?: { __typename?: 'VoiceMessage', liveAnswer?: { __typename?: 'LiveAnswer', audioId?: any | null, liveAnswerEnabled?: boolean | null, transferCallEnabled?: boolean | null, transferCallNumber?: string | null, unsubscribeDigit?: number | null, transferCallDigit?: number | null, liveAnswer?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, voiceMail?: { __typename?: 'VoiceMail', audioId?: any | null, voiceMailEnabled?: boolean | null, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null } | null, ringlessMessage?: { __typename?: 'RinglessMessage', callbackEnabled: boolean, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, delay?: { __typename?: 'CampaignStepDelayResponse', id?: any | null, hour?: number | null, minute?: number | null, period?: CampaignDelayPeriod | null, value: number, sendDate?: any | null, scheduleType?: CampaignScheduleType | null, customField?: { __typename?: 'CustomField', createdAt?: any | null, type?: CustomFieldType | null, id?: any | null, name?: string | null, displayIndex?: number | null, key?: string | null, used?: boolean | null } | null } | null } | null> | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', revenue?: number | null, total?: any | null } | null, conversion?: { __typename?: 'Conversion', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit?: boolean | null, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null } | null };

export type UpdateCampaignMutationVariables = Exact<{
  campaignInput: CampaignUpdateRequestInput;
}>;


export type UpdateCampaignMutation = { __typename?: 'Mutation', updateCampaign?: { __typename?: 'CampaignResponse', id?: any | null, createdAt?: any | null, uuid?: any | null, name?: string | null, status?: Status | null, reEnrollEnabled: boolean, messagesStat?: { __typename?: 'StatusStatistics', callbackCount: any, successCount: any, pendingCount: any, failedCount: any, totalCount: any, unsubscribedCount: any } | null, campaignListResponses?: Array<{ __typename?: 'CampaignListResponse', listId?: any | null, listName?: string | null } | null> | null, campaignStepResponses?: Array<{ __typename?: 'CampaignStepResponse', id?: any | null, type?: ContentType | null, name?: string | null, uuid?: any | null, delayType?: CampaignDelayType | null, phoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, voiceMessage?: { __typename?: 'VoiceMessage', liveAnswer?: { __typename?: 'LiveAnswer', audioId?: any | null, liveAnswerEnabled?: boolean | null, transferCallEnabled?: boolean | null, transferCallNumber?: string | null, unsubscribeDigit?: number | null, transferCallDigit?: number | null, liveAnswer?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, voiceMail?: { __typename?: 'VoiceMail', audioId?: any | null, voiceMailEnabled?: boolean | null, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null } | null, ringlessMessage?: { __typename?: 'RinglessMessage', callbackEnabled: boolean, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, delay?: { __typename?: 'CampaignStepDelayResponse', id?: any | null, hour?: number | null, minute?: number | null, period?: CampaignDelayPeriod | null, value: number, sendDate?: any | null, scheduleType?: CampaignScheduleType | null, customField?: { __typename?: 'CustomField', createdAt?: any | null, type?: CustomFieldType | null, id?: any | null, name?: string | null, displayIndex?: number | null, key?: string | null, used?: boolean | null } | null } | null } | null> | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', revenue?: number | null, total?: any | null } | null, conversion?: { __typename?: 'Conversion', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit?: boolean | null, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null } | null };

export type ActionCampaignArchiveMutationVariables = Exact<{
  campaignIds: Array<InputMaybe<Scalars['Long']>> | InputMaybe<Scalars['Long']>;
}>;


export type ActionCampaignArchiveMutation = { __typename?: 'Mutation', actionCampaignArchive: boolean };

export type ActionCampaignRestoreMutationVariables = Exact<{
  campaignIds: Array<InputMaybe<Scalars['Long']>> | InputMaybe<Scalars['Long']>;
}>;


export type ActionCampaignRestoreMutation = { __typename?: 'Mutation', actionCampaignRestore: boolean };

export type ActionCampaignSwitchEnabledMutationVariables = Exact<{
  campaignIds: Array<InputMaybe<Scalars['Long']>> | InputMaybe<Scalars['Long']>;
  enabled: Scalars['Boolean'];
}>;


export type ActionCampaignSwitchEnabledMutation = { __typename?: 'Mutation', actionCampaignSwitchEnabled: boolean };

export type DeleteCampaignsMutationVariables = Exact<{
  campaignIds: Array<InputMaybe<Scalars['Long']>> | InputMaybe<Scalars['Long']>;
}>;


export type DeleteCampaignsMutation = { __typename?: 'Mutation', deleteCampaigns?: string | null };

export type CampaignFragmentFragment = { __typename?: 'CampaignResponse', id?: any | null, createdAt?: any | null, uuid?: any | null, name?: string | null, status?: Status | null, reEnrollEnabled: boolean, messagesStat?: { __typename?: 'StatusStatistics', callbackCount: any, successCount: any, pendingCount: any, failedCount: any, totalCount: any, unsubscribedCount: any } | null, campaignListResponses?: Array<{ __typename?: 'CampaignListResponse', listId?: any | null, listName?: string | null } | null> | null, campaignStepResponses?: Array<{ __typename?: 'CampaignStepResponse', id?: any | null, type?: ContentType | null, name?: string | null, uuid?: any | null, delayType?: CampaignDelayType | null, phoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, voiceMessage?: { __typename?: 'VoiceMessage', liveAnswer?: { __typename?: 'LiveAnswer', audioId?: any | null, liveAnswerEnabled?: boolean | null, transferCallEnabled?: boolean | null, transferCallNumber?: string | null, unsubscribeDigit?: number | null, transferCallDigit?: number | null, liveAnswer?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, voiceMail?: { __typename?: 'VoiceMail', audioId?: any | null, voiceMailEnabled?: boolean | null, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null } | null, ringlessMessage?: { __typename?: 'RinglessMessage', callbackEnabled: boolean, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, delay?: { __typename?: 'CampaignStepDelayResponse', id?: any | null, hour?: number | null, minute?: number | null, period?: CampaignDelayPeriod | null, value: number, sendDate?: any | null, scheduleType?: CampaignScheduleType | null, customField?: { __typename?: 'CustomField', createdAt?: any | null, type?: CustomFieldType | null, id?: any | null, name?: string | null, displayIndex?: number | null, key?: string | null, used?: boolean | null } | null } | null } | null> | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', revenue?: number | null, total?: any | null } | null, conversion?: { __typename?: 'Conversion', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit?: boolean | null, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null };

export type GetMyOrganizationContactsQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
  contactSearch?: InputMaybe<ContactSearchInput>;
}>;


export type GetMyOrganizationContactsQuery = { __typename?: 'Query', getMyOrganizationContacts?: { __typename?: 'PageResponse_ContactLightResponse', pageNumber: number, total: any, pageSize: number, content?: Array<{ __typename?: 'ContactLightResponse', id?: any | null, name?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, createdAt?: any | null, status?: Status | null, carrierType?: string | null, optIn?: ContactOptIn | null, listings?: Array<{ __typename?: 'ListingLight', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null } | null> | null, contactCustomFields?: Array<{ __typename?: 'ContactCustomFieldResponse', name?: string | null, type?: string | null, key?: string | null, date?: any | null, number?: any | null, text?: string | null } | null> | null } | null> | null } | null };

export type GetListContactsQueryVariables = Exact<{
  listId?: InputMaybe<Scalars['Long']>;
  page?: InputMaybe<PaginationInput>;
  contactSearch?: InputMaybe<ContactSearchInput>;
}>;


export type GetListContactsQuery = { __typename?: 'Query', getListContacts?: { __typename?: 'PageResponse_ContactLightResponse', pageNumber: number, total: any, pageSize: number, content?: Array<{ __typename?: 'ContactLightResponse', id?: any | null, name?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, createdAt?: any | null, status?: Status | null, carrierType?: string | null, optIn?: ContactOptIn | null, listings?: Array<{ __typename?: 'ListingLight', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null } | null> | null, contactCustomFields?: Array<{ __typename?: 'ContactCustomFieldResponse', name?: string | null, type?: string | null, key?: string | null, date?: any | null, number?: any | null, text?: string | null } | null> | null } | null> | null } | null };

export type GetShortMyOrganizationListsQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
  listingSearch?: InputMaybe<ListingSearchInput>;
}>;


export type GetShortMyOrganizationListsQuery = { __typename?: 'Query', getMyOrganizationLists?: { __typename?: 'PageResponse_ListResponse', pageSize: number, total: any, pageNumber: number, content?: Array<{ __typename?: 'ListResponse', id?: any | null, name?: string | null, activeContactsCount: any } | null> | null } | null };

export type GetMyOrganizationListsQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
  listingSearch?: InputMaybe<ListingSearchInput>;
}>;


export type GetMyOrganizationListsQuery = { __typename?: 'Query', getMyOrganizationLists?: { __typename?: 'PageResponse_ListResponse', pageSize: number, total: any, pageNumber: number, content?: Array<{ __typename?: 'ListResponse', id?: any | null, name?: string | null, createdAt?: any | null, activeContactsCount: any, invalidContactsCount: any, totalContactsCount: any, unsubscribedContactsCount: any, keywords?: Array<{ __typename?: 'KeywordForm', id?: any | null, name?: string | null } | null> | null, webForms?: Array<{ __typename?: 'WebFormForm', id?: any | null, name?: string | null } | null> | null } | null> | null } | null };

export type GetMyOrganizationContactsStatisticsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyOrganizationContactsStatisticsQuery = { __typename?: 'Query', getMyOrganizationContactsStatistics?: { __typename?: 'ContactStatisticsResponse', invalidCount: any, totalCount: any, activeCount: any, archivedCount: any, unsubscribedCount: any, inactiveCount: any } | null };

export type GetListContactsStatisticsQueryVariables = Exact<{
  listId?: InputMaybe<Scalars['Long']>;
}>;


export type GetListContactsStatisticsQuery = { __typename?: 'Query', getListContactsStatistics?: { __typename?: 'ContactStatisticsResponse', invalidCount: any, totalCount: any, activeCount: any, archivedCount: any, unsubscribedCount: any, inactiveCount: any } | null };

export type GetTotalContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTotalContactsQuery = { __typename?: 'Query', getMyOrganizationContacts?: { __typename?: 'PageResponse_ContactLightResponse', total: any } | null };

export type GetMyContactCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyContactCardsQuery = { __typename?: 'Query', getMyContactCards?: Array<{ __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null> | null };

export type GetMyContactQueryVariables = Exact<{
  contactId: Scalars['Long'];
}>;


export type GetMyContactQuery = { __typename?: 'Query', getMyContact?: { __typename?: 'Contact', id?: any | null, email?: string | null, name?: string | null, formattedPhoneNumber?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, createdAt?: any | null, charged: boolean, optIn?: ContactOptIn | null, status?: Status | null, carrierType?: string | null, listContacts?: Array<{ __typename?: 'ListContact', listing?: { __typename?: 'Listing', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, activeContactsCount: any, invalidContactsCount: any, totalContactsCount: any, unsubscribedContactsCount: any } | null } | null> | null, contactSource?: { __typename?: 'ContactSource', name?: string | null, id?: any | null, sourceType?: SourceType | null } | null, customFields?: Array<{ __typename?: 'ContactCustomField', text?: string | null, date?: any | null, number?: any | null, contactFieldId?: { __typename?: 'ContactFieldId', contactId?: any | null, fieldId?: any | null } | null, field?: { __typename?: 'CustomField', key?: string | null, type?: CustomFieldType | null, name?: string | null } | null } | null> | null } | null };

export type SearchListsAndContactsQueryVariables = Exact<{
  search?: InputMaybe<ListContactSearchInput>;
}>;


export type SearchListsAndContactsQuery = { __typename?: 'Query', searchListsAndContacts?: { __typename?: 'ListContactSearchResult', totalContacts: number, totalListings: number, totalSegments: number, contacts?: Array<{ __typename?: 'Contact', id?: any | null, name?: string | null, formattedPhoneNumber?: string | null, email?: string | null } | null> | null, listings?: Array<{ __typename?: 'Listing', id?: any | null, name?: string | null, activeContactsCount: any } | null> | null, segments?: Array<{ __typename?: 'SegmentResponse', createdAt?: any | null, name?: string | null, id?: any | null, updatedAt?: any | null, filterValue?: { __typename?: 'FilterValue', contactIds?: Array<any | null> | null, segmentIds?: Array<any | null> | null, listIds?: Array<any | null> | null, filters?: Array<{ __typename?: 'Filter', field?: string | null, dataType?: FilterDataType | null, andIndex: number, condition?: FilterCondition | null, orIndex: number, type?: FilterFieldType | null, value?: string | null, valueExt?: string | null } | null> | null } | null } | null> | null } | null };

export type CreateContactMutationVariables = Exact<{
  createContactInput: ContactRequestInput;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', createContact?: { __typename?: 'ContactResponse', contact?: { __typename?: 'Contact', id?: any | null, email?: string | null, name?: string | null, formattedPhoneNumber?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, createdAt?: any | null, charged: boolean, optIn?: ContactOptIn | null, status?: Status | null, carrierType?: string | null, listContacts?: Array<{ __typename?: 'ListContact', listing?: { __typename?: 'Listing', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, activeContactsCount: any, invalidContactsCount: any, totalContactsCount: any, unsubscribedContactsCount: any } | null } | null> | null, contactSource?: { __typename?: 'ContactSource', name?: string | null, id?: any | null, sourceType?: SourceType | null } | null, customFields?: Array<{ __typename?: 'ContactCustomField', text?: string | null, date?: any | null, number?: any | null, contactFieldId?: { __typename?: 'ContactFieldId', contactId?: any | null, fieldId?: any | null } | null, field?: { __typename?: 'CustomField', key?: string | null, type?: CustomFieldType | null, name?: string | null } | null } | null> | null } | null, updatedListings?: Array<{ __typename?: 'Listing', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, activeContactsCount: any, invalidContactsCount: any, totalContactsCount: any, unsubscribedContactsCount: any } | null> | null } | null };

export type UpdateContactMutationVariables = Exact<{
  updateContactInput: ContactRequestInput;
}>;


export type UpdateContactMutation = { __typename?: 'Mutation', updateContact?: { __typename?: 'ContactResponse', contact?: { __typename?: 'Contact', id?: any | null, email?: string | null, name?: string | null, formattedPhoneNumber?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, createdAt?: any | null, charged: boolean, optIn?: ContactOptIn | null, status?: Status | null, carrierType?: string | null, listContacts?: Array<{ __typename?: 'ListContact', listing?: { __typename?: 'Listing', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, activeContactsCount: any, invalidContactsCount: any, totalContactsCount: any, unsubscribedContactsCount: any } | null } | null> | null, contactSource?: { __typename?: 'ContactSource', name?: string | null, id?: any | null, sourceType?: SourceType | null } | null, customFields?: Array<{ __typename?: 'ContactCustomField', text?: string | null, date?: any | null, number?: any | null, contactFieldId?: { __typename?: 'ContactFieldId', contactId?: any | null, fieldId?: any | null } | null, field?: { __typename?: 'CustomField', key?: string | null, type?: CustomFieldType | null, name?: string | null } | null } | null> | null } | null, updatedListings?: Array<{ __typename?: 'Listing', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, activeContactsCount: any, invalidContactsCount: any, totalContactsCount: any, unsubscribedContactsCount: any } | null> | null } | null };

export type RemoveContactsMutationVariables = Exact<{
  bulk?: InputMaybe<ContactBulkOperationRequestInput>;
}>;


export type RemoveContactsMutation = { __typename?: 'Mutation', removeContacts?: string | null };

export type UpdateListMutationVariables = Exact<{
  listInput: ListRequestInput;
}>;


export type UpdateListMutation = { __typename?: 'Mutation', updateList?: { __typename?: 'Listing', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, activeContactsCount: any, invalidContactsCount: any, totalContactsCount: any, unsubscribedContactsCount: any } | null };

export type CreateListMutationVariables = Exact<{
  listInput: ListRequestInput;
}>;


export type CreateListMutation = { __typename?: 'Mutation', createList?: { __typename?: 'Listing', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, activeContactsCount: any, invalidContactsCount: any, totalContactsCount: any, unsubscribedContactsCount: any } | null };

export type RemoveListsMutationVariables = Exact<{
  listIds?: InputMaybe<Array<Scalars['Long']> | Scalars['Long']>;
}>;


export type RemoveListsMutation = { __typename?: 'Mutation', removeLists?: string | null };

export type UpdateContactImportStateMutationVariables = Exact<{
  importStateInput: ContactImportRequestInput;
}>;


export type UpdateContactImportStateMutation = { __typename?: 'Mutation', updateContactImportState?: { __typename?: 'ContactImportState', status?: Status | null, successPercentage: number, originalFileName?: string | null, createdAt?: any | null, updatedAt?: any | null, id?: any | null, columns?: Array<string | null> | null, deletedAt?: any | null, skipFirstRow: boolean, invalidCount: number, successCount: number, contactsLimit: number, fileKey?: string | null, simplifiedStatus?: Status | null, allowImportStatus?: AllowImportStatus | null, organization?: { __typename?: 'Organization', id?: any | null, importApprovedAt?: any | null, companyName?: string | null, importApprover?: { __typename?: 'Member', id?: any | null, profile?: { __typename?: 'MemberProfile', name?: string | null } | null } | null } | null, member?: { __typename?: 'Member', id?: any | null, profile?: { __typename?: 'MemberProfile', name?: string | null, firstName?: string | null, lastName?: string | null } | null } | null } | null };

export type AddToListsMutationVariables = Exact<{
  bulk: ContactBulkOperationRequestInput;
  listIds: Array<InputMaybe<Scalars['Long']>> | InputMaybe<Scalars['Long']>;
}>;


export type AddToListsMutation = { __typename?: 'Mutation', addToLists?: string | null };

export type RemoveFromListsMutationVariables = Exact<{
  bulk: ContactBulkOperationRequestInput;
  listIds: Array<InputMaybe<Scalars['Long']>> | InputMaybe<Scalars['Long']>;
}>;


export type RemoveFromListsMutation = { __typename?: 'Mutation', removeFromLists?: string | null };

export type CreateContactCardMutationVariables = Exact<{
  cardInput: ContactCardRequestInput;
}>;


export type CreateContactCardMutation = { __typename?: 'Mutation', createContactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null };

export type UpdateContactCardMutationVariables = Exact<{
  cardInput: ContactCardRequestInput;
  contactCardId: Scalars['Long'];
}>;


export type UpdateContactCardMutation = { __typename?: 'Mutation', updateContactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null };

export type RemoveContactCardsMutationVariables = Exact<{
  cardIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>> | InputMaybe<Scalars['Long']>>;
}>;


export type RemoveContactCardsMutation = { __typename?: 'Mutation', removeContactCards?: string | null };

export type RequestDoubleOptInConfirmationMutationVariables = Exact<{
  contactIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>> | InputMaybe<Scalars['Long']>>;
}>;


export type RequestDoubleOptInConfirmationMutation = { __typename?: 'Mutation', requestDoubleOptInConfirmation: boolean };

export type VerifyContactsMutationVariables = Exact<{
  bulk: ContactBulkOperationRequestInput;
}>;


export type VerifyContactsMutation = { __typename?: 'Mutation', verifyContacts?: string | null };

export type VerifyContactListsMutationVariables = Exact<{
  listIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>> | InputMaybe<Scalars['Long']>>;
}>;


export type VerifyContactListsMutation = { __typename?: 'Mutation', verifyContactLists?: Array<{ __typename?: 'Listing', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, activeContactsCount: any, invalidContactsCount: any, totalContactsCount: any, unsubscribedContactsCount: any } | null> | null };

export type ContactBulkArchiveMutationVariables = Exact<{
  bulk: ContactBulkOperationRequestInput;
}>;


export type ContactBulkArchiveMutation = { __typename?: 'Mutation', contactBulkArchive?: string | null };

export type ContactBulkUnArchiveMutationVariables = Exact<{
  bulk: ContactBulkOperationRequestInput;
}>;


export type ContactBulkUnArchiveMutation = { __typename?: 'Mutation', contactBulkUnArchive?: string | null };

export type ContactBulkReSubscribeMutationVariables = Exact<{
  bulk: ContactBulkOperationRequestInput;
}>;


export type ContactBulkReSubscribeMutation = { __typename?: 'Mutation', contactBulkReSubscribe?: string | null };

export type ContactBulkSoftUnsubscribeMutationVariables = Exact<{
  bulk: ContactBulkOperationRequestInput;
}>;


export type ContactBulkSoftUnsubscribeMutation = { __typename?: 'Mutation', contactBulkSoftUnsubscribe?: string | null };

export type CustomFieldsFragmentFragment = { __typename?: 'CustomField', createdAt?: any | null, type?: CustomFieldType | null, id?: any | null, name?: string | null, displayIndex?: number | null, key?: string | null, used?: boolean | null };

export type GetCustomFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomFieldsQuery = { __typename?: 'Query', getCustomFields?: Array<{ __typename?: 'CustomField', createdAt?: any | null, type?: CustomFieldType | null, id?: any | null, name?: string | null, displayIndex?: number | null, key?: string | null, used?: boolean | null } | null> | null };

export type UpdateCustomFieldsMutationVariables = Exact<{
  fields: CustomFieldsRequestInput;
}>;


export type UpdateCustomFieldsMutation = { __typename?: 'Mutation', updateCustomFields?: Array<{ __typename?: 'CustomField', createdAt?: any | null, type?: CustomFieldType | null, id?: any | null, name?: string | null, displayIndex?: number | null, key?: string | null, used?: boolean | null } | null> | null };

export type ListFragmentFragment = { __typename?: 'Listing', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, activeContactsCount: any, invalidContactsCount: any, totalContactsCount: any, unsubscribedContactsCount: any };

export type ListingLightFragment = { __typename?: 'ListingLight', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null };

export type ListResponseFragment = { __typename?: 'ListResponse', id?: any | null, name?: string | null, activeContactsCount: any };

export type ListResponseForTableFragment = { __typename?: 'ListResponse', id?: any | null, name?: string | null, createdAt?: any | null, activeContactsCount: any, invalidContactsCount: any, totalContactsCount: any, unsubscribedContactsCount: any, keywords?: Array<{ __typename?: 'KeywordForm', id?: any | null, name?: string | null } | null> | null, webForms?: Array<{ __typename?: 'WebFormForm', id?: any | null, name?: string | null } | null> | null };

export type ContactCustomFieldsFragmentFragment = { __typename?: 'ContactCustomField', text?: string | null, date?: any | null, number?: any | null, contactFieldId?: { __typename?: 'ContactFieldId', contactId?: any | null, fieldId?: any | null } | null, field?: { __typename?: 'CustomField', key?: string | null, type?: CustomFieldType | null, name?: string | null } | null };

export type ContactCustomFieldResponseFragment = { __typename?: 'ContactCustomFieldResponse', name?: string | null, type?: string | null, key?: string | null, date?: any | null, number?: any | null, text?: string | null };

export type ContactListFragmentFragment = { __typename?: 'ListContact', listing?: { __typename?: 'Listing', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, activeContactsCount: any, invalidContactsCount: any, totalContactsCount: any, unsubscribedContactsCount: any } | null };

export type ContactFragmentFragment = { __typename?: 'Contact', id?: any | null, email?: string | null, name?: string | null, formattedPhoneNumber?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, createdAt?: any | null, charged: boolean, optIn?: ContactOptIn | null, status?: Status | null, carrierType?: string | null, listContacts?: Array<{ __typename?: 'ListContact', listing?: { __typename?: 'Listing', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, activeContactsCount: any, invalidContactsCount: any, totalContactsCount: any, unsubscribedContactsCount: any } | null } | null> | null, contactSource?: { __typename?: 'ContactSource', name?: string | null, id?: any | null, sourceType?: SourceType | null } | null, customFields?: Array<{ __typename?: 'ContactCustomField', text?: string | null, date?: any | null, number?: any | null, contactFieldId?: { __typename?: 'ContactFieldId', contactId?: any | null, fieldId?: any | null } | null, field?: { __typename?: 'CustomField', key?: string | null, type?: CustomFieldType | null, name?: string | null } | null } | null> | null };

export type ContactsLightResponseFragment = { __typename?: 'PageResponse_ContactLightResponse', pageNumber: number, total: any, pageSize: number, content?: Array<{ __typename?: 'ContactLightResponse', id?: any | null, name?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, createdAt?: any | null, status?: Status | null, carrierType?: string | null, optIn?: ContactOptIn | null, listings?: Array<{ __typename?: 'ListingLight', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null } | null> | null, contactCustomFields?: Array<{ __typename?: 'ContactCustomFieldResponse', name?: string | null, type?: string | null, key?: string | null, date?: any | null, number?: any | null, text?: string | null } | null> | null } | null> | null };

export type ContactLightResponseFragment = { __typename?: 'ContactLightResponse', email?: string | null, name?: string | null, id?: any | null, phone?: string | null, createdAt?: any | null };

export type ContactLightResponseForTableFragment = { __typename?: 'ContactLightResponse', id?: any | null, name?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, createdAt?: any | null, status?: Status | null, carrierType?: string | null, optIn?: ContactOptIn | null, listings?: Array<{ __typename?: 'ListingLight', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null } | null> | null, contactCustomFields?: Array<{ __typename?: 'ContactCustomFieldResponse', name?: string | null, type?: string | null, key?: string | null, date?: any | null, number?: any | null, text?: string | null } | null> | null };

export type ContactCardFragment = { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null };

export type ContactImportStateFragment = { __typename?: 'ContactImportState', status?: Status | null, successPercentage: number, originalFileName?: string | null, createdAt?: any | null, updatedAt?: any | null, id?: any | null, columns?: Array<string | null> | null, deletedAt?: any | null, skipFirstRow: boolean, invalidCount: number, successCount: number, contactsLimit: number, fileKey?: string | null, simplifiedStatus?: Status | null, allowImportStatus?: AllowImportStatus | null, organization?: { __typename?: 'Organization', id?: any | null, importApprovedAt?: any | null, companyName?: string | null, importApprover?: { __typename?: 'Member', id?: any | null, profile?: { __typename?: 'MemberProfile', name?: string | null } | null } | null } | null, member?: { __typename?: 'Member', id?: any | null, profile?: { __typename?: 'MemberProfile', name?: string | null, firstName?: string | null, lastName?: string | null } | null } | null };

export type GetImportHistoryQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
  statuses?: InputMaybe<Array<InputMaybe<Status>> | InputMaybe<Status>>;
}>;


export type GetImportHistoryQuery = { __typename?: 'Query', getImportHistory?: { __typename?: 'PageResponse_ContactImportState', pageNumber: number, pageSize: number, total: any, content?: Array<{ __typename?: 'ContactImportState', status?: Status | null, successPercentage: number, originalFileName?: string | null, createdAt?: any | null, updatedAt?: any | null, id?: any | null, columns?: Array<string | null> | null, deletedAt?: any | null, skipFirstRow: boolean, invalidCount: number, successCount: number, contactsLimit: number, fileKey?: string | null, simplifiedStatus?: Status | null, allowImportStatus?: AllowImportStatus | null, organization?: { __typename?: 'Organization', id?: any | null, importApprovedAt?: any | null, companyName?: string | null, importApprover?: { __typename?: 'Member', id?: any | null, profile?: { __typename?: 'MemberProfile', name?: string | null } | null } | null } | null, member?: { __typename?: 'Member', id?: any | null, profile?: { __typename?: 'MemberProfile', name?: string | null, firstName?: string | null, lastName?: string | null } | null } | null } | null> | null } | null, getMyOrganization?: { __typename?: 'Organization', allowImport: boolean } | null };

export type GetSkippedContactsQueryVariables = Exact<{
  page: PaginationInput;
  importStateId: Scalars['Long'];
}>;


export type GetSkippedContactsQuery = { __typename?: 'Query', getSkippedContacts?: { __typename?: 'UnvalidatedContactPage', total: any, pageSize: number, pageNumber: number, importState?: { __typename?: 'ContactImportState', status?: Status | null, successPercentage: number, originalFileName?: string | null, createdAt?: any | null, updatedAt?: any | null, id?: any | null, columns?: Array<string | null> | null, deletedAt?: any | null, skipFirstRow: boolean, invalidCount: number, successCount: number, contactsLimit: number, fileKey?: string | null, simplifiedStatus?: Status | null, allowImportStatus?: AllowImportStatus | null, organization?: { __typename?: 'Organization', id?: any | null, importApprovedAt?: any | null, companyName?: string | null, importApprover?: { __typename?: 'Member', id?: any | null, profile?: { __typename?: 'MemberProfile', name?: string | null } | null } | null } | null, member?: { __typename?: 'Member', id?: any | null, profile?: { __typename?: 'MemberProfile', name?: string | null, firstName?: string | null, lastName?: string | null } | null } | null } | null, content?: Array<{ __typename?: 'UnvalidatedContact', name?: string | null, id?: any | null, phoneNumber?: string | null, invalidReason?: string | null } | null> | null } | null };

export type RemoveContactImportStatesMutationVariables = Exact<{
  importStateIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>> | InputMaybe<Scalars['Long']>>;
}>;


export type RemoveContactImportStatesMutation = { __typename?: 'Mutation', removeContactImportStates?: string | null };

export type FilterOptionFragment = { __typename?: 'FilterOption', dataType?: FilterDataType | null, ext?: string | null, key?: string | null, label?: string | null, options?: Array<{ __typename?: 'Labeled', label?: string | null, key?: string | null } | null> | null };

export type FilterFragment = { __typename?: 'Filter', field?: string | null, dataType?: FilterDataType | null, andIndex: number, condition?: FilterCondition | null, orIndex: number, type?: FilterFieldType | null, value?: string | null, valueExt?: string | null };

export type FilterValueFragment = { __typename?: 'FilterValue', contactIds?: Array<any | null> | null, segmentIds?: Array<any | null> | null, listIds?: Array<any | null> | null, filters?: Array<{ __typename?: 'Filter', field?: string | null, dataType?: FilterDataType | null, andIndex: number, condition?: FilterCondition | null, orIndex: number, type?: FilterFieldType | null, value?: string | null, valueExt?: string | null } | null> | null };

export type SegmentResponseFragment = { __typename?: 'SegmentResponse', createdAt?: any | null, name?: string | null, id?: any | null, updatedAt?: any | null, filterValue?: { __typename?: 'FilterValue', contactIds?: Array<any | null> | null, segmentIds?: Array<any | null> | null, listIds?: Array<any | null> | null, filters?: Array<{ __typename?: 'Filter', field?: string | null, dataType?: FilterDataType | null, andIndex: number, condition?: FilterCondition | null, orIndex: number, type?: FilterFieldType | null, value?: string | null, valueExt?: string | null } | null> | null } | null };

export type GetAvailableFilterFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableFilterFieldsQuery = { __typename?: 'Query', getAvailableFilterFields?: { __typename?: 'FilterFieldsResponse', dataTypeConditions?: any | null, fields?: Array<{ __typename?: 'FilterOption', dataType?: FilterDataType | null, ext?: string | null, key?: string | null, label?: string | null, options?: Array<{ __typename?: 'Labeled', label?: string | null, key?: string | null } | null> | null } | null> | null } | null };

export type CreateSegmentMutationVariables = Exact<{
  segment?: InputMaybe<UpdateSegmentRequestInput>;
}>;


export type CreateSegmentMutation = { __typename?: 'Mutation', createSegment?: { __typename?: 'SegmentResponse', createdAt?: any | null, name?: string | null, id?: any | null, updatedAt?: any | null, filterValue?: { __typename?: 'FilterValue', contactIds?: Array<any | null> | null, segmentIds?: Array<any | null> | null, listIds?: Array<any | null> | null, filters?: Array<{ __typename?: 'Filter', field?: string | null, dataType?: FilterDataType | null, andIndex: number, condition?: FilterCondition | null, orIndex: number, type?: FilterFieldType | null, value?: string | null, valueExt?: string | null } | null> | null } | null } | null };

export type UpdateSegmentMutationVariables = Exact<{
  segment?: InputMaybe<UpdateSegmentRequestInput>;
}>;


export type UpdateSegmentMutation = { __typename?: 'Mutation', updateSegment?: { __typename?: 'SegmentResponse', createdAt?: any | null, name?: string | null, id?: any | null, updatedAt?: any | null, filterValue?: { __typename?: 'FilterValue', contactIds?: Array<any | null> | null, segmentIds?: Array<any | null> | null, listIds?: Array<any | null> | null, filters?: Array<{ __typename?: 'Filter', field?: string | null, dataType?: FilterDataType | null, andIndex: number, condition?: FilterCondition | null, orIndex: number, type?: FilterFieldType | null, value?: string | null, valueExt?: string | null } | null> | null } | null } | null };

export type GetSegmentsQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
  searchPattern?: InputMaybe<Scalars['String']>;
}>;


export type GetSegmentsQuery = { __typename?: 'Query', getSegments?: { __typename?: 'PageResponse_SegmentResponse', pageNumber: number, pageSize: number, total: any, content?: Array<{ __typename?: 'SegmentResponse', createdAt?: any | null, name?: string | null, id?: any | null, updatedAt?: any | null, filterValue?: { __typename?: 'FilterValue', contactIds?: Array<any | null> | null, segmentIds?: Array<any | null> | null, listIds?: Array<any | null> | null, filters?: Array<{ __typename?: 'Filter', field?: string | null, dataType?: FilterDataType | null, andIndex: number, condition?: FilterCondition | null, orIndex: number, type?: FilterFieldType | null, value?: string | null, valueExt?: string | null } | null> | null } | null } | null> | null } | null };

export type GetSegmentQueryVariables = Exact<{
  segmentId: Scalars['Long'];
}>;


export type GetSegmentQuery = { __typename?: 'Query', getSegment?: { __typename?: 'SegmentResponse', createdAt?: any | null, name?: string | null, id?: any | null, updatedAt?: any | null, filterValue?: { __typename?: 'FilterValue', contactIds?: Array<any | null> | null, segmentIds?: Array<any | null> | null, listIds?: Array<any | null> | null, filters?: Array<{ __typename?: 'Filter', field?: string | null, dataType?: FilterDataType | null, andIndex: number, condition?: FilterCondition | null, orIndex: number, type?: FilterFieldType | null, value?: string | null, valueExt?: string | null } | null> | null } | null } | null };

export type EvaluateFilterQueryVariables = Exact<{
  filterValue: FilterValueInput;
  page?: InputMaybe<PaginationInput>;
}>;


export type EvaluateFilterQuery = { __typename?: 'Query', evaluateFilter?: { __typename?: 'PageResponse_ContactLightResponse', total: any, content?: Array<{ __typename?: 'ContactLightResponse', id?: any | null, name?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, createdAt?: any | null, status?: Status | null, carrierType?: string | null, optIn?: ContactOptIn | null, listings?: Array<{ __typename?: 'ListingLight', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null } | null> | null, contactCustomFields?: Array<{ __typename?: 'ContactCustomFieldResponse', name?: string | null, type?: string | null, key?: string | null, date?: any | null, number?: any | null, text?: string | null } | null> | null } | null> | null } | null };

export type DeleteSegmentsMutationVariables = Exact<{
  segmentIds?: InputMaybe<Array<Scalars['Long']> | Scalars['Long']>;
}>;


export type DeleteSegmentsMutation = { __typename?: 'Mutation', deleteSegments: boolean };

export type KeywordFragmentFragment = { __typename?: 'Keyword', uuid?: any | null, createdAt?: any | null, status: Status, listIds?: Array<any | null> | null, name: string, id?: any | null, sourceName: string, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, keywordLists?: Array<{ __typename?: 'ListKeyword', listing?: { __typename?: 'Listing', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, activeContactsCount: any, invalidContactsCount: any, totalContactsCount: any, unsubscribedContactsCount: any } | null } | null> | null, keywordPhoneNumbers?: Array<{ __typename?: 'KeywordPhoneNumber', phoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null } | null> | null, contactStatusStatistics?: { __typename?: 'KeywordContactStatusStatistics', unsubscribedCount: any, activeCount: any, subscribersCount: any } | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', total?: any | null, revenue?: number | null } | null, conversion?: { __typename?: 'Conversion', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit?: boolean | null, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null, dataCaptureConfig?: { __typename?: 'DataCaptureConfig', retriesCount: number, lastReplyConfig?: { __typename?: 'WorkflowSmsConfig', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, assets?: Array<{ __typename?: 'AssetLight', id?: any | null, size?: any | null, originalFileName?: string | null, sourceUrl?: string | null, sourceSize: any, contentType?: string | null } | null> | null, audios?: Array<{ __typename?: 'AudioItemLight', size?: any | null, url?: string | null, type?: AudioType | null, duration: number, fileKey?: string | null } | null> | null, contactCards?: Array<{ __typename?: 'ContactCardLight', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null> | null } | null, fieldCaptures?: Array<{ __typename?: 'FieldCapture', fieldName?: string | null, index: number, smsConfig?: { __typename?: 'WorkflowSmsConfig', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, assets?: Array<{ __typename?: 'AssetLight', id?: any | null, size?: any | null, originalFileName?: string | null, sourceUrl?: string | null, sourceSize: any, contentType?: string | null } | null> | null, audios?: Array<{ __typename?: 'AudioItemLight', size?: any | null, url?: string | null, type?: AudioType | null, duration: number, fileKey?: string | null } | null> | null, contactCards?: Array<{ __typename?: 'ContactCardLight', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null> | null } | null } | null> | null } | null };

export type GetAllKeywordsQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
  searchPattern?: InputMaybe<Scalars['String']>;
}>;


export type GetAllKeywordsQuery = { __typename?: 'Query', getAllKeywords?: { __typename?: 'PageResponse_Keyword', pageNumber: number, pageSize: number, total: any, content?: Array<{ __typename?: 'Keyword', uuid?: any | null, createdAt?: any | null, status: Status, listIds?: Array<any | null> | null, name: string, id?: any | null, sourceName: string, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, keywordLists?: Array<{ __typename?: 'ListKeyword', listing?: { __typename?: 'Listing', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, activeContactsCount: any, invalidContactsCount: any, totalContactsCount: any, unsubscribedContactsCount: any } | null } | null> | null, keywordPhoneNumbers?: Array<{ __typename?: 'KeywordPhoneNumber', phoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null } | null> | null, contactStatusStatistics?: { __typename?: 'KeywordContactStatusStatistics', unsubscribedCount: any, activeCount: any, subscribersCount: any } | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', total?: any | null, revenue?: number | null } | null, conversion?: { __typename?: 'Conversion', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit?: boolean | null, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null, dataCaptureConfig?: { __typename?: 'DataCaptureConfig', retriesCount: number, lastReplyConfig?: { __typename?: 'WorkflowSmsConfig', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, assets?: Array<{ __typename?: 'AssetLight', id?: any | null, size?: any | null, originalFileName?: string | null, sourceUrl?: string | null, sourceSize: any, contentType?: string | null } | null> | null, audios?: Array<{ __typename?: 'AudioItemLight', size?: any | null, url?: string | null, type?: AudioType | null, duration: number, fileKey?: string | null } | null> | null, contactCards?: Array<{ __typename?: 'ContactCardLight', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null> | null } | null, fieldCaptures?: Array<{ __typename?: 'FieldCapture', fieldName?: string | null, index: number, smsConfig?: { __typename?: 'WorkflowSmsConfig', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, assets?: Array<{ __typename?: 'AssetLight', id?: any | null, size?: any | null, originalFileName?: string | null, sourceUrl?: string | null, sourceSize: any, contentType?: string | null } | null> | null, audios?: Array<{ __typename?: 'AudioItemLight', size?: any | null, url?: string | null, type?: AudioType | null, duration: number, fileKey?: string | null } | null> | null, contactCards?: Array<{ __typename?: 'ContactCardLight', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null> | null } | null } | null> | null } | null } | null> | null } | null };

export type GetExistingKeywordPhoneNumbersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExistingKeywordPhoneNumbersQuery = { __typename?: 'Query', getExistingKeywordPhoneNumbers?: any | null };

export type GetKeywordByIdQueryVariables = Exact<{
  keywordId?: InputMaybe<Scalars['Long']>;
}>;


export type GetKeywordByIdQuery = { __typename?: 'Query', getKeywordById?: { __typename?: 'Keyword', uuid?: any | null, createdAt?: any | null, status: Status, listIds?: Array<any | null> | null, name: string, id?: any | null, sourceName: string, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, keywordLists?: Array<{ __typename?: 'ListKeyword', listing?: { __typename?: 'Listing', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, activeContactsCount: any, invalidContactsCount: any, totalContactsCount: any, unsubscribedContactsCount: any } | null } | null> | null, keywordPhoneNumbers?: Array<{ __typename?: 'KeywordPhoneNumber', phoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null } | null> | null, contactStatusStatistics?: { __typename?: 'KeywordContactStatusStatistics', unsubscribedCount: any, activeCount: any, subscribersCount: any } | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', total?: any | null, revenue?: number | null } | null, conversion?: { __typename?: 'Conversion', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit?: boolean | null, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null, dataCaptureConfig?: { __typename?: 'DataCaptureConfig', retriesCount: number, lastReplyConfig?: { __typename?: 'WorkflowSmsConfig', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, assets?: Array<{ __typename?: 'AssetLight', id?: any | null, size?: any | null, originalFileName?: string | null, sourceUrl?: string | null, sourceSize: any, contentType?: string | null } | null> | null, audios?: Array<{ __typename?: 'AudioItemLight', size?: any | null, url?: string | null, type?: AudioType | null, duration: number, fileKey?: string | null } | null> | null, contactCards?: Array<{ __typename?: 'ContactCardLight', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null> | null } | null, fieldCaptures?: Array<{ __typename?: 'FieldCapture', fieldName?: string | null, index: number, smsConfig?: { __typename?: 'WorkflowSmsConfig', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, assets?: Array<{ __typename?: 'AssetLight', id?: any | null, size?: any | null, originalFileName?: string | null, sourceUrl?: string | null, sourceSize: any, contentType?: string | null } | null> | null, audios?: Array<{ __typename?: 'AudioItemLight', size?: any | null, url?: string | null, type?: AudioType | null, duration: number, fileKey?: string | null } | null> | null, contactCards?: Array<{ __typename?: 'ContactCardLight', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null> | null } | null } | null> | null } | null } | null };

export type GetKeywordContactStatisticsQueryVariables = Exact<{
  keywordId: Scalars['Long'];
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
}>;


export type GetKeywordContactStatisticsQuery = { __typename?: 'Query', getKeywordContactStatistics?: { __typename?: 'KeywordContactStatisticsResponse', chargeStatistics?: { __typename?: 'ChargeStatistics', totalCharged?: number | null } | null, percentageStatistics?: { __typename?: 'KeywordContactPercentageStatistics', activePercentage: number, unsubscribedPercentage: number } | null, todayStatistics?: { __typename?: 'KeywordContactStatusStatistics', subscribersCount: any, activeCount: any, unsubscribedCount: any } | null, totalStatistics?: { __typename?: 'KeywordContactStatusStatistics', unsubscribedCount: any, activeCount: any, subscribersCount: any } | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'TodayConversionStatistics', revenue?: number | null, roi?: number | null, totalCosts?: number | null, total?: any | null, percentage?: number | null, todayConversionStatistics?: { __typename?: 'ConversionStatistics', percentage?: number | null, revenue?: number | null, totalCosts?: number | null, roi?: number | null, total?: any | null } | null } | null } | null };

export type GetKeywordContactsQueryVariables = Exact<{
  keywordId: Scalars['Long'];
  page?: InputMaybe<PaginationInput>;
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
  status?: InputMaybe<Status>;
}>;


export type GetKeywordContactsQuery = { __typename?: 'Query', getKeywordContacts?: { __typename?: 'PageResponse_KeywordContactResponse', pageNumber: number, pageSize: number, total: any, content?: Array<{ __typename?: 'KeywordContactResponse', status?: Status | null, name?: string | null, addedTime?: any | null, phone?: string | null } | null> | null } | null };

export type CreateKeywordMutationVariables = Exact<{
  keywordInput: KeywordInput;
}>;


export type CreateKeywordMutation = { __typename?: 'Mutation', createKeyword?: { __typename?: 'Keyword', uuid?: any | null, createdAt?: any | null, status: Status, listIds?: Array<any | null> | null, name: string, id?: any | null, sourceName: string, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, keywordLists?: Array<{ __typename?: 'ListKeyword', listing?: { __typename?: 'Listing', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, activeContactsCount: any, invalidContactsCount: any, totalContactsCount: any, unsubscribedContactsCount: any } | null } | null> | null, keywordPhoneNumbers?: Array<{ __typename?: 'KeywordPhoneNumber', phoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null } | null> | null, contactStatusStatistics?: { __typename?: 'KeywordContactStatusStatistics', unsubscribedCount: any, activeCount: any, subscribersCount: any } | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', total?: any | null, revenue?: number | null } | null, conversion?: { __typename?: 'Conversion', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit?: boolean | null, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null, dataCaptureConfig?: { __typename?: 'DataCaptureConfig', retriesCount: number, lastReplyConfig?: { __typename?: 'WorkflowSmsConfig', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, assets?: Array<{ __typename?: 'AssetLight', id?: any | null, size?: any | null, originalFileName?: string | null, sourceUrl?: string | null, sourceSize: any, contentType?: string | null } | null> | null, audios?: Array<{ __typename?: 'AudioItemLight', size?: any | null, url?: string | null, type?: AudioType | null, duration: number, fileKey?: string | null } | null> | null, contactCards?: Array<{ __typename?: 'ContactCardLight', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null> | null } | null, fieldCaptures?: Array<{ __typename?: 'FieldCapture', fieldName?: string | null, index: number, smsConfig?: { __typename?: 'WorkflowSmsConfig', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, assets?: Array<{ __typename?: 'AssetLight', id?: any | null, size?: any | null, originalFileName?: string | null, sourceUrl?: string | null, sourceSize: any, contentType?: string | null } | null> | null, audios?: Array<{ __typename?: 'AudioItemLight', size?: any | null, url?: string | null, type?: AudioType | null, duration: number, fileKey?: string | null } | null> | null, contactCards?: Array<{ __typename?: 'ContactCardLight', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null> | null } | null } | null> | null } | null } | null };

export type UpdateKeywordMutationVariables = Exact<{
  keywordInput: KeywordInput;
}>;


export type UpdateKeywordMutation = { __typename?: 'Mutation', updateKeyword?: { __typename?: 'Keyword', uuid?: any | null, createdAt?: any | null, status: Status, listIds?: Array<any | null> | null, name: string, id?: any | null, sourceName: string, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, keywordLists?: Array<{ __typename?: 'ListKeyword', listing?: { __typename?: 'Listing', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, activeContactsCount: any, invalidContactsCount: any, totalContactsCount: any, unsubscribedContactsCount: any } | null } | null> | null, keywordPhoneNumbers?: Array<{ __typename?: 'KeywordPhoneNumber', phoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null } | null> | null, contactStatusStatistics?: { __typename?: 'KeywordContactStatusStatistics', unsubscribedCount: any, activeCount: any, subscribersCount: any } | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', total?: any | null, revenue?: number | null } | null, conversion?: { __typename?: 'Conversion', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit?: boolean | null, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null, dataCaptureConfig?: { __typename?: 'DataCaptureConfig', retriesCount: number, lastReplyConfig?: { __typename?: 'WorkflowSmsConfig', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, assets?: Array<{ __typename?: 'AssetLight', id?: any | null, size?: any | null, originalFileName?: string | null, sourceUrl?: string | null, sourceSize: any, contentType?: string | null } | null> | null, audios?: Array<{ __typename?: 'AudioItemLight', size?: any | null, url?: string | null, type?: AudioType | null, duration: number, fileKey?: string | null } | null> | null, contactCards?: Array<{ __typename?: 'ContactCardLight', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null> | null } | null, fieldCaptures?: Array<{ __typename?: 'FieldCapture', fieldName?: string | null, index: number, smsConfig?: { __typename?: 'WorkflowSmsConfig', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, assets?: Array<{ __typename?: 'AssetLight', id?: any | null, size?: any | null, originalFileName?: string | null, sourceUrl?: string | null, sourceSize: any, contentType?: string | null } | null> | null, audios?: Array<{ __typename?: 'AudioItemLight', size?: any | null, url?: string | null, type?: AudioType | null, duration: number, fileKey?: string | null } | null> | null, contactCards?: Array<{ __typename?: 'ContactCardLight', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null> | null } | null } | null> | null } | null } | null };

export type RemoveKeywordsMutationVariables = Exact<{
  keywordIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>> | InputMaybe<Scalars['Long']>>;
}>;


export type RemoveKeywordsMutation = { __typename?: 'Mutation', removeKeywords?: string | null };

export type DisableKeywordMutationVariables = Exact<{
  id: Scalars['Long'];
}>;


export type DisableKeywordMutation = { __typename?: 'Mutation', disableKeyword?: { __typename?: 'Keyword', uuid?: any | null, createdAt?: any | null, status: Status, listIds?: Array<any | null> | null, name: string, id?: any | null, sourceName: string, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, keywordLists?: Array<{ __typename?: 'ListKeyword', listing?: { __typename?: 'Listing', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, activeContactsCount: any, invalidContactsCount: any, totalContactsCount: any, unsubscribedContactsCount: any } | null } | null> | null, keywordPhoneNumbers?: Array<{ __typename?: 'KeywordPhoneNumber', phoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null } | null> | null, contactStatusStatistics?: { __typename?: 'KeywordContactStatusStatistics', unsubscribedCount: any, activeCount: any, subscribersCount: any } | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', total?: any | null, revenue?: number | null } | null, conversion?: { __typename?: 'Conversion', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit?: boolean | null, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null, dataCaptureConfig?: { __typename?: 'DataCaptureConfig', retriesCount: number, lastReplyConfig?: { __typename?: 'WorkflowSmsConfig', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, assets?: Array<{ __typename?: 'AssetLight', id?: any | null, size?: any | null, originalFileName?: string | null, sourceUrl?: string | null, sourceSize: any, contentType?: string | null } | null> | null, audios?: Array<{ __typename?: 'AudioItemLight', size?: any | null, url?: string | null, type?: AudioType | null, duration: number, fileKey?: string | null } | null> | null, contactCards?: Array<{ __typename?: 'ContactCardLight', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null> | null } | null, fieldCaptures?: Array<{ __typename?: 'FieldCapture', fieldName?: string | null, index: number, smsConfig?: { __typename?: 'WorkflowSmsConfig', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, assets?: Array<{ __typename?: 'AssetLight', id?: any | null, size?: any | null, originalFileName?: string | null, sourceUrl?: string | null, sourceSize: any, contentType?: string | null } | null> | null, audios?: Array<{ __typename?: 'AudioItemLight', size?: any | null, url?: string | null, type?: AudioType | null, duration: number, fileKey?: string | null } | null> | null, contactCards?: Array<{ __typename?: 'ContactCardLight', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null> | null } | null } | null> | null } | null } | null };

export type EnableKeywordMutationVariables = Exact<{
  id: Scalars['Long'];
}>;


export type EnableKeywordMutation = { __typename?: 'Mutation', enableKeyword?: { __typename?: 'Keyword', uuid?: any | null, createdAt?: any | null, status: Status, listIds?: Array<any | null> | null, name: string, id?: any | null, sourceName: string, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, keywordLists?: Array<{ __typename?: 'ListKeyword', listing?: { __typename?: 'Listing', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, activeContactsCount: any, invalidContactsCount: any, totalContactsCount: any, unsubscribedContactsCount: any } | null } | null> | null, keywordPhoneNumbers?: Array<{ __typename?: 'KeywordPhoneNumber', phoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null } | null> | null, contactStatusStatistics?: { __typename?: 'KeywordContactStatusStatistics', unsubscribedCount: any, activeCount: any, subscribersCount: any } | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', total?: any | null, revenue?: number | null } | null, conversion?: { __typename?: 'Conversion', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit?: boolean | null, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null, dataCaptureConfig?: { __typename?: 'DataCaptureConfig', retriesCount: number, lastReplyConfig?: { __typename?: 'WorkflowSmsConfig', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, assets?: Array<{ __typename?: 'AssetLight', id?: any | null, size?: any | null, originalFileName?: string | null, sourceUrl?: string | null, sourceSize: any, contentType?: string | null } | null> | null, audios?: Array<{ __typename?: 'AudioItemLight', size?: any | null, url?: string | null, type?: AudioType | null, duration: number, fileKey?: string | null } | null> | null, contactCards?: Array<{ __typename?: 'ContactCardLight', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null> | null } | null, fieldCaptures?: Array<{ __typename?: 'FieldCapture', fieldName?: string | null, index: number, smsConfig?: { __typename?: 'WorkflowSmsConfig', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, assets?: Array<{ __typename?: 'AssetLight', id?: any | null, size?: any | null, originalFileName?: string | null, sourceUrl?: string | null, sourceSize: any, contentType?: string | null } | null> | null, audios?: Array<{ __typename?: 'AudioItemLight', size?: any | null, url?: string | null, type?: AudioType | null, duration: number, fileKey?: string | null } | null> | null, contactCards?: Array<{ __typename?: 'ContactCardLight', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null> | null } | null } | null> | null } | null } | null };

export type MessageTemplateResponseFragment = { __typename?: 'MessageTemplateResponse', id?: any | null, name?: string | null, updatedAt?: any | null, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null };

export type GetMessageTemplatesQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
  searchPattern?: InputMaybe<Scalars['String']>;
}>;


export type GetMessageTemplatesQuery = { __typename?: 'Query', getMessageTemplates?: { __typename?: 'PageResponse_MessageTemplateResponse', total: any, pageNumber: number, content?: Array<{ __typename?: 'MessageTemplateResponse', id?: any | null, name?: string | null, updatedAt?: any | null, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null } | null> | null } | null };

export type GetMessageTemplateQueryVariables = Exact<{
  templateId?: InputMaybe<Scalars['Long']>;
}>;


export type GetMessageTemplateQuery = { __typename?: 'Query', getMessageTemplate?: { __typename?: 'MessageTemplateResponse', id?: any | null, name?: string | null, updatedAt?: any | null, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null } | null };

export type CreateMessageTemplateMutationVariables = Exact<{
  template?: InputMaybe<UpdateMessageTemplateRequestInput>;
}>;


export type CreateMessageTemplateMutation = { __typename?: 'Mutation', createMessageTemplate?: { __typename?: 'MessageTemplateResponse', id?: any | null, name?: string | null, updatedAt?: any | null, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null } | null };

export type UpdateMessageTemplateMutationVariables = Exact<{
  template?: InputMaybe<UpdateMessageTemplateRequestInput>;
}>;


export type UpdateMessageTemplateMutation = { __typename?: 'Mutation', updateMessageTemplate?: { __typename?: 'MessageTemplateResponse', id?: any | null, name?: string | null, updatedAt?: any | null, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null } | null };

export type DeleteMessageTemplatesMutationVariables = Exact<{
  templateIds?: InputMaybe<Array<InputMaybe<Scalars['Long']>> | InputMaybe<Scalars['Long']>>;
}>;


export type DeleteMessageTemplatesMutation = { __typename?: 'Mutation', deleteMessageTemplates: boolean };

export type UpdateMemberMutationVariables = Exact<{
  member: MemberUpdateInput;
}>;


export type UpdateMemberMutation = { __typename?: 'Mutation', updateMember?: { __typename?: 'MemberResponse', registrationFinished: boolean, name?: string | null, displayRole?: string | null, displayState?: string | null, isAdmin?: boolean | null, accessType?: InvitationAccessType | null, listIds?: Array<any | null> | null, invitationLink?: string | null, deletedAt?: any | null, updatedAt?: any | null, createdAt?: any | null, phone?: string | null, internationalPhone?: string | null, email?: string | null, role?: MemberRole | null, lastName?: string | null, firstName?: string | null, id?: any | null, state?: MemberState | null, memberHash?: string | null, uniqueId?: string | null, memberRegistration?: { __typename?: 'MemberRegistration', type?: MemberRegistrationType | null, oldCredits?: number | null, currentStep?: number | null, migratedEmail?: string | null, selectedPriceId?: string | null, migrationFinished: boolean, oldCreditsForPurchase: number, oldCreditsFree: number, oldCreditsLastYear: number, saveCredits: boolean, oldSubscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null } | null, organization?: { __typename?: 'Organization', id?: any | null, uuid?: any | null, updatedAt?: any | null, migrationStatus?: Status | null, createdAt?: any | null, companyName?: string | null, employees?: string | null, website?: string | null, formattedPhoneNumber?: string | null, phoneCountryCode?: string | null, status?: OrganizationStatus | null, phoneCheckerEnabled: boolean, allowImport: boolean, termsUrl?: string | null, complianceUrl?: string | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, recordingPin?: any | null, carrierFeePaymentFailed: boolean, contract: boolean, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null, userTimeZone?: { __typename?: 'UserTimeZone', fullName?: string | null, offset?: string | null, shortName?: string | null, zoneAbbreviation?: string | null, zoneId?: string | null } | null, invitationBid?: { __typename?: 'InvitationBid', role?: InvitationRole | null, expirationDate?: any | null, email?: string | null, uuid?: any | null, id?: any | null, listIds?: Array<any | null> | null } | null } | null };

export type UpdateLeadMemberMutationVariables = Exact<{
  member: MemberUpdateInput;
}>;


export type UpdateLeadMemberMutation = { __typename?: 'Mutation', updateLeadMember?: { __typename?: 'MemberResponse', registrationFinished: boolean, name?: string | null, displayRole?: string | null, displayState?: string | null, isAdmin?: boolean | null, accessType?: InvitationAccessType | null, listIds?: Array<any | null> | null, invitationLink?: string | null, deletedAt?: any | null, updatedAt?: any | null, createdAt?: any | null, phone?: string | null, internationalPhone?: string | null, email?: string | null, role?: MemberRole | null, lastName?: string | null, firstName?: string | null, id?: any | null, state?: MemberState | null, memberHash?: string | null, uniqueId?: string | null, memberRegistration?: { __typename?: 'MemberRegistration', type?: MemberRegistrationType | null, oldCredits?: number | null, currentStep?: number | null, migratedEmail?: string | null, selectedPriceId?: string | null, migrationFinished: boolean, oldCreditsForPurchase: number, oldCreditsFree: number, oldCreditsLastYear: number, saveCredits: boolean, oldSubscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null } | null, organization?: { __typename?: 'Organization', id?: any | null, uuid?: any | null, updatedAt?: any | null, migrationStatus?: Status | null, createdAt?: any | null, companyName?: string | null, employees?: string | null, website?: string | null, formattedPhoneNumber?: string | null, phoneCountryCode?: string | null, status?: OrganizationStatus | null, phoneCheckerEnabled: boolean, allowImport: boolean, termsUrl?: string | null, complianceUrl?: string | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, recordingPin?: any | null, carrierFeePaymentFailed: boolean, contract: boolean, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null, userTimeZone?: { __typename?: 'UserTimeZone', fullName?: string | null, offset?: string | null, shortName?: string | null, zoneAbbreviation?: string | null, zoneId?: string | null } | null, invitationBid?: { __typename?: 'InvitationBid', role?: InvitationRole | null, expirationDate?: any | null, email?: string | null, uuid?: any | null, id?: any | null, listIds?: Array<any | null> | null } | null } | null };

export type UpdateOrganizationMutationVariables = Exact<{
  organization: OrganizationUpdateInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization?: { __typename?: 'Organization', id?: any | null, uuid?: any | null, updatedAt?: any | null, migrationStatus?: Status | null, createdAt?: any | null, companyName?: string | null, employees?: string | null, website?: string | null, formattedPhoneNumber?: string | null, phoneCountryCode?: string | null, status?: OrganizationStatus | null, phoneCheckerEnabled: boolean, allowImport: boolean, termsUrl?: string | null, complianceUrl?: string | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, recordingPin?: any | null, carrierFeePaymentFailed: boolean, contract: boolean, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null };

export type UpdateOrganizationInfoMutationVariables = Exact<{
  input: OrganizationInfoUpdateInput;
}>;


export type UpdateOrganizationInfoMutation = { __typename?: 'Mutation', updateOrganizationInfo?: { __typename?: 'Organization', id?: any | null, uuid?: any | null, updatedAt?: any | null, migrationStatus?: Status | null, createdAt?: any | null, companyName?: string | null, employees?: string | null, website?: string | null, formattedPhoneNumber?: string | null, phoneCountryCode?: string | null, status?: OrganizationStatus | null, phoneCheckerEnabled: boolean, allowImport: boolean, termsUrl?: string | null, complianceUrl?: string | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, recordingPin?: any | null, carrierFeePaymentFailed: boolean, contract: boolean, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null };

export type ChangePasswordMutationVariables = Exact<{
  input: ChangePasswordRequestInput;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword?: string | null };

export type ChangeEmailMutationVariables = Exact<{
  input: ChangeEmailRequestInput;
}>;


export type ChangeEmailMutation = { __typename?: 'Mutation', changeEmail?: { __typename?: 'ChangeEmailResponse', email?: string | null, resendRemainingSeconds?: any | null } | null };

export type ConfirmChangeEmailMutationVariables = Exact<{
  input: ConfirmVerificationCodeRequestInput;
}>;


export type ConfirmChangeEmailMutation = { __typename?: 'Mutation', confirmChangeEmail?: { __typename?: 'UserInfoResponse', email?: string | null, token?: string | null } | null };

export type RestorePasswordMutationVariables = Exact<{ [key: string]: never; }>;


export type RestorePasswordMutation = { __typename?: 'Mutation', restorePassword?: { __typename?: 'ChangePasswordResponse', resendRemainingSeconds?: any | null } | null };

export type VerifyRestorePasswordCodeMutationVariables = Exact<{
  input: ConfirmVerificationCodeRequestInput;
}>;


export type VerifyRestorePasswordCodeMutation = { __typename?: 'Mutation', verifyRestorePasswordCode?: string | null };

export type ConfirmRestorePasswordMutationVariables = Exact<{
  input: ConfirmChangePasswordRequestInput;
}>;


export type ConfirmRestorePasswordMutation = { __typename?: 'Mutation', confirmRestorePassword?: { __typename?: 'UserInfoResponse', token?: string | null } | null };

export type ContactDetailsRegistrationStepMutationVariables = Exact<{
  input: RegistrationContactDetailsInput;
}>;


export type ContactDetailsRegistrationStepMutation = { __typename?: 'Mutation', contactDetailsRegistrationStep?: { __typename?: 'MemberResponse', registrationFinished: boolean, name?: string | null, displayRole?: string | null, displayState?: string | null, isAdmin?: boolean | null, accessType?: InvitationAccessType | null, listIds?: Array<any | null> | null, invitationLink?: string | null, deletedAt?: any | null, updatedAt?: any | null, createdAt?: any | null, phone?: string | null, internationalPhone?: string | null, email?: string | null, role?: MemberRole | null, lastName?: string | null, firstName?: string | null, id?: any | null, state?: MemberState | null, memberHash?: string | null, uniqueId?: string | null, memberRegistration?: { __typename?: 'MemberRegistration', type?: MemberRegistrationType | null, oldCredits?: number | null, currentStep?: number | null, migratedEmail?: string | null, selectedPriceId?: string | null, migrationFinished: boolean, oldCreditsForPurchase: number, oldCreditsFree: number, oldCreditsLastYear: number, saveCredits: boolean, oldSubscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null } | null, organization?: { __typename?: 'Organization', id?: any | null, uuid?: any | null, updatedAt?: any | null, migrationStatus?: Status | null, createdAt?: any | null, companyName?: string | null, employees?: string | null, website?: string | null, formattedPhoneNumber?: string | null, phoneCountryCode?: string | null, status?: OrganizationStatus | null, phoneCheckerEnabled: boolean, allowImport: boolean, termsUrl?: string | null, complianceUrl?: string | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, recordingPin?: any | null, carrierFeePaymentFailed: boolean, contract: boolean, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null, userTimeZone?: { __typename?: 'UserTimeZone', fullName?: string | null, offset?: string | null, shortName?: string | null, zoneAbbreviation?: string | null, zoneId?: string | null } | null, invitationBid?: { __typename?: 'InvitationBid', role?: InvitationRole | null, expirationDate?: any | null, email?: string | null, uuid?: any | null, id?: any | null, listIds?: Array<any | null> | null } | null } | null };

export type CompanyDetailsRegistrationStepMutationVariables = Exact<{
  input: OrganizationUpdateInput;
}>;


export type CompanyDetailsRegistrationStepMutation = { __typename?: 'Mutation', companyDetailsRegistrationStep?: { __typename?: 'MemberResponse', registrationFinished: boolean, name?: string | null, displayRole?: string | null, displayState?: string | null, isAdmin?: boolean | null, accessType?: InvitationAccessType | null, listIds?: Array<any | null> | null, invitationLink?: string | null, deletedAt?: any | null, updatedAt?: any | null, createdAt?: any | null, phone?: string | null, internationalPhone?: string | null, email?: string | null, role?: MemberRole | null, lastName?: string | null, firstName?: string | null, id?: any | null, state?: MemberState | null, memberHash?: string | null, uniqueId?: string | null, memberRegistration?: { __typename?: 'MemberRegistration', type?: MemberRegistrationType | null, oldCredits?: number | null, currentStep?: number | null, migratedEmail?: string | null, selectedPriceId?: string | null, migrationFinished: boolean, oldCreditsForPurchase: number, oldCreditsFree: number, oldCreditsLastYear: number, saveCredits: boolean, oldSubscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null } | null, organization?: { __typename?: 'Organization', id?: any | null, uuid?: any | null, updatedAt?: any | null, migrationStatus?: Status | null, createdAt?: any | null, companyName?: string | null, employees?: string | null, website?: string | null, formattedPhoneNumber?: string | null, phoneCountryCode?: string | null, status?: OrganizationStatus | null, phoneCheckerEnabled: boolean, allowImport: boolean, termsUrl?: string | null, complianceUrl?: string | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, recordingPin?: any | null, carrierFeePaymentFailed: boolean, contract: boolean, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null, userTimeZone?: { __typename?: 'UserTimeZone', fullName?: string | null, offset?: string | null, shortName?: string | null, zoneAbbreviation?: string | null, zoneId?: string | null } | null, invitationBid?: { __typename?: 'InvitationBid', role?: InvitationRole | null, expirationDate?: any | null, email?: string | null, uuid?: any | null, id?: any | null, listIds?: Array<any | null> | null } | null } | null };

export type MigrationRegistrationStepMutationVariables = Exact<{ [key: string]: never; }>;


export type MigrationRegistrationStepMutation = { __typename?: 'Mutation', migrationRegistrationStep?: { __typename?: 'MemberResponse', registrationFinished: boolean, name?: string | null, displayRole?: string | null, displayState?: string | null, isAdmin?: boolean | null, accessType?: InvitationAccessType | null, listIds?: Array<any | null> | null, invitationLink?: string | null, deletedAt?: any | null, updatedAt?: any | null, createdAt?: any | null, phone?: string | null, internationalPhone?: string | null, email?: string | null, role?: MemberRole | null, lastName?: string | null, firstName?: string | null, id?: any | null, state?: MemberState | null, memberHash?: string | null, uniqueId?: string | null, memberRegistration?: { __typename?: 'MemberRegistration', type?: MemberRegistrationType | null, oldCredits?: number | null, currentStep?: number | null, migratedEmail?: string | null, selectedPriceId?: string | null, migrationFinished: boolean, oldCreditsForPurchase: number, oldCreditsFree: number, oldCreditsLastYear: number, saveCredits: boolean, oldSubscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null } | null, organization?: { __typename?: 'Organization', id?: any | null, uuid?: any | null, updatedAt?: any | null, migrationStatus?: Status | null, createdAt?: any | null, companyName?: string | null, employees?: string | null, website?: string | null, formattedPhoneNumber?: string | null, phoneCountryCode?: string | null, status?: OrganizationStatus | null, phoneCheckerEnabled: boolean, allowImport: boolean, termsUrl?: string | null, complianceUrl?: string | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, recordingPin?: any | null, carrierFeePaymentFailed: boolean, contract: boolean, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null, userTimeZone?: { __typename?: 'UserTimeZone', fullName?: string | null, offset?: string | null, shortName?: string | null, zoneAbbreviation?: string | null, zoneId?: string | null } | null, invitationBid?: { __typename?: 'InvitationBid', role?: InvitationRole | null, expirationDate?: any | null, email?: string | null, uuid?: any | null, id?: any | null, listIds?: Array<any | null> | null } | null } | null };

export type MemberRegistrationPreviousStepMutationVariables = Exact<{ [key: string]: never; }>;


export type MemberRegistrationPreviousStepMutation = { __typename?: 'Mutation', memberRegistrationPreviousStep?: { __typename?: 'MemberResponse', registrationFinished: boolean, name?: string | null, displayRole?: string | null, displayState?: string | null, isAdmin?: boolean | null, accessType?: InvitationAccessType | null, listIds?: Array<any | null> | null, invitationLink?: string | null, deletedAt?: any | null, updatedAt?: any | null, createdAt?: any | null, phone?: string | null, internationalPhone?: string | null, email?: string | null, role?: MemberRole | null, lastName?: string | null, firstName?: string | null, id?: any | null, state?: MemberState | null, memberHash?: string | null, uniqueId?: string | null, memberRegistration?: { __typename?: 'MemberRegistration', type?: MemberRegistrationType | null, oldCredits?: number | null, currentStep?: number | null, migratedEmail?: string | null, selectedPriceId?: string | null, migrationFinished: boolean, oldCreditsForPurchase: number, oldCreditsFree: number, oldCreditsLastYear: number, saveCredits: boolean, oldSubscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null } | null, organization?: { __typename?: 'Organization', id?: any | null, uuid?: any | null, updatedAt?: any | null, migrationStatus?: Status | null, createdAt?: any | null, companyName?: string | null, employees?: string | null, website?: string | null, formattedPhoneNumber?: string | null, phoneCountryCode?: string | null, status?: OrganizationStatus | null, phoneCheckerEnabled: boolean, allowImport: boolean, termsUrl?: string | null, complianceUrl?: string | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, recordingPin?: any | null, carrierFeePaymentFailed: boolean, contract: boolean, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null, userTimeZone?: { __typename?: 'UserTimeZone', fullName?: string | null, offset?: string | null, shortName?: string | null, zoneAbbreviation?: string | null, zoneId?: string | null } | null, invitationBid?: { __typename?: 'InvitationBid', role?: InvitationRole | null, expirationDate?: any | null, email?: string | null, uuid?: any | null, id?: any | null, listIds?: Array<any | null> | null } | null } | null };

export type PlanSelectionRegistrationStepMutationVariables = Exact<{
  price?: InputMaybe<Scalars['String']>;
  saveCredits: Scalars['Boolean'];
}>;


export type PlanSelectionRegistrationStepMutation = { __typename?: 'Mutation', planSelectionRegistrationStep?: { __typename?: 'MemberResponse', registrationFinished: boolean, name?: string | null, displayRole?: string | null, displayState?: string | null, isAdmin?: boolean | null, accessType?: InvitationAccessType | null, listIds?: Array<any | null> | null, invitationLink?: string | null, deletedAt?: any | null, updatedAt?: any | null, createdAt?: any | null, phone?: string | null, internationalPhone?: string | null, email?: string | null, role?: MemberRole | null, lastName?: string | null, firstName?: string | null, id?: any | null, state?: MemberState | null, memberHash?: string | null, uniqueId?: string | null, memberRegistration?: { __typename?: 'MemberRegistration', type?: MemberRegistrationType | null, oldCredits?: number | null, currentStep?: number | null, migratedEmail?: string | null, selectedPriceId?: string | null, migrationFinished: boolean, oldCreditsForPurchase: number, oldCreditsFree: number, oldCreditsLastYear: number, saveCredits: boolean, oldSubscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null } | null, organization?: { __typename?: 'Organization', id?: any | null, uuid?: any | null, updatedAt?: any | null, migrationStatus?: Status | null, createdAt?: any | null, companyName?: string | null, employees?: string | null, website?: string | null, formattedPhoneNumber?: string | null, phoneCountryCode?: string | null, status?: OrganizationStatus | null, phoneCheckerEnabled: boolean, allowImport: boolean, termsUrl?: string | null, complianceUrl?: string | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, recordingPin?: any | null, carrierFeePaymentFailed: boolean, contract: boolean, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null, userTimeZone?: { __typename?: 'UserTimeZone', fullName?: string | null, offset?: string | null, shortName?: string | null, zoneAbbreviation?: string | null, zoneId?: string | null } | null, invitationBid?: { __typename?: 'InvitationBid', role?: InvitationRole | null, expirationDate?: any | null, email?: string | null, uuid?: any | null, id?: any | null, listIds?: Array<any | null> | null } | null } | null };

export type StartTrialRegistrationStepMutationVariables = Exact<{
  paymentMethodId?: InputMaybe<Scalars['String']>;
}>;


export type StartTrialRegistrationStepMutation = { __typename?: 'Mutation', startTrialRegistrationStep?: { __typename?: 'MemberResponse', registrationFinished: boolean, name?: string | null, displayRole?: string | null, displayState?: string | null, isAdmin?: boolean | null, accessType?: InvitationAccessType | null, listIds?: Array<any | null> | null, invitationLink?: string | null, deletedAt?: any | null, updatedAt?: any | null, createdAt?: any | null, phone?: string | null, internationalPhone?: string | null, email?: string | null, role?: MemberRole | null, lastName?: string | null, firstName?: string | null, id?: any | null, state?: MemberState | null, memberHash?: string | null, uniqueId?: string | null, memberRegistration?: { __typename?: 'MemberRegistration', type?: MemberRegistrationType | null, oldCredits?: number | null, currentStep?: number | null, migratedEmail?: string | null, selectedPriceId?: string | null, migrationFinished: boolean, oldCreditsForPurchase: number, oldCreditsFree: number, oldCreditsLastYear: number, saveCredits: boolean, oldSubscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null } | null, organization?: { __typename?: 'Organization', id?: any | null, uuid?: any | null, updatedAt?: any | null, migrationStatus?: Status | null, createdAt?: any | null, companyName?: string | null, employees?: string | null, website?: string | null, formattedPhoneNumber?: string | null, phoneCountryCode?: string | null, status?: OrganizationStatus | null, phoneCheckerEnabled: boolean, allowImport: boolean, termsUrl?: string | null, complianceUrl?: string | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, recordingPin?: any | null, carrierFeePaymentFailed: boolean, contract: boolean, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null, userTimeZone?: { __typename?: 'UserTimeZone', fullName?: string | null, offset?: string | null, shortName?: string | null, zoneAbbreviation?: string | null, zoneId?: string | null } | null, invitationBid?: { __typename?: 'InvitationBid', role?: InvitationRole | null, expirationDate?: any | null, email?: string | null, uuid?: any | null, id?: any | null, listIds?: Array<any | null> | null } | null } | null };

export type ApplyCouponMutationVariables = Exact<{
  couponId?: InputMaybe<Scalars['String']>;
}>;


export type ApplyCouponMutation = { __typename?: 'Mutation', applyCoupon?: { __typename?: 'OrgBillingInfo', stripeCouponId?: string | null } | null };

export type GetMemberQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMemberQuery = { __typename?: 'Query', getMember?: { __typename?: 'MemberResponse', registrationFinished: boolean, name?: string | null, displayRole?: string | null, displayState?: string | null, isAdmin?: boolean | null, accessType?: InvitationAccessType | null, listIds?: Array<any | null> | null, invitationLink?: string | null, deletedAt?: any | null, updatedAt?: any | null, createdAt?: any | null, phone?: string | null, internationalPhone?: string | null, email?: string | null, role?: MemberRole | null, lastName?: string | null, firstName?: string | null, id?: any | null, state?: MemberState | null, memberHash?: string | null, uniqueId?: string | null, memberRegistration?: { __typename?: 'MemberRegistration', type?: MemberRegistrationType | null, oldCredits?: number | null, currentStep?: number | null, migratedEmail?: string | null, selectedPriceId?: string | null, migrationFinished: boolean, oldCreditsForPurchase: number, oldCreditsFree: number, oldCreditsLastYear: number, saveCredits: boolean, oldSubscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null } | null, organization?: { __typename?: 'Organization', id?: any | null, uuid?: any | null, updatedAt?: any | null, migrationStatus?: Status | null, createdAt?: any | null, companyName?: string | null, employees?: string | null, website?: string | null, formattedPhoneNumber?: string | null, phoneCountryCode?: string | null, status?: OrganizationStatus | null, phoneCheckerEnabled: boolean, allowImport: boolean, termsUrl?: string | null, complianceUrl?: string | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, recordingPin?: any | null, carrierFeePaymentFailed: boolean, contract: boolean, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null, userTimeZone?: { __typename?: 'UserTimeZone', fullName?: string | null, offset?: string | null, shortName?: string | null, zoneAbbreviation?: string | null, zoneId?: string | null } | null, invitationBid?: { __typename?: 'InvitationBid', role?: InvitationRole | null, expirationDate?: any | null, email?: string | null, uuid?: any | null, id?: any | null, listIds?: Array<any | null> | null } | null } | null };

export type GetAllUserTimezonesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllUserTimezonesQuery = { __typename?: 'Query', getAllUserTimezones?: Array<{ __typename?: 'UserTimeZone', fullName?: string | null, offset?: string | null, shortName?: string | null, zoneAbbreviation?: string | null, zoneId?: string | null } | null> | null };

export type GetAllCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCountriesQuery = { __typename?: 'Query', getAllCountries?: Array<{ __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null> | null };

export type CheckStripeCouponIdQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckStripeCouponIdQuery = { __typename?: 'Query', getOrganizationBillingInfo?: { __typename?: 'OrgBillingInfo', stripeCouponId?: string | null } | null };

export type AddressFragmentFragment = { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null };

export type UserTimezoneFragmentFragment = { __typename?: 'UserTimeZone', fullName?: string | null, offset?: string | null, shortName?: string | null, zoneAbbreviation?: string | null, zoneId?: string | null };

export type InvitationBidFragmentFragment = { __typename?: 'InvitationBid', role?: InvitationRole | null, expirationDate?: any | null, email?: string | null, uuid?: any | null, id?: any | null, listIds?: Array<any | null> | null };

export type MemberRegistrationFragmentFragment = { __typename?: 'MemberRegistration', type?: MemberRegistrationType | null, oldCredits?: number | null, currentStep?: number | null, migratedEmail?: string | null, selectedPriceId?: string | null, migrationFinished: boolean, oldCreditsForPurchase: number, oldCreditsFree: number, oldCreditsLastYear: number, saveCredits: boolean, oldSubscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null };

export type MemberResponseFragment = { __typename?: 'MemberResponse', registrationFinished: boolean, name?: string | null, displayRole?: string | null, displayState?: string | null, isAdmin?: boolean | null, accessType?: InvitationAccessType | null, listIds?: Array<any | null> | null, invitationLink?: string | null, deletedAt?: any | null, updatedAt?: any | null, createdAt?: any | null, phone?: string | null, internationalPhone?: string | null, email?: string | null, role?: MemberRole | null, lastName?: string | null, firstName?: string | null, id?: any | null, state?: MemberState | null, memberHash?: string | null, uniqueId?: string | null, memberRegistration?: { __typename?: 'MemberRegistration', type?: MemberRegistrationType | null, oldCredits?: number | null, currentStep?: number | null, migratedEmail?: string | null, selectedPriceId?: string | null, migrationFinished: boolean, oldCreditsForPurchase: number, oldCreditsFree: number, oldCreditsLastYear: number, saveCredits: boolean, oldSubscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null } | null, organization?: { __typename?: 'Organization', id?: any | null, uuid?: any | null, updatedAt?: any | null, migrationStatus?: Status | null, createdAt?: any | null, companyName?: string | null, employees?: string | null, website?: string | null, formattedPhoneNumber?: string | null, phoneCountryCode?: string | null, status?: OrganizationStatus | null, phoneCheckerEnabled: boolean, allowImport: boolean, termsUrl?: string | null, complianceUrl?: string | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, recordingPin?: any | null, carrierFeePaymentFailed: boolean, contract: boolean, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null, userTimeZone?: { __typename?: 'UserTimeZone', fullName?: string | null, offset?: string | null, shortName?: string | null, zoneAbbreviation?: string | null, zoneId?: string | null } | null, invitationBid?: { __typename?: 'InvitationBid', role?: InvitationRole | null, expirationDate?: any | null, email?: string | null, uuid?: any | null, id?: any | null, listIds?: Array<any | null> | null } | null };

export type InviteResponseFragmentFragment = { __typename?: 'InvitationBidResponse', id?: any | null, uuid?: any | null, email?: string | null, expirationDate?: any | null, link?: string | null, role?: InvitationRole | null };

export type PhoneNumberFragmentFragment = { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null };

export type GetAllMembersQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
}>;


export type GetAllMembersQuery = { __typename?: 'Query', getAllMembers?: { __typename?: 'PageResponse_MemberResponse', pageNumber: number, pageSize: number, total: any, content?: Array<{ __typename?: 'MemberResponse', registrationFinished: boolean, name?: string | null, displayRole?: string | null, displayState?: string | null, isAdmin?: boolean | null, accessType?: InvitationAccessType | null, listIds?: Array<any | null> | null, invitationLink?: string | null, deletedAt?: any | null, updatedAt?: any | null, createdAt?: any | null, phone?: string | null, internationalPhone?: string | null, email?: string | null, role?: MemberRole | null, lastName?: string | null, firstName?: string | null, id?: any | null, state?: MemberState | null, memberHash?: string | null, uniqueId?: string | null, memberRegistration?: { __typename?: 'MemberRegistration', type?: MemberRegistrationType | null, oldCredits?: number | null, currentStep?: number | null, migratedEmail?: string | null, selectedPriceId?: string | null, migrationFinished: boolean, oldCreditsForPurchase: number, oldCreditsFree: number, oldCreditsLastYear: number, saveCredits: boolean, oldSubscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null } | null, organization?: { __typename?: 'Organization', id?: any | null, uuid?: any | null, updatedAt?: any | null, migrationStatus?: Status | null, createdAt?: any | null, companyName?: string | null, employees?: string | null, website?: string | null, formattedPhoneNumber?: string | null, phoneCountryCode?: string | null, status?: OrganizationStatus | null, phoneCheckerEnabled: boolean, allowImport: boolean, termsUrl?: string | null, complianceUrl?: string | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, recordingPin?: any | null, carrierFeePaymentFailed: boolean, contract: boolean, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null, userTimeZone?: { __typename?: 'UserTimeZone', fullName?: string | null, offset?: string | null, shortName?: string | null, zoneAbbreviation?: string | null, zoneId?: string | null } | null, invitationBid?: { __typename?: 'InvitationBid', role?: InvitationRole | null, expirationDate?: any | null, email?: string | null, uuid?: any | null, id?: any | null, listIds?: Array<any | null> | null } | null } | null> | null } | null };

export type CreateInvitationMutationVariables = Exact<{
  input: CreateInvitationBidRequestInput;
}>;


export type CreateInvitationMutation = { __typename?: 'Mutation', createInvitation?: { __typename?: 'InvitationBidResponse', id?: any | null, uuid?: any | null, email?: string | null, expirationDate?: any | null, link?: string | null, role?: InvitationRole | null } | null };

export type RemoveInvitationMutationVariables = Exact<{
  invitationId: Scalars['Long'];
}>;


export type RemoveInvitationMutation = { __typename?: 'Mutation', removeInvitation?: string | null };

export type ResendInvitationMutationVariables = Exact<{
  invitationId: Scalars['Long'];
}>;


export type ResendInvitationMutation = { __typename?: 'Mutation', resendInvitation?: string | null };

export type UpdateMemberRestrictionsMutationVariables = Exact<{
  input: UpdateMemberRestrictionsRequestInput;
  memberId: Scalars['Long'];
}>;


export type UpdateMemberRestrictionsMutation = { __typename?: 'Mutation', updateMemberRestrictions?: { __typename?: 'MemberResponse', registrationFinished: boolean, name?: string | null, displayRole?: string | null, displayState?: string | null, isAdmin?: boolean | null, accessType?: InvitationAccessType | null, listIds?: Array<any | null> | null, invitationLink?: string | null, deletedAt?: any | null, updatedAt?: any | null, createdAt?: any | null, phone?: string | null, internationalPhone?: string | null, email?: string | null, role?: MemberRole | null, lastName?: string | null, firstName?: string | null, id?: any | null, state?: MemberState | null, memberHash?: string | null, uniqueId?: string | null, memberRegistration?: { __typename?: 'MemberRegistration', type?: MemberRegistrationType | null, oldCredits?: number | null, currentStep?: number | null, migratedEmail?: string | null, selectedPriceId?: string | null, migrationFinished: boolean, oldCreditsForPurchase: number, oldCreditsFree: number, oldCreditsLastYear: number, saveCredits: boolean, oldSubscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null } | null, organization?: { __typename?: 'Organization', id?: any | null, uuid?: any | null, updatedAt?: any | null, migrationStatus?: Status | null, createdAt?: any | null, companyName?: string | null, employees?: string | null, website?: string | null, formattedPhoneNumber?: string | null, phoneCountryCode?: string | null, status?: OrganizationStatus | null, phoneCheckerEnabled: boolean, allowImport: boolean, termsUrl?: string | null, complianceUrl?: string | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, recordingPin?: any | null, carrierFeePaymentFailed: boolean, contract: boolean, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null, userTimeZone?: { __typename?: 'UserTimeZone', fullName?: string | null, offset?: string | null, shortName?: string | null, zoneAbbreviation?: string | null, zoneId?: string | null } | null, invitationBid?: { __typename?: 'InvitationBid', role?: InvitationRole | null, expirationDate?: any | null, email?: string | null, uuid?: any | null, id?: any | null, listIds?: Array<any | null> | null } | null } | null };

export type RemoveMemberMutationVariables = Exact<{
  memberId: Scalars['Long'];
}>;


export type RemoveMemberMutation = { __typename?: 'Mutation', removeMember?: string | null };

export type GetAllAudioItemsQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
  pattern?: InputMaybe<Scalars['String']>;
}>;


export type GetAllAudioItemsQuery = { __typename?: 'Query', getAllAudioItems?: { __typename?: 'PageResponse_AudioItem', total: any, pageNumber: number, pageSize: number, content?: Array<{ __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null> | null } | null };

export type CheckAudioItemExistsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type CheckAudioItemExistsQuery = { __typename?: 'Query', checkAudioItemExists?: boolean | null };

export type UpdateAudioItemMutationVariables = Exact<{
  input: UpdateAudioItemRequestInput;
}>;


export type UpdateAudioItemMutation = { __typename?: 'Mutation', updateAudioItem?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null };

export type DeleteAudioItemsMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Long']> | Scalars['Long']>;
}>;


export type DeleteAudioItemsMutation = { __typename?: 'Mutation', deleteAudioItems: number };

export type AudioItemFragmentFragment = { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null };

export type SetupAutoRechargeMutationVariables = Exact<{
  options?: InputMaybe<AutoRechargeOptionsInput>;
}>;


export type SetupAutoRechargeMutation = { __typename?: 'Mutation', setupAutoRecharge?: { __typename?: 'OrgBillingInfo', autoRecharge?: boolean | null, autoRechargeCreditsAmount?: number | null, autoRechargeThreshold?: AutoRechargeThreshold | null, status?: Status | null, stripeCustomerId?: string | null, backupPaymentMethod?: string | null, primaryPaymentMethod?: string | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id?: string | null, type?: string | null, card?: { __typename?: 'Card', last4?: string | null, expYear?: string | null, expMonth?: string | null, country?: string | null, brand?: string | null, funding?: string | null } | null } | null> | null } | null };

export type GetOrganizationBillingInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationBillingInfoQuery = { __typename?: 'Query', getOrganizationBillingInfo?: { __typename?: 'OrgBillingInfo', autoRecharge?: boolean | null, autoRechargeCreditsAmount?: number | null, autoRechargeThreshold?: AutoRechargeThreshold | null, status?: Status | null, stripeCustomerId?: string | null, backupPaymentMethod?: string | null, primaryPaymentMethod?: string | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id?: string | null, type?: string | null, card?: { __typename?: 'Card', last4?: string | null, expYear?: string | null, expMonth?: string | null, country?: string | null, brand?: string | null, funding?: string | null } | null } | null> | null } | null, getSubscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null };

export type GetPaymentsMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentsMethodsQuery = { __typename?: 'Query', getOrganizationBillingInfo?: { __typename?: 'OrgBillingInfo', autoRecharge?: boolean | null, autoRechargeCreditsAmount?: number | null, autoRechargeThreshold?: AutoRechargeThreshold | null, status?: Status | null, stripeCustomerId?: string | null, backupPaymentMethod?: string | null, primaryPaymentMethod?: string | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id?: string | null, type?: string | null, card?: { __typename?: 'Card', last4?: string | null, expYear?: string | null, expMonth?: string | null, country?: string | null, brand?: string | null, funding?: string | null } | null } | null> | null } | null };

export type GetBalancesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBalancesQuery = { __typename?: 'Query', getBalances?: { __typename?: 'Balances', plan?: number | null, purchased?: number | null, purchasedExpire?: any | null, rollover?: number | null } | null };

export type GetInvoicesQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
}>;


export type GetInvoicesQuery = { __typename?: 'Query', getInvoices?: { __typename?: 'PageResponse_BillingInvoice', pageNumber: number, pageSize: number, total: any, content?: Array<{ __typename?: 'BillingInvoice', id?: string | null, status?: InvoiceStatus | null, date?: any | null, link?: string | null, amount?: number | null, currency?: string | null, paymentMethodDetails?: string | null } | null> | null } | null };

export type GetPricesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPricesQuery = { __typename?: 'Query', getPrices?: Array<{ __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null> | null };

export type GetPriceMigrationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPriceMigrationQuery = { __typename?: 'Query', getPriceMigration?: { __typename?: 'PriceMigration', annualPrices?: Array<{ __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null> | null, monthlyPrices?: Array<{ __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null> | null } | null };

export type PaymentRegistrationSelectPricesQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentRegistrationSelectPricesQuery = { __typename?: 'Query', paymentRegistrationSelectPrices?: { __typename?: 'PriceMigrationSelection', annualPrice?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, monthlyPrice?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null };

export type GetCreditPriceSelectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreditPriceSelectionQuery = { __typename?: 'Query', getCreditPriceSelection?: { __typename?: 'CreditPriceSelection', planName?: string | null, allowedPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null, upgradePrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null };

export type GetCreditPriceSelectionForPlansQueryVariables = Exact<{
  planNames: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;


export type GetCreditPriceSelectionForPlansQuery = { __typename?: 'Query', getCreditPriceSelectionForPlans?: Array<{ __typename?: 'CreditPriceSelection', planName?: string | null, allowedPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null, upgradePrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null> | null };

export type FetchInvoiceLinkQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type FetchInvoiceLinkQuery = { __typename?: 'Query', fetchInvoice?: { __typename?: 'BillingInvoice', link?: string | null } | null };

export type SwitchPlanMutationVariables = Exact<{
  price?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['String']>;
  userInput?: InputMaybe<SubscriptionChangeInputInput>;
}>;


export type SwitchPlanMutation = { __typename?: 'Mutation', switchPlan?: { __typename?: 'UpdatedSubscription', subscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null, balances?: { __typename?: 'Balances', plan?: number | null, purchased?: number | null, purchasedExpire?: any | null, rollover?: number | null } | null } | null };

export type DeletePaymentMethodMutationVariables = Exact<{
  pmId?: InputMaybe<Scalars['String']>;
}>;


export type DeletePaymentMethodMutation = { __typename?: 'Mutation', deletePaymentMethod?: { __typename?: 'OrgBillingInfo', autoRecharge?: boolean | null, autoRechargeCreditsAmount?: number | null, autoRechargeThreshold?: AutoRechargeThreshold | null, status?: Status | null, stripeCustomerId?: string | null, backupPaymentMethod?: string | null, primaryPaymentMethod?: string | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id?: string | null, type?: string | null, card?: { __typename?: 'Card', last4?: string | null, expYear?: string | null, expMonth?: string | null, country?: string | null, brand?: string | null, funding?: string | null } | null } | null> | null } | null };

export type SetBackupPaymentMethodMutationVariables = Exact<{
  pmId?: InputMaybe<Scalars['String']>;
}>;


export type SetBackupPaymentMethodMutation = { __typename?: 'Mutation', setBackupPaymentMethod?: { __typename?: 'OrgBillingInfo', autoRecharge?: boolean | null, autoRechargeCreditsAmount?: number | null, autoRechargeThreshold?: AutoRechargeThreshold | null, status?: Status | null, stripeCustomerId?: string | null, backupPaymentMethod?: string | null, primaryPaymentMethod?: string | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id?: string | null, type?: string | null, card?: { __typename?: 'Card', last4?: string | null, expYear?: string | null, expMonth?: string | null, country?: string | null, brand?: string | null, funding?: string | null } | null } | null> | null } | null };

export type SetPrimaryPaymentMethodMutationVariables = Exact<{
  pmId?: InputMaybe<Scalars['String']>;
}>;


export type SetPrimaryPaymentMethodMutation = { __typename?: 'Mutation', setPrimaryPaymentMethod?: { __typename?: 'OrgBillingInfo', autoRecharge?: boolean | null, autoRechargeCreditsAmount?: number | null, autoRechargeThreshold?: AutoRechargeThreshold | null, status?: Status | null, stripeCustomerId?: string | null, backupPaymentMethod?: string | null, primaryPaymentMethod?: string | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id?: string | null, type?: string | null, card?: { __typename?: 'Card', last4?: string | null, expYear?: string | null, expMonth?: string | null, country?: string | null, brand?: string | null, funding?: string | null } | null } | null> | null } | null };

export type BuyCreditsMutationVariables = Exact<{
  creditsAmount?: InputMaybe<Scalars['Int']>;
  paymentMethodId?: InputMaybe<Scalars['String']>;
}>;


export type BuyCreditsMutation = { __typename?: 'Mutation', buyCredits?: { __typename?: 'Balances', plan?: number | null, purchased?: number | null, purchasedExpire?: any | null, rollover?: number | null } | null };

export type CancelDowngradeMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelDowngradeMutation = { __typename?: 'Mutation', cancelDowngrade?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null };

export type AddCardMutationVariables = Exact<{
  tokenId?: InputMaybe<Scalars['String']>;
}>;


export type AddCardMutation = { __typename?: 'Mutation', addCard?: { __typename?: 'OrgBillingInfo', autoRecharge?: boolean | null, autoRechargeCreditsAmount?: number | null, autoRechargeThreshold?: AutoRechargeThreshold | null, status?: Status | null, stripeCustomerId?: string | null, backupPaymentMethod?: string | null, primaryPaymentMethod?: string | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id?: string | null, type?: string | null, card?: { __typename?: 'Card', last4?: string | null, expYear?: string | null, expMonth?: string | null, country?: string | null, brand?: string | null, funding?: string | null } | null } | null> | null } | null };

export type CancelSubscriptionMutationVariables = Exact<{
  userInput?: InputMaybe<SubscriptionChangeInputInput>;
}>;


export type CancelSubscriptionMutation = { __typename?: 'Mutation', cancelSubscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null };

export type StopCancelSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type StopCancelSubscriptionMutation = { __typename?: 'Mutation', stopCancelSubscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null };

export type StartTrialMutationVariables = Exact<{
  tokenId?: InputMaybe<Scalars['String']>;
  member: MemberUpdateInput;
}>;


export type StartTrialMutation = { __typename?: 'Mutation', startTrial?: { __typename?: 'MemberAndCLSubscription', member?: { __typename?: 'MemberResponse', registrationFinished: boolean, name?: string | null, displayRole?: string | null, displayState?: string | null, isAdmin?: boolean | null, accessType?: InvitationAccessType | null, listIds?: Array<any | null> | null, invitationLink?: string | null, deletedAt?: any | null, updatedAt?: any | null, createdAt?: any | null, phone?: string | null, internationalPhone?: string | null, email?: string | null, role?: MemberRole | null, lastName?: string | null, firstName?: string | null, id?: any | null, state?: MemberState | null, memberHash?: string | null, uniqueId?: string | null, memberRegistration?: { __typename?: 'MemberRegistration', type?: MemberRegistrationType | null, oldCredits?: number | null, currentStep?: number | null, migratedEmail?: string | null, selectedPriceId?: string | null, migrationFinished: boolean, oldCreditsForPurchase: number, oldCreditsFree: number, oldCreditsLastYear: number, saveCredits: boolean, oldSubscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null } | null, organization?: { __typename?: 'Organization', id?: any | null, uuid?: any | null, updatedAt?: any | null, migrationStatus?: Status | null, createdAt?: any | null, companyName?: string | null, employees?: string | null, website?: string | null, formattedPhoneNumber?: string | null, phoneCountryCode?: string | null, status?: OrganizationStatus | null, phoneCheckerEnabled: boolean, allowImport: boolean, termsUrl?: string | null, complianceUrl?: string | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, recordingPin?: any | null, carrierFeePaymentFailed: boolean, contract: boolean, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null, userTimeZone?: { __typename?: 'UserTimeZone', fullName?: string | null, offset?: string | null, shortName?: string | null, zoneAbbreviation?: string | null, zoneId?: string | null } | null, invitationBid?: { __typename?: 'InvitationBid', role?: InvitationRole | null, expirationDate?: any | null, email?: string | null, uuid?: any | null, id?: any | null, listIds?: Array<any | null> | null } | null } | null, subscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null } | null };

export type SwitchPhoneCheckerMutationVariables = Exact<{
  input: SwitchPhoneCheckerRequestInput;
}>;


export type SwitchPhoneCheckerMutation = { __typename?: 'Mutation', switchPhoneChecker?: { __typename?: 'Organization', id?: any | null, uuid?: any | null, updatedAt?: any | null, migrationStatus?: Status | null, createdAt?: any | null, companyName?: string | null, employees?: string | null, website?: string | null, formattedPhoneNumber?: string | null, phoneCountryCode?: string | null, status?: OrganizationStatus | null, phoneCheckerEnabled: boolean, allowImport: boolean, termsUrl?: string | null, complianceUrl?: string | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, recordingPin?: any | null, carrierFeePaymentFailed: boolean, contract: boolean, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null };

export type PaymentRegistrationStepMutationVariables = Exact<{
  price: Scalars['String'];
  paymentMethodId?: InputMaybe<Scalars['String']>;
}>;


export type PaymentRegistrationStepMutation = { __typename?: 'Mutation', paymentRegistrationStep?: { __typename?: 'MemberResponse', registrationFinished: boolean, name?: string | null, displayRole?: string | null, displayState?: string | null, isAdmin?: boolean | null, accessType?: InvitationAccessType | null, listIds?: Array<any | null> | null, invitationLink?: string | null, deletedAt?: any | null, updatedAt?: any | null, createdAt?: any | null, phone?: string | null, internationalPhone?: string | null, email?: string | null, role?: MemberRole | null, lastName?: string | null, firstName?: string | null, id?: any | null, state?: MemberState | null, memberHash?: string | null, uniqueId?: string | null, memberRegistration?: { __typename?: 'MemberRegistration', type?: MemberRegistrationType | null, oldCredits?: number | null, currentStep?: number | null, migratedEmail?: string | null, selectedPriceId?: string | null, migrationFinished: boolean, oldCreditsForPurchase: number, oldCreditsFree: number, oldCreditsLastYear: number, saveCredits: boolean, oldSubscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null } | null, organization?: { __typename?: 'Organization', id?: any | null, uuid?: any | null, updatedAt?: any | null, migrationStatus?: Status | null, createdAt?: any | null, companyName?: string | null, employees?: string | null, website?: string | null, formattedPhoneNumber?: string | null, phoneCountryCode?: string | null, status?: OrganizationStatus | null, phoneCheckerEnabled: boolean, allowImport: boolean, termsUrl?: string | null, complianceUrl?: string | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, recordingPin?: any | null, carrierFeePaymentFailed: boolean, contract: boolean, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null, userTimeZone?: { __typename?: 'UserTimeZone', fullName?: string | null, offset?: string | null, shortName?: string | null, zoneAbbreviation?: string | null, zoneId?: string | null } | null, invitationBid?: { __typename?: 'InvitationBid', role?: InvitationRole | null, expirationDate?: any | null, email?: string | null, uuid?: any | null, id?: any | null, listIds?: Array<any | null> | null } | null } | null };

export type CarrierFeePayMutationVariables = Exact<{
  paymentMethodId?: InputMaybe<Scalars['String']>;
}>;


export type CarrierFeePayMutation = { __typename?: 'Mutation', carrierFeePay?: { __typename?: 'Organization', id?: any | null, uuid?: any | null, updatedAt?: any | null, migrationStatus?: Status | null, createdAt?: any | null, companyName?: string | null, employees?: string | null, website?: string | null, formattedPhoneNumber?: string | null, phoneCountryCode?: string | null, status?: OrganizationStatus | null, phoneCheckerEnabled: boolean, allowImport: boolean, termsUrl?: string | null, complianceUrl?: string | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, recordingPin?: any | null, carrierFeePaymentFailed: boolean, contract: boolean, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null };

export type LimitsFragmentFragment = { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null };

export type CreditPricesFragmentFragment = { __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null };

export type SimplePriceFragmentFragment = { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null };

export type UiNextPlanFragmentFragment = { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null };

export type SubscriptionFragmentFragment = { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null };

export type ClInvoiceFragmentFragment = { __typename?: 'BillingInvoice', id?: string | null, status?: InvoiceStatus | null, date?: any | null, link?: string | null, amount?: number | null, currency?: string | null, paymentMethodDetails?: string | null };

export type BalancesFragmentFragment = { __typename?: 'Balances', plan?: number | null, purchased?: number | null, purchasedExpire?: any | null, rollover?: number | null };

export type UpdateSubscriptionFragmentFragment = { __typename?: 'UpdatedSubscription', subscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null, balances?: { __typename?: 'Balances', plan?: number | null, purchased?: number | null, purchasedExpire?: any | null, rollover?: number | null } | null };

export type CardFragmentFragment = { __typename?: 'Card', last4?: string | null, expYear?: string | null, expMonth?: string | null, country?: string | null, brand?: string | null, funding?: string | null };

export type PaymentMethodFragmentFragment = { __typename?: 'PaymentMethod', id?: string | null, type?: string | null, card?: { __typename?: 'Card', last4?: string | null, expYear?: string | null, expMonth?: string | null, country?: string | null, brand?: string | null, funding?: string | null } | null };

export type OrganizationBillingFragmentFragment = { __typename?: 'OrgBillingInfo', autoRecharge?: boolean | null, autoRechargeCreditsAmount?: number | null, autoRechargeThreshold?: AutoRechargeThreshold | null, status?: Status | null, stripeCustomerId?: string | null, backupPaymentMethod?: string | null, primaryPaymentMethod?: string | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id?: string | null, type?: string | null, card?: { __typename?: 'Card', last4?: string | null, expYear?: string | null, expMonth?: string | null, country?: string | null, brand?: string | null, funding?: string | null } | null } | null> | null };

export type CheckMigrationStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckMigrationStatusQuery = { __typename?: 'Query', getMyOrganization?: { __typename?: 'Organization', migrationStatus?: Status | null } | null };

export type GetTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTypesQuery = { __typename?: 'Query', getBusinessProfileTypes?: { __typename?: 'BusinessProfileTypes', businessIndustryMapping?: any | null, businessTypeMapping?: any | null, businessOperationRegionMapping?: any | null, businessJobPositionMapping?: any | null, businessProfileStatusMapping?: any | null } | null, getTenDlcTypes?: { __typename?: 'TenDlcTypes', optInMethods?: any | null, businessTypes?: Array<TenDlcBusinessType | null> | null, packageTypes?: any | null, stockExchanges?: any | null, useCaseTypes?: any | null, statusMap?: any | null } | null, getTollFreeVerificationProfileTypes?: { __typename?: 'TollFreeVerificationProfileTypes', messageAmountMapping?: any | null, optInMethodMapping?: any | null, useCaseMapping?: any | null, verificationStatusMapping?: any | null, tollFreeVerificationStatusMapping?: any | null } | null };

export type OrganizationFragmentFragment = { __typename?: 'Organization', id?: any | null, uuid?: any | null, updatedAt?: any | null, migrationStatus?: Status | null, createdAt?: any | null, companyName?: string | null, employees?: string | null, website?: string | null, formattedPhoneNumber?: string | null, phoneCountryCode?: string | null, status?: OrganizationStatus | null, phoneCheckerEnabled: boolean, allowImport: boolean, termsUrl?: string | null, complianceUrl?: string | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, recordingPin?: any | null, carrierFeePaymentFailed: boolean, contract: boolean, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null };

export type SecondStreetAddressFragmentFragment = { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null };

export type SearchBusinessGeneralInfoQueryVariables = Exact<{
  input: Scalars['String'];
}>;


export type SearchBusinessGeneralInfoQuery = { __typename?: 'Query', searchBusinessGeneralInfo?: Array<{ __typename?: 'BusinessGeneralInfoEinResponse', ein?: string | null, name?: string | null, street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, countryCode?: string | null } | null> | null };

export type GetFullBusinessProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFullBusinessProfileQuery = { __typename?: 'Query', getFullBusinessProfile?: { __typename?: 'BusinessProfileResponse', businessGeneralInfo?: { __typename?: 'BusinessGeneralInfo', id?: any | null, name?: string | null, manual?: boolean | null, einDocument?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, businessAuthorizedUsers?: Array<{ __typename?: 'BusinessAuthorizedUser', id?: any | null, firstName?: string | null, lastName?: string | null, title?: string | null, jobPosition?: BusinessJobPosition | null, email?: string | null, phoneNumber?: string | null, formattedPhoneNumber?: string | null } | null> | null, businessInfo?: { __typename?: 'BusinessInfo', id?: any | null, type?: BusinessType | null, industry?: BusinessIndustry | null, website?: string | null, socialMediaProfile?: string | null, operationRegions?: Array<BusinessOperationRegion | null> | null } | null, businessProfile?: { __typename?: 'BusinessProfile', id?: any | null, currentStep?: number | null, hasEin: boolean, ein?: string | null, status?: BusinessProfileStatus | null, operationCountries?: Array<CountryCode | null> | null, updatedAt?: any | null } | null, errors?: Array<{ __typename?: 'BusinessProfileEvaluationErrors', errorCode?: number | null, failureReason?: string | null, fieldName?: string | null, passed: boolean, objectType?: string | null } | null> | null } | null };

export type GetBusinessCountryStatesQueryVariables = Exact<{
  countryCode: Scalars['String'];
}>;


export type GetBusinessCountryStatesQuery = { __typename?: 'Query', getBusinessCountryStates?: Array<string | null> | null };

export type RegisterBusinessProfileMutationVariables = Exact<{
  input: BusinessProfileRequestInput;
}>;


export type RegisterBusinessProfileMutation = { __typename?: 'Mutation', registerBusinessProfile?: { __typename?: 'BusinessProfileResponse', businessGeneralInfo?: { __typename?: 'BusinessGeneralInfo', id?: any | null, name?: string | null, manual?: boolean | null, einDocument?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, businessAuthorizedUsers?: Array<{ __typename?: 'BusinessAuthorizedUser', id?: any | null, firstName?: string | null, lastName?: string | null, title?: string | null, jobPosition?: BusinessJobPosition | null, email?: string | null, phoneNumber?: string | null, formattedPhoneNumber?: string | null } | null> | null, businessInfo?: { __typename?: 'BusinessInfo', id?: any | null, type?: BusinessType | null, industry?: BusinessIndustry | null, website?: string | null, socialMediaProfile?: string | null, operationRegions?: Array<BusinessOperationRegion | null> | null } | null, businessProfile?: { __typename?: 'BusinessProfile', id?: any | null, currentStep?: number | null, hasEin: boolean, ein?: string | null, status?: BusinessProfileStatus | null, operationCountries?: Array<CountryCode | null> | null, updatedAt?: any | null } | null, errors?: Array<{ __typename?: 'BusinessProfileEvaluationErrors', errorCode?: number | null, failureReason?: string | null, fieldName?: string | null, passed: boolean, objectType?: string | null } | null> | null } | null };

export type InitCompanyTypeMutationVariables = Exact<{
  hasEin: Scalars['Boolean'];
}>;


export type InitCompanyTypeMutation = { __typename?: 'Mutation', initCompanyType?: { __typename?: 'BusinessProfileResponse', businessGeneralInfo?: { __typename?: 'BusinessGeneralInfo', id?: any | null, name?: string | null, manual?: boolean | null, einDocument?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, businessAuthorizedUsers?: Array<{ __typename?: 'BusinessAuthorizedUser', id?: any | null, firstName?: string | null, lastName?: string | null, title?: string | null, jobPosition?: BusinessJobPosition | null, email?: string | null, phoneNumber?: string | null, formattedPhoneNumber?: string | null } | null> | null, businessInfo?: { __typename?: 'BusinessInfo', id?: any | null, type?: BusinessType | null, industry?: BusinessIndustry | null, website?: string | null, socialMediaProfile?: string | null, operationRegions?: Array<BusinessOperationRegion | null> | null } | null, businessProfile?: { __typename?: 'BusinessProfile', id?: any | null, currentStep?: number | null, hasEin: boolean, ein?: string | null, status?: BusinessProfileStatus | null, operationCountries?: Array<CountryCode | null> | null, updatedAt?: any | null } | null, errors?: Array<{ __typename?: 'BusinessProfileEvaluationErrors', errorCode?: number | null, failureReason?: string | null, fieldName?: string | null, passed: boolean, objectType?: string | null } | null> | null } | null };

export type BusinessProfilePreviousStepMutationVariables = Exact<{ [key: string]: never; }>;


export type BusinessProfilePreviousStepMutation = { __typename?: 'Mutation', businessProfilePreviousStep?: { __typename?: 'BusinessProfileResponse', businessGeneralInfo?: { __typename?: 'BusinessGeneralInfo', id?: any | null, name?: string | null, manual?: boolean | null, einDocument?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, businessAuthorizedUsers?: Array<{ __typename?: 'BusinessAuthorizedUser', id?: any | null, firstName?: string | null, lastName?: string | null, title?: string | null, jobPosition?: BusinessJobPosition | null, email?: string | null, phoneNumber?: string | null, formattedPhoneNumber?: string | null } | null> | null, businessInfo?: { __typename?: 'BusinessInfo', id?: any | null, type?: BusinessType | null, industry?: BusinessIndustry | null, website?: string | null, socialMediaProfile?: string | null, operationRegions?: Array<BusinessOperationRegion | null> | null } | null, businessProfile?: { __typename?: 'BusinessProfile', id?: any | null, currentStep?: number | null, hasEin: boolean, ein?: string | null, status?: BusinessProfileStatus | null, operationCountries?: Array<CountryCode | null> | null, updatedAt?: any | null } | null, errors?: Array<{ __typename?: 'BusinessProfileEvaluationErrors', errorCode?: number | null, failureReason?: string | null, fieldName?: string | null, passed: boolean, objectType?: string | null } | null> | null } | null };

export type InitBusinessGeneralInfoMutationVariables = Exact<{
  input: BusinessGeneralInfoRequestInput;
}>;


export type InitBusinessGeneralInfoMutation = { __typename?: 'Mutation', initBusinessGeneralInfo?: { __typename?: 'BusinessProfileResponse', businessGeneralInfo?: { __typename?: 'BusinessGeneralInfo', id?: any | null, name?: string | null, manual?: boolean | null, einDocument?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, businessAuthorizedUsers?: Array<{ __typename?: 'BusinessAuthorizedUser', id?: any | null, firstName?: string | null, lastName?: string | null, title?: string | null, jobPosition?: BusinessJobPosition | null, email?: string | null, phoneNumber?: string | null, formattedPhoneNumber?: string | null } | null> | null, businessInfo?: { __typename?: 'BusinessInfo', id?: any | null, type?: BusinessType | null, industry?: BusinessIndustry | null, website?: string | null, socialMediaProfile?: string | null, operationRegions?: Array<BusinessOperationRegion | null> | null } | null, businessProfile?: { __typename?: 'BusinessProfile', id?: any | null, currentStep?: number | null, hasEin: boolean, ein?: string | null, status?: BusinessProfileStatus | null, operationCountries?: Array<CountryCode | null> | null, updatedAt?: any | null } | null, errors?: Array<{ __typename?: 'BusinessProfileEvaluationErrors', errorCode?: number | null, failureReason?: string | null, fieldName?: string | null, passed: boolean, objectType?: string | null } | null> | null } | null };

export type InitBusinessInfoMutationVariables = Exact<{
  input: BusinessInfoRequestInput;
}>;


export type InitBusinessInfoMutation = { __typename?: 'Mutation', initBusinessInfo?: { __typename?: 'BusinessProfileResponse', businessGeneralInfo?: { __typename?: 'BusinessGeneralInfo', id?: any | null, name?: string | null, manual?: boolean | null, einDocument?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, businessAuthorizedUsers?: Array<{ __typename?: 'BusinessAuthorizedUser', id?: any | null, firstName?: string | null, lastName?: string | null, title?: string | null, jobPosition?: BusinessJobPosition | null, email?: string | null, phoneNumber?: string | null, formattedPhoneNumber?: string | null } | null> | null, businessInfo?: { __typename?: 'BusinessInfo', id?: any | null, type?: BusinessType | null, industry?: BusinessIndustry | null, website?: string | null, socialMediaProfile?: string | null, operationRegions?: Array<BusinessOperationRegion | null> | null } | null, businessProfile?: { __typename?: 'BusinessProfile', id?: any | null, currentStep?: number | null, hasEin: boolean, ein?: string | null, status?: BusinessProfileStatus | null, operationCountries?: Array<CountryCode | null> | null, updatedAt?: any | null } | null, errors?: Array<{ __typename?: 'BusinessProfileEvaluationErrors', errorCode?: number | null, failureReason?: string | null, fieldName?: string | null, passed: boolean, objectType?: string | null } | null> | null } | null };

export type InitBusinessAuthorizedUsersMutationVariables = Exact<{
  input: Array<InputMaybe<BusinessAuthorizedUserRequestInput>> | InputMaybe<BusinessAuthorizedUserRequestInput>;
}>;


export type InitBusinessAuthorizedUsersMutation = { __typename?: 'Mutation', initBusinessAuthorizedUsers?: { __typename?: 'BusinessProfileResponse', businessGeneralInfo?: { __typename?: 'BusinessGeneralInfo', id?: any | null, name?: string | null, manual?: boolean | null, einDocument?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, businessAuthorizedUsers?: Array<{ __typename?: 'BusinessAuthorizedUser', id?: any | null, firstName?: string | null, lastName?: string | null, title?: string | null, jobPosition?: BusinessJobPosition | null, email?: string | null, phoneNumber?: string | null, formattedPhoneNumber?: string | null } | null> | null, businessInfo?: { __typename?: 'BusinessInfo', id?: any | null, type?: BusinessType | null, industry?: BusinessIndustry | null, website?: string | null, socialMediaProfile?: string | null, operationRegions?: Array<BusinessOperationRegion | null> | null } | null, businessProfile?: { __typename?: 'BusinessProfile', id?: any | null, currentStep?: number | null, hasEin: boolean, ein?: string | null, status?: BusinessProfileStatus | null, operationCountries?: Array<CountryCode | null> | null, updatedAt?: any | null } | null, errors?: Array<{ __typename?: 'BusinessProfileEvaluationErrors', errorCode?: number | null, failureReason?: string | null, fieldName?: string | null, passed: boolean, objectType?: string | null } | null> | null } | null };

export type InitBusinessTermsMutationVariables = Exact<{ [key: string]: never; }>;


export type InitBusinessTermsMutation = { __typename?: 'Mutation', initBusinessTerms?: { __typename?: 'BusinessProfileResponse', businessGeneralInfo?: { __typename?: 'BusinessGeneralInfo', id?: any | null, name?: string | null, manual?: boolean | null, einDocument?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, businessAuthorizedUsers?: Array<{ __typename?: 'BusinessAuthorizedUser', id?: any | null, firstName?: string | null, lastName?: string | null, title?: string | null, jobPosition?: BusinessJobPosition | null, email?: string | null, phoneNumber?: string | null, formattedPhoneNumber?: string | null } | null> | null, businessInfo?: { __typename?: 'BusinessInfo', id?: any | null, type?: BusinessType | null, industry?: BusinessIndustry | null, website?: string | null, socialMediaProfile?: string | null, operationRegions?: Array<BusinessOperationRegion | null> | null } | null, businessProfile?: { __typename?: 'BusinessProfile', id?: any | null, currentStep?: number | null, hasEin: boolean, ein?: string | null, status?: BusinessProfileStatus | null, operationCountries?: Array<CountryCode | null> | null, updatedAt?: any | null } | null, errors?: Array<{ __typename?: 'BusinessProfileEvaluationErrors', errorCode?: number | null, failureReason?: string | null, fieldName?: string | null, passed: boolean, objectType?: string | null } | null> | null } | null };

export type InitBusinessGeneralInfoByEinMutationVariables = Exact<{
  ein: Scalars['String'];
}>;


export type InitBusinessGeneralInfoByEinMutation = { __typename?: 'Mutation', initBusinessGeneralInfoByEin?: { __typename?: 'BusinessProfileResponse', businessGeneralInfo?: { __typename?: 'BusinessGeneralInfo', id?: any | null, name?: string | null, manual?: boolean | null, einDocument?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, businessAuthorizedUsers?: Array<{ __typename?: 'BusinessAuthorizedUser', id?: any | null, firstName?: string | null, lastName?: string | null, title?: string | null, jobPosition?: BusinessJobPosition | null, email?: string | null, phoneNumber?: string | null, formattedPhoneNumber?: string | null } | null> | null, businessInfo?: { __typename?: 'BusinessInfo', id?: any | null, type?: BusinessType | null, industry?: BusinessIndustry | null, website?: string | null, socialMediaProfile?: string | null, operationRegions?: Array<BusinessOperationRegion | null> | null } | null, businessProfile?: { __typename?: 'BusinessProfile', id?: any | null, currentStep?: number | null, hasEin: boolean, ein?: string | null, status?: BusinessProfileStatus | null, operationCountries?: Array<CountryCode | null> | null, updatedAt?: any | null } | null, errors?: Array<{ __typename?: 'BusinessProfileEvaluationErrors', errorCode?: number | null, failureReason?: string | null, fieldName?: string | null, passed: boolean, objectType?: string | null } | null> | null } | null };

export type InitBusinessGeneralInfoByManualEinMutationVariables = Exact<{
  input: BusinessGeneralInfoEinRequestInput;
}>;


export type InitBusinessGeneralInfoByManualEinMutation = { __typename?: 'Mutation', initBusinessGeneralInfoByManualEin?: { __typename?: 'BusinessProfileResponse', businessGeneralInfo?: { __typename?: 'BusinessGeneralInfo', id?: any | null, name?: string | null, manual?: boolean | null, einDocument?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, businessAuthorizedUsers?: Array<{ __typename?: 'BusinessAuthorizedUser', id?: any | null, firstName?: string | null, lastName?: string | null, title?: string | null, jobPosition?: BusinessJobPosition | null, email?: string | null, phoneNumber?: string | null, formattedPhoneNumber?: string | null } | null> | null, businessInfo?: { __typename?: 'BusinessInfo', id?: any | null, type?: BusinessType | null, industry?: BusinessIndustry | null, website?: string | null, socialMediaProfile?: string | null, operationRegions?: Array<BusinessOperationRegion | null> | null } | null, businessProfile?: { __typename?: 'BusinessProfile', id?: any | null, currentStep?: number | null, hasEin: boolean, ein?: string | null, status?: BusinessProfileStatus | null, operationCountries?: Array<CountryCode | null> | null, updatedAt?: any | null } | null, errors?: Array<{ __typename?: 'BusinessProfileEvaluationErrors', errorCode?: number | null, failureReason?: string | null, fieldName?: string | null, passed: boolean, objectType?: string | null } | null> | null } | null };

export type BusinessInfoFragmentFragment = { __typename?: 'BusinessInfo', id?: any | null, type?: BusinessType | null, industry?: BusinessIndustry | null, website?: string | null, socialMediaProfile?: string | null, operationRegions?: Array<BusinessOperationRegion | null> | null };

export type BusinessProfileFragmentFragment = { __typename?: 'BusinessProfile', id?: any | null, currentStep?: number | null, hasEin: boolean, ein?: string | null, status?: BusinessProfileStatus | null, operationCountries?: Array<CountryCode | null> | null, updatedAt?: any | null };

export type BusinessGeneralInfoFragmentFragment = { __typename?: 'BusinessGeneralInfo', id?: any | null, name?: string | null, manual?: boolean | null, einDocument?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null };

export type BusinessGeneralInfoEinResponseFragmentFragment = { __typename?: 'BusinessGeneralInfoEinResponse', ein?: string | null, name?: string | null, street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, countryCode?: string | null };

export type BusinessAuthorizedUserFragmentFragment = { __typename?: 'BusinessAuthorizedUser', id?: any | null, firstName?: string | null, lastName?: string | null, title?: string | null, jobPosition?: BusinessJobPosition | null, email?: string | null, phoneNumber?: string | null, formattedPhoneNumber?: string | null };

export type BusinessProfileResponseFragmentFragment = { __typename?: 'BusinessProfileResponse', businessGeneralInfo?: { __typename?: 'BusinessGeneralInfo', id?: any | null, name?: string | null, manual?: boolean | null, einDocument?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, businessAuthorizedUsers?: Array<{ __typename?: 'BusinessAuthorizedUser', id?: any | null, firstName?: string | null, lastName?: string | null, title?: string | null, jobPosition?: BusinessJobPosition | null, email?: string | null, phoneNumber?: string | null, formattedPhoneNumber?: string | null } | null> | null, businessInfo?: { __typename?: 'BusinessInfo', id?: any | null, type?: BusinessType | null, industry?: BusinessIndustry | null, website?: string | null, socialMediaProfile?: string | null, operationRegions?: Array<BusinessOperationRegion | null> | null } | null, businessProfile?: { __typename?: 'BusinessProfile', id?: any | null, currentStep?: number | null, hasEin: boolean, ein?: string | null, status?: BusinessProfileStatus | null, operationCountries?: Array<CountryCode | null> | null, updatedAt?: any | null } | null, errors?: Array<{ __typename?: 'BusinessProfileEvaluationErrors', errorCode?: number | null, failureReason?: string | null, fieldName?: string | null, passed: boolean, objectType?: string | null } | null> | null };

export type TollFreeBusinessInfoFragmentFragment = { __typename?: 'TollFreeBusinessInfo', id?: any | null, name?: string | null, website?: string | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null };

export type TollFreeContactInfoFragmentFragment = { __typename?: 'TollFreeContactInfo', id?: any | null, phoneNumber?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, formattedPhoneNumber?: string | null };

export type TollFreeVerificationProfileFragmentFragment = { __typename?: 'TollFreeVerificationProfile', id?: any | null, updatedAt?: any | null, optInMethod?: TollFreeVerificationOptInMethod | null, status?: TollFreeVerificationStatus | null, currentStep?: TollFreeVerificationStep | null, phoneNumberIds?: Array<any | null> | null, firstSampleMessage?: string | null, secondSampleMessage?: string | null, messageAmount?: TollFreeVerificationMessageAmount | null, useCaseName?: string | null, reasonOfMultipleNumbers?: string | null, verificationErrorDescription?: string | null, verificationRejectedDate?: any | null, isNotResubmitable?: boolean | null, optInAsset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null> | null, useCase?: { __typename?: 'TollFreeVerificationUseCase', useCaseDescription?: string | null, useCaseType?: TollFreeVerificationUseCaseType | null } | null, businessInfo?: { __typename?: 'TollFreeBusinessInfo', id?: any | null, name?: string | null, website?: string | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, contactInfo?: { __typename?: 'TollFreeContactInfo', id?: any | null, phoneNumber?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, formattedPhoneNumber?: string | null } | null, verificationResponse?: { __typename?: 'TwilioCodeMapping', causes?: string | null, code?: number | null, description?: string | null, message?: string | null, solutions?: string | null } | null };

export type TenDlcProfileResponseFragment = { __typename?: 'TenDlcRegisterProfileResponse', profile?: { __typename?: 'TenDlcProfile', status?: TenDlcProfileStatus | null, stockExchange?: StockExchange | null, companyStockTicker?: string | null, secondSampleMessage?: string | null, firstSampleMessage?: string | null, businessType?: TenDlcBusinessType | null, packageType?: TenDlcPackageType | null, currentStep?: TenDlcProfileStep | null, optInMethods?: Array<TenDlcOptInMethod | null> | null, optInImages?: any | null, optInDescriptions?: any | null, optInAssets?: any | null, tenDlcUseCase?: { __typename?: 'TenDlcUseCase', useCaseType?: TenDlcUseCaseType | null, useCaseDescription?: string | null } | null } | null };

export type GetFullTollFreeVerificationProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFullTollFreeVerificationProfileQuery = { __typename?: 'Query', getFullTollFreeVerificationProfile?: { __typename?: 'TollFreeVerificationProfile', id?: any | null, updatedAt?: any | null, optInMethod?: TollFreeVerificationOptInMethod | null, status?: TollFreeVerificationStatus | null, currentStep?: TollFreeVerificationStep | null, phoneNumberIds?: Array<any | null> | null, firstSampleMessage?: string | null, secondSampleMessage?: string | null, messageAmount?: TollFreeVerificationMessageAmount | null, useCaseName?: string | null, reasonOfMultipleNumbers?: string | null, verificationErrorDescription?: string | null, verificationRejectedDate?: any | null, isNotResubmitable?: boolean | null, optInAsset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null> | null, useCase?: { __typename?: 'TollFreeVerificationUseCase', useCaseDescription?: string | null, useCaseType?: TollFreeVerificationUseCaseType | null } | null, businessInfo?: { __typename?: 'TollFreeBusinessInfo', id?: any | null, name?: string | null, website?: string | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, contactInfo?: { __typename?: 'TollFreeContactInfo', id?: any | null, phoneNumber?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, formattedPhoneNumber?: string | null } | null, verificationResponse?: { __typename?: 'TwilioCodeMapping', causes?: string | null, code?: number | null, description?: string | null, message?: string | null, solutions?: string | null } | null } | null };

export type InitTollFreeVerificationProfileMutationVariables = Exact<{
  input: TollFreeVerificationRequestInput;
}>;


export type InitTollFreeVerificationProfileMutation = { __typename?: 'Mutation', initTollFreeVerificationProfile?: { __typename?: 'TollFreeVerificationProfile', id?: any | null, updatedAt?: any | null, optInMethod?: TollFreeVerificationOptInMethod | null, status?: TollFreeVerificationStatus | null, currentStep?: TollFreeVerificationStep | null, phoneNumberIds?: Array<any | null> | null, firstSampleMessage?: string | null, secondSampleMessage?: string | null, messageAmount?: TollFreeVerificationMessageAmount | null, useCaseName?: string | null, reasonOfMultipleNumbers?: string | null, verificationErrorDescription?: string | null, verificationRejectedDate?: any | null, isNotResubmitable?: boolean | null, optInAsset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null> | null, useCase?: { __typename?: 'TollFreeVerificationUseCase', useCaseDescription?: string | null, useCaseType?: TollFreeVerificationUseCaseType | null } | null, businessInfo?: { __typename?: 'TollFreeBusinessInfo', id?: any | null, name?: string | null, website?: string | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, contactInfo?: { __typename?: 'TollFreeContactInfo', id?: any | null, phoneNumber?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, formattedPhoneNumber?: string | null } | null, verificationResponse?: { __typename?: 'TwilioCodeMapping', causes?: string | null, code?: number | null, description?: string | null, message?: string | null, solutions?: string | null } | null } | null };

export type InitTfProfileBusinessInfoMutationVariables = Exact<{
  input: TfBusinessInfoRequestInput;
}>;


export type InitTfProfileBusinessInfoMutation = { __typename?: 'Mutation', initTFProfileBusinessInfo?: { __typename?: 'TollFreeVerificationProfile', id?: any | null, updatedAt?: any | null, optInMethod?: TollFreeVerificationOptInMethod | null, status?: TollFreeVerificationStatus | null, currentStep?: TollFreeVerificationStep | null, phoneNumberIds?: Array<any | null> | null, firstSampleMessage?: string | null, secondSampleMessage?: string | null, messageAmount?: TollFreeVerificationMessageAmount | null, useCaseName?: string | null, reasonOfMultipleNumbers?: string | null, verificationErrorDescription?: string | null, verificationRejectedDate?: any | null, isNotResubmitable?: boolean | null, optInAsset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null> | null, useCase?: { __typename?: 'TollFreeVerificationUseCase', useCaseDescription?: string | null, useCaseType?: TollFreeVerificationUseCaseType | null } | null, businessInfo?: { __typename?: 'TollFreeBusinessInfo', id?: any | null, name?: string | null, website?: string | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, contactInfo?: { __typename?: 'TollFreeContactInfo', id?: any | null, phoneNumber?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, formattedPhoneNumber?: string | null } | null, verificationResponse?: { __typename?: 'TwilioCodeMapping', causes?: string | null, code?: number | null, description?: string | null, message?: string | null, solutions?: string | null } | null } | null };

export type InitTfProfileContactInfoMutationVariables = Exact<{
  input: ContactInfoRequestInput;
}>;


export type InitTfProfileContactInfoMutation = { __typename?: 'Mutation', initTFProfileContactInfo?: { __typename?: 'TollFreeVerificationProfile', id?: any | null, updatedAt?: any | null, optInMethod?: TollFreeVerificationOptInMethod | null, status?: TollFreeVerificationStatus | null, currentStep?: TollFreeVerificationStep | null, phoneNumberIds?: Array<any | null> | null, firstSampleMessage?: string | null, secondSampleMessage?: string | null, messageAmount?: TollFreeVerificationMessageAmount | null, useCaseName?: string | null, reasonOfMultipleNumbers?: string | null, verificationErrorDescription?: string | null, verificationRejectedDate?: any | null, isNotResubmitable?: boolean | null, optInAsset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null> | null, useCase?: { __typename?: 'TollFreeVerificationUseCase', useCaseDescription?: string | null, useCaseType?: TollFreeVerificationUseCaseType | null } | null, businessInfo?: { __typename?: 'TollFreeBusinessInfo', id?: any | null, name?: string | null, website?: string | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, contactInfo?: { __typename?: 'TollFreeContactInfo', id?: any | null, phoneNumber?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, formattedPhoneNumber?: string | null } | null, verificationResponse?: { __typename?: 'TwilioCodeMapping', causes?: string | null, code?: number | null, description?: string | null, message?: string | null, solutions?: string | null } | null } | null };

export type InitTollFreeVerificationUseCaseMutationVariables = Exact<{
  input: TollFreeVerificationUseCaseRequestInput;
}>;


export type InitTollFreeVerificationUseCaseMutation = { __typename?: 'Mutation', initTollFreeVerificationUseCase?: { __typename?: 'TollFreeVerificationProfile', id?: any | null, updatedAt?: any | null, optInMethod?: TollFreeVerificationOptInMethod | null, status?: TollFreeVerificationStatus | null, currentStep?: TollFreeVerificationStep | null, phoneNumberIds?: Array<any | null> | null, firstSampleMessage?: string | null, secondSampleMessage?: string | null, messageAmount?: TollFreeVerificationMessageAmount | null, useCaseName?: string | null, reasonOfMultipleNumbers?: string | null, verificationErrorDescription?: string | null, verificationRejectedDate?: any | null, isNotResubmitable?: boolean | null, optInAsset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null> | null, useCase?: { __typename?: 'TollFreeVerificationUseCase', useCaseDescription?: string | null, useCaseType?: TollFreeVerificationUseCaseType | null } | null, businessInfo?: { __typename?: 'TollFreeBusinessInfo', id?: any | null, name?: string | null, website?: string | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, contactInfo?: { __typename?: 'TollFreeContactInfo', id?: any | null, phoneNumber?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, formattedPhoneNumber?: string | null } | null, verificationResponse?: { __typename?: 'TwilioCodeMapping', causes?: string | null, code?: number | null, description?: string | null, message?: string | null, solutions?: string | null } | null } | null };

export type InitTollFreeVerificationOptInMethodMutationVariables = Exact<{
  input: TollFreeVerificationOptInMethodRequestInput;
}>;


export type InitTollFreeVerificationOptInMethodMutation = { __typename?: 'Mutation', initTollFreeVerificationOptInMethod?: { __typename?: 'TollFreeVerificationProfile', id?: any | null, updatedAt?: any | null, optInMethod?: TollFreeVerificationOptInMethod | null, status?: TollFreeVerificationStatus | null, currentStep?: TollFreeVerificationStep | null, phoneNumberIds?: Array<any | null> | null, firstSampleMessage?: string | null, secondSampleMessage?: string | null, messageAmount?: TollFreeVerificationMessageAmount | null, useCaseName?: string | null, reasonOfMultipleNumbers?: string | null, verificationErrorDescription?: string | null, verificationRejectedDate?: any | null, isNotResubmitable?: boolean | null, optInAsset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null> | null, useCase?: { __typename?: 'TollFreeVerificationUseCase', useCaseDescription?: string | null, useCaseType?: TollFreeVerificationUseCaseType | null } | null, businessInfo?: { __typename?: 'TollFreeBusinessInfo', id?: any | null, name?: string | null, website?: string | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, contactInfo?: { __typename?: 'TollFreeContactInfo', id?: any | null, phoneNumber?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, formattedPhoneNumber?: string | null } | null, verificationResponse?: { __typename?: 'TwilioCodeMapping', causes?: string | null, code?: number | null, description?: string | null, message?: string | null, solutions?: string | null } | null } | null };

export type InitTollFreeVerificationTermsMutationVariables = Exact<{ [key: string]: never; }>;


export type InitTollFreeVerificationTermsMutation = { __typename?: 'Mutation', initTollFreeVerificationTerms?: { __typename?: 'TollFreeVerificationProfile', id?: any | null, updatedAt?: any | null, optInMethod?: TollFreeVerificationOptInMethod | null, status?: TollFreeVerificationStatus | null, currentStep?: TollFreeVerificationStep | null, phoneNumberIds?: Array<any | null> | null, firstSampleMessage?: string | null, secondSampleMessage?: string | null, messageAmount?: TollFreeVerificationMessageAmount | null, useCaseName?: string | null, reasonOfMultipleNumbers?: string | null, verificationErrorDescription?: string | null, verificationRejectedDate?: any | null, isNotResubmitable?: boolean | null, optInAsset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null> | null, useCase?: { __typename?: 'TollFreeVerificationUseCase', useCaseDescription?: string | null, useCaseType?: TollFreeVerificationUseCaseType | null } | null, businessInfo?: { __typename?: 'TollFreeBusinessInfo', id?: any | null, name?: string | null, website?: string | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, contactInfo?: { __typename?: 'TollFreeContactInfo', id?: any | null, phoneNumber?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, formattedPhoneNumber?: string | null } | null, verificationResponse?: { __typename?: 'TwilioCodeMapping', causes?: string | null, code?: number | null, description?: string | null, message?: string | null, solutions?: string | null } | null } | null };

export type TollFreeVerificationProfilePreviousStepMutationVariables = Exact<{ [key: string]: never; }>;


export type TollFreeVerificationProfilePreviousStepMutation = { __typename?: 'Mutation', tollFreeVerificationProfilePreviousStep?: { __typename?: 'TollFreeVerificationProfile', id?: any | null, updatedAt?: any | null, optInMethod?: TollFreeVerificationOptInMethod | null, status?: TollFreeVerificationStatus | null, currentStep?: TollFreeVerificationStep | null, phoneNumberIds?: Array<any | null> | null, firstSampleMessage?: string | null, secondSampleMessage?: string | null, messageAmount?: TollFreeVerificationMessageAmount | null, useCaseName?: string | null, reasonOfMultipleNumbers?: string | null, verificationErrorDescription?: string | null, verificationRejectedDate?: any | null, isNotResubmitable?: boolean | null, optInAsset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null> | null, useCase?: { __typename?: 'TollFreeVerificationUseCase', useCaseDescription?: string | null, useCaseType?: TollFreeVerificationUseCaseType | null } | null, businessInfo?: { __typename?: 'TollFreeBusinessInfo', id?: any | null, name?: string | null, website?: string | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, contactInfo?: { __typename?: 'TollFreeContactInfo', id?: any | null, phoneNumber?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, formattedPhoneNumber?: string | null } | null, verificationResponse?: { __typename?: 'TwilioCodeMapping', causes?: string | null, code?: number | null, description?: string | null, message?: string | null, solutions?: string | null } | null } | null };

export type GetFullTenDlcProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFullTenDlcProfileQuery = { __typename?: 'Query', getFullTenDlcProfile?: { __typename?: 'TenDlcRegisterProfileResponse', profile?: { __typename?: 'TenDlcProfile', status?: TenDlcProfileStatus | null, stockExchange?: StockExchange | null, companyStockTicker?: string | null, secondSampleMessage?: string | null, firstSampleMessage?: string | null, businessType?: TenDlcBusinessType | null, packageType?: TenDlcPackageType | null, currentStep?: TenDlcProfileStep | null, optInMethods?: Array<TenDlcOptInMethod | null> | null, optInImages?: any | null, optInDescriptions?: any | null, optInAssets?: any | null, tenDlcUseCase?: { __typename?: 'TenDlcUseCase', useCaseType?: TenDlcUseCaseType | null, useCaseDescription?: string | null } | null } | null } | null };

export type InitPackageTenDlcMutationVariables = Exact<{
  input: TenDlcSelectPackageRequestInput;
}>;


export type InitPackageTenDlcMutation = { __typename?: 'Mutation', initPackageTenDlc?: { __typename?: 'TenDlcRegisterProfileResponse', profile?: { __typename?: 'TenDlcProfile', status?: TenDlcProfileStatus | null, stockExchange?: StockExchange | null, companyStockTicker?: string | null, secondSampleMessage?: string | null, firstSampleMessage?: string | null, businessType?: TenDlcBusinessType | null, packageType?: TenDlcPackageType | null, currentStep?: TenDlcProfileStep | null, optInMethods?: Array<TenDlcOptInMethod | null> | null, optInImages?: any | null, optInDescriptions?: any | null, optInAssets?: any | null, tenDlcUseCase?: { __typename?: 'TenDlcUseCase', useCaseType?: TenDlcUseCaseType | null, useCaseDescription?: string | null } | null } | null } | null };

export type InitUseCaseTenDlcMutationVariables = Exact<{
  input: TenDlcUseCaseRequestInput;
}>;


export type InitUseCaseTenDlcMutation = { __typename?: 'Mutation', initUseCaseTenDlc?: { __typename?: 'TenDlcRegisterProfileResponse', profile?: { __typename?: 'TenDlcProfile', status?: TenDlcProfileStatus | null, stockExchange?: StockExchange | null, companyStockTicker?: string | null, secondSampleMessage?: string | null, firstSampleMessage?: string | null, businessType?: TenDlcBusinessType | null, packageType?: TenDlcPackageType | null, currentStep?: TenDlcProfileStep | null, optInMethods?: Array<TenDlcOptInMethod | null> | null, optInImages?: any | null, optInDescriptions?: any | null, optInAssets?: any | null, tenDlcUseCase?: { __typename?: 'TenDlcUseCase', useCaseType?: TenDlcUseCaseType | null, useCaseDescription?: string | null } | null } | null } | null };

export type InitOptInMethodTenDlcMutationVariables = Exact<{
  input: TenDlcOptInMethodRequestInput;
}>;


export type InitOptInMethodTenDlcMutation = { __typename?: 'Mutation', initOptInMethodTenDlc?: { __typename?: 'TenDlcRegisterProfileResponse', profile?: { __typename?: 'TenDlcProfile', status?: TenDlcProfileStatus | null, stockExchange?: StockExchange | null, companyStockTicker?: string | null, secondSampleMessage?: string | null, firstSampleMessage?: string | null, businessType?: TenDlcBusinessType | null, packageType?: TenDlcPackageType | null, currentStep?: TenDlcProfileStep | null, optInMethods?: Array<TenDlcOptInMethod | null> | null, optInImages?: any | null, optInDescriptions?: any | null, optInAssets?: any | null, tenDlcUseCase?: { __typename?: 'TenDlcUseCase', useCaseType?: TenDlcUseCaseType | null, useCaseDescription?: string | null } | null } | null } | null };

export type InitOptInDescriptionTenDlcMutationVariables = Exact<{
  input: TenDlcOptInDescriptionRequestInput;
}>;


export type InitOptInDescriptionTenDlcMutation = { __typename?: 'Mutation', initOptInDescriptionTenDlc?: { __typename?: 'TenDlcRegisterProfileResponse', profile?: { __typename?: 'TenDlcProfile', status?: TenDlcProfileStatus | null, stockExchange?: StockExchange | null, companyStockTicker?: string | null, secondSampleMessage?: string | null, firstSampleMessage?: string | null, businessType?: TenDlcBusinessType | null, packageType?: TenDlcPackageType | null, currentStep?: TenDlcProfileStep | null, optInMethods?: Array<TenDlcOptInMethod | null> | null, optInImages?: any | null, optInDescriptions?: any | null, optInAssets?: any | null, tenDlcUseCase?: { __typename?: 'TenDlcUseCase', useCaseType?: TenDlcUseCaseType | null, useCaseDescription?: string | null } | null } | null } | null };

export type InitOptInImageTenDlcMutationVariables = Exact<{
  input: TenDlcOptInImagesRequestInput;
}>;


export type InitOptInImageTenDlcMutation = { __typename?: 'Mutation', initOptInImageTenDlc?: { __typename?: 'TenDlcRegisterProfileResponse', profile?: { __typename?: 'TenDlcProfile', status?: TenDlcProfileStatus | null, stockExchange?: StockExchange | null, companyStockTicker?: string | null, secondSampleMessage?: string | null, firstSampleMessage?: string | null, businessType?: TenDlcBusinessType | null, packageType?: TenDlcPackageType | null, currentStep?: TenDlcProfileStep | null, optInMethods?: Array<TenDlcOptInMethod | null> | null, optInImages?: any | null, optInDescriptions?: any | null, optInAssets?: any | null, tenDlcUseCase?: { __typename?: 'TenDlcUseCase', useCaseType?: TenDlcUseCaseType | null, useCaseDescription?: string | null } | null } | null } | null };

export type InitMessageSampleTenDlcMutationVariables = Exact<{
  input: TenDlcMessageSampleRequestInput;
}>;


export type InitMessageSampleTenDlcMutation = { __typename?: 'Mutation', initMessageSampleTenDlc?: { __typename?: 'TenDlcRegisterProfileResponse', profile?: { __typename?: 'TenDlcProfile', status?: TenDlcProfileStatus | null, stockExchange?: StockExchange | null, companyStockTicker?: string | null, secondSampleMessage?: string | null, firstSampleMessage?: string | null, businessType?: TenDlcBusinessType | null, packageType?: TenDlcPackageType | null, currentStep?: TenDlcProfileStep | null, optInMethods?: Array<TenDlcOptInMethod | null> | null, optInImages?: any | null, optInDescriptions?: any | null, optInAssets?: any | null, tenDlcUseCase?: { __typename?: 'TenDlcUseCase', useCaseType?: TenDlcUseCaseType | null, useCaseDescription?: string | null } | null } | null } | null };

export type CompleteTenDlcMutationVariables = Exact<{
  paymentMethodId: Scalars['String'];
}>;


export type CompleteTenDlcMutation = { __typename?: 'Mutation', completeTenDlc?: { __typename?: 'TenDlcRegisterProfileResponse', profile?: { __typename?: 'TenDlcProfile', status?: TenDlcProfileStatus | null, stockExchange?: StockExchange | null, companyStockTicker?: string | null, secondSampleMessage?: string | null, firstSampleMessage?: string | null, businessType?: TenDlcBusinessType | null, packageType?: TenDlcPackageType | null, currentStep?: TenDlcProfileStep | null, optInMethods?: Array<TenDlcOptInMethod | null> | null, optInImages?: any | null, optInDescriptions?: any | null, optInAssets?: any | null, tenDlcUseCase?: { __typename?: 'TenDlcUseCase', useCaseType?: TenDlcUseCaseType | null, useCaseDescription?: string | null } | null } | null } | null };

export type PreviousStepTenDlcMutationVariables = Exact<{ [key: string]: never; }>;


export type PreviousStepTenDlcMutation = { __typename?: 'Mutation', previousStepTenDlc?: { __typename?: 'TenDlcRegisterProfileResponse', profile?: { __typename?: 'TenDlcProfile', status?: TenDlcProfileStatus | null, stockExchange?: StockExchange | null, companyStockTicker?: string | null, secondSampleMessage?: string | null, firstSampleMessage?: string | null, businessType?: TenDlcBusinessType | null, packageType?: TenDlcPackageType | null, currentStep?: TenDlcProfileStep | null, optInMethods?: Array<TenDlcOptInMethod | null> | null, optInImages?: any | null, optInDescriptions?: any | null, optInAssets?: any | null, tenDlcUseCase?: { __typename?: 'TenDlcUseCase', useCaseType?: TenDlcUseCaseType | null, useCaseDescription?: string | null } | null } | null } | null };

export type CreateConversionMutationVariables = Exact<{
  conversion?: InputMaybe<UpdateConversionRequestInput>;
}>;


export type CreateConversionMutation = { __typename?: 'Mutation', createConversion?: { __typename?: 'ConversionResponse', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit: boolean, conversion: number, totalHits: any, revenue: number, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null };

export type UpdateConversionMutationVariables = Exact<{
  conversion?: InputMaybe<UpdateConversionRequestInput>;
}>;


export type UpdateConversionMutation = { __typename?: 'Mutation', updateConversion?: { __typename?: 'ConversionResponse', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit: boolean, conversion: number, totalHits: any, revenue: number, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null };

export type DeleteConversionsMutationVariables = Exact<{
  conversionIds: Array<InputMaybe<Scalars['Long']>> | InputMaybe<Scalars['Long']>;
}>;


export type DeleteConversionsMutation = { __typename?: 'Mutation', deleteConversions: boolean };

export type GetConversionsQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
  searchPattern?: InputMaybe<Scalars['String']>;
}>;


export type GetConversionsQuery = { __typename?: 'Query', getConversions?: { __typename?: 'PageResponse_ConversionResponse', total: any, pageNumber: number, pageSize: number, content?: Array<{ __typename?: 'ConversionResponse', conversion: number, totalHits: any, revenue: number, id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit: boolean, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null> | null } | null };

export type GetConversionsTotalStatisticsQueryVariables = Exact<{
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
}>;


export type GetConversionsTotalStatisticsQuery = { __typename?: 'Query', getConversionsTotalStatistics?: { __typename?: 'ConversionStatistics', total?: any | null, revenue?: number | null, totalCosts?: number | null, roi?: number | null, percentage?: number | null } | null };

export type GetConversionQueryVariables = Exact<{
  conversionId?: InputMaybe<Scalars['Long']>;
}>;


export type GetConversionQuery = { __typename?: 'Query', getConversion?: { __typename?: 'ConversionResponse', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit: boolean, conversion: number, totalHits: any, revenue: number, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null };

export type GetConversionStatisticsQueryVariables = Exact<{
  conversionId?: InputMaybe<Scalars['Long']>;
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
}>;


export type GetConversionStatisticsQuery = { __typename?: 'Query', getConversionStatistics?: { __typename?: 'ConversionStatistics', totalCosts?: number | null, revenue?: number | null, roi?: number | null, percentage?: number | null, total?: any | null } | null };

export type GetConversionHitsQueryVariables = Exact<{
  conversionId?: InputMaybe<Scalars['Long']>;
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
  page?: InputMaybe<PaginationInput>;
}>;


export type GetConversionHitsQuery = { __typename?: 'Query', getConversionHits?: { __typename?: 'PageResponse_ConversionHitProjection', total: any, pageSize: number, pageNumber: number, content?: Array<{ __typename?: 'ConversionHitProjection', id?: any | null, name?: string | null, date?: any | null, amount?: number | null, phone?: string | null } | null> | null } | null };

export type ConversionResponseFragment = { __typename?: 'ConversionResponse', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit: boolean, conversion: number, totalHits: any, revenue: number, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null };

export type ConversionResponseListFragment = { __typename?: 'ConversionResponse', conversion: number, totalHits: any, revenue: number, id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit: boolean, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null };

export type ConversionFragment = { __typename?: 'Conversion', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit?: boolean | null, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null };

export type ActiveCampaignFragmentFragment = { __typename?: 'ActiveCampaignIntegration', apiKey?: string | null, apiUrl?: string | null, connected?: boolean | null, connectedUser?: string | null };

export type OAuth2IntegrationResponseFragmentFragment = { __typename?: 'OAuth2IntegrationResponse', connected?: boolean | null, connectedUser?: string | null, invalidated: boolean, type?: AccountIntegrationType | null, authUrl?: string | null };

export type AccountIntegrationsFragmentFragment = { __typename?: 'AccountIntegrationsResponse', activeCampaign?: { __typename?: 'ActiveCampaignIntegration', apiKey?: string | null, apiUrl?: string | null, connected?: boolean | null, connectedUser?: string | null } | null, OAuth2Integrations?: Array<{ __typename?: 'OAuth2IntegrationResponse', connected?: boolean | null, connectedUser?: string | null, invalidated: boolean, type?: AccountIntegrationType | null, authUrl?: string | null } | null> | null };

export type GetIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIntegrationsQuery = { __typename?: 'Query', getIntegrations?: { __typename?: 'AccountIntegrationsResponse', activeCampaign?: { __typename?: 'ActiveCampaignIntegration', apiKey?: string | null, apiUrl?: string | null, connected?: boolean | null, connectedUser?: string | null } | null, OAuth2Integrations?: Array<{ __typename?: 'OAuth2IntegrationResponse', connected?: boolean | null, connectedUser?: string | null, invalidated: boolean, type?: AccountIntegrationType | null, authUrl?: string | null } | null> | null } | null };

export type GetContactWebhookUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContactWebhookUrlQuery = { __typename?: 'Query', getContactWebhookUrl?: string | null };

export type SetupIntegrationMutationVariables = Exact<{
  input: AccountIntegrationsInput;
}>;


export type SetupIntegrationMutation = { __typename?: 'Mutation', setupIntegration?: { __typename?: 'AccountIntegrationsResponse', activeCampaign?: { __typename?: 'ActiveCampaignIntegration', apiKey?: string | null, apiUrl?: string | null, connected?: boolean | null, connectedUser?: string | null } | null, OAuth2Integrations?: Array<{ __typename?: 'OAuth2IntegrationResponse', connected?: boolean | null, connectedUser?: string | null, invalidated: boolean, type?: AccountIntegrationType | null, authUrl?: string | null } | null> | null } | null };

export type DisconnectIntegrationMutationVariables = Exact<{
  accountIntegrationType: AccountIntegrationType;
}>;


export type DisconnectIntegrationMutation = { __typename?: 'Mutation', disconnectIntegration?: { __typename?: 'AccountIntegrationsResponse', activeCampaign?: { __typename?: 'ActiveCampaignIntegration', apiKey?: string | null, apiUrl?: string | null, connected?: boolean | null, connectedUser?: string | null } | null, OAuth2Integrations?: Array<{ __typename?: 'OAuth2IntegrationResponse', connected?: boolean | null, connectedUser?: string | null, invalidated: boolean, type?: AccountIntegrationType | null, authUrl?: string | null } | null> | null } | null };

export type GetAllNumbersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllNumbersQuery = { __typename?: 'Query', getAllNumbers?: Array<{ __typename?: 'PhoneNumberWithVerificationProfileData', useCaseTitle?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null } | null> | null };

export type GetNumbersPageQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
  searchPattern?: InputMaybe<Scalars['String']>;
}>;


export type GetNumbersPageQuery = { __typename?: 'Query', getNumbersPage?: { __typename?: 'PageResponse_PhoneNumberWithVerificationProfileData', pageSize: number, total: any, pageNumber: number, content?: Array<{ __typename?: 'PhoneNumberWithVerificationProfileData', useCaseTitle?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null } | null> | null } | null };

export type GetAvailablePhoneNumbersQueryVariables = Exact<{
  pageSize: Scalars['Int'];
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  areaCode?: InputMaybe<Scalars['String']>;
  partOfNumber?: InputMaybe<Scalars['String']>;
  phoneNumberType?: InputMaybe<PhoneNumberType>;
  state?: InputMaybe<Scalars['String']>;
}>;


export type GetAvailablePhoneNumbersQuery = { __typename?: 'Query', getAvailablePhoneNumbers?: { __typename?: 'AvailablePhoneNumbers', availablePhoneNumbers?: Array<{ __typename?: 'TwPhoneNumber', phoneNumber?: string | null, friendlyName?: string | null, isoCountry?: string | null, locality?: string | null, region?: string | null } | null> | null } | null };

export type FindCitiesQueryVariables = Exact<{
  country?: InputMaybe<Scalars['String']>;
  cityName?: InputMaybe<Scalars['String']>;
}>;


export type FindCitiesQuery = { __typename?: 'Query', findCities?: Array<{ __typename?: 'Location', city?: string | null, state?: string | null } | null> | null };

export type ReservePhoneNumberMutationVariables = Exact<{
  input?: InputMaybe<ReservePhoneNumberRequestInput>;
}>;


export type ReservePhoneNumberMutation = { __typename?: 'Mutation', reservePhoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null };

export type UpdatePhoneNumbersMutationVariables = Exact<{
  inputUpdatePhoneNumber?: InputMaybe<UpdatePhoneNumbersRequestInput>;
}>;


export type UpdatePhoneNumbersMutation = { __typename?: 'Mutation', updatePhoneNumbers?: Array<{ __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null> | null };

export type ReleasePhoneNumberMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Long']>;
}>;


export type ReleasePhoneNumberMutation = { __typename?: 'Mutation', releasePhoneNumber?: string | null };

export type DeletePhoneNumberMutationVariables = Exact<{
  id: Scalars['Long'];
}>;


export type DeletePhoneNumberMutation = { __typename?: 'Mutation', deletePhoneNumber: boolean };

export type GetProfileOrganizationsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetProfileOrganizationsQuery = { __typename?: 'Query', getProfileOrganizations?: Array<{ __typename?: 'MemberProfileOrganization', id?: any | null, companyName?: string | null } | null> | null };

export type SelectOrganizationMutationVariables = Exact<{
  organizationId: Scalars['Long'];
}>;


export type SelectOrganizationMutation = { __typename?: 'Mutation', selectOrganization?: { __typename?: 'MemberResponse', registrationFinished: boolean, name?: string | null, displayRole?: string | null, displayState?: string | null, isAdmin?: boolean | null, accessType?: InvitationAccessType | null, listIds?: Array<any | null> | null, invitationLink?: string | null, deletedAt?: any | null, updatedAt?: any | null, createdAt?: any | null, phone?: string | null, internationalPhone?: string | null, email?: string | null, role?: MemberRole | null, lastName?: string | null, firstName?: string | null, id?: any | null, state?: MemberState | null, memberHash?: string | null, uniqueId?: string | null, memberRegistration?: { __typename?: 'MemberRegistration', type?: MemberRegistrationType | null, oldCredits?: number | null, currentStep?: number | null, migratedEmail?: string | null, selectedPriceId?: string | null, migrationFinished: boolean, oldCreditsForPurchase: number, oldCreditsFree: number, oldCreditsLastYear: number, saveCredits: boolean, oldSubscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null } | null, organization?: { __typename?: 'Organization', id?: any | null, uuid?: any | null, updatedAt?: any | null, migrationStatus?: Status | null, createdAt?: any | null, companyName?: string | null, employees?: string | null, website?: string | null, formattedPhoneNumber?: string | null, phoneCountryCode?: string | null, status?: OrganizationStatus | null, phoneCheckerEnabled: boolean, allowImport: boolean, termsUrl?: string | null, complianceUrl?: string | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, recordingPin?: any | null, carrierFeePaymentFailed: boolean, contract: boolean, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null, userTimeZone?: { __typename?: 'UserTimeZone', fullName?: string | null, offset?: string | null, shortName?: string | null, zoneAbbreviation?: string | null, zoneId?: string | null } | null, invitationBid?: { __typename?: 'InvitationBid', role?: InvitationRole | null, expirationDate?: any | null, email?: string | null, uuid?: any | null, id?: any | null, listIds?: Array<any | null> | null } | null } | null };

export type CreateOrganizationMutationVariables = Exact<{
  input: OrganizationUpdateInput;
  tokenId?: InputMaybe<Scalars['String']>;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization?: { __typename?: 'MemberAndCLSubscription', member?: { __typename?: 'MemberResponse', registrationFinished: boolean, name?: string | null, displayRole?: string | null, displayState?: string | null, isAdmin?: boolean | null, accessType?: InvitationAccessType | null, listIds?: Array<any | null> | null, invitationLink?: string | null, deletedAt?: any | null, updatedAt?: any | null, createdAt?: any | null, phone?: string | null, internationalPhone?: string | null, email?: string | null, role?: MemberRole | null, lastName?: string | null, firstName?: string | null, id?: any | null, state?: MemberState | null, memberHash?: string | null, uniqueId?: string | null, memberRegistration?: { __typename?: 'MemberRegistration', type?: MemberRegistrationType | null, oldCredits?: number | null, currentStep?: number | null, migratedEmail?: string | null, selectedPriceId?: string | null, migrationFinished: boolean, oldCreditsForPurchase: number, oldCreditsFree: number, oldCreditsLastYear: number, saveCredits: boolean, oldSubscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null } | null, organization?: { __typename?: 'Organization', id?: any | null, uuid?: any | null, updatedAt?: any | null, migrationStatus?: Status | null, createdAt?: any | null, companyName?: string | null, employees?: string | null, website?: string | null, formattedPhoneNumber?: string | null, phoneCountryCode?: string | null, status?: OrganizationStatus | null, phoneCheckerEnabled: boolean, allowImport: boolean, termsUrl?: string | null, complianceUrl?: string | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, recordingPin?: any | null, carrierFeePaymentFailed: boolean, contract: boolean, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null, userTimeZone?: { __typename?: 'UserTimeZone', fullName?: string | null, offset?: string | null, shortName?: string | null, zoneAbbreviation?: string | null, zoneId?: string | null } | null, invitationBid?: { __typename?: 'InvitationBid', role?: InvitationRole | null, expirationDate?: any | null, email?: string | null, uuid?: any | null, id?: any | null, listIds?: Array<any | null> | null } | null } | null, subscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null } | null };

export type AdminOrganizationComplianceListQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
  search?: InputMaybe<OrganizationComplianceSearchInput>;
}>;


export type AdminOrganizationComplianceListQuery = { __typename?: 'Query', adminOrganizationComplianceList?: { __typename?: 'PageResponse_OrganizationComplianceResponse', pageSize: number, pageNumber: number, total: any, content?: Array<{ __typename?: 'OrganizationComplianceResponse', id?: any | null, companyName?: string | null, status?: string | null, trialPeriodEnded?: boolean | null, businessProfileId?: any | null, businessProfileStatus?: BusinessProfileStatus | null, tollFreeStatus?: TollFreeVerificationStatus | null, tollFreeProfileId?: any | null, organizationStatus?: string | null, signupDate?: any | null } | null> | null } | null };

export type AdminGetFullTollFreeVerificationProfileQueryVariables = Exact<{
  organizationId: Scalars['Long'];
}>;


export type AdminGetFullTollFreeVerificationProfileQuery = { __typename?: 'Query', adminGetFullTollFreeVerificationProfile?: { __typename?: 'TollFreeVerificationProfile', id?: any | null, updatedAt?: any | null, optInMethod?: TollFreeVerificationOptInMethod | null, status?: TollFreeVerificationStatus | null, currentStep?: TollFreeVerificationStep | null, phoneNumberIds?: Array<any | null> | null, firstSampleMessage?: string | null, secondSampleMessage?: string | null, messageAmount?: TollFreeVerificationMessageAmount | null, useCaseName?: string | null, reasonOfMultipleNumbers?: string | null, verificationErrorDescription?: string | null, verificationRejectedDate?: any | null, isNotResubmitable?: boolean | null, optInAsset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null> | null, useCase?: { __typename?: 'TollFreeVerificationUseCase', useCaseDescription?: string | null, useCaseType?: TollFreeVerificationUseCaseType | null } | null, businessInfo?: { __typename?: 'TollFreeBusinessInfo', id?: any | null, name?: string | null, website?: string | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, contactInfo?: { __typename?: 'TollFreeContactInfo', id?: any | null, phoneNumber?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, formattedPhoneNumber?: string | null } | null, verificationResponse?: { __typename?: 'TwilioCodeMapping', causes?: string | null, code?: number | null, description?: string | null, message?: string | null, solutions?: string | null } | null } | null };

export type AdminInitTollFreeVerificationProfileMutationVariables = Exact<{
  input: TollFreeVerificationRequestInput;
  organizationId: Scalars['Long'];
}>;


export type AdminInitTollFreeVerificationProfileMutation = { __typename?: 'Mutation', adminInitTollFreeVerificationProfile?: { __typename?: 'TollFreeVerificationProfile', id?: any | null, updatedAt?: any | null, optInMethod?: TollFreeVerificationOptInMethod | null, status?: TollFreeVerificationStatus | null, currentStep?: TollFreeVerificationStep | null, phoneNumberIds?: Array<any | null> | null, firstSampleMessage?: string | null, secondSampleMessage?: string | null, messageAmount?: TollFreeVerificationMessageAmount | null, useCaseName?: string | null, reasonOfMultipleNumbers?: string | null, verificationErrorDescription?: string | null, verificationRejectedDate?: any | null, isNotResubmitable?: boolean | null, optInAsset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null> | null, useCase?: { __typename?: 'TollFreeVerificationUseCase', useCaseDescription?: string | null, useCaseType?: TollFreeVerificationUseCaseType | null } | null, businessInfo?: { __typename?: 'TollFreeBusinessInfo', id?: any | null, name?: string | null, website?: string | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, contactInfo?: { __typename?: 'TollFreeContactInfo', id?: any | null, phoneNumber?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, formattedPhoneNumber?: string | null } | null, verificationResponse?: { __typename?: 'TwilioCodeMapping', causes?: string | null, code?: number | null, description?: string | null, message?: string | null, solutions?: string | null } | null } | null };

export type AdminInitTfProfileBusinessInfoMutationVariables = Exact<{
  input: TfBusinessInfoRequestInput;
  organizationId: Scalars['Long'];
}>;


export type AdminInitTfProfileBusinessInfoMutation = { __typename?: 'Mutation', adminInitTFProfileBusinessInfo?: { __typename?: 'TollFreeVerificationProfile', id?: any | null, updatedAt?: any | null, optInMethod?: TollFreeVerificationOptInMethod | null, status?: TollFreeVerificationStatus | null, currentStep?: TollFreeVerificationStep | null, phoneNumberIds?: Array<any | null> | null, firstSampleMessage?: string | null, secondSampleMessage?: string | null, messageAmount?: TollFreeVerificationMessageAmount | null, useCaseName?: string | null, reasonOfMultipleNumbers?: string | null, verificationErrorDescription?: string | null, verificationRejectedDate?: any | null, isNotResubmitable?: boolean | null, optInAsset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null> | null, useCase?: { __typename?: 'TollFreeVerificationUseCase', useCaseDescription?: string | null, useCaseType?: TollFreeVerificationUseCaseType | null } | null, businessInfo?: { __typename?: 'TollFreeBusinessInfo', id?: any | null, name?: string | null, website?: string | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, contactInfo?: { __typename?: 'TollFreeContactInfo', id?: any | null, phoneNumber?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, formattedPhoneNumber?: string | null } | null, verificationResponse?: { __typename?: 'TwilioCodeMapping', causes?: string | null, code?: number | null, description?: string | null, message?: string | null, solutions?: string | null } | null } | null };

export type AdminInitTfProfileContactInfoMutationVariables = Exact<{
  input: ContactInfoRequestInput;
  organizationId: Scalars['Long'];
}>;


export type AdminInitTfProfileContactInfoMutation = { __typename?: 'Mutation', adminInitTFProfileContactInfo?: { __typename?: 'TollFreeVerificationProfile', id?: any | null, updatedAt?: any | null, optInMethod?: TollFreeVerificationOptInMethod | null, status?: TollFreeVerificationStatus | null, currentStep?: TollFreeVerificationStep | null, phoneNumberIds?: Array<any | null> | null, firstSampleMessage?: string | null, secondSampleMessage?: string | null, messageAmount?: TollFreeVerificationMessageAmount | null, useCaseName?: string | null, reasonOfMultipleNumbers?: string | null, verificationErrorDescription?: string | null, verificationRejectedDate?: any | null, isNotResubmitable?: boolean | null, optInAsset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null> | null, useCase?: { __typename?: 'TollFreeVerificationUseCase', useCaseDescription?: string | null, useCaseType?: TollFreeVerificationUseCaseType | null } | null, businessInfo?: { __typename?: 'TollFreeBusinessInfo', id?: any | null, name?: string | null, website?: string | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, contactInfo?: { __typename?: 'TollFreeContactInfo', id?: any | null, phoneNumber?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, formattedPhoneNumber?: string | null } | null, verificationResponse?: { __typename?: 'TwilioCodeMapping', causes?: string | null, code?: number | null, description?: string | null, message?: string | null, solutions?: string | null } | null } | null };

export type AdminInitTollFreeVerificationUseCaseMutationVariables = Exact<{
  input: TollFreeVerificationUseCaseRequestInput;
  organizationId: Scalars['Long'];
}>;


export type AdminInitTollFreeVerificationUseCaseMutation = { __typename?: 'Mutation', adminInitTollFreeVerificationUseCase?: { __typename?: 'TollFreeVerificationProfile', id?: any | null, updatedAt?: any | null, optInMethod?: TollFreeVerificationOptInMethod | null, status?: TollFreeVerificationStatus | null, currentStep?: TollFreeVerificationStep | null, phoneNumberIds?: Array<any | null> | null, firstSampleMessage?: string | null, secondSampleMessage?: string | null, messageAmount?: TollFreeVerificationMessageAmount | null, useCaseName?: string | null, reasonOfMultipleNumbers?: string | null, verificationErrorDescription?: string | null, verificationRejectedDate?: any | null, isNotResubmitable?: boolean | null, optInAsset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null> | null, useCase?: { __typename?: 'TollFreeVerificationUseCase', useCaseDescription?: string | null, useCaseType?: TollFreeVerificationUseCaseType | null } | null, businessInfo?: { __typename?: 'TollFreeBusinessInfo', id?: any | null, name?: string | null, website?: string | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, contactInfo?: { __typename?: 'TollFreeContactInfo', id?: any | null, phoneNumber?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, formattedPhoneNumber?: string | null } | null, verificationResponse?: { __typename?: 'TwilioCodeMapping', causes?: string | null, code?: number | null, description?: string | null, message?: string | null, solutions?: string | null } | null } | null };

export type AdminInitTollFreeVerificationOptInMethodMutationVariables = Exact<{
  input: TollFreeVerificationOptInMethodRequestInput;
  organizationId: Scalars['Long'];
}>;


export type AdminInitTollFreeVerificationOptInMethodMutation = { __typename?: 'Mutation', adminInitTollFreeVerificationOptInMethod?: { __typename?: 'TollFreeVerificationProfile', id?: any | null, updatedAt?: any | null, optInMethod?: TollFreeVerificationOptInMethod | null, status?: TollFreeVerificationStatus | null, currentStep?: TollFreeVerificationStep | null, phoneNumberIds?: Array<any | null> | null, firstSampleMessage?: string | null, secondSampleMessage?: string | null, messageAmount?: TollFreeVerificationMessageAmount | null, useCaseName?: string | null, reasonOfMultipleNumbers?: string | null, verificationErrorDescription?: string | null, verificationRejectedDate?: any | null, isNotResubmitable?: boolean | null, optInAsset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null> | null, useCase?: { __typename?: 'TollFreeVerificationUseCase', useCaseDescription?: string | null, useCaseType?: TollFreeVerificationUseCaseType | null } | null, businessInfo?: { __typename?: 'TollFreeBusinessInfo', id?: any | null, name?: string | null, website?: string | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, contactInfo?: { __typename?: 'TollFreeContactInfo', id?: any | null, phoneNumber?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, formattedPhoneNumber?: string | null } | null, verificationResponse?: { __typename?: 'TwilioCodeMapping', causes?: string | null, code?: number | null, description?: string | null, message?: string | null, solutions?: string | null } | null } | null };

export type AdminInitTollFreeVerificationTermsMutationVariables = Exact<{
  organizationId: Scalars['Long'];
  shouldSend: Scalars['Boolean'];
}>;


export type AdminInitTollFreeVerificationTermsMutation = { __typename?: 'Mutation', adminInitTollFreeVerificationTerms?: { __typename?: 'TollFreeVerificationProfile', id?: any | null, updatedAt?: any | null, optInMethod?: TollFreeVerificationOptInMethod | null, status?: TollFreeVerificationStatus | null, currentStep?: TollFreeVerificationStep | null, phoneNumberIds?: Array<any | null> | null, firstSampleMessage?: string | null, secondSampleMessage?: string | null, messageAmount?: TollFreeVerificationMessageAmount | null, useCaseName?: string | null, reasonOfMultipleNumbers?: string | null, verificationErrorDescription?: string | null, verificationRejectedDate?: any | null, isNotResubmitable?: boolean | null, optInAsset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null> | null, useCase?: { __typename?: 'TollFreeVerificationUseCase', useCaseDescription?: string | null, useCaseType?: TollFreeVerificationUseCaseType | null } | null, businessInfo?: { __typename?: 'TollFreeBusinessInfo', id?: any | null, name?: string | null, website?: string | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, contactInfo?: { __typename?: 'TollFreeContactInfo', id?: any | null, phoneNumber?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, formattedPhoneNumber?: string | null } | null, verificationResponse?: { __typename?: 'TwilioCodeMapping', causes?: string | null, code?: number | null, description?: string | null, message?: string | null, solutions?: string | null } | null } | null };

export type AdminTollFreeVerificationProfilePreviousStepMutationVariables = Exact<{
  organizationId: Scalars['Long'];
}>;


export type AdminTollFreeVerificationProfilePreviousStepMutation = { __typename?: 'Mutation', adminTollFreeVerificationProfilePreviousStep?: { __typename?: 'TollFreeVerificationProfile', id?: any | null, updatedAt?: any | null, optInMethod?: TollFreeVerificationOptInMethod | null, status?: TollFreeVerificationStatus | null, currentStep?: TollFreeVerificationStep | null, phoneNumberIds?: Array<any | null> | null, firstSampleMessage?: string | null, secondSampleMessage?: string | null, messageAmount?: TollFreeVerificationMessageAmount | null, useCaseName?: string | null, reasonOfMultipleNumbers?: string | null, verificationErrorDescription?: string | null, verificationRejectedDate?: any | null, isNotResubmitable?: boolean | null, optInAsset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null> | null, useCase?: { __typename?: 'TollFreeVerificationUseCase', useCaseDescription?: string | null, useCaseType?: TollFreeVerificationUseCaseType | null } | null, businessInfo?: { __typename?: 'TollFreeBusinessInfo', id?: any | null, name?: string | null, website?: string | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, contactInfo?: { __typename?: 'TollFreeContactInfo', id?: any | null, phoneNumber?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, formattedPhoneNumber?: string | null } | null, verificationResponse?: { __typename?: 'TwilioCodeMapping', causes?: string | null, code?: number | null, description?: string | null, message?: string | null, solutions?: string | null } | null } | null };

export type AdminGetFullBusinessProfileQueryVariables = Exact<{
  organizationId: Scalars['Long'];
}>;


export type AdminGetFullBusinessProfileQuery = { __typename?: 'Query', adminGetFullBusinessProfile?: { __typename?: 'BusinessProfileResponse', businessGeneralInfo?: { __typename?: 'BusinessGeneralInfo', id?: any | null, name?: string | null, manual?: boolean | null, einDocument?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, businessAuthorizedUsers?: Array<{ __typename?: 'BusinessAuthorizedUser', id?: any | null, firstName?: string | null, lastName?: string | null, title?: string | null, jobPosition?: BusinessJobPosition | null, email?: string | null, phoneNumber?: string | null, formattedPhoneNumber?: string | null } | null> | null, businessInfo?: { __typename?: 'BusinessInfo', id?: any | null, type?: BusinessType | null, industry?: BusinessIndustry | null, website?: string | null, socialMediaProfile?: string | null, operationRegions?: Array<BusinessOperationRegion | null> | null } | null, businessProfile?: { __typename?: 'BusinessProfile', id?: any | null, currentStep?: number | null, hasEin: boolean, ein?: string | null, status?: BusinessProfileStatus | null, operationCountries?: Array<CountryCode | null> | null, updatedAt?: any | null } | null, errors?: Array<{ __typename?: 'BusinessProfileEvaluationErrors', errorCode?: number | null, failureReason?: string | null, fieldName?: string | null, passed: boolean, objectType?: string | null } | null> | null } | null };

export type AdminRegisterBusinessProfileMutationVariables = Exact<{
  input: BusinessProfileRequestInput;
  organizationId: Scalars['Long'];
}>;


export type AdminRegisterBusinessProfileMutation = { __typename?: 'Mutation', adminRegisterBusinessProfile?: { __typename?: 'BusinessProfileResponse', businessGeneralInfo?: { __typename?: 'BusinessGeneralInfo', id?: any | null, name?: string | null, manual?: boolean | null, einDocument?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, businessAuthorizedUsers?: Array<{ __typename?: 'BusinessAuthorizedUser', id?: any | null, firstName?: string | null, lastName?: string | null, title?: string | null, jobPosition?: BusinessJobPosition | null, email?: string | null, phoneNumber?: string | null, formattedPhoneNumber?: string | null } | null> | null, businessInfo?: { __typename?: 'BusinessInfo', id?: any | null, type?: BusinessType | null, industry?: BusinessIndustry | null, website?: string | null, socialMediaProfile?: string | null, operationRegions?: Array<BusinessOperationRegion | null> | null } | null, businessProfile?: { __typename?: 'BusinessProfile', id?: any | null, currentStep?: number | null, hasEin: boolean, ein?: string | null, status?: BusinessProfileStatus | null, operationCountries?: Array<CountryCode | null> | null, updatedAt?: any | null } | null, errors?: Array<{ __typename?: 'BusinessProfileEvaluationErrors', errorCode?: number | null, failureReason?: string | null, fieldName?: string | null, passed: boolean, objectType?: string | null } | null> | null } | null };

export type AdminInitCompanyTypeMutationVariables = Exact<{
  hasEin: Scalars['Boolean'];
  organizationId: Scalars['Long'];
}>;


export type AdminInitCompanyTypeMutation = { __typename?: 'Mutation', adminInitCompanyType?: { __typename?: 'BusinessProfileResponse', businessGeneralInfo?: { __typename?: 'BusinessGeneralInfo', id?: any | null, name?: string | null, manual?: boolean | null, einDocument?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, businessAuthorizedUsers?: Array<{ __typename?: 'BusinessAuthorizedUser', id?: any | null, firstName?: string | null, lastName?: string | null, title?: string | null, jobPosition?: BusinessJobPosition | null, email?: string | null, phoneNumber?: string | null, formattedPhoneNumber?: string | null } | null> | null, businessInfo?: { __typename?: 'BusinessInfo', id?: any | null, type?: BusinessType | null, industry?: BusinessIndustry | null, website?: string | null, socialMediaProfile?: string | null, operationRegions?: Array<BusinessOperationRegion | null> | null } | null, businessProfile?: { __typename?: 'BusinessProfile', id?: any | null, currentStep?: number | null, hasEin: boolean, ein?: string | null, status?: BusinessProfileStatus | null, operationCountries?: Array<CountryCode | null> | null, updatedAt?: any | null } | null, errors?: Array<{ __typename?: 'BusinessProfileEvaluationErrors', errorCode?: number | null, failureReason?: string | null, fieldName?: string | null, passed: boolean, objectType?: string | null } | null> | null } | null };

export type AdminBusinessProfilePreviousStepMutationVariables = Exact<{
  organizationId: Scalars['Long'];
}>;


export type AdminBusinessProfilePreviousStepMutation = { __typename?: 'Mutation', adminBusinessProfilePreviousStep?: { __typename?: 'BusinessProfileResponse', businessGeneralInfo?: { __typename?: 'BusinessGeneralInfo', id?: any | null, name?: string | null, manual?: boolean | null, einDocument?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, businessAuthorizedUsers?: Array<{ __typename?: 'BusinessAuthorizedUser', id?: any | null, firstName?: string | null, lastName?: string | null, title?: string | null, jobPosition?: BusinessJobPosition | null, email?: string | null, phoneNumber?: string | null, formattedPhoneNumber?: string | null } | null> | null, businessInfo?: { __typename?: 'BusinessInfo', id?: any | null, type?: BusinessType | null, industry?: BusinessIndustry | null, website?: string | null, socialMediaProfile?: string | null, operationRegions?: Array<BusinessOperationRegion | null> | null } | null, businessProfile?: { __typename?: 'BusinessProfile', id?: any | null, currentStep?: number | null, hasEin: boolean, ein?: string | null, status?: BusinessProfileStatus | null, operationCountries?: Array<CountryCode | null> | null, updatedAt?: any | null } | null, errors?: Array<{ __typename?: 'BusinessProfileEvaluationErrors', errorCode?: number | null, failureReason?: string | null, fieldName?: string | null, passed: boolean, objectType?: string | null } | null> | null } | null };

export type AdminInitBusinessGeneralInfoMutationVariables = Exact<{
  input: BusinessGeneralInfoRequestInput;
  organizationId: Scalars['Long'];
}>;


export type AdminInitBusinessGeneralInfoMutation = { __typename?: 'Mutation', adminInitBusinessGeneralInfo?: { __typename?: 'BusinessProfileResponse', businessGeneralInfo?: { __typename?: 'BusinessGeneralInfo', id?: any | null, name?: string | null, manual?: boolean | null, einDocument?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, businessAuthorizedUsers?: Array<{ __typename?: 'BusinessAuthorizedUser', id?: any | null, firstName?: string | null, lastName?: string | null, title?: string | null, jobPosition?: BusinessJobPosition | null, email?: string | null, phoneNumber?: string | null, formattedPhoneNumber?: string | null } | null> | null, businessInfo?: { __typename?: 'BusinessInfo', id?: any | null, type?: BusinessType | null, industry?: BusinessIndustry | null, website?: string | null, socialMediaProfile?: string | null, operationRegions?: Array<BusinessOperationRegion | null> | null } | null, businessProfile?: { __typename?: 'BusinessProfile', id?: any | null, currentStep?: number | null, hasEin: boolean, ein?: string | null, status?: BusinessProfileStatus | null, operationCountries?: Array<CountryCode | null> | null, updatedAt?: any | null } | null, errors?: Array<{ __typename?: 'BusinessProfileEvaluationErrors', errorCode?: number | null, failureReason?: string | null, fieldName?: string | null, passed: boolean, objectType?: string | null } | null> | null } | null };

export type AdminInitBusinessInfoMutationVariables = Exact<{
  input: BusinessInfoRequestInput;
  organizationId: Scalars['Long'];
}>;


export type AdminInitBusinessInfoMutation = { __typename?: 'Mutation', adminInitBusinessInfo?: { __typename?: 'BusinessProfileResponse', businessGeneralInfo?: { __typename?: 'BusinessGeneralInfo', id?: any | null, name?: string | null, manual?: boolean | null, einDocument?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, businessAuthorizedUsers?: Array<{ __typename?: 'BusinessAuthorizedUser', id?: any | null, firstName?: string | null, lastName?: string | null, title?: string | null, jobPosition?: BusinessJobPosition | null, email?: string | null, phoneNumber?: string | null, formattedPhoneNumber?: string | null } | null> | null, businessInfo?: { __typename?: 'BusinessInfo', id?: any | null, type?: BusinessType | null, industry?: BusinessIndustry | null, website?: string | null, socialMediaProfile?: string | null, operationRegions?: Array<BusinessOperationRegion | null> | null } | null, businessProfile?: { __typename?: 'BusinessProfile', id?: any | null, currentStep?: number | null, hasEin: boolean, ein?: string | null, status?: BusinessProfileStatus | null, operationCountries?: Array<CountryCode | null> | null, updatedAt?: any | null } | null, errors?: Array<{ __typename?: 'BusinessProfileEvaluationErrors', errorCode?: number | null, failureReason?: string | null, fieldName?: string | null, passed: boolean, objectType?: string | null } | null> | null } | null };

export type AdminInitBusinessAuthorizedUsersMutationVariables = Exact<{
  input: Array<InputMaybe<BusinessAuthorizedUserRequestInput>> | InputMaybe<BusinessAuthorizedUserRequestInput>;
  organizationId: Scalars['Long'];
}>;


export type AdminInitBusinessAuthorizedUsersMutation = { __typename?: 'Mutation', adminInitBusinessAuthorizedUsers?: { __typename?: 'BusinessProfileResponse', businessGeneralInfo?: { __typename?: 'BusinessGeneralInfo', id?: any | null, name?: string | null, manual?: boolean | null, einDocument?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, businessAuthorizedUsers?: Array<{ __typename?: 'BusinessAuthorizedUser', id?: any | null, firstName?: string | null, lastName?: string | null, title?: string | null, jobPosition?: BusinessJobPosition | null, email?: string | null, phoneNumber?: string | null, formattedPhoneNumber?: string | null } | null> | null, businessInfo?: { __typename?: 'BusinessInfo', id?: any | null, type?: BusinessType | null, industry?: BusinessIndustry | null, website?: string | null, socialMediaProfile?: string | null, operationRegions?: Array<BusinessOperationRegion | null> | null } | null, businessProfile?: { __typename?: 'BusinessProfile', id?: any | null, currentStep?: number | null, hasEin: boolean, ein?: string | null, status?: BusinessProfileStatus | null, operationCountries?: Array<CountryCode | null> | null, updatedAt?: any | null } | null, errors?: Array<{ __typename?: 'BusinessProfileEvaluationErrors', errorCode?: number | null, failureReason?: string | null, fieldName?: string | null, passed: boolean, objectType?: string | null } | null> | null } | null };

export type AdminInitBusinessTermsMutationVariables = Exact<{
  organizationId: Scalars['Long'];
}>;


export type AdminInitBusinessTermsMutation = { __typename?: 'Mutation', adminInitBusinessTerms?: { __typename?: 'BusinessProfileResponse', businessGeneralInfo?: { __typename?: 'BusinessGeneralInfo', id?: any | null, name?: string | null, manual?: boolean | null, einDocument?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, businessAuthorizedUsers?: Array<{ __typename?: 'BusinessAuthorizedUser', id?: any | null, firstName?: string | null, lastName?: string | null, title?: string | null, jobPosition?: BusinessJobPosition | null, email?: string | null, phoneNumber?: string | null, formattedPhoneNumber?: string | null } | null> | null, businessInfo?: { __typename?: 'BusinessInfo', id?: any | null, type?: BusinessType | null, industry?: BusinessIndustry | null, website?: string | null, socialMediaProfile?: string | null, operationRegions?: Array<BusinessOperationRegion | null> | null } | null, businessProfile?: { __typename?: 'BusinessProfile', id?: any | null, currentStep?: number | null, hasEin: boolean, ein?: string | null, status?: BusinessProfileStatus | null, operationCountries?: Array<CountryCode | null> | null, updatedAt?: any | null } | null, errors?: Array<{ __typename?: 'BusinessProfileEvaluationErrors', errorCode?: number | null, failureReason?: string | null, fieldName?: string | null, passed: boolean, objectType?: string | null } | null> | null } | null };

export type AdminInitBusinessGeneralInfoByEinMutationVariables = Exact<{
  ein: Scalars['String'];
  organizationId: Scalars['Long'];
}>;


export type AdminInitBusinessGeneralInfoByEinMutation = { __typename?: 'Mutation', adminInitBusinessGeneralInfoByEin?: { __typename?: 'BusinessProfileResponse', businessGeneralInfo?: { __typename?: 'BusinessGeneralInfo', id?: any | null, name?: string | null, manual?: boolean | null, einDocument?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, businessAuthorizedUsers?: Array<{ __typename?: 'BusinessAuthorizedUser', id?: any | null, firstName?: string | null, lastName?: string | null, title?: string | null, jobPosition?: BusinessJobPosition | null, email?: string | null, phoneNumber?: string | null, formattedPhoneNumber?: string | null } | null> | null, businessInfo?: { __typename?: 'BusinessInfo', id?: any | null, type?: BusinessType | null, industry?: BusinessIndustry | null, website?: string | null, socialMediaProfile?: string | null, operationRegions?: Array<BusinessOperationRegion | null> | null } | null, businessProfile?: { __typename?: 'BusinessProfile', id?: any | null, currentStep?: number | null, hasEin: boolean, ein?: string | null, status?: BusinessProfileStatus | null, operationCountries?: Array<CountryCode | null> | null, updatedAt?: any | null } | null, errors?: Array<{ __typename?: 'BusinessProfileEvaluationErrors', errorCode?: number | null, failureReason?: string | null, fieldName?: string | null, passed: boolean, objectType?: string | null } | null> | null } | null };

export type AdminInitBusinessGeneralInfoByManualEinMutationVariables = Exact<{
  input: BusinessGeneralInfoEinRequestInput;
  organizationId: Scalars['Long'];
}>;


export type AdminInitBusinessGeneralInfoByManualEinMutation = { __typename?: 'Mutation', adminInitBusinessGeneralInfoByManualEin?: { __typename?: 'BusinessProfileResponse', businessGeneralInfo?: { __typename?: 'BusinessGeneralInfo', id?: any | null, name?: string | null, manual?: boolean | null, einDocument?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, businessAuthorizedUsers?: Array<{ __typename?: 'BusinessAuthorizedUser', id?: any | null, firstName?: string | null, lastName?: string | null, title?: string | null, jobPosition?: BusinessJobPosition | null, email?: string | null, phoneNumber?: string | null, formattedPhoneNumber?: string | null } | null> | null, businessInfo?: { __typename?: 'BusinessInfo', id?: any | null, type?: BusinessType | null, industry?: BusinessIndustry | null, website?: string | null, socialMediaProfile?: string | null, operationRegions?: Array<BusinessOperationRegion | null> | null } | null, businessProfile?: { __typename?: 'BusinessProfile', id?: any | null, currentStep?: number | null, hasEin: boolean, ein?: string | null, status?: BusinessProfileStatus | null, operationCountries?: Array<CountryCode | null> | null, updatedAt?: any | null } | null, errors?: Array<{ __typename?: 'BusinessProfileEvaluationErrors', errorCode?: number | null, failureReason?: string | null, fieldName?: string | null, passed: boolean, objectType?: string | null } | null> | null } | null };

export type OrganizationResponseFragmentFragment = { __typename?: 'OrganizationResponse', id?: any | null, isMigrated?: boolean | null, ownerId?: any | null, status?: string | null, companyName?: string | null, ownerName?: string | null, ownerEmail?: string | null, signupDate?: any | null, credits?: number | null, organizationStatus?: string | null, trialPeriodEnded: boolean, canUseGlobalNumber?: boolean | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, cancelAccountAt?: any | null };

export type OrganizationDetailsFragmentFragment = { __typename?: 'OrganizationDetails', id?: any | null, ownerId?: any | null, migrated: boolean, organizationStatus?: OrganizationStatus | null, status?: string | null, canUseGlobalNumber?: boolean | null, companyName?: string | null, signupDate?: any | null, teamSize?: string | null, twilioSubAccountSid?: string | null, hubSpotAppId?: string | null, hubSpotCompanyId?: string | null, hubSpotOwnerId?: string | null, totalContacts: number, intercomCompanyLink?: string | null, intercomContactLink?: string | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, totalSpend?: number | null, mrr?: number | null, contract: boolean, subscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null, balances?: { __typename?: 'Balances', plan?: number | null, purchased?: number | null, purchasedExpire?: any | null, rollover?: number | null } | null, billingInfo?: { __typename?: 'OrgBillingInfo', autoRecharge?: boolean | null, autoRechargeCreditsAmount?: number | null, autoRechargeThreshold?: AutoRechargeThreshold | null, status?: Status | null, stripeCustomerId?: string | null, backupPaymentMethod?: string | null, primaryPaymentMethod?: string | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id?: string | null, type?: string | null, card?: { __typename?: 'Card', last4?: string | null, expYear?: string | null, expMonth?: string | null, country?: string | null, brand?: string | null, funding?: string | null } | null } | null> | null } | null, tollFreeVerificationProfile?: { __typename?: 'TollFreeVerificationProfile', id?: any | null, updatedAt?: any | null, optInMethod?: TollFreeVerificationOptInMethod | null, status?: TollFreeVerificationStatus | null, currentStep?: TollFreeVerificationStep | null, phoneNumberIds?: Array<any | null> | null, firstSampleMessage?: string | null, secondSampleMessage?: string | null, messageAmount?: TollFreeVerificationMessageAmount | null, useCaseName?: string | null, reasonOfMultipleNumbers?: string | null, verificationErrorDescription?: string | null, verificationRejectedDate?: any | null, isNotResubmitable?: boolean | null, optInAsset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null> | null, useCase?: { __typename?: 'TollFreeVerificationUseCase', useCaseDescription?: string | null, useCaseType?: TollFreeVerificationUseCaseType | null } | null, businessInfo?: { __typename?: 'TollFreeBusinessInfo', id?: any | null, name?: string | null, website?: string | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, contactInfo?: { __typename?: 'TollFreeContactInfo', id?: any | null, phoneNumber?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, formattedPhoneNumber?: string | null } | null, verificationResponse?: { __typename?: 'TwilioCodeMapping', causes?: string | null, code?: number | null, description?: string | null, message?: string | null, solutions?: string | null } | null } | null, businessProfile?: { __typename?: 'BusinessProfileResponse', businessGeneralInfo?: { __typename?: 'BusinessGeneralInfo', id?: any | null, name?: string | null, manual?: boolean | null, einDocument?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, businessAuthorizedUsers?: Array<{ __typename?: 'BusinessAuthorizedUser', id?: any | null, firstName?: string | null, lastName?: string | null, title?: string | null, jobPosition?: BusinessJobPosition | null, email?: string | null, phoneNumber?: string | null, formattedPhoneNumber?: string | null } | null> | null, businessInfo?: { __typename?: 'BusinessInfo', id?: any | null, type?: BusinessType | null, industry?: BusinessIndustry | null, website?: string | null, socialMediaProfile?: string | null, operationRegions?: Array<BusinessOperationRegion | null> | null } | null, businessProfile?: { __typename?: 'BusinessProfile', id?: any | null, currentStep?: number | null, hasEin: boolean, ein?: string | null, status?: BusinessProfileStatus | null, operationCountries?: Array<CountryCode | null> | null, updatedAt?: any | null } | null, errors?: Array<{ __typename?: 'BusinessProfileEvaluationErrors', errorCode?: number | null, failureReason?: string | null, fieldName?: string | null, passed: boolean, objectType?: string | null } | null> | null } | null, integrations?: { __typename?: 'AccountIntegrationsResponse', activeCampaign?: { __typename?: 'ActiveCampaignIntegration', apiKey?: string | null, apiUrl?: string | null, connected?: boolean | null, connectedUser?: string | null } | null, OAuth2Integrations?: Array<{ __typename?: 'OAuth2IntegrationResponse', connected?: boolean | null, connectedUser?: string | null, invalidated: boolean, type?: AccountIntegrationType | null, authUrl?: string | null } | null> | null } | null, activeSubscriberInfo?: { __typename?: 'ActiveSubscriberInfo', days: number, months: number, years: number } | null };

export type SuperAdminContactImportStateFragment = { __typename?: 'ContactImportState', id?: any | null, createdAt?: any | null, totalCount: any, originalFileName?: string | null, allowImportStatus?: AllowImportStatus | null, organization?: { __typename?: 'Organization', id?: any | null, companyName?: string | null, allowImport: boolean, importApprovedAt?: any | null, importApprover?: { __typename?: 'Member', id?: any | null, profile?: { __typename?: 'MemberProfile', name?: string | null } | null } | null } | null, member?: { __typename?: 'Member', id?: any | null, profile?: { __typename?: 'MemberProfile', name?: string | null, email: string } | null } | null };

export type OrganizationComplianceResponseFragmentFragment = { __typename?: 'OrganizationComplianceResponse', id?: any | null, companyName?: string | null, status?: string | null, trialPeriodEnded?: boolean | null, businessProfileId?: any | null, businessProfileStatus?: BusinessProfileStatus | null, tollFreeStatus?: TollFreeVerificationStatus | null, tollFreeProfileId?: any | null, organizationStatus?: string | null, signupDate?: any | null };

export type OrganizationsListQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
  search?: InputMaybe<OrganizationSearchInput>;
}>;


export type OrganizationsListQuery = { __typename?: 'Query', organizationsList?: { __typename?: 'PageResponse_OrganizationResponse', pageSize: number, pageNumber: number, total: any, content?: Array<{ __typename?: 'OrganizationResponse', id?: any | null, isMigrated?: boolean | null, ownerId?: any | null, status?: string | null, companyName?: string | null, ownerName?: string | null, ownerEmail?: string | null, signupDate?: any | null, credits?: number | null, organizationStatus?: string | null, trialPeriodEnded: boolean, canUseGlobalNumber?: boolean | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, cancelAccountAt?: any | null } | null> | null } | null };

export type GetTokenForOrganizationQueryVariables = Exact<{
  request?: InputMaybe<OrganizationTokenRequestInput>;
}>;


export type GetTokenForOrganizationQuery = { __typename?: 'Query', getTokenForOrganization?: { __typename?: 'OrganizationTokenResponse', token?: string | null } | null };

export type GetOrganizationDetailsQueryVariables = Exact<{
  id: Scalars['Long'];
}>;


export type GetOrganizationDetailsQuery = { __typename?: 'Query', getOrganizationDetails?: { __typename?: 'OrganizationDetails', id?: any | null, ownerId?: any | null, migrated: boolean, organizationStatus?: OrganizationStatus | null, status?: string | null, canUseGlobalNumber?: boolean | null, companyName?: string | null, signupDate?: any | null, teamSize?: string | null, twilioSubAccountSid?: string | null, hubSpotAppId?: string | null, hubSpotCompanyId?: string | null, hubSpotOwnerId?: string | null, totalContacts: number, intercomCompanyLink?: string | null, intercomContactLink?: string | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, totalSpend?: number | null, mrr?: number | null, contract: boolean, subscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null, balances?: { __typename?: 'Balances', plan?: number | null, purchased?: number | null, purchasedExpire?: any | null, rollover?: number | null } | null, billingInfo?: { __typename?: 'OrgBillingInfo', autoRecharge?: boolean | null, autoRechargeCreditsAmount?: number | null, autoRechargeThreshold?: AutoRechargeThreshold | null, status?: Status | null, stripeCustomerId?: string | null, backupPaymentMethod?: string | null, primaryPaymentMethod?: string | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id?: string | null, type?: string | null, card?: { __typename?: 'Card', last4?: string | null, expYear?: string | null, expMonth?: string | null, country?: string | null, brand?: string | null, funding?: string | null } | null } | null> | null } | null, tollFreeVerificationProfile?: { __typename?: 'TollFreeVerificationProfile', id?: any | null, updatedAt?: any | null, optInMethod?: TollFreeVerificationOptInMethod | null, status?: TollFreeVerificationStatus | null, currentStep?: TollFreeVerificationStep | null, phoneNumberIds?: Array<any | null> | null, firstSampleMessage?: string | null, secondSampleMessage?: string | null, messageAmount?: TollFreeVerificationMessageAmount | null, useCaseName?: string | null, reasonOfMultipleNumbers?: string | null, verificationErrorDescription?: string | null, verificationRejectedDate?: any | null, isNotResubmitable?: boolean | null, optInAsset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null> | null, useCase?: { __typename?: 'TollFreeVerificationUseCase', useCaseDescription?: string | null, useCaseType?: TollFreeVerificationUseCaseType | null } | null, businessInfo?: { __typename?: 'TollFreeBusinessInfo', id?: any | null, name?: string | null, website?: string | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, contactInfo?: { __typename?: 'TollFreeContactInfo', id?: any | null, phoneNumber?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, formattedPhoneNumber?: string | null } | null, verificationResponse?: { __typename?: 'TwilioCodeMapping', causes?: string | null, code?: number | null, description?: string | null, message?: string | null, solutions?: string | null } | null } | null, businessProfile?: { __typename?: 'BusinessProfileResponse', businessGeneralInfo?: { __typename?: 'BusinessGeneralInfo', id?: any | null, name?: string | null, manual?: boolean | null, einDocument?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, businessAuthorizedUsers?: Array<{ __typename?: 'BusinessAuthorizedUser', id?: any | null, firstName?: string | null, lastName?: string | null, title?: string | null, jobPosition?: BusinessJobPosition | null, email?: string | null, phoneNumber?: string | null, formattedPhoneNumber?: string | null } | null> | null, businessInfo?: { __typename?: 'BusinessInfo', id?: any | null, type?: BusinessType | null, industry?: BusinessIndustry | null, website?: string | null, socialMediaProfile?: string | null, operationRegions?: Array<BusinessOperationRegion | null> | null } | null, businessProfile?: { __typename?: 'BusinessProfile', id?: any | null, currentStep?: number | null, hasEin: boolean, ein?: string | null, status?: BusinessProfileStatus | null, operationCountries?: Array<CountryCode | null> | null, updatedAt?: any | null } | null, errors?: Array<{ __typename?: 'BusinessProfileEvaluationErrors', errorCode?: number | null, failureReason?: string | null, fieldName?: string | null, passed: boolean, objectType?: string | null } | null> | null } | null, integrations?: { __typename?: 'AccountIntegrationsResponse', activeCampaign?: { __typename?: 'ActiveCampaignIntegration', apiKey?: string | null, apiUrl?: string | null, connected?: boolean | null, connectedUser?: string | null } | null, OAuth2Integrations?: Array<{ __typename?: 'OAuth2IntegrationResponse', connected?: boolean | null, connectedUser?: string | null, invalidated: boolean, type?: AccountIntegrationType | null, authUrl?: string | null } | null> | null } | null, activeSubscriberInfo?: { __typename?: 'ActiveSubscriberInfo', days: number, months: number, years: number } | null } | null };

export type AdminGetOrganizationMembersQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['Long']>;
  page?: InputMaybe<PaginationInput>;
}>;


export type AdminGetOrganizationMembersQuery = { __typename?: 'Query', adminGetOrganizationMembers?: { __typename?: 'PageResponse_MemberResponse', total: any, pageNumber: number, pageSize: number, content?: Array<{ __typename?: 'MemberResponse', registrationFinished: boolean, name?: string | null, displayRole?: string | null, displayState?: string | null, isAdmin?: boolean | null, accessType?: InvitationAccessType | null, listIds?: Array<any | null> | null, invitationLink?: string | null, deletedAt?: any | null, updatedAt?: any | null, createdAt?: any | null, phone?: string | null, internationalPhone?: string | null, email?: string | null, role?: MemberRole | null, lastName?: string | null, firstName?: string | null, id?: any | null, state?: MemberState | null, memberHash?: string | null, uniqueId?: string | null, memberRegistration?: { __typename?: 'MemberRegistration', type?: MemberRegistrationType | null, oldCredits?: number | null, currentStep?: number | null, migratedEmail?: string | null, selectedPriceId?: string | null, migrationFinished: boolean, oldCreditsForPurchase: number, oldCreditsFree: number, oldCreditsLastYear: number, saveCredits: boolean, oldSubscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null } | null, organization?: { __typename?: 'Organization', id?: any | null, uuid?: any | null, updatedAt?: any | null, migrationStatus?: Status | null, createdAt?: any | null, companyName?: string | null, employees?: string | null, website?: string | null, formattedPhoneNumber?: string | null, phoneCountryCode?: string | null, status?: OrganizationStatus | null, phoneCheckerEnabled: boolean, allowImport: boolean, termsUrl?: string | null, complianceUrl?: string | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, recordingPin?: any | null, carrierFeePaymentFailed: boolean, contract: boolean, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null } | null, userTimeZone?: { __typename?: 'UserTimeZone', fullName?: string | null, offset?: string | null, shortName?: string | null, zoneAbbreviation?: string | null, zoneId?: string | null } | null, invitationBid?: { __typename?: 'InvitationBid', role?: InvitationRole | null, expirationDate?: any | null, email?: string | null, uuid?: any | null, id?: any | null, listIds?: Array<any | null> | null } | null } | null> | null } | null };

export type AdminGetImportHistoryQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
  searchPattern?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<AllowImportStatus>> | InputMaybe<AllowImportStatus>>;
}>;


export type AdminGetImportHistoryQuery = { __typename?: 'Query', adminGetImportHistory?: { __typename?: 'PageResponse_ContactImportState', pageSize: number, pageNumber: number, total: any, content?: Array<{ __typename?: 'ContactImportState', id?: any | null, createdAt?: any | null, totalCount: any, originalFileName?: string | null, allowImportStatus?: AllowImportStatus | null, organization?: { __typename?: 'Organization', id?: any | null, companyName?: string | null, allowImport: boolean, importApprovedAt?: any | null, importApprover?: { __typename?: 'Member', id?: any | null, profile?: { __typename?: 'MemberProfile', name?: string | null } | null } | null } | null, member?: { __typename?: 'Member', id?: any | null, profile?: { __typename?: 'MemberProfile', name?: string | null, email: string } | null } | null } | null> | null } | null };

export type AdminGetNotificationQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminGetNotificationQuery = { __typename?: 'Query', adminGetImportHistory?: { __typename?: 'PageResponse_ContactImportState', total: any } | null, adminOrganizationComplianceList?: { __typename?: 'PageResponse_OrganizationComplianceResponse', total: any } | null };

export type AdminCustomPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminCustomPlansQuery = { __typename?: 'Query', adminCustomPlans?: Array<{ __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null> | null };

export type AddOrganizationCreditsMutationVariables = Exact<{
  input: AddCreditInput;
}>;


export type AddOrganizationCreditsMutation = { __typename?: 'Mutation', addCredits?: { __typename?: 'Balances', plan?: number | null, purchased?: number | null, purchasedExpire?: any | null, rollover?: number | null } | null };

export type AdminCreateCallerIdPhoneNumberMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['Long']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
}>;


export type AdminCreateCallerIdPhoneNumberMutation = { __typename?: 'Mutation', adminCreateCallerIdPhoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null };

export type BanOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationStatusRequestInput;
}>;


export type BanOrganizationMutation = { __typename?: 'Mutation', banOrganization?: Array<{ __typename?: 'OrganizationResponse', id?: any | null, isMigrated?: boolean | null, ownerId?: any | null, status?: string | null, companyName?: string | null, ownerName?: string | null, ownerEmail?: string | null, signupDate?: any | null, credits?: number | null, organizationStatus?: string | null, trialPeriodEnded: boolean, canUseGlobalNumber?: boolean | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, cancelAccountAt?: any | null } | null> | null };

export type UnbanOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationStatusRequestInput;
}>;


export type UnbanOrganizationMutation = { __typename?: 'Mutation', unbanOrganization?: Array<{ __typename?: 'OrganizationResponse', id?: any | null, isMigrated?: boolean | null, ownerId?: any | null, status?: string | null, companyName?: string | null, ownerName?: string | null, ownerEmail?: string | null, signupDate?: any | null, credits?: number | null, organizationStatus?: string | null, trialPeriodEnded: boolean, canUseGlobalNumber?: boolean | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, cancelAccountAt?: any | null } | null> | null };

export type ResetMemberPasswordMutationVariables = Exact<{
  memberId: Scalars['Long'];
  password: Scalars['String'];
}>;


export type ResetMemberPasswordMutation = { __typename?: 'Mutation', resetMemberProfilePassword?: string | null };

export type UpdateSharedNumberAccessMutationVariables = Exact<{
  id: Scalars['Long'];
  allowed: Scalars['Boolean'];
}>;


export type UpdateSharedNumberAccessMutation = { __typename?: 'Mutation', updateSharedNumberAccess?: { __typename?: 'OrganizationDetails', id?: any | null, ownerId?: any | null, migrated: boolean, organizationStatus?: OrganizationStatus | null, status?: string | null, canUseGlobalNumber?: boolean | null, companyName?: string | null, signupDate?: any | null, teamSize?: string | null, twilioSubAccountSid?: string | null, hubSpotAppId?: string | null, hubSpotCompanyId?: string | null, hubSpotOwnerId?: string | null, totalContacts: number, intercomCompanyLink?: string | null, intercomContactLink?: string | null, ipAddress?: string | null, ipCountryCode?: string | null, ipCountryName?: string | null, totalSpend?: number | null, mrr?: number | null, contract: boolean, subscription?: { __typename?: 'CLSubscription', canceledAt?: any | null, cancelAt?: any | null, status?: ClStatus | null, renews?: any | null, trialEnd?: any | null, created?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null, limits?: { __typename?: 'Limits', campaigns?: number | null, broadcasts?: number | null, automations?: number | null, contacts?: number | null, integrations?: number | null, keywords?: number | null, numbers?: number | null, triggers?: number | null, users?: number | null, webForms?: number | null } | null, nextPlan?: { __typename?: 'UINextPlan', startDate?: any | null, price?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null } | null } | null, balances?: { __typename?: 'Balances', plan?: number | null, purchased?: number | null, purchasedExpire?: any | null, rollover?: number | null } | null, billingInfo?: { __typename?: 'OrgBillingInfo', autoRecharge?: boolean | null, autoRechargeCreditsAmount?: number | null, autoRechargeThreshold?: AutoRechargeThreshold | null, status?: Status | null, stripeCustomerId?: string | null, backupPaymentMethod?: string | null, primaryPaymentMethod?: string | null, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id?: string | null, type?: string | null, card?: { __typename?: 'Card', last4?: string | null, expYear?: string | null, expMonth?: string | null, country?: string | null, brand?: string | null, funding?: string | null } | null } | null> | null } | null, tollFreeVerificationProfile?: { __typename?: 'TollFreeVerificationProfile', id?: any | null, updatedAt?: any | null, optInMethod?: TollFreeVerificationOptInMethod | null, status?: TollFreeVerificationStatus | null, currentStep?: TollFreeVerificationStep | null, phoneNumberIds?: Array<any | null> | null, firstSampleMessage?: string | null, secondSampleMessage?: string | null, messageAmount?: TollFreeVerificationMessageAmount | null, useCaseName?: string | null, reasonOfMultipleNumbers?: string | null, verificationErrorDescription?: string | null, verificationRejectedDate?: any | null, isNotResubmitable?: boolean | null, optInAsset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null> | null, useCase?: { __typename?: 'TollFreeVerificationUseCase', useCaseDescription?: string | null, useCaseType?: TollFreeVerificationUseCaseType | null } | null, businessInfo?: { __typename?: 'TollFreeBusinessInfo', id?: any | null, name?: string | null, website?: string | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, contactInfo?: { __typename?: 'TollFreeContactInfo', id?: any | null, phoneNumber?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, formattedPhoneNumber?: string | null } | null, verificationResponse?: { __typename?: 'TwilioCodeMapping', causes?: string | null, code?: number | null, description?: string | null, message?: string | null, solutions?: string | null } | null } | null, businessProfile?: { __typename?: 'BusinessProfileResponse', businessGeneralInfo?: { __typename?: 'BusinessGeneralInfo', id?: any | null, name?: string | null, manual?: boolean | null, einDocument?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null, address?: { __typename?: 'SecondStreetAddress', street?: string | null, secondStreet?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryCode?: string | null, countryName?: string | null } | null } | null } | null, businessAuthorizedUsers?: Array<{ __typename?: 'BusinessAuthorizedUser', id?: any | null, firstName?: string | null, lastName?: string | null, title?: string | null, jobPosition?: BusinessJobPosition | null, email?: string | null, phoneNumber?: string | null, formattedPhoneNumber?: string | null } | null> | null, businessInfo?: { __typename?: 'BusinessInfo', id?: any | null, type?: BusinessType | null, industry?: BusinessIndustry | null, website?: string | null, socialMediaProfile?: string | null, operationRegions?: Array<BusinessOperationRegion | null> | null } | null, businessProfile?: { __typename?: 'BusinessProfile', id?: any | null, currentStep?: number | null, hasEin: boolean, ein?: string | null, status?: BusinessProfileStatus | null, operationCountries?: Array<CountryCode | null> | null, updatedAt?: any | null } | null, errors?: Array<{ __typename?: 'BusinessProfileEvaluationErrors', errorCode?: number | null, failureReason?: string | null, fieldName?: string | null, passed: boolean, objectType?: string | null } | null> | null } | null, integrations?: { __typename?: 'AccountIntegrationsResponse', activeCampaign?: { __typename?: 'ActiveCampaignIntegration', apiKey?: string | null, apiUrl?: string | null, connected?: boolean | null, connectedUser?: string | null } | null, OAuth2Integrations?: Array<{ __typename?: 'OAuth2IntegrationResponse', connected?: boolean | null, connectedUser?: string | null, invalidated: boolean, type?: AccountIntegrationType | null, authUrl?: string | null } | null> | null } | null, activeSubscriberInfo?: { __typename?: 'ActiveSubscriberInfo', days: number, months: number, years: number } | null } | null };

export type AdminChangeImportStateMutationVariables = Exact<{
  allowStatus: AllowImportStatus;
  importId?: InputMaybe<Scalars['Long']>;
}>;


export type AdminChangeImportStateMutation = { __typename?: 'Mutation', adminChangeImportState?: { __typename?: 'ContactImportState', id?: any | null, createdAt?: any | null, totalCount: any, originalFileName?: string | null, allowImportStatus?: AllowImportStatus | null, organization?: { __typename?: 'Organization', id?: any | null, companyName?: string | null, allowImport: boolean, importApprovedAt?: any | null, importApprover?: { __typename?: 'Member', id?: any | null, profile?: { __typename?: 'MemberProfile', name?: string | null } | null } | null } | null, member?: { __typename?: 'Member', id?: any | null, profile?: { __typename?: 'MemberProfile', name?: string | null, email: string } | null } | null } | null };

export type AdminCreateCustomPlanMutationVariables = Exact<{
  input: CustomPlanCreateRqInput;
}>;


export type AdminCreateCustomPlanMutation = { __typename?: 'Mutation', adminCreateCustomPlan?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null };

export type AdminUpdateCustomPlanMutationVariables = Exact<{
  input: CustomPlanUpdateRqInput;
}>;


export type AdminUpdateCustomPlanMutation = { __typename?: 'Mutation', adminUpdateCustomPlan?: { __typename?: 'SimplePrice', priceCatalogId?: any | null, planDescription?: string | null, priceValue?: number | null, planTitle?: string | null, planName?: string | null, planLine?: string | null, period?: string | null, creditsIncluded?: number | null, bonusValue: number, additionalCreditPrice?: number | null, customObjectPrices?: Array<{ __typename?: 'ChargeObjectPrice', creditPrice?: any | null, chargeObject?: ChargeObject | null } | null> | null, creditPrices?: Array<{ __typename?: 'CreditPrice', creditsAmount?: number | null, planName?: string | null, title?: string | null, cost?: number | null } | null> | null } | null };

export type SyncTwilioTollFreeDataMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['Long']>;
}>;


export type SyncTwilioTollFreeDataMutation = { __typename?: 'Mutation', syncTwilioTollFreeData: boolean };

export type AdminUpdateOrganizationContractMutationVariables = Exact<{
  organizationId: Scalars['Long'];
  contract: Scalars['Boolean'];
}>;


export type AdminUpdateOrganizationContractMutation = { __typename?: 'Mutation', adminUpdateOrganizationContract: boolean };

export type AdminChangeOwnerMutationVariables = Exact<{
  memberId: Scalars['Long'];
}>;


export type AdminChangeOwnerMutation = { __typename?: 'Mutation', changeOwner?: string | null };

export type TriggerFragmentFragment = { __typename?: 'Trigger', uuid?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, listIds?: Array<any | null> | null, link?: string | null, id?: any | null, name: string, sendFromCompany?: string | null, app?: AccountIntegrationType | null, appPhoneField?: string | null, status: Status, type?: ContentType | null, triggerLists?: Array<{ __typename?: 'ListTrigger', listing?: { __typename?: 'Listing', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, activeContactsCount: any, invalidContactsCount: any, totalContactsCount: any, unsubscribedContactsCount: any } | null } | null> | null, messagesStat?: { __typename?: 'StatusStatistics', callbackCount: any, successCount: any, pendingCount: any, failedCount: any, totalCount: any, unsubscribedCount: any } | null, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, ringlessMessage?: { __typename?: 'RinglessMessage', callbackEnabled: boolean, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, sendFromPhoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null, voiceMessage?: { __typename?: 'VoiceMessage', liveAnswer?: { __typename?: 'LiveAnswer', audioId?: any | null, liveAnswerEnabled?: boolean | null, transferCallEnabled?: boolean | null, transferCallNumber?: string | null, unsubscribeDigit?: number | null, transferCallDigit?: number | null, liveAnswer?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, voiceMail?: { __typename?: 'VoiceMail', audioId?: any | null, voiceMailEnabled?: boolean | null, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null } | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', total?: any | null, revenue?: number | null } | null, conversion?: { __typename?: 'Conversion', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit?: boolean | null, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null };

export type GetTriggersQueryVariables = Exact<{
  page: PaginationInput;
}>;


export type GetTriggersQuery = { __typename?: 'Query', getAllTriggers?: { __typename?: 'PageResponse_Trigger', total: any, pageSize: number, pageNumber: number, content?: Array<{ __typename?: 'Trigger', uuid?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, listIds?: Array<any | null> | null, link?: string | null, id?: any | null, name: string, sendFromCompany?: string | null, app?: AccountIntegrationType | null, appPhoneField?: string | null, status: Status, type?: ContentType | null, triggerLists?: Array<{ __typename?: 'ListTrigger', listing?: { __typename?: 'Listing', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, activeContactsCount: any, invalidContactsCount: any, totalContactsCount: any, unsubscribedContactsCount: any } | null } | null> | null, messagesStat?: { __typename?: 'StatusStatistics', callbackCount: any, successCount: any, pendingCount: any, failedCount: any, totalCount: any, unsubscribedCount: any } | null, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, ringlessMessage?: { __typename?: 'RinglessMessage', callbackEnabled: boolean, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, sendFromPhoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null, voiceMessage?: { __typename?: 'VoiceMessage', liveAnswer?: { __typename?: 'LiveAnswer', audioId?: any | null, liveAnswerEnabled?: boolean | null, transferCallEnabled?: boolean | null, transferCallNumber?: string | null, unsubscribeDigit?: number | null, transferCallDigit?: number | null, liveAnswer?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, voiceMail?: { __typename?: 'VoiceMail', audioId?: any | null, voiceMailEnabled?: boolean | null, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null } | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', total?: any | null, revenue?: number | null } | null, conversion?: { __typename?: 'Conversion', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit?: boolean | null, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null } | null> | null } | null };

export type GetTriggerQueryVariables = Exact<{
  id: Scalars['Long'];
}>;


export type GetTriggerQuery = { __typename?: 'Query', getTriggerById?: { __typename?: 'Trigger', uuid?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, listIds?: Array<any | null> | null, link?: string | null, id?: any | null, name: string, sendFromCompany?: string | null, app?: AccountIntegrationType | null, appPhoneField?: string | null, status: Status, type?: ContentType | null, triggerLists?: Array<{ __typename?: 'ListTrigger', listing?: { __typename?: 'Listing', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, activeContactsCount: any, invalidContactsCount: any, totalContactsCount: any, unsubscribedContactsCount: any } | null } | null> | null, messagesStat?: { __typename?: 'StatusStatistics', callbackCount: any, successCount: any, pendingCount: any, failedCount: any, totalCount: any, unsubscribedCount: any } | null, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, ringlessMessage?: { __typename?: 'RinglessMessage', callbackEnabled: boolean, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, sendFromPhoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null, voiceMessage?: { __typename?: 'VoiceMessage', liveAnswer?: { __typename?: 'LiveAnswer', audioId?: any | null, liveAnswerEnabled?: boolean | null, transferCallEnabled?: boolean | null, transferCallNumber?: string | null, unsubscribeDigit?: number | null, transferCallDigit?: number | null, liveAnswer?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, voiceMail?: { __typename?: 'VoiceMail', audioId?: any | null, voiceMailEnabled?: boolean | null, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null } | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', total?: any | null, revenue?: number | null } | null, conversion?: { __typename?: 'Conversion', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit?: boolean | null, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null } | null };

export type CreateTriggerMutationVariables = Exact<{
  triggerInput: TriggerInput;
}>;


export type CreateTriggerMutation = { __typename?: 'Mutation', createTrigger?: { __typename?: 'Trigger', uuid?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, listIds?: Array<any | null> | null, link?: string | null, id?: any | null, name: string, sendFromCompany?: string | null, app?: AccountIntegrationType | null, appPhoneField?: string | null, status: Status, type?: ContentType | null, triggerLists?: Array<{ __typename?: 'ListTrigger', listing?: { __typename?: 'Listing', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, activeContactsCount: any, invalidContactsCount: any, totalContactsCount: any, unsubscribedContactsCount: any } | null } | null> | null, messagesStat?: { __typename?: 'StatusStatistics', callbackCount: any, successCount: any, pendingCount: any, failedCount: any, totalCount: any, unsubscribedCount: any } | null, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, ringlessMessage?: { __typename?: 'RinglessMessage', callbackEnabled: boolean, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, sendFromPhoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null, voiceMessage?: { __typename?: 'VoiceMessage', liveAnswer?: { __typename?: 'LiveAnswer', audioId?: any | null, liveAnswerEnabled?: boolean | null, transferCallEnabled?: boolean | null, transferCallNumber?: string | null, unsubscribeDigit?: number | null, transferCallDigit?: number | null, liveAnswer?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, voiceMail?: { __typename?: 'VoiceMail', audioId?: any | null, voiceMailEnabled?: boolean | null, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null } | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', total?: any | null, revenue?: number | null } | null, conversion?: { __typename?: 'Conversion', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit?: boolean | null, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null } | null };

export type UpdateTriggerMutationVariables = Exact<{
  triggerInput: TriggerInput;
}>;


export type UpdateTriggerMutation = { __typename?: 'Mutation', updateTrigger?: { __typename?: 'Trigger', uuid?: any | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, listIds?: Array<any | null> | null, link?: string | null, id?: any | null, name: string, sendFromCompany?: string | null, app?: AccountIntegrationType | null, appPhoneField?: string | null, status: Status, type?: ContentType | null, triggerLists?: Array<{ __typename?: 'ListTrigger', listing?: { __typename?: 'Listing', id?: any | null, name?: string | null, createdAt?: any | null, updatedAt?: any | null, activeContactsCount: any, invalidContactsCount: any, totalContactsCount: any, unsubscribedContactsCount: any } | null } | null> | null, messagesStat?: { __typename?: 'StatusStatistics', callbackCount: any, successCount: any, pendingCount: any, failedCount: any, totalCount: any, unsubscribedCount: any } | null, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, ringlessMessage?: { __typename?: 'RinglessMessage', callbackEnabled: boolean, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, sendFromPhoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null, voiceMessage?: { __typename?: 'VoiceMessage', liveAnswer?: { __typename?: 'LiveAnswer', audioId?: any | null, liveAnswerEnabled?: boolean | null, transferCallEnabled?: boolean | null, transferCallNumber?: string | null, unsubscribeDigit?: number | null, transferCallDigit?: number | null, liveAnswer?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null, voiceMail?: { __typename?: 'VoiceMail', audioId?: any | null, voiceMailEnabled?: boolean | null, voiceMail?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null } | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', total?: any | null, revenue?: number | null } | null, conversion?: { __typename?: 'Conversion', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit?: boolean | null, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null } | null };

export type RemoveTriggersMutationVariables = Exact<{
  triggersIds?: InputMaybe<Array<Scalars['Long']> | Scalars['Long']>;
}>;


export type RemoveTriggersMutation = { __typename?: 'Mutation', removeTriggers?: string | null };

export type ConfirmExternalPhoneNumberMutationVariables = Exact<{
  uuid: Scalars['String'];
  code: Scalars['String'];
}>;


export type ConfirmExternalPhoneNumberMutation = { __typename?: 'Mutation', confirmExternalPhoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null };

export type AddExternalPhoneNumberMutationVariables = Exact<{
  inputPhoneNumber: Scalars['String'];
  extension?: InputMaybe<Scalars['String']>;
}>;


export type AddExternalPhoneNumberMutation = { __typename?: 'Mutation', addExternalPhoneNumber?: string | null };

export type GetTriggerMessagesQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
  uuid?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Status>;
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
}>;


export type GetTriggerMessagesQuery = { __typename?: 'Query', getTriggerMessages?: { __typename?: 'PageResponse_MessageDataResponse', total: any, pageSize: number, pageNumber: number, content?: Array<{ __typename?: 'MessageDataResponse', id?: any | null, totalShortUrl?: any | null, uniqueClicks?: any | null, type?: MessageType | null, duration?: number | null, extStatus?: string | null, extStatusLabel?: string | null, extStatusDescription?: string | null, state?: { __typename?: 'MessageStateResponse', boundType?: BoundType | null, simpleStatus?: Status | null, timeToSend?: any | null, contactName?: string | null, toNumber?: string | null, reason?: string | null, failReasonType?: FailReasonType | null, status?: Status | null, contactId?: any | null } | null } | null> | null } | null };

export type GetTriggerMessageStatisticsQueryVariables = Exact<{
  uuid?: InputMaybe<Scalars['String']>;
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
}>;


export type GetTriggerMessageStatisticsQuery = { __typename?: 'Query', getTriggerMessageStatistics?: { __typename?: 'MessageStatisticsResponse', shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, percentageStatistics?: { __typename?: 'PercentageStatistics', callbackPercentage: number, failedPercentage: number, pendingPercentage: number, successPercentage: number, unsubscribedPercentage: number } | null, todayStatistics?: { __typename?: 'StatusStatistics', callbackCount: any, successCount: any, pendingCount: any, failedCount: any, totalCount: any, unsubscribedCount: any } | null, totalStatistics?: { __typename?: 'StatusStatistics', callbackCount: any, successCount: any, pendingCount: any, failedCount: any, totalCount: any, unsubscribedCount: any } | null, chargeStatistics?: { __typename?: 'ChargeStatistics', totalCharged?: number | null } | null, voiceTransferMessageStatistics?: { __typename?: 'TotalMessageStatistics', total?: any | null, percentage?: number | null, today?: any | null } | null, conversionStatistics?: { __typename?: 'TodayConversionStatistics', revenue?: number | null, roi?: number | null, totalCosts?: number | null, total?: any | null, percentage?: number | null, todayConversionStatistics?: { __typename?: 'ConversionStatistics', percentage?: number | null, revenue?: number | null, totalCosts?: number | null, roi?: number | null, total?: any | null } | null } | null } | null };

export type GetIntegrationCustomFieldsQueryVariables = Exact<{
  byPassCache?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetIntegrationCustomFieldsQuery = { __typename?: 'Query', getIntegrationCustomFields?: Array<{ __typename?: 'IntegrationField', integrationType?: AccountIntegrationType | null, specificFields?: Array<{ __typename?: 'SpecificField', name?: string | null, key?: string | null } | null> | null, standardFields?: Array<{ __typename?: 'StandardField', name?: string | null, key?: string | null } | null> | null, phoneFields?: Array<{ __typename?: 'SpecificField', name?: string | null, key?: string | null } | null> | null } | null> | null };

export type WebFormListContactFragment = { __typename?: 'WebFormListContact', listing?: { __typename?: 'Listing', name?: string | null, id?: any | null, activeContactsCount: any } | null };

export type WebFormFragmentFragment = { __typename?: 'WebForm', id?: any | null, name: string, createdAt?: any | null, uuid?: any | null, contactsListsIds?: Array<any | null> | null, subscribeBtnText?: string | null, doubleOptInMessage?: string | null, thankYouPage?: string | null, status?: Status | null, doubleOptIn?: boolean | null, complianceMessage?: string | null, complianceUrl?: string | null, termsUrl?: string | null, webFormConfig?: string | null, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, contactsLists?: Array<{ __typename?: 'WebFormListContact', listing?: { __typename?: 'Listing', name?: string | null, id?: any | null, activeContactsCount: any } | null } | null> | null, sendFromPhoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null, fieldsToCollect?: Array<{ __typename?: 'WebFormCustomField', required?: boolean | null, field?: { __typename?: 'CustomField', createdAt?: any | null, type?: CustomFieldType | null, id?: any | null, name?: string | null, displayIndex?: number | null, key?: string | null, used?: boolean | null } | null } | null> | null, contactStatusStatistics?: { __typename?: 'ContactStatusStatistics', active?: any | null, unsubscribed?: any | null, subscribed?: any | null, confirmed?: any | null, total?: any | null } | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', total?: any | null, revenue?: number | null } | null, conversion?: { __typename?: 'Conversion', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit?: boolean | null, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null };

export type GetWebFormsQueryVariables = Exact<{
  page?: InputMaybe<PaginationInput>;
  searchPattern?: InputMaybe<Scalars['String']>;
}>;


export type GetWebFormsQuery = { __typename?: 'Query', getWebForms?: { __typename?: 'PageResponse_WebForm', pageNumber: number, pageSize: number, total: any, content?: Array<{ __typename?: 'WebForm', id?: any | null, name: string, createdAt?: any | null, uuid?: any | null, contactsListsIds?: Array<any | null> | null, subscribeBtnText?: string | null, doubleOptInMessage?: string | null, thankYouPage?: string | null, status?: Status | null, doubleOptIn?: boolean | null, complianceMessage?: string | null, complianceUrl?: string | null, termsUrl?: string | null, webFormConfig?: string | null, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, contactsLists?: Array<{ __typename?: 'WebFormListContact', listing?: { __typename?: 'Listing', name?: string | null, id?: any | null, activeContactsCount: any } | null } | null> | null, sendFromPhoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null, fieldsToCollect?: Array<{ __typename?: 'WebFormCustomField', required?: boolean | null, field?: { __typename?: 'CustomField', createdAt?: any | null, type?: CustomFieldType | null, id?: any | null, name?: string | null, displayIndex?: number | null, key?: string | null, used?: boolean | null } | null } | null> | null, contactStatusStatistics?: { __typename?: 'ContactStatusStatistics', active?: any | null, unsubscribed?: any | null, subscribed?: any | null, confirmed?: any | null, total?: any | null } | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', total?: any | null, revenue?: number | null } | null, conversion?: { __typename?: 'Conversion', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit?: boolean | null, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null } | null> | null } | null };

export type GetWebFormQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Long']>;
}>;


export type GetWebFormQuery = { __typename?: 'Query', getWebForm?: { __typename?: 'WebForm', id?: any | null, name: string, createdAt?: any | null, uuid?: any | null, contactsListsIds?: Array<any | null> | null, subscribeBtnText?: string | null, doubleOptInMessage?: string | null, thankYouPage?: string | null, status?: Status | null, doubleOptIn?: boolean | null, complianceMessage?: string | null, complianceUrl?: string | null, termsUrl?: string | null, webFormConfig?: string | null, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, contactsLists?: Array<{ __typename?: 'WebFormListContact', listing?: { __typename?: 'Listing', name?: string | null, id?: any | null, activeContactsCount: any } | null } | null> | null, sendFromPhoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null, fieldsToCollect?: Array<{ __typename?: 'WebFormCustomField', required?: boolean | null, field?: { __typename?: 'CustomField', createdAt?: any | null, type?: CustomFieldType | null, id?: any | null, name?: string | null, displayIndex?: number | null, key?: string | null, used?: boolean | null } | null } | null> | null, contactStatusStatistics?: { __typename?: 'ContactStatusStatistics', active?: any | null, unsubscribed?: any | null, subscribed?: any | null, confirmed?: any | null, total?: any | null } | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', total?: any | null, revenue?: number | null } | null, conversion?: { __typename?: 'Conversion', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit?: boolean | null, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null } | null };

export type GetWebFormContactsStatisticsQueryVariables = Exact<{
  uuid?: InputMaybe<Scalars['String']>;
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
}>;


export type GetWebFormContactsStatisticsQuery = { __typename?: 'Query', getWebFormContactsStatistics?: { __typename?: 'ContactStatisticsByUuidResponse', percentageStatistics?: { __typename?: 'PercentageContactStatusStatistics', confirmed?: number | null, subscribed?: number | null, unsubscribed?: number | null, active?: number | null } | null, chargeStatistics?: { __typename?: 'ChargeStatistics', totalCharged?: number | null } | null, todayStat?: { __typename?: 'ContactStatusStatistics', total?: any | null, confirmed?: any | null, subscribed?: any | null, unsubscribed?: any | null, active?: any | null } | null, totalStat?: { __typename?: 'ContactStatusStatistics', unsubscribed?: any | null, subscribed?: any | null, confirmed?: any | null, total?: any | null, active?: any | null } | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'TodayConversionStatistics', revenue?: number | null, roi?: number | null, totalCosts?: number | null, total?: any | null, percentage?: number | null, todayConversionStatistics?: { __typename?: 'ConversionStatistics', percentage?: number | null, revenue?: number | null, totalCosts?: number | null, roi?: number | null, total?: any | null } | null } | null } | null };

export type GetWebFormContactsQueryVariables = Exact<{
  uuid?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<PaginationInput>;
  dateRange?: InputMaybe<DateRangeCriteriaInput>;
  status?: InputMaybe<Status>;
}>;


export type GetWebFormContactsQuery = { __typename?: 'Query', getWebFormContacts?: { __typename?: 'PageResponse_ContactLightResponse', total: any, pageSize: number, pageNumber: number, content?: Array<{ __typename?: 'ContactLightResponse', email?: string | null, name?: string | null, id?: any | null, phone?: string | null, createdAt?: any | null } | null> | null } | null };

export type CreateWebFormMutationVariables = Exact<{
  input: WebFormInput;
}>;


export type CreateWebFormMutation = { __typename?: 'Mutation', createWebForm?: { __typename?: 'WebForm', id?: any | null, name: string, createdAt?: any | null, uuid?: any | null, contactsListsIds?: Array<any | null> | null, subscribeBtnText?: string | null, doubleOptInMessage?: string | null, thankYouPage?: string | null, status?: Status | null, doubleOptIn?: boolean | null, complianceMessage?: string | null, complianceUrl?: string | null, termsUrl?: string | null, webFormConfig?: string | null, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, contactsLists?: Array<{ __typename?: 'WebFormListContact', listing?: { __typename?: 'Listing', name?: string | null, id?: any | null, activeContactsCount: any } | null } | null> | null, sendFromPhoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null, fieldsToCollect?: Array<{ __typename?: 'WebFormCustomField', required?: boolean | null, field?: { __typename?: 'CustomField', createdAt?: any | null, type?: CustomFieldType | null, id?: any | null, name?: string | null, displayIndex?: number | null, key?: string | null, used?: boolean | null } | null } | null> | null, contactStatusStatistics?: { __typename?: 'ContactStatusStatistics', active?: any | null, unsubscribed?: any | null, subscribed?: any | null, confirmed?: any | null, total?: any | null } | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', total?: any | null, revenue?: number | null } | null, conversion?: { __typename?: 'Conversion', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit?: boolean | null, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null } | null };

export type UpdateWebFormMutationVariables = Exact<{
  input: WebFormInput;
}>;


export type UpdateWebFormMutation = { __typename?: 'Mutation', updateWebForm?: { __typename?: 'WebForm', id?: any | null, name: string, createdAt?: any | null, uuid?: any | null, contactsListsIds?: Array<any | null> | null, subscribeBtnText?: string | null, doubleOptInMessage?: string | null, thankYouPage?: string | null, status?: Status | null, doubleOptIn?: boolean | null, complianceMessage?: string | null, complianceUrl?: string | null, termsUrl?: string | null, webFormConfig?: string | null, smsMessage?: { __typename?: 'SMSMessage', compliance: boolean, complianceText?: string | null, text?: string | null, assetIds?: Array<any | null> | null, cardIds?: Array<any | null> | null, audioIds?: Array<any | null> | null, messageAssets?: Array<{ __typename?: 'SMSMessageAsset', asset?: { __typename?: 'Asset', id?: any | null, compressedSize: any, compressedUrl?: string | null, contentType?: string | null, extension?: string | null, originalFileName?: string | null, previewUrl?: string | null, sourceSize: any, sourceUrl?: string | null } | null } | null> | null, messageCards?: Array<{ __typename?: 'SMSMessageContactCard', contactCard?: { __typename?: 'ContactCard', id?: any | null, fileSize: any, name?: string | null, tagline?: string | null, formattedPhoneNumber?: string | null, website?: string | null, email?: string | null, facebookUrl?: string | null, twitterUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, youtubeUrl?: string | null, address?: { __typename?: 'Address', state?: string | null, street?: string | null, city?: string | null, zipCode?: string | null, country?: { __typename?: 'Country', countryName?: string | null, countryCode?: string | null } | null } | null, member?: { __typename?: 'Member', id?: any | null } | null } | null } | null> | null, messageAudios?: Array<{ __typename?: 'SMSMessageAudio', audio?: { __typename?: 'AudioItem', id?: any | null, size?: any | null, name?: string | null, type?: AudioType | null, createdAt?: any | null, duration: number, fileKey?: string | null, url?: string | null, contentType?: string | null, personalized: boolean, ttsMessage?: { __typename?: 'TTSMessageTemplate', id?: any | null, name?: string | null, ttsText?: string | null, provider?: TtsProviderType | null, audioItem?: { __typename?: 'AudioItem', id?: any | null, name?: string | null, url?: string | null } | null, voice?: { __typename?: 'TTSExternalVoice', name?: string | null, type?: TtsType | null, externalId?: string | null, pollyId?: string | null } | null } | null, usageStatistics?: { __typename?: 'AudioUsageStatistics', broadcastCount: number, campaignCount: number, triggerCount: number, broadcasts?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, campaigns?: Array<{ __typename?: 'AudioUsageSource', name?: string | null, id?: any | null } | null> | null, triggers?: Array<{ __typename?: 'TriggerUsageSource', name?: string | null, id?: any | null, app?: AccountIntegrationType | null } | null> | null } | null } | null } | null> | null } | null, contactsLists?: Array<{ __typename?: 'WebFormListContact', listing?: { __typename?: 'Listing', name?: string | null, id?: any | null, activeContactsCount: any } | null } | null> | null, sendFromPhoneNumber?: { __typename?: 'PhoneNumber', id?: any | null, updatedAt?: any | null, friendlyName?: string | null, phoneNumber?: string | null, callForwardEnabled?: boolean | null, destinationPhoneNumber?: string | null, destinationExtension?: number | null, verificationStatus?: VerificationStatus | null, sms?: boolean | null, voice?: boolean | null, sourceType?: PhoneNumberSourceType | null, status?: string | null, type?: PhoneType | null, city?: string | null, state?: string | null } | null, fieldsToCollect?: Array<{ __typename?: 'WebFormCustomField', required?: boolean | null, field?: { __typename?: 'CustomField', createdAt?: any | null, type?: CustomFieldType | null, id?: any | null, name?: string | null, displayIndex?: number | null, key?: string | null, used?: boolean | null } | null } | null> | null, contactStatusStatistics?: { __typename?: 'ContactStatusStatistics', active?: any | null, unsubscribed?: any | null, subscribed?: any | null, confirmed?: any | null, total?: any | null } | null, shortUrlClickStatistics?: { __typename?: 'ShortUrlClickStatistics', totalVisits?: any | null, totalVisitsToday?: any | null, totalVisitsPercentage?: number | null, shortUrlVisits?: Array<{ __typename?: 'SpecificUrlClickStatistics', totalVisitsToday?: any | null, totalVisits?: any | null, longUrl?: string | null, percentage?: number | null, shortUrl?: string | null } | null> | null } | null, conversionStatistics?: { __typename?: 'ConversionSourceStatistics', total?: any | null, revenue?: number | null } | null, conversion?: { __typename?: 'Conversion', id?: any | null, name?: string | null, defaultAmount?: number | null, uniqueHit?: boolean | null, urlPatterns?: Array<{ __typename?: 'ConversionUrlMatchConfig', id?: number | null, matchType?: ConversionMatchType | null, pattern?: string | null } | null> | null } | null } | null };

export type DeleteWebFormsMutationVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['Long']>> | InputMaybe<Scalars['Long']>>;
}>;


export type DeleteWebFormsMutation = { __typename?: 'Mutation', deleteWebForms?: string | null };

export type SendTestMessageMutationVariables = Exact<{
  testMessageInput?: InputMaybe<TestMessageRequestInput>;
}>;


export type SendTestMessageMutation = { __typename?: 'Mutation', sendTestMessage?: { __typename?: 'TestMessage', chargeAmount?: number | null } | null };

export const ShortUrlClickStatisticsFragmentFragmentDoc = gql`
    fragment ShortUrlClickStatisticsFragment on ShortUrlClickStatistics {
  shortUrlVisits {
    totalVisitsToday
    totalVisits
    longUrl
    percentage
    shortUrl
  }
  totalVisits
  totalVisitsToday
  totalVisitsPercentage
}
    `;
export const StatusStatisticsFragmentFragmentDoc = gql`
    fragment StatusStatisticsFragment on StatusStatistics {
  callbackCount
  successCount
  pendingCount
  failedCount
  totalCount
  unsubscribedCount
}
    `;
export const ConversionStatisticsFragmentDoc = gql`
    fragment ConversionStatistics on TodayConversionStatistics {
  revenue
  roi
  totalCosts
  total
  percentage
  todayConversionStatistics {
    percentage
    revenue
    totalCosts
    roi
    total
  }
}
    `;
export const MessageStatisticsResponseFragmentFragmentDoc = gql`
    fragment MessageStatisticsResponseFragment on MessageStatisticsResponse {
  shortUrlClickStatistics {
    ...ShortUrlClickStatisticsFragment
  }
  percentageStatistics {
    callbackPercentage
    failedPercentage
    pendingPercentage
    successPercentage
    unsubscribedPercentage
  }
  todayStatistics {
    ...StatusStatisticsFragment
  }
  totalStatistics {
    ...StatusStatisticsFragment
  }
  chargeStatistics {
    totalCharged
  }
  voiceTransferMessageStatistics {
    total
    percentage
    today
  }
  conversionStatistics {
    ...ConversionStatistics
  }
}
    ${ShortUrlClickStatisticsFragmentFragmentDoc}
${StatusStatisticsFragmentFragmentDoc}
${ConversionStatisticsFragmentDoc}`;
export const MessageFragmentFragmentDoc = gql`
    fragment MessageFragment on MessageDataResponse {
  id
  totalShortUrl
  uniqueClicks
  type
  state {
    boundType
    simpleStatus
    timeToSend
    contactName
    toNumber
    reason
    failReasonType
    status
    contactId
    contactName
  }
  duration
  extStatus
  extStatusLabel
  extStatusDescription
}
    `;
export const PageResponse_MessageFragmentFragmentDoc = gql`
    fragment PageResponse_MessageFragment on PageResponse_MessageDataResponse {
  total
  pageSize
  pageNumber
  content {
    ...MessageFragment
  }
}
    ${MessageFragmentFragmentDoc}`;
export const CapabilitiesFragmentFragmentDoc = gql`
    fragment CapabilitiesFragment on Capabilities {
  mms
  sms
  voice
}
    `;
export const TwPhoneNumberFragmentFragmentDoc = gql`
    fragment TwPhoneNumberFragment on TwPhoneNumber {
  status
  phoneNumber
  friendlyName
  capabilities {
    ...CapabilitiesFragment
  }
}
    ${CapabilitiesFragmentFragmentDoc}`;
export const ConversionResponseFragmentDoc = gql`
    fragment ConversionResponse on ConversionResponse {
  id
  name
  defaultAmount
  uniqueHit
  conversion
  totalHits
  revenue
  urlPatterns {
    id
    matchType
    pattern
  }
}
    `;
export const AudioItemFragmentFragmentDoc = gql`
    fragment AudioItemFragment on AudioItem {
  id
  size
  name
  type
  createdAt
  duration
  fileKey
  url
  contentType
  personalized
  ttsMessage {
    id
    name
    ttsText
    provider
    audioItem {
      id
      name
      url
    }
    voice {
      name
      type
      externalId
      pollyId
    }
  }
  usageStatistics {
    broadcastCount
    broadcasts {
      name
      id
    }
    campaignCount
    campaigns {
      name
      id
    }
    triggers {
      name
      id
      app
    }
    triggerCount
  }
}
    `;
export const LiveAnswerFragmentFragmentDoc = gql`
    fragment LiveAnswerFragment on LiveAnswer {
  audioId
  liveAnswer {
    ...AudioItemFragment
  }
  liveAnswerEnabled
  transferCallEnabled
  transferCallNumber
  unsubscribeDigit
  transferCallDigit
}
    ${AudioItemFragmentFragmentDoc}`;
export const VoiceMailFragmentFragmentDoc = gql`
    fragment VoiceMailFragment on VoiceMail {
  audioId
  voiceMail {
    ...AudioItemFragment
  }
  voiceMailEnabled
}
    ${AudioItemFragmentFragmentDoc}`;
export const VoiceMessageDetailsFragmentDoc = gql`
    fragment VoiceMessageDetails on VoiceMessage {
  liveAnswer {
    ...LiveAnswerFragment
  }
  voiceMail {
    ...VoiceMailFragment
  }
}
    ${LiveAnswerFragmentFragmentDoc}
${VoiceMailFragmentFragmentDoc}`;
export const RinglessMessageDetailsFragmentDoc = gql`
    fragment RinglessMessageDetails on RinglessMessage {
  voiceMail {
    ...AudioItemFragment
  }
  callbackEnabled
}
    ${AudioItemFragmentFragmentDoc}`;
export const AssetFragmentFragmentDoc = gql`
    fragment AssetFragment on Asset {
  id
  compressedSize
  compressedUrl
  contentType
  extension
  originalFileName
  previewUrl
  sourceSize
  sourceUrl
}
    `;
export const AddressFragmentFragmentDoc = gql`
    fragment AddressFragment on Address {
  state
  street
  city
  country {
    countryName
    countryCode
  }
  zipCode
}
    `;
export const ContactCardFragmentDoc = gql`
    fragment ContactCard on ContactCard {
  id
  fileSize
  name
  tagline
  formattedPhoneNumber
  website
  email
  fileSize
  address {
    ...AddressFragment
  }
  facebookUrl
  twitterUrl
  instagramUrl
  linkedinUrl
  youtubeUrl
  member {
    id
  }
}
    ${AddressFragmentFragmentDoc}`;
export const SmsMessageDetailsFragmentDoc = gql`
    fragment SmsMessageDetails on SMSMessage {
  compliance
  complianceText
  text
  assetIds
  cardIds
  audioIds
  messageAssets {
    asset {
      ...AssetFragment
    }
  }
  messageCards {
    contactCard {
      ...ContactCard
    }
  }
  messageAudios {
    audio {
      ...AudioItemFragment
    }
  }
}
    ${AssetFragmentFragmentDoc}
${ContactCardFragmentDoc}
${AudioItemFragmentFragmentDoc}`;
export const PhoneNumberFragmentFragmentDoc = gql`
    fragment PhoneNumberFragment on PhoneNumber {
  id
  updatedAt
  friendlyName
  phoneNumber
  callForwardEnabled
  destinationPhoneNumber
  destinationExtension
  verificationStatus
  sms
  voice
  sourceType
  status
  type
  city
  state
}
    `;
export const BroadcastResponseFragmentDoc = gql`
    fragment BroadcastResponse on BroadcastResponse {
  id
  uuid
  assetIds
  cardIds
  finished
  simplifiedStatus
  sendTime
  updatedAt
  createdAt
  sendFromCompany
  messagesStat {
    ...StatusStatisticsFragment
  }
  conversion {
    ...ConversionResponse
  }
  conversionStatistics {
    revenue
    total
  }
  name
  schedulingConfig {
    sendType
    sendLaterConfig {
      repeatType
      id
      sendDate
      repeatConfig {
        id
        endDate
        customRepeatConfig {
          repeatType
          repeatCount
          weekConfig {
            days
          }
          monthConfig {
            eachMonthDayConfig {
              days
            }
            monthRepeatType
            onMonthDayConfig {
              dayOrdinal
              dayType
            }
          }
        }
      }
    }
  }
  voiceMessage {
    ...VoiceMessageDetails
  }
  ringlessMessage {
    ...RinglessMessageDetails
  }
  smsMessage {
    ...SmsMessageDetails
  }
  type
  status
  sendFromPhoneNumber {
    ...PhoneNumberFragment
  }
  firstItemResponse {
    id
    name
    type
  }
  shortUrlClickStatistics {
    ...ShortUrlClickStatisticsFragment
  }
  listCount
  contactCount
  segmentCount
  filterCount
}
    ${StatusStatisticsFragmentFragmentDoc}
${ConversionResponseFragmentDoc}
${VoiceMessageDetailsFragmentDoc}
${RinglessMessageDetailsFragmentDoc}
${SmsMessageDetailsFragmentDoc}
${PhoneNumberFragmentFragmentDoc}
${ShortUrlClickStatisticsFragmentFragmentDoc}`;
export const ListResponseFragmentDoc = gql`
    fragment ListResponse on ListResponse {
  id
  name
  activeContactsCount
}
    `;
export const FilterFragmentDoc = gql`
    fragment Filter on Filter {
  field
  dataType
  andIndex
  condition
  orIndex
  type
  value
  valueExt
}
    `;
export const FilterValueFragmentDoc = gql`
    fragment FilterValue on FilterValue {
  contactIds
  segmentIds
  listIds
  filters {
    ...Filter
  }
}
    ${FilterFragmentDoc}`;
export const SegmentResponseFragmentDoc = gql`
    fragment SegmentResponse on SegmentResponse {
  createdAt
  name
  id
  updatedAt
  filterValue {
    ...FilterValue
  }
}
    ${FilterValueFragmentDoc}`;
export const ContactLightResponseFragmentDoc = gql`
    fragment ContactLightResponse on ContactLightResponse {
  email
  name
  id
  phone
  createdAt
}
    `;
export const AdvancedSchedulingConfigFragmentDoc = gql`
    fragment AdvancedSchedulingConfig on AdvancedSchedulingConfig {
  durationDays
  durationHours
  durationMinutes
  expectedStartDate
  expectedFinishDate
  allowedDays
  contactsPerDay
  startTimeHour
  startTimeMinute
  speedConfig {
    unit
    unitAmount
    contactsAmount
  }
}
    `;
export const BroadcastEstimatedDurationResponseFragmentDoc = gql`
    fragment BroadcastEstimatedDurationResponse on BroadcastEstimatedDurationResponse {
  expectedFinishDate
  expectedStartDate
  durationDays
  durationHours
  durationMinutes
}
    `;
export const BroadcastFullResponseFragmentDoc = gql`
    fragment BroadcastFullResponse on BroadcastFullResponse {
  id
  uuid
  contactCount
  conversion {
    ...ConversionResponse
  }
  conversionStatistics {
    revenue
    total
  }
  contactsCount {
    total
    active
    globalOptOut
  }
  listCount
  segmentCount
  filterCount
  assetIds
  cardIds
  finished
  simplifiedStatus
  sendTime
  updatedAt
  createdAt
  sendFromCompany
  messagesStat {
    ...StatusStatisticsFragment
  }
  name
  schedulingConfig {
    sendType
    sendLaterConfig {
      repeatType
      id
      sendDate
      repeatConfig {
        id
        endDate
        customRepeatConfig {
          repeatType
          repeatCount
          weekConfig {
            days
          }
          monthConfig {
            eachMonthDayConfig {
              days
            }
            monthRepeatType
            onMonthDayConfig {
              dayOrdinal
              dayType
            }
          }
        }
      }
    }
  }
  voiceMessage {
    ...VoiceMessageDetails
  }
  ringlessMessage {
    ...RinglessMessageDetails
  }
  smsMessage {
    ...SmsMessageDetails
  }
  type
  status
  sendFromPhoneNumber {
    ...PhoneNumberFragment
  }
  lists {
    ...ListResponse
  }
  segments {
    ...SegmentResponse
  }
  contacts {
    ...ContactLightResponse
  }
  filterValue {
    sourceFilters {
      ...Filter
    }
  }
  shortUrlClickStatistics {
    ...ShortUrlClickStatisticsFragment
  }
  advancedSchedulingConfig {
    ...AdvancedSchedulingConfig
  }
  estimatedDuration {
    ...BroadcastEstimatedDurationResponse
  }
  workflowConfig {
    actions {
      type
      groupNumber
      properties
    }
  }
}
    ${ConversionResponseFragmentDoc}
${StatusStatisticsFragmentFragmentDoc}
${VoiceMessageDetailsFragmentDoc}
${RinglessMessageDetailsFragmentDoc}
${SmsMessageDetailsFragmentDoc}
${PhoneNumberFragmentFragmentDoc}
${ListResponseFragmentDoc}
${SegmentResponseFragmentDoc}
${ContactLightResponseFragmentDoc}
${FilterFragmentDoc}
${ShortUrlClickStatisticsFragmentFragmentDoc}
${AdvancedSchedulingConfigFragmentDoc}
${BroadcastEstimatedDurationResponseFragmentDoc}`;
export const CustomFieldsFragmentFragmentDoc = gql`
    fragment CustomFieldsFragment on CustomField {
  createdAt
  type
  id
  name
  displayIndex
  key
  used
}
    `;
export const ConversionFragmentDoc = gql`
    fragment Conversion on Conversion {
  id
  name
  defaultAmount
  uniqueHit
  urlPatterns {
    id
    matchType
    pattern
  }
}
    `;
export const CampaignFragmentFragmentDoc = gql`
    fragment CampaignFragment on CampaignResponse {
  id
  createdAt
  uuid
  name
  status
  reEnrollEnabled
  messagesStat {
    ...StatusStatisticsFragment
  }
  campaignListResponses {
    listId
    listName
  }
  campaignStepResponses {
    id
    type
    phoneNumber {
      ...PhoneNumberFragment
    }
    name
    uuid
    smsMessage {
      ...SmsMessageDetails
    }
    voiceMessage {
      ...VoiceMessageDetails
    }
    ringlessMessage {
      ...RinglessMessageDetails
    }
    delayType
    delay {
      id
      hour
      minute
      period
      value
      sendDate
      scheduleType
      customField {
        ...CustomFieldsFragment
      }
    }
  }
  shortUrlClickStatistics {
    ...ShortUrlClickStatisticsFragment
  }
  conversionStatistics {
    revenue
    total
  }
  conversion {
    ...Conversion
  }
}
    ${StatusStatisticsFragmentFragmentDoc}
${PhoneNumberFragmentFragmentDoc}
${SmsMessageDetailsFragmentDoc}
${VoiceMessageDetailsFragmentDoc}
${RinglessMessageDetailsFragmentDoc}
${CustomFieldsFragmentFragmentDoc}
${ShortUrlClickStatisticsFragmentFragmentDoc}
${ConversionFragmentDoc}`;
export const ListResponseForTableFragmentDoc = gql`
    fragment ListResponseForTable on ListResponse {
  id
  name
  createdAt
  activeContactsCount
  invalidContactsCount
  totalContactsCount
  unsubscribedContactsCount
  keywords {
    id
    name
  }
  webForms {
    id
    name
  }
}
    `;
export const ListFragmentFragmentDoc = gql`
    fragment ListFragment on Listing {
  id
  name
  createdAt
  updatedAt
  activeContactsCount
  invalidContactsCount
  totalContactsCount
  unsubscribedContactsCount
}
    `;
export const ContactListFragmentFragmentDoc = gql`
    fragment ContactListFragment on ListContact {
  listing {
    ...ListFragment
  }
}
    ${ListFragmentFragmentDoc}`;
export const ContactCustomFieldsFragmentFragmentDoc = gql`
    fragment ContactCustomFieldsFragment on ContactCustomField {
  text
  contactFieldId {
    contactId
    fieldId
  }
  date
  field {
    key
    type
    name
  }
  number
}
    `;
export const ContactFragmentFragmentDoc = gql`
    fragment ContactFragment on Contact {
  id
  email
  listContacts {
    ...ContactListFragment
  }
  name
  formattedPhoneNumber
  firstName
  lastName
  phoneNumber
  createdAt
  charged
  optIn
  status
  carrierType
  charged
  contactSource {
    name
    id
    sourceType
  }
  customFields {
    ...ContactCustomFieldsFragment
  }
}
    ${ContactListFragmentFragmentDoc}
${ContactCustomFieldsFragmentFragmentDoc}`;
export const ListingLightFragmentDoc = gql`
    fragment ListingLight on ListingLight {
  id
  name
  createdAt
  updatedAt
}
    `;
export const ContactCustomFieldResponseFragmentDoc = gql`
    fragment ContactCustomFieldResponse on ContactCustomFieldResponse {
  name
  type
  key
  date
  number
  text
}
    `;
export const ContactLightResponseForTableFragmentDoc = gql`
    fragment ContactLightResponseForTable on ContactLightResponse {
  id
  name
  firstName
  lastName
  email
  phone
  listings {
    ...ListingLight
  }
  createdAt
  status
  carrierType
  contactCustomFields {
    ...ContactCustomFieldResponse
  }
  optIn
}
    ${ListingLightFragmentDoc}
${ContactCustomFieldResponseFragmentDoc}`;
export const ContactsLightResponseFragmentDoc = gql`
    fragment ContactsLightResponse on PageResponse_ContactLightResponse {
  pageNumber
  total
  content {
    ...ContactLightResponseForTable
  }
  pageSize
}
    ${ContactLightResponseForTableFragmentDoc}`;
export const ContactImportStateFragmentDoc = gql`
    fragment ContactImportState on ContactImportState {
  status
  successPercentage
  originalFileName
  createdAt
  updatedAt
  id
  columns
  deletedAt
  skipFirstRow
  invalidCount
  successCount
  contactsLimit
  fileKey
  simplifiedStatus
  allowImportStatus
  organization {
    id
    importApprovedAt
    companyName
    importApprover {
      profile {
        name
      }
      id
    }
  }
  member {
    id
    profile {
      name
      firstName
      lastName
    }
  }
}
    `;
export const FilterOptionFragmentDoc = gql`
    fragment FilterOption on FilterOption {
  dataType
  ext
  key
  label
  options {
    label
    key
  }
}
    `;
export const AssetLightFragmentDoc = gql`
    fragment AssetLight on AssetLight {
  id
  size
  originalFileName
  sourceUrl
  sourceSize
  sourceUrl
  contentType
}
    `;
export const AudioItemLightFragmentDoc = gql`
    fragment AudioItemLight on AudioItemLight {
  size
  url
  type
  duration
  fileKey
}
    `;
export const ContactCardLightFragmentDoc = gql`
    fragment ContactCardLight on ContactCardLight {
  id
  fileSize
  name
  tagline
  formattedPhoneNumber
  website
  email
  fileSize
  address {
    ...AddressFragment
  }
  facebookUrl
  twitterUrl
  instagramUrl
  linkedinUrl
  youtubeUrl
}
    ${AddressFragmentFragmentDoc}`;
export const WorkflowSmsConfigFragmentDoc = gql`
    fragment WorkflowSmsConfig on WorkflowSmsConfig {
  compliance
  complianceText
  text
  assetIds
  assets {
    ...AssetLight
  }
  audioIds
  audios {
    ...AudioItemLight
  }
  cardIds
  contactCards {
    ...ContactCardLight
  }
}
    ${AssetLightFragmentDoc}
${AudioItemLightFragmentDoc}
${ContactCardLightFragmentDoc}`;
export const FieldCaptureFragmentDoc = gql`
    fragment FieldCapture on FieldCapture {
  fieldName
  index
  smsConfig {
    ...WorkflowSmsConfig
  }
}
    ${WorkflowSmsConfigFragmentDoc}`;
export const DataCaptureConfigFragmentDoc = gql`
    fragment DataCaptureConfig on DataCaptureConfig {
  retriesCount
  lastReplyConfig {
    ...WorkflowSmsConfig
  }
  fieldCaptures {
    ...FieldCapture
  }
}
    ${WorkflowSmsConfigFragmentDoc}
${FieldCaptureFragmentDoc}`;
export const KeywordFragmentFragmentDoc = gql`
    fragment KeywordFragment on Keyword {
  uuid
  createdAt
  status
  listIds
  smsMessage {
    ...SmsMessageDetails
  }
  name
  keywordLists {
    listing {
      ...ListFragment
    }
  }
  id
  sourceName
  keywordPhoneNumbers {
    phoneNumber {
      ...PhoneNumberFragment
    }
  }
  contactStatusStatistics {
    unsubscribedCount
    activeCount
    subscribersCount
  }
  shortUrlClickStatistics {
    ...ShortUrlClickStatisticsFragment
  }
  conversionStatistics {
    total
    revenue
  }
  conversion {
    ...Conversion
  }
  dataCaptureConfig {
    ...DataCaptureConfig
  }
}
    ${SmsMessageDetailsFragmentDoc}
${ListFragmentFragmentDoc}
${PhoneNumberFragmentFragmentDoc}
${ShortUrlClickStatisticsFragmentFragmentDoc}
${ConversionFragmentDoc}
${DataCaptureConfigFragmentDoc}`;
export const MessageTemplateResponseFragmentDoc = gql`
    fragment MessageTemplateResponse on MessageTemplateResponse {
  id
  name
  updatedAt
  smsMessage {
    ...SmsMessageDetails
  }
}
    ${SmsMessageDetailsFragmentDoc}`;
export const CreditPricesFragmentFragmentDoc = gql`
    fragment CreditPricesFragment on CreditPrice {
  creditsAmount
  planName
  title
  cost
}
    `;
export const SimplePriceFragmentFragmentDoc = gql`
    fragment SimplePriceFragment on SimplePrice {
  priceCatalogId
  planDescription
  priceValue
  planTitle
  planName
  planLine
  period
  creditsIncluded
  bonusValue
  additionalCreditPrice
  customObjectPrices {
    creditPrice
    chargeObject
  }
  creditPrices {
    ...CreditPricesFragment
  }
}
    ${CreditPricesFragmentFragmentDoc}`;
export const LimitsFragmentFragmentDoc = gql`
    fragment LimitsFragment on Limits {
  campaigns
  broadcasts
  automations
  contacts
  integrations
  keywords
  numbers
  triggers
  users
  webForms
}
    `;
export const UiNextPlanFragmentFragmentDoc = gql`
    fragment UINextPlanFragment on UINextPlan {
  price {
    ...SimplePriceFragment
  }
  startDate
}
    ${SimplePriceFragmentFragmentDoc}`;
export const SubscriptionFragmentFragmentDoc = gql`
    fragment SubscriptionFragment on CLSubscription {
  canceledAt
  cancelAt
  status
  renews
  price {
    ...SimplePriceFragment
  }
  limits {
    ...LimitsFragment
  }
  nextPlan {
    ...UINextPlanFragment
  }
  trialEnd
  created
}
    ${SimplePriceFragmentFragmentDoc}
${LimitsFragmentFragmentDoc}
${UiNextPlanFragmentFragmentDoc}`;
export const MemberRegistrationFragmentFragmentDoc = gql`
    fragment MemberRegistrationFragment on MemberRegistration {
  type
  oldCredits
  currentStep
  migratedEmail
  oldSubscription {
    ...SubscriptionFragment
  }
  selectedPriceId
  migrationFinished
  oldCreditsForPurchase
  oldCreditsFree
  oldCreditsLastYear
  saveCredits
}
    ${SubscriptionFragmentFragmentDoc}`;
export const OrganizationFragmentFragmentDoc = gql`
    fragment OrganizationFragment on Organization {
  id
  uuid
  updatedAt
  migrationStatus
  createdAt
  companyName
  employees
  website
  formattedPhoneNumber
  phoneCountryCode
  status
  phoneCheckerEnabled
  allowImport
  termsUrl
  complianceUrl
  ipAddress
  ipCountryCode
  ipCountryName
  recordingPin
  address {
    ...AddressFragment
  }
  carrierFeePaymentFailed
  contract
}
    ${AddressFragmentFragmentDoc}`;
export const UserTimezoneFragmentFragmentDoc = gql`
    fragment UserTimezoneFragment on UserTimeZone {
  fullName
  offset
  shortName
  zoneAbbreviation
  zoneId
}
    `;
export const InvitationBidFragmentFragmentDoc = gql`
    fragment InvitationBidFragment on InvitationBid {
  role
  expirationDate
  email
  uuid
  id
  listIds
}
    `;
export const MemberResponseFragmentDoc = gql`
    fragment MemberResponse on MemberResponse {
  registrationFinished
  memberRegistration {
    ...MemberRegistrationFragment
  }
  name
  displayRole
  displayState
  isAdmin
  accessType
  listIds
  invitationLink
  deletedAt
  updatedAt
  createdAt
  phone
  internationalPhone
  email
  organization {
    ...OrganizationFragment
  }
  role
  lastName
  firstName
  id
  userTimeZone {
    ...UserTimezoneFragment
  }
  state
  invitationBid {
    ...InvitationBidFragment
  }
  memberHash
  uniqueId
}
    ${MemberRegistrationFragmentFragmentDoc}
${OrganizationFragmentFragmentDoc}
${UserTimezoneFragmentFragmentDoc}
${InvitationBidFragmentFragmentDoc}`;
export const InviteResponseFragmentFragmentDoc = gql`
    fragment InviteResponseFragment on InvitationBidResponse {
  id
  uuid
  email
  expirationDate
  link
  role
}
    `;
export const ClInvoiceFragmentFragmentDoc = gql`
    fragment CLInvoiceFragment on BillingInvoice {
  id
  status
  date
  link
  amount
  currency
  paymentMethodDetails
}
    `;
export const BalancesFragmentFragmentDoc = gql`
    fragment BalancesFragment on Balances {
  plan
  purchased
  purchasedExpire
  rollover
}
    `;
export const UpdateSubscriptionFragmentFragmentDoc = gql`
    fragment UpdateSubscriptionFragment on UpdatedSubscription {
  subscription {
    ...SubscriptionFragment
  }
  balances {
    ...BalancesFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}
${BalancesFragmentFragmentDoc}`;
export const BusinessGeneralInfoEinResponseFragmentFragmentDoc = gql`
    fragment BusinessGeneralInfoEinResponseFragment on BusinessGeneralInfoEinResponse {
  ein
  name
  street
  secondStreet
  city
  state
  zipCode
  countryCode
}
    `;
export const TenDlcProfileResponseFragmentDoc = gql`
    fragment TenDlcProfileResponse on TenDlcRegisterProfileResponse {
  profile {
    status
    tenDlcUseCase {
      useCaseType
      useCaseDescription
    }
    stockExchange
    companyStockTicker
    secondSampleMessage
    firstSampleMessage
    businessType
    packageType
    currentStep
    optInMethods
    optInImages
    optInDescriptions
    optInAssets
  }
}
    `;
export const ConversionResponseListFragmentDoc = gql`
    fragment ConversionResponseList on ConversionResponse {
  ...ConversionResponse
  conversion
  totalHits
  revenue
}
    ${ConversionResponseFragmentDoc}`;
export const OrganizationResponseFragmentFragmentDoc = gql`
    fragment OrganizationResponseFragment on OrganizationResponse {
  id
  isMigrated
  ownerId
  status
  companyName
  ownerName
  ownerEmail
  signupDate
  credits
  organizationStatus
  trialPeriodEnded
  canUseGlobalNumber
  ipAddress
  ipCountryCode
  ipCountryName
  cancelAccountAt
}
    `;
export const CardFragmentFragmentDoc = gql`
    fragment CardFragment on Card {
  last4
  expYear
  expMonth
  country
  brand
  funding
}
    `;
export const PaymentMethodFragmentFragmentDoc = gql`
    fragment PaymentMethodFragment on PaymentMethod {
  id
  type
  card {
    ...CardFragment
  }
}
    ${CardFragmentFragmentDoc}`;
export const OrganizationBillingFragmentFragmentDoc = gql`
    fragment OrganizationBillingFragment on OrgBillingInfo {
  autoRecharge
  autoRechargeCreditsAmount
  autoRechargeThreshold
  status
  stripeCustomerId
  backupPaymentMethod
  primaryPaymentMethod
  paymentMethods {
    ...PaymentMethodFragment
  }
}
    ${PaymentMethodFragmentFragmentDoc}`;
export const SecondStreetAddressFragmentFragmentDoc = gql`
    fragment SecondStreetAddressFragment on SecondStreetAddress {
  country {
    countryCode
    countryName
  }
  street
  secondStreet
  city
  state
  zipCode
}
    `;
export const TollFreeBusinessInfoFragmentFragmentDoc = gql`
    fragment TollFreeBusinessInfoFragment on TollFreeBusinessInfo {
  id
  name
  website
  address {
    ...SecondStreetAddressFragment
  }
}
    ${SecondStreetAddressFragmentFragmentDoc}`;
export const TollFreeContactInfoFragmentFragmentDoc = gql`
    fragment TollFreeContactInfoFragment on TollFreeContactInfo {
  id
  phoneNumber
  email
  firstName
  lastName
  formattedPhoneNumber
}
    `;
export const TollFreeVerificationProfileFragmentFragmentDoc = gql`
    fragment TollFreeVerificationProfileFragment on TollFreeVerificationProfile {
  id
  updatedAt
  optInMethod
  optInAsset {
    ...AssetFragment
  }
  status
  currentStep
  phoneNumberIds
  firstSampleMessage
  secondSampleMessage
  phoneNumbers {
    ...PhoneNumberFragment
  }
  messageAmount
  useCase {
    useCaseDescription
    useCaseType
  }
  businessInfo {
    ...TollFreeBusinessInfoFragment
  }
  contactInfo {
    ...TollFreeContactInfoFragment
  }
  useCaseName
  reasonOfMultipleNumbers
  verificationErrorDescription
  verificationRejectedDate
  isNotResubmitable
  verificationResponse {
    causes
    code
    description
    message
    solutions
  }
}
    ${AssetFragmentFragmentDoc}
${PhoneNumberFragmentFragmentDoc}
${TollFreeBusinessInfoFragmentFragmentDoc}
${TollFreeContactInfoFragmentFragmentDoc}`;
export const BusinessGeneralInfoFragmentFragmentDoc = gql`
    fragment BusinessGeneralInfoFragment on BusinessGeneralInfo {
  id
  name
  manual
  einDocument {
    ...AssetFragment
  }
  address {
    ...SecondStreetAddressFragment
  }
}
    ${AssetFragmentFragmentDoc}
${SecondStreetAddressFragmentFragmentDoc}`;
export const BusinessAuthorizedUserFragmentFragmentDoc = gql`
    fragment BusinessAuthorizedUserFragment on BusinessAuthorizedUser {
  id
  firstName
  lastName
  title
  jobPosition
  email
  phoneNumber
  formattedPhoneNumber
}
    `;
export const BusinessInfoFragmentFragmentDoc = gql`
    fragment BusinessInfoFragment on BusinessInfo {
  id
  type
  industry
  website
  socialMediaProfile
  operationRegions
}
    `;
export const BusinessProfileFragmentFragmentDoc = gql`
    fragment BusinessProfileFragment on BusinessProfile {
  id
  currentStep
  hasEin
  ein
  status
  operationCountries
  updatedAt
}
    `;
export const BusinessProfileResponseFragmentFragmentDoc = gql`
    fragment BusinessProfileResponseFragment on BusinessProfileResponse {
  businessGeneralInfo {
    ...BusinessGeneralInfoFragment
  }
  businessAuthorizedUsers {
    ...BusinessAuthorizedUserFragment
  }
  businessInfo {
    ...BusinessInfoFragment
  }
  businessProfile {
    ...BusinessProfileFragment
  }
  errors {
    errorCode
    failureReason
    fieldName
    passed
    objectType
  }
}
    ${BusinessGeneralInfoFragmentFragmentDoc}
${BusinessAuthorizedUserFragmentFragmentDoc}
${BusinessInfoFragmentFragmentDoc}
${BusinessProfileFragmentFragmentDoc}`;
export const ActiveCampaignFragmentFragmentDoc = gql`
    fragment ActiveCampaignFragment on ActiveCampaignIntegration {
  apiKey
  apiUrl
  connected
  connectedUser
}
    `;
export const OAuth2IntegrationResponseFragmentFragmentDoc = gql`
    fragment OAuth2IntegrationResponseFragment on OAuth2IntegrationResponse {
  connected
  connectedUser
  invalidated
  type
  authUrl
}
    `;
export const AccountIntegrationsFragmentFragmentDoc = gql`
    fragment AccountIntegrationsFragment on AccountIntegrationsResponse {
  activeCampaign {
    ...ActiveCampaignFragment
  }
  OAuth2Integrations {
    ...OAuth2IntegrationResponseFragment
  }
}
    ${ActiveCampaignFragmentFragmentDoc}
${OAuth2IntegrationResponseFragmentFragmentDoc}`;
export const OrganizationDetailsFragmentFragmentDoc = gql`
    fragment OrganizationDetailsFragment on OrganizationDetails {
  id
  ownerId
  migrated
  organizationStatus
  status
  canUseGlobalNumber
  companyName
  signupDate
  subscription {
    ...SubscriptionFragment
  }
  balances {
    ...BalancesFragment
  }
  billingInfo {
    ...OrganizationBillingFragment
  }
  tollFreeVerificationProfile {
    ...TollFreeVerificationProfileFragment
  }
  businessProfile {
    ...BusinessProfileResponseFragment
  }
  integrations {
    ...AccountIntegrationsFragment
  }
  teamSize
  twilioSubAccountSid
  hubSpotAppId
  hubSpotCompanyId
  hubSpotOwnerId
  totalContacts
  intercomCompanyLink
  intercomContactLink
  ipAddress
  ipCountryCode
  ipCountryName
  activeSubscriberInfo {
    days
    months
    years
  }
  totalSpend
  mrr
  contract
}
    ${SubscriptionFragmentFragmentDoc}
${BalancesFragmentFragmentDoc}
${OrganizationBillingFragmentFragmentDoc}
${TollFreeVerificationProfileFragmentFragmentDoc}
${BusinessProfileResponseFragmentFragmentDoc}
${AccountIntegrationsFragmentFragmentDoc}`;
export const SuperAdminContactImportStateFragmentDoc = gql`
    fragment SuperAdminContactImportState on ContactImportState {
  id
  organization {
    id
    companyName
    allowImport
    importApprover {
      profile {
        name
      }
      id
    }
    importApprovedAt
  }
  member {
    id
    profile {
      name
      email
    }
  }
  createdAt
  totalCount
  originalFileName
  allowImportStatus
}
    `;
export const OrganizationComplianceResponseFragmentFragmentDoc = gql`
    fragment OrganizationComplianceResponseFragment on OrganizationComplianceResponse {
  id
  companyName
  status
  trialPeriodEnded
  businessProfileId
  businessProfileStatus
  tollFreeStatus
  tollFreeProfileId
  organizationStatus
  signupDate
}
    `;
export const TriggerFragmentFragmentDoc = gql`
    fragment TriggerFragment on Trigger {
  uuid
  createdAt
  updatedAt
  deletedAt
  listIds
  triggerLists {
    listing {
      ...ListFragment
    }
  }
  link
  messagesStat {
    ...StatusStatisticsFragment
  }
  id
  name
  smsMessage {
    ...SmsMessageDetails
  }
  ringlessMessage {
    ...RinglessMessageDetails
  }
  sendFromCompany
  app
  sendFromPhoneNumber {
    ...PhoneNumberFragment
  }
  appPhoneField
  status
  type
  voiceMessage {
    ...VoiceMessageDetails
  }
  shortUrlClickStatistics {
    ...ShortUrlClickStatisticsFragment
  }
  conversionStatistics {
    total
    revenue
  }
  conversion {
    ...Conversion
  }
}
    ${ListFragmentFragmentDoc}
${StatusStatisticsFragmentFragmentDoc}
${SmsMessageDetailsFragmentDoc}
${RinglessMessageDetailsFragmentDoc}
${PhoneNumberFragmentFragmentDoc}
${VoiceMessageDetailsFragmentDoc}
${ShortUrlClickStatisticsFragmentFragmentDoc}
${ConversionFragmentDoc}`;
export const WebFormListContactFragmentDoc = gql`
    fragment WebFormListContact on WebFormListContact {
  listing {
    name
    id
    activeContactsCount
  }
}
    `;
export const WebFormFragmentFragmentDoc = gql`
    fragment WebFormFragment on WebForm {
  id
  name
  createdAt
  uuid
  contactsListsIds
  subscribeBtnText
  doubleOptInMessage
  smsMessage {
    ...SmsMessageDetails
  }
  contactsLists {
    ...WebFormListContact
  }
  thankYouPage
  status
  sendFromPhoneNumber {
    ...PhoneNumberFragment
  }
  doubleOptIn
  fieldsToCollect {
    field {
      ...CustomFieldsFragment
    }
    required
  }
  contactStatusStatistics {
    active
    unsubscribed
    subscribed
    confirmed
    total
  }
  shortUrlClickStatistics {
    ...ShortUrlClickStatisticsFragment
  }
  conversionStatistics {
    total
    revenue
  }
  conversion {
    ...Conversion
  }
  complianceMessage
  complianceUrl
  termsUrl
  webFormConfig
}
    ${SmsMessageDetailsFragmentDoc}
${WebFormListContactFragmentDoc}
${PhoneNumberFragmentFragmentDoc}
${CustomFieldsFragmentFragmentDoc}
${ShortUrlClickStatisticsFragmentFragmentDoc}
${ConversionFragmentDoc}`;
export const GetAssetsDocument = gql`
    query getAssets($page: PaginationInput) {
  getMyAssets(page: $page) {
    total
    pageSize
    pageNumber
    content {
      ...AssetFragment
    }
  }
}
    ${AssetFragmentFragmentDoc}`;

/**
 * __useGetAssetsQuery__
 *
 * To run a query within a React component, call `useGetAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetsQuery({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetAssetsQuery(baseOptions?: Apollo.QueryHookOptions<GetAssetsQuery, GetAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssetsQuery, GetAssetsQueryVariables>(GetAssetsDocument, options);
      }
export function useGetAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssetsQuery, GetAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssetsQuery, GetAssetsQueryVariables>(GetAssetsDocument, options);
        }
export type GetAssetsQueryHookResult = ReturnType<typeof useGetAssetsQuery>;
export type GetAssetsLazyQueryHookResult = ReturnType<typeof useGetAssetsLazyQuery>;
export type GetAssetsQueryResult = Apollo.QueryResult<GetAssetsQuery, GetAssetsQueryVariables>;
export const RemoveAssetsDocument = gql`
    mutation removeAssets($assetIds: [Long]) {
  removeAssets(assetIds: $assetIds)
}
    `;
export type RemoveAssetsMutationFn = Apollo.MutationFunction<RemoveAssetsMutation, RemoveAssetsMutationVariables>;

/**
 * __useRemoveAssetsMutation__
 *
 * To run a mutation, you first call `useRemoveAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAssetsMutation, { data, loading, error }] = useRemoveAssetsMutation({
 *   variables: {
 *      assetIds: // value for 'assetIds'
 *   },
 * });
 */
export function useRemoveAssetsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAssetsMutation, RemoveAssetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAssetsMutation, RemoveAssetsMutationVariables>(RemoveAssetsDocument, options);
      }
export type RemoveAssetsMutationHookResult = ReturnType<typeof useRemoveAssetsMutation>;
export type RemoveAssetsMutationResult = Apollo.MutationResult<RemoveAssetsMutation>;
export type RemoveAssetsMutationOptions = Apollo.BaseMutationOptions<RemoveAssetsMutation, RemoveAssetsMutationVariables>;
export const GetMainInfoDocument = gql`
    query GetMainInfo {
  getSubscription {
    ...SubscriptionFragment
  }
  getOrganizationBillingInfo {
    stripeCustomerId
    cancelAccountAt
    autoRechargeThreshold
    autoRecharge
    autoRechargeCreditsAmount
    status
    primaryPaymentMethod
  }
  getMember {
    ...MemberResponse
  }
}
    ${SubscriptionFragmentFragmentDoc}
${MemberResponseFragmentDoc}`;

/**
 * __useGetMainInfoQuery__
 *
 * To run a query within a React component, call `useGetMainInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMainInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMainInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMainInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetMainInfoQuery, GetMainInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMainInfoQuery, GetMainInfoQueryVariables>(GetMainInfoDocument, options);
      }
export function useGetMainInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMainInfoQuery, GetMainInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMainInfoQuery, GetMainInfoQueryVariables>(GetMainInfoDocument, options);
        }
export type GetMainInfoQueryHookResult = ReturnType<typeof useGetMainInfoQuery>;
export type GetMainInfoLazyQueryHookResult = ReturnType<typeof useGetMainInfoLazyQuery>;
export type GetMainInfoQueryResult = Apollo.QueryResult<GetMainInfoQuery, GetMainInfoQueryVariables>;
export const GetActiveContactsCountDocument = gql`
    query getActiveContactsCount($input: BroadcastInput) {
  getActiveContactsCount(input: $input)
}
    `;

/**
 * __useGetActiveContactsCountQuery__
 *
 * To run a query within a React component, call `useGetActiveContactsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveContactsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveContactsCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetActiveContactsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveContactsCountQuery, GetActiveContactsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveContactsCountQuery, GetActiveContactsCountQueryVariables>(GetActiveContactsCountDocument, options);
      }
export function useGetActiveContactsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveContactsCountQuery, GetActiveContactsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveContactsCountQuery, GetActiveContactsCountQueryVariables>(GetActiveContactsCountDocument, options);
        }
export type GetActiveContactsCountQueryHookResult = ReturnType<typeof useGetActiveContactsCountQuery>;
export type GetActiveContactsCountLazyQueryHookResult = ReturnType<typeof useGetActiveContactsCountLazyQuery>;
export type GetActiveContactsCountQueryResult = Apollo.QueryResult<GetActiveContactsCountQuery, GetActiveContactsCountQueryVariables>;
export const GetDataForSmsDocument = gql`
    query getDataForSMS {
  getMyContactCards {
    ...ContactCard
  }
  getCustomFields {
    ...CustomFieldsFragment
  }
}
    ${ContactCardFragmentDoc}
${CustomFieldsFragmentFragmentDoc}`;

/**
 * __useGetDataForSmsQuery__
 *
 * To run a query within a React component, call `useGetDataForSmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataForSmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataForSmsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDataForSmsQuery(baseOptions?: Apollo.QueryHookOptions<GetDataForSmsQuery, GetDataForSmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataForSmsQuery, GetDataForSmsQueryVariables>(GetDataForSmsDocument, options);
      }
export function useGetDataForSmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataForSmsQuery, GetDataForSmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataForSmsQuery, GetDataForSmsQueryVariables>(GetDataForSmsDocument, options);
        }
export type GetDataForSmsQueryHookResult = ReturnType<typeof useGetDataForSmsQuery>;
export type GetDataForSmsLazyQueryHookResult = ReturnType<typeof useGetDataForSmsLazyQuery>;
export type GetDataForSmsQueryResult = Apollo.QueryResult<GetDataForSmsQuery, GetDataForSmsQueryVariables>;
export const GetConfigurationDocument = gql`
    query getConfiguration {
  getConfiguration {
    twilioCallRecordingNumber
    shortUrlDomains
    defaultChargeObjectPrices {
      chargeObject
      creditPrice
    }
  }
}
    `;

/**
 * __useGetConfigurationQuery__
 *
 * To run a query within a React component, call `useGetConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<GetConfigurationQuery, GetConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConfigurationQuery, GetConfigurationQueryVariables>(GetConfigurationDocument, options);
      }
export function useGetConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConfigurationQuery, GetConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConfigurationQuery, GetConfigurationQueryVariables>(GetConfigurationDocument, options);
        }
export type GetConfigurationQueryHookResult = ReturnType<typeof useGetConfigurationQuery>;
export type GetConfigurationLazyQueryHookResult = ReturnType<typeof useGetConfigurationLazyQuery>;
export type GetConfigurationQueryResult = Apollo.QueryResult<GetConfigurationQuery, GetConfigurationQueryVariables>;
export const SendTestCallMessageDocument = gql`
    mutation sendTestCallMessage($testMessageInput: TestCallMessageRequestInput) {
  sendTestCallMessage(testMessageInput: $testMessageInput) {
    id
    state {
      status
    }
  }
}
    `;
export type SendTestCallMessageMutationFn = Apollo.MutationFunction<SendTestCallMessageMutation, SendTestCallMessageMutationVariables>;

/**
 * __useSendTestCallMessageMutation__
 *
 * To run a mutation, you first call `useSendTestCallMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestCallMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestCallMessageMutation, { data, loading, error }] = useSendTestCallMessageMutation({
 *   variables: {
 *      testMessageInput: // value for 'testMessageInput'
 *   },
 * });
 */
export function useSendTestCallMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendTestCallMessageMutation, SendTestCallMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTestCallMessageMutation, SendTestCallMessageMutationVariables>(SendTestCallMessageDocument, options);
      }
export type SendTestCallMessageMutationHookResult = ReturnType<typeof useSendTestCallMessageMutation>;
export type SendTestCallMessageMutationResult = Apollo.MutationResult<SendTestCallMessageMutation>;
export type SendTestCallMessageMutationOptions = Apollo.BaseMutationOptions<SendTestCallMessageMutation, SendTestCallMessageMutationVariables>;
export const SendTestRinglessMessageDocument = gql`
    mutation sendTestRinglessMessage($testMessageInput: TestRinglessMessageRequestInput) {
  sendTestRinglessMessage(testMessageInput: $testMessageInput) {
    id
    state {
      status
    }
  }
}
    `;
export type SendTestRinglessMessageMutationFn = Apollo.MutationFunction<SendTestRinglessMessageMutation, SendTestRinglessMessageMutationVariables>;

/**
 * __useSendTestRinglessMessageMutation__
 *
 * To run a mutation, you first call `useSendTestRinglessMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestRinglessMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestRinglessMessageMutation, { data, loading, error }] = useSendTestRinglessMessageMutation({
 *   variables: {
 *      testMessageInput: // value for 'testMessageInput'
 *   },
 * });
 */
export function useSendTestRinglessMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendTestRinglessMessageMutation, SendTestRinglessMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTestRinglessMessageMutation, SendTestRinglessMessageMutationVariables>(SendTestRinglessMessageDocument, options);
      }
export type SendTestRinglessMessageMutationHookResult = ReturnType<typeof useSendTestRinglessMessageMutation>;
export type SendTestRinglessMessageMutationResult = Apollo.MutationResult<SendTestRinglessMessageMutation>;
export type SendTestRinglessMessageMutationOptions = Apollo.BaseMutationOptions<SendTestRinglessMessageMutation, SendTestRinglessMessageMutationVariables>;
export const GetAllBroadcastsDocument = gql`
    query getAllBroadcasts($page: PaginationInput) {
  getAllBroadcasts(page: $page) {
    total
    pageSize
    pageNumber
    content {
      ...BroadcastResponse
    }
  }
}
    ${BroadcastResponseFragmentDoc}`;

/**
 * __useGetAllBroadcastsQuery__
 *
 * To run a query within a React component, call `useGetAllBroadcastsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllBroadcastsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllBroadcastsQuery({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetAllBroadcastsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllBroadcastsQuery, GetAllBroadcastsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllBroadcastsQuery, GetAllBroadcastsQueryVariables>(GetAllBroadcastsDocument, options);
      }
export function useGetAllBroadcastsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllBroadcastsQuery, GetAllBroadcastsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllBroadcastsQuery, GetAllBroadcastsQueryVariables>(GetAllBroadcastsDocument, options);
        }
export type GetAllBroadcastsQueryHookResult = ReturnType<typeof useGetAllBroadcastsQuery>;
export type GetAllBroadcastsLazyQueryHookResult = ReturnType<typeof useGetAllBroadcastsLazyQuery>;
export type GetAllBroadcastsQueryResult = Apollo.QueryResult<GetAllBroadcastsQuery, GetAllBroadcastsQueryVariables>;
export const GetBroadcastByIdDocument = gql`
    query getBroadcastById($broadcastId: Long) {
  getBroadcastById(broadcastId: $broadcastId) {
    ...BroadcastFullResponse
  }
}
    ${BroadcastFullResponseFragmentDoc}`;

/**
 * __useGetBroadcastByIdQuery__
 *
 * To run a query within a React component, call `useGetBroadcastByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBroadcastByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBroadcastByIdQuery({
 *   variables: {
 *      broadcastId: // value for 'broadcastId'
 *   },
 * });
 */
export function useGetBroadcastByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetBroadcastByIdQuery, GetBroadcastByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBroadcastByIdQuery, GetBroadcastByIdQueryVariables>(GetBroadcastByIdDocument, options);
      }
export function useGetBroadcastByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBroadcastByIdQuery, GetBroadcastByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBroadcastByIdQuery, GetBroadcastByIdQueryVariables>(GetBroadcastByIdDocument, options);
        }
export type GetBroadcastByIdQueryHookResult = ReturnType<typeof useGetBroadcastByIdQuery>;
export type GetBroadcastByIdLazyQueryHookResult = ReturnType<typeof useGetBroadcastByIdLazyQuery>;
export type GetBroadcastByIdQueryResult = Apollo.QueryResult<GetBroadcastByIdQuery, GetBroadcastByIdQueryVariables>;
export const GetBroadcastMessagesDocument = gql`
    query getBroadcastMessages($uuid: String, $page: PaginationInput, $status: Status) {
  getBroadcastMessages(uuid: $uuid, page: $page, status: $status) {
    ...PageResponse_MessageFragment
  }
}
    ${PageResponse_MessageFragmentFragmentDoc}`;

/**
 * __useGetBroadcastMessagesQuery__
 *
 * To run a query within a React component, call `useGetBroadcastMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBroadcastMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBroadcastMessagesQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      page: // value for 'page'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetBroadcastMessagesQuery(baseOptions?: Apollo.QueryHookOptions<GetBroadcastMessagesQuery, GetBroadcastMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBroadcastMessagesQuery, GetBroadcastMessagesQueryVariables>(GetBroadcastMessagesDocument, options);
      }
export function useGetBroadcastMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBroadcastMessagesQuery, GetBroadcastMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBroadcastMessagesQuery, GetBroadcastMessagesQueryVariables>(GetBroadcastMessagesDocument, options);
        }
export type GetBroadcastMessagesQueryHookResult = ReturnType<typeof useGetBroadcastMessagesQuery>;
export type GetBroadcastMessagesLazyQueryHookResult = ReturnType<typeof useGetBroadcastMessagesLazyQuery>;
export type GetBroadcastMessagesQueryResult = Apollo.QueryResult<GetBroadcastMessagesQuery, GetBroadcastMessagesQueryVariables>;
export const GetBroadcastEstimatedPriceDocument = gql`
    query getBroadcastEstimatedPrice($broadcastInput: BroadcastInput!) {
  getBroadcastEstimatedPrice(broadcastInput: $broadcastInput) {
    activeContactsCount
    totalPrice
    broadcastAllowed
    message
  }
}
    `;

/**
 * __useGetBroadcastEstimatedPriceQuery__
 *
 * To run a query within a React component, call `useGetBroadcastEstimatedPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBroadcastEstimatedPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBroadcastEstimatedPriceQuery({
 *   variables: {
 *      broadcastInput: // value for 'broadcastInput'
 *   },
 * });
 */
export function useGetBroadcastEstimatedPriceQuery(baseOptions: Apollo.QueryHookOptions<GetBroadcastEstimatedPriceQuery, GetBroadcastEstimatedPriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBroadcastEstimatedPriceQuery, GetBroadcastEstimatedPriceQueryVariables>(GetBroadcastEstimatedPriceDocument, options);
      }
export function useGetBroadcastEstimatedPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBroadcastEstimatedPriceQuery, GetBroadcastEstimatedPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBroadcastEstimatedPriceQuery, GetBroadcastEstimatedPriceQueryVariables>(GetBroadcastEstimatedPriceDocument, options);
        }
export type GetBroadcastEstimatedPriceQueryHookResult = ReturnType<typeof useGetBroadcastEstimatedPriceQuery>;
export type GetBroadcastEstimatedPriceLazyQueryHookResult = ReturnType<typeof useGetBroadcastEstimatedPriceLazyQuery>;
export type GetBroadcastEstimatedPriceQueryResult = Apollo.QueryResult<GetBroadcastEstimatedPriceQuery, GetBroadcastEstimatedPriceQueryVariables>;
export const GetBroadcastMessageStatisticsDocument = gql`
    query getBroadcastMessageStatistics($uuid: String) {
  getBroadcastMessageStatistics(uuid: $uuid) {
    ...MessageStatisticsResponseFragment
  }
}
    ${MessageStatisticsResponseFragmentFragmentDoc}`;

/**
 * __useGetBroadcastMessageStatisticsQuery__
 *
 * To run a query within a React component, call `useGetBroadcastMessageStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBroadcastMessageStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBroadcastMessageStatisticsQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetBroadcastMessageStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<GetBroadcastMessageStatisticsQuery, GetBroadcastMessageStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBroadcastMessageStatisticsQuery, GetBroadcastMessageStatisticsQueryVariables>(GetBroadcastMessageStatisticsDocument, options);
      }
export function useGetBroadcastMessageStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBroadcastMessageStatisticsQuery, GetBroadcastMessageStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBroadcastMessageStatisticsQuery, GetBroadcastMessageStatisticsQueryVariables>(GetBroadcastMessageStatisticsDocument, options);
        }
export type GetBroadcastMessageStatisticsQueryHookResult = ReturnType<typeof useGetBroadcastMessageStatisticsQuery>;
export type GetBroadcastMessageStatisticsLazyQueryHookResult = ReturnType<typeof useGetBroadcastMessageStatisticsLazyQuery>;
export type GetBroadcastMessageStatisticsQueryResult = Apollo.QueryResult<GetBroadcastMessageStatisticsQuery, GetBroadcastMessageStatisticsQueryVariables>;
export const CreateBroadcastDocument = gql`
    mutation createBroadcast($broadcastInput: BroadcastInput!) {
  createBroadcast(broadcastInput: $broadcastInput) {
    ...BroadcastFullResponse
  }
}
    ${BroadcastFullResponseFragmentDoc}`;
export type CreateBroadcastMutationFn = Apollo.MutationFunction<CreateBroadcastMutation, CreateBroadcastMutationVariables>;

/**
 * __useCreateBroadcastMutation__
 *
 * To run a mutation, you first call `useCreateBroadcastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBroadcastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBroadcastMutation, { data, loading, error }] = useCreateBroadcastMutation({
 *   variables: {
 *      broadcastInput: // value for 'broadcastInput'
 *   },
 * });
 */
export function useCreateBroadcastMutation(baseOptions?: Apollo.MutationHookOptions<CreateBroadcastMutation, CreateBroadcastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBroadcastMutation, CreateBroadcastMutationVariables>(CreateBroadcastDocument, options);
      }
export type CreateBroadcastMutationHookResult = ReturnType<typeof useCreateBroadcastMutation>;
export type CreateBroadcastMutationResult = Apollo.MutationResult<CreateBroadcastMutation>;
export type CreateBroadcastMutationOptions = Apollo.BaseMutationOptions<CreateBroadcastMutation, CreateBroadcastMutationVariables>;
export const UpdateBroadcastDocument = gql`
    mutation updateBroadcast($broadcastInput: BroadcastInput!) {
  updateBroadcast(broadcastInput: $broadcastInput) {
    ...BroadcastFullResponse
  }
}
    ${BroadcastFullResponseFragmentDoc}`;
export type UpdateBroadcastMutationFn = Apollo.MutationFunction<UpdateBroadcastMutation, UpdateBroadcastMutationVariables>;

/**
 * __useUpdateBroadcastMutation__
 *
 * To run a mutation, you first call `useUpdateBroadcastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBroadcastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBroadcastMutation, { data, loading, error }] = useUpdateBroadcastMutation({
 *   variables: {
 *      broadcastInput: // value for 'broadcastInput'
 *   },
 * });
 */
export function useUpdateBroadcastMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBroadcastMutation, UpdateBroadcastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBroadcastMutation, UpdateBroadcastMutationVariables>(UpdateBroadcastDocument, options);
      }
export type UpdateBroadcastMutationHookResult = ReturnType<typeof useUpdateBroadcastMutation>;
export type UpdateBroadcastMutationResult = Apollo.MutationResult<UpdateBroadcastMutation>;
export type UpdateBroadcastMutationOptions = Apollo.BaseMutationOptions<UpdateBroadcastMutation, UpdateBroadcastMutationVariables>;
export const DeleteBroadcastsDocument = gql`
    mutation deleteBroadcasts($broadcastIds: [Long]!) {
  deleteBroadcasts(broadcastIds: $broadcastIds)
}
    `;
export type DeleteBroadcastsMutationFn = Apollo.MutationFunction<DeleteBroadcastsMutation, DeleteBroadcastsMutationVariables>;

/**
 * __useDeleteBroadcastsMutation__
 *
 * To run a mutation, you first call `useDeleteBroadcastsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBroadcastsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBroadcastsMutation, { data, loading, error }] = useDeleteBroadcastsMutation({
 *   variables: {
 *      broadcastIds: // value for 'broadcastIds'
 *   },
 * });
 */
export function useDeleteBroadcastsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBroadcastsMutation, DeleteBroadcastsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBroadcastsMutation, DeleteBroadcastsMutationVariables>(DeleteBroadcastsDocument, options);
      }
export type DeleteBroadcastsMutationHookResult = ReturnType<typeof useDeleteBroadcastsMutation>;
export type DeleteBroadcastsMutationResult = Apollo.MutationResult<DeleteBroadcastsMutation>;
export type DeleteBroadcastsMutationOptions = Apollo.BaseMutationOptions<DeleteBroadcastsMutation, DeleteBroadcastsMutationVariables>;
export const ChangeBroadcastsStateDocument = gql`
    mutation changeBroadcastsState($action: ChangeBroadcastStateAction, $broadcastIds: [Long]) {
  changeBroadcastsState(action: $action, broadcastIds: $broadcastIds) {
    ...BroadcastResponse
  }
}
    ${BroadcastResponseFragmentDoc}`;
export type ChangeBroadcastsStateMutationFn = Apollo.MutationFunction<ChangeBroadcastsStateMutation, ChangeBroadcastsStateMutationVariables>;

/**
 * __useChangeBroadcastsStateMutation__
 *
 * To run a mutation, you first call `useChangeBroadcastsStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeBroadcastsStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeBroadcastsStateMutation, { data, loading, error }] = useChangeBroadcastsStateMutation({
 *   variables: {
 *      action: // value for 'action'
 *      broadcastIds: // value for 'broadcastIds'
 *   },
 * });
 */
export function useChangeBroadcastsStateMutation(baseOptions?: Apollo.MutationHookOptions<ChangeBroadcastsStateMutation, ChangeBroadcastsStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeBroadcastsStateMutation, ChangeBroadcastsStateMutationVariables>(ChangeBroadcastsStateDocument, options);
      }
export type ChangeBroadcastsStateMutationHookResult = ReturnType<typeof useChangeBroadcastsStateMutation>;
export type ChangeBroadcastsStateMutationResult = Apollo.MutationResult<ChangeBroadcastsStateMutation>;
export type ChangeBroadcastsStateMutationOptions = Apollo.BaseMutationOptions<ChangeBroadcastsStateMutation, ChangeBroadcastsStateMutationVariables>;
export const GetBroadcastSpeedOptionsDocument = gql`
    query getBroadcastSpeedOptions {
  getBroadcastSpeedOptions {
    unit
    allowedUnits
  }
}
    `;

/**
 * __useGetBroadcastSpeedOptionsQuery__
 *
 * To run a query within a React component, call `useGetBroadcastSpeedOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBroadcastSpeedOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBroadcastSpeedOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBroadcastSpeedOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetBroadcastSpeedOptionsQuery, GetBroadcastSpeedOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBroadcastSpeedOptionsQuery, GetBroadcastSpeedOptionsQueryVariables>(GetBroadcastSpeedOptionsDocument, options);
      }
export function useGetBroadcastSpeedOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBroadcastSpeedOptionsQuery, GetBroadcastSpeedOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBroadcastSpeedOptionsQuery, GetBroadcastSpeedOptionsQueryVariables>(GetBroadcastSpeedOptionsDocument, options);
        }
export type GetBroadcastSpeedOptionsQueryHookResult = ReturnType<typeof useGetBroadcastSpeedOptionsQuery>;
export type GetBroadcastSpeedOptionsLazyQueryHookResult = ReturnType<typeof useGetBroadcastSpeedOptionsLazyQuery>;
export type GetBroadcastSpeedOptionsQueryResult = Apollo.QueryResult<GetBroadcastSpeedOptionsQuery, GetBroadcastSpeedOptionsQueryVariables>;
export const GetBroadcastEstimatedDurationDocument = gql`
    query getBroadcastEstimatedDuration($broadcastInput: BroadcastInput, $expectedContactsCount: Int!) {
  getBroadcastEstimatedDuration(
    broadcastInput: $broadcastInput
    expectedContactsCount: $expectedContactsCount
  ) {
    ...BroadcastEstimatedDurationResponse
  }
}
    ${BroadcastEstimatedDurationResponseFragmentDoc}`;

/**
 * __useGetBroadcastEstimatedDurationQuery__
 *
 * To run a query within a React component, call `useGetBroadcastEstimatedDurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBroadcastEstimatedDurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBroadcastEstimatedDurationQuery({
 *   variables: {
 *      broadcastInput: // value for 'broadcastInput'
 *      expectedContactsCount: // value for 'expectedContactsCount'
 *   },
 * });
 */
export function useGetBroadcastEstimatedDurationQuery(baseOptions: Apollo.QueryHookOptions<GetBroadcastEstimatedDurationQuery, GetBroadcastEstimatedDurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBroadcastEstimatedDurationQuery, GetBroadcastEstimatedDurationQueryVariables>(GetBroadcastEstimatedDurationDocument, options);
      }
export function useGetBroadcastEstimatedDurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBroadcastEstimatedDurationQuery, GetBroadcastEstimatedDurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBroadcastEstimatedDurationQuery, GetBroadcastEstimatedDurationQueryVariables>(GetBroadcastEstimatedDurationDocument, options);
        }
export type GetBroadcastEstimatedDurationQueryHookResult = ReturnType<typeof useGetBroadcastEstimatedDurationQuery>;
export type GetBroadcastEstimatedDurationLazyQueryHookResult = ReturnType<typeof useGetBroadcastEstimatedDurationLazyQuery>;
export type GetBroadcastEstimatedDurationQueryResult = Apollo.QueryResult<GetBroadcastEstimatedDurationQuery, GetBroadcastEstimatedDurationQueryVariables>;
export const GetAllCampaignsDocument = gql`
    query getAllCampaigns($page: PaginationInput, $search: CampaignSearchInput!) {
  getAllCampaigns(page: $page, search: $search) {
    total
    pageSize
    pageNumber
    content {
      ...CampaignFragment
    }
  }
}
    ${CampaignFragmentFragmentDoc}`;

/**
 * __useGetAllCampaignsQuery__
 *
 * To run a query within a React component, call `useGetAllCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCampaignsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetAllCampaignsQuery(baseOptions: Apollo.QueryHookOptions<GetAllCampaignsQuery, GetAllCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCampaignsQuery, GetAllCampaignsQueryVariables>(GetAllCampaignsDocument, options);
      }
export function useGetAllCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCampaignsQuery, GetAllCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCampaignsQuery, GetAllCampaignsQueryVariables>(GetAllCampaignsDocument, options);
        }
export type GetAllCampaignsQueryHookResult = ReturnType<typeof useGetAllCampaignsQuery>;
export type GetAllCampaignsLazyQueryHookResult = ReturnType<typeof useGetAllCampaignsLazyQuery>;
export type GetAllCampaignsQueryResult = Apollo.QueryResult<GetAllCampaignsQuery, GetAllCampaignsQueryVariables>;
export const GetCampaignByIdDocument = gql`
    query getCampaignById($campaignId: Long) {
  getCampaignById(campaignId: $campaignId) {
    ...CampaignFragment
  }
}
    ${CampaignFragmentFragmentDoc}`;

/**
 * __useGetCampaignByIdQuery__
 *
 * To run a query within a React component, call `useGetCampaignByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignByIdQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetCampaignByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetCampaignByIdQuery, GetCampaignByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignByIdQuery, GetCampaignByIdQueryVariables>(GetCampaignByIdDocument, options);
      }
export function useGetCampaignByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignByIdQuery, GetCampaignByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignByIdQuery, GetCampaignByIdQueryVariables>(GetCampaignByIdDocument, options);
        }
export type GetCampaignByIdQueryHookResult = ReturnType<typeof useGetCampaignByIdQuery>;
export type GetCampaignByIdLazyQueryHookResult = ReturnType<typeof useGetCampaignByIdLazyQuery>;
export type GetCampaignByIdQueryResult = Apollo.QueryResult<GetCampaignByIdQuery, GetCampaignByIdQueryVariables>;
export const GetCampaignStatisticsDocument = gql`
    query getCampaignStatistics($uuid: String!) {
  getCampaignStatistics(uuid: $uuid) {
    ...MessageStatisticsResponseFragment
  }
}
    ${MessageStatisticsResponseFragmentFragmentDoc}`;

/**
 * __useGetCampaignStatisticsQuery__
 *
 * To run a query within a React component, call `useGetCampaignStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignStatisticsQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetCampaignStatisticsQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignStatisticsQuery, GetCampaignStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignStatisticsQuery, GetCampaignStatisticsQueryVariables>(GetCampaignStatisticsDocument, options);
      }
export function useGetCampaignStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignStatisticsQuery, GetCampaignStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignStatisticsQuery, GetCampaignStatisticsQueryVariables>(GetCampaignStatisticsDocument, options);
        }
export type GetCampaignStatisticsQueryHookResult = ReturnType<typeof useGetCampaignStatisticsQuery>;
export type GetCampaignStatisticsLazyQueryHookResult = ReturnType<typeof useGetCampaignStatisticsLazyQuery>;
export type GetCampaignStatisticsQueryResult = Apollo.QueryResult<GetCampaignStatisticsQuery, GetCampaignStatisticsQueryVariables>;
export const GetCampaignAnalyticsStatisticsDocument = gql`
    query getCampaignAnalyticsStatistics($uuid: String!, $dateRange: DateRangeCriteriaInput) {
  getCampaignAnalyticsStatistics(uuid: $uuid, dateRange: $dateRange) {
    chargeStatistics {
      totalCharged
    }
    percentageStatistics {
      successPercentage
      pendingPercentage
      failedPercentage
      unsubscribedPercentage
      callbackPercentage
    }
    chargeStatistics {
      totalCharged
    }
    totalStatistics {
      totalCount
      unsubscribedCount
      failedCount
      pendingCount
      successCount
      callbackCount
    }
    shortUrlClickStatistics {
      ...ShortUrlClickStatisticsFragment
    }
    conversionStatistics {
      ...ConversionStatistics
    }
  }
}
    ${ShortUrlClickStatisticsFragmentFragmentDoc}
${ConversionStatisticsFragmentDoc}`;

/**
 * __useGetCampaignAnalyticsStatisticsQuery__
 *
 * To run a query within a React component, call `useGetCampaignAnalyticsStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignAnalyticsStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignAnalyticsStatisticsQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetCampaignAnalyticsStatisticsQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignAnalyticsStatisticsQuery, GetCampaignAnalyticsStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignAnalyticsStatisticsQuery, GetCampaignAnalyticsStatisticsQueryVariables>(GetCampaignAnalyticsStatisticsDocument, options);
      }
export function useGetCampaignAnalyticsStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignAnalyticsStatisticsQuery, GetCampaignAnalyticsStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignAnalyticsStatisticsQuery, GetCampaignAnalyticsStatisticsQueryVariables>(GetCampaignAnalyticsStatisticsDocument, options);
        }
export type GetCampaignAnalyticsStatisticsQueryHookResult = ReturnType<typeof useGetCampaignAnalyticsStatisticsQuery>;
export type GetCampaignAnalyticsStatisticsLazyQueryHookResult = ReturnType<typeof useGetCampaignAnalyticsStatisticsLazyQuery>;
export type GetCampaignAnalyticsStatisticsQueryResult = Apollo.QueryResult<GetCampaignAnalyticsStatisticsQuery, GetCampaignAnalyticsStatisticsQueryVariables>;
export const GetCampaignStepStatisticsDocument = gql`
    query getCampaignStepStatistics($uuid: String!, $dateRange: DateRangeCriteriaInput) {
  getCampaignStepStatistics(uuid: $uuid, dateRange: $dateRange) {
    ...MessageStatisticsResponseFragment
  }
}
    ${MessageStatisticsResponseFragmentFragmentDoc}`;

/**
 * __useGetCampaignStepStatisticsQuery__
 *
 * To run a query within a React component, call `useGetCampaignStepStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignStepStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignStepStatisticsQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetCampaignStepStatisticsQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignStepStatisticsQuery, GetCampaignStepStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignStepStatisticsQuery, GetCampaignStepStatisticsQueryVariables>(GetCampaignStepStatisticsDocument, options);
      }
export function useGetCampaignStepStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignStepStatisticsQuery, GetCampaignStepStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignStepStatisticsQuery, GetCampaignStepStatisticsQueryVariables>(GetCampaignStepStatisticsDocument, options);
        }
export type GetCampaignStepStatisticsQueryHookResult = ReturnType<typeof useGetCampaignStepStatisticsQuery>;
export type GetCampaignStepStatisticsLazyQueryHookResult = ReturnType<typeof useGetCampaignStepStatisticsLazyQuery>;
export type GetCampaignStepStatisticsQueryResult = Apollo.QueryResult<GetCampaignStepStatisticsQuery, GetCampaignStepStatisticsQueryVariables>;
export const GetCampaignStepMessagesDocument = gql`
    query getCampaignStepMessages($uuid: String!, $status: Status, $page: PaginationInput, $dateRange: DateRangeCriteriaInput) {
  getCampaignStepMessages(
    uuid: $uuid
    status: $status
    page: $page
    dateRange: $dateRange
  ) {
    ...PageResponse_MessageFragment
  }
}
    ${PageResponse_MessageFragmentFragmentDoc}`;

/**
 * __useGetCampaignStepMessagesQuery__
 *
 * To run a query within a React component, call `useGetCampaignStepMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignStepMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignStepMessagesQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      status: // value for 'status'
 *      page: // value for 'page'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetCampaignStepMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignStepMessagesQuery, GetCampaignStepMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignStepMessagesQuery, GetCampaignStepMessagesQueryVariables>(GetCampaignStepMessagesDocument, options);
      }
export function useGetCampaignStepMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignStepMessagesQuery, GetCampaignStepMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignStepMessagesQuery, GetCampaignStepMessagesQueryVariables>(GetCampaignStepMessagesDocument, options);
        }
export type GetCampaignStepMessagesQueryHookResult = ReturnType<typeof useGetCampaignStepMessagesQuery>;
export type GetCampaignStepMessagesLazyQueryHookResult = ReturnType<typeof useGetCampaignStepMessagesLazyQuery>;
export type GetCampaignStepMessagesQueryResult = Apollo.QueryResult<GetCampaignStepMessagesQuery, GetCampaignStepMessagesQueryVariables>;
export const CreateCampaignDocument = gql`
    mutation createCampaign($campaignInput: CampaignCreateRequestInput!) {
  createCampaign(campaignInput: $campaignInput) {
    ...CampaignFragment
  }
}
    ${CampaignFragmentFragmentDoc}`;
export type CreateCampaignMutationFn = Apollo.MutationFunction<CreateCampaignMutation, CreateCampaignMutationVariables>;

/**
 * __useCreateCampaignMutation__
 *
 * To run a mutation, you first call `useCreateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignMutation, { data, loading, error }] = useCreateCampaignMutation({
 *   variables: {
 *      campaignInput: // value for 'campaignInput'
 *   },
 * });
 */
export function useCreateCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignMutation, CreateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignMutation, CreateCampaignMutationVariables>(CreateCampaignDocument, options);
      }
export type CreateCampaignMutationHookResult = ReturnType<typeof useCreateCampaignMutation>;
export type CreateCampaignMutationResult = Apollo.MutationResult<CreateCampaignMutation>;
export type CreateCampaignMutationOptions = Apollo.BaseMutationOptions<CreateCampaignMutation, CreateCampaignMutationVariables>;
export const UpdateCampaignDocument = gql`
    mutation updateCampaign($campaignInput: CampaignUpdateRequestInput!) {
  updateCampaign(campaignInput: $campaignInput) {
    ...CampaignFragment
  }
}
    ${CampaignFragmentFragmentDoc}`;
export type UpdateCampaignMutationFn = Apollo.MutationFunction<UpdateCampaignMutation, UpdateCampaignMutationVariables>;

/**
 * __useUpdateCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignMutation, { data, loading, error }] = useUpdateCampaignMutation({
 *   variables: {
 *      campaignInput: // value for 'campaignInput'
 *   },
 * });
 */
export function useUpdateCampaignMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignMutation, UpdateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignMutation, UpdateCampaignMutationVariables>(UpdateCampaignDocument, options);
      }
export type UpdateCampaignMutationHookResult = ReturnType<typeof useUpdateCampaignMutation>;
export type UpdateCampaignMutationResult = Apollo.MutationResult<UpdateCampaignMutation>;
export type UpdateCampaignMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignMutation, UpdateCampaignMutationVariables>;
export const ActionCampaignArchiveDocument = gql`
    mutation actionCampaignArchive($campaignIds: [Long]!) {
  actionCampaignArchive(campaignIds: $campaignIds)
}
    `;
export type ActionCampaignArchiveMutationFn = Apollo.MutationFunction<ActionCampaignArchiveMutation, ActionCampaignArchiveMutationVariables>;

/**
 * __useActionCampaignArchiveMutation__
 *
 * To run a mutation, you first call `useActionCampaignArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActionCampaignArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actionCampaignArchiveMutation, { data, loading, error }] = useActionCampaignArchiveMutation({
 *   variables: {
 *      campaignIds: // value for 'campaignIds'
 *   },
 * });
 */
export function useActionCampaignArchiveMutation(baseOptions?: Apollo.MutationHookOptions<ActionCampaignArchiveMutation, ActionCampaignArchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActionCampaignArchiveMutation, ActionCampaignArchiveMutationVariables>(ActionCampaignArchiveDocument, options);
      }
export type ActionCampaignArchiveMutationHookResult = ReturnType<typeof useActionCampaignArchiveMutation>;
export type ActionCampaignArchiveMutationResult = Apollo.MutationResult<ActionCampaignArchiveMutation>;
export type ActionCampaignArchiveMutationOptions = Apollo.BaseMutationOptions<ActionCampaignArchiveMutation, ActionCampaignArchiveMutationVariables>;
export const ActionCampaignRestoreDocument = gql`
    mutation actionCampaignRestore($campaignIds: [Long]!) {
  actionCampaignRestore(campaignIds: $campaignIds)
}
    `;
export type ActionCampaignRestoreMutationFn = Apollo.MutationFunction<ActionCampaignRestoreMutation, ActionCampaignRestoreMutationVariables>;

/**
 * __useActionCampaignRestoreMutation__
 *
 * To run a mutation, you first call `useActionCampaignRestoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActionCampaignRestoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actionCampaignRestoreMutation, { data, loading, error }] = useActionCampaignRestoreMutation({
 *   variables: {
 *      campaignIds: // value for 'campaignIds'
 *   },
 * });
 */
export function useActionCampaignRestoreMutation(baseOptions?: Apollo.MutationHookOptions<ActionCampaignRestoreMutation, ActionCampaignRestoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActionCampaignRestoreMutation, ActionCampaignRestoreMutationVariables>(ActionCampaignRestoreDocument, options);
      }
export type ActionCampaignRestoreMutationHookResult = ReturnType<typeof useActionCampaignRestoreMutation>;
export type ActionCampaignRestoreMutationResult = Apollo.MutationResult<ActionCampaignRestoreMutation>;
export type ActionCampaignRestoreMutationOptions = Apollo.BaseMutationOptions<ActionCampaignRestoreMutation, ActionCampaignRestoreMutationVariables>;
export const ActionCampaignSwitchEnabledDocument = gql`
    mutation actionCampaignSwitchEnabled($campaignIds: [Long]!, $enabled: Boolean!) {
  actionCampaignSwitchEnabled(campaignIds: $campaignIds, enabled: $enabled)
}
    `;
export type ActionCampaignSwitchEnabledMutationFn = Apollo.MutationFunction<ActionCampaignSwitchEnabledMutation, ActionCampaignSwitchEnabledMutationVariables>;

/**
 * __useActionCampaignSwitchEnabledMutation__
 *
 * To run a mutation, you first call `useActionCampaignSwitchEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActionCampaignSwitchEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [actionCampaignSwitchEnabledMutation, { data, loading, error }] = useActionCampaignSwitchEnabledMutation({
 *   variables: {
 *      campaignIds: // value for 'campaignIds'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useActionCampaignSwitchEnabledMutation(baseOptions?: Apollo.MutationHookOptions<ActionCampaignSwitchEnabledMutation, ActionCampaignSwitchEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActionCampaignSwitchEnabledMutation, ActionCampaignSwitchEnabledMutationVariables>(ActionCampaignSwitchEnabledDocument, options);
      }
export type ActionCampaignSwitchEnabledMutationHookResult = ReturnType<typeof useActionCampaignSwitchEnabledMutation>;
export type ActionCampaignSwitchEnabledMutationResult = Apollo.MutationResult<ActionCampaignSwitchEnabledMutation>;
export type ActionCampaignSwitchEnabledMutationOptions = Apollo.BaseMutationOptions<ActionCampaignSwitchEnabledMutation, ActionCampaignSwitchEnabledMutationVariables>;
export const DeleteCampaignsDocument = gql`
    mutation deleteCampaigns($campaignIds: [Long]!) {
  deleteCampaigns(campaignIds: $campaignIds)
}
    `;
export type DeleteCampaignsMutationFn = Apollo.MutationFunction<DeleteCampaignsMutation, DeleteCampaignsMutationVariables>;

/**
 * __useDeleteCampaignsMutation__
 *
 * To run a mutation, you first call `useDeleteCampaignsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaignsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampaignsMutation, { data, loading, error }] = useDeleteCampaignsMutation({
 *   variables: {
 *      campaignIds: // value for 'campaignIds'
 *   },
 * });
 */
export function useDeleteCampaignsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCampaignsMutation, DeleteCampaignsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCampaignsMutation, DeleteCampaignsMutationVariables>(DeleteCampaignsDocument, options);
      }
export type DeleteCampaignsMutationHookResult = ReturnType<typeof useDeleteCampaignsMutation>;
export type DeleteCampaignsMutationResult = Apollo.MutationResult<DeleteCampaignsMutation>;
export type DeleteCampaignsMutationOptions = Apollo.BaseMutationOptions<DeleteCampaignsMutation, DeleteCampaignsMutationVariables>;
export const GetMyOrganizationContactsDocument = gql`
    query GetMyOrganizationContacts($page: PaginationInput, $contactSearch: ContactSearchInput) {
  getMyOrganizationContacts(page: $page, contactSearch: $contactSearch) {
    ...ContactsLightResponse
  }
}
    ${ContactsLightResponseFragmentDoc}`;

/**
 * __useGetMyOrganizationContactsQuery__
 *
 * To run a query within a React component, call `useGetMyOrganizationContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyOrganizationContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyOrganizationContactsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      contactSearch: // value for 'contactSearch'
 *   },
 * });
 */
export function useGetMyOrganizationContactsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyOrganizationContactsQuery, GetMyOrganizationContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyOrganizationContactsQuery, GetMyOrganizationContactsQueryVariables>(GetMyOrganizationContactsDocument, options);
      }
export function useGetMyOrganizationContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyOrganizationContactsQuery, GetMyOrganizationContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyOrganizationContactsQuery, GetMyOrganizationContactsQueryVariables>(GetMyOrganizationContactsDocument, options);
        }
export type GetMyOrganizationContactsQueryHookResult = ReturnType<typeof useGetMyOrganizationContactsQuery>;
export type GetMyOrganizationContactsLazyQueryHookResult = ReturnType<typeof useGetMyOrganizationContactsLazyQuery>;
export type GetMyOrganizationContactsQueryResult = Apollo.QueryResult<GetMyOrganizationContactsQuery, GetMyOrganizationContactsQueryVariables>;
export const GetListContactsDocument = gql`
    query GetListContacts($listId: Long, $page: PaginationInput, $contactSearch: ContactSearchInput) {
  getListContacts(page: $page, listId: $listId, contactSearch: $contactSearch) {
    ...ContactsLightResponse
  }
}
    ${ContactsLightResponseFragmentDoc}`;

/**
 * __useGetListContactsQuery__
 *
 * To run a query within a React component, call `useGetListContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListContactsQuery({
 *   variables: {
 *      listId: // value for 'listId'
 *      page: // value for 'page'
 *      contactSearch: // value for 'contactSearch'
 *   },
 * });
 */
export function useGetListContactsQuery(baseOptions?: Apollo.QueryHookOptions<GetListContactsQuery, GetListContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListContactsQuery, GetListContactsQueryVariables>(GetListContactsDocument, options);
      }
export function useGetListContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListContactsQuery, GetListContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListContactsQuery, GetListContactsQueryVariables>(GetListContactsDocument, options);
        }
export type GetListContactsQueryHookResult = ReturnType<typeof useGetListContactsQuery>;
export type GetListContactsLazyQueryHookResult = ReturnType<typeof useGetListContactsLazyQuery>;
export type GetListContactsQueryResult = Apollo.QueryResult<GetListContactsQuery, GetListContactsQueryVariables>;
export const GetShortMyOrganizationListsDocument = gql`
    query GetShortMyOrganizationLists($page: PaginationInput, $listingSearch: ListingSearchInput) {
  getMyOrganizationLists(page: $page, listingSearch: $listingSearch) {
    pageSize
    content {
      ...ListResponse
    }
    total
    pageNumber
  }
}
    ${ListResponseFragmentDoc}`;

/**
 * __useGetShortMyOrganizationListsQuery__
 *
 * To run a query within a React component, call `useGetShortMyOrganizationListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShortMyOrganizationListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShortMyOrganizationListsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      listingSearch: // value for 'listingSearch'
 *   },
 * });
 */
export function useGetShortMyOrganizationListsQuery(baseOptions?: Apollo.QueryHookOptions<GetShortMyOrganizationListsQuery, GetShortMyOrganizationListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShortMyOrganizationListsQuery, GetShortMyOrganizationListsQueryVariables>(GetShortMyOrganizationListsDocument, options);
      }
export function useGetShortMyOrganizationListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShortMyOrganizationListsQuery, GetShortMyOrganizationListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShortMyOrganizationListsQuery, GetShortMyOrganizationListsQueryVariables>(GetShortMyOrganizationListsDocument, options);
        }
export type GetShortMyOrganizationListsQueryHookResult = ReturnType<typeof useGetShortMyOrganizationListsQuery>;
export type GetShortMyOrganizationListsLazyQueryHookResult = ReturnType<typeof useGetShortMyOrganizationListsLazyQuery>;
export type GetShortMyOrganizationListsQueryResult = Apollo.QueryResult<GetShortMyOrganizationListsQuery, GetShortMyOrganizationListsQueryVariables>;
export const GetMyOrganizationListsDocument = gql`
    query GetMyOrganizationLists($page: PaginationInput, $listingSearch: ListingSearchInput) {
  getMyOrganizationLists(page: $page, listingSearch: $listingSearch) {
    pageSize
    content {
      ...ListResponseForTable
    }
    total
    pageNumber
  }
}
    ${ListResponseForTableFragmentDoc}`;

/**
 * __useGetMyOrganizationListsQuery__
 *
 * To run a query within a React component, call `useGetMyOrganizationListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyOrganizationListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyOrganizationListsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      listingSearch: // value for 'listingSearch'
 *   },
 * });
 */
export function useGetMyOrganizationListsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyOrganizationListsQuery, GetMyOrganizationListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyOrganizationListsQuery, GetMyOrganizationListsQueryVariables>(GetMyOrganizationListsDocument, options);
      }
export function useGetMyOrganizationListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyOrganizationListsQuery, GetMyOrganizationListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyOrganizationListsQuery, GetMyOrganizationListsQueryVariables>(GetMyOrganizationListsDocument, options);
        }
export type GetMyOrganizationListsQueryHookResult = ReturnType<typeof useGetMyOrganizationListsQuery>;
export type GetMyOrganizationListsLazyQueryHookResult = ReturnType<typeof useGetMyOrganizationListsLazyQuery>;
export type GetMyOrganizationListsQueryResult = Apollo.QueryResult<GetMyOrganizationListsQuery, GetMyOrganizationListsQueryVariables>;
export const GetMyOrganizationContactsStatisticsDocument = gql`
    query getMyOrganizationContactsStatistics {
  getMyOrganizationContactsStatistics {
    invalidCount
    totalCount
    activeCount
    archivedCount
    unsubscribedCount
    inactiveCount
  }
}
    `;

/**
 * __useGetMyOrganizationContactsStatisticsQuery__
 *
 * To run a query within a React component, call `useGetMyOrganizationContactsStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyOrganizationContactsStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyOrganizationContactsStatisticsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyOrganizationContactsStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyOrganizationContactsStatisticsQuery, GetMyOrganizationContactsStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyOrganizationContactsStatisticsQuery, GetMyOrganizationContactsStatisticsQueryVariables>(GetMyOrganizationContactsStatisticsDocument, options);
      }
export function useGetMyOrganizationContactsStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyOrganizationContactsStatisticsQuery, GetMyOrganizationContactsStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyOrganizationContactsStatisticsQuery, GetMyOrganizationContactsStatisticsQueryVariables>(GetMyOrganizationContactsStatisticsDocument, options);
        }
export type GetMyOrganizationContactsStatisticsQueryHookResult = ReturnType<typeof useGetMyOrganizationContactsStatisticsQuery>;
export type GetMyOrganizationContactsStatisticsLazyQueryHookResult = ReturnType<typeof useGetMyOrganizationContactsStatisticsLazyQuery>;
export type GetMyOrganizationContactsStatisticsQueryResult = Apollo.QueryResult<GetMyOrganizationContactsStatisticsQuery, GetMyOrganizationContactsStatisticsQueryVariables>;
export const GetListContactsStatisticsDocument = gql`
    query getListContactsStatistics($listId: Long) {
  getListContactsStatistics(listId: $listId) {
    invalidCount
    totalCount
    activeCount
    archivedCount
    unsubscribedCount
    inactiveCount
  }
}
    `;

/**
 * __useGetListContactsStatisticsQuery__
 *
 * To run a query within a React component, call `useGetListContactsStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListContactsStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListContactsStatisticsQuery({
 *   variables: {
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function useGetListContactsStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<GetListContactsStatisticsQuery, GetListContactsStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListContactsStatisticsQuery, GetListContactsStatisticsQueryVariables>(GetListContactsStatisticsDocument, options);
      }
export function useGetListContactsStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListContactsStatisticsQuery, GetListContactsStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListContactsStatisticsQuery, GetListContactsStatisticsQueryVariables>(GetListContactsStatisticsDocument, options);
        }
export type GetListContactsStatisticsQueryHookResult = ReturnType<typeof useGetListContactsStatisticsQuery>;
export type GetListContactsStatisticsLazyQueryHookResult = ReturnType<typeof useGetListContactsStatisticsLazyQuery>;
export type GetListContactsStatisticsQueryResult = Apollo.QueryResult<GetListContactsStatisticsQuery, GetListContactsStatisticsQueryVariables>;
export const GetTotalContactsDocument = gql`
    query getTotalContacts {
  getMyOrganizationContacts(
    page: {pageNumber: 0, pageSize: 25}
    contactSearch: {}
  ) {
    total
  }
}
    `;

/**
 * __useGetTotalContactsQuery__
 *
 * To run a query within a React component, call `useGetTotalContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalContactsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTotalContactsQuery(baseOptions?: Apollo.QueryHookOptions<GetTotalContactsQuery, GetTotalContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTotalContactsQuery, GetTotalContactsQueryVariables>(GetTotalContactsDocument, options);
      }
export function useGetTotalContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTotalContactsQuery, GetTotalContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTotalContactsQuery, GetTotalContactsQueryVariables>(GetTotalContactsDocument, options);
        }
export type GetTotalContactsQueryHookResult = ReturnType<typeof useGetTotalContactsQuery>;
export type GetTotalContactsLazyQueryHookResult = ReturnType<typeof useGetTotalContactsLazyQuery>;
export type GetTotalContactsQueryResult = Apollo.QueryResult<GetTotalContactsQuery, GetTotalContactsQueryVariables>;
export const GetMyContactCardsDocument = gql`
    query getMyContactCards {
  getMyContactCards {
    ...ContactCard
  }
}
    ${ContactCardFragmentDoc}`;

/**
 * __useGetMyContactCardsQuery__
 *
 * To run a query within a React component, call `useGetMyContactCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyContactCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyContactCardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyContactCardsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyContactCardsQuery, GetMyContactCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyContactCardsQuery, GetMyContactCardsQueryVariables>(GetMyContactCardsDocument, options);
      }
export function useGetMyContactCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyContactCardsQuery, GetMyContactCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyContactCardsQuery, GetMyContactCardsQueryVariables>(GetMyContactCardsDocument, options);
        }
export type GetMyContactCardsQueryHookResult = ReturnType<typeof useGetMyContactCardsQuery>;
export type GetMyContactCardsLazyQueryHookResult = ReturnType<typeof useGetMyContactCardsLazyQuery>;
export type GetMyContactCardsQueryResult = Apollo.QueryResult<GetMyContactCardsQuery, GetMyContactCardsQueryVariables>;
export const GetMyContactDocument = gql`
    query getMyContact($contactId: Long!) {
  getMyContact(contactId: $contactId) {
    ...ContactFragment
  }
}
    ${ContactFragmentFragmentDoc}`;

/**
 * __useGetMyContactQuery__
 *
 * To run a query within a React component, call `useGetMyContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyContactQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetMyContactQuery(baseOptions: Apollo.QueryHookOptions<GetMyContactQuery, GetMyContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyContactQuery, GetMyContactQueryVariables>(GetMyContactDocument, options);
      }
export function useGetMyContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyContactQuery, GetMyContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyContactQuery, GetMyContactQueryVariables>(GetMyContactDocument, options);
        }
export type GetMyContactQueryHookResult = ReturnType<typeof useGetMyContactQuery>;
export type GetMyContactLazyQueryHookResult = ReturnType<typeof useGetMyContactLazyQuery>;
export type GetMyContactQueryResult = Apollo.QueryResult<GetMyContactQuery, GetMyContactQueryVariables>;
export const SearchListsAndContactsDocument = gql`
    query searchListsAndContacts($search: ListContactSearchInput) {
  searchListsAndContacts(search: $search) {
    totalContacts
    totalListings
    totalSegments
    contacts {
      id
      name
      formattedPhoneNumber
      email
    }
    listings {
      id
      name
      activeContactsCount
    }
    segments {
      ...SegmentResponse
    }
  }
}
    ${SegmentResponseFragmentDoc}`;

/**
 * __useSearchListsAndContactsQuery__
 *
 * To run a query within a React component, call `useSearchListsAndContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchListsAndContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchListsAndContactsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchListsAndContactsQuery(baseOptions?: Apollo.QueryHookOptions<SearchListsAndContactsQuery, SearchListsAndContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchListsAndContactsQuery, SearchListsAndContactsQueryVariables>(SearchListsAndContactsDocument, options);
      }
export function useSearchListsAndContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchListsAndContactsQuery, SearchListsAndContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchListsAndContactsQuery, SearchListsAndContactsQueryVariables>(SearchListsAndContactsDocument, options);
        }
export type SearchListsAndContactsQueryHookResult = ReturnType<typeof useSearchListsAndContactsQuery>;
export type SearchListsAndContactsLazyQueryHookResult = ReturnType<typeof useSearchListsAndContactsLazyQuery>;
export type SearchListsAndContactsQueryResult = Apollo.QueryResult<SearchListsAndContactsQuery, SearchListsAndContactsQueryVariables>;
export const CreateContactDocument = gql`
    mutation createContact($createContactInput: ContactRequestInput!) {
  createContact(contactInput: $createContactInput) {
    contact {
      ...ContactFragment
    }
    updatedListings {
      ...ListFragment
    }
  }
}
    ${ContactFragmentFragmentDoc}
${ListFragmentFragmentDoc}`;
export type CreateContactMutationFn = Apollo.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      createContactInput: // value for 'createContactInput'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<CreateContactMutation, CreateContactMutationVariables>;
export const UpdateContactDocument = gql`
    mutation updateContact($updateContactInput: ContactRequestInput!) {
  updateContact(contactInput: $updateContactInput) {
    contact {
      ...ContactFragment
    }
    updatedListings {
      ...ListFragment
    }
  }
}
    ${ContactFragmentFragmentDoc}
${ListFragmentFragmentDoc}`;
export type UpdateContactMutationFn = Apollo.MutationFunction<UpdateContactMutation, UpdateContactMutationVariables>;

/**
 * __useUpdateContactMutation__
 *
 * To run a mutation, you first call `useUpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactMutation, { data, loading, error }] = useUpdateContactMutation({
 *   variables: {
 *      updateContactInput: // value for 'updateContactInput'
 *   },
 * });
 */
export function useUpdateContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactMutation, UpdateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactMutation, UpdateContactMutationVariables>(UpdateContactDocument, options);
      }
export type UpdateContactMutationHookResult = ReturnType<typeof useUpdateContactMutation>;
export type UpdateContactMutationResult = Apollo.MutationResult<UpdateContactMutation>;
export type UpdateContactMutationOptions = Apollo.BaseMutationOptions<UpdateContactMutation, UpdateContactMutationVariables>;
export const RemoveContactsDocument = gql`
    mutation removeContacts($bulk: ContactBulkOperationRequestInput) {
  removeContacts(bulk: $bulk)
}
    `;
export type RemoveContactsMutationFn = Apollo.MutationFunction<RemoveContactsMutation, RemoveContactsMutationVariables>;

/**
 * __useRemoveContactsMutation__
 *
 * To run a mutation, you first call `useRemoveContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeContactsMutation, { data, loading, error }] = useRemoveContactsMutation({
 *   variables: {
 *      bulk: // value for 'bulk'
 *   },
 * });
 */
export function useRemoveContactsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveContactsMutation, RemoveContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveContactsMutation, RemoveContactsMutationVariables>(RemoveContactsDocument, options);
      }
export type RemoveContactsMutationHookResult = ReturnType<typeof useRemoveContactsMutation>;
export type RemoveContactsMutationResult = Apollo.MutationResult<RemoveContactsMutation>;
export type RemoveContactsMutationOptions = Apollo.BaseMutationOptions<RemoveContactsMutation, RemoveContactsMutationVariables>;
export const UpdateListDocument = gql`
    mutation updateList($listInput: ListRequestInput!) {
  updateList(listInput: $listInput) {
    ...ListFragment
  }
}
    ${ListFragmentFragmentDoc}`;
export type UpdateListMutationFn = Apollo.MutationFunction<UpdateListMutation, UpdateListMutationVariables>;

/**
 * __useUpdateListMutation__
 *
 * To run a mutation, you first call `useUpdateListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListMutation, { data, loading, error }] = useUpdateListMutation({
 *   variables: {
 *      listInput: // value for 'listInput'
 *   },
 * });
 */
export function useUpdateListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateListMutation, UpdateListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateListMutation, UpdateListMutationVariables>(UpdateListDocument, options);
      }
export type UpdateListMutationHookResult = ReturnType<typeof useUpdateListMutation>;
export type UpdateListMutationResult = Apollo.MutationResult<UpdateListMutation>;
export type UpdateListMutationOptions = Apollo.BaseMutationOptions<UpdateListMutation, UpdateListMutationVariables>;
export const CreateListDocument = gql`
    mutation createList($listInput: ListRequestInput!) {
  createList(listInput: $listInput) {
    ...ListFragment
  }
}
    ${ListFragmentFragmentDoc}`;
export type CreateListMutationFn = Apollo.MutationFunction<CreateListMutation, CreateListMutationVariables>;

/**
 * __useCreateListMutation__
 *
 * To run a mutation, you first call `useCreateListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListMutation, { data, loading, error }] = useCreateListMutation({
 *   variables: {
 *      listInput: // value for 'listInput'
 *   },
 * });
 */
export function useCreateListMutation(baseOptions?: Apollo.MutationHookOptions<CreateListMutation, CreateListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateListMutation, CreateListMutationVariables>(CreateListDocument, options);
      }
export type CreateListMutationHookResult = ReturnType<typeof useCreateListMutation>;
export type CreateListMutationResult = Apollo.MutationResult<CreateListMutation>;
export type CreateListMutationOptions = Apollo.BaseMutationOptions<CreateListMutation, CreateListMutationVariables>;
export const RemoveListsDocument = gql`
    mutation removeLists($listIds: [Long!]) {
  removeLists(listIds: $listIds)
}
    `;
export type RemoveListsMutationFn = Apollo.MutationFunction<RemoveListsMutation, RemoveListsMutationVariables>;

/**
 * __useRemoveListsMutation__
 *
 * To run a mutation, you first call `useRemoveListsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveListsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeListsMutation, { data, loading, error }] = useRemoveListsMutation({
 *   variables: {
 *      listIds: // value for 'listIds'
 *   },
 * });
 */
export function useRemoveListsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveListsMutation, RemoveListsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveListsMutation, RemoveListsMutationVariables>(RemoveListsDocument, options);
      }
export type RemoveListsMutationHookResult = ReturnType<typeof useRemoveListsMutation>;
export type RemoveListsMutationResult = Apollo.MutationResult<RemoveListsMutation>;
export type RemoveListsMutationOptions = Apollo.BaseMutationOptions<RemoveListsMutation, RemoveListsMutationVariables>;
export const UpdateContactImportStateDocument = gql`
    mutation updateContactImportState($importStateInput: ContactImportRequestInput!) {
  updateContactImportState(importStateInput: $importStateInput) {
    ...ContactImportState
  }
}
    ${ContactImportStateFragmentDoc}`;
export type UpdateContactImportStateMutationFn = Apollo.MutationFunction<UpdateContactImportStateMutation, UpdateContactImportStateMutationVariables>;

/**
 * __useUpdateContactImportStateMutation__
 *
 * To run a mutation, you first call `useUpdateContactImportStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactImportStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactImportStateMutation, { data, loading, error }] = useUpdateContactImportStateMutation({
 *   variables: {
 *      importStateInput: // value for 'importStateInput'
 *   },
 * });
 */
export function useUpdateContactImportStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactImportStateMutation, UpdateContactImportStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactImportStateMutation, UpdateContactImportStateMutationVariables>(UpdateContactImportStateDocument, options);
      }
export type UpdateContactImportStateMutationHookResult = ReturnType<typeof useUpdateContactImportStateMutation>;
export type UpdateContactImportStateMutationResult = Apollo.MutationResult<UpdateContactImportStateMutation>;
export type UpdateContactImportStateMutationOptions = Apollo.BaseMutationOptions<UpdateContactImportStateMutation, UpdateContactImportStateMutationVariables>;
export const AddToListsDocument = gql`
    mutation addToLists($bulk: ContactBulkOperationRequestInput!, $listIds: [Long]!) {
  addToLists(bulk: $bulk, listIds: $listIds)
}
    `;
export type AddToListsMutationFn = Apollo.MutationFunction<AddToListsMutation, AddToListsMutationVariables>;

/**
 * __useAddToListsMutation__
 *
 * To run a mutation, you first call `useAddToListsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToListsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToListsMutation, { data, loading, error }] = useAddToListsMutation({
 *   variables: {
 *      bulk: // value for 'bulk'
 *      listIds: // value for 'listIds'
 *   },
 * });
 */
export function useAddToListsMutation(baseOptions?: Apollo.MutationHookOptions<AddToListsMutation, AddToListsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddToListsMutation, AddToListsMutationVariables>(AddToListsDocument, options);
      }
export type AddToListsMutationHookResult = ReturnType<typeof useAddToListsMutation>;
export type AddToListsMutationResult = Apollo.MutationResult<AddToListsMutation>;
export type AddToListsMutationOptions = Apollo.BaseMutationOptions<AddToListsMutation, AddToListsMutationVariables>;
export const RemoveFromListsDocument = gql`
    mutation removeFromLists($bulk: ContactBulkOperationRequestInput!, $listIds: [Long]!) {
  removeFromLists(bulk: $bulk, listIds: $listIds)
}
    `;
export type RemoveFromListsMutationFn = Apollo.MutationFunction<RemoveFromListsMutation, RemoveFromListsMutationVariables>;

/**
 * __useRemoveFromListsMutation__
 *
 * To run a mutation, you first call `useRemoveFromListsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFromListsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFromListsMutation, { data, loading, error }] = useRemoveFromListsMutation({
 *   variables: {
 *      bulk: // value for 'bulk'
 *      listIds: // value for 'listIds'
 *   },
 * });
 */
export function useRemoveFromListsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFromListsMutation, RemoveFromListsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFromListsMutation, RemoveFromListsMutationVariables>(RemoveFromListsDocument, options);
      }
export type RemoveFromListsMutationHookResult = ReturnType<typeof useRemoveFromListsMutation>;
export type RemoveFromListsMutationResult = Apollo.MutationResult<RemoveFromListsMutation>;
export type RemoveFromListsMutationOptions = Apollo.BaseMutationOptions<RemoveFromListsMutation, RemoveFromListsMutationVariables>;
export const CreateContactCardDocument = gql`
    mutation createContactCard($cardInput: ContactCardRequestInput!) {
  createContactCard(cardInput: $cardInput) {
    ...ContactCard
  }
}
    ${ContactCardFragmentDoc}`;
export type CreateContactCardMutationFn = Apollo.MutationFunction<CreateContactCardMutation, CreateContactCardMutationVariables>;

/**
 * __useCreateContactCardMutation__
 *
 * To run a mutation, you first call `useCreateContactCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactCardMutation, { data, loading, error }] = useCreateContactCardMutation({
 *   variables: {
 *      cardInput: // value for 'cardInput'
 *   },
 * });
 */
export function useCreateContactCardMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactCardMutation, CreateContactCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactCardMutation, CreateContactCardMutationVariables>(CreateContactCardDocument, options);
      }
export type CreateContactCardMutationHookResult = ReturnType<typeof useCreateContactCardMutation>;
export type CreateContactCardMutationResult = Apollo.MutationResult<CreateContactCardMutation>;
export type CreateContactCardMutationOptions = Apollo.BaseMutationOptions<CreateContactCardMutation, CreateContactCardMutationVariables>;
export const UpdateContactCardDocument = gql`
    mutation updateContactCard($cardInput: ContactCardRequestInput!, $contactCardId: Long!) {
  updateContactCard(contactCardId: $contactCardId, cardInput: $cardInput) {
    ...ContactCard
  }
}
    ${ContactCardFragmentDoc}`;
export type UpdateContactCardMutationFn = Apollo.MutationFunction<UpdateContactCardMutation, UpdateContactCardMutationVariables>;

/**
 * __useUpdateContactCardMutation__
 *
 * To run a mutation, you first call `useUpdateContactCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactCardMutation, { data, loading, error }] = useUpdateContactCardMutation({
 *   variables: {
 *      cardInput: // value for 'cardInput'
 *      contactCardId: // value for 'contactCardId'
 *   },
 * });
 */
export function useUpdateContactCardMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactCardMutation, UpdateContactCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactCardMutation, UpdateContactCardMutationVariables>(UpdateContactCardDocument, options);
      }
export type UpdateContactCardMutationHookResult = ReturnType<typeof useUpdateContactCardMutation>;
export type UpdateContactCardMutationResult = Apollo.MutationResult<UpdateContactCardMutation>;
export type UpdateContactCardMutationOptions = Apollo.BaseMutationOptions<UpdateContactCardMutation, UpdateContactCardMutationVariables>;
export const RemoveContactCardsDocument = gql`
    mutation removeContactCards($cardIds: [Long]) {
  removeContactCards(cardIds: $cardIds)
}
    `;
export type RemoveContactCardsMutationFn = Apollo.MutationFunction<RemoveContactCardsMutation, RemoveContactCardsMutationVariables>;

/**
 * __useRemoveContactCardsMutation__
 *
 * To run a mutation, you first call `useRemoveContactCardsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveContactCardsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeContactCardsMutation, { data, loading, error }] = useRemoveContactCardsMutation({
 *   variables: {
 *      cardIds: // value for 'cardIds'
 *   },
 * });
 */
export function useRemoveContactCardsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveContactCardsMutation, RemoveContactCardsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveContactCardsMutation, RemoveContactCardsMutationVariables>(RemoveContactCardsDocument, options);
      }
export type RemoveContactCardsMutationHookResult = ReturnType<typeof useRemoveContactCardsMutation>;
export type RemoveContactCardsMutationResult = Apollo.MutationResult<RemoveContactCardsMutation>;
export type RemoveContactCardsMutationOptions = Apollo.BaseMutationOptions<RemoveContactCardsMutation, RemoveContactCardsMutationVariables>;
export const RequestDoubleOptInConfirmationDocument = gql`
    mutation requestDoubleOptInConfirmation($contactIds: [Long]) {
  requestDoubleOptInConfirmation(contactIds: $contactIds)
}
    `;
export type RequestDoubleOptInConfirmationMutationFn = Apollo.MutationFunction<RequestDoubleOptInConfirmationMutation, RequestDoubleOptInConfirmationMutationVariables>;

/**
 * __useRequestDoubleOptInConfirmationMutation__
 *
 * To run a mutation, you first call `useRequestDoubleOptInConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestDoubleOptInConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestDoubleOptInConfirmationMutation, { data, loading, error }] = useRequestDoubleOptInConfirmationMutation({
 *   variables: {
 *      contactIds: // value for 'contactIds'
 *   },
 * });
 */
export function useRequestDoubleOptInConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<RequestDoubleOptInConfirmationMutation, RequestDoubleOptInConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestDoubleOptInConfirmationMutation, RequestDoubleOptInConfirmationMutationVariables>(RequestDoubleOptInConfirmationDocument, options);
      }
export type RequestDoubleOptInConfirmationMutationHookResult = ReturnType<typeof useRequestDoubleOptInConfirmationMutation>;
export type RequestDoubleOptInConfirmationMutationResult = Apollo.MutationResult<RequestDoubleOptInConfirmationMutation>;
export type RequestDoubleOptInConfirmationMutationOptions = Apollo.BaseMutationOptions<RequestDoubleOptInConfirmationMutation, RequestDoubleOptInConfirmationMutationVariables>;
export const VerifyContactsDocument = gql`
    mutation verifyContacts($bulk: ContactBulkOperationRequestInput!) {
  verifyContacts(bulk: $bulk)
}
    `;
export type VerifyContactsMutationFn = Apollo.MutationFunction<VerifyContactsMutation, VerifyContactsMutationVariables>;

/**
 * __useVerifyContactsMutation__
 *
 * To run a mutation, you first call `useVerifyContactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyContactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyContactsMutation, { data, loading, error }] = useVerifyContactsMutation({
 *   variables: {
 *      bulk: // value for 'bulk'
 *   },
 * });
 */
export function useVerifyContactsMutation(baseOptions?: Apollo.MutationHookOptions<VerifyContactsMutation, VerifyContactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyContactsMutation, VerifyContactsMutationVariables>(VerifyContactsDocument, options);
      }
export type VerifyContactsMutationHookResult = ReturnType<typeof useVerifyContactsMutation>;
export type VerifyContactsMutationResult = Apollo.MutationResult<VerifyContactsMutation>;
export type VerifyContactsMutationOptions = Apollo.BaseMutationOptions<VerifyContactsMutation, VerifyContactsMutationVariables>;
export const VerifyContactListsDocument = gql`
    mutation verifyContactLists($listIds: [Long]) {
  verifyContactLists(listIds: $listIds) {
    ...ListFragment
  }
}
    ${ListFragmentFragmentDoc}`;
export type VerifyContactListsMutationFn = Apollo.MutationFunction<VerifyContactListsMutation, VerifyContactListsMutationVariables>;

/**
 * __useVerifyContactListsMutation__
 *
 * To run a mutation, you first call `useVerifyContactListsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyContactListsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyContactListsMutation, { data, loading, error }] = useVerifyContactListsMutation({
 *   variables: {
 *      listIds: // value for 'listIds'
 *   },
 * });
 */
export function useVerifyContactListsMutation(baseOptions?: Apollo.MutationHookOptions<VerifyContactListsMutation, VerifyContactListsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyContactListsMutation, VerifyContactListsMutationVariables>(VerifyContactListsDocument, options);
      }
export type VerifyContactListsMutationHookResult = ReturnType<typeof useVerifyContactListsMutation>;
export type VerifyContactListsMutationResult = Apollo.MutationResult<VerifyContactListsMutation>;
export type VerifyContactListsMutationOptions = Apollo.BaseMutationOptions<VerifyContactListsMutation, VerifyContactListsMutationVariables>;
export const ContactBulkArchiveDocument = gql`
    mutation contactBulkArchive($bulk: ContactBulkOperationRequestInput!) {
  contactBulkArchive(bulk: $bulk)
}
    `;
export type ContactBulkArchiveMutationFn = Apollo.MutationFunction<ContactBulkArchiveMutation, ContactBulkArchiveMutationVariables>;

/**
 * __useContactBulkArchiveMutation__
 *
 * To run a mutation, you first call `useContactBulkArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactBulkArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactBulkArchiveMutation, { data, loading, error }] = useContactBulkArchiveMutation({
 *   variables: {
 *      bulk: // value for 'bulk'
 *   },
 * });
 */
export function useContactBulkArchiveMutation(baseOptions?: Apollo.MutationHookOptions<ContactBulkArchiveMutation, ContactBulkArchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactBulkArchiveMutation, ContactBulkArchiveMutationVariables>(ContactBulkArchiveDocument, options);
      }
export type ContactBulkArchiveMutationHookResult = ReturnType<typeof useContactBulkArchiveMutation>;
export type ContactBulkArchiveMutationResult = Apollo.MutationResult<ContactBulkArchiveMutation>;
export type ContactBulkArchiveMutationOptions = Apollo.BaseMutationOptions<ContactBulkArchiveMutation, ContactBulkArchiveMutationVariables>;
export const ContactBulkUnArchiveDocument = gql`
    mutation contactBulkUnArchive($bulk: ContactBulkOperationRequestInput!) {
  contactBulkUnArchive(bulk: $bulk)
}
    `;
export type ContactBulkUnArchiveMutationFn = Apollo.MutationFunction<ContactBulkUnArchiveMutation, ContactBulkUnArchiveMutationVariables>;

/**
 * __useContactBulkUnArchiveMutation__
 *
 * To run a mutation, you first call `useContactBulkUnArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactBulkUnArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactBulkUnArchiveMutation, { data, loading, error }] = useContactBulkUnArchiveMutation({
 *   variables: {
 *      bulk: // value for 'bulk'
 *   },
 * });
 */
export function useContactBulkUnArchiveMutation(baseOptions?: Apollo.MutationHookOptions<ContactBulkUnArchiveMutation, ContactBulkUnArchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactBulkUnArchiveMutation, ContactBulkUnArchiveMutationVariables>(ContactBulkUnArchiveDocument, options);
      }
export type ContactBulkUnArchiveMutationHookResult = ReturnType<typeof useContactBulkUnArchiveMutation>;
export type ContactBulkUnArchiveMutationResult = Apollo.MutationResult<ContactBulkUnArchiveMutation>;
export type ContactBulkUnArchiveMutationOptions = Apollo.BaseMutationOptions<ContactBulkUnArchiveMutation, ContactBulkUnArchiveMutationVariables>;
export const ContactBulkReSubscribeDocument = gql`
    mutation contactBulkReSubscribe($bulk: ContactBulkOperationRequestInput!) {
  contactBulkReSubscribe(bulk: $bulk)
}
    `;
export type ContactBulkReSubscribeMutationFn = Apollo.MutationFunction<ContactBulkReSubscribeMutation, ContactBulkReSubscribeMutationVariables>;

/**
 * __useContactBulkReSubscribeMutation__
 *
 * To run a mutation, you first call `useContactBulkReSubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactBulkReSubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactBulkReSubscribeMutation, { data, loading, error }] = useContactBulkReSubscribeMutation({
 *   variables: {
 *      bulk: // value for 'bulk'
 *   },
 * });
 */
export function useContactBulkReSubscribeMutation(baseOptions?: Apollo.MutationHookOptions<ContactBulkReSubscribeMutation, ContactBulkReSubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactBulkReSubscribeMutation, ContactBulkReSubscribeMutationVariables>(ContactBulkReSubscribeDocument, options);
      }
export type ContactBulkReSubscribeMutationHookResult = ReturnType<typeof useContactBulkReSubscribeMutation>;
export type ContactBulkReSubscribeMutationResult = Apollo.MutationResult<ContactBulkReSubscribeMutation>;
export type ContactBulkReSubscribeMutationOptions = Apollo.BaseMutationOptions<ContactBulkReSubscribeMutation, ContactBulkReSubscribeMutationVariables>;
export const ContactBulkSoftUnsubscribeDocument = gql`
    mutation contactBulkSoftUnsubscribe($bulk: ContactBulkOperationRequestInput!) {
  contactBulkSoftUnsubscribe(bulk: $bulk)
}
    `;
export type ContactBulkSoftUnsubscribeMutationFn = Apollo.MutationFunction<ContactBulkSoftUnsubscribeMutation, ContactBulkSoftUnsubscribeMutationVariables>;

/**
 * __useContactBulkSoftUnsubscribeMutation__
 *
 * To run a mutation, you first call `useContactBulkSoftUnsubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactBulkSoftUnsubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactBulkSoftUnsubscribeMutation, { data, loading, error }] = useContactBulkSoftUnsubscribeMutation({
 *   variables: {
 *      bulk: // value for 'bulk'
 *   },
 * });
 */
export function useContactBulkSoftUnsubscribeMutation(baseOptions?: Apollo.MutationHookOptions<ContactBulkSoftUnsubscribeMutation, ContactBulkSoftUnsubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactBulkSoftUnsubscribeMutation, ContactBulkSoftUnsubscribeMutationVariables>(ContactBulkSoftUnsubscribeDocument, options);
      }
export type ContactBulkSoftUnsubscribeMutationHookResult = ReturnType<typeof useContactBulkSoftUnsubscribeMutation>;
export type ContactBulkSoftUnsubscribeMutationResult = Apollo.MutationResult<ContactBulkSoftUnsubscribeMutation>;
export type ContactBulkSoftUnsubscribeMutationOptions = Apollo.BaseMutationOptions<ContactBulkSoftUnsubscribeMutation, ContactBulkSoftUnsubscribeMutationVariables>;
export const GetCustomFieldsDocument = gql`
    query GetCustomFields {
  getCustomFields {
    ...CustomFieldsFragment
  }
}
    ${CustomFieldsFragmentFragmentDoc}`;

/**
 * __useGetCustomFieldsQuery__
 *
 * To run a query within a React component, call `useGetCustomFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomFieldsQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomFieldsQuery, GetCustomFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomFieldsQuery, GetCustomFieldsQueryVariables>(GetCustomFieldsDocument, options);
      }
export function useGetCustomFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomFieldsQuery, GetCustomFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomFieldsQuery, GetCustomFieldsQueryVariables>(GetCustomFieldsDocument, options);
        }
export type GetCustomFieldsQueryHookResult = ReturnType<typeof useGetCustomFieldsQuery>;
export type GetCustomFieldsLazyQueryHookResult = ReturnType<typeof useGetCustomFieldsLazyQuery>;
export type GetCustomFieldsQueryResult = Apollo.QueryResult<GetCustomFieldsQuery, GetCustomFieldsQueryVariables>;
export const UpdateCustomFieldsDocument = gql`
    mutation UpdateCustomFields($fields: CustomFieldsRequestInput!) {
  updateCustomFields(fields: $fields) {
    ...CustomFieldsFragment
  }
}
    ${CustomFieldsFragmentFragmentDoc}`;
export type UpdateCustomFieldsMutationFn = Apollo.MutationFunction<UpdateCustomFieldsMutation, UpdateCustomFieldsMutationVariables>;

/**
 * __useUpdateCustomFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateCustomFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomFieldsMutation, { data, loading, error }] = useUpdateCustomFieldsMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateCustomFieldsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomFieldsMutation, UpdateCustomFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomFieldsMutation, UpdateCustomFieldsMutationVariables>(UpdateCustomFieldsDocument, options);
      }
export type UpdateCustomFieldsMutationHookResult = ReturnType<typeof useUpdateCustomFieldsMutation>;
export type UpdateCustomFieldsMutationResult = Apollo.MutationResult<UpdateCustomFieldsMutation>;
export type UpdateCustomFieldsMutationOptions = Apollo.BaseMutationOptions<UpdateCustomFieldsMutation, UpdateCustomFieldsMutationVariables>;
export const GetImportHistoryDocument = gql`
    query getImportHistory($page: PaginationInput, $statuses: [Status]) {
  getImportHistory(page: $page, statuses: $statuses) {
    content {
      ...ContactImportState
    }
    pageNumber
    pageSize
    total
  }
  getMyOrganization {
    allowImport
  }
}
    ${ContactImportStateFragmentDoc}`;

/**
 * __useGetImportHistoryQuery__
 *
 * To run a query within a React component, call `useGetImportHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportHistoryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useGetImportHistoryQuery(baseOptions?: Apollo.QueryHookOptions<GetImportHistoryQuery, GetImportHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImportHistoryQuery, GetImportHistoryQueryVariables>(GetImportHistoryDocument, options);
      }
export function useGetImportHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImportHistoryQuery, GetImportHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImportHistoryQuery, GetImportHistoryQueryVariables>(GetImportHistoryDocument, options);
        }
export type GetImportHistoryQueryHookResult = ReturnType<typeof useGetImportHistoryQuery>;
export type GetImportHistoryLazyQueryHookResult = ReturnType<typeof useGetImportHistoryLazyQuery>;
export type GetImportHistoryQueryResult = Apollo.QueryResult<GetImportHistoryQuery, GetImportHistoryQueryVariables>;
export const GetSkippedContactsDocument = gql`
    query getSkippedContacts($page: PaginationInput!, $importStateId: Long!) {
  getSkippedContacts(page: $page, importStateId: $importStateId) {
    total
    pageSize
    pageNumber
    importState {
      ...ContactImportState
    }
    content {
      name
      id
      phoneNumber
      invalidReason
    }
  }
}
    ${ContactImportStateFragmentDoc}`;

/**
 * __useGetSkippedContactsQuery__
 *
 * To run a query within a React component, call `useGetSkippedContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSkippedContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSkippedContactsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      importStateId: // value for 'importStateId'
 *   },
 * });
 */
export function useGetSkippedContactsQuery(baseOptions: Apollo.QueryHookOptions<GetSkippedContactsQuery, GetSkippedContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSkippedContactsQuery, GetSkippedContactsQueryVariables>(GetSkippedContactsDocument, options);
      }
export function useGetSkippedContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSkippedContactsQuery, GetSkippedContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSkippedContactsQuery, GetSkippedContactsQueryVariables>(GetSkippedContactsDocument, options);
        }
export type GetSkippedContactsQueryHookResult = ReturnType<typeof useGetSkippedContactsQuery>;
export type GetSkippedContactsLazyQueryHookResult = ReturnType<typeof useGetSkippedContactsLazyQuery>;
export type GetSkippedContactsQueryResult = Apollo.QueryResult<GetSkippedContactsQuery, GetSkippedContactsQueryVariables>;
export const RemoveContactImportStatesDocument = gql`
    mutation removeContactImportStates($importStateIds: [Long]) {
  removeContactImportStates(importStateIds: $importStateIds)
}
    `;
export type RemoveContactImportStatesMutationFn = Apollo.MutationFunction<RemoveContactImportStatesMutation, RemoveContactImportStatesMutationVariables>;

/**
 * __useRemoveContactImportStatesMutation__
 *
 * To run a mutation, you first call `useRemoveContactImportStatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveContactImportStatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeContactImportStatesMutation, { data, loading, error }] = useRemoveContactImportStatesMutation({
 *   variables: {
 *      importStateIds: // value for 'importStateIds'
 *   },
 * });
 */
export function useRemoveContactImportStatesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveContactImportStatesMutation, RemoveContactImportStatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveContactImportStatesMutation, RemoveContactImportStatesMutationVariables>(RemoveContactImportStatesDocument, options);
      }
export type RemoveContactImportStatesMutationHookResult = ReturnType<typeof useRemoveContactImportStatesMutation>;
export type RemoveContactImportStatesMutationResult = Apollo.MutationResult<RemoveContactImportStatesMutation>;
export type RemoveContactImportStatesMutationOptions = Apollo.BaseMutationOptions<RemoveContactImportStatesMutation, RemoveContactImportStatesMutationVariables>;
export const GetAvailableFilterFieldsDocument = gql`
    query getAvailableFilterFields {
  getAvailableFilterFields {
    dataTypeConditions
    fields {
      ...FilterOption
    }
  }
}
    ${FilterOptionFragmentDoc}`;

/**
 * __useGetAvailableFilterFieldsQuery__
 *
 * To run a query within a React component, call `useGetAvailableFilterFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableFilterFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableFilterFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableFilterFieldsQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableFilterFieldsQuery, GetAvailableFilterFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableFilterFieldsQuery, GetAvailableFilterFieldsQueryVariables>(GetAvailableFilterFieldsDocument, options);
      }
export function useGetAvailableFilterFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableFilterFieldsQuery, GetAvailableFilterFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableFilterFieldsQuery, GetAvailableFilterFieldsQueryVariables>(GetAvailableFilterFieldsDocument, options);
        }
export type GetAvailableFilterFieldsQueryHookResult = ReturnType<typeof useGetAvailableFilterFieldsQuery>;
export type GetAvailableFilterFieldsLazyQueryHookResult = ReturnType<typeof useGetAvailableFilterFieldsLazyQuery>;
export type GetAvailableFilterFieldsQueryResult = Apollo.QueryResult<GetAvailableFilterFieldsQuery, GetAvailableFilterFieldsQueryVariables>;
export const CreateSegmentDocument = gql`
    mutation createSegment($segment: UpdateSegmentRequestInput) {
  createSegment(segment: $segment) {
    ...SegmentResponse
  }
}
    ${SegmentResponseFragmentDoc}`;
export type CreateSegmentMutationFn = Apollo.MutationFunction<CreateSegmentMutation, CreateSegmentMutationVariables>;

/**
 * __useCreateSegmentMutation__
 *
 * To run a mutation, you first call `useCreateSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSegmentMutation, { data, loading, error }] = useCreateSegmentMutation({
 *   variables: {
 *      segment: // value for 'segment'
 *   },
 * });
 */
export function useCreateSegmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSegmentMutation, CreateSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSegmentMutation, CreateSegmentMutationVariables>(CreateSegmentDocument, options);
      }
export type CreateSegmentMutationHookResult = ReturnType<typeof useCreateSegmentMutation>;
export type CreateSegmentMutationResult = Apollo.MutationResult<CreateSegmentMutation>;
export type CreateSegmentMutationOptions = Apollo.BaseMutationOptions<CreateSegmentMutation, CreateSegmentMutationVariables>;
export const UpdateSegmentDocument = gql`
    mutation updateSegment($segment: UpdateSegmentRequestInput) {
  updateSegment(segment: $segment) {
    ...SegmentResponse
  }
}
    ${SegmentResponseFragmentDoc}`;
export type UpdateSegmentMutationFn = Apollo.MutationFunction<UpdateSegmentMutation, UpdateSegmentMutationVariables>;

/**
 * __useUpdateSegmentMutation__
 *
 * To run a mutation, you first call `useUpdateSegmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSegmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSegmentMutation, { data, loading, error }] = useUpdateSegmentMutation({
 *   variables: {
 *      segment: // value for 'segment'
 *   },
 * });
 */
export function useUpdateSegmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSegmentMutation, UpdateSegmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSegmentMutation, UpdateSegmentMutationVariables>(UpdateSegmentDocument, options);
      }
export type UpdateSegmentMutationHookResult = ReturnType<typeof useUpdateSegmentMutation>;
export type UpdateSegmentMutationResult = Apollo.MutationResult<UpdateSegmentMutation>;
export type UpdateSegmentMutationOptions = Apollo.BaseMutationOptions<UpdateSegmentMutation, UpdateSegmentMutationVariables>;
export const GetSegmentsDocument = gql`
    query getSegments($page: PaginationInput, $searchPattern: String) {
  getSegments(page: $page, searchPattern: $searchPattern) {
    pageNumber
    pageSize
    total
    content {
      ...SegmentResponse
    }
  }
}
    ${SegmentResponseFragmentDoc}`;

/**
 * __useGetSegmentsQuery__
 *
 * To run a query within a React component, call `useGetSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSegmentsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      searchPattern: // value for 'searchPattern'
 *   },
 * });
 */
export function useGetSegmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetSegmentsQuery, GetSegmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSegmentsQuery, GetSegmentsQueryVariables>(GetSegmentsDocument, options);
      }
export function useGetSegmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSegmentsQuery, GetSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSegmentsQuery, GetSegmentsQueryVariables>(GetSegmentsDocument, options);
        }
export type GetSegmentsQueryHookResult = ReturnType<typeof useGetSegmentsQuery>;
export type GetSegmentsLazyQueryHookResult = ReturnType<typeof useGetSegmentsLazyQuery>;
export type GetSegmentsQueryResult = Apollo.QueryResult<GetSegmentsQuery, GetSegmentsQueryVariables>;
export const GetSegmentDocument = gql`
    query getSegment($segmentId: Long!) {
  getSegment(segmentId: $segmentId) {
    ...SegmentResponse
  }
}
    ${SegmentResponseFragmentDoc}`;

/**
 * __useGetSegmentQuery__
 *
 * To run a query within a React component, call `useGetSegmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSegmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSegmentQuery({
 *   variables: {
 *      segmentId: // value for 'segmentId'
 *   },
 * });
 */
export function useGetSegmentQuery(baseOptions: Apollo.QueryHookOptions<GetSegmentQuery, GetSegmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSegmentQuery, GetSegmentQueryVariables>(GetSegmentDocument, options);
      }
export function useGetSegmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSegmentQuery, GetSegmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSegmentQuery, GetSegmentQueryVariables>(GetSegmentDocument, options);
        }
export type GetSegmentQueryHookResult = ReturnType<typeof useGetSegmentQuery>;
export type GetSegmentLazyQueryHookResult = ReturnType<typeof useGetSegmentLazyQuery>;
export type GetSegmentQueryResult = Apollo.QueryResult<GetSegmentQuery, GetSegmentQueryVariables>;
export const EvaluateFilterDocument = gql`
    query evaluateFilter($filterValue: FilterValueInput!, $page: PaginationInput) {
  evaluateFilter(filterValue: $filterValue, page: $page) {
    content {
      ...ContactLightResponseForTable
    }
    total
  }
}
    ${ContactLightResponseForTableFragmentDoc}`;

/**
 * __useEvaluateFilterQuery__
 *
 * To run a query within a React component, call `useEvaluateFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useEvaluateFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEvaluateFilterQuery({
 *   variables: {
 *      filterValue: // value for 'filterValue'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useEvaluateFilterQuery(baseOptions: Apollo.QueryHookOptions<EvaluateFilterQuery, EvaluateFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EvaluateFilterQuery, EvaluateFilterQueryVariables>(EvaluateFilterDocument, options);
      }
export function useEvaluateFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EvaluateFilterQuery, EvaluateFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EvaluateFilterQuery, EvaluateFilterQueryVariables>(EvaluateFilterDocument, options);
        }
export type EvaluateFilterQueryHookResult = ReturnType<typeof useEvaluateFilterQuery>;
export type EvaluateFilterLazyQueryHookResult = ReturnType<typeof useEvaluateFilterLazyQuery>;
export type EvaluateFilterQueryResult = Apollo.QueryResult<EvaluateFilterQuery, EvaluateFilterQueryVariables>;
export const DeleteSegmentsDocument = gql`
    mutation deleteSegments($segmentIds: [Long!]) {
  deleteSegments(segmentIds: $segmentIds)
}
    `;
export type DeleteSegmentsMutationFn = Apollo.MutationFunction<DeleteSegmentsMutation, DeleteSegmentsMutationVariables>;

/**
 * __useDeleteSegmentsMutation__
 *
 * To run a mutation, you first call `useDeleteSegmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSegmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSegmentsMutation, { data, loading, error }] = useDeleteSegmentsMutation({
 *   variables: {
 *      segmentIds: // value for 'segmentIds'
 *   },
 * });
 */
export function useDeleteSegmentsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSegmentsMutation, DeleteSegmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSegmentsMutation, DeleteSegmentsMutationVariables>(DeleteSegmentsDocument, options);
      }
export type DeleteSegmentsMutationHookResult = ReturnType<typeof useDeleteSegmentsMutation>;
export type DeleteSegmentsMutationResult = Apollo.MutationResult<DeleteSegmentsMutation>;
export type DeleteSegmentsMutationOptions = Apollo.BaseMutationOptions<DeleteSegmentsMutation, DeleteSegmentsMutationVariables>;
export const GetAllKeywordsDocument = gql`
    query getAllKeywords($page: PaginationInput, $searchPattern: String) {
  getAllKeywords(page: $page, searchPattern: $searchPattern) {
    pageNumber
    pageSize
    total
    content {
      ...KeywordFragment
    }
  }
}
    ${KeywordFragmentFragmentDoc}`;

/**
 * __useGetAllKeywordsQuery__
 *
 * To run a query within a React component, call `useGetAllKeywordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllKeywordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllKeywordsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      searchPattern: // value for 'searchPattern'
 *   },
 * });
 */
export function useGetAllKeywordsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllKeywordsQuery, GetAllKeywordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllKeywordsQuery, GetAllKeywordsQueryVariables>(GetAllKeywordsDocument, options);
      }
export function useGetAllKeywordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllKeywordsQuery, GetAllKeywordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllKeywordsQuery, GetAllKeywordsQueryVariables>(GetAllKeywordsDocument, options);
        }
export type GetAllKeywordsQueryHookResult = ReturnType<typeof useGetAllKeywordsQuery>;
export type GetAllKeywordsLazyQueryHookResult = ReturnType<typeof useGetAllKeywordsLazyQuery>;
export type GetAllKeywordsQueryResult = Apollo.QueryResult<GetAllKeywordsQuery, GetAllKeywordsQueryVariables>;
export const GetExistingKeywordPhoneNumbersDocument = gql`
    query getExistingKeywordPhoneNumbers {
  getExistingKeywordPhoneNumbers
}
    `;

/**
 * __useGetExistingKeywordPhoneNumbersQuery__
 *
 * To run a query within a React component, call `useGetExistingKeywordPhoneNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExistingKeywordPhoneNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExistingKeywordPhoneNumbersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExistingKeywordPhoneNumbersQuery(baseOptions?: Apollo.QueryHookOptions<GetExistingKeywordPhoneNumbersQuery, GetExistingKeywordPhoneNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExistingKeywordPhoneNumbersQuery, GetExistingKeywordPhoneNumbersQueryVariables>(GetExistingKeywordPhoneNumbersDocument, options);
      }
export function useGetExistingKeywordPhoneNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExistingKeywordPhoneNumbersQuery, GetExistingKeywordPhoneNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExistingKeywordPhoneNumbersQuery, GetExistingKeywordPhoneNumbersQueryVariables>(GetExistingKeywordPhoneNumbersDocument, options);
        }
export type GetExistingKeywordPhoneNumbersQueryHookResult = ReturnType<typeof useGetExistingKeywordPhoneNumbersQuery>;
export type GetExistingKeywordPhoneNumbersLazyQueryHookResult = ReturnType<typeof useGetExistingKeywordPhoneNumbersLazyQuery>;
export type GetExistingKeywordPhoneNumbersQueryResult = Apollo.QueryResult<GetExistingKeywordPhoneNumbersQuery, GetExistingKeywordPhoneNumbersQueryVariables>;
export const GetKeywordByIdDocument = gql`
    query getKeywordById($keywordId: Long) {
  getKeywordById(keywordId: $keywordId) {
    ...KeywordFragment
  }
}
    ${KeywordFragmentFragmentDoc}`;

/**
 * __useGetKeywordByIdQuery__
 *
 * To run a query within a React component, call `useGetKeywordByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKeywordByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKeywordByIdQuery({
 *   variables: {
 *      keywordId: // value for 'keywordId'
 *   },
 * });
 */
export function useGetKeywordByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetKeywordByIdQuery, GetKeywordByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKeywordByIdQuery, GetKeywordByIdQueryVariables>(GetKeywordByIdDocument, options);
      }
export function useGetKeywordByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKeywordByIdQuery, GetKeywordByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKeywordByIdQuery, GetKeywordByIdQueryVariables>(GetKeywordByIdDocument, options);
        }
export type GetKeywordByIdQueryHookResult = ReturnType<typeof useGetKeywordByIdQuery>;
export type GetKeywordByIdLazyQueryHookResult = ReturnType<typeof useGetKeywordByIdLazyQuery>;
export type GetKeywordByIdQueryResult = Apollo.QueryResult<GetKeywordByIdQuery, GetKeywordByIdQueryVariables>;
export const GetKeywordContactStatisticsDocument = gql`
    query getKeywordContactStatistics($keywordId: Long!, $dateRange: DateRangeCriteriaInput) {
  getKeywordContactStatistics(keywordId: $keywordId, dateRange: $dateRange) {
    chargeStatistics {
      totalCharged
    }
    percentageStatistics {
      activePercentage
      unsubscribedPercentage
    }
    todayStatistics {
      subscribersCount
      activeCount
      unsubscribedCount
    }
    totalStatistics {
      unsubscribedCount
      activeCount
      subscribersCount
    }
    shortUrlClickStatistics {
      ...ShortUrlClickStatisticsFragment
    }
    conversionStatistics {
      ...ConversionStatistics
    }
  }
}
    ${ShortUrlClickStatisticsFragmentFragmentDoc}
${ConversionStatisticsFragmentDoc}`;

/**
 * __useGetKeywordContactStatisticsQuery__
 *
 * To run a query within a React component, call `useGetKeywordContactStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKeywordContactStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKeywordContactStatisticsQuery({
 *   variables: {
 *      keywordId: // value for 'keywordId'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetKeywordContactStatisticsQuery(baseOptions: Apollo.QueryHookOptions<GetKeywordContactStatisticsQuery, GetKeywordContactStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKeywordContactStatisticsQuery, GetKeywordContactStatisticsQueryVariables>(GetKeywordContactStatisticsDocument, options);
      }
export function useGetKeywordContactStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKeywordContactStatisticsQuery, GetKeywordContactStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKeywordContactStatisticsQuery, GetKeywordContactStatisticsQueryVariables>(GetKeywordContactStatisticsDocument, options);
        }
export type GetKeywordContactStatisticsQueryHookResult = ReturnType<typeof useGetKeywordContactStatisticsQuery>;
export type GetKeywordContactStatisticsLazyQueryHookResult = ReturnType<typeof useGetKeywordContactStatisticsLazyQuery>;
export type GetKeywordContactStatisticsQueryResult = Apollo.QueryResult<GetKeywordContactStatisticsQuery, GetKeywordContactStatisticsQueryVariables>;
export const GetKeywordContactsDocument = gql`
    query getKeywordContacts($keywordId: Long!, $page: PaginationInput, $dateRange: DateRangeCriteriaInput, $status: Status) {
  getKeywordContacts(
    keywordId: $keywordId
    page: $page
    dateRange: $dateRange
    status: $status
  ) {
    pageNumber
    pageSize
    total
    content {
      status
      name
      addedTime
      phone
    }
  }
}
    `;

/**
 * __useGetKeywordContactsQuery__
 *
 * To run a query within a React component, call `useGetKeywordContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKeywordContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKeywordContactsQuery({
 *   variables: {
 *      keywordId: // value for 'keywordId'
 *      page: // value for 'page'
 *      dateRange: // value for 'dateRange'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetKeywordContactsQuery(baseOptions: Apollo.QueryHookOptions<GetKeywordContactsQuery, GetKeywordContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKeywordContactsQuery, GetKeywordContactsQueryVariables>(GetKeywordContactsDocument, options);
      }
export function useGetKeywordContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKeywordContactsQuery, GetKeywordContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKeywordContactsQuery, GetKeywordContactsQueryVariables>(GetKeywordContactsDocument, options);
        }
export type GetKeywordContactsQueryHookResult = ReturnType<typeof useGetKeywordContactsQuery>;
export type GetKeywordContactsLazyQueryHookResult = ReturnType<typeof useGetKeywordContactsLazyQuery>;
export type GetKeywordContactsQueryResult = Apollo.QueryResult<GetKeywordContactsQuery, GetKeywordContactsQueryVariables>;
export const CreateKeywordDocument = gql`
    mutation createKeyword($keywordInput: KeywordInput!) {
  createKeyword(keywordInput: $keywordInput) {
    ...KeywordFragment
  }
}
    ${KeywordFragmentFragmentDoc}`;
export type CreateKeywordMutationFn = Apollo.MutationFunction<CreateKeywordMutation, CreateKeywordMutationVariables>;

/**
 * __useCreateKeywordMutation__
 *
 * To run a mutation, you first call `useCreateKeywordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKeywordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKeywordMutation, { data, loading, error }] = useCreateKeywordMutation({
 *   variables: {
 *      keywordInput: // value for 'keywordInput'
 *   },
 * });
 */
export function useCreateKeywordMutation(baseOptions?: Apollo.MutationHookOptions<CreateKeywordMutation, CreateKeywordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKeywordMutation, CreateKeywordMutationVariables>(CreateKeywordDocument, options);
      }
export type CreateKeywordMutationHookResult = ReturnType<typeof useCreateKeywordMutation>;
export type CreateKeywordMutationResult = Apollo.MutationResult<CreateKeywordMutation>;
export type CreateKeywordMutationOptions = Apollo.BaseMutationOptions<CreateKeywordMutation, CreateKeywordMutationVariables>;
export const UpdateKeywordDocument = gql`
    mutation updateKeyword($keywordInput: KeywordInput!) {
  updateKeyword(keywordInput: $keywordInput) {
    ...KeywordFragment
  }
}
    ${KeywordFragmentFragmentDoc}`;
export type UpdateKeywordMutationFn = Apollo.MutationFunction<UpdateKeywordMutation, UpdateKeywordMutationVariables>;

/**
 * __useUpdateKeywordMutation__
 *
 * To run a mutation, you first call `useUpdateKeywordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKeywordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKeywordMutation, { data, loading, error }] = useUpdateKeywordMutation({
 *   variables: {
 *      keywordInput: // value for 'keywordInput'
 *   },
 * });
 */
export function useUpdateKeywordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKeywordMutation, UpdateKeywordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKeywordMutation, UpdateKeywordMutationVariables>(UpdateKeywordDocument, options);
      }
export type UpdateKeywordMutationHookResult = ReturnType<typeof useUpdateKeywordMutation>;
export type UpdateKeywordMutationResult = Apollo.MutationResult<UpdateKeywordMutation>;
export type UpdateKeywordMutationOptions = Apollo.BaseMutationOptions<UpdateKeywordMutation, UpdateKeywordMutationVariables>;
export const RemoveKeywordsDocument = gql`
    mutation removeKeywords($keywordIds: [Long]) {
  removeKeywords(keywordIds: $keywordIds)
}
    `;
export type RemoveKeywordsMutationFn = Apollo.MutationFunction<RemoveKeywordsMutation, RemoveKeywordsMutationVariables>;

/**
 * __useRemoveKeywordsMutation__
 *
 * To run a mutation, you first call `useRemoveKeywordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveKeywordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeKeywordsMutation, { data, loading, error }] = useRemoveKeywordsMutation({
 *   variables: {
 *      keywordIds: // value for 'keywordIds'
 *   },
 * });
 */
export function useRemoveKeywordsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveKeywordsMutation, RemoveKeywordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveKeywordsMutation, RemoveKeywordsMutationVariables>(RemoveKeywordsDocument, options);
      }
export type RemoveKeywordsMutationHookResult = ReturnType<typeof useRemoveKeywordsMutation>;
export type RemoveKeywordsMutationResult = Apollo.MutationResult<RemoveKeywordsMutation>;
export type RemoveKeywordsMutationOptions = Apollo.BaseMutationOptions<RemoveKeywordsMutation, RemoveKeywordsMutationVariables>;
export const DisableKeywordDocument = gql`
    mutation disableKeyword($id: Long!) {
  disableKeyword(id: $id) {
    ...KeywordFragment
  }
}
    ${KeywordFragmentFragmentDoc}`;
export type DisableKeywordMutationFn = Apollo.MutationFunction<DisableKeywordMutation, DisableKeywordMutationVariables>;

/**
 * __useDisableKeywordMutation__
 *
 * To run a mutation, you first call `useDisableKeywordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableKeywordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableKeywordMutation, { data, loading, error }] = useDisableKeywordMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisableKeywordMutation(baseOptions?: Apollo.MutationHookOptions<DisableKeywordMutation, DisableKeywordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableKeywordMutation, DisableKeywordMutationVariables>(DisableKeywordDocument, options);
      }
export type DisableKeywordMutationHookResult = ReturnType<typeof useDisableKeywordMutation>;
export type DisableKeywordMutationResult = Apollo.MutationResult<DisableKeywordMutation>;
export type DisableKeywordMutationOptions = Apollo.BaseMutationOptions<DisableKeywordMutation, DisableKeywordMutationVariables>;
export const EnableKeywordDocument = gql`
    mutation enableKeyword($id: Long!) {
  enableKeyword(id: $id) {
    ...KeywordFragment
  }
}
    ${KeywordFragmentFragmentDoc}`;
export type EnableKeywordMutationFn = Apollo.MutationFunction<EnableKeywordMutation, EnableKeywordMutationVariables>;

/**
 * __useEnableKeywordMutation__
 *
 * To run a mutation, you first call `useEnableKeywordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableKeywordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableKeywordMutation, { data, loading, error }] = useEnableKeywordMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnableKeywordMutation(baseOptions?: Apollo.MutationHookOptions<EnableKeywordMutation, EnableKeywordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableKeywordMutation, EnableKeywordMutationVariables>(EnableKeywordDocument, options);
      }
export type EnableKeywordMutationHookResult = ReturnType<typeof useEnableKeywordMutation>;
export type EnableKeywordMutationResult = Apollo.MutationResult<EnableKeywordMutation>;
export type EnableKeywordMutationOptions = Apollo.BaseMutationOptions<EnableKeywordMutation, EnableKeywordMutationVariables>;
export const GetMessageTemplatesDocument = gql`
    query getMessageTemplates($page: PaginationInput, $searchPattern: String) {
  getMessageTemplates(page: $page, searchPattern: $searchPattern) {
    total
    pageNumber
    content {
      ...MessageTemplateResponse
    }
  }
}
    ${MessageTemplateResponseFragmentDoc}`;

/**
 * __useGetMessageTemplatesQuery__
 *
 * To run a query within a React component, call `useGetMessageTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageTemplatesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      searchPattern: // value for 'searchPattern'
 *   },
 * });
 */
export function useGetMessageTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>(GetMessageTemplatesDocument, options);
      }
export function useGetMessageTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>(GetMessageTemplatesDocument, options);
        }
export type GetMessageTemplatesQueryHookResult = ReturnType<typeof useGetMessageTemplatesQuery>;
export type GetMessageTemplatesLazyQueryHookResult = ReturnType<typeof useGetMessageTemplatesLazyQuery>;
export type GetMessageTemplatesQueryResult = Apollo.QueryResult<GetMessageTemplatesQuery, GetMessageTemplatesQueryVariables>;
export const GetMessageTemplateDocument = gql`
    query getMessageTemplate($templateId: Long) {
  getMessageTemplate(templateId: $templateId) {
    ...MessageTemplateResponse
  }
}
    ${MessageTemplateResponseFragmentDoc}`;

/**
 * __useGetMessageTemplateQuery__
 *
 * To run a query within a React component, call `useGetMessageTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageTemplateQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useGetMessageTemplateQuery(baseOptions?: Apollo.QueryHookOptions<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>(GetMessageTemplateDocument, options);
      }
export function useGetMessageTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>(GetMessageTemplateDocument, options);
        }
export type GetMessageTemplateQueryHookResult = ReturnType<typeof useGetMessageTemplateQuery>;
export type GetMessageTemplateLazyQueryHookResult = ReturnType<typeof useGetMessageTemplateLazyQuery>;
export type GetMessageTemplateQueryResult = Apollo.QueryResult<GetMessageTemplateQuery, GetMessageTemplateQueryVariables>;
export const CreateMessageTemplateDocument = gql`
    mutation createMessageTemplate($template: UpdateMessageTemplateRequestInput) {
  createMessageTemplate(template: $template) {
    ...MessageTemplateResponse
  }
}
    ${MessageTemplateResponseFragmentDoc}`;
export type CreateMessageTemplateMutationFn = Apollo.MutationFunction<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>;

/**
 * __useCreateMessageTemplateMutation__
 *
 * To run a mutation, you first call `useCreateMessageTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageTemplateMutation, { data, loading, error }] = useCreateMessageTemplateMutation({
 *   variables: {
 *      template: // value for 'template'
 *   },
 * });
 */
export function useCreateMessageTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>(CreateMessageTemplateDocument, options);
      }
export type CreateMessageTemplateMutationHookResult = ReturnType<typeof useCreateMessageTemplateMutation>;
export type CreateMessageTemplateMutationResult = Apollo.MutationResult<CreateMessageTemplateMutation>;
export type CreateMessageTemplateMutationOptions = Apollo.BaseMutationOptions<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>;
export const UpdateMessageTemplateDocument = gql`
    mutation updateMessageTemplate($template: UpdateMessageTemplateRequestInput) {
  updateMessageTemplate(template: $template) {
    ...MessageTemplateResponse
  }
}
    ${MessageTemplateResponseFragmentDoc}`;
export type UpdateMessageTemplateMutationFn = Apollo.MutationFunction<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>;

/**
 * __useUpdateMessageTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateMessageTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessageTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessageTemplateMutation, { data, loading, error }] = useUpdateMessageTemplateMutation({
 *   variables: {
 *      template: // value for 'template'
 *   },
 * });
 */
export function useUpdateMessageTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>(UpdateMessageTemplateDocument, options);
      }
export type UpdateMessageTemplateMutationHookResult = ReturnType<typeof useUpdateMessageTemplateMutation>;
export type UpdateMessageTemplateMutationResult = Apollo.MutationResult<UpdateMessageTemplateMutation>;
export type UpdateMessageTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>;
export const DeleteMessageTemplatesDocument = gql`
    mutation deleteMessageTemplates($templateIds: [Long]) {
  deleteMessageTemplates(templateIds: $templateIds)
}
    `;
export type DeleteMessageTemplatesMutationFn = Apollo.MutationFunction<DeleteMessageTemplatesMutation, DeleteMessageTemplatesMutationVariables>;

/**
 * __useDeleteMessageTemplatesMutation__
 *
 * To run a mutation, you first call `useDeleteMessageTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageTemplatesMutation, { data, loading, error }] = useDeleteMessageTemplatesMutation({
 *   variables: {
 *      templateIds: // value for 'templateIds'
 *   },
 * });
 */
export function useDeleteMessageTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMessageTemplatesMutation, DeleteMessageTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMessageTemplatesMutation, DeleteMessageTemplatesMutationVariables>(DeleteMessageTemplatesDocument, options);
      }
export type DeleteMessageTemplatesMutationHookResult = ReturnType<typeof useDeleteMessageTemplatesMutation>;
export type DeleteMessageTemplatesMutationResult = Apollo.MutationResult<DeleteMessageTemplatesMutation>;
export type DeleteMessageTemplatesMutationOptions = Apollo.BaseMutationOptions<DeleteMessageTemplatesMutation, DeleteMessageTemplatesMutationVariables>;
export const UpdateMemberDocument = gql`
    mutation UpdateMember($member: MemberUpdateInput!) {
  updateMember(input: $member) {
    ...MemberResponse
  }
}
    ${MemberResponseFragmentDoc}`;
export type UpdateMemberMutationFn = Apollo.MutationFunction<UpdateMemberMutation, UpdateMemberMutationVariables>;

/**
 * __useUpdateMemberMutation__
 *
 * To run a mutation, you first call `useUpdateMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMemberMutation, { data, loading, error }] = useUpdateMemberMutation({
 *   variables: {
 *      member: // value for 'member'
 *   },
 * });
 */
export function useUpdateMemberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMemberMutation, UpdateMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMemberMutation, UpdateMemberMutationVariables>(UpdateMemberDocument, options);
      }
export type UpdateMemberMutationHookResult = ReturnType<typeof useUpdateMemberMutation>;
export type UpdateMemberMutationResult = Apollo.MutationResult<UpdateMemberMutation>;
export type UpdateMemberMutationOptions = Apollo.BaseMutationOptions<UpdateMemberMutation, UpdateMemberMutationVariables>;
export const UpdateLeadMemberDocument = gql`
    mutation updateLeadMember($member: MemberUpdateInput!) {
  updateLeadMember(input: $member) {
    ...MemberResponse
  }
}
    ${MemberResponseFragmentDoc}`;
export type UpdateLeadMemberMutationFn = Apollo.MutationFunction<UpdateLeadMemberMutation, UpdateLeadMemberMutationVariables>;

/**
 * __useUpdateLeadMemberMutation__
 *
 * To run a mutation, you first call `useUpdateLeadMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeadMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeadMemberMutation, { data, loading, error }] = useUpdateLeadMemberMutation({
 *   variables: {
 *      member: // value for 'member'
 *   },
 * });
 */
export function useUpdateLeadMemberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeadMemberMutation, UpdateLeadMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeadMemberMutation, UpdateLeadMemberMutationVariables>(UpdateLeadMemberDocument, options);
      }
export type UpdateLeadMemberMutationHookResult = ReturnType<typeof useUpdateLeadMemberMutation>;
export type UpdateLeadMemberMutationResult = Apollo.MutationResult<UpdateLeadMemberMutation>;
export type UpdateLeadMemberMutationOptions = Apollo.BaseMutationOptions<UpdateLeadMemberMutation, UpdateLeadMemberMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation UpdateOrganization($organization: OrganizationUpdateInput!) {
  updateOrganization(input: $organization) {
    ...OrganizationFragment
  }
}
    ${OrganizationFragmentFragmentDoc}`;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      organization: // value for 'organization'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const UpdateOrganizationInfoDocument = gql`
    mutation updateOrganizationInfo($input: OrganizationInfoUpdateInput!) {
  updateOrganizationInfo(input: $input) {
    ...OrganizationFragment
  }
}
    ${OrganizationFragmentFragmentDoc}`;
export type UpdateOrganizationInfoMutationFn = Apollo.MutationFunction<UpdateOrganizationInfoMutation, UpdateOrganizationInfoMutationVariables>;

/**
 * __useUpdateOrganizationInfoMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationInfoMutation, { data, loading, error }] = useUpdateOrganizationInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationInfoMutation, UpdateOrganizationInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationInfoMutation, UpdateOrganizationInfoMutationVariables>(UpdateOrganizationInfoDocument, options);
      }
export type UpdateOrganizationInfoMutationHookResult = ReturnType<typeof useUpdateOrganizationInfoMutation>;
export type UpdateOrganizationInfoMutationResult = Apollo.MutationResult<UpdateOrganizationInfoMutation>;
export type UpdateOrganizationInfoMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationInfoMutation, UpdateOrganizationInfoMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation changePassword($input: ChangePasswordRequestInput!) {
  changePassword(input: $input)
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const ChangeEmailDocument = gql`
    mutation changeEmail($input: ChangeEmailRequestInput!) {
  changeEmail(input: $input) {
    email
    resendRemainingSeconds
  }
}
    `;
export type ChangeEmailMutationFn = Apollo.MutationFunction<ChangeEmailMutation, ChangeEmailMutationVariables>;

/**
 * __useChangeEmailMutation__
 *
 * To run a mutation, you first call `useChangeEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeEmailMutation, { data, loading, error }] = useChangeEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeEmailMutation(baseOptions?: Apollo.MutationHookOptions<ChangeEmailMutation, ChangeEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeEmailMutation, ChangeEmailMutationVariables>(ChangeEmailDocument, options);
      }
export type ChangeEmailMutationHookResult = ReturnType<typeof useChangeEmailMutation>;
export type ChangeEmailMutationResult = Apollo.MutationResult<ChangeEmailMutation>;
export type ChangeEmailMutationOptions = Apollo.BaseMutationOptions<ChangeEmailMutation, ChangeEmailMutationVariables>;
export const ConfirmChangeEmailDocument = gql`
    mutation confirmChangeEmail($input: ConfirmVerificationCodeRequestInput!) {
  confirmChangeEmail(input: $input) {
    email
    token
  }
}
    `;
export type ConfirmChangeEmailMutationFn = Apollo.MutationFunction<ConfirmChangeEmailMutation, ConfirmChangeEmailMutationVariables>;

/**
 * __useConfirmChangeEmailMutation__
 *
 * To run a mutation, you first call `useConfirmChangeEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmChangeEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmChangeEmailMutation, { data, loading, error }] = useConfirmChangeEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmChangeEmailMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmChangeEmailMutation, ConfirmChangeEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmChangeEmailMutation, ConfirmChangeEmailMutationVariables>(ConfirmChangeEmailDocument, options);
      }
export type ConfirmChangeEmailMutationHookResult = ReturnType<typeof useConfirmChangeEmailMutation>;
export type ConfirmChangeEmailMutationResult = Apollo.MutationResult<ConfirmChangeEmailMutation>;
export type ConfirmChangeEmailMutationOptions = Apollo.BaseMutationOptions<ConfirmChangeEmailMutation, ConfirmChangeEmailMutationVariables>;
export const RestorePasswordDocument = gql`
    mutation restorePassword {
  restorePassword {
    resendRemainingSeconds
  }
}
    `;
export type RestorePasswordMutationFn = Apollo.MutationFunction<RestorePasswordMutation, RestorePasswordMutationVariables>;

/**
 * __useRestorePasswordMutation__
 *
 * To run a mutation, you first call `useRestorePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestorePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restorePasswordMutation, { data, loading, error }] = useRestorePasswordMutation({
 *   variables: {
 *   },
 * });
 */
export function useRestorePasswordMutation(baseOptions?: Apollo.MutationHookOptions<RestorePasswordMutation, RestorePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestorePasswordMutation, RestorePasswordMutationVariables>(RestorePasswordDocument, options);
      }
export type RestorePasswordMutationHookResult = ReturnType<typeof useRestorePasswordMutation>;
export type RestorePasswordMutationResult = Apollo.MutationResult<RestorePasswordMutation>;
export type RestorePasswordMutationOptions = Apollo.BaseMutationOptions<RestorePasswordMutation, RestorePasswordMutationVariables>;
export const VerifyRestorePasswordCodeDocument = gql`
    mutation verifyRestorePasswordCode($input: ConfirmVerificationCodeRequestInput!) {
  verifyRestorePasswordCode(input: $input)
}
    `;
export type VerifyRestorePasswordCodeMutationFn = Apollo.MutationFunction<VerifyRestorePasswordCodeMutation, VerifyRestorePasswordCodeMutationVariables>;

/**
 * __useVerifyRestorePasswordCodeMutation__
 *
 * To run a mutation, you first call `useVerifyRestorePasswordCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyRestorePasswordCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyRestorePasswordCodeMutation, { data, loading, error }] = useVerifyRestorePasswordCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyRestorePasswordCodeMutation(baseOptions?: Apollo.MutationHookOptions<VerifyRestorePasswordCodeMutation, VerifyRestorePasswordCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyRestorePasswordCodeMutation, VerifyRestorePasswordCodeMutationVariables>(VerifyRestorePasswordCodeDocument, options);
      }
export type VerifyRestorePasswordCodeMutationHookResult = ReturnType<typeof useVerifyRestorePasswordCodeMutation>;
export type VerifyRestorePasswordCodeMutationResult = Apollo.MutationResult<VerifyRestorePasswordCodeMutation>;
export type VerifyRestorePasswordCodeMutationOptions = Apollo.BaseMutationOptions<VerifyRestorePasswordCodeMutation, VerifyRestorePasswordCodeMutationVariables>;
export const ConfirmRestorePasswordDocument = gql`
    mutation confirmRestorePassword($input: ConfirmChangePasswordRequestInput!) {
  confirmRestorePassword(input: $input) {
    token
  }
}
    `;
export type ConfirmRestorePasswordMutationFn = Apollo.MutationFunction<ConfirmRestorePasswordMutation, ConfirmRestorePasswordMutationVariables>;

/**
 * __useConfirmRestorePasswordMutation__
 *
 * To run a mutation, you first call `useConfirmRestorePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmRestorePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmRestorePasswordMutation, { data, loading, error }] = useConfirmRestorePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmRestorePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmRestorePasswordMutation, ConfirmRestorePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmRestorePasswordMutation, ConfirmRestorePasswordMutationVariables>(ConfirmRestorePasswordDocument, options);
      }
export type ConfirmRestorePasswordMutationHookResult = ReturnType<typeof useConfirmRestorePasswordMutation>;
export type ConfirmRestorePasswordMutationResult = Apollo.MutationResult<ConfirmRestorePasswordMutation>;
export type ConfirmRestorePasswordMutationOptions = Apollo.BaseMutationOptions<ConfirmRestorePasswordMutation, ConfirmRestorePasswordMutationVariables>;
export const ContactDetailsRegistrationStepDocument = gql`
    mutation contactDetailsRegistrationStep($input: RegistrationContactDetailsInput!) {
  contactDetailsRegistrationStep(input: $input) {
    ...MemberResponse
  }
}
    ${MemberResponseFragmentDoc}`;
export type ContactDetailsRegistrationStepMutationFn = Apollo.MutationFunction<ContactDetailsRegistrationStepMutation, ContactDetailsRegistrationStepMutationVariables>;

/**
 * __useContactDetailsRegistrationStepMutation__
 *
 * To run a mutation, you first call `useContactDetailsRegistrationStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactDetailsRegistrationStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactDetailsRegistrationStepMutation, { data, loading, error }] = useContactDetailsRegistrationStepMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContactDetailsRegistrationStepMutation(baseOptions?: Apollo.MutationHookOptions<ContactDetailsRegistrationStepMutation, ContactDetailsRegistrationStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactDetailsRegistrationStepMutation, ContactDetailsRegistrationStepMutationVariables>(ContactDetailsRegistrationStepDocument, options);
      }
export type ContactDetailsRegistrationStepMutationHookResult = ReturnType<typeof useContactDetailsRegistrationStepMutation>;
export type ContactDetailsRegistrationStepMutationResult = Apollo.MutationResult<ContactDetailsRegistrationStepMutation>;
export type ContactDetailsRegistrationStepMutationOptions = Apollo.BaseMutationOptions<ContactDetailsRegistrationStepMutation, ContactDetailsRegistrationStepMutationVariables>;
export const CompanyDetailsRegistrationStepDocument = gql`
    mutation companyDetailsRegistrationStep($input: OrganizationUpdateInput!) {
  companyDetailsRegistrationStep(input: $input) {
    ...MemberResponse
  }
}
    ${MemberResponseFragmentDoc}`;
export type CompanyDetailsRegistrationStepMutationFn = Apollo.MutationFunction<CompanyDetailsRegistrationStepMutation, CompanyDetailsRegistrationStepMutationVariables>;

/**
 * __useCompanyDetailsRegistrationStepMutation__
 *
 * To run a mutation, you first call `useCompanyDetailsRegistrationStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyDetailsRegistrationStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyDetailsRegistrationStepMutation, { data, loading, error }] = useCompanyDetailsRegistrationStepMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanyDetailsRegistrationStepMutation(baseOptions?: Apollo.MutationHookOptions<CompanyDetailsRegistrationStepMutation, CompanyDetailsRegistrationStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyDetailsRegistrationStepMutation, CompanyDetailsRegistrationStepMutationVariables>(CompanyDetailsRegistrationStepDocument, options);
      }
export type CompanyDetailsRegistrationStepMutationHookResult = ReturnType<typeof useCompanyDetailsRegistrationStepMutation>;
export type CompanyDetailsRegistrationStepMutationResult = Apollo.MutationResult<CompanyDetailsRegistrationStepMutation>;
export type CompanyDetailsRegistrationStepMutationOptions = Apollo.BaseMutationOptions<CompanyDetailsRegistrationStepMutation, CompanyDetailsRegistrationStepMutationVariables>;
export const MigrationRegistrationStepDocument = gql`
    mutation migrationRegistrationStep {
  migrationRegistrationStep {
    ...MemberResponse
  }
}
    ${MemberResponseFragmentDoc}`;
export type MigrationRegistrationStepMutationFn = Apollo.MutationFunction<MigrationRegistrationStepMutation, MigrationRegistrationStepMutationVariables>;

/**
 * __useMigrationRegistrationStepMutation__
 *
 * To run a mutation, you first call `useMigrationRegistrationStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMigrationRegistrationStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [migrationRegistrationStepMutation, { data, loading, error }] = useMigrationRegistrationStepMutation({
 *   variables: {
 *   },
 * });
 */
export function useMigrationRegistrationStepMutation(baseOptions?: Apollo.MutationHookOptions<MigrationRegistrationStepMutation, MigrationRegistrationStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MigrationRegistrationStepMutation, MigrationRegistrationStepMutationVariables>(MigrationRegistrationStepDocument, options);
      }
export type MigrationRegistrationStepMutationHookResult = ReturnType<typeof useMigrationRegistrationStepMutation>;
export type MigrationRegistrationStepMutationResult = Apollo.MutationResult<MigrationRegistrationStepMutation>;
export type MigrationRegistrationStepMutationOptions = Apollo.BaseMutationOptions<MigrationRegistrationStepMutation, MigrationRegistrationStepMutationVariables>;
export const MemberRegistrationPreviousStepDocument = gql`
    mutation memberRegistrationPreviousStep {
  memberRegistrationPreviousStep {
    ...MemberResponse
  }
}
    ${MemberResponseFragmentDoc}`;
export type MemberRegistrationPreviousStepMutationFn = Apollo.MutationFunction<MemberRegistrationPreviousStepMutation, MemberRegistrationPreviousStepMutationVariables>;

/**
 * __useMemberRegistrationPreviousStepMutation__
 *
 * To run a mutation, you first call `useMemberRegistrationPreviousStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMemberRegistrationPreviousStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [memberRegistrationPreviousStepMutation, { data, loading, error }] = useMemberRegistrationPreviousStepMutation({
 *   variables: {
 *   },
 * });
 */
export function useMemberRegistrationPreviousStepMutation(baseOptions?: Apollo.MutationHookOptions<MemberRegistrationPreviousStepMutation, MemberRegistrationPreviousStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MemberRegistrationPreviousStepMutation, MemberRegistrationPreviousStepMutationVariables>(MemberRegistrationPreviousStepDocument, options);
      }
export type MemberRegistrationPreviousStepMutationHookResult = ReturnType<typeof useMemberRegistrationPreviousStepMutation>;
export type MemberRegistrationPreviousStepMutationResult = Apollo.MutationResult<MemberRegistrationPreviousStepMutation>;
export type MemberRegistrationPreviousStepMutationOptions = Apollo.BaseMutationOptions<MemberRegistrationPreviousStepMutation, MemberRegistrationPreviousStepMutationVariables>;
export const PlanSelectionRegistrationStepDocument = gql`
    mutation planSelectionRegistrationStep($price: String, $saveCredits: Boolean!) {
  planSelectionRegistrationStep(price: $price, saveCredits: $saveCredits) {
    ...MemberResponse
  }
}
    ${MemberResponseFragmentDoc}`;
export type PlanSelectionRegistrationStepMutationFn = Apollo.MutationFunction<PlanSelectionRegistrationStepMutation, PlanSelectionRegistrationStepMutationVariables>;

/**
 * __usePlanSelectionRegistrationStepMutation__
 *
 * To run a mutation, you first call `usePlanSelectionRegistrationStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlanSelectionRegistrationStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [planSelectionRegistrationStepMutation, { data, loading, error }] = usePlanSelectionRegistrationStepMutation({
 *   variables: {
 *      price: // value for 'price'
 *      saveCredits: // value for 'saveCredits'
 *   },
 * });
 */
export function usePlanSelectionRegistrationStepMutation(baseOptions?: Apollo.MutationHookOptions<PlanSelectionRegistrationStepMutation, PlanSelectionRegistrationStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlanSelectionRegistrationStepMutation, PlanSelectionRegistrationStepMutationVariables>(PlanSelectionRegistrationStepDocument, options);
      }
export type PlanSelectionRegistrationStepMutationHookResult = ReturnType<typeof usePlanSelectionRegistrationStepMutation>;
export type PlanSelectionRegistrationStepMutationResult = Apollo.MutationResult<PlanSelectionRegistrationStepMutation>;
export type PlanSelectionRegistrationStepMutationOptions = Apollo.BaseMutationOptions<PlanSelectionRegistrationStepMutation, PlanSelectionRegistrationStepMutationVariables>;
export const StartTrialRegistrationStepDocument = gql`
    mutation startTrialRegistrationStep($paymentMethodId: String) {
  startTrialRegistrationStep(paymentMethodId: $paymentMethodId) {
    ...MemberResponse
  }
}
    ${MemberResponseFragmentDoc}`;
export type StartTrialRegistrationStepMutationFn = Apollo.MutationFunction<StartTrialRegistrationStepMutation, StartTrialRegistrationStepMutationVariables>;

/**
 * __useStartTrialRegistrationStepMutation__
 *
 * To run a mutation, you first call `useStartTrialRegistrationStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartTrialRegistrationStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startTrialRegistrationStepMutation, { data, loading, error }] = useStartTrialRegistrationStepMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useStartTrialRegistrationStepMutation(baseOptions?: Apollo.MutationHookOptions<StartTrialRegistrationStepMutation, StartTrialRegistrationStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartTrialRegistrationStepMutation, StartTrialRegistrationStepMutationVariables>(StartTrialRegistrationStepDocument, options);
      }
export type StartTrialRegistrationStepMutationHookResult = ReturnType<typeof useStartTrialRegistrationStepMutation>;
export type StartTrialRegistrationStepMutationResult = Apollo.MutationResult<StartTrialRegistrationStepMutation>;
export type StartTrialRegistrationStepMutationOptions = Apollo.BaseMutationOptions<StartTrialRegistrationStepMutation, StartTrialRegistrationStepMutationVariables>;
export const ApplyCouponDocument = gql`
    mutation applyCoupon($couponId: String) {
  applyCoupon(couponId: $couponId) {
    stripeCouponId
  }
}
    `;
export type ApplyCouponMutationFn = Apollo.MutationFunction<ApplyCouponMutation, ApplyCouponMutationVariables>;

/**
 * __useApplyCouponMutation__
 *
 * To run a mutation, you first call `useApplyCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyCouponMutation, { data, loading, error }] = useApplyCouponMutation({
 *   variables: {
 *      couponId: // value for 'couponId'
 *   },
 * });
 */
export function useApplyCouponMutation(baseOptions?: Apollo.MutationHookOptions<ApplyCouponMutation, ApplyCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyCouponMutation, ApplyCouponMutationVariables>(ApplyCouponDocument, options);
      }
export type ApplyCouponMutationHookResult = ReturnType<typeof useApplyCouponMutation>;
export type ApplyCouponMutationResult = Apollo.MutationResult<ApplyCouponMutation>;
export type ApplyCouponMutationOptions = Apollo.BaseMutationOptions<ApplyCouponMutation, ApplyCouponMutationVariables>;
export const GetMemberDocument = gql`
    query getMember {
  getMember {
    ...MemberResponse
  }
}
    ${MemberResponseFragmentDoc}`;

/**
 * __useGetMemberQuery__
 *
 * To run a query within a React component, call `useGetMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMemberQuery(baseOptions?: Apollo.QueryHookOptions<GetMemberQuery, GetMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberQuery, GetMemberQueryVariables>(GetMemberDocument, options);
      }
export function useGetMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberQuery, GetMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberQuery, GetMemberQueryVariables>(GetMemberDocument, options);
        }
export type GetMemberQueryHookResult = ReturnType<typeof useGetMemberQuery>;
export type GetMemberLazyQueryHookResult = ReturnType<typeof useGetMemberLazyQuery>;
export type GetMemberQueryResult = Apollo.QueryResult<GetMemberQuery, GetMemberQueryVariables>;
export const GetAllUserTimezonesDocument = gql`
    query getAllUserTimezones {
  getAllUserTimezones {
    ...UserTimezoneFragment
  }
}
    ${UserTimezoneFragmentFragmentDoc}`;

/**
 * __useGetAllUserTimezonesQuery__
 *
 * To run a query within a React component, call `useGetAllUserTimezonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUserTimezonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUserTimezonesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllUserTimezonesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllUserTimezonesQuery, GetAllUserTimezonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllUserTimezonesQuery, GetAllUserTimezonesQueryVariables>(GetAllUserTimezonesDocument, options);
      }
export function useGetAllUserTimezonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllUserTimezonesQuery, GetAllUserTimezonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllUserTimezonesQuery, GetAllUserTimezonesQueryVariables>(GetAllUserTimezonesDocument, options);
        }
export type GetAllUserTimezonesQueryHookResult = ReturnType<typeof useGetAllUserTimezonesQuery>;
export type GetAllUserTimezonesLazyQueryHookResult = ReturnType<typeof useGetAllUserTimezonesLazyQuery>;
export type GetAllUserTimezonesQueryResult = Apollo.QueryResult<GetAllUserTimezonesQuery, GetAllUserTimezonesQueryVariables>;
export const GetAllCountriesDocument = gql`
    query getAllCountries {
  getAllCountries {
    countryCode
    countryName
  }
}
    `;

/**
 * __useGetAllCountriesQuery__
 *
 * To run a query within a React component, call `useGetAllCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCountriesQuery, GetAllCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCountriesQuery, GetAllCountriesQueryVariables>(GetAllCountriesDocument, options);
      }
export function useGetAllCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCountriesQuery, GetAllCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCountriesQuery, GetAllCountriesQueryVariables>(GetAllCountriesDocument, options);
        }
export type GetAllCountriesQueryHookResult = ReturnType<typeof useGetAllCountriesQuery>;
export type GetAllCountriesLazyQueryHookResult = ReturnType<typeof useGetAllCountriesLazyQuery>;
export type GetAllCountriesQueryResult = Apollo.QueryResult<GetAllCountriesQuery, GetAllCountriesQueryVariables>;
export const CheckStripeCouponIdDocument = gql`
    query checkStripeCouponId {
  getOrganizationBillingInfo {
    stripeCouponId
  }
}
    `;

/**
 * __useCheckStripeCouponIdQuery__
 *
 * To run a query within a React component, call `useCheckStripeCouponIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckStripeCouponIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckStripeCouponIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckStripeCouponIdQuery(baseOptions?: Apollo.QueryHookOptions<CheckStripeCouponIdQuery, CheckStripeCouponIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckStripeCouponIdQuery, CheckStripeCouponIdQueryVariables>(CheckStripeCouponIdDocument, options);
      }
export function useCheckStripeCouponIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckStripeCouponIdQuery, CheckStripeCouponIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckStripeCouponIdQuery, CheckStripeCouponIdQueryVariables>(CheckStripeCouponIdDocument, options);
        }
export type CheckStripeCouponIdQueryHookResult = ReturnType<typeof useCheckStripeCouponIdQuery>;
export type CheckStripeCouponIdLazyQueryHookResult = ReturnType<typeof useCheckStripeCouponIdLazyQuery>;
export type CheckStripeCouponIdQueryResult = Apollo.QueryResult<CheckStripeCouponIdQuery, CheckStripeCouponIdQueryVariables>;
export const GetAllMembersDocument = gql`
    query getAllMembers($page: PaginationInput) {
  getAllMembers(page: $page) {
    pageNumber
    pageSize
    total
    content {
      ...MemberResponse
    }
  }
}
    ${MemberResponseFragmentDoc}`;

/**
 * __useGetAllMembersQuery__
 *
 * To run a query within a React component, call `useGetAllMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMembersQuery({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetAllMembersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllMembersQuery, GetAllMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllMembersQuery, GetAllMembersQueryVariables>(GetAllMembersDocument, options);
      }
export function useGetAllMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMembersQuery, GetAllMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllMembersQuery, GetAllMembersQueryVariables>(GetAllMembersDocument, options);
        }
export type GetAllMembersQueryHookResult = ReturnType<typeof useGetAllMembersQuery>;
export type GetAllMembersLazyQueryHookResult = ReturnType<typeof useGetAllMembersLazyQuery>;
export type GetAllMembersQueryResult = Apollo.QueryResult<GetAllMembersQuery, GetAllMembersQueryVariables>;
export const CreateInvitationDocument = gql`
    mutation createInvitation($input: CreateInvitationBidRequestInput!) {
  createInvitation(input: $input) {
    ...InviteResponseFragment
  }
}
    ${InviteResponseFragmentFragmentDoc}`;
export type CreateInvitationMutationFn = Apollo.MutationFunction<CreateInvitationMutation, CreateInvitationMutationVariables>;

/**
 * __useCreateInvitationMutation__
 *
 * To run a mutation, you first call `useCreateInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvitationMutation, { data, loading, error }] = useCreateInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInvitationMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvitationMutation, CreateInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInvitationMutation, CreateInvitationMutationVariables>(CreateInvitationDocument, options);
      }
export type CreateInvitationMutationHookResult = ReturnType<typeof useCreateInvitationMutation>;
export type CreateInvitationMutationResult = Apollo.MutationResult<CreateInvitationMutation>;
export type CreateInvitationMutationOptions = Apollo.BaseMutationOptions<CreateInvitationMutation, CreateInvitationMutationVariables>;
export const RemoveInvitationDocument = gql`
    mutation removeInvitation($invitationId: Long!) {
  removeInvitation(invitationId: $invitationId)
}
    `;
export type RemoveInvitationMutationFn = Apollo.MutationFunction<RemoveInvitationMutation, RemoveInvitationMutationVariables>;

/**
 * __useRemoveInvitationMutation__
 *
 * To run a mutation, you first call `useRemoveInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeInvitationMutation, { data, loading, error }] = useRemoveInvitationMutation({
 *   variables: {
 *      invitationId: // value for 'invitationId'
 *   },
 * });
 */
export function useRemoveInvitationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveInvitationMutation, RemoveInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveInvitationMutation, RemoveInvitationMutationVariables>(RemoveInvitationDocument, options);
      }
export type RemoveInvitationMutationHookResult = ReturnType<typeof useRemoveInvitationMutation>;
export type RemoveInvitationMutationResult = Apollo.MutationResult<RemoveInvitationMutation>;
export type RemoveInvitationMutationOptions = Apollo.BaseMutationOptions<RemoveInvitationMutation, RemoveInvitationMutationVariables>;
export const ResendInvitationDocument = gql`
    mutation resendInvitation($invitationId: Long!) {
  resendInvitation(invitationId: $invitationId)
}
    `;
export type ResendInvitationMutationFn = Apollo.MutationFunction<ResendInvitationMutation, ResendInvitationMutationVariables>;

/**
 * __useResendInvitationMutation__
 *
 * To run a mutation, you first call `useResendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInvitationMutation, { data, loading, error }] = useResendInvitationMutation({
 *   variables: {
 *      invitationId: // value for 'invitationId'
 *   },
 * });
 */
export function useResendInvitationMutation(baseOptions?: Apollo.MutationHookOptions<ResendInvitationMutation, ResendInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendInvitationMutation, ResendInvitationMutationVariables>(ResendInvitationDocument, options);
      }
export type ResendInvitationMutationHookResult = ReturnType<typeof useResendInvitationMutation>;
export type ResendInvitationMutationResult = Apollo.MutationResult<ResendInvitationMutation>;
export type ResendInvitationMutationOptions = Apollo.BaseMutationOptions<ResendInvitationMutation, ResendInvitationMutationVariables>;
export const UpdateMemberRestrictionsDocument = gql`
    mutation updateMemberRestrictions($input: UpdateMemberRestrictionsRequestInput!, $memberId: Long!) {
  updateMemberRestrictions(input: $input, memberId: $memberId) {
    ...MemberResponse
  }
}
    ${MemberResponseFragmentDoc}`;
export type UpdateMemberRestrictionsMutationFn = Apollo.MutationFunction<UpdateMemberRestrictionsMutation, UpdateMemberRestrictionsMutationVariables>;

/**
 * __useUpdateMemberRestrictionsMutation__
 *
 * To run a mutation, you first call `useUpdateMemberRestrictionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMemberRestrictionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMemberRestrictionsMutation, { data, loading, error }] = useUpdateMemberRestrictionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useUpdateMemberRestrictionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMemberRestrictionsMutation, UpdateMemberRestrictionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMemberRestrictionsMutation, UpdateMemberRestrictionsMutationVariables>(UpdateMemberRestrictionsDocument, options);
      }
export type UpdateMemberRestrictionsMutationHookResult = ReturnType<typeof useUpdateMemberRestrictionsMutation>;
export type UpdateMemberRestrictionsMutationResult = Apollo.MutationResult<UpdateMemberRestrictionsMutation>;
export type UpdateMemberRestrictionsMutationOptions = Apollo.BaseMutationOptions<UpdateMemberRestrictionsMutation, UpdateMemberRestrictionsMutationVariables>;
export const RemoveMemberDocument = gql`
    mutation removeMember($memberId: Long!) {
  removeMember(memberId: $memberId)
}
    `;
export type RemoveMemberMutationFn = Apollo.MutationFunction<RemoveMemberMutation, RemoveMemberMutationVariables>;

/**
 * __useRemoveMemberMutation__
 *
 * To run a mutation, you first call `useRemoveMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMemberMutation, { data, loading, error }] = useRemoveMemberMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useRemoveMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMemberMutation, RemoveMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMemberMutation, RemoveMemberMutationVariables>(RemoveMemberDocument, options);
      }
export type RemoveMemberMutationHookResult = ReturnType<typeof useRemoveMemberMutation>;
export type RemoveMemberMutationResult = Apollo.MutationResult<RemoveMemberMutation>;
export type RemoveMemberMutationOptions = Apollo.BaseMutationOptions<RemoveMemberMutation, RemoveMemberMutationVariables>;
export const GetAllAudioItemsDocument = gql`
    query getAllAudioItems($page: PaginationInput, $pattern: String) {
  getAllAudioItems(page: $page, pattern: $pattern) {
    total
    pageNumber
    pageSize
    content {
      ...AudioItemFragment
    }
  }
}
    ${AudioItemFragmentFragmentDoc}`;

/**
 * __useGetAllAudioItemsQuery__
 *
 * To run a query within a React component, call `useGetAllAudioItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAudioItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAudioItemsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pattern: // value for 'pattern'
 *   },
 * });
 */
export function useGetAllAudioItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllAudioItemsQuery, GetAllAudioItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAudioItemsQuery, GetAllAudioItemsQueryVariables>(GetAllAudioItemsDocument, options);
      }
export function useGetAllAudioItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAudioItemsQuery, GetAllAudioItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAudioItemsQuery, GetAllAudioItemsQueryVariables>(GetAllAudioItemsDocument, options);
        }
export type GetAllAudioItemsQueryHookResult = ReturnType<typeof useGetAllAudioItemsQuery>;
export type GetAllAudioItemsLazyQueryHookResult = ReturnType<typeof useGetAllAudioItemsLazyQuery>;
export type GetAllAudioItemsQueryResult = Apollo.QueryResult<GetAllAudioItemsQuery, GetAllAudioItemsQueryVariables>;
export const CheckAudioItemExistsDocument = gql`
    query checkAudioItemExists($name: String) {
  checkAudioItemExists(name: $name)
}
    `;

/**
 * __useCheckAudioItemExistsQuery__
 *
 * To run a query within a React component, call `useCheckAudioItemExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckAudioItemExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckAudioItemExistsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCheckAudioItemExistsQuery(baseOptions?: Apollo.QueryHookOptions<CheckAudioItemExistsQuery, CheckAudioItemExistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckAudioItemExistsQuery, CheckAudioItemExistsQueryVariables>(CheckAudioItemExistsDocument, options);
      }
export function useCheckAudioItemExistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckAudioItemExistsQuery, CheckAudioItemExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckAudioItemExistsQuery, CheckAudioItemExistsQueryVariables>(CheckAudioItemExistsDocument, options);
        }
export type CheckAudioItemExistsQueryHookResult = ReturnType<typeof useCheckAudioItemExistsQuery>;
export type CheckAudioItemExistsLazyQueryHookResult = ReturnType<typeof useCheckAudioItemExistsLazyQuery>;
export type CheckAudioItemExistsQueryResult = Apollo.QueryResult<CheckAudioItemExistsQuery, CheckAudioItemExistsQueryVariables>;
export const UpdateAudioItemDocument = gql`
    mutation updateAudioItem($input: UpdateAudioItemRequestInput!) {
  updateAudioItem(input: $input) {
    ...AudioItemFragment
  }
}
    ${AudioItemFragmentFragmentDoc}`;
export type UpdateAudioItemMutationFn = Apollo.MutationFunction<UpdateAudioItemMutation, UpdateAudioItemMutationVariables>;

/**
 * __useUpdateAudioItemMutation__
 *
 * To run a mutation, you first call `useUpdateAudioItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAudioItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAudioItemMutation, { data, loading, error }] = useUpdateAudioItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAudioItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAudioItemMutation, UpdateAudioItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAudioItemMutation, UpdateAudioItemMutationVariables>(UpdateAudioItemDocument, options);
      }
export type UpdateAudioItemMutationHookResult = ReturnType<typeof useUpdateAudioItemMutation>;
export type UpdateAudioItemMutationResult = Apollo.MutationResult<UpdateAudioItemMutation>;
export type UpdateAudioItemMutationOptions = Apollo.BaseMutationOptions<UpdateAudioItemMutation, UpdateAudioItemMutationVariables>;
export const DeleteAudioItemsDocument = gql`
    mutation deleteAudioItems($ids: [Long!]) {
  deleteAudioItems(ids: $ids)
}
    `;
export type DeleteAudioItemsMutationFn = Apollo.MutationFunction<DeleteAudioItemsMutation, DeleteAudioItemsMutationVariables>;

/**
 * __useDeleteAudioItemsMutation__
 *
 * To run a mutation, you first call `useDeleteAudioItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAudioItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAudioItemsMutation, { data, loading, error }] = useDeleteAudioItemsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteAudioItemsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAudioItemsMutation, DeleteAudioItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAudioItemsMutation, DeleteAudioItemsMutationVariables>(DeleteAudioItemsDocument, options);
      }
export type DeleteAudioItemsMutationHookResult = ReturnType<typeof useDeleteAudioItemsMutation>;
export type DeleteAudioItemsMutationResult = Apollo.MutationResult<DeleteAudioItemsMutation>;
export type DeleteAudioItemsMutationOptions = Apollo.BaseMutationOptions<DeleteAudioItemsMutation, DeleteAudioItemsMutationVariables>;
export const SetupAutoRechargeDocument = gql`
    mutation setupAutoRecharge($options: AutoRechargeOptionsInput) {
  setupAutoRecharge(options: $options) {
    ...OrganizationBillingFragment
  }
}
    ${OrganizationBillingFragmentFragmentDoc}`;
export type SetupAutoRechargeMutationFn = Apollo.MutationFunction<SetupAutoRechargeMutation, SetupAutoRechargeMutationVariables>;

/**
 * __useSetupAutoRechargeMutation__
 *
 * To run a mutation, you first call `useSetupAutoRechargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupAutoRechargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupAutoRechargeMutation, { data, loading, error }] = useSetupAutoRechargeMutation({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useSetupAutoRechargeMutation(baseOptions?: Apollo.MutationHookOptions<SetupAutoRechargeMutation, SetupAutoRechargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupAutoRechargeMutation, SetupAutoRechargeMutationVariables>(SetupAutoRechargeDocument, options);
      }
export type SetupAutoRechargeMutationHookResult = ReturnType<typeof useSetupAutoRechargeMutation>;
export type SetupAutoRechargeMutationResult = Apollo.MutationResult<SetupAutoRechargeMutation>;
export type SetupAutoRechargeMutationOptions = Apollo.BaseMutationOptions<SetupAutoRechargeMutation, SetupAutoRechargeMutationVariables>;
export const GetOrganizationBillingInfoDocument = gql`
    query getOrganizationBillingInfo {
  getOrganizationBillingInfo {
    ...OrganizationBillingFragment
  }
  getSubscription {
    ...SubscriptionFragment
  }
}
    ${OrganizationBillingFragmentFragmentDoc}
${SubscriptionFragmentFragmentDoc}`;

/**
 * __useGetOrganizationBillingInfoQuery__
 *
 * To run a query within a React component, call `useGetOrganizationBillingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationBillingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationBillingInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationBillingInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationBillingInfoQuery, GetOrganizationBillingInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationBillingInfoQuery, GetOrganizationBillingInfoQueryVariables>(GetOrganizationBillingInfoDocument, options);
      }
export function useGetOrganizationBillingInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationBillingInfoQuery, GetOrganizationBillingInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationBillingInfoQuery, GetOrganizationBillingInfoQueryVariables>(GetOrganizationBillingInfoDocument, options);
        }
export type GetOrganizationBillingInfoQueryHookResult = ReturnType<typeof useGetOrganizationBillingInfoQuery>;
export type GetOrganizationBillingInfoLazyQueryHookResult = ReturnType<typeof useGetOrganizationBillingInfoLazyQuery>;
export type GetOrganizationBillingInfoQueryResult = Apollo.QueryResult<GetOrganizationBillingInfoQuery, GetOrganizationBillingInfoQueryVariables>;
export const GetPaymentsMethodsDocument = gql`
    query getPaymentsMethods {
  getOrganizationBillingInfo {
    ...OrganizationBillingFragment
  }
}
    ${OrganizationBillingFragmentFragmentDoc}`;

/**
 * __useGetPaymentsMethodsQuery__
 *
 * To run a query within a React component, call `useGetPaymentsMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentsMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentsMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPaymentsMethodsQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentsMethodsQuery, GetPaymentsMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentsMethodsQuery, GetPaymentsMethodsQueryVariables>(GetPaymentsMethodsDocument, options);
      }
export function useGetPaymentsMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentsMethodsQuery, GetPaymentsMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentsMethodsQuery, GetPaymentsMethodsQueryVariables>(GetPaymentsMethodsDocument, options);
        }
export type GetPaymentsMethodsQueryHookResult = ReturnType<typeof useGetPaymentsMethodsQuery>;
export type GetPaymentsMethodsLazyQueryHookResult = ReturnType<typeof useGetPaymentsMethodsLazyQuery>;
export type GetPaymentsMethodsQueryResult = Apollo.QueryResult<GetPaymentsMethodsQuery, GetPaymentsMethodsQueryVariables>;
export const GetBalancesDocument = gql`
    query getBalances {
  getBalances {
    ...BalancesFragment
  }
}
    ${BalancesFragmentFragmentDoc}`;

/**
 * __useGetBalancesQuery__
 *
 * To run a query within a React component, call `useGetBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBalancesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBalancesQuery(baseOptions?: Apollo.QueryHookOptions<GetBalancesQuery, GetBalancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBalancesQuery, GetBalancesQueryVariables>(GetBalancesDocument, options);
      }
export function useGetBalancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBalancesQuery, GetBalancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBalancesQuery, GetBalancesQueryVariables>(GetBalancesDocument, options);
        }
export type GetBalancesQueryHookResult = ReturnType<typeof useGetBalancesQuery>;
export type GetBalancesLazyQueryHookResult = ReturnType<typeof useGetBalancesLazyQuery>;
export type GetBalancesQueryResult = Apollo.QueryResult<GetBalancesQuery, GetBalancesQueryVariables>;
export const GetInvoicesDocument = gql`
    query getInvoices($page: PaginationInput) {
  getInvoices(page: $page) {
    content {
      ...CLInvoiceFragment
    }
    pageNumber
    pageSize
    total
  }
}
    ${ClInvoiceFragmentFragmentDoc}`;

/**
 * __useGetInvoicesQuery__
 *
 * To run a query within a React component, call `useGetInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesQuery({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
      }
export function useGetInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
        }
export type GetInvoicesQueryHookResult = ReturnType<typeof useGetInvoicesQuery>;
export type GetInvoicesLazyQueryHookResult = ReturnType<typeof useGetInvoicesLazyQuery>;
export type GetInvoicesQueryResult = Apollo.QueryResult<GetInvoicesQuery, GetInvoicesQueryVariables>;
export const GetPricesDocument = gql`
    query GetPrices {
  getPrices {
    ...SimplePriceFragment
  }
}
    ${SimplePriceFragmentFragmentDoc}`;

/**
 * __useGetPricesQuery__
 *
 * To run a query within a React component, call `useGetPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPricesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPricesQuery(baseOptions?: Apollo.QueryHookOptions<GetPricesQuery, GetPricesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPricesQuery, GetPricesQueryVariables>(GetPricesDocument, options);
      }
export function useGetPricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPricesQuery, GetPricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPricesQuery, GetPricesQueryVariables>(GetPricesDocument, options);
        }
export type GetPricesQueryHookResult = ReturnType<typeof useGetPricesQuery>;
export type GetPricesLazyQueryHookResult = ReturnType<typeof useGetPricesLazyQuery>;
export type GetPricesQueryResult = Apollo.QueryResult<GetPricesQuery, GetPricesQueryVariables>;
export const GetPriceMigrationDocument = gql`
    query getPriceMigration {
  getPriceMigration {
    annualPrices {
      ...SimplePriceFragment
    }
    monthlyPrices {
      ...SimplePriceFragment
    }
  }
}
    ${SimplePriceFragmentFragmentDoc}`;

/**
 * __useGetPriceMigrationQuery__
 *
 * To run a query within a React component, call `useGetPriceMigrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPriceMigrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPriceMigrationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPriceMigrationQuery(baseOptions?: Apollo.QueryHookOptions<GetPriceMigrationQuery, GetPriceMigrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPriceMigrationQuery, GetPriceMigrationQueryVariables>(GetPriceMigrationDocument, options);
      }
export function useGetPriceMigrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPriceMigrationQuery, GetPriceMigrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPriceMigrationQuery, GetPriceMigrationQueryVariables>(GetPriceMigrationDocument, options);
        }
export type GetPriceMigrationQueryHookResult = ReturnType<typeof useGetPriceMigrationQuery>;
export type GetPriceMigrationLazyQueryHookResult = ReturnType<typeof useGetPriceMigrationLazyQuery>;
export type GetPriceMigrationQueryResult = Apollo.QueryResult<GetPriceMigrationQuery, GetPriceMigrationQueryVariables>;
export const PaymentRegistrationSelectPricesDocument = gql`
    query paymentRegistrationSelectPrices {
  paymentRegistrationSelectPrices {
    annualPrice {
      ...SimplePriceFragment
    }
    monthlyPrice {
      ...SimplePriceFragment
    }
  }
}
    ${SimplePriceFragmentFragmentDoc}`;

/**
 * __usePaymentRegistrationSelectPricesQuery__
 *
 * To run a query within a React component, call `usePaymentRegistrationSelectPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentRegistrationSelectPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentRegistrationSelectPricesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentRegistrationSelectPricesQuery(baseOptions?: Apollo.QueryHookOptions<PaymentRegistrationSelectPricesQuery, PaymentRegistrationSelectPricesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentRegistrationSelectPricesQuery, PaymentRegistrationSelectPricesQueryVariables>(PaymentRegistrationSelectPricesDocument, options);
      }
export function usePaymentRegistrationSelectPricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentRegistrationSelectPricesQuery, PaymentRegistrationSelectPricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentRegistrationSelectPricesQuery, PaymentRegistrationSelectPricesQueryVariables>(PaymentRegistrationSelectPricesDocument, options);
        }
export type PaymentRegistrationSelectPricesQueryHookResult = ReturnType<typeof usePaymentRegistrationSelectPricesQuery>;
export type PaymentRegistrationSelectPricesLazyQueryHookResult = ReturnType<typeof usePaymentRegistrationSelectPricesLazyQuery>;
export type PaymentRegistrationSelectPricesQueryResult = Apollo.QueryResult<PaymentRegistrationSelectPricesQuery, PaymentRegistrationSelectPricesQueryVariables>;
export const GetCreditPriceSelectionDocument = gql`
    query getCreditPriceSelection {
  getCreditPriceSelection {
    allowedPrices {
      ...CreditPricesFragment
    }
    planName
    upgradePrices {
      ...CreditPricesFragment
    }
  }
}
    ${CreditPricesFragmentFragmentDoc}`;

/**
 * __useGetCreditPriceSelectionQuery__
 *
 * To run a query within a React component, call `useGetCreditPriceSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditPriceSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditPriceSelectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCreditPriceSelectionQuery(baseOptions?: Apollo.QueryHookOptions<GetCreditPriceSelectionQuery, GetCreditPriceSelectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditPriceSelectionQuery, GetCreditPriceSelectionQueryVariables>(GetCreditPriceSelectionDocument, options);
      }
export function useGetCreditPriceSelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditPriceSelectionQuery, GetCreditPriceSelectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditPriceSelectionQuery, GetCreditPriceSelectionQueryVariables>(GetCreditPriceSelectionDocument, options);
        }
export type GetCreditPriceSelectionQueryHookResult = ReturnType<typeof useGetCreditPriceSelectionQuery>;
export type GetCreditPriceSelectionLazyQueryHookResult = ReturnType<typeof useGetCreditPriceSelectionLazyQuery>;
export type GetCreditPriceSelectionQueryResult = Apollo.QueryResult<GetCreditPriceSelectionQuery, GetCreditPriceSelectionQueryVariables>;
export const GetCreditPriceSelectionForPlansDocument = gql`
    query getCreditPriceSelectionForPlans($planNames: [String]!) {
  getCreditPriceSelectionForPlans(planNames: $planNames) {
    allowedPrices {
      ...CreditPricesFragment
    }
    planName
    upgradePrices {
      ...CreditPricesFragment
    }
  }
}
    ${CreditPricesFragmentFragmentDoc}`;

/**
 * __useGetCreditPriceSelectionForPlansQuery__
 *
 * To run a query within a React component, call `useGetCreditPriceSelectionForPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditPriceSelectionForPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditPriceSelectionForPlansQuery({
 *   variables: {
 *      planNames: // value for 'planNames'
 *   },
 * });
 */
export function useGetCreditPriceSelectionForPlansQuery(baseOptions: Apollo.QueryHookOptions<GetCreditPriceSelectionForPlansQuery, GetCreditPriceSelectionForPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditPriceSelectionForPlansQuery, GetCreditPriceSelectionForPlansQueryVariables>(GetCreditPriceSelectionForPlansDocument, options);
      }
export function useGetCreditPriceSelectionForPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditPriceSelectionForPlansQuery, GetCreditPriceSelectionForPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditPriceSelectionForPlansQuery, GetCreditPriceSelectionForPlansQueryVariables>(GetCreditPriceSelectionForPlansDocument, options);
        }
export type GetCreditPriceSelectionForPlansQueryHookResult = ReturnType<typeof useGetCreditPriceSelectionForPlansQuery>;
export type GetCreditPriceSelectionForPlansLazyQueryHookResult = ReturnType<typeof useGetCreditPriceSelectionForPlansLazyQuery>;
export type GetCreditPriceSelectionForPlansQueryResult = Apollo.QueryResult<GetCreditPriceSelectionForPlansQuery, GetCreditPriceSelectionForPlansQueryVariables>;
export const FetchInvoiceLinkDocument = gql`
    query fetchInvoiceLink($id: String!) {
  fetchInvoice(id: $id) {
    link
  }
}
    `;

/**
 * __useFetchInvoiceLinkQuery__
 *
 * To run a query within a React component, call `useFetchInvoiceLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchInvoiceLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchInvoiceLinkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchInvoiceLinkQuery(baseOptions: Apollo.QueryHookOptions<FetchInvoiceLinkQuery, FetchInvoiceLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchInvoiceLinkQuery, FetchInvoiceLinkQueryVariables>(FetchInvoiceLinkDocument, options);
      }
export function useFetchInvoiceLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchInvoiceLinkQuery, FetchInvoiceLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchInvoiceLinkQuery, FetchInvoiceLinkQueryVariables>(FetchInvoiceLinkDocument, options);
        }
export type FetchInvoiceLinkQueryHookResult = ReturnType<typeof useFetchInvoiceLinkQuery>;
export type FetchInvoiceLinkLazyQueryHookResult = ReturnType<typeof useFetchInvoiceLinkLazyQuery>;
export type FetchInvoiceLinkQueryResult = Apollo.QueryResult<FetchInvoiceLinkQuery, FetchInvoiceLinkQueryVariables>;
export const SwitchPlanDocument = gql`
    mutation switchPlan($price: String, $paymentMethodId: String, $userInput: SubscriptionChangeInputInput) {
  switchPlan(
    price: $price
    paymentMethodId: $paymentMethodId
    userInput: $userInput
  ) {
    ...UpdateSubscriptionFragment
  }
}
    ${UpdateSubscriptionFragmentFragmentDoc}`;
export type SwitchPlanMutationFn = Apollo.MutationFunction<SwitchPlanMutation, SwitchPlanMutationVariables>;

/**
 * __useSwitchPlanMutation__
 *
 * To run a mutation, you first call `useSwitchPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchPlanMutation, { data, loading, error }] = useSwitchPlanMutation({
 *   variables: {
 *      price: // value for 'price'
 *      paymentMethodId: // value for 'paymentMethodId'
 *      userInput: // value for 'userInput'
 *   },
 * });
 */
export function useSwitchPlanMutation(baseOptions?: Apollo.MutationHookOptions<SwitchPlanMutation, SwitchPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchPlanMutation, SwitchPlanMutationVariables>(SwitchPlanDocument, options);
      }
export type SwitchPlanMutationHookResult = ReturnType<typeof useSwitchPlanMutation>;
export type SwitchPlanMutationResult = Apollo.MutationResult<SwitchPlanMutation>;
export type SwitchPlanMutationOptions = Apollo.BaseMutationOptions<SwitchPlanMutation, SwitchPlanMutationVariables>;
export const DeletePaymentMethodDocument = gql`
    mutation DeletePaymentMethod($pmId: String) {
  deletePaymentMethod(pmId: $pmId) {
    ...OrganizationBillingFragment
  }
}
    ${OrganizationBillingFragmentFragmentDoc}`;
export type DeletePaymentMethodMutationFn = Apollo.MutationFunction<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>;

/**
 * __useDeletePaymentMethodMutation__
 *
 * To run a mutation, you first call `useDeletePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentMethodMutation, { data, loading, error }] = useDeletePaymentMethodMutation({
 *   variables: {
 *      pmId: // value for 'pmId'
 *   },
 * });
 */
export function useDeletePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>(DeletePaymentMethodDocument, options);
      }
export type DeletePaymentMethodMutationHookResult = ReturnType<typeof useDeletePaymentMethodMutation>;
export type DeletePaymentMethodMutationResult = Apollo.MutationResult<DeletePaymentMethodMutation>;
export type DeletePaymentMethodMutationOptions = Apollo.BaseMutationOptions<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>;
export const SetBackupPaymentMethodDocument = gql`
    mutation SetBackupPaymentMethod($pmId: String) {
  setBackupPaymentMethod(pmId: $pmId) {
    ...OrganizationBillingFragment
  }
}
    ${OrganizationBillingFragmentFragmentDoc}`;
export type SetBackupPaymentMethodMutationFn = Apollo.MutationFunction<SetBackupPaymentMethodMutation, SetBackupPaymentMethodMutationVariables>;

/**
 * __useSetBackupPaymentMethodMutation__
 *
 * To run a mutation, you first call `useSetBackupPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBackupPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBackupPaymentMethodMutation, { data, loading, error }] = useSetBackupPaymentMethodMutation({
 *   variables: {
 *      pmId: // value for 'pmId'
 *   },
 * });
 */
export function useSetBackupPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<SetBackupPaymentMethodMutation, SetBackupPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetBackupPaymentMethodMutation, SetBackupPaymentMethodMutationVariables>(SetBackupPaymentMethodDocument, options);
      }
export type SetBackupPaymentMethodMutationHookResult = ReturnType<typeof useSetBackupPaymentMethodMutation>;
export type SetBackupPaymentMethodMutationResult = Apollo.MutationResult<SetBackupPaymentMethodMutation>;
export type SetBackupPaymentMethodMutationOptions = Apollo.BaseMutationOptions<SetBackupPaymentMethodMutation, SetBackupPaymentMethodMutationVariables>;
export const SetPrimaryPaymentMethodDocument = gql`
    mutation SetPrimaryPaymentMethod($pmId: String) {
  setPrimaryPaymentMethod(pmId: $pmId) {
    ...OrganizationBillingFragment
  }
}
    ${OrganizationBillingFragmentFragmentDoc}`;
export type SetPrimaryPaymentMethodMutationFn = Apollo.MutationFunction<SetPrimaryPaymentMethodMutation, SetPrimaryPaymentMethodMutationVariables>;

/**
 * __useSetPrimaryPaymentMethodMutation__
 *
 * To run a mutation, you first call `useSetPrimaryPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPrimaryPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPrimaryPaymentMethodMutation, { data, loading, error }] = useSetPrimaryPaymentMethodMutation({
 *   variables: {
 *      pmId: // value for 'pmId'
 *   },
 * });
 */
export function useSetPrimaryPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<SetPrimaryPaymentMethodMutation, SetPrimaryPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPrimaryPaymentMethodMutation, SetPrimaryPaymentMethodMutationVariables>(SetPrimaryPaymentMethodDocument, options);
      }
export type SetPrimaryPaymentMethodMutationHookResult = ReturnType<typeof useSetPrimaryPaymentMethodMutation>;
export type SetPrimaryPaymentMethodMutationResult = Apollo.MutationResult<SetPrimaryPaymentMethodMutation>;
export type SetPrimaryPaymentMethodMutationOptions = Apollo.BaseMutationOptions<SetPrimaryPaymentMethodMutation, SetPrimaryPaymentMethodMutationVariables>;
export const BuyCreditsDocument = gql`
    mutation buyCredits($creditsAmount: Int, $paymentMethodId: String) {
  buyCredits(creditsAmount: $creditsAmount, paymentMethodId: $paymentMethodId) {
    ...BalancesFragment
  }
}
    ${BalancesFragmentFragmentDoc}`;
export type BuyCreditsMutationFn = Apollo.MutationFunction<BuyCreditsMutation, BuyCreditsMutationVariables>;

/**
 * __useBuyCreditsMutation__
 *
 * To run a mutation, you first call `useBuyCreditsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyCreditsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyCreditsMutation, { data, loading, error }] = useBuyCreditsMutation({
 *   variables: {
 *      creditsAmount: // value for 'creditsAmount'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useBuyCreditsMutation(baseOptions?: Apollo.MutationHookOptions<BuyCreditsMutation, BuyCreditsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuyCreditsMutation, BuyCreditsMutationVariables>(BuyCreditsDocument, options);
      }
export type BuyCreditsMutationHookResult = ReturnType<typeof useBuyCreditsMutation>;
export type BuyCreditsMutationResult = Apollo.MutationResult<BuyCreditsMutation>;
export type BuyCreditsMutationOptions = Apollo.BaseMutationOptions<BuyCreditsMutation, BuyCreditsMutationVariables>;
export const CancelDowngradeDocument = gql`
    mutation cancelDowngrade {
  cancelDowngrade {
    ...SubscriptionFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}`;
export type CancelDowngradeMutationFn = Apollo.MutationFunction<CancelDowngradeMutation, CancelDowngradeMutationVariables>;

/**
 * __useCancelDowngradeMutation__
 *
 * To run a mutation, you first call `useCancelDowngradeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDowngradeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDowngradeMutation, { data, loading, error }] = useCancelDowngradeMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelDowngradeMutation(baseOptions?: Apollo.MutationHookOptions<CancelDowngradeMutation, CancelDowngradeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelDowngradeMutation, CancelDowngradeMutationVariables>(CancelDowngradeDocument, options);
      }
export type CancelDowngradeMutationHookResult = ReturnType<typeof useCancelDowngradeMutation>;
export type CancelDowngradeMutationResult = Apollo.MutationResult<CancelDowngradeMutation>;
export type CancelDowngradeMutationOptions = Apollo.BaseMutationOptions<CancelDowngradeMutation, CancelDowngradeMutationVariables>;
export const AddCardDocument = gql`
    mutation addCard($tokenId: String) {
  addCard(tokenId: $tokenId) {
    ...OrganizationBillingFragment
  }
}
    ${OrganizationBillingFragmentFragmentDoc}`;
export type AddCardMutationFn = Apollo.MutationFunction<AddCardMutation, AddCardMutationVariables>;

/**
 * __useAddCardMutation__
 *
 * To run a mutation, you first call `useAddCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCardMutation, { data, loading, error }] = useAddCardMutation({
 *   variables: {
 *      tokenId: // value for 'tokenId'
 *   },
 * });
 */
export function useAddCardMutation(baseOptions?: Apollo.MutationHookOptions<AddCardMutation, AddCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCardMutation, AddCardMutationVariables>(AddCardDocument, options);
      }
export type AddCardMutationHookResult = ReturnType<typeof useAddCardMutation>;
export type AddCardMutationResult = Apollo.MutationResult<AddCardMutation>;
export type AddCardMutationOptions = Apollo.BaseMutationOptions<AddCardMutation, AddCardMutationVariables>;
export const CancelSubscriptionDocument = gql`
    mutation cancelSubscription($userInput: SubscriptionChangeInputInput) {
  cancelSubscription(userInput: $userInput) {
    ...SubscriptionFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}`;
export type CancelSubscriptionMutationFn = Apollo.MutationFunction<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *      userInput: // value for 'userInput'
 *   },
 * });
 */
export function useCancelSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(CancelSubscriptionDocument, options);
      }
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = Apollo.MutationResult<CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;
export const StopCancelSubscriptionDocument = gql`
    mutation stopCancelSubscription {
  stopCancelSubscription {
    ...SubscriptionFragment
  }
}
    ${SubscriptionFragmentFragmentDoc}`;
export type StopCancelSubscriptionMutationFn = Apollo.MutationFunction<StopCancelSubscriptionMutation, StopCancelSubscriptionMutationVariables>;

/**
 * __useStopCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useStopCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopCancelSubscriptionMutation, { data, loading, error }] = useStopCancelSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useStopCancelSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<StopCancelSubscriptionMutation, StopCancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopCancelSubscriptionMutation, StopCancelSubscriptionMutationVariables>(StopCancelSubscriptionDocument, options);
      }
export type StopCancelSubscriptionMutationHookResult = ReturnType<typeof useStopCancelSubscriptionMutation>;
export type StopCancelSubscriptionMutationResult = Apollo.MutationResult<StopCancelSubscriptionMutation>;
export type StopCancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<StopCancelSubscriptionMutation, StopCancelSubscriptionMutationVariables>;
export const StartTrialDocument = gql`
    mutation startTrial($tokenId: String, $member: MemberUpdateInput!) {
  startTrial(tokenId: $tokenId, customer: $member) {
    member {
      ...MemberResponse
    }
    subscription {
      ...SubscriptionFragment
    }
  }
}
    ${MemberResponseFragmentDoc}
${SubscriptionFragmentFragmentDoc}`;
export type StartTrialMutationFn = Apollo.MutationFunction<StartTrialMutation, StartTrialMutationVariables>;

/**
 * __useStartTrialMutation__
 *
 * To run a mutation, you first call `useStartTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startTrialMutation, { data, loading, error }] = useStartTrialMutation({
 *   variables: {
 *      tokenId: // value for 'tokenId'
 *      member: // value for 'member'
 *   },
 * });
 */
export function useStartTrialMutation(baseOptions?: Apollo.MutationHookOptions<StartTrialMutation, StartTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartTrialMutation, StartTrialMutationVariables>(StartTrialDocument, options);
      }
export type StartTrialMutationHookResult = ReturnType<typeof useStartTrialMutation>;
export type StartTrialMutationResult = Apollo.MutationResult<StartTrialMutation>;
export type StartTrialMutationOptions = Apollo.BaseMutationOptions<StartTrialMutation, StartTrialMutationVariables>;
export const SwitchPhoneCheckerDocument = gql`
    mutation switchPhoneChecker($input: SwitchPhoneCheckerRequestInput!) {
  switchPhoneChecker(input: $input) {
    ...OrganizationFragment
  }
}
    ${OrganizationFragmentFragmentDoc}`;
export type SwitchPhoneCheckerMutationFn = Apollo.MutationFunction<SwitchPhoneCheckerMutation, SwitchPhoneCheckerMutationVariables>;

/**
 * __useSwitchPhoneCheckerMutation__
 *
 * To run a mutation, you first call `useSwitchPhoneCheckerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchPhoneCheckerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchPhoneCheckerMutation, { data, loading, error }] = useSwitchPhoneCheckerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSwitchPhoneCheckerMutation(baseOptions?: Apollo.MutationHookOptions<SwitchPhoneCheckerMutation, SwitchPhoneCheckerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchPhoneCheckerMutation, SwitchPhoneCheckerMutationVariables>(SwitchPhoneCheckerDocument, options);
      }
export type SwitchPhoneCheckerMutationHookResult = ReturnType<typeof useSwitchPhoneCheckerMutation>;
export type SwitchPhoneCheckerMutationResult = Apollo.MutationResult<SwitchPhoneCheckerMutation>;
export type SwitchPhoneCheckerMutationOptions = Apollo.BaseMutationOptions<SwitchPhoneCheckerMutation, SwitchPhoneCheckerMutationVariables>;
export const PaymentRegistrationStepDocument = gql`
    mutation paymentRegistrationStep($price: String!, $paymentMethodId: String) {
  paymentRegistrationStep(price: $price, paymentMethodId: $paymentMethodId) {
    ...MemberResponse
  }
}
    ${MemberResponseFragmentDoc}`;
export type PaymentRegistrationStepMutationFn = Apollo.MutationFunction<PaymentRegistrationStepMutation, PaymentRegistrationStepMutationVariables>;

/**
 * __usePaymentRegistrationStepMutation__
 *
 * To run a mutation, you first call `usePaymentRegistrationStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentRegistrationStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentRegistrationStepMutation, { data, loading, error }] = usePaymentRegistrationStepMutation({
 *   variables: {
 *      price: // value for 'price'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function usePaymentRegistrationStepMutation(baseOptions?: Apollo.MutationHookOptions<PaymentRegistrationStepMutation, PaymentRegistrationStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentRegistrationStepMutation, PaymentRegistrationStepMutationVariables>(PaymentRegistrationStepDocument, options);
      }
export type PaymentRegistrationStepMutationHookResult = ReturnType<typeof usePaymentRegistrationStepMutation>;
export type PaymentRegistrationStepMutationResult = Apollo.MutationResult<PaymentRegistrationStepMutation>;
export type PaymentRegistrationStepMutationOptions = Apollo.BaseMutationOptions<PaymentRegistrationStepMutation, PaymentRegistrationStepMutationVariables>;
export const CarrierFeePayDocument = gql`
    mutation carrierFeePay($paymentMethodId: String) {
  carrierFeePay(paymentMethodId: $paymentMethodId) {
    ...OrganizationFragment
  }
}
    ${OrganizationFragmentFragmentDoc}`;
export type CarrierFeePayMutationFn = Apollo.MutationFunction<CarrierFeePayMutation, CarrierFeePayMutationVariables>;

/**
 * __useCarrierFeePayMutation__
 *
 * To run a mutation, you first call `useCarrierFeePayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCarrierFeePayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [carrierFeePayMutation, { data, loading, error }] = useCarrierFeePayMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useCarrierFeePayMutation(baseOptions?: Apollo.MutationHookOptions<CarrierFeePayMutation, CarrierFeePayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CarrierFeePayMutation, CarrierFeePayMutationVariables>(CarrierFeePayDocument, options);
      }
export type CarrierFeePayMutationHookResult = ReturnType<typeof useCarrierFeePayMutation>;
export type CarrierFeePayMutationResult = Apollo.MutationResult<CarrierFeePayMutation>;
export type CarrierFeePayMutationOptions = Apollo.BaseMutationOptions<CarrierFeePayMutation, CarrierFeePayMutationVariables>;
export const CheckMigrationStatusDocument = gql`
    query checkMigrationStatus {
  getMyOrganization {
    migrationStatus
  }
}
    `;

/**
 * __useCheckMigrationStatusQuery__
 *
 * To run a query within a React component, call `useCheckMigrationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckMigrationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckMigrationStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckMigrationStatusQuery(baseOptions?: Apollo.QueryHookOptions<CheckMigrationStatusQuery, CheckMigrationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckMigrationStatusQuery, CheckMigrationStatusQueryVariables>(CheckMigrationStatusDocument, options);
      }
export function useCheckMigrationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckMigrationStatusQuery, CheckMigrationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckMigrationStatusQuery, CheckMigrationStatusQueryVariables>(CheckMigrationStatusDocument, options);
        }
export type CheckMigrationStatusQueryHookResult = ReturnType<typeof useCheckMigrationStatusQuery>;
export type CheckMigrationStatusLazyQueryHookResult = ReturnType<typeof useCheckMigrationStatusLazyQuery>;
export type CheckMigrationStatusQueryResult = Apollo.QueryResult<CheckMigrationStatusQuery, CheckMigrationStatusQueryVariables>;
export const GetTypesDocument = gql`
    query getTypes {
  getBusinessProfileTypes {
    businessIndustryMapping
    businessTypeMapping
    businessOperationRegionMapping
    businessJobPositionMapping
    businessProfileStatusMapping
  }
  getTenDlcTypes {
    optInMethods
    businessTypes
    packageTypes
    stockExchanges
    useCaseTypes
    statusMap
  }
  getTollFreeVerificationProfileTypes {
    messageAmountMapping
    optInMethodMapping
    useCaseMapping
    verificationStatusMapping
    tollFreeVerificationStatusMapping
  }
}
    `;

/**
 * __useGetTypesQuery__
 *
 * To run a query within a React component, call `useGetTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetTypesQuery, GetTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTypesQuery, GetTypesQueryVariables>(GetTypesDocument, options);
      }
export function useGetTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTypesQuery, GetTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTypesQuery, GetTypesQueryVariables>(GetTypesDocument, options);
        }
export type GetTypesQueryHookResult = ReturnType<typeof useGetTypesQuery>;
export type GetTypesLazyQueryHookResult = ReturnType<typeof useGetTypesLazyQuery>;
export type GetTypesQueryResult = Apollo.QueryResult<GetTypesQuery, GetTypesQueryVariables>;
export const SearchBusinessGeneralInfoDocument = gql`
    query searchBusinessGeneralInfo($input: String!) {
  searchBusinessGeneralInfo(input: $input) {
    ...BusinessGeneralInfoEinResponseFragment
  }
}
    ${BusinessGeneralInfoEinResponseFragmentFragmentDoc}`;

/**
 * __useSearchBusinessGeneralInfoQuery__
 *
 * To run a query within a React component, call `useSearchBusinessGeneralInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchBusinessGeneralInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchBusinessGeneralInfoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchBusinessGeneralInfoQuery(baseOptions: Apollo.QueryHookOptions<SearchBusinessGeneralInfoQuery, SearchBusinessGeneralInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchBusinessGeneralInfoQuery, SearchBusinessGeneralInfoQueryVariables>(SearchBusinessGeneralInfoDocument, options);
      }
export function useSearchBusinessGeneralInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchBusinessGeneralInfoQuery, SearchBusinessGeneralInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchBusinessGeneralInfoQuery, SearchBusinessGeneralInfoQueryVariables>(SearchBusinessGeneralInfoDocument, options);
        }
export type SearchBusinessGeneralInfoQueryHookResult = ReturnType<typeof useSearchBusinessGeneralInfoQuery>;
export type SearchBusinessGeneralInfoLazyQueryHookResult = ReturnType<typeof useSearchBusinessGeneralInfoLazyQuery>;
export type SearchBusinessGeneralInfoQueryResult = Apollo.QueryResult<SearchBusinessGeneralInfoQuery, SearchBusinessGeneralInfoQueryVariables>;
export const GetFullBusinessProfileDocument = gql`
    query getFullBusinessProfile {
  getFullBusinessProfile {
    ...BusinessProfileResponseFragment
  }
}
    ${BusinessProfileResponseFragmentFragmentDoc}`;

/**
 * __useGetFullBusinessProfileQuery__
 *
 * To run a query within a React component, call `useGetFullBusinessProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullBusinessProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullBusinessProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFullBusinessProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetFullBusinessProfileQuery, GetFullBusinessProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFullBusinessProfileQuery, GetFullBusinessProfileQueryVariables>(GetFullBusinessProfileDocument, options);
      }
export function useGetFullBusinessProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFullBusinessProfileQuery, GetFullBusinessProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFullBusinessProfileQuery, GetFullBusinessProfileQueryVariables>(GetFullBusinessProfileDocument, options);
        }
export type GetFullBusinessProfileQueryHookResult = ReturnType<typeof useGetFullBusinessProfileQuery>;
export type GetFullBusinessProfileLazyQueryHookResult = ReturnType<typeof useGetFullBusinessProfileLazyQuery>;
export type GetFullBusinessProfileQueryResult = Apollo.QueryResult<GetFullBusinessProfileQuery, GetFullBusinessProfileQueryVariables>;
export const GetBusinessCountryStatesDocument = gql`
    query getBusinessCountryStates($countryCode: String!) {
  getBusinessCountryStates(countryCode: $countryCode)
}
    `;

/**
 * __useGetBusinessCountryStatesQuery__
 *
 * To run a query within a React component, call `useGetBusinessCountryStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessCountryStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessCountryStatesQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useGetBusinessCountryStatesQuery(baseOptions: Apollo.QueryHookOptions<GetBusinessCountryStatesQuery, GetBusinessCountryStatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessCountryStatesQuery, GetBusinessCountryStatesQueryVariables>(GetBusinessCountryStatesDocument, options);
      }
export function useGetBusinessCountryStatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessCountryStatesQuery, GetBusinessCountryStatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessCountryStatesQuery, GetBusinessCountryStatesQueryVariables>(GetBusinessCountryStatesDocument, options);
        }
export type GetBusinessCountryStatesQueryHookResult = ReturnType<typeof useGetBusinessCountryStatesQuery>;
export type GetBusinessCountryStatesLazyQueryHookResult = ReturnType<typeof useGetBusinessCountryStatesLazyQuery>;
export type GetBusinessCountryStatesQueryResult = Apollo.QueryResult<GetBusinessCountryStatesQuery, GetBusinessCountryStatesQueryVariables>;
export const RegisterBusinessProfileDocument = gql`
    mutation registerBusinessProfile($input: BusinessProfileRequestInput!) {
  registerBusinessProfile(input: $input) {
    ...BusinessProfileResponseFragment
  }
}
    ${BusinessProfileResponseFragmentFragmentDoc}`;
export type RegisterBusinessProfileMutationFn = Apollo.MutationFunction<RegisterBusinessProfileMutation, RegisterBusinessProfileMutationVariables>;

/**
 * __useRegisterBusinessProfileMutation__
 *
 * To run a mutation, you first call `useRegisterBusinessProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterBusinessProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerBusinessProfileMutation, { data, loading, error }] = useRegisterBusinessProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterBusinessProfileMutation(baseOptions?: Apollo.MutationHookOptions<RegisterBusinessProfileMutation, RegisterBusinessProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterBusinessProfileMutation, RegisterBusinessProfileMutationVariables>(RegisterBusinessProfileDocument, options);
      }
export type RegisterBusinessProfileMutationHookResult = ReturnType<typeof useRegisterBusinessProfileMutation>;
export type RegisterBusinessProfileMutationResult = Apollo.MutationResult<RegisterBusinessProfileMutation>;
export type RegisterBusinessProfileMutationOptions = Apollo.BaseMutationOptions<RegisterBusinessProfileMutation, RegisterBusinessProfileMutationVariables>;
export const InitCompanyTypeDocument = gql`
    mutation initCompanyType($hasEin: Boolean!) {
  initCompanyType(hasEin: $hasEin) {
    ...BusinessProfileResponseFragment
  }
}
    ${BusinessProfileResponseFragmentFragmentDoc}`;
export type InitCompanyTypeMutationFn = Apollo.MutationFunction<InitCompanyTypeMutation, InitCompanyTypeMutationVariables>;

/**
 * __useInitCompanyTypeMutation__
 *
 * To run a mutation, you first call `useInitCompanyTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitCompanyTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initCompanyTypeMutation, { data, loading, error }] = useInitCompanyTypeMutation({
 *   variables: {
 *      hasEin: // value for 'hasEin'
 *   },
 * });
 */
export function useInitCompanyTypeMutation(baseOptions?: Apollo.MutationHookOptions<InitCompanyTypeMutation, InitCompanyTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitCompanyTypeMutation, InitCompanyTypeMutationVariables>(InitCompanyTypeDocument, options);
      }
export type InitCompanyTypeMutationHookResult = ReturnType<typeof useInitCompanyTypeMutation>;
export type InitCompanyTypeMutationResult = Apollo.MutationResult<InitCompanyTypeMutation>;
export type InitCompanyTypeMutationOptions = Apollo.BaseMutationOptions<InitCompanyTypeMutation, InitCompanyTypeMutationVariables>;
export const BusinessProfilePreviousStepDocument = gql`
    mutation businessProfilePreviousStep {
  businessProfilePreviousStep {
    ...BusinessProfileResponseFragment
  }
}
    ${BusinessProfileResponseFragmentFragmentDoc}`;
export type BusinessProfilePreviousStepMutationFn = Apollo.MutationFunction<BusinessProfilePreviousStepMutation, BusinessProfilePreviousStepMutationVariables>;

/**
 * __useBusinessProfilePreviousStepMutation__
 *
 * To run a mutation, you first call `useBusinessProfilePreviousStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBusinessProfilePreviousStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [businessProfilePreviousStepMutation, { data, loading, error }] = useBusinessProfilePreviousStepMutation({
 *   variables: {
 *   },
 * });
 */
export function useBusinessProfilePreviousStepMutation(baseOptions?: Apollo.MutationHookOptions<BusinessProfilePreviousStepMutation, BusinessProfilePreviousStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BusinessProfilePreviousStepMutation, BusinessProfilePreviousStepMutationVariables>(BusinessProfilePreviousStepDocument, options);
      }
export type BusinessProfilePreviousStepMutationHookResult = ReturnType<typeof useBusinessProfilePreviousStepMutation>;
export type BusinessProfilePreviousStepMutationResult = Apollo.MutationResult<BusinessProfilePreviousStepMutation>;
export type BusinessProfilePreviousStepMutationOptions = Apollo.BaseMutationOptions<BusinessProfilePreviousStepMutation, BusinessProfilePreviousStepMutationVariables>;
export const InitBusinessGeneralInfoDocument = gql`
    mutation initBusinessGeneralInfo($input: BusinessGeneralInfoRequestInput!) {
  initBusinessGeneralInfo(input: $input) {
    ...BusinessProfileResponseFragment
  }
}
    ${BusinessProfileResponseFragmentFragmentDoc}`;
export type InitBusinessGeneralInfoMutationFn = Apollo.MutationFunction<InitBusinessGeneralInfoMutation, InitBusinessGeneralInfoMutationVariables>;

/**
 * __useInitBusinessGeneralInfoMutation__
 *
 * To run a mutation, you first call `useInitBusinessGeneralInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitBusinessGeneralInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initBusinessGeneralInfoMutation, { data, loading, error }] = useInitBusinessGeneralInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitBusinessGeneralInfoMutation(baseOptions?: Apollo.MutationHookOptions<InitBusinessGeneralInfoMutation, InitBusinessGeneralInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitBusinessGeneralInfoMutation, InitBusinessGeneralInfoMutationVariables>(InitBusinessGeneralInfoDocument, options);
      }
export type InitBusinessGeneralInfoMutationHookResult = ReturnType<typeof useInitBusinessGeneralInfoMutation>;
export type InitBusinessGeneralInfoMutationResult = Apollo.MutationResult<InitBusinessGeneralInfoMutation>;
export type InitBusinessGeneralInfoMutationOptions = Apollo.BaseMutationOptions<InitBusinessGeneralInfoMutation, InitBusinessGeneralInfoMutationVariables>;
export const InitBusinessInfoDocument = gql`
    mutation initBusinessInfo($input: BusinessInfoRequestInput!) {
  initBusinessInfo(input: $input) {
    ...BusinessProfileResponseFragment
  }
}
    ${BusinessProfileResponseFragmentFragmentDoc}`;
export type InitBusinessInfoMutationFn = Apollo.MutationFunction<InitBusinessInfoMutation, InitBusinessInfoMutationVariables>;

/**
 * __useInitBusinessInfoMutation__
 *
 * To run a mutation, you first call `useInitBusinessInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitBusinessInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initBusinessInfoMutation, { data, loading, error }] = useInitBusinessInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitBusinessInfoMutation(baseOptions?: Apollo.MutationHookOptions<InitBusinessInfoMutation, InitBusinessInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitBusinessInfoMutation, InitBusinessInfoMutationVariables>(InitBusinessInfoDocument, options);
      }
export type InitBusinessInfoMutationHookResult = ReturnType<typeof useInitBusinessInfoMutation>;
export type InitBusinessInfoMutationResult = Apollo.MutationResult<InitBusinessInfoMutation>;
export type InitBusinessInfoMutationOptions = Apollo.BaseMutationOptions<InitBusinessInfoMutation, InitBusinessInfoMutationVariables>;
export const InitBusinessAuthorizedUsersDocument = gql`
    mutation initBusinessAuthorizedUsers($input: [BusinessAuthorizedUserRequestInput]!) {
  initBusinessAuthorizedUsers(input: $input) {
    ...BusinessProfileResponseFragment
  }
}
    ${BusinessProfileResponseFragmentFragmentDoc}`;
export type InitBusinessAuthorizedUsersMutationFn = Apollo.MutationFunction<InitBusinessAuthorizedUsersMutation, InitBusinessAuthorizedUsersMutationVariables>;

/**
 * __useInitBusinessAuthorizedUsersMutation__
 *
 * To run a mutation, you first call `useInitBusinessAuthorizedUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitBusinessAuthorizedUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initBusinessAuthorizedUsersMutation, { data, loading, error }] = useInitBusinessAuthorizedUsersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitBusinessAuthorizedUsersMutation(baseOptions?: Apollo.MutationHookOptions<InitBusinessAuthorizedUsersMutation, InitBusinessAuthorizedUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitBusinessAuthorizedUsersMutation, InitBusinessAuthorizedUsersMutationVariables>(InitBusinessAuthorizedUsersDocument, options);
      }
export type InitBusinessAuthorizedUsersMutationHookResult = ReturnType<typeof useInitBusinessAuthorizedUsersMutation>;
export type InitBusinessAuthorizedUsersMutationResult = Apollo.MutationResult<InitBusinessAuthorizedUsersMutation>;
export type InitBusinessAuthorizedUsersMutationOptions = Apollo.BaseMutationOptions<InitBusinessAuthorizedUsersMutation, InitBusinessAuthorizedUsersMutationVariables>;
export const InitBusinessTermsDocument = gql`
    mutation initBusinessTerms {
  initBusinessTerms {
    ...BusinessProfileResponseFragment
  }
}
    ${BusinessProfileResponseFragmentFragmentDoc}`;
export type InitBusinessTermsMutationFn = Apollo.MutationFunction<InitBusinessTermsMutation, InitBusinessTermsMutationVariables>;

/**
 * __useInitBusinessTermsMutation__
 *
 * To run a mutation, you first call `useInitBusinessTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitBusinessTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initBusinessTermsMutation, { data, loading, error }] = useInitBusinessTermsMutation({
 *   variables: {
 *   },
 * });
 */
export function useInitBusinessTermsMutation(baseOptions?: Apollo.MutationHookOptions<InitBusinessTermsMutation, InitBusinessTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitBusinessTermsMutation, InitBusinessTermsMutationVariables>(InitBusinessTermsDocument, options);
      }
export type InitBusinessTermsMutationHookResult = ReturnType<typeof useInitBusinessTermsMutation>;
export type InitBusinessTermsMutationResult = Apollo.MutationResult<InitBusinessTermsMutation>;
export type InitBusinessTermsMutationOptions = Apollo.BaseMutationOptions<InitBusinessTermsMutation, InitBusinessTermsMutationVariables>;
export const InitBusinessGeneralInfoByEinDocument = gql`
    mutation initBusinessGeneralInfoByEin($ein: String!) {
  initBusinessGeneralInfoByEin(ein: $ein) {
    ...BusinessProfileResponseFragment
  }
}
    ${BusinessProfileResponseFragmentFragmentDoc}`;
export type InitBusinessGeneralInfoByEinMutationFn = Apollo.MutationFunction<InitBusinessGeneralInfoByEinMutation, InitBusinessGeneralInfoByEinMutationVariables>;

/**
 * __useInitBusinessGeneralInfoByEinMutation__
 *
 * To run a mutation, you first call `useInitBusinessGeneralInfoByEinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitBusinessGeneralInfoByEinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initBusinessGeneralInfoByEinMutation, { data, loading, error }] = useInitBusinessGeneralInfoByEinMutation({
 *   variables: {
 *      ein: // value for 'ein'
 *   },
 * });
 */
export function useInitBusinessGeneralInfoByEinMutation(baseOptions?: Apollo.MutationHookOptions<InitBusinessGeneralInfoByEinMutation, InitBusinessGeneralInfoByEinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitBusinessGeneralInfoByEinMutation, InitBusinessGeneralInfoByEinMutationVariables>(InitBusinessGeneralInfoByEinDocument, options);
      }
export type InitBusinessGeneralInfoByEinMutationHookResult = ReturnType<typeof useInitBusinessGeneralInfoByEinMutation>;
export type InitBusinessGeneralInfoByEinMutationResult = Apollo.MutationResult<InitBusinessGeneralInfoByEinMutation>;
export type InitBusinessGeneralInfoByEinMutationOptions = Apollo.BaseMutationOptions<InitBusinessGeneralInfoByEinMutation, InitBusinessGeneralInfoByEinMutationVariables>;
export const InitBusinessGeneralInfoByManualEinDocument = gql`
    mutation initBusinessGeneralInfoByManualEin($input: BusinessGeneralInfoEinRequestInput!) {
  initBusinessGeneralInfoByManualEin(input: $input) {
    ...BusinessProfileResponseFragment
  }
}
    ${BusinessProfileResponseFragmentFragmentDoc}`;
export type InitBusinessGeneralInfoByManualEinMutationFn = Apollo.MutationFunction<InitBusinessGeneralInfoByManualEinMutation, InitBusinessGeneralInfoByManualEinMutationVariables>;

/**
 * __useInitBusinessGeneralInfoByManualEinMutation__
 *
 * To run a mutation, you first call `useInitBusinessGeneralInfoByManualEinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitBusinessGeneralInfoByManualEinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initBusinessGeneralInfoByManualEinMutation, { data, loading, error }] = useInitBusinessGeneralInfoByManualEinMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitBusinessGeneralInfoByManualEinMutation(baseOptions?: Apollo.MutationHookOptions<InitBusinessGeneralInfoByManualEinMutation, InitBusinessGeneralInfoByManualEinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitBusinessGeneralInfoByManualEinMutation, InitBusinessGeneralInfoByManualEinMutationVariables>(InitBusinessGeneralInfoByManualEinDocument, options);
      }
export type InitBusinessGeneralInfoByManualEinMutationHookResult = ReturnType<typeof useInitBusinessGeneralInfoByManualEinMutation>;
export type InitBusinessGeneralInfoByManualEinMutationResult = Apollo.MutationResult<InitBusinessGeneralInfoByManualEinMutation>;
export type InitBusinessGeneralInfoByManualEinMutationOptions = Apollo.BaseMutationOptions<InitBusinessGeneralInfoByManualEinMutation, InitBusinessGeneralInfoByManualEinMutationVariables>;
export const GetFullTollFreeVerificationProfileDocument = gql`
    query getFullTollFreeVerificationProfile {
  getFullTollFreeVerificationProfile {
    ...TollFreeVerificationProfileFragment
  }
}
    ${TollFreeVerificationProfileFragmentFragmentDoc}`;

/**
 * __useGetFullTollFreeVerificationProfileQuery__
 *
 * To run a query within a React component, call `useGetFullTollFreeVerificationProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullTollFreeVerificationProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullTollFreeVerificationProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFullTollFreeVerificationProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetFullTollFreeVerificationProfileQuery, GetFullTollFreeVerificationProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFullTollFreeVerificationProfileQuery, GetFullTollFreeVerificationProfileQueryVariables>(GetFullTollFreeVerificationProfileDocument, options);
      }
export function useGetFullTollFreeVerificationProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFullTollFreeVerificationProfileQuery, GetFullTollFreeVerificationProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFullTollFreeVerificationProfileQuery, GetFullTollFreeVerificationProfileQueryVariables>(GetFullTollFreeVerificationProfileDocument, options);
        }
export type GetFullTollFreeVerificationProfileQueryHookResult = ReturnType<typeof useGetFullTollFreeVerificationProfileQuery>;
export type GetFullTollFreeVerificationProfileLazyQueryHookResult = ReturnType<typeof useGetFullTollFreeVerificationProfileLazyQuery>;
export type GetFullTollFreeVerificationProfileQueryResult = Apollo.QueryResult<GetFullTollFreeVerificationProfileQuery, GetFullTollFreeVerificationProfileQueryVariables>;
export const InitTollFreeVerificationProfileDocument = gql`
    mutation initTollFreeVerificationProfile($input: TollFreeVerificationRequestInput!) {
  initTollFreeVerificationProfile(input: $input) {
    ...TollFreeVerificationProfileFragment
  }
}
    ${TollFreeVerificationProfileFragmentFragmentDoc}`;
export type InitTollFreeVerificationProfileMutationFn = Apollo.MutationFunction<InitTollFreeVerificationProfileMutation, InitTollFreeVerificationProfileMutationVariables>;

/**
 * __useInitTollFreeVerificationProfileMutation__
 *
 * To run a mutation, you first call `useInitTollFreeVerificationProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitTollFreeVerificationProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initTollFreeVerificationProfileMutation, { data, loading, error }] = useInitTollFreeVerificationProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitTollFreeVerificationProfileMutation(baseOptions?: Apollo.MutationHookOptions<InitTollFreeVerificationProfileMutation, InitTollFreeVerificationProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitTollFreeVerificationProfileMutation, InitTollFreeVerificationProfileMutationVariables>(InitTollFreeVerificationProfileDocument, options);
      }
export type InitTollFreeVerificationProfileMutationHookResult = ReturnType<typeof useInitTollFreeVerificationProfileMutation>;
export type InitTollFreeVerificationProfileMutationResult = Apollo.MutationResult<InitTollFreeVerificationProfileMutation>;
export type InitTollFreeVerificationProfileMutationOptions = Apollo.BaseMutationOptions<InitTollFreeVerificationProfileMutation, InitTollFreeVerificationProfileMutationVariables>;
export const InitTfProfileBusinessInfoDocument = gql`
    mutation initTFProfileBusinessInfo($input: TFBusinessInfoRequestInput!) {
  initTFProfileBusinessInfo(input: $input) {
    ...TollFreeVerificationProfileFragment
  }
}
    ${TollFreeVerificationProfileFragmentFragmentDoc}`;
export type InitTfProfileBusinessInfoMutationFn = Apollo.MutationFunction<InitTfProfileBusinessInfoMutation, InitTfProfileBusinessInfoMutationVariables>;

/**
 * __useInitTfProfileBusinessInfoMutation__
 *
 * To run a mutation, you first call `useInitTfProfileBusinessInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitTfProfileBusinessInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initTfProfileBusinessInfoMutation, { data, loading, error }] = useInitTfProfileBusinessInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitTfProfileBusinessInfoMutation(baseOptions?: Apollo.MutationHookOptions<InitTfProfileBusinessInfoMutation, InitTfProfileBusinessInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitTfProfileBusinessInfoMutation, InitTfProfileBusinessInfoMutationVariables>(InitTfProfileBusinessInfoDocument, options);
      }
export type InitTfProfileBusinessInfoMutationHookResult = ReturnType<typeof useInitTfProfileBusinessInfoMutation>;
export type InitTfProfileBusinessInfoMutationResult = Apollo.MutationResult<InitTfProfileBusinessInfoMutation>;
export type InitTfProfileBusinessInfoMutationOptions = Apollo.BaseMutationOptions<InitTfProfileBusinessInfoMutation, InitTfProfileBusinessInfoMutationVariables>;
export const InitTfProfileContactInfoDocument = gql`
    mutation initTFProfileContactInfo($input: ContactInfoRequestInput!) {
  initTFProfileContactInfo(input: $input) {
    ...TollFreeVerificationProfileFragment
  }
}
    ${TollFreeVerificationProfileFragmentFragmentDoc}`;
export type InitTfProfileContactInfoMutationFn = Apollo.MutationFunction<InitTfProfileContactInfoMutation, InitTfProfileContactInfoMutationVariables>;

/**
 * __useInitTfProfileContactInfoMutation__
 *
 * To run a mutation, you first call `useInitTfProfileContactInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitTfProfileContactInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initTfProfileContactInfoMutation, { data, loading, error }] = useInitTfProfileContactInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitTfProfileContactInfoMutation(baseOptions?: Apollo.MutationHookOptions<InitTfProfileContactInfoMutation, InitTfProfileContactInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitTfProfileContactInfoMutation, InitTfProfileContactInfoMutationVariables>(InitTfProfileContactInfoDocument, options);
      }
export type InitTfProfileContactInfoMutationHookResult = ReturnType<typeof useInitTfProfileContactInfoMutation>;
export type InitTfProfileContactInfoMutationResult = Apollo.MutationResult<InitTfProfileContactInfoMutation>;
export type InitTfProfileContactInfoMutationOptions = Apollo.BaseMutationOptions<InitTfProfileContactInfoMutation, InitTfProfileContactInfoMutationVariables>;
export const InitTollFreeVerificationUseCaseDocument = gql`
    mutation initTollFreeVerificationUseCase($input: TollFreeVerificationUseCaseRequestInput!) {
  initTollFreeVerificationUseCase(input: $input) {
    ...TollFreeVerificationProfileFragment
  }
}
    ${TollFreeVerificationProfileFragmentFragmentDoc}`;
export type InitTollFreeVerificationUseCaseMutationFn = Apollo.MutationFunction<InitTollFreeVerificationUseCaseMutation, InitTollFreeVerificationUseCaseMutationVariables>;

/**
 * __useInitTollFreeVerificationUseCaseMutation__
 *
 * To run a mutation, you first call `useInitTollFreeVerificationUseCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitTollFreeVerificationUseCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initTollFreeVerificationUseCaseMutation, { data, loading, error }] = useInitTollFreeVerificationUseCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitTollFreeVerificationUseCaseMutation(baseOptions?: Apollo.MutationHookOptions<InitTollFreeVerificationUseCaseMutation, InitTollFreeVerificationUseCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitTollFreeVerificationUseCaseMutation, InitTollFreeVerificationUseCaseMutationVariables>(InitTollFreeVerificationUseCaseDocument, options);
      }
export type InitTollFreeVerificationUseCaseMutationHookResult = ReturnType<typeof useInitTollFreeVerificationUseCaseMutation>;
export type InitTollFreeVerificationUseCaseMutationResult = Apollo.MutationResult<InitTollFreeVerificationUseCaseMutation>;
export type InitTollFreeVerificationUseCaseMutationOptions = Apollo.BaseMutationOptions<InitTollFreeVerificationUseCaseMutation, InitTollFreeVerificationUseCaseMutationVariables>;
export const InitTollFreeVerificationOptInMethodDocument = gql`
    mutation initTollFreeVerificationOptInMethod($input: TollFreeVerificationOptInMethodRequestInput!) {
  initTollFreeVerificationOptInMethod(input: $input) {
    ...TollFreeVerificationProfileFragment
  }
}
    ${TollFreeVerificationProfileFragmentFragmentDoc}`;
export type InitTollFreeVerificationOptInMethodMutationFn = Apollo.MutationFunction<InitTollFreeVerificationOptInMethodMutation, InitTollFreeVerificationOptInMethodMutationVariables>;

/**
 * __useInitTollFreeVerificationOptInMethodMutation__
 *
 * To run a mutation, you first call `useInitTollFreeVerificationOptInMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitTollFreeVerificationOptInMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initTollFreeVerificationOptInMethodMutation, { data, loading, error }] = useInitTollFreeVerificationOptInMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitTollFreeVerificationOptInMethodMutation(baseOptions?: Apollo.MutationHookOptions<InitTollFreeVerificationOptInMethodMutation, InitTollFreeVerificationOptInMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitTollFreeVerificationOptInMethodMutation, InitTollFreeVerificationOptInMethodMutationVariables>(InitTollFreeVerificationOptInMethodDocument, options);
      }
export type InitTollFreeVerificationOptInMethodMutationHookResult = ReturnType<typeof useInitTollFreeVerificationOptInMethodMutation>;
export type InitTollFreeVerificationOptInMethodMutationResult = Apollo.MutationResult<InitTollFreeVerificationOptInMethodMutation>;
export type InitTollFreeVerificationOptInMethodMutationOptions = Apollo.BaseMutationOptions<InitTollFreeVerificationOptInMethodMutation, InitTollFreeVerificationOptInMethodMutationVariables>;
export const InitTollFreeVerificationTermsDocument = gql`
    mutation initTollFreeVerificationTerms {
  initTollFreeVerificationTerms {
    ...TollFreeVerificationProfileFragment
  }
}
    ${TollFreeVerificationProfileFragmentFragmentDoc}`;
export type InitTollFreeVerificationTermsMutationFn = Apollo.MutationFunction<InitTollFreeVerificationTermsMutation, InitTollFreeVerificationTermsMutationVariables>;

/**
 * __useInitTollFreeVerificationTermsMutation__
 *
 * To run a mutation, you first call `useInitTollFreeVerificationTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitTollFreeVerificationTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initTollFreeVerificationTermsMutation, { data, loading, error }] = useInitTollFreeVerificationTermsMutation({
 *   variables: {
 *   },
 * });
 */
export function useInitTollFreeVerificationTermsMutation(baseOptions?: Apollo.MutationHookOptions<InitTollFreeVerificationTermsMutation, InitTollFreeVerificationTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitTollFreeVerificationTermsMutation, InitTollFreeVerificationTermsMutationVariables>(InitTollFreeVerificationTermsDocument, options);
      }
export type InitTollFreeVerificationTermsMutationHookResult = ReturnType<typeof useInitTollFreeVerificationTermsMutation>;
export type InitTollFreeVerificationTermsMutationResult = Apollo.MutationResult<InitTollFreeVerificationTermsMutation>;
export type InitTollFreeVerificationTermsMutationOptions = Apollo.BaseMutationOptions<InitTollFreeVerificationTermsMutation, InitTollFreeVerificationTermsMutationVariables>;
export const TollFreeVerificationProfilePreviousStepDocument = gql`
    mutation tollFreeVerificationProfilePreviousStep {
  tollFreeVerificationProfilePreviousStep {
    ...TollFreeVerificationProfileFragment
  }
}
    ${TollFreeVerificationProfileFragmentFragmentDoc}`;
export type TollFreeVerificationProfilePreviousStepMutationFn = Apollo.MutationFunction<TollFreeVerificationProfilePreviousStepMutation, TollFreeVerificationProfilePreviousStepMutationVariables>;

/**
 * __useTollFreeVerificationProfilePreviousStepMutation__
 *
 * To run a mutation, you first call `useTollFreeVerificationProfilePreviousStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTollFreeVerificationProfilePreviousStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tollFreeVerificationProfilePreviousStepMutation, { data, loading, error }] = useTollFreeVerificationProfilePreviousStepMutation({
 *   variables: {
 *   },
 * });
 */
export function useTollFreeVerificationProfilePreviousStepMutation(baseOptions?: Apollo.MutationHookOptions<TollFreeVerificationProfilePreviousStepMutation, TollFreeVerificationProfilePreviousStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TollFreeVerificationProfilePreviousStepMutation, TollFreeVerificationProfilePreviousStepMutationVariables>(TollFreeVerificationProfilePreviousStepDocument, options);
      }
export type TollFreeVerificationProfilePreviousStepMutationHookResult = ReturnType<typeof useTollFreeVerificationProfilePreviousStepMutation>;
export type TollFreeVerificationProfilePreviousStepMutationResult = Apollo.MutationResult<TollFreeVerificationProfilePreviousStepMutation>;
export type TollFreeVerificationProfilePreviousStepMutationOptions = Apollo.BaseMutationOptions<TollFreeVerificationProfilePreviousStepMutation, TollFreeVerificationProfilePreviousStepMutationVariables>;
export const GetFullTenDlcProfileDocument = gql`
    query getFullTenDlcProfile {
  getFullTenDlcProfile {
    ...TenDlcProfileResponse
  }
}
    ${TenDlcProfileResponseFragmentDoc}`;

/**
 * __useGetFullTenDlcProfileQuery__
 *
 * To run a query within a React component, call `useGetFullTenDlcProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullTenDlcProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullTenDlcProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFullTenDlcProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetFullTenDlcProfileQuery, GetFullTenDlcProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFullTenDlcProfileQuery, GetFullTenDlcProfileQueryVariables>(GetFullTenDlcProfileDocument, options);
      }
export function useGetFullTenDlcProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFullTenDlcProfileQuery, GetFullTenDlcProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFullTenDlcProfileQuery, GetFullTenDlcProfileQueryVariables>(GetFullTenDlcProfileDocument, options);
        }
export type GetFullTenDlcProfileQueryHookResult = ReturnType<typeof useGetFullTenDlcProfileQuery>;
export type GetFullTenDlcProfileLazyQueryHookResult = ReturnType<typeof useGetFullTenDlcProfileLazyQuery>;
export type GetFullTenDlcProfileQueryResult = Apollo.QueryResult<GetFullTenDlcProfileQuery, GetFullTenDlcProfileQueryVariables>;
export const InitPackageTenDlcDocument = gql`
    mutation initPackageTenDlc($input: TenDlcSelectPackageRequestInput!) {
  initPackageTenDlc(input: $input) {
    ...TenDlcProfileResponse
  }
}
    ${TenDlcProfileResponseFragmentDoc}`;
export type InitPackageTenDlcMutationFn = Apollo.MutationFunction<InitPackageTenDlcMutation, InitPackageTenDlcMutationVariables>;

/**
 * __useInitPackageTenDlcMutation__
 *
 * To run a mutation, you first call `useInitPackageTenDlcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitPackageTenDlcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initPackageTenDlcMutation, { data, loading, error }] = useInitPackageTenDlcMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitPackageTenDlcMutation(baseOptions?: Apollo.MutationHookOptions<InitPackageTenDlcMutation, InitPackageTenDlcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitPackageTenDlcMutation, InitPackageTenDlcMutationVariables>(InitPackageTenDlcDocument, options);
      }
export type InitPackageTenDlcMutationHookResult = ReturnType<typeof useInitPackageTenDlcMutation>;
export type InitPackageTenDlcMutationResult = Apollo.MutationResult<InitPackageTenDlcMutation>;
export type InitPackageTenDlcMutationOptions = Apollo.BaseMutationOptions<InitPackageTenDlcMutation, InitPackageTenDlcMutationVariables>;
export const InitUseCaseTenDlcDocument = gql`
    mutation initUseCaseTenDlc($input: TenDlcUseCaseRequestInput!) {
  initUseCaseTenDlc(input: $input) {
    ...TenDlcProfileResponse
  }
}
    ${TenDlcProfileResponseFragmentDoc}`;
export type InitUseCaseTenDlcMutationFn = Apollo.MutationFunction<InitUseCaseTenDlcMutation, InitUseCaseTenDlcMutationVariables>;

/**
 * __useInitUseCaseTenDlcMutation__
 *
 * To run a mutation, you first call `useInitUseCaseTenDlcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitUseCaseTenDlcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initUseCaseTenDlcMutation, { data, loading, error }] = useInitUseCaseTenDlcMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitUseCaseTenDlcMutation(baseOptions?: Apollo.MutationHookOptions<InitUseCaseTenDlcMutation, InitUseCaseTenDlcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitUseCaseTenDlcMutation, InitUseCaseTenDlcMutationVariables>(InitUseCaseTenDlcDocument, options);
      }
export type InitUseCaseTenDlcMutationHookResult = ReturnType<typeof useInitUseCaseTenDlcMutation>;
export type InitUseCaseTenDlcMutationResult = Apollo.MutationResult<InitUseCaseTenDlcMutation>;
export type InitUseCaseTenDlcMutationOptions = Apollo.BaseMutationOptions<InitUseCaseTenDlcMutation, InitUseCaseTenDlcMutationVariables>;
export const InitOptInMethodTenDlcDocument = gql`
    mutation initOptInMethodTenDlc($input: TenDlcOptInMethodRequestInput!) {
  initOptInMethodTenDlc(input: $input) {
    ...TenDlcProfileResponse
  }
}
    ${TenDlcProfileResponseFragmentDoc}`;
export type InitOptInMethodTenDlcMutationFn = Apollo.MutationFunction<InitOptInMethodTenDlcMutation, InitOptInMethodTenDlcMutationVariables>;

/**
 * __useInitOptInMethodTenDlcMutation__
 *
 * To run a mutation, you first call `useInitOptInMethodTenDlcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitOptInMethodTenDlcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initOptInMethodTenDlcMutation, { data, loading, error }] = useInitOptInMethodTenDlcMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitOptInMethodTenDlcMutation(baseOptions?: Apollo.MutationHookOptions<InitOptInMethodTenDlcMutation, InitOptInMethodTenDlcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitOptInMethodTenDlcMutation, InitOptInMethodTenDlcMutationVariables>(InitOptInMethodTenDlcDocument, options);
      }
export type InitOptInMethodTenDlcMutationHookResult = ReturnType<typeof useInitOptInMethodTenDlcMutation>;
export type InitOptInMethodTenDlcMutationResult = Apollo.MutationResult<InitOptInMethodTenDlcMutation>;
export type InitOptInMethodTenDlcMutationOptions = Apollo.BaseMutationOptions<InitOptInMethodTenDlcMutation, InitOptInMethodTenDlcMutationVariables>;
export const InitOptInDescriptionTenDlcDocument = gql`
    mutation initOptInDescriptionTenDlc($input: TenDlcOptInDescriptionRequestInput!) {
  initOptInDescriptionTenDlc(input: $input) {
    ...TenDlcProfileResponse
  }
}
    ${TenDlcProfileResponseFragmentDoc}`;
export type InitOptInDescriptionTenDlcMutationFn = Apollo.MutationFunction<InitOptInDescriptionTenDlcMutation, InitOptInDescriptionTenDlcMutationVariables>;

/**
 * __useInitOptInDescriptionTenDlcMutation__
 *
 * To run a mutation, you first call `useInitOptInDescriptionTenDlcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitOptInDescriptionTenDlcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initOptInDescriptionTenDlcMutation, { data, loading, error }] = useInitOptInDescriptionTenDlcMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitOptInDescriptionTenDlcMutation(baseOptions?: Apollo.MutationHookOptions<InitOptInDescriptionTenDlcMutation, InitOptInDescriptionTenDlcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitOptInDescriptionTenDlcMutation, InitOptInDescriptionTenDlcMutationVariables>(InitOptInDescriptionTenDlcDocument, options);
      }
export type InitOptInDescriptionTenDlcMutationHookResult = ReturnType<typeof useInitOptInDescriptionTenDlcMutation>;
export type InitOptInDescriptionTenDlcMutationResult = Apollo.MutationResult<InitOptInDescriptionTenDlcMutation>;
export type InitOptInDescriptionTenDlcMutationOptions = Apollo.BaseMutationOptions<InitOptInDescriptionTenDlcMutation, InitOptInDescriptionTenDlcMutationVariables>;
export const InitOptInImageTenDlcDocument = gql`
    mutation initOptInImageTenDlc($input: TenDlcOptInImagesRequestInput!) {
  initOptInImageTenDlc(input: $input) {
    ...TenDlcProfileResponse
  }
}
    ${TenDlcProfileResponseFragmentDoc}`;
export type InitOptInImageTenDlcMutationFn = Apollo.MutationFunction<InitOptInImageTenDlcMutation, InitOptInImageTenDlcMutationVariables>;

/**
 * __useInitOptInImageTenDlcMutation__
 *
 * To run a mutation, you first call `useInitOptInImageTenDlcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitOptInImageTenDlcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initOptInImageTenDlcMutation, { data, loading, error }] = useInitOptInImageTenDlcMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitOptInImageTenDlcMutation(baseOptions?: Apollo.MutationHookOptions<InitOptInImageTenDlcMutation, InitOptInImageTenDlcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitOptInImageTenDlcMutation, InitOptInImageTenDlcMutationVariables>(InitOptInImageTenDlcDocument, options);
      }
export type InitOptInImageTenDlcMutationHookResult = ReturnType<typeof useInitOptInImageTenDlcMutation>;
export type InitOptInImageTenDlcMutationResult = Apollo.MutationResult<InitOptInImageTenDlcMutation>;
export type InitOptInImageTenDlcMutationOptions = Apollo.BaseMutationOptions<InitOptInImageTenDlcMutation, InitOptInImageTenDlcMutationVariables>;
export const InitMessageSampleTenDlcDocument = gql`
    mutation initMessageSampleTenDlc($input: TenDlcMessageSampleRequestInput!) {
  initMessageSampleTenDlc(input: $input) {
    ...TenDlcProfileResponse
  }
}
    ${TenDlcProfileResponseFragmentDoc}`;
export type InitMessageSampleTenDlcMutationFn = Apollo.MutationFunction<InitMessageSampleTenDlcMutation, InitMessageSampleTenDlcMutationVariables>;

/**
 * __useInitMessageSampleTenDlcMutation__
 *
 * To run a mutation, you first call `useInitMessageSampleTenDlcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitMessageSampleTenDlcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initMessageSampleTenDlcMutation, { data, loading, error }] = useInitMessageSampleTenDlcMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitMessageSampleTenDlcMutation(baseOptions?: Apollo.MutationHookOptions<InitMessageSampleTenDlcMutation, InitMessageSampleTenDlcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitMessageSampleTenDlcMutation, InitMessageSampleTenDlcMutationVariables>(InitMessageSampleTenDlcDocument, options);
      }
export type InitMessageSampleTenDlcMutationHookResult = ReturnType<typeof useInitMessageSampleTenDlcMutation>;
export type InitMessageSampleTenDlcMutationResult = Apollo.MutationResult<InitMessageSampleTenDlcMutation>;
export type InitMessageSampleTenDlcMutationOptions = Apollo.BaseMutationOptions<InitMessageSampleTenDlcMutation, InitMessageSampleTenDlcMutationVariables>;
export const CompleteTenDlcDocument = gql`
    mutation completeTenDlc($paymentMethodId: String!) {
  completeTenDlc(paymentMethodId: $paymentMethodId) {
    ...TenDlcProfileResponse
  }
}
    ${TenDlcProfileResponseFragmentDoc}`;
export type CompleteTenDlcMutationFn = Apollo.MutationFunction<CompleteTenDlcMutation, CompleteTenDlcMutationVariables>;

/**
 * __useCompleteTenDlcMutation__
 *
 * To run a mutation, you first call `useCompleteTenDlcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteTenDlcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeTenDlcMutation, { data, loading, error }] = useCompleteTenDlcMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useCompleteTenDlcMutation(baseOptions?: Apollo.MutationHookOptions<CompleteTenDlcMutation, CompleteTenDlcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteTenDlcMutation, CompleteTenDlcMutationVariables>(CompleteTenDlcDocument, options);
      }
export type CompleteTenDlcMutationHookResult = ReturnType<typeof useCompleteTenDlcMutation>;
export type CompleteTenDlcMutationResult = Apollo.MutationResult<CompleteTenDlcMutation>;
export type CompleteTenDlcMutationOptions = Apollo.BaseMutationOptions<CompleteTenDlcMutation, CompleteTenDlcMutationVariables>;
export const PreviousStepTenDlcDocument = gql`
    mutation previousStepTenDlc {
  previousStepTenDlc {
    ...TenDlcProfileResponse
  }
}
    ${TenDlcProfileResponseFragmentDoc}`;
export type PreviousStepTenDlcMutationFn = Apollo.MutationFunction<PreviousStepTenDlcMutation, PreviousStepTenDlcMutationVariables>;

/**
 * __usePreviousStepTenDlcMutation__
 *
 * To run a mutation, you first call `usePreviousStepTenDlcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviousStepTenDlcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previousStepTenDlcMutation, { data, loading, error }] = usePreviousStepTenDlcMutation({
 *   variables: {
 *   },
 * });
 */
export function usePreviousStepTenDlcMutation(baseOptions?: Apollo.MutationHookOptions<PreviousStepTenDlcMutation, PreviousStepTenDlcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreviousStepTenDlcMutation, PreviousStepTenDlcMutationVariables>(PreviousStepTenDlcDocument, options);
      }
export type PreviousStepTenDlcMutationHookResult = ReturnType<typeof usePreviousStepTenDlcMutation>;
export type PreviousStepTenDlcMutationResult = Apollo.MutationResult<PreviousStepTenDlcMutation>;
export type PreviousStepTenDlcMutationOptions = Apollo.BaseMutationOptions<PreviousStepTenDlcMutation, PreviousStepTenDlcMutationVariables>;
export const CreateConversionDocument = gql`
    mutation createConversion($conversion: UpdateConversionRequestInput) {
  createConversion(conversion: $conversion) {
    ...ConversionResponse
  }
}
    ${ConversionResponseFragmentDoc}`;
export type CreateConversionMutationFn = Apollo.MutationFunction<CreateConversionMutation, CreateConversionMutationVariables>;

/**
 * __useCreateConversionMutation__
 *
 * To run a mutation, you first call `useCreateConversionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConversionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConversionMutation, { data, loading, error }] = useCreateConversionMutation({
 *   variables: {
 *      conversion: // value for 'conversion'
 *   },
 * });
 */
export function useCreateConversionMutation(baseOptions?: Apollo.MutationHookOptions<CreateConversionMutation, CreateConversionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConversionMutation, CreateConversionMutationVariables>(CreateConversionDocument, options);
      }
export type CreateConversionMutationHookResult = ReturnType<typeof useCreateConversionMutation>;
export type CreateConversionMutationResult = Apollo.MutationResult<CreateConversionMutation>;
export type CreateConversionMutationOptions = Apollo.BaseMutationOptions<CreateConversionMutation, CreateConversionMutationVariables>;
export const UpdateConversionDocument = gql`
    mutation updateConversion($conversion: UpdateConversionRequestInput) {
  updateConversion(conversion: $conversion) {
    ...ConversionResponse
  }
}
    ${ConversionResponseFragmentDoc}`;
export type UpdateConversionMutationFn = Apollo.MutationFunction<UpdateConversionMutation, UpdateConversionMutationVariables>;

/**
 * __useUpdateConversionMutation__
 *
 * To run a mutation, you first call `useUpdateConversionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConversionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConversionMutation, { data, loading, error }] = useUpdateConversionMutation({
 *   variables: {
 *      conversion: // value for 'conversion'
 *   },
 * });
 */
export function useUpdateConversionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConversionMutation, UpdateConversionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConversionMutation, UpdateConversionMutationVariables>(UpdateConversionDocument, options);
      }
export type UpdateConversionMutationHookResult = ReturnType<typeof useUpdateConversionMutation>;
export type UpdateConversionMutationResult = Apollo.MutationResult<UpdateConversionMutation>;
export type UpdateConversionMutationOptions = Apollo.BaseMutationOptions<UpdateConversionMutation, UpdateConversionMutationVariables>;
export const DeleteConversionsDocument = gql`
    mutation deleteConversions($conversionIds: [Long]!) {
  deleteConversions(conversionIds: $conversionIds)
}
    `;
export type DeleteConversionsMutationFn = Apollo.MutationFunction<DeleteConversionsMutation, DeleteConversionsMutationVariables>;

/**
 * __useDeleteConversionsMutation__
 *
 * To run a mutation, you first call `useDeleteConversionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConversionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConversionsMutation, { data, loading, error }] = useDeleteConversionsMutation({
 *   variables: {
 *      conversionIds: // value for 'conversionIds'
 *   },
 * });
 */
export function useDeleteConversionsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteConversionsMutation, DeleteConversionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteConversionsMutation, DeleteConversionsMutationVariables>(DeleteConversionsDocument, options);
      }
export type DeleteConversionsMutationHookResult = ReturnType<typeof useDeleteConversionsMutation>;
export type DeleteConversionsMutationResult = Apollo.MutationResult<DeleteConversionsMutation>;
export type DeleteConversionsMutationOptions = Apollo.BaseMutationOptions<DeleteConversionsMutation, DeleteConversionsMutationVariables>;
export const GetConversionsDocument = gql`
    query getConversions($page: PaginationInput, $dateRange: DateRangeCriteriaInput, $searchPattern: String) {
  getConversions(
    page: $page
    dateRange: $dateRange
    searchPattern: $searchPattern
  ) {
    total
    pageNumber
    pageSize
    content {
      ...ConversionResponseList
    }
  }
}
    ${ConversionResponseListFragmentDoc}`;

/**
 * __useGetConversionsQuery__
 *
 * To run a query within a React component, call `useGetConversionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      dateRange: // value for 'dateRange'
 *      searchPattern: // value for 'searchPattern'
 *   },
 * });
 */
export function useGetConversionsQuery(baseOptions?: Apollo.QueryHookOptions<GetConversionsQuery, GetConversionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversionsQuery, GetConversionsQueryVariables>(GetConversionsDocument, options);
      }
export function useGetConversionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversionsQuery, GetConversionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversionsQuery, GetConversionsQueryVariables>(GetConversionsDocument, options);
        }
export type GetConversionsQueryHookResult = ReturnType<typeof useGetConversionsQuery>;
export type GetConversionsLazyQueryHookResult = ReturnType<typeof useGetConversionsLazyQuery>;
export type GetConversionsQueryResult = Apollo.QueryResult<GetConversionsQuery, GetConversionsQueryVariables>;
export const GetConversionsTotalStatisticsDocument = gql`
    query getConversionsTotalStatistics($dateRange: DateRangeCriteriaInput) {
  getConversionsTotalStatistics(dateRange: $dateRange) {
    total
    revenue
    totalCosts
    roi
    percentage
  }
}
    `;

/**
 * __useGetConversionsTotalStatisticsQuery__
 *
 * To run a query within a React component, call `useGetConversionsTotalStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversionsTotalStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversionsTotalStatisticsQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetConversionsTotalStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<GetConversionsTotalStatisticsQuery, GetConversionsTotalStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversionsTotalStatisticsQuery, GetConversionsTotalStatisticsQueryVariables>(GetConversionsTotalStatisticsDocument, options);
      }
export function useGetConversionsTotalStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversionsTotalStatisticsQuery, GetConversionsTotalStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversionsTotalStatisticsQuery, GetConversionsTotalStatisticsQueryVariables>(GetConversionsTotalStatisticsDocument, options);
        }
export type GetConversionsTotalStatisticsQueryHookResult = ReturnType<typeof useGetConversionsTotalStatisticsQuery>;
export type GetConversionsTotalStatisticsLazyQueryHookResult = ReturnType<typeof useGetConversionsTotalStatisticsLazyQuery>;
export type GetConversionsTotalStatisticsQueryResult = Apollo.QueryResult<GetConversionsTotalStatisticsQuery, GetConversionsTotalStatisticsQueryVariables>;
export const GetConversionDocument = gql`
    query getConversion($conversionId: Long) {
  getConversion(conversionId: $conversionId) {
    ...ConversionResponse
  }
}
    ${ConversionResponseFragmentDoc}`;

/**
 * __useGetConversionQuery__
 *
 * To run a query within a React component, call `useGetConversionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversionQuery({
 *   variables: {
 *      conversionId: // value for 'conversionId'
 *   },
 * });
 */
export function useGetConversionQuery(baseOptions?: Apollo.QueryHookOptions<GetConversionQuery, GetConversionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversionQuery, GetConversionQueryVariables>(GetConversionDocument, options);
      }
export function useGetConversionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversionQuery, GetConversionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversionQuery, GetConversionQueryVariables>(GetConversionDocument, options);
        }
export type GetConversionQueryHookResult = ReturnType<typeof useGetConversionQuery>;
export type GetConversionLazyQueryHookResult = ReturnType<typeof useGetConversionLazyQuery>;
export type GetConversionQueryResult = Apollo.QueryResult<GetConversionQuery, GetConversionQueryVariables>;
export const GetConversionStatisticsDocument = gql`
    query getConversionStatistics($conversionId: Long, $dateRange: DateRangeCriteriaInput) {
  getConversionStatistics(conversionId: $conversionId, dateRange: $dateRange) {
    totalCosts
    revenue
    roi
    percentage
    total
  }
}
    `;

/**
 * __useGetConversionStatisticsQuery__
 *
 * To run a query within a React component, call `useGetConversionStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversionStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversionStatisticsQuery({
 *   variables: {
 *      conversionId: // value for 'conversionId'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetConversionStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<GetConversionStatisticsQuery, GetConversionStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversionStatisticsQuery, GetConversionStatisticsQueryVariables>(GetConversionStatisticsDocument, options);
      }
export function useGetConversionStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversionStatisticsQuery, GetConversionStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversionStatisticsQuery, GetConversionStatisticsQueryVariables>(GetConversionStatisticsDocument, options);
        }
export type GetConversionStatisticsQueryHookResult = ReturnType<typeof useGetConversionStatisticsQuery>;
export type GetConversionStatisticsLazyQueryHookResult = ReturnType<typeof useGetConversionStatisticsLazyQuery>;
export type GetConversionStatisticsQueryResult = Apollo.QueryResult<GetConversionStatisticsQuery, GetConversionStatisticsQueryVariables>;
export const GetConversionHitsDocument = gql`
    query getConversionHits($conversionId: Long, $dateRange: DateRangeCriteriaInput, $page: PaginationInput) {
  getConversionHits(
    conversionId: $conversionId
    dateRange: $dateRange
    page: $page
  ) {
    total
    pageSize
    pageNumber
    content {
      id
      name
      date
      amount
      phone
    }
  }
}
    `;

/**
 * __useGetConversionHitsQuery__
 *
 * To run a query within a React component, call `useGetConversionHitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversionHitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversionHitsQuery({
 *   variables: {
 *      conversionId: // value for 'conversionId'
 *      dateRange: // value for 'dateRange'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetConversionHitsQuery(baseOptions?: Apollo.QueryHookOptions<GetConversionHitsQuery, GetConversionHitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversionHitsQuery, GetConversionHitsQueryVariables>(GetConversionHitsDocument, options);
      }
export function useGetConversionHitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversionHitsQuery, GetConversionHitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversionHitsQuery, GetConversionHitsQueryVariables>(GetConversionHitsDocument, options);
        }
export type GetConversionHitsQueryHookResult = ReturnType<typeof useGetConversionHitsQuery>;
export type GetConversionHitsLazyQueryHookResult = ReturnType<typeof useGetConversionHitsLazyQuery>;
export type GetConversionHitsQueryResult = Apollo.QueryResult<GetConversionHitsQuery, GetConversionHitsQueryVariables>;
export const GetIntegrationsDocument = gql`
    query getIntegrations {
  getIntegrations {
    ...AccountIntegrationsFragment
  }
}
    ${AccountIntegrationsFragmentFragmentDoc}`;

/**
 * __useGetIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
      }
export function useGetIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
        }
export type GetIntegrationsQueryHookResult = ReturnType<typeof useGetIntegrationsQuery>;
export type GetIntegrationsLazyQueryHookResult = ReturnType<typeof useGetIntegrationsLazyQuery>;
export type GetIntegrationsQueryResult = Apollo.QueryResult<GetIntegrationsQuery, GetIntegrationsQueryVariables>;
export const GetContactWebhookUrlDocument = gql`
    query getContactWebhookUrl {
  getContactWebhookUrl
}
    `;

/**
 * __useGetContactWebhookUrlQuery__
 *
 * To run a query within a React component, call `useGetContactWebhookUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactWebhookUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactWebhookUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContactWebhookUrlQuery(baseOptions?: Apollo.QueryHookOptions<GetContactWebhookUrlQuery, GetContactWebhookUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactWebhookUrlQuery, GetContactWebhookUrlQueryVariables>(GetContactWebhookUrlDocument, options);
      }
export function useGetContactWebhookUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactWebhookUrlQuery, GetContactWebhookUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactWebhookUrlQuery, GetContactWebhookUrlQueryVariables>(GetContactWebhookUrlDocument, options);
        }
export type GetContactWebhookUrlQueryHookResult = ReturnType<typeof useGetContactWebhookUrlQuery>;
export type GetContactWebhookUrlLazyQueryHookResult = ReturnType<typeof useGetContactWebhookUrlLazyQuery>;
export type GetContactWebhookUrlQueryResult = Apollo.QueryResult<GetContactWebhookUrlQuery, GetContactWebhookUrlQueryVariables>;
export const SetupIntegrationDocument = gql`
    mutation setupIntegration($input: AccountIntegrationsInput!) {
  setupIntegration(input: $input) {
    ...AccountIntegrationsFragment
  }
}
    ${AccountIntegrationsFragmentFragmentDoc}`;
export type SetupIntegrationMutationFn = Apollo.MutationFunction<SetupIntegrationMutation, SetupIntegrationMutationVariables>;

/**
 * __useSetupIntegrationMutation__
 *
 * To run a mutation, you first call `useSetupIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupIntegrationMutation, { data, loading, error }] = useSetupIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetupIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<SetupIntegrationMutation, SetupIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupIntegrationMutation, SetupIntegrationMutationVariables>(SetupIntegrationDocument, options);
      }
export type SetupIntegrationMutationHookResult = ReturnType<typeof useSetupIntegrationMutation>;
export type SetupIntegrationMutationResult = Apollo.MutationResult<SetupIntegrationMutation>;
export type SetupIntegrationMutationOptions = Apollo.BaseMutationOptions<SetupIntegrationMutation, SetupIntegrationMutationVariables>;
export const DisconnectIntegrationDocument = gql`
    mutation disconnectIntegration($accountIntegrationType: AccountIntegrationType!) {
  disconnectIntegration(accountIntegrationType: $accountIntegrationType) {
    ...AccountIntegrationsFragment
  }
}
    ${AccountIntegrationsFragmentFragmentDoc}`;
export type DisconnectIntegrationMutationFn = Apollo.MutationFunction<DisconnectIntegrationMutation, DisconnectIntegrationMutationVariables>;

/**
 * __useDisconnectIntegrationMutation__
 *
 * To run a mutation, you first call `useDisconnectIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectIntegrationMutation, { data, loading, error }] = useDisconnectIntegrationMutation({
 *   variables: {
 *      accountIntegrationType: // value for 'accountIntegrationType'
 *   },
 * });
 */
export function useDisconnectIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectIntegrationMutation, DisconnectIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectIntegrationMutation, DisconnectIntegrationMutationVariables>(DisconnectIntegrationDocument, options);
      }
export type DisconnectIntegrationMutationHookResult = ReturnType<typeof useDisconnectIntegrationMutation>;
export type DisconnectIntegrationMutationResult = Apollo.MutationResult<DisconnectIntegrationMutation>;
export type DisconnectIntegrationMutationOptions = Apollo.BaseMutationOptions<DisconnectIntegrationMutation, DisconnectIntegrationMutationVariables>;
export const GetAllNumbersDocument = gql`
    query getAllNumbers {
  getAllNumbers {
    useCaseTitle
    phoneNumber {
      ...PhoneNumberFragment
    }
  }
}
    ${PhoneNumberFragmentFragmentDoc}`;

/**
 * __useGetAllNumbersQuery__
 *
 * To run a query within a React component, call `useGetAllNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllNumbersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllNumbersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllNumbersQuery, GetAllNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllNumbersQuery, GetAllNumbersQueryVariables>(GetAllNumbersDocument, options);
      }
export function useGetAllNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllNumbersQuery, GetAllNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllNumbersQuery, GetAllNumbersQueryVariables>(GetAllNumbersDocument, options);
        }
export type GetAllNumbersQueryHookResult = ReturnType<typeof useGetAllNumbersQuery>;
export type GetAllNumbersLazyQueryHookResult = ReturnType<typeof useGetAllNumbersLazyQuery>;
export type GetAllNumbersQueryResult = Apollo.QueryResult<GetAllNumbersQuery, GetAllNumbersQueryVariables>;
export const GetNumbersPageDocument = gql`
    query getNumbersPage($page: PaginationInput, $searchPattern: String) {
  getNumbersPage(page: $page, searchPattern: $searchPattern) {
    pageSize
    total
    pageNumber
    content {
      useCaseTitle
      phoneNumber {
        ...PhoneNumberFragment
      }
    }
  }
}
    ${PhoneNumberFragmentFragmentDoc}`;

/**
 * __useGetNumbersPageQuery__
 *
 * To run a query within a React component, call `useGetNumbersPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNumbersPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNumbersPageQuery({
 *   variables: {
 *      page: // value for 'page'
 *      searchPattern: // value for 'searchPattern'
 *   },
 * });
 */
export function useGetNumbersPageQuery(baseOptions?: Apollo.QueryHookOptions<GetNumbersPageQuery, GetNumbersPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNumbersPageQuery, GetNumbersPageQueryVariables>(GetNumbersPageDocument, options);
      }
export function useGetNumbersPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNumbersPageQuery, GetNumbersPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNumbersPageQuery, GetNumbersPageQueryVariables>(GetNumbersPageDocument, options);
        }
export type GetNumbersPageQueryHookResult = ReturnType<typeof useGetNumbersPageQuery>;
export type GetNumbersPageLazyQueryHookResult = ReturnType<typeof useGetNumbersPageLazyQuery>;
export type GetNumbersPageQueryResult = Apollo.QueryResult<GetNumbersPageQuery, GetNumbersPageQueryVariables>;
export const GetAvailablePhoneNumbersDocument = gql`
    query getAvailablePhoneNumbers($pageSize: Int!, $city: String, $country: String, $areaCode: String, $partOfNumber: String, $phoneNumberType: PhoneNumberType, $state: String) {
  getAvailablePhoneNumbers(
    pageSize: $pageSize
    city: $city
    country: $country
    areaCode: $areaCode
    partOfNumber: $partOfNumber
    phoneNumberType: $phoneNumberType
    state: $state
  ) {
    availablePhoneNumbers {
      phoneNumber
      friendlyName
      isoCountry
      locality
      region
    }
  }
}
    `;

/**
 * __useGetAvailablePhoneNumbersQuery__
 *
 * To run a query within a React component, call `useGetAvailablePhoneNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailablePhoneNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailablePhoneNumbersQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      city: // value for 'city'
 *      country: // value for 'country'
 *      areaCode: // value for 'areaCode'
 *      partOfNumber: // value for 'partOfNumber'
 *      phoneNumberType: // value for 'phoneNumberType'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useGetAvailablePhoneNumbersQuery(baseOptions: Apollo.QueryHookOptions<GetAvailablePhoneNumbersQuery, GetAvailablePhoneNumbersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailablePhoneNumbersQuery, GetAvailablePhoneNumbersQueryVariables>(GetAvailablePhoneNumbersDocument, options);
      }
export function useGetAvailablePhoneNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailablePhoneNumbersQuery, GetAvailablePhoneNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailablePhoneNumbersQuery, GetAvailablePhoneNumbersQueryVariables>(GetAvailablePhoneNumbersDocument, options);
        }
export type GetAvailablePhoneNumbersQueryHookResult = ReturnType<typeof useGetAvailablePhoneNumbersQuery>;
export type GetAvailablePhoneNumbersLazyQueryHookResult = ReturnType<typeof useGetAvailablePhoneNumbersLazyQuery>;
export type GetAvailablePhoneNumbersQueryResult = Apollo.QueryResult<GetAvailablePhoneNumbersQuery, GetAvailablePhoneNumbersQueryVariables>;
export const FindCitiesDocument = gql`
    query findCities($country: String, $cityName: String) {
  findCities(country: $country, cityName: $cityName) {
    city
    state
  }
}
    `;

/**
 * __useFindCitiesQuery__
 *
 * To run a query within a React component, call `useFindCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCitiesQuery({
 *   variables: {
 *      country: // value for 'country'
 *      cityName: // value for 'cityName'
 *   },
 * });
 */
export function useFindCitiesQuery(baseOptions?: Apollo.QueryHookOptions<FindCitiesQuery, FindCitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindCitiesQuery, FindCitiesQueryVariables>(FindCitiesDocument, options);
      }
export function useFindCitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindCitiesQuery, FindCitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindCitiesQuery, FindCitiesQueryVariables>(FindCitiesDocument, options);
        }
export type FindCitiesQueryHookResult = ReturnType<typeof useFindCitiesQuery>;
export type FindCitiesLazyQueryHookResult = ReturnType<typeof useFindCitiesLazyQuery>;
export type FindCitiesQueryResult = Apollo.QueryResult<FindCitiesQuery, FindCitiesQueryVariables>;
export const ReservePhoneNumberDocument = gql`
    mutation reservePhoneNumber($input: ReservePhoneNumberRequestInput) {
  reservePhoneNumber(input: $input) {
    ...PhoneNumberFragment
  }
}
    ${PhoneNumberFragmentFragmentDoc}`;
export type ReservePhoneNumberMutationFn = Apollo.MutationFunction<ReservePhoneNumberMutation, ReservePhoneNumberMutationVariables>;

/**
 * __useReservePhoneNumberMutation__
 *
 * To run a mutation, you first call `useReservePhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReservePhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reservePhoneNumberMutation, { data, loading, error }] = useReservePhoneNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReservePhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<ReservePhoneNumberMutation, ReservePhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReservePhoneNumberMutation, ReservePhoneNumberMutationVariables>(ReservePhoneNumberDocument, options);
      }
export type ReservePhoneNumberMutationHookResult = ReturnType<typeof useReservePhoneNumberMutation>;
export type ReservePhoneNumberMutationResult = Apollo.MutationResult<ReservePhoneNumberMutation>;
export type ReservePhoneNumberMutationOptions = Apollo.BaseMutationOptions<ReservePhoneNumberMutation, ReservePhoneNumberMutationVariables>;
export const UpdatePhoneNumbersDocument = gql`
    mutation updatePhoneNumbers($inputUpdatePhoneNumber: UpdatePhoneNumbersRequestInput) {
  updatePhoneNumbers(inputUpdatePhoneNumbers: $inputUpdatePhoneNumber) {
    ...PhoneNumberFragment
  }
}
    ${PhoneNumberFragmentFragmentDoc}`;
export type UpdatePhoneNumbersMutationFn = Apollo.MutationFunction<UpdatePhoneNumbersMutation, UpdatePhoneNumbersMutationVariables>;

/**
 * __useUpdatePhoneNumbersMutation__
 *
 * To run a mutation, you first call `useUpdatePhoneNumbersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhoneNumbersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhoneNumbersMutation, { data, loading, error }] = useUpdatePhoneNumbersMutation({
 *   variables: {
 *      inputUpdatePhoneNumber: // value for 'inputUpdatePhoneNumber'
 *   },
 * });
 */
export function useUpdatePhoneNumbersMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePhoneNumbersMutation, UpdatePhoneNumbersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePhoneNumbersMutation, UpdatePhoneNumbersMutationVariables>(UpdatePhoneNumbersDocument, options);
      }
export type UpdatePhoneNumbersMutationHookResult = ReturnType<typeof useUpdatePhoneNumbersMutation>;
export type UpdatePhoneNumbersMutationResult = Apollo.MutationResult<UpdatePhoneNumbersMutation>;
export type UpdatePhoneNumbersMutationOptions = Apollo.BaseMutationOptions<UpdatePhoneNumbersMutation, UpdatePhoneNumbersMutationVariables>;
export const ReleasePhoneNumberDocument = gql`
    mutation releasePhoneNumber($id: Long) {
  releasePhoneNumber(id: $id)
}
    `;
export type ReleasePhoneNumberMutationFn = Apollo.MutationFunction<ReleasePhoneNumberMutation, ReleasePhoneNumberMutationVariables>;

/**
 * __useReleasePhoneNumberMutation__
 *
 * To run a mutation, you first call `useReleasePhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleasePhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releasePhoneNumberMutation, { data, loading, error }] = useReleasePhoneNumberMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReleasePhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<ReleasePhoneNumberMutation, ReleasePhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReleasePhoneNumberMutation, ReleasePhoneNumberMutationVariables>(ReleasePhoneNumberDocument, options);
      }
export type ReleasePhoneNumberMutationHookResult = ReturnType<typeof useReleasePhoneNumberMutation>;
export type ReleasePhoneNumberMutationResult = Apollo.MutationResult<ReleasePhoneNumberMutation>;
export type ReleasePhoneNumberMutationOptions = Apollo.BaseMutationOptions<ReleasePhoneNumberMutation, ReleasePhoneNumberMutationVariables>;
export const DeletePhoneNumberDocument = gql`
    mutation deletePhoneNumber($id: Long!) {
  deletePhoneNumber(id: $id)
}
    `;
export type DeletePhoneNumberMutationFn = Apollo.MutationFunction<DeletePhoneNumberMutation, DeletePhoneNumberMutationVariables>;

/**
 * __useDeletePhoneNumberMutation__
 *
 * To run a mutation, you first call `useDeletePhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePhoneNumberMutation, { data, loading, error }] = useDeletePhoneNumberMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<DeletePhoneNumberMutation, DeletePhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePhoneNumberMutation, DeletePhoneNumberMutationVariables>(DeletePhoneNumberDocument, options);
      }
export type DeletePhoneNumberMutationHookResult = ReturnType<typeof useDeletePhoneNumberMutation>;
export type DeletePhoneNumberMutationResult = Apollo.MutationResult<DeletePhoneNumberMutation>;
export type DeletePhoneNumberMutationOptions = Apollo.BaseMutationOptions<DeletePhoneNumberMutation, DeletePhoneNumberMutationVariables>;
export const GetProfileOrganizationsDocument = gql`
    query getProfileOrganizations($search: String) {
  getProfileOrganizations(search: $search) {
    id
    companyName
  }
}
    `;

/**
 * __useGetProfileOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetProfileOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileOrganizationsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetProfileOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetProfileOrganizationsQuery, GetProfileOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfileOrganizationsQuery, GetProfileOrganizationsQueryVariables>(GetProfileOrganizationsDocument, options);
      }
export function useGetProfileOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfileOrganizationsQuery, GetProfileOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfileOrganizationsQuery, GetProfileOrganizationsQueryVariables>(GetProfileOrganizationsDocument, options);
        }
export type GetProfileOrganizationsQueryHookResult = ReturnType<typeof useGetProfileOrganizationsQuery>;
export type GetProfileOrganizationsLazyQueryHookResult = ReturnType<typeof useGetProfileOrganizationsLazyQuery>;
export type GetProfileOrganizationsQueryResult = Apollo.QueryResult<GetProfileOrganizationsQuery, GetProfileOrganizationsQueryVariables>;
export const SelectOrganizationDocument = gql`
    mutation selectOrganization($organizationId: Long!) {
  selectOrganization(organizationId: $organizationId) {
    ...MemberResponse
  }
}
    ${MemberResponseFragmentDoc}`;
export type SelectOrganizationMutationFn = Apollo.MutationFunction<SelectOrganizationMutation, SelectOrganizationMutationVariables>;

/**
 * __useSelectOrganizationMutation__
 *
 * To run a mutation, you first call `useSelectOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectOrganizationMutation, { data, loading, error }] = useSelectOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useSelectOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<SelectOrganizationMutation, SelectOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelectOrganizationMutation, SelectOrganizationMutationVariables>(SelectOrganizationDocument, options);
      }
export type SelectOrganizationMutationHookResult = ReturnType<typeof useSelectOrganizationMutation>;
export type SelectOrganizationMutationResult = Apollo.MutationResult<SelectOrganizationMutation>;
export type SelectOrganizationMutationOptions = Apollo.BaseMutationOptions<SelectOrganizationMutation, SelectOrganizationMutationVariables>;
export const CreateOrganizationDocument = gql`
    mutation createOrganization($input: OrganizationUpdateInput!, $tokenId: String) {
  createOrganization(input: $input, tokenId: $tokenId) {
    member {
      ...MemberResponse
    }
    subscription {
      ...SubscriptionFragment
    }
  }
}
    ${MemberResponseFragmentDoc}
${SubscriptionFragmentFragmentDoc}`;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      tokenId: // value for 'tokenId'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const AdminOrganizationComplianceListDocument = gql`
    query adminOrganizationComplianceList($page: PaginationInput, $search: OrganizationComplianceSearchInput) {
  adminOrganizationComplianceList(page: $page, search: $search) {
    pageSize
    pageNumber
    total
    content {
      ...OrganizationComplianceResponseFragment
    }
  }
}
    ${OrganizationComplianceResponseFragmentFragmentDoc}`;

/**
 * __useAdminOrganizationComplianceListQuery__
 *
 * To run a query within a React component, call `useAdminOrganizationComplianceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOrganizationComplianceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOrganizationComplianceListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAdminOrganizationComplianceListQuery(baseOptions?: Apollo.QueryHookOptions<AdminOrganizationComplianceListQuery, AdminOrganizationComplianceListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOrganizationComplianceListQuery, AdminOrganizationComplianceListQueryVariables>(AdminOrganizationComplianceListDocument, options);
      }
export function useAdminOrganizationComplianceListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOrganizationComplianceListQuery, AdminOrganizationComplianceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOrganizationComplianceListQuery, AdminOrganizationComplianceListQueryVariables>(AdminOrganizationComplianceListDocument, options);
        }
export type AdminOrganizationComplianceListQueryHookResult = ReturnType<typeof useAdminOrganizationComplianceListQuery>;
export type AdminOrganizationComplianceListLazyQueryHookResult = ReturnType<typeof useAdminOrganizationComplianceListLazyQuery>;
export type AdminOrganizationComplianceListQueryResult = Apollo.QueryResult<AdminOrganizationComplianceListQuery, AdminOrganizationComplianceListQueryVariables>;
export const AdminGetFullTollFreeVerificationProfileDocument = gql`
    query adminGetFullTollFreeVerificationProfile($organizationId: Long!) {
  adminGetFullTollFreeVerificationProfile(organizationId: $organizationId) {
    ...TollFreeVerificationProfileFragment
  }
}
    ${TollFreeVerificationProfileFragmentFragmentDoc}`;

/**
 * __useAdminGetFullTollFreeVerificationProfileQuery__
 *
 * To run a query within a React component, call `useAdminGetFullTollFreeVerificationProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetFullTollFreeVerificationProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetFullTollFreeVerificationProfileQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAdminGetFullTollFreeVerificationProfileQuery(baseOptions: Apollo.QueryHookOptions<AdminGetFullTollFreeVerificationProfileQuery, AdminGetFullTollFreeVerificationProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetFullTollFreeVerificationProfileQuery, AdminGetFullTollFreeVerificationProfileQueryVariables>(AdminGetFullTollFreeVerificationProfileDocument, options);
      }
export function useAdminGetFullTollFreeVerificationProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetFullTollFreeVerificationProfileQuery, AdminGetFullTollFreeVerificationProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetFullTollFreeVerificationProfileQuery, AdminGetFullTollFreeVerificationProfileQueryVariables>(AdminGetFullTollFreeVerificationProfileDocument, options);
        }
export type AdminGetFullTollFreeVerificationProfileQueryHookResult = ReturnType<typeof useAdminGetFullTollFreeVerificationProfileQuery>;
export type AdminGetFullTollFreeVerificationProfileLazyQueryHookResult = ReturnType<typeof useAdminGetFullTollFreeVerificationProfileLazyQuery>;
export type AdminGetFullTollFreeVerificationProfileQueryResult = Apollo.QueryResult<AdminGetFullTollFreeVerificationProfileQuery, AdminGetFullTollFreeVerificationProfileQueryVariables>;
export const AdminInitTollFreeVerificationProfileDocument = gql`
    mutation adminInitTollFreeVerificationProfile($input: TollFreeVerificationRequestInput!, $organizationId: Long!) {
  adminInitTollFreeVerificationProfile(
    input: $input
    organizationId: $organizationId
  ) {
    ...TollFreeVerificationProfileFragment
  }
}
    ${TollFreeVerificationProfileFragmentFragmentDoc}`;
export type AdminInitTollFreeVerificationProfileMutationFn = Apollo.MutationFunction<AdminInitTollFreeVerificationProfileMutation, AdminInitTollFreeVerificationProfileMutationVariables>;

/**
 * __useAdminInitTollFreeVerificationProfileMutation__
 *
 * To run a mutation, you first call `useAdminInitTollFreeVerificationProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminInitTollFreeVerificationProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminInitTollFreeVerificationProfileMutation, { data, loading, error }] = useAdminInitTollFreeVerificationProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAdminInitTollFreeVerificationProfileMutation(baseOptions?: Apollo.MutationHookOptions<AdminInitTollFreeVerificationProfileMutation, AdminInitTollFreeVerificationProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminInitTollFreeVerificationProfileMutation, AdminInitTollFreeVerificationProfileMutationVariables>(AdminInitTollFreeVerificationProfileDocument, options);
      }
export type AdminInitTollFreeVerificationProfileMutationHookResult = ReturnType<typeof useAdminInitTollFreeVerificationProfileMutation>;
export type AdminInitTollFreeVerificationProfileMutationResult = Apollo.MutationResult<AdminInitTollFreeVerificationProfileMutation>;
export type AdminInitTollFreeVerificationProfileMutationOptions = Apollo.BaseMutationOptions<AdminInitTollFreeVerificationProfileMutation, AdminInitTollFreeVerificationProfileMutationVariables>;
export const AdminInitTfProfileBusinessInfoDocument = gql`
    mutation adminInitTFProfileBusinessInfo($input: TFBusinessInfoRequestInput!, $organizationId: Long!) {
  adminInitTFProfileBusinessInfo(input: $input, organizationId: $organizationId) {
    ...TollFreeVerificationProfileFragment
  }
}
    ${TollFreeVerificationProfileFragmentFragmentDoc}`;
export type AdminInitTfProfileBusinessInfoMutationFn = Apollo.MutationFunction<AdminInitTfProfileBusinessInfoMutation, AdminInitTfProfileBusinessInfoMutationVariables>;

/**
 * __useAdminInitTfProfileBusinessInfoMutation__
 *
 * To run a mutation, you first call `useAdminInitTfProfileBusinessInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminInitTfProfileBusinessInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminInitTfProfileBusinessInfoMutation, { data, loading, error }] = useAdminInitTfProfileBusinessInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAdminInitTfProfileBusinessInfoMutation(baseOptions?: Apollo.MutationHookOptions<AdminInitTfProfileBusinessInfoMutation, AdminInitTfProfileBusinessInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminInitTfProfileBusinessInfoMutation, AdminInitTfProfileBusinessInfoMutationVariables>(AdminInitTfProfileBusinessInfoDocument, options);
      }
export type AdminInitTfProfileBusinessInfoMutationHookResult = ReturnType<typeof useAdminInitTfProfileBusinessInfoMutation>;
export type AdminInitTfProfileBusinessInfoMutationResult = Apollo.MutationResult<AdminInitTfProfileBusinessInfoMutation>;
export type AdminInitTfProfileBusinessInfoMutationOptions = Apollo.BaseMutationOptions<AdminInitTfProfileBusinessInfoMutation, AdminInitTfProfileBusinessInfoMutationVariables>;
export const AdminInitTfProfileContactInfoDocument = gql`
    mutation adminInitTFProfileContactInfo($input: ContactInfoRequestInput!, $organizationId: Long!) {
  adminInitTFProfileContactInfo(input: $input, organizationId: $organizationId) {
    ...TollFreeVerificationProfileFragment
  }
}
    ${TollFreeVerificationProfileFragmentFragmentDoc}`;
export type AdminInitTfProfileContactInfoMutationFn = Apollo.MutationFunction<AdminInitTfProfileContactInfoMutation, AdminInitTfProfileContactInfoMutationVariables>;

/**
 * __useAdminInitTfProfileContactInfoMutation__
 *
 * To run a mutation, you first call `useAdminInitTfProfileContactInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminInitTfProfileContactInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminInitTfProfileContactInfoMutation, { data, loading, error }] = useAdminInitTfProfileContactInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAdminInitTfProfileContactInfoMutation(baseOptions?: Apollo.MutationHookOptions<AdminInitTfProfileContactInfoMutation, AdminInitTfProfileContactInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminInitTfProfileContactInfoMutation, AdminInitTfProfileContactInfoMutationVariables>(AdminInitTfProfileContactInfoDocument, options);
      }
export type AdminInitTfProfileContactInfoMutationHookResult = ReturnType<typeof useAdminInitTfProfileContactInfoMutation>;
export type AdminInitTfProfileContactInfoMutationResult = Apollo.MutationResult<AdminInitTfProfileContactInfoMutation>;
export type AdminInitTfProfileContactInfoMutationOptions = Apollo.BaseMutationOptions<AdminInitTfProfileContactInfoMutation, AdminInitTfProfileContactInfoMutationVariables>;
export const AdminInitTollFreeVerificationUseCaseDocument = gql`
    mutation adminInitTollFreeVerificationUseCase($input: TollFreeVerificationUseCaseRequestInput!, $organizationId: Long!) {
  adminInitTollFreeVerificationUseCase(
    input: $input
    organizationId: $organizationId
  ) {
    ...TollFreeVerificationProfileFragment
  }
}
    ${TollFreeVerificationProfileFragmentFragmentDoc}`;
export type AdminInitTollFreeVerificationUseCaseMutationFn = Apollo.MutationFunction<AdminInitTollFreeVerificationUseCaseMutation, AdminInitTollFreeVerificationUseCaseMutationVariables>;

/**
 * __useAdminInitTollFreeVerificationUseCaseMutation__
 *
 * To run a mutation, you first call `useAdminInitTollFreeVerificationUseCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminInitTollFreeVerificationUseCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminInitTollFreeVerificationUseCaseMutation, { data, loading, error }] = useAdminInitTollFreeVerificationUseCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAdminInitTollFreeVerificationUseCaseMutation(baseOptions?: Apollo.MutationHookOptions<AdminInitTollFreeVerificationUseCaseMutation, AdminInitTollFreeVerificationUseCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminInitTollFreeVerificationUseCaseMutation, AdminInitTollFreeVerificationUseCaseMutationVariables>(AdminInitTollFreeVerificationUseCaseDocument, options);
      }
export type AdminInitTollFreeVerificationUseCaseMutationHookResult = ReturnType<typeof useAdminInitTollFreeVerificationUseCaseMutation>;
export type AdminInitTollFreeVerificationUseCaseMutationResult = Apollo.MutationResult<AdminInitTollFreeVerificationUseCaseMutation>;
export type AdminInitTollFreeVerificationUseCaseMutationOptions = Apollo.BaseMutationOptions<AdminInitTollFreeVerificationUseCaseMutation, AdminInitTollFreeVerificationUseCaseMutationVariables>;
export const AdminInitTollFreeVerificationOptInMethodDocument = gql`
    mutation adminInitTollFreeVerificationOptInMethod($input: TollFreeVerificationOptInMethodRequestInput!, $organizationId: Long!) {
  adminInitTollFreeVerificationOptInMethod(
    organizationId: $organizationId
    input: $input
  ) {
    ...TollFreeVerificationProfileFragment
  }
}
    ${TollFreeVerificationProfileFragmentFragmentDoc}`;
export type AdminInitTollFreeVerificationOptInMethodMutationFn = Apollo.MutationFunction<AdminInitTollFreeVerificationOptInMethodMutation, AdminInitTollFreeVerificationOptInMethodMutationVariables>;

/**
 * __useAdminInitTollFreeVerificationOptInMethodMutation__
 *
 * To run a mutation, you first call `useAdminInitTollFreeVerificationOptInMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminInitTollFreeVerificationOptInMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminInitTollFreeVerificationOptInMethodMutation, { data, loading, error }] = useAdminInitTollFreeVerificationOptInMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAdminInitTollFreeVerificationOptInMethodMutation(baseOptions?: Apollo.MutationHookOptions<AdminInitTollFreeVerificationOptInMethodMutation, AdminInitTollFreeVerificationOptInMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminInitTollFreeVerificationOptInMethodMutation, AdminInitTollFreeVerificationOptInMethodMutationVariables>(AdminInitTollFreeVerificationOptInMethodDocument, options);
      }
export type AdminInitTollFreeVerificationOptInMethodMutationHookResult = ReturnType<typeof useAdminInitTollFreeVerificationOptInMethodMutation>;
export type AdminInitTollFreeVerificationOptInMethodMutationResult = Apollo.MutationResult<AdminInitTollFreeVerificationOptInMethodMutation>;
export type AdminInitTollFreeVerificationOptInMethodMutationOptions = Apollo.BaseMutationOptions<AdminInitTollFreeVerificationOptInMethodMutation, AdminInitTollFreeVerificationOptInMethodMutationVariables>;
export const AdminInitTollFreeVerificationTermsDocument = gql`
    mutation adminInitTollFreeVerificationTerms($organizationId: Long!, $shouldSend: Boolean!) {
  adminInitTollFreeVerificationTerms(
    organizationId: $organizationId
    shouldSend: $shouldSend
  ) {
    ...TollFreeVerificationProfileFragment
  }
}
    ${TollFreeVerificationProfileFragmentFragmentDoc}`;
export type AdminInitTollFreeVerificationTermsMutationFn = Apollo.MutationFunction<AdminInitTollFreeVerificationTermsMutation, AdminInitTollFreeVerificationTermsMutationVariables>;

/**
 * __useAdminInitTollFreeVerificationTermsMutation__
 *
 * To run a mutation, you first call `useAdminInitTollFreeVerificationTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminInitTollFreeVerificationTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminInitTollFreeVerificationTermsMutation, { data, loading, error }] = useAdminInitTollFreeVerificationTermsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      shouldSend: // value for 'shouldSend'
 *   },
 * });
 */
export function useAdminInitTollFreeVerificationTermsMutation(baseOptions?: Apollo.MutationHookOptions<AdminInitTollFreeVerificationTermsMutation, AdminInitTollFreeVerificationTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminInitTollFreeVerificationTermsMutation, AdminInitTollFreeVerificationTermsMutationVariables>(AdminInitTollFreeVerificationTermsDocument, options);
      }
export type AdminInitTollFreeVerificationTermsMutationHookResult = ReturnType<typeof useAdminInitTollFreeVerificationTermsMutation>;
export type AdminInitTollFreeVerificationTermsMutationResult = Apollo.MutationResult<AdminInitTollFreeVerificationTermsMutation>;
export type AdminInitTollFreeVerificationTermsMutationOptions = Apollo.BaseMutationOptions<AdminInitTollFreeVerificationTermsMutation, AdminInitTollFreeVerificationTermsMutationVariables>;
export const AdminTollFreeVerificationProfilePreviousStepDocument = gql`
    mutation adminTollFreeVerificationProfilePreviousStep($organizationId: Long!) {
  adminTollFreeVerificationProfilePreviousStep(organizationId: $organizationId) {
    ...TollFreeVerificationProfileFragment
  }
}
    ${TollFreeVerificationProfileFragmentFragmentDoc}`;
export type AdminTollFreeVerificationProfilePreviousStepMutationFn = Apollo.MutationFunction<AdminTollFreeVerificationProfilePreviousStepMutation, AdminTollFreeVerificationProfilePreviousStepMutationVariables>;

/**
 * __useAdminTollFreeVerificationProfilePreviousStepMutation__
 *
 * To run a mutation, you first call `useAdminTollFreeVerificationProfilePreviousStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminTollFreeVerificationProfilePreviousStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminTollFreeVerificationProfilePreviousStepMutation, { data, loading, error }] = useAdminTollFreeVerificationProfilePreviousStepMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAdminTollFreeVerificationProfilePreviousStepMutation(baseOptions?: Apollo.MutationHookOptions<AdminTollFreeVerificationProfilePreviousStepMutation, AdminTollFreeVerificationProfilePreviousStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminTollFreeVerificationProfilePreviousStepMutation, AdminTollFreeVerificationProfilePreviousStepMutationVariables>(AdminTollFreeVerificationProfilePreviousStepDocument, options);
      }
export type AdminTollFreeVerificationProfilePreviousStepMutationHookResult = ReturnType<typeof useAdminTollFreeVerificationProfilePreviousStepMutation>;
export type AdminTollFreeVerificationProfilePreviousStepMutationResult = Apollo.MutationResult<AdminTollFreeVerificationProfilePreviousStepMutation>;
export type AdminTollFreeVerificationProfilePreviousStepMutationOptions = Apollo.BaseMutationOptions<AdminTollFreeVerificationProfilePreviousStepMutation, AdminTollFreeVerificationProfilePreviousStepMutationVariables>;
export const AdminGetFullBusinessProfileDocument = gql`
    query adminGetFullBusinessProfile($organizationId: Long!) {
  adminGetFullBusinessProfile(organizationId: $organizationId) {
    ...BusinessProfileResponseFragment
  }
}
    ${BusinessProfileResponseFragmentFragmentDoc}`;

/**
 * __useAdminGetFullBusinessProfileQuery__
 *
 * To run a query within a React component, call `useAdminGetFullBusinessProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetFullBusinessProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetFullBusinessProfileQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAdminGetFullBusinessProfileQuery(baseOptions: Apollo.QueryHookOptions<AdminGetFullBusinessProfileQuery, AdminGetFullBusinessProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetFullBusinessProfileQuery, AdminGetFullBusinessProfileQueryVariables>(AdminGetFullBusinessProfileDocument, options);
      }
export function useAdminGetFullBusinessProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetFullBusinessProfileQuery, AdminGetFullBusinessProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetFullBusinessProfileQuery, AdminGetFullBusinessProfileQueryVariables>(AdminGetFullBusinessProfileDocument, options);
        }
export type AdminGetFullBusinessProfileQueryHookResult = ReturnType<typeof useAdminGetFullBusinessProfileQuery>;
export type AdminGetFullBusinessProfileLazyQueryHookResult = ReturnType<typeof useAdminGetFullBusinessProfileLazyQuery>;
export type AdminGetFullBusinessProfileQueryResult = Apollo.QueryResult<AdminGetFullBusinessProfileQuery, AdminGetFullBusinessProfileQueryVariables>;
export const AdminRegisterBusinessProfileDocument = gql`
    mutation adminRegisterBusinessProfile($input: BusinessProfileRequestInput!, $organizationId: Long!) {
  adminRegisterBusinessProfile(input: $input, organizationId: $organizationId) {
    ...BusinessProfileResponseFragment
  }
}
    ${BusinessProfileResponseFragmentFragmentDoc}`;
export type AdminRegisterBusinessProfileMutationFn = Apollo.MutationFunction<AdminRegisterBusinessProfileMutation, AdminRegisterBusinessProfileMutationVariables>;

/**
 * __useAdminRegisterBusinessProfileMutation__
 *
 * To run a mutation, you first call `useAdminRegisterBusinessProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRegisterBusinessProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRegisterBusinessProfileMutation, { data, loading, error }] = useAdminRegisterBusinessProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAdminRegisterBusinessProfileMutation(baseOptions?: Apollo.MutationHookOptions<AdminRegisterBusinessProfileMutation, AdminRegisterBusinessProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminRegisterBusinessProfileMutation, AdminRegisterBusinessProfileMutationVariables>(AdminRegisterBusinessProfileDocument, options);
      }
export type AdminRegisterBusinessProfileMutationHookResult = ReturnType<typeof useAdminRegisterBusinessProfileMutation>;
export type AdminRegisterBusinessProfileMutationResult = Apollo.MutationResult<AdminRegisterBusinessProfileMutation>;
export type AdminRegisterBusinessProfileMutationOptions = Apollo.BaseMutationOptions<AdminRegisterBusinessProfileMutation, AdminRegisterBusinessProfileMutationVariables>;
export const AdminInitCompanyTypeDocument = gql`
    mutation adminInitCompanyType($hasEin: Boolean!, $organizationId: Long!) {
  adminInitCompanyType(hasEin: $hasEin, organizationId: $organizationId) {
    ...BusinessProfileResponseFragment
  }
}
    ${BusinessProfileResponseFragmentFragmentDoc}`;
export type AdminInitCompanyTypeMutationFn = Apollo.MutationFunction<AdminInitCompanyTypeMutation, AdminInitCompanyTypeMutationVariables>;

/**
 * __useAdminInitCompanyTypeMutation__
 *
 * To run a mutation, you first call `useAdminInitCompanyTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminInitCompanyTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminInitCompanyTypeMutation, { data, loading, error }] = useAdminInitCompanyTypeMutation({
 *   variables: {
 *      hasEin: // value for 'hasEin'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAdminInitCompanyTypeMutation(baseOptions?: Apollo.MutationHookOptions<AdminInitCompanyTypeMutation, AdminInitCompanyTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminInitCompanyTypeMutation, AdminInitCompanyTypeMutationVariables>(AdminInitCompanyTypeDocument, options);
      }
export type AdminInitCompanyTypeMutationHookResult = ReturnType<typeof useAdminInitCompanyTypeMutation>;
export type AdminInitCompanyTypeMutationResult = Apollo.MutationResult<AdminInitCompanyTypeMutation>;
export type AdminInitCompanyTypeMutationOptions = Apollo.BaseMutationOptions<AdminInitCompanyTypeMutation, AdminInitCompanyTypeMutationVariables>;
export const AdminBusinessProfilePreviousStepDocument = gql`
    mutation adminBusinessProfilePreviousStep($organizationId: Long!) {
  adminBusinessProfilePreviousStep(organizationId: $organizationId) {
    ...BusinessProfileResponseFragment
  }
}
    ${BusinessProfileResponseFragmentFragmentDoc}`;
export type AdminBusinessProfilePreviousStepMutationFn = Apollo.MutationFunction<AdminBusinessProfilePreviousStepMutation, AdminBusinessProfilePreviousStepMutationVariables>;

/**
 * __useAdminBusinessProfilePreviousStepMutation__
 *
 * To run a mutation, you first call `useAdminBusinessProfilePreviousStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBusinessProfilePreviousStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBusinessProfilePreviousStepMutation, { data, loading, error }] = useAdminBusinessProfilePreviousStepMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAdminBusinessProfilePreviousStepMutation(baseOptions?: Apollo.MutationHookOptions<AdminBusinessProfilePreviousStepMutation, AdminBusinessProfilePreviousStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBusinessProfilePreviousStepMutation, AdminBusinessProfilePreviousStepMutationVariables>(AdminBusinessProfilePreviousStepDocument, options);
      }
export type AdminBusinessProfilePreviousStepMutationHookResult = ReturnType<typeof useAdminBusinessProfilePreviousStepMutation>;
export type AdminBusinessProfilePreviousStepMutationResult = Apollo.MutationResult<AdminBusinessProfilePreviousStepMutation>;
export type AdminBusinessProfilePreviousStepMutationOptions = Apollo.BaseMutationOptions<AdminBusinessProfilePreviousStepMutation, AdminBusinessProfilePreviousStepMutationVariables>;
export const AdminInitBusinessGeneralInfoDocument = gql`
    mutation adminInitBusinessGeneralInfo($input: BusinessGeneralInfoRequestInput!, $organizationId: Long!) {
  adminInitBusinessGeneralInfo(input: $input, organizationId: $organizationId) {
    ...BusinessProfileResponseFragment
  }
}
    ${BusinessProfileResponseFragmentFragmentDoc}`;
export type AdminInitBusinessGeneralInfoMutationFn = Apollo.MutationFunction<AdminInitBusinessGeneralInfoMutation, AdminInitBusinessGeneralInfoMutationVariables>;

/**
 * __useAdminInitBusinessGeneralInfoMutation__
 *
 * To run a mutation, you first call `useAdminInitBusinessGeneralInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminInitBusinessGeneralInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminInitBusinessGeneralInfoMutation, { data, loading, error }] = useAdminInitBusinessGeneralInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAdminInitBusinessGeneralInfoMutation(baseOptions?: Apollo.MutationHookOptions<AdminInitBusinessGeneralInfoMutation, AdminInitBusinessGeneralInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminInitBusinessGeneralInfoMutation, AdminInitBusinessGeneralInfoMutationVariables>(AdminInitBusinessGeneralInfoDocument, options);
      }
export type AdminInitBusinessGeneralInfoMutationHookResult = ReturnType<typeof useAdminInitBusinessGeneralInfoMutation>;
export type AdminInitBusinessGeneralInfoMutationResult = Apollo.MutationResult<AdminInitBusinessGeneralInfoMutation>;
export type AdminInitBusinessGeneralInfoMutationOptions = Apollo.BaseMutationOptions<AdminInitBusinessGeneralInfoMutation, AdminInitBusinessGeneralInfoMutationVariables>;
export const AdminInitBusinessInfoDocument = gql`
    mutation adminInitBusinessInfo($input: BusinessInfoRequestInput!, $organizationId: Long!) {
  adminInitBusinessInfo(input: $input, organizationId: $organizationId) {
    ...BusinessProfileResponseFragment
  }
}
    ${BusinessProfileResponseFragmentFragmentDoc}`;
export type AdminInitBusinessInfoMutationFn = Apollo.MutationFunction<AdminInitBusinessInfoMutation, AdminInitBusinessInfoMutationVariables>;

/**
 * __useAdminInitBusinessInfoMutation__
 *
 * To run a mutation, you first call `useAdminInitBusinessInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminInitBusinessInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminInitBusinessInfoMutation, { data, loading, error }] = useAdminInitBusinessInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAdminInitBusinessInfoMutation(baseOptions?: Apollo.MutationHookOptions<AdminInitBusinessInfoMutation, AdminInitBusinessInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminInitBusinessInfoMutation, AdminInitBusinessInfoMutationVariables>(AdminInitBusinessInfoDocument, options);
      }
export type AdminInitBusinessInfoMutationHookResult = ReturnType<typeof useAdminInitBusinessInfoMutation>;
export type AdminInitBusinessInfoMutationResult = Apollo.MutationResult<AdminInitBusinessInfoMutation>;
export type AdminInitBusinessInfoMutationOptions = Apollo.BaseMutationOptions<AdminInitBusinessInfoMutation, AdminInitBusinessInfoMutationVariables>;
export const AdminInitBusinessAuthorizedUsersDocument = gql`
    mutation adminInitBusinessAuthorizedUsers($input: [BusinessAuthorizedUserRequestInput]!, $organizationId: Long!) {
  adminInitBusinessAuthorizedUsers(input: $input, organizationId: $organizationId) {
    ...BusinessProfileResponseFragment
  }
}
    ${BusinessProfileResponseFragmentFragmentDoc}`;
export type AdminInitBusinessAuthorizedUsersMutationFn = Apollo.MutationFunction<AdminInitBusinessAuthorizedUsersMutation, AdminInitBusinessAuthorizedUsersMutationVariables>;

/**
 * __useAdminInitBusinessAuthorizedUsersMutation__
 *
 * To run a mutation, you first call `useAdminInitBusinessAuthorizedUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminInitBusinessAuthorizedUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminInitBusinessAuthorizedUsersMutation, { data, loading, error }] = useAdminInitBusinessAuthorizedUsersMutation({
 *   variables: {
 *      input: // value for 'input'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAdminInitBusinessAuthorizedUsersMutation(baseOptions?: Apollo.MutationHookOptions<AdminInitBusinessAuthorizedUsersMutation, AdminInitBusinessAuthorizedUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminInitBusinessAuthorizedUsersMutation, AdminInitBusinessAuthorizedUsersMutationVariables>(AdminInitBusinessAuthorizedUsersDocument, options);
      }
export type AdminInitBusinessAuthorizedUsersMutationHookResult = ReturnType<typeof useAdminInitBusinessAuthorizedUsersMutation>;
export type AdminInitBusinessAuthorizedUsersMutationResult = Apollo.MutationResult<AdminInitBusinessAuthorizedUsersMutation>;
export type AdminInitBusinessAuthorizedUsersMutationOptions = Apollo.BaseMutationOptions<AdminInitBusinessAuthorizedUsersMutation, AdminInitBusinessAuthorizedUsersMutationVariables>;
export const AdminInitBusinessTermsDocument = gql`
    mutation adminInitBusinessTerms($organizationId: Long!) {
  adminInitBusinessTerms(organizationId: $organizationId) {
    ...BusinessProfileResponseFragment
  }
}
    ${BusinessProfileResponseFragmentFragmentDoc}`;
export type AdminInitBusinessTermsMutationFn = Apollo.MutationFunction<AdminInitBusinessTermsMutation, AdminInitBusinessTermsMutationVariables>;

/**
 * __useAdminInitBusinessTermsMutation__
 *
 * To run a mutation, you first call `useAdminInitBusinessTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminInitBusinessTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminInitBusinessTermsMutation, { data, loading, error }] = useAdminInitBusinessTermsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAdminInitBusinessTermsMutation(baseOptions?: Apollo.MutationHookOptions<AdminInitBusinessTermsMutation, AdminInitBusinessTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminInitBusinessTermsMutation, AdminInitBusinessTermsMutationVariables>(AdminInitBusinessTermsDocument, options);
      }
export type AdminInitBusinessTermsMutationHookResult = ReturnType<typeof useAdminInitBusinessTermsMutation>;
export type AdminInitBusinessTermsMutationResult = Apollo.MutationResult<AdminInitBusinessTermsMutation>;
export type AdminInitBusinessTermsMutationOptions = Apollo.BaseMutationOptions<AdminInitBusinessTermsMutation, AdminInitBusinessTermsMutationVariables>;
export const AdminInitBusinessGeneralInfoByEinDocument = gql`
    mutation adminInitBusinessGeneralInfoByEin($ein: String!, $organizationId: Long!) {
  adminInitBusinessGeneralInfoByEin(ein: $ein, organizationId: $organizationId) {
    ...BusinessProfileResponseFragment
  }
}
    ${BusinessProfileResponseFragmentFragmentDoc}`;
export type AdminInitBusinessGeneralInfoByEinMutationFn = Apollo.MutationFunction<AdminInitBusinessGeneralInfoByEinMutation, AdminInitBusinessGeneralInfoByEinMutationVariables>;

/**
 * __useAdminInitBusinessGeneralInfoByEinMutation__
 *
 * To run a mutation, you first call `useAdminInitBusinessGeneralInfoByEinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminInitBusinessGeneralInfoByEinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminInitBusinessGeneralInfoByEinMutation, { data, loading, error }] = useAdminInitBusinessGeneralInfoByEinMutation({
 *   variables: {
 *      ein: // value for 'ein'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAdminInitBusinessGeneralInfoByEinMutation(baseOptions?: Apollo.MutationHookOptions<AdminInitBusinessGeneralInfoByEinMutation, AdminInitBusinessGeneralInfoByEinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminInitBusinessGeneralInfoByEinMutation, AdminInitBusinessGeneralInfoByEinMutationVariables>(AdminInitBusinessGeneralInfoByEinDocument, options);
      }
export type AdminInitBusinessGeneralInfoByEinMutationHookResult = ReturnType<typeof useAdminInitBusinessGeneralInfoByEinMutation>;
export type AdminInitBusinessGeneralInfoByEinMutationResult = Apollo.MutationResult<AdminInitBusinessGeneralInfoByEinMutation>;
export type AdminInitBusinessGeneralInfoByEinMutationOptions = Apollo.BaseMutationOptions<AdminInitBusinessGeneralInfoByEinMutation, AdminInitBusinessGeneralInfoByEinMutationVariables>;
export const AdminInitBusinessGeneralInfoByManualEinDocument = gql`
    mutation adminInitBusinessGeneralInfoByManualEin($input: BusinessGeneralInfoEinRequestInput!, $organizationId: Long!) {
  adminInitBusinessGeneralInfoByManualEin(
    input: $input
    organizationId: $organizationId
  ) {
    ...BusinessProfileResponseFragment
  }
}
    ${BusinessProfileResponseFragmentFragmentDoc}`;
export type AdminInitBusinessGeneralInfoByManualEinMutationFn = Apollo.MutationFunction<AdminInitBusinessGeneralInfoByManualEinMutation, AdminInitBusinessGeneralInfoByManualEinMutationVariables>;

/**
 * __useAdminInitBusinessGeneralInfoByManualEinMutation__
 *
 * To run a mutation, you first call `useAdminInitBusinessGeneralInfoByManualEinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminInitBusinessGeneralInfoByManualEinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminInitBusinessGeneralInfoByManualEinMutation, { data, loading, error }] = useAdminInitBusinessGeneralInfoByManualEinMutation({
 *   variables: {
 *      input: // value for 'input'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAdminInitBusinessGeneralInfoByManualEinMutation(baseOptions?: Apollo.MutationHookOptions<AdminInitBusinessGeneralInfoByManualEinMutation, AdminInitBusinessGeneralInfoByManualEinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminInitBusinessGeneralInfoByManualEinMutation, AdminInitBusinessGeneralInfoByManualEinMutationVariables>(AdminInitBusinessGeneralInfoByManualEinDocument, options);
      }
export type AdminInitBusinessGeneralInfoByManualEinMutationHookResult = ReturnType<typeof useAdminInitBusinessGeneralInfoByManualEinMutation>;
export type AdminInitBusinessGeneralInfoByManualEinMutationResult = Apollo.MutationResult<AdminInitBusinessGeneralInfoByManualEinMutation>;
export type AdminInitBusinessGeneralInfoByManualEinMutationOptions = Apollo.BaseMutationOptions<AdminInitBusinessGeneralInfoByManualEinMutation, AdminInitBusinessGeneralInfoByManualEinMutationVariables>;
export const OrganizationsListDocument = gql`
    query organizationsList($page: PaginationInput, $search: OrganizationSearchInput) {
  organizationsList(page: $page, search: $search) {
    pageSize
    pageNumber
    total
    content {
      ...OrganizationResponseFragment
    }
  }
}
    ${OrganizationResponseFragmentFragmentDoc}`;

/**
 * __useOrganizationsListQuery__
 *
 * To run a query within a React component, call `useOrganizationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationsListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useOrganizationsListQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationsListQuery, OrganizationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationsListQuery, OrganizationsListQueryVariables>(OrganizationsListDocument, options);
      }
export function useOrganizationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationsListQuery, OrganizationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationsListQuery, OrganizationsListQueryVariables>(OrganizationsListDocument, options);
        }
export type OrganizationsListQueryHookResult = ReturnType<typeof useOrganizationsListQuery>;
export type OrganizationsListLazyQueryHookResult = ReturnType<typeof useOrganizationsListLazyQuery>;
export type OrganizationsListQueryResult = Apollo.QueryResult<OrganizationsListQuery, OrganizationsListQueryVariables>;
export const GetTokenForOrganizationDocument = gql`
    query getTokenForOrganization($request: OrganizationTokenRequestInput) {
  getTokenForOrganization(request: $request) {
    token
  }
}
    `;

/**
 * __useGetTokenForOrganizationQuery__
 *
 * To run a query within a React component, call `useGetTokenForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTokenForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTokenForOrganizationQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useGetTokenForOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<GetTokenForOrganizationQuery, GetTokenForOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTokenForOrganizationQuery, GetTokenForOrganizationQueryVariables>(GetTokenForOrganizationDocument, options);
      }
export function useGetTokenForOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTokenForOrganizationQuery, GetTokenForOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTokenForOrganizationQuery, GetTokenForOrganizationQueryVariables>(GetTokenForOrganizationDocument, options);
        }
export type GetTokenForOrganizationQueryHookResult = ReturnType<typeof useGetTokenForOrganizationQuery>;
export type GetTokenForOrganizationLazyQueryHookResult = ReturnType<typeof useGetTokenForOrganizationLazyQuery>;
export type GetTokenForOrganizationQueryResult = Apollo.QueryResult<GetTokenForOrganizationQuery, GetTokenForOrganizationQueryVariables>;
export const GetOrganizationDetailsDocument = gql`
    query getOrganizationDetails($id: Long!) {
  getOrganizationDetails(id: $id) {
    ...OrganizationDetailsFragment
  }
}
    ${OrganizationDetailsFragmentFragmentDoc}`;

/**
 * __useGetOrganizationDetailsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationDetailsQuery, GetOrganizationDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationDetailsQuery, GetOrganizationDetailsQueryVariables>(GetOrganizationDetailsDocument, options);
      }
export function useGetOrganizationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationDetailsQuery, GetOrganizationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationDetailsQuery, GetOrganizationDetailsQueryVariables>(GetOrganizationDetailsDocument, options);
        }
export type GetOrganizationDetailsQueryHookResult = ReturnType<typeof useGetOrganizationDetailsQuery>;
export type GetOrganizationDetailsLazyQueryHookResult = ReturnType<typeof useGetOrganizationDetailsLazyQuery>;
export type GetOrganizationDetailsQueryResult = Apollo.QueryResult<GetOrganizationDetailsQuery, GetOrganizationDetailsQueryVariables>;
export const AdminGetOrganizationMembersDocument = gql`
    query adminGetOrganizationMembers($organizationId: Long, $page: PaginationInput) {
  adminGetOrganizationMembers(organizationId: $organizationId, page: $page) {
    content {
      ...MemberResponse
    }
    total
    pageNumber
    pageSize
  }
}
    ${MemberResponseFragmentDoc}`;

/**
 * __useAdminGetOrganizationMembersQuery__
 *
 * To run a query within a React component, call `useAdminGetOrganizationMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetOrganizationMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetOrganizationMembersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useAdminGetOrganizationMembersQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetOrganizationMembersQuery, AdminGetOrganizationMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetOrganizationMembersQuery, AdminGetOrganizationMembersQueryVariables>(AdminGetOrganizationMembersDocument, options);
      }
export function useAdminGetOrganizationMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetOrganizationMembersQuery, AdminGetOrganizationMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetOrganizationMembersQuery, AdminGetOrganizationMembersQueryVariables>(AdminGetOrganizationMembersDocument, options);
        }
export type AdminGetOrganizationMembersQueryHookResult = ReturnType<typeof useAdminGetOrganizationMembersQuery>;
export type AdminGetOrganizationMembersLazyQueryHookResult = ReturnType<typeof useAdminGetOrganizationMembersLazyQuery>;
export type AdminGetOrganizationMembersQueryResult = Apollo.QueryResult<AdminGetOrganizationMembersQuery, AdminGetOrganizationMembersQueryVariables>;
export const AdminGetImportHistoryDocument = gql`
    query adminGetImportHistory($page: PaginationInput, $searchPattern: String, $statuses: [AllowImportStatus]) {
  adminGetImportHistory(
    page: $page
    searchPattern: $searchPattern
    statuses: $statuses
  ) {
    pageSize
    pageNumber
    total
    content {
      ...SuperAdminContactImportState
    }
  }
}
    ${SuperAdminContactImportStateFragmentDoc}`;

/**
 * __useAdminGetImportHistoryQuery__
 *
 * To run a query within a React component, call `useAdminGetImportHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetImportHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetImportHistoryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      searchPattern: // value for 'searchPattern'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useAdminGetImportHistoryQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetImportHistoryQuery, AdminGetImportHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetImportHistoryQuery, AdminGetImportHistoryQueryVariables>(AdminGetImportHistoryDocument, options);
      }
export function useAdminGetImportHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetImportHistoryQuery, AdminGetImportHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetImportHistoryQuery, AdminGetImportHistoryQueryVariables>(AdminGetImportHistoryDocument, options);
        }
export type AdminGetImportHistoryQueryHookResult = ReturnType<typeof useAdminGetImportHistoryQuery>;
export type AdminGetImportHistoryLazyQueryHookResult = ReturnType<typeof useAdminGetImportHistoryLazyQuery>;
export type AdminGetImportHistoryQueryResult = Apollo.QueryResult<AdminGetImportHistoryQuery, AdminGetImportHistoryQueryVariables>;
export const AdminGetNotificationDocument = gql`
    query adminGetNotification {
  adminGetImportHistory(
    page: {pageNumber: 0, pageSize: 20}
    statuses: [NEEDS_REVIEW]
  ) {
    total
  }
  adminOrganizationComplianceList(
    page: {pageNumber: 0, pageSize: 20}
    search: {bpStatuses: [REVIEW_REQUIRED], tfStatuses: [REVIEW_REQUIRED], billingStatuses: [Active, Trial]}
  ) {
    total
  }
}
    `;

/**
 * __useAdminGetNotificationQuery__
 *
 * To run a query within a React component, call `useAdminGetNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetNotificationQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminGetNotificationQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetNotificationQuery, AdminGetNotificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetNotificationQuery, AdminGetNotificationQueryVariables>(AdminGetNotificationDocument, options);
      }
export function useAdminGetNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetNotificationQuery, AdminGetNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetNotificationQuery, AdminGetNotificationQueryVariables>(AdminGetNotificationDocument, options);
        }
export type AdminGetNotificationQueryHookResult = ReturnType<typeof useAdminGetNotificationQuery>;
export type AdminGetNotificationLazyQueryHookResult = ReturnType<typeof useAdminGetNotificationLazyQuery>;
export type AdminGetNotificationQueryResult = Apollo.QueryResult<AdminGetNotificationQuery, AdminGetNotificationQueryVariables>;
export const AdminCustomPlansDocument = gql`
    query adminCustomPlans {
  adminCustomPlans {
    ...SimplePriceFragment
  }
}
    ${SimplePriceFragmentFragmentDoc}`;

/**
 * __useAdminCustomPlansQuery__
 *
 * To run a query within a React component, call `useAdminCustomPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCustomPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCustomPlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminCustomPlansQuery(baseOptions?: Apollo.QueryHookOptions<AdminCustomPlansQuery, AdminCustomPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCustomPlansQuery, AdminCustomPlansQueryVariables>(AdminCustomPlansDocument, options);
      }
export function useAdminCustomPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCustomPlansQuery, AdminCustomPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCustomPlansQuery, AdminCustomPlansQueryVariables>(AdminCustomPlansDocument, options);
        }
export type AdminCustomPlansQueryHookResult = ReturnType<typeof useAdminCustomPlansQuery>;
export type AdminCustomPlansLazyQueryHookResult = ReturnType<typeof useAdminCustomPlansLazyQuery>;
export type AdminCustomPlansQueryResult = Apollo.QueryResult<AdminCustomPlansQuery, AdminCustomPlansQueryVariables>;
export const AddOrganizationCreditsDocument = gql`
    mutation addOrganizationCredits($input: AddCreditInput!) {
  addCredits(input: $input) {
    plan
    purchased
    purchasedExpire
    rollover
  }
}
    `;
export type AddOrganizationCreditsMutationFn = Apollo.MutationFunction<AddOrganizationCreditsMutation, AddOrganizationCreditsMutationVariables>;

/**
 * __useAddOrganizationCreditsMutation__
 *
 * To run a mutation, you first call `useAddOrganizationCreditsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganizationCreditsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganizationCreditsMutation, { data, loading, error }] = useAddOrganizationCreditsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrganizationCreditsMutation(baseOptions?: Apollo.MutationHookOptions<AddOrganizationCreditsMutation, AddOrganizationCreditsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrganizationCreditsMutation, AddOrganizationCreditsMutationVariables>(AddOrganizationCreditsDocument, options);
      }
export type AddOrganizationCreditsMutationHookResult = ReturnType<typeof useAddOrganizationCreditsMutation>;
export type AddOrganizationCreditsMutationResult = Apollo.MutationResult<AddOrganizationCreditsMutation>;
export type AddOrganizationCreditsMutationOptions = Apollo.BaseMutationOptions<AddOrganizationCreditsMutation, AddOrganizationCreditsMutationVariables>;
export const AdminCreateCallerIdPhoneNumberDocument = gql`
    mutation adminCreateCallerIdPhoneNumber($organizationId: Long, $phoneNumber: String) {
  adminCreateCallerIdPhoneNumber(
    organizationId: $organizationId
    phoneNumber: $phoneNumber
  ) {
    ...PhoneNumberFragment
  }
}
    ${PhoneNumberFragmentFragmentDoc}`;
export type AdminCreateCallerIdPhoneNumberMutationFn = Apollo.MutationFunction<AdminCreateCallerIdPhoneNumberMutation, AdminCreateCallerIdPhoneNumberMutationVariables>;

/**
 * __useAdminCreateCallerIdPhoneNumberMutation__
 *
 * To run a mutation, you first call `useAdminCreateCallerIdPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateCallerIdPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateCallerIdPhoneNumberMutation, { data, loading, error }] = useAdminCreateCallerIdPhoneNumberMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useAdminCreateCallerIdPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateCallerIdPhoneNumberMutation, AdminCreateCallerIdPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateCallerIdPhoneNumberMutation, AdminCreateCallerIdPhoneNumberMutationVariables>(AdminCreateCallerIdPhoneNumberDocument, options);
      }
export type AdminCreateCallerIdPhoneNumberMutationHookResult = ReturnType<typeof useAdminCreateCallerIdPhoneNumberMutation>;
export type AdminCreateCallerIdPhoneNumberMutationResult = Apollo.MutationResult<AdminCreateCallerIdPhoneNumberMutation>;
export type AdminCreateCallerIdPhoneNumberMutationOptions = Apollo.BaseMutationOptions<AdminCreateCallerIdPhoneNumberMutation, AdminCreateCallerIdPhoneNumberMutationVariables>;
export const BanOrganizationDocument = gql`
    mutation banOrganization($input: UpdateOrganizationStatusRequestInput!) {
  banOrganization(input: $input) {
    ...OrganizationResponseFragment
  }
}
    ${OrganizationResponseFragmentFragmentDoc}`;
export type BanOrganizationMutationFn = Apollo.MutationFunction<BanOrganizationMutation, BanOrganizationMutationVariables>;

/**
 * __useBanOrganizationMutation__
 *
 * To run a mutation, you first call `useBanOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBanOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [banOrganizationMutation, { data, loading, error }] = useBanOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBanOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<BanOrganizationMutation, BanOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BanOrganizationMutation, BanOrganizationMutationVariables>(BanOrganizationDocument, options);
      }
export type BanOrganizationMutationHookResult = ReturnType<typeof useBanOrganizationMutation>;
export type BanOrganizationMutationResult = Apollo.MutationResult<BanOrganizationMutation>;
export type BanOrganizationMutationOptions = Apollo.BaseMutationOptions<BanOrganizationMutation, BanOrganizationMutationVariables>;
export const UnbanOrganizationDocument = gql`
    mutation unbanOrganization($input: UpdateOrganizationStatusRequestInput!) {
  unbanOrganization(input: $input) {
    ...OrganizationResponseFragment
  }
}
    ${OrganizationResponseFragmentFragmentDoc}`;
export type UnbanOrganizationMutationFn = Apollo.MutationFunction<UnbanOrganizationMutation, UnbanOrganizationMutationVariables>;

/**
 * __useUnbanOrganizationMutation__
 *
 * To run a mutation, you first call `useUnbanOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnbanOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unbanOrganizationMutation, { data, loading, error }] = useUnbanOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnbanOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UnbanOrganizationMutation, UnbanOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnbanOrganizationMutation, UnbanOrganizationMutationVariables>(UnbanOrganizationDocument, options);
      }
export type UnbanOrganizationMutationHookResult = ReturnType<typeof useUnbanOrganizationMutation>;
export type UnbanOrganizationMutationResult = Apollo.MutationResult<UnbanOrganizationMutation>;
export type UnbanOrganizationMutationOptions = Apollo.BaseMutationOptions<UnbanOrganizationMutation, UnbanOrganizationMutationVariables>;
export const ResetMemberPasswordDocument = gql`
    mutation resetMemberPassword($memberId: Long!, $password: String!) {
  resetMemberProfilePassword(memberProfileId: $memberId, password: $password)
}
    `;
export type ResetMemberPasswordMutationFn = Apollo.MutationFunction<ResetMemberPasswordMutation, ResetMemberPasswordMutationVariables>;

/**
 * __useResetMemberPasswordMutation__
 *
 * To run a mutation, you first call `useResetMemberPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetMemberPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetMemberPasswordMutation, { data, loading, error }] = useResetMemberPasswordMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useResetMemberPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetMemberPasswordMutation, ResetMemberPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetMemberPasswordMutation, ResetMemberPasswordMutationVariables>(ResetMemberPasswordDocument, options);
      }
export type ResetMemberPasswordMutationHookResult = ReturnType<typeof useResetMemberPasswordMutation>;
export type ResetMemberPasswordMutationResult = Apollo.MutationResult<ResetMemberPasswordMutation>;
export type ResetMemberPasswordMutationOptions = Apollo.BaseMutationOptions<ResetMemberPasswordMutation, ResetMemberPasswordMutationVariables>;
export const UpdateSharedNumberAccessDocument = gql`
    mutation updateSharedNumberAccess($id: Long!, $allowed: Boolean!) {
  updateSharedNumberAccess(id: $id, allowed: $allowed) {
    ...OrganizationDetailsFragment
  }
}
    ${OrganizationDetailsFragmentFragmentDoc}`;
export type UpdateSharedNumberAccessMutationFn = Apollo.MutationFunction<UpdateSharedNumberAccessMutation, UpdateSharedNumberAccessMutationVariables>;

/**
 * __useUpdateSharedNumberAccessMutation__
 *
 * To run a mutation, you first call `useUpdateSharedNumberAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSharedNumberAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSharedNumberAccessMutation, { data, loading, error }] = useUpdateSharedNumberAccessMutation({
 *   variables: {
 *      id: // value for 'id'
 *      allowed: // value for 'allowed'
 *   },
 * });
 */
export function useUpdateSharedNumberAccessMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSharedNumberAccessMutation, UpdateSharedNumberAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSharedNumberAccessMutation, UpdateSharedNumberAccessMutationVariables>(UpdateSharedNumberAccessDocument, options);
      }
export type UpdateSharedNumberAccessMutationHookResult = ReturnType<typeof useUpdateSharedNumberAccessMutation>;
export type UpdateSharedNumberAccessMutationResult = Apollo.MutationResult<UpdateSharedNumberAccessMutation>;
export type UpdateSharedNumberAccessMutationOptions = Apollo.BaseMutationOptions<UpdateSharedNumberAccessMutation, UpdateSharedNumberAccessMutationVariables>;
export const AdminChangeImportStateDocument = gql`
    mutation adminChangeImportState($allowStatus: AllowImportStatus!, $importId: Long) {
  adminChangeImportState(allowStatus: $allowStatus, importId: $importId) {
    ...SuperAdminContactImportState
  }
}
    ${SuperAdminContactImportStateFragmentDoc}`;
export type AdminChangeImportStateMutationFn = Apollo.MutationFunction<AdminChangeImportStateMutation, AdminChangeImportStateMutationVariables>;

/**
 * __useAdminChangeImportStateMutation__
 *
 * To run a mutation, you first call `useAdminChangeImportStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminChangeImportStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminChangeImportStateMutation, { data, loading, error }] = useAdminChangeImportStateMutation({
 *   variables: {
 *      allowStatus: // value for 'allowStatus'
 *      importId: // value for 'importId'
 *   },
 * });
 */
export function useAdminChangeImportStateMutation(baseOptions?: Apollo.MutationHookOptions<AdminChangeImportStateMutation, AdminChangeImportStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminChangeImportStateMutation, AdminChangeImportStateMutationVariables>(AdminChangeImportStateDocument, options);
      }
export type AdminChangeImportStateMutationHookResult = ReturnType<typeof useAdminChangeImportStateMutation>;
export type AdminChangeImportStateMutationResult = Apollo.MutationResult<AdminChangeImportStateMutation>;
export type AdminChangeImportStateMutationOptions = Apollo.BaseMutationOptions<AdminChangeImportStateMutation, AdminChangeImportStateMutationVariables>;
export const AdminCreateCustomPlanDocument = gql`
    mutation adminCreateCustomPlan($input: CustomPlanCreateRqInput!) {
  adminCreateCustomPlan(input: $input) {
    ...SimplePriceFragment
  }
}
    ${SimplePriceFragmentFragmentDoc}`;
export type AdminCreateCustomPlanMutationFn = Apollo.MutationFunction<AdminCreateCustomPlanMutation, AdminCreateCustomPlanMutationVariables>;

/**
 * __useAdminCreateCustomPlanMutation__
 *
 * To run a mutation, you first call `useAdminCreateCustomPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateCustomPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateCustomPlanMutation, { data, loading, error }] = useAdminCreateCustomPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateCustomPlanMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateCustomPlanMutation, AdminCreateCustomPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateCustomPlanMutation, AdminCreateCustomPlanMutationVariables>(AdminCreateCustomPlanDocument, options);
      }
export type AdminCreateCustomPlanMutationHookResult = ReturnType<typeof useAdminCreateCustomPlanMutation>;
export type AdminCreateCustomPlanMutationResult = Apollo.MutationResult<AdminCreateCustomPlanMutation>;
export type AdminCreateCustomPlanMutationOptions = Apollo.BaseMutationOptions<AdminCreateCustomPlanMutation, AdminCreateCustomPlanMutationVariables>;
export const AdminUpdateCustomPlanDocument = gql`
    mutation adminUpdateCustomPlan($input: CustomPlanUpdateRqInput!) {
  adminUpdateCustomPlan(input: $input) {
    ...SimplePriceFragment
  }
}
    ${SimplePriceFragmentFragmentDoc}`;
export type AdminUpdateCustomPlanMutationFn = Apollo.MutationFunction<AdminUpdateCustomPlanMutation, AdminUpdateCustomPlanMutationVariables>;

/**
 * __useAdminUpdateCustomPlanMutation__
 *
 * To run a mutation, you first call `useAdminUpdateCustomPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateCustomPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateCustomPlanMutation, { data, loading, error }] = useAdminUpdateCustomPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateCustomPlanMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateCustomPlanMutation, AdminUpdateCustomPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateCustomPlanMutation, AdminUpdateCustomPlanMutationVariables>(AdminUpdateCustomPlanDocument, options);
      }
export type AdminUpdateCustomPlanMutationHookResult = ReturnType<typeof useAdminUpdateCustomPlanMutation>;
export type AdminUpdateCustomPlanMutationResult = Apollo.MutationResult<AdminUpdateCustomPlanMutation>;
export type AdminUpdateCustomPlanMutationOptions = Apollo.BaseMutationOptions<AdminUpdateCustomPlanMutation, AdminUpdateCustomPlanMutationVariables>;
export const SyncTwilioTollFreeDataDocument = gql`
    mutation syncTwilioTollFreeData($organizationId: Long) {
  syncTwilioTollFreeData(organizationId: $organizationId)
}
    `;
export type SyncTwilioTollFreeDataMutationFn = Apollo.MutationFunction<SyncTwilioTollFreeDataMutation, SyncTwilioTollFreeDataMutationVariables>;

/**
 * __useSyncTwilioTollFreeDataMutation__
 *
 * To run a mutation, you first call `useSyncTwilioTollFreeDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncTwilioTollFreeDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncTwilioTollFreeDataMutation, { data, loading, error }] = useSyncTwilioTollFreeDataMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useSyncTwilioTollFreeDataMutation(baseOptions?: Apollo.MutationHookOptions<SyncTwilioTollFreeDataMutation, SyncTwilioTollFreeDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncTwilioTollFreeDataMutation, SyncTwilioTollFreeDataMutationVariables>(SyncTwilioTollFreeDataDocument, options);
      }
export type SyncTwilioTollFreeDataMutationHookResult = ReturnType<typeof useSyncTwilioTollFreeDataMutation>;
export type SyncTwilioTollFreeDataMutationResult = Apollo.MutationResult<SyncTwilioTollFreeDataMutation>;
export type SyncTwilioTollFreeDataMutationOptions = Apollo.BaseMutationOptions<SyncTwilioTollFreeDataMutation, SyncTwilioTollFreeDataMutationVariables>;
export const AdminUpdateOrganizationContractDocument = gql`
    mutation adminUpdateOrganizationContract($organizationId: Long!, $contract: Boolean!) {
  adminUpdateOrganizationContract(
    organizationId: $organizationId
    contract: $contract
  )
}
    `;
export type AdminUpdateOrganizationContractMutationFn = Apollo.MutationFunction<AdminUpdateOrganizationContractMutation, AdminUpdateOrganizationContractMutationVariables>;

/**
 * __useAdminUpdateOrganizationContractMutation__
 *
 * To run a mutation, you first call `useAdminUpdateOrganizationContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateOrganizationContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateOrganizationContractMutation, { data, loading, error }] = useAdminUpdateOrganizationContractMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      contract: // value for 'contract'
 *   },
 * });
 */
export function useAdminUpdateOrganizationContractMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateOrganizationContractMutation, AdminUpdateOrganizationContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateOrganizationContractMutation, AdminUpdateOrganizationContractMutationVariables>(AdminUpdateOrganizationContractDocument, options);
      }
export type AdminUpdateOrganizationContractMutationHookResult = ReturnType<typeof useAdminUpdateOrganizationContractMutation>;
export type AdminUpdateOrganizationContractMutationResult = Apollo.MutationResult<AdminUpdateOrganizationContractMutation>;
export type AdminUpdateOrganizationContractMutationOptions = Apollo.BaseMutationOptions<AdminUpdateOrganizationContractMutation, AdminUpdateOrganizationContractMutationVariables>;
export const AdminChangeOwnerDocument = gql`
    mutation adminChangeOwner($memberId: Long!) {
  changeOwner(memberId: $memberId)
}
    `;
export type AdminChangeOwnerMutationFn = Apollo.MutationFunction<AdminChangeOwnerMutation, AdminChangeOwnerMutationVariables>;

/**
 * __useAdminChangeOwnerMutation__
 *
 * To run a mutation, you first call `useAdminChangeOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminChangeOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminChangeOwnerMutation, { data, loading, error }] = useAdminChangeOwnerMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useAdminChangeOwnerMutation(baseOptions?: Apollo.MutationHookOptions<AdminChangeOwnerMutation, AdminChangeOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminChangeOwnerMutation, AdminChangeOwnerMutationVariables>(AdminChangeOwnerDocument, options);
      }
export type AdminChangeOwnerMutationHookResult = ReturnType<typeof useAdminChangeOwnerMutation>;
export type AdminChangeOwnerMutationResult = Apollo.MutationResult<AdminChangeOwnerMutation>;
export type AdminChangeOwnerMutationOptions = Apollo.BaseMutationOptions<AdminChangeOwnerMutation, AdminChangeOwnerMutationVariables>;
export const GetTriggersDocument = gql`
    query GetTriggers($page: PaginationInput!) {
  getAllTriggers(page: $page) {
    total
    pageSize
    pageNumber
    content {
      ...TriggerFragment
    }
  }
}
    ${TriggerFragmentFragmentDoc}`;

/**
 * __useGetTriggersQuery__
 *
 * To run a query within a React component, call `useGetTriggersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTriggersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTriggersQuery({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetTriggersQuery(baseOptions: Apollo.QueryHookOptions<GetTriggersQuery, GetTriggersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTriggersQuery, GetTriggersQueryVariables>(GetTriggersDocument, options);
      }
export function useGetTriggersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTriggersQuery, GetTriggersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTriggersQuery, GetTriggersQueryVariables>(GetTriggersDocument, options);
        }
export type GetTriggersQueryHookResult = ReturnType<typeof useGetTriggersQuery>;
export type GetTriggersLazyQueryHookResult = ReturnType<typeof useGetTriggersLazyQuery>;
export type GetTriggersQueryResult = Apollo.QueryResult<GetTriggersQuery, GetTriggersQueryVariables>;
export const GetTriggerDocument = gql`
    query GetTrigger($id: Long!) {
  getTriggerById(triggerId: $id) {
    ...TriggerFragment
  }
}
    ${TriggerFragmentFragmentDoc}`;

/**
 * __useGetTriggerQuery__
 *
 * To run a query within a React component, call `useGetTriggerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTriggerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTriggerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTriggerQuery(baseOptions: Apollo.QueryHookOptions<GetTriggerQuery, GetTriggerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTriggerQuery, GetTriggerQueryVariables>(GetTriggerDocument, options);
      }
export function useGetTriggerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTriggerQuery, GetTriggerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTriggerQuery, GetTriggerQueryVariables>(GetTriggerDocument, options);
        }
export type GetTriggerQueryHookResult = ReturnType<typeof useGetTriggerQuery>;
export type GetTriggerLazyQueryHookResult = ReturnType<typeof useGetTriggerLazyQuery>;
export type GetTriggerQueryResult = Apollo.QueryResult<GetTriggerQuery, GetTriggerQueryVariables>;
export const CreateTriggerDocument = gql`
    mutation CreateTrigger($triggerInput: TriggerInput!) {
  createTrigger(triggerInput: $triggerInput) {
    ...TriggerFragment
  }
}
    ${TriggerFragmentFragmentDoc}`;
export type CreateTriggerMutationFn = Apollo.MutationFunction<CreateTriggerMutation, CreateTriggerMutationVariables>;

/**
 * __useCreateTriggerMutation__
 *
 * To run a mutation, you first call `useCreateTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTriggerMutation, { data, loading, error }] = useCreateTriggerMutation({
 *   variables: {
 *      triggerInput: // value for 'triggerInput'
 *   },
 * });
 */
export function useCreateTriggerMutation(baseOptions?: Apollo.MutationHookOptions<CreateTriggerMutation, CreateTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTriggerMutation, CreateTriggerMutationVariables>(CreateTriggerDocument, options);
      }
export type CreateTriggerMutationHookResult = ReturnType<typeof useCreateTriggerMutation>;
export type CreateTriggerMutationResult = Apollo.MutationResult<CreateTriggerMutation>;
export type CreateTriggerMutationOptions = Apollo.BaseMutationOptions<CreateTriggerMutation, CreateTriggerMutationVariables>;
export const UpdateTriggerDocument = gql`
    mutation UpdateTrigger($triggerInput: TriggerInput!) {
  updateTrigger(triggerInput: $triggerInput) {
    ...TriggerFragment
  }
}
    ${TriggerFragmentFragmentDoc}`;
export type UpdateTriggerMutationFn = Apollo.MutationFunction<UpdateTriggerMutation, UpdateTriggerMutationVariables>;

/**
 * __useUpdateTriggerMutation__
 *
 * To run a mutation, you first call `useUpdateTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTriggerMutation, { data, loading, error }] = useUpdateTriggerMutation({
 *   variables: {
 *      triggerInput: // value for 'triggerInput'
 *   },
 * });
 */
export function useUpdateTriggerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTriggerMutation, UpdateTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTriggerMutation, UpdateTriggerMutationVariables>(UpdateTriggerDocument, options);
      }
export type UpdateTriggerMutationHookResult = ReturnType<typeof useUpdateTriggerMutation>;
export type UpdateTriggerMutationResult = Apollo.MutationResult<UpdateTriggerMutation>;
export type UpdateTriggerMutationOptions = Apollo.BaseMutationOptions<UpdateTriggerMutation, UpdateTriggerMutationVariables>;
export const RemoveTriggersDocument = gql`
    mutation RemoveTriggers($triggersIds: [Long!]) {
  removeTriggers(triggersIds: $triggersIds)
}
    `;
export type RemoveTriggersMutationFn = Apollo.MutationFunction<RemoveTriggersMutation, RemoveTriggersMutationVariables>;

/**
 * __useRemoveTriggersMutation__
 *
 * To run a mutation, you first call `useRemoveTriggersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTriggersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTriggersMutation, { data, loading, error }] = useRemoveTriggersMutation({
 *   variables: {
 *      triggersIds: // value for 'triggersIds'
 *   },
 * });
 */
export function useRemoveTriggersMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTriggersMutation, RemoveTriggersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTriggersMutation, RemoveTriggersMutationVariables>(RemoveTriggersDocument, options);
      }
export type RemoveTriggersMutationHookResult = ReturnType<typeof useRemoveTriggersMutation>;
export type RemoveTriggersMutationResult = Apollo.MutationResult<RemoveTriggersMutation>;
export type RemoveTriggersMutationOptions = Apollo.BaseMutationOptions<RemoveTriggersMutation, RemoveTriggersMutationVariables>;
export const ConfirmExternalPhoneNumberDocument = gql`
    mutation ConfirmExternalPhoneNumber($uuid: String!, $code: String!) {
  confirmExternalPhoneNumber(uuid: $uuid, code: $code) {
    ...PhoneNumberFragment
  }
}
    ${PhoneNumberFragmentFragmentDoc}`;
export type ConfirmExternalPhoneNumberMutationFn = Apollo.MutationFunction<ConfirmExternalPhoneNumberMutation, ConfirmExternalPhoneNumberMutationVariables>;

/**
 * __useConfirmExternalPhoneNumberMutation__
 *
 * To run a mutation, you first call `useConfirmExternalPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmExternalPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmExternalPhoneNumberMutation, { data, loading, error }] = useConfirmExternalPhoneNumberMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useConfirmExternalPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmExternalPhoneNumberMutation, ConfirmExternalPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmExternalPhoneNumberMutation, ConfirmExternalPhoneNumberMutationVariables>(ConfirmExternalPhoneNumberDocument, options);
      }
export type ConfirmExternalPhoneNumberMutationHookResult = ReturnType<typeof useConfirmExternalPhoneNumberMutation>;
export type ConfirmExternalPhoneNumberMutationResult = Apollo.MutationResult<ConfirmExternalPhoneNumberMutation>;
export type ConfirmExternalPhoneNumberMutationOptions = Apollo.BaseMutationOptions<ConfirmExternalPhoneNumberMutation, ConfirmExternalPhoneNumberMutationVariables>;
export const AddExternalPhoneNumberDocument = gql`
    mutation AddExternalPhoneNumber($inputPhoneNumber: String!, $extension: String) {
  addExternalPhoneNumber(
    inputPhoneNumber: $inputPhoneNumber
    extension: $extension
  )
}
    `;
export type AddExternalPhoneNumberMutationFn = Apollo.MutationFunction<AddExternalPhoneNumberMutation, AddExternalPhoneNumberMutationVariables>;

/**
 * __useAddExternalPhoneNumberMutation__
 *
 * To run a mutation, you first call `useAddExternalPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddExternalPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addExternalPhoneNumberMutation, { data, loading, error }] = useAddExternalPhoneNumberMutation({
 *   variables: {
 *      inputPhoneNumber: // value for 'inputPhoneNumber'
 *      extension: // value for 'extension'
 *   },
 * });
 */
export function useAddExternalPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<AddExternalPhoneNumberMutation, AddExternalPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddExternalPhoneNumberMutation, AddExternalPhoneNumberMutationVariables>(AddExternalPhoneNumberDocument, options);
      }
export type AddExternalPhoneNumberMutationHookResult = ReturnType<typeof useAddExternalPhoneNumberMutation>;
export type AddExternalPhoneNumberMutationResult = Apollo.MutationResult<AddExternalPhoneNumberMutation>;
export type AddExternalPhoneNumberMutationOptions = Apollo.BaseMutationOptions<AddExternalPhoneNumberMutation, AddExternalPhoneNumberMutationVariables>;
export const GetTriggerMessagesDocument = gql`
    query GetTriggerMessages($page: PaginationInput, $uuid: String, $status: Status, $dateRange: DateRangeCriteriaInput) {
  getTriggerMessages(
    page: $page
    uuid: $uuid
    status: $status
    dateRange: $dateRange
  ) {
    ...PageResponse_MessageFragment
  }
}
    ${PageResponse_MessageFragmentFragmentDoc}`;

/**
 * __useGetTriggerMessagesQuery__
 *
 * To run a query within a React component, call `useGetTriggerMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTriggerMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTriggerMessagesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      uuid: // value for 'uuid'
 *      status: // value for 'status'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetTriggerMessagesQuery(baseOptions?: Apollo.QueryHookOptions<GetTriggerMessagesQuery, GetTriggerMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTriggerMessagesQuery, GetTriggerMessagesQueryVariables>(GetTriggerMessagesDocument, options);
      }
export function useGetTriggerMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTriggerMessagesQuery, GetTriggerMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTriggerMessagesQuery, GetTriggerMessagesQueryVariables>(GetTriggerMessagesDocument, options);
        }
export type GetTriggerMessagesQueryHookResult = ReturnType<typeof useGetTriggerMessagesQuery>;
export type GetTriggerMessagesLazyQueryHookResult = ReturnType<typeof useGetTriggerMessagesLazyQuery>;
export type GetTriggerMessagesQueryResult = Apollo.QueryResult<GetTriggerMessagesQuery, GetTriggerMessagesQueryVariables>;
export const GetTriggerMessageStatisticsDocument = gql`
    query getTriggerMessageStatistics($uuid: String, $dateRange: DateRangeCriteriaInput) {
  getTriggerMessageStatistics(uuid: $uuid, dateRange: $dateRange) {
    ...MessageStatisticsResponseFragment
  }
}
    ${MessageStatisticsResponseFragmentFragmentDoc}`;

/**
 * __useGetTriggerMessageStatisticsQuery__
 *
 * To run a query within a React component, call `useGetTriggerMessageStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTriggerMessageStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTriggerMessageStatisticsQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetTriggerMessageStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<GetTriggerMessageStatisticsQuery, GetTriggerMessageStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTriggerMessageStatisticsQuery, GetTriggerMessageStatisticsQueryVariables>(GetTriggerMessageStatisticsDocument, options);
      }
export function useGetTriggerMessageStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTriggerMessageStatisticsQuery, GetTriggerMessageStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTriggerMessageStatisticsQuery, GetTriggerMessageStatisticsQueryVariables>(GetTriggerMessageStatisticsDocument, options);
        }
export type GetTriggerMessageStatisticsQueryHookResult = ReturnType<typeof useGetTriggerMessageStatisticsQuery>;
export type GetTriggerMessageStatisticsLazyQueryHookResult = ReturnType<typeof useGetTriggerMessageStatisticsLazyQuery>;
export type GetTriggerMessageStatisticsQueryResult = Apollo.QueryResult<GetTriggerMessageStatisticsQuery, GetTriggerMessageStatisticsQueryVariables>;
export const GetIntegrationCustomFieldsDocument = gql`
    query getIntegrationCustomFields($byPassCache: Boolean) {
  getIntegrationCustomFields(byPassCache: $byPassCache) {
    specificFields {
      name
      key
    }
    standardFields {
      name
      key
    }
    integrationType
    phoneFields {
      name
      key
    }
  }
}
    `;

/**
 * __useGetIntegrationCustomFieldsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationCustomFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationCustomFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationCustomFieldsQuery({
 *   variables: {
 *      byPassCache: // value for 'byPassCache'
 *   },
 * });
 */
export function useGetIntegrationCustomFieldsQuery(baseOptions?: Apollo.QueryHookOptions<GetIntegrationCustomFieldsQuery, GetIntegrationCustomFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationCustomFieldsQuery, GetIntegrationCustomFieldsQueryVariables>(GetIntegrationCustomFieldsDocument, options);
      }
export function useGetIntegrationCustomFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationCustomFieldsQuery, GetIntegrationCustomFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationCustomFieldsQuery, GetIntegrationCustomFieldsQueryVariables>(GetIntegrationCustomFieldsDocument, options);
        }
export type GetIntegrationCustomFieldsQueryHookResult = ReturnType<typeof useGetIntegrationCustomFieldsQuery>;
export type GetIntegrationCustomFieldsLazyQueryHookResult = ReturnType<typeof useGetIntegrationCustomFieldsLazyQuery>;
export type GetIntegrationCustomFieldsQueryResult = Apollo.QueryResult<GetIntegrationCustomFieldsQuery, GetIntegrationCustomFieldsQueryVariables>;
export const GetWebFormsDocument = gql`
    query getWebForms($page: PaginationInput, $searchPattern: String) {
  getWebForms(page: $page, searchPattern: $searchPattern) {
    pageNumber
    pageSize
    total
    content {
      ...WebFormFragment
    }
  }
}
    ${WebFormFragmentFragmentDoc}`;

/**
 * __useGetWebFormsQuery__
 *
 * To run a query within a React component, call `useGetWebFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebFormsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      searchPattern: // value for 'searchPattern'
 *   },
 * });
 */
export function useGetWebFormsQuery(baseOptions?: Apollo.QueryHookOptions<GetWebFormsQuery, GetWebFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWebFormsQuery, GetWebFormsQueryVariables>(GetWebFormsDocument, options);
      }
export function useGetWebFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebFormsQuery, GetWebFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWebFormsQuery, GetWebFormsQueryVariables>(GetWebFormsDocument, options);
        }
export type GetWebFormsQueryHookResult = ReturnType<typeof useGetWebFormsQuery>;
export type GetWebFormsLazyQueryHookResult = ReturnType<typeof useGetWebFormsLazyQuery>;
export type GetWebFormsQueryResult = Apollo.QueryResult<GetWebFormsQuery, GetWebFormsQueryVariables>;
export const GetWebFormDocument = gql`
    query getWebForm($id: Long) {
  getWebForm(id: $id) {
    ...WebFormFragment
  }
}
    ${WebFormFragmentFragmentDoc}`;

/**
 * __useGetWebFormQuery__
 *
 * To run a query within a React component, call `useGetWebFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWebFormQuery(baseOptions?: Apollo.QueryHookOptions<GetWebFormQuery, GetWebFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWebFormQuery, GetWebFormQueryVariables>(GetWebFormDocument, options);
      }
export function useGetWebFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebFormQuery, GetWebFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWebFormQuery, GetWebFormQueryVariables>(GetWebFormDocument, options);
        }
export type GetWebFormQueryHookResult = ReturnType<typeof useGetWebFormQuery>;
export type GetWebFormLazyQueryHookResult = ReturnType<typeof useGetWebFormLazyQuery>;
export type GetWebFormQueryResult = Apollo.QueryResult<GetWebFormQuery, GetWebFormQueryVariables>;
export const GetWebFormContactsStatisticsDocument = gql`
    query getWebFormContactsStatistics($uuid: String, $dateRange: DateRangeCriteriaInput) {
  getWebFormContactsStatistics(uuid: $uuid, dateRange: $dateRange) {
    percentageStatistics {
      confirmed
      subscribed
      unsubscribed
      active
    }
    chargeStatistics {
      totalCharged
    }
    todayStat {
      total
      confirmed
      subscribed
      unsubscribed
      active
    }
    totalStat {
      unsubscribed
      subscribed
      confirmed
      total
      active
    }
    shortUrlClickStatistics {
      ...ShortUrlClickStatisticsFragment
    }
    conversionStatistics {
      ...ConversionStatistics
    }
  }
}
    ${ShortUrlClickStatisticsFragmentFragmentDoc}
${ConversionStatisticsFragmentDoc}`;

/**
 * __useGetWebFormContactsStatisticsQuery__
 *
 * To run a query within a React component, call `useGetWebFormContactsStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebFormContactsStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebFormContactsStatisticsQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetWebFormContactsStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<GetWebFormContactsStatisticsQuery, GetWebFormContactsStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWebFormContactsStatisticsQuery, GetWebFormContactsStatisticsQueryVariables>(GetWebFormContactsStatisticsDocument, options);
      }
export function useGetWebFormContactsStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebFormContactsStatisticsQuery, GetWebFormContactsStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWebFormContactsStatisticsQuery, GetWebFormContactsStatisticsQueryVariables>(GetWebFormContactsStatisticsDocument, options);
        }
export type GetWebFormContactsStatisticsQueryHookResult = ReturnType<typeof useGetWebFormContactsStatisticsQuery>;
export type GetWebFormContactsStatisticsLazyQueryHookResult = ReturnType<typeof useGetWebFormContactsStatisticsLazyQuery>;
export type GetWebFormContactsStatisticsQueryResult = Apollo.QueryResult<GetWebFormContactsStatisticsQuery, GetWebFormContactsStatisticsQueryVariables>;
export const GetWebFormContactsDocument = gql`
    query getWebFormContacts($uuid: String, $page: PaginationInput, $dateRange: DateRangeCriteriaInput, $status: Status) {
  getWebFormContacts(
    uuid: $uuid
    page: $page
    dateRange: $dateRange
    status: $status
  ) {
    total
    content {
      ...ContactLightResponse
    }
    pageSize
    pageNumber
  }
}
    ${ContactLightResponseFragmentDoc}`;

/**
 * __useGetWebFormContactsQuery__
 *
 * To run a query within a React component, call `useGetWebFormContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebFormContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebFormContactsQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      page: // value for 'page'
 *      dateRange: // value for 'dateRange'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetWebFormContactsQuery(baseOptions?: Apollo.QueryHookOptions<GetWebFormContactsQuery, GetWebFormContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWebFormContactsQuery, GetWebFormContactsQueryVariables>(GetWebFormContactsDocument, options);
      }
export function useGetWebFormContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebFormContactsQuery, GetWebFormContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWebFormContactsQuery, GetWebFormContactsQueryVariables>(GetWebFormContactsDocument, options);
        }
export type GetWebFormContactsQueryHookResult = ReturnType<typeof useGetWebFormContactsQuery>;
export type GetWebFormContactsLazyQueryHookResult = ReturnType<typeof useGetWebFormContactsLazyQuery>;
export type GetWebFormContactsQueryResult = Apollo.QueryResult<GetWebFormContactsQuery, GetWebFormContactsQueryVariables>;
export const CreateWebFormDocument = gql`
    mutation createWebForm($input: WebFormInput!) {
  createWebForm(input: $input) {
    ...WebFormFragment
  }
}
    ${WebFormFragmentFragmentDoc}`;
export type CreateWebFormMutationFn = Apollo.MutationFunction<CreateWebFormMutation, CreateWebFormMutationVariables>;

/**
 * __useCreateWebFormMutation__
 *
 * To run a mutation, you first call `useCreateWebFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebFormMutation, { data, loading, error }] = useCreateWebFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWebFormMutation(baseOptions?: Apollo.MutationHookOptions<CreateWebFormMutation, CreateWebFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWebFormMutation, CreateWebFormMutationVariables>(CreateWebFormDocument, options);
      }
export type CreateWebFormMutationHookResult = ReturnType<typeof useCreateWebFormMutation>;
export type CreateWebFormMutationResult = Apollo.MutationResult<CreateWebFormMutation>;
export type CreateWebFormMutationOptions = Apollo.BaseMutationOptions<CreateWebFormMutation, CreateWebFormMutationVariables>;
export const UpdateWebFormDocument = gql`
    mutation updateWebForm($input: WebFormInput!) {
  updateWebForm(input: $input) {
    ...WebFormFragment
  }
}
    ${WebFormFragmentFragmentDoc}`;
export type UpdateWebFormMutationFn = Apollo.MutationFunction<UpdateWebFormMutation, UpdateWebFormMutationVariables>;

/**
 * __useUpdateWebFormMutation__
 *
 * To run a mutation, you first call `useUpdateWebFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebFormMutation, { data, loading, error }] = useUpdateWebFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWebFormMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWebFormMutation, UpdateWebFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWebFormMutation, UpdateWebFormMutationVariables>(UpdateWebFormDocument, options);
      }
export type UpdateWebFormMutationHookResult = ReturnType<typeof useUpdateWebFormMutation>;
export type UpdateWebFormMutationResult = Apollo.MutationResult<UpdateWebFormMutation>;
export type UpdateWebFormMutationOptions = Apollo.BaseMutationOptions<UpdateWebFormMutation, UpdateWebFormMutationVariables>;
export const DeleteWebFormsDocument = gql`
    mutation deleteWebForms($ids: [Long]) {
  deleteWebForms(ids: $ids)
}
    `;
export type DeleteWebFormsMutationFn = Apollo.MutationFunction<DeleteWebFormsMutation, DeleteWebFormsMutationVariables>;

/**
 * __useDeleteWebFormsMutation__
 *
 * To run a mutation, you first call `useDeleteWebFormsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWebFormsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWebFormsMutation, { data, loading, error }] = useDeleteWebFormsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteWebFormsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWebFormsMutation, DeleteWebFormsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWebFormsMutation, DeleteWebFormsMutationVariables>(DeleteWebFormsDocument, options);
      }
export type DeleteWebFormsMutationHookResult = ReturnType<typeof useDeleteWebFormsMutation>;
export type DeleteWebFormsMutationResult = Apollo.MutationResult<DeleteWebFormsMutation>;
export type DeleteWebFormsMutationOptions = Apollo.BaseMutationOptions<DeleteWebFormsMutation, DeleteWebFormsMutationVariables>;
export const SendTestMessageDocument = gql`
    mutation sendTestMessage($testMessageInput: TestMessageRequestInput) {
  sendTestMessage(testMessageInput: $testMessageInput) {
    chargeAmount
  }
}
    `;
export type SendTestMessageMutationFn = Apollo.MutationFunction<SendTestMessageMutation, SendTestMessageMutationVariables>;

/**
 * __useSendTestMessageMutation__
 *
 * To run a mutation, you first call `useSendTestMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestMessageMutation, { data, loading, error }] = useSendTestMessageMutation({
 *   variables: {
 *      testMessageInput: // value for 'testMessageInput'
 *   },
 * });
 */
export function useSendTestMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendTestMessageMutation, SendTestMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTestMessageMutation, SendTestMessageMutationVariables>(SendTestMessageDocument, options);
      }
export type SendTestMessageMutationHookResult = ReturnType<typeof useSendTestMessageMutation>;
export type SendTestMessageMutationResult = Apollo.MutationResult<SendTestMessageMutation>;
export type SendTestMessageMutationOptions = Apollo.BaseMutationOptions<SendTestMessageMutation, SendTestMessageMutationVariables>;